import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Json: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AddTemplateFieldInput = {
  content?: InputMaybe<Scalars['JSON']['input']>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FieldType>;
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int']['output'];
};

export type Author = {
  __typename?: 'Author';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['Json']['output']>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  resourceType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type AuthorContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type AuthorHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type AuthorPropertiesArgs = {
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type AuthorCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthorCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<AuthorCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuthorCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<AuthorCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<AuthorCreateManyNetworkInputEnvelope>;
};

export type AuthorCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AuthorCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<AuthorCreateWithoutContentInput>;
};

export type AuthorCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AuthorCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<AuthorCreateWithoutPropertiesInput>;
};

export type AuthorCreateOrConnectWithoutContentInput = {
  create: AuthorCreateWithoutContentInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorCreateOrConnectWithoutNetworkInput = {
  create: AuthorCreateWithoutNetworkInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorCreateOrConnectWithoutPropertiesInput = {
  create: AuthorCreateWithoutPropertiesInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorCreateWithoutContentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutAuthorInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutAuthorInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthorCreateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutAuthorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutAuthorInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthorCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutAuthorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutAuthorInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthorListRelationFilter = {
  every?: InputMaybe<AuthorWhereInput>;
  none?: InputMaybe<AuthorWhereInput>;
  some?: InputMaybe<AuthorWhereInput>;
};

export type AuthorOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AuthorOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrder>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type AuthorScalarWhereInput = {
  AND?: InputMaybe<Array<AuthorScalarWhereInput>>;
  NOT?: InputMaybe<Array<AuthorScalarWhereInput>>;
  OR?: InputMaybe<Array<AuthorScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AuthorUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuthorUpdateManyWithWhereWithoutNetworkInput = {
  data: AuthorUpdateManyMutationInput;
  where: AuthorScalarWhereInput;
};

export type AuthorUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuthorCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<AuthorCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<AuthorCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AuthorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  set?: InputMaybe<Array<AuthorWhereUniqueInput>>;
  update?: InputMaybe<Array<AuthorUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<AuthorUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<AuthorUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type AuthorUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AuthorCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<AuthorCreateWithoutContentInput>;
  delete?: InputMaybe<AuthorWhereInput>;
  disconnect?: InputMaybe<AuthorWhereInput>;
  update?: InputMaybe<AuthorUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<AuthorUpsertWithoutContentInput>;
};

export type AuthorUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<AuthorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AuthorCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<AuthorCreateWithoutPropertiesInput>;
  delete?: InputMaybe<AuthorWhereInput>;
  disconnect?: InputMaybe<AuthorWhereInput>;
  update?: InputMaybe<AuthorUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<AuthorUpsertWithoutPropertiesInput>;
};

export type AuthorUpdateToOneWithWhereWithoutContentInput = {
  data: AuthorUpdateWithoutContentInput;
  where?: InputMaybe<AuthorWhereInput>;
};

export type AuthorUpdateToOneWithWhereWithoutPropertiesInput = {
  data: AuthorUpdateWithoutPropertiesInput;
  where?: InputMaybe<AuthorWhereInput>;
};

export type AuthorUpdateWithWhereUniqueWithoutNetworkInput = {
  data: AuthorUpdateWithoutNetworkInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorUpdateWithoutContentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutAuthorNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutAuthorNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuthorUpdateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutAuthorNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutAuthorNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuthorUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutAuthorNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutAuthorNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuthorUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type AuthorUpsertWithWhereUniqueWithoutNetworkInput = {
  create: AuthorCreateWithoutNetworkInput;
  update: AuthorUpdateWithoutNetworkInput;
  where: AuthorWhereUniqueInput;
};

export type AuthorUpsertWithoutContentInput = {
  create: AuthorCreateWithoutContentInput;
  update: AuthorUpdateWithoutContentInput;
  where?: InputMaybe<AuthorWhereInput>;
};

export type AuthorUpsertWithoutPropertiesInput = {
  create: AuthorCreateWithoutPropertiesInput;
  update: AuthorUpdateWithoutPropertiesInput;
  where?: InputMaybe<AuthorWhereInput>;
};

export type AuthorWhereInput = {
  AND?: InputMaybe<Array<AuthorWhereInput>>;
  NOT?: InputMaybe<Array<AuthorWhereInput>>;
  OR?: InputMaybe<Array<AuthorWhereInput>>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AuthorWhereUniqueInput = {
  AND?: InputMaybe<Array<AuthorWhereInput>>;
  NOT?: InputMaybe<Array<AuthorWhereInput>>;
  OR?: InputMaybe<Array<AuthorWhereInput>>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type CloudinaryFileInput = {
  access_mode?: InputMaybe<Scalars['String']['input']>;
  asset_id?: InputMaybe<Scalars['String']['input']>;
  batchId?: InputMaybe<Scalars['String']['input']>;
  bytes?: InputMaybe<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['String']['input']>;
  format: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  original_filename?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['Boolean']['input']>;
  public_id: Scalars['String']['input'];
  resource_type?: InputMaybe<Scalars['String']['input']>;
  secure_url: Scalars['String']['input'];
  signature?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thumbnail_url?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  version_id?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type Company = {
  __typename?: 'Company';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  networks: Array<Network>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CompanyNetworksArgs = {
  cursor?: InputMaybe<NetworkWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NetworkWhereInput>;
};

export type CompanyCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  networks?: InputMaybe<NetworkCreateNestedManyWithoutCompanyInput>;
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompanyCreateNestedOneWithoutNetworksInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CompanyCreateOrConnectWithoutNetworksInput>;
  create?: InputMaybe<CompanyCreateWithoutNetworksInput>;
};

export type CompanyCreateOrConnectWithoutNetworksInput = {
  create: CompanyCreateWithoutNetworksInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateWithoutNetworksInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompanyOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  networks?: InputMaybe<NetworkOrderByRelationAggregateInput>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CompanyUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  networks?: InputMaybe<NetworkUpdateManyWithoutCompanyNestedInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpdateOneWithoutNetworksNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CompanyCreateOrConnectWithoutNetworksInput>;
  create?: InputMaybe<CompanyCreateWithoutNetworksInput>;
  delete?: InputMaybe<CompanyWhereInput>;
  disconnect?: InputMaybe<CompanyWhereInput>;
  update?: InputMaybe<CompanyUpdateToOneWithWhereWithoutNetworksInput>;
  upsert?: InputMaybe<CompanyUpsertWithoutNetworksInput>;
};

export type CompanyUpdateToOneWithWhereWithoutNetworksInput = {
  data: CompanyUpdateWithoutNetworksInput;
  where?: InputMaybe<CompanyWhereInput>;
};

export type CompanyUpdateWithoutNetworksInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CompanyUpsertWithoutNetworksInput = {
  create: CompanyCreateWithoutNetworksInput;
  update: CompanyUpdateWithoutNetworksInput;
  where?: InputMaybe<CompanyWhereInput>;
};

export type CompanyWhereInput = {
  AND?: InputMaybe<Array<CompanyWhereInput>>;
  NOT?: InputMaybe<Array<CompanyWhereInput>>;
  OR?: InputMaybe<Array<CompanyWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  slug?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CompanyWhereUniqueInput = {
  AND?: InputMaybe<Array<CompanyWhereInput>>;
  NOT?: InputMaybe<Array<CompanyWhereInput>>;
  OR?: InputMaybe<Array<CompanyWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id: Scalars['String']['input'];
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ContentItem = {
  __typename?: 'ContentItem';
  field?: Maybe<TemplateField>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  network?: Maybe<Network>;
  strings: Array<StringItem>;
  translationType: ContentItemTranslationType;
};


export type ContentItemFieldArgs = {
  where?: InputMaybe<TemplateFieldWhereInput>;
};


export type ContentItemNetworkArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type ContentItemStringsArgs = {
  cursor?: InputMaybe<StringItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<StringItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StringItemWhereInput>;
};

export type ContentItemCreateInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateManyAuthorInput = {
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyAuthorInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyAuthorInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyFieldInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyFieldInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyFieldInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyFilterTaxonomyItemInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyFilterTaxonomyItemInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyFilterTaxonomyItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyFilterTaxonomyRuleInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyFilterTaxonomyRuleInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyFilterTaxonomyRuleInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyMenuItemInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyMenuItemInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyMenuItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyNetworkContentInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyNetworkContentInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyNetworkContentInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyNetworkInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyPostInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyPostInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyPostInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyProductInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyProductInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyProductInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyProviderInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyProviderInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyProviderInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyProviderTaxonomyConnectionInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyProviderTaxonomyConnectionInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyProviderTaxonomyConnectionInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManySiteInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManySiteInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManySiteInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyStringTemplateInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyStringTemplateInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyStringTemplateInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyStringTemplateVariableInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyStringTemplateVariableInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyStringTemplateVariableInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyTaxonomyItemInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyTaxonomyItemInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyTaxonomyItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyTemplateFieldInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyTemplateFieldInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyTemplateFieldInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyTemplateInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemCreateManyTemplateInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyTemplateInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateManyVerticalInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkContentId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  translationType?: InputMaybe<ContentItemTranslationType>;
};

export type ContentItemCreateManyVerticalInputEnvelope = {
  data?: InputMaybe<Array<ContentItemCreateManyVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemCreateNestedManyWithoutAuthorInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutAuthorInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutAuthorInput>>;
  createMany?: InputMaybe<ContentItemCreateManyAuthorInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutFieldInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutFieldInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutFieldInput>>;
  createMany?: InputMaybe<ContentItemCreateManyFieldInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutFilterTaxonomyItemInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutFilterTaxonomyItemInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutFilterTaxonomyItemInput>>;
  createMany?: InputMaybe<ContentItemCreateManyFilterTaxonomyItemInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutFilterTaxonomyRuleInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutFilterTaxonomyRuleInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutFilterTaxonomyRuleInput>>;
  createMany?: InputMaybe<ContentItemCreateManyFilterTaxonomyRuleInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutMenuItemInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutMenuItemInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutMenuItemInput>>;
  createMany?: InputMaybe<ContentItemCreateManyMenuItemInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutNetworkContentInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutNetworkContentInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutNetworkContentInput>>;
  createMany?: InputMaybe<ContentItemCreateManyNetworkContentInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ContentItemCreateManyNetworkInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutPostInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutPostInput>>;
  createMany?: InputMaybe<ContentItemCreateManyPostInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<ContentItemCreateManyProductInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutProviderInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutProviderInput>>;
  createMany?: InputMaybe<ContentItemCreateManyProviderInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutProviderTaxonomyConnectionInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutProviderTaxonomyConnectionInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutProviderTaxonomyConnectionInput>>;
  createMany?: InputMaybe<ContentItemCreateManyProviderTaxonomyConnectionInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutSiteInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutSiteInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutSiteInput>>;
  createMany?: InputMaybe<ContentItemCreateManySiteInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutStringTemplateInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutStringTemplateInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutStringTemplateInput>>;
  createMany?: InputMaybe<ContentItemCreateManyStringTemplateInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutStringTemplateVariableInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutStringTemplateVariableInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutStringTemplateVariableInput>>;
  createMany?: InputMaybe<ContentItemCreateManyStringTemplateVariableInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutTaxonomyItemInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutTaxonomyItemInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutTaxonomyItemInput>>;
  createMany?: InputMaybe<ContentItemCreateManyTaxonomyItemInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutTemplateFieldInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutTemplateFieldInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutTemplateFieldInput>>;
  createMany?: InputMaybe<ContentItemCreateManyTemplateFieldInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<ContentItemCreateManyTemplateInputEnvelope>;
};

export type ContentItemCreateNestedManyWithoutVerticalInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<ContentItemCreateManyVerticalInputEnvelope>;
};

export type ContentItemCreateNestedOneWithoutStringsInput = {
  connect?: InputMaybe<ContentItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ContentItemCreateOrConnectWithoutStringsInput>;
  create?: InputMaybe<ContentItemCreateWithoutStringsInput>;
};

export type ContentItemCreateOrConnectWithoutAuthorInput = {
  create: ContentItemCreateWithoutAuthorInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutFieldInput = {
  create: ContentItemCreateWithoutFieldInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutFilterTaxonomyItemInput = {
  create: ContentItemCreateWithoutFilterTaxonomyItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutFilterTaxonomyRuleInput = {
  create: ContentItemCreateWithoutFilterTaxonomyRuleInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutMenuItemInput = {
  create: ContentItemCreateWithoutMenuItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutNetworkContentInput = {
  create: ContentItemCreateWithoutNetworkContentInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutNetworkInput = {
  create: ContentItemCreateWithoutNetworkInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutPostInput = {
  create: ContentItemCreateWithoutPostInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutProductInput = {
  create: ContentItemCreateWithoutProductInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutProviderInput = {
  create: ContentItemCreateWithoutProviderInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutProviderTaxonomyConnectionInput = {
  create: ContentItemCreateWithoutProviderTaxonomyConnectionInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutSiteInput = {
  create: ContentItemCreateWithoutSiteInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutStringTemplateInput = {
  create: ContentItemCreateWithoutStringTemplateInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutStringTemplateVariableInput = {
  create: ContentItemCreateWithoutStringTemplateVariableInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutStringsInput = {
  create: ContentItemCreateWithoutStringsInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutTaxonomyItemInput = {
  create: ContentItemCreateWithoutTaxonomyItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutTemplateFieldInput = {
  create: ContentItemCreateWithoutTemplateFieldInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutTemplateInput = {
  create: ContentItemCreateWithoutTemplateInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateOrConnectWithoutVerticalInput = {
  create: ContentItemCreateWithoutVerticalInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemCreateWithoutAuthorInput = {
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutFieldInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutFilterTaxonomyItemInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutFilterTaxonomyRuleInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutMenuItemInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutNetworkContentInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutNetworkInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutPostInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutProductInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutProviderInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutProviderTaxonomyConnectionInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutSiteInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutStringTemplateInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutStringTemplateVariableInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutStringsInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutTaxonomyItemInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutTemplateFieldInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutTemplateInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentOldInput>;
};

export type ContentItemCreateWithoutVerticalInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutContentInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutContentInput>;
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentOldInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentOldInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentItemInput>;
  networkContent?: InputMaybe<NetworkCreateNestedOneWithoutContentOldInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutContentInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutContentInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentOldInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentOldInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentOldInput>;
  strings?: InputMaybe<StringItemCreateNestedManyWithoutContentItemInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutContentInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentOldInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentOldInput>;
  translationType?: InputMaybe<ContentItemTranslationType>;
};

export type ContentItemListRelationFilter = {
  every?: InputMaybe<ContentItemWhereInput>;
  none?: InputMaybe<ContentItemWhereInput>;
  some?: InputMaybe<ContentItemWhereInput>;
};

export type ContentItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ContentItemOrderByWithRelationInput = {
  Author?: InputMaybe<AuthorOrderByWithRelationInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemOrderByWithRelationInput>;
  authorId?: InputMaybe<SortOrderInput>;
  field?: InputMaybe<TemplateFieldOrderByWithRelationInput>;
  fieldId?: InputMaybe<SortOrderInput>;
  filterTaxonomyItemId?: InputMaybe<SortOrderInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleOrderByWithRelationInput>;
  filterTaxonomyRuleId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  menuItem?: InputMaybe<MenuItemOrderByWithRelationInput>;
  menuItemId?: InputMaybe<SortOrderInput>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkContent?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkContentId?: InputMaybe<SortOrderInput>;
  networkId?: InputMaybe<SortOrderInput>;
  post?: InputMaybe<PostOrderByWithRelationInput>;
  postId?: InputMaybe<SortOrderInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrderInput>;
  provider?: InputMaybe<ProviderOrderByWithRelationInput>;
  providerId?: InputMaybe<SortOrderInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionOrderByWithRelationInput>;
  providerTaxonomyConnectionId?: InputMaybe<SortOrderInput>;
  site?: InputMaybe<SiteOrderByWithRelationInput>;
  siteId?: InputMaybe<SortOrderInput>;
  stringTemplate?: InputMaybe<StringTemplateOrderByWithRelationInput>;
  stringTemplateId?: InputMaybe<SortOrderInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableOrderByWithRelationInput>;
  stringTemplateVariableId?: InputMaybe<SortOrderInput>;
  strings?: InputMaybe<StringItemOrderByRelationAggregateInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemOrderByWithRelationInput>;
  taxonomyItemId?: InputMaybe<SortOrderInput>;
  template?: InputMaybe<TemplateOrderByWithRelationInput>;
  templateField?: InputMaybe<TemplateFieldOrderByWithRelationInput>;
  templateFieldId?: InputMaybe<SortOrderInput>;
  templateId?: InputMaybe<SortOrderInput>;
  translationType?: InputMaybe<SortOrder>;
  vertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  verticalId?: InputMaybe<SortOrderInput>;
};

export type ContentItemScalarWhereInput = {
  AND?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  OR?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  authorId?: InputMaybe<StringNullableFilter>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyItemId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  networkContentId?: InputMaybe<StringNullableFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  postId?: InputMaybe<StringNullableFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  providerId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  siteId?: InputMaybe<StringNullableFilter>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  taxonomyItemId?: InputMaybe<StringNullableFilter>;
  templateFieldId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export enum ContentItemTranslationType {
  Cldr = 'CLDR',
  Human = 'HUMAN',
  Localized = 'LOCALIZED',
  Machine = 'MACHINE',
  Notranslate = 'NOTRANSLATE'
}

export type ContentItemUpdateInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
};

export type ContentItemUpdateManyWithWhereWithoutAuthorInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutFieldInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutFilterTaxonomyItemInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutFilterTaxonomyRuleInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutMenuItemInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutNetworkContentInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutNetworkInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutPostInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutProductInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutProviderInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutProviderTaxonomyConnectionInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutSiteInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutStringTemplateInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutStringTemplateVariableInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutTaxonomyItemInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutTemplateFieldInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutTemplateInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithWhereWithoutVerticalInput = {
  data: ContentItemUpdateManyMutationInput;
  where: ContentItemScalarWhereInput;
};

export type ContentItemUpdateManyWithoutAuthorNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutAuthorInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutAuthorInput>>;
  createMany?: InputMaybe<ContentItemCreateManyAuthorInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutAuthorInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutAuthorInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutAuthorInput>>;
};

export type ContentItemUpdateManyWithoutFieldNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutFieldInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutFieldInput>>;
  createMany?: InputMaybe<ContentItemCreateManyFieldInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutFieldInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutFieldInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutFieldInput>>;
};

export type ContentItemUpdateManyWithoutFilterTaxonomyItemNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutFilterTaxonomyItemInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutFilterTaxonomyItemInput>>;
  createMany?: InputMaybe<ContentItemCreateManyFilterTaxonomyItemInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutFilterTaxonomyItemInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutFilterTaxonomyItemInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutFilterTaxonomyItemInput>>;
};

export type ContentItemUpdateManyWithoutFilterTaxonomyRuleNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutFilterTaxonomyRuleInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutFilterTaxonomyRuleInput>>;
  createMany?: InputMaybe<ContentItemCreateManyFilterTaxonomyRuleInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutFilterTaxonomyRuleInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutFilterTaxonomyRuleInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutFilterTaxonomyRuleInput>>;
};

export type ContentItemUpdateManyWithoutMenuItemNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutMenuItemInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutMenuItemInput>>;
  createMany?: InputMaybe<ContentItemCreateManyMenuItemInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutMenuItemInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutMenuItemInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutMenuItemInput>>;
};

export type ContentItemUpdateManyWithoutNetworkContentNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutNetworkContentInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutNetworkContentInput>>;
  createMany?: InputMaybe<ContentItemCreateManyNetworkContentInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutNetworkContentInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutNetworkContentInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutNetworkContentInput>>;
};

export type ContentItemUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ContentItemCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type ContentItemUpdateManyWithoutPostNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutPostInput>>;
  createMany?: InputMaybe<ContentItemCreateManyPostInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutPostInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutPostInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutPostInput>>;
};

export type ContentItemUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<ContentItemCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ContentItemUpdateManyWithoutProviderNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutProviderInput>>;
  createMany?: InputMaybe<ContentItemCreateManyProviderInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutProviderInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutProviderInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutProviderInput>>;
};

export type ContentItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutProviderTaxonomyConnectionInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutProviderTaxonomyConnectionInput>>;
  createMany?: InputMaybe<ContentItemCreateManyProviderTaxonomyConnectionInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutProviderTaxonomyConnectionInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutProviderTaxonomyConnectionInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutProviderTaxonomyConnectionInput>>;
};

export type ContentItemUpdateManyWithoutSiteNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutSiteInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutSiteInput>>;
  createMany?: InputMaybe<ContentItemCreateManySiteInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutSiteInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutSiteInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutSiteInput>>;
};

export type ContentItemUpdateManyWithoutStringTemplateNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutStringTemplateInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutStringTemplateInput>>;
  createMany?: InputMaybe<ContentItemCreateManyStringTemplateInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutStringTemplateInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutStringTemplateInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutStringTemplateInput>>;
};

export type ContentItemUpdateManyWithoutStringTemplateVariableNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutStringTemplateVariableInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutStringTemplateVariableInput>>;
  createMany?: InputMaybe<ContentItemCreateManyStringTemplateVariableInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutStringTemplateVariableInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutStringTemplateVariableInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutStringTemplateVariableInput>>;
};

export type ContentItemUpdateManyWithoutTaxonomyItemNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutTaxonomyItemInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutTaxonomyItemInput>>;
  createMany?: InputMaybe<ContentItemCreateManyTaxonomyItemInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutTaxonomyItemInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutTaxonomyItemInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutTaxonomyItemInput>>;
};

export type ContentItemUpdateManyWithoutTemplateFieldNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutTemplateFieldInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutTemplateFieldInput>>;
  createMany?: InputMaybe<ContentItemCreateManyTemplateFieldInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutTemplateFieldInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutTemplateFieldInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutTemplateFieldInput>>;
};

export type ContentItemUpdateManyWithoutTemplateNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<ContentItemCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type ContentItemUpdateManyWithoutVerticalNestedInput = {
  connect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<ContentItemCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<ContentItemCreateManyVerticalInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemUpdateWithWhereUniqueWithoutVerticalInput>>;
  updateMany?: InputMaybe<Array<ContentItemUpdateManyWithWhereWithoutVerticalInput>>;
  upsert?: InputMaybe<Array<ContentItemUpsertWithWhereUniqueWithoutVerticalInput>>;
};

export type ContentItemUpdateOneRequiredWithoutStringsNestedInput = {
  connect?: InputMaybe<ContentItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ContentItemCreateOrConnectWithoutStringsInput>;
  create?: InputMaybe<ContentItemCreateWithoutStringsInput>;
  update?: InputMaybe<ContentItemUpdateToOneWithWhereWithoutStringsInput>;
  upsert?: InputMaybe<ContentItemUpsertWithoutStringsInput>;
};

export type ContentItemUpdateToOneWithWhereWithoutStringsInput = {
  data: ContentItemUpdateWithoutStringsInput;
  where?: InputMaybe<ContentItemWhereInput>;
};

export type ContentItemUpdateWithWhereUniqueWithoutAuthorInput = {
  data: ContentItemUpdateWithoutAuthorInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutFieldInput = {
  data: ContentItemUpdateWithoutFieldInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutFilterTaxonomyItemInput = {
  data: ContentItemUpdateWithoutFilterTaxonomyItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutFilterTaxonomyRuleInput = {
  data: ContentItemUpdateWithoutFilterTaxonomyRuleInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutMenuItemInput = {
  data: ContentItemUpdateWithoutMenuItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutNetworkContentInput = {
  data: ContentItemUpdateWithoutNetworkContentInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutNetworkInput = {
  data: ContentItemUpdateWithoutNetworkInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutPostInput = {
  data: ContentItemUpdateWithoutPostInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutProductInput = {
  data: ContentItemUpdateWithoutProductInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutProviderInput = {
  data: ContentItemUpdateWithoutProviderInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutProviderTaxonomyConnectionInput = {
  data: ContentItemUpdateWithoutProviderTaxonomyConnectionInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutSiteInput = {
  data: ContentItemUpdateWithoutSiteInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutStringTemplateInput = {
  data: ContentItemUpdateWithoutStringTemplateInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutStringTemplateVariableInput = {
  data: ContentItemUpdateWithoutStringTemplateVariableInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutTaxonomyItemInput = {
  data: ContentItemUpdateWithoutTaxonomyItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutTemplateFieldInput = {
  data: ContentItemUpdateWithoutTemplateFieldInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutTemplateInput = {
  data: ContentItemUpdateWithoutTemplateInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithWhereUniqueWithoutVerticalInput = {
  data: ContentItemUpdateWithoutVerticalInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpdateWithoutAuthorInput = {
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutFieldInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutFilterTaxonomyItemInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutFilterTaxonomyRuleInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutMenuItemInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutNetworkContentInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutNetworkInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutPostInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutProductInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutProviderInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutProviderTaxonomyConnectionInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutSiteInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutStringTemplateInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutStringTemplateVariableInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutStringsInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutTaxonomyItemInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutTemplateFieldInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutTemplateInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentOldNestedInput>;
};

export type ContentItemUpdateWithoutVerticalInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutContentNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutContentNestedInput>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentOldNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentItemNestedInput>;
  networkContent?: InputMaybe<NetworkUpdateOneWithoutContentOldNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutContentNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutContentNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentOldNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentOldNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentOldNestedInput>;
  strings?: InputMaybe<StringItemUpdateManyWithoutContentItemNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutContentNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentOldNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentOldNestedInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
};

export type ContentItemUpsertWithWhereUniqueWithoutAuthorInput = {
  create: ContentItemCreateWithoutAuthorInput;
  update: ContentItemUpdateWithoutAuthorInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutFieldInput = {
  create: ContentItemCreateWithoutFieldInput;
  update: ContentItemUpdateWithoutFieldInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutFilterTaxonomyItemInput = {
  create: ContentItemCreateWithoutFilterTaxonomyItemInput;
  update: ContentItemUpdateWithoutFilterTaxonomyItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutFilterTaxonomyRuleInput = {
  create: ContentItemCreateWithoutFilterTaxonomyRuleInput;
  update: ContentItemUpdateWithoutFilterTaxonomyRuleInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutMenuItemInput = {
  create: ContentItemCreateWithoutMenuItemInput;
  update: ContentItemUpdateWithoutMenuItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutNetworkContentInput = {
  create: ContentItemCreateWithoutNetworkContentInput;
  update: ContentItemUpdateWithoutNetworkContentInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutNetworkInput = {
  create: ContentItemCreateWithoutNetworkInput;
  update: ContentItemUpdateWithoutNetworkInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutPostInput = {
  create: ContentItemCreateWithoutPostInput;
  update: ContentItemUpdateWithoutPostInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutProductInput = {
  create: ContentItemCreateWithoutProductInput;
  update: ContentItemUpdateWithoutProductInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutProviderInput = {
  create: ContentItemCreateWithoutProviderInput;
  update: ContentItemUpdateWithoutProviderInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutProviderTaxonomyConnectionInput = {
  create: ContentItemCreateWithoutProviderTaxonomyConnectionInput;
  update: ContentItemUpdateWithoutProviderTaxonomyConnectionInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutSiteInput = {
  create: ContentItemCreateWithoutSiteInput;
  update: ContentItemUpdateWithoutSiteInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutStringTemplateInput = {
  create: ContentItemCreateWithoutStringTemplateInput;
  update: ContentItemUpdateWithoutStringTemplateInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutStringTemplateVariableInput = {
  create: ContentItemCreateWithoutStringTemplateVariableInput;
  update: ContentItemUpdateWithoutStringTemplateVariableInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutTaxonomyItemInput = {
  create: ContentItemCreateWithoutTaxonomyItemInput;
  update: ContentItemUpdateWithoutTaxonomyItemInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutTemplateFieldInput = {
  create: ContentItemCreateWithoutTemplateFieldInput;
  update: ContentItemUpdateWithoutTemplateFieldInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutTemplateInput = {
  create: ContentItemCreateWithoutTemplateInput;
  update: ContentItemUpdateWithoutTemplateInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithWhereUniqueWithoutVerticalInput = {
  create: ContentItemCreateWithoutVerticalInput;
  update: ContentItemUpdateWithoutVerticalInput;
  where: ContentItemWhereUniqueInput;
};

export type ContentItemUpsertWithoutStringsInput = {
  create: ContentItemCreateWithoutStringsInput;
  update: ContentItemUpdateWithoutStringsInput;
  where?: InputMaybe<ContentItemWhereInput>;
};

export type ContentItemV2 = {
  __typename?: 'ContentItemV2';
  contextId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['JSON']['output']>;
  field?: Maybe<TemplateField>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  language: Language;
  list: Scalars['Boolean']['output'];
  status: StringItemStatus;
  text?: Maybe<Scalars['String']['output']>;
  translatedAt?: Maybe<Scalars['DateTime']['output']>;
  translation: StringItemTranslationType;
  translationType: ContentItemTranslationType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  variant: Scalars['Int']['output'];
};


export type ContentItemV2DataArgs = {
  type?: InputMaybe<ContentItemV2DataType>;
};


export type ContentItemV2FieldArgs = {
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type ContentItemV2CreateInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateManyFieldInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyFieldInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyFieldInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyFilterTaxonomyRuleInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyFilterTaxonomyRuleInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyFilterTaxonomyRuleInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyLanguageInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyLanguageInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyLanguageInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyMenuItemInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyMenuItemInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyMenuItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyNetworkInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyProviderTaxonomyConnectionInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyProviderTaxonomyConnectionInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyProviderTaxonomyConnectionInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyRouteResourceInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyRouteResourceInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyRouteResourceInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManySiteInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManySiteInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManySiteInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyStringTemplateInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyStringTemplateInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyStringTemplateInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyStringTemplateVariableInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyStringTemplateVariableInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyStringTemplateVariableInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyTemplateFieldInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyTemplateFieldInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyTemplateFieldInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyTemplateInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type ContentItemV2CreateManyTemplateInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyTemplateInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateManyVerticalInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateFieldId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
};

export type ContentItemV2CreateManyVerticalInputEnvelope = {
  data?: InputMaybe<Array<ContentItemV2CreateManyVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentItemV2CreateNestedManyWithoutFieldInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutFieldInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutFieldInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyFieldInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutFilterTaxonomyRuleInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutFilterTaxonomyRuleInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutFilterTaxonomyRuleInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyFilterTaxonomyRuleInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutLanguageInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutLanguageInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyLanguageInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutMenuItemInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutMenuItemInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutMenuItemInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyMenuItemInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyNetworkInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutProviderTaxonomyConnectionInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutProviderTaxonomyConnectionInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutProviderTaxonomyConnectionInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyProviderTaxonomyConnectionInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutRouteResourceInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutRouteResourceInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutRouteResourceInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyRouteResourceInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutSiteInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutSiteInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutSiteInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManySiteInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutStringTemplateInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutStringTemplateInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutStringTemplateInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyStringTemplateInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutStringTemplateVariableInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutStringTemplateVariableInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutStringTemplateVariableInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyStringTemplateVariableInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutTemplateFieldInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutTemplateFieldInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutTemplateFieldInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyTemplateFieldInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutTemplateInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyTemplateInputEnvelope>;
};

export type ContentItemV2CreateNestedManyWithoutVerticalInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutVerticalInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyVerticalInputEnvelope>;
};

export type ContentItemV2CreateOrConnectWithoutFieldInput = {
  create: ContentItemV2CreateWithoutFieldInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutFilterTaxonomyRuleInput = {
  create: ContentItemV2CreateWithoutFilterTaxonomyRuleInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutLanguageInput = {
  create: ContentItemV2CreateWithoutLanguageInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutMenuItemInput = {
  create: ContentItemV2CreateWithoutMenuItemInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutNetworkInput = {
  create: ContentItemV2CreateWithoutNetworkInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutProviderTaxonomyConnectionInput = {
  create: ContentItemV2CreateWithoutProviderTaxonomyConnectionInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutRouteResourceInput = {
  create: ContentItemV2CreateWithoutRouteResourceInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutSiteInput = {
  create: ContentItemV2CreateWithoutSiteInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutStringTemplateInput = {
  create: ContentItemV2CreateWithoutStringTemplateInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutStringTemplateVariableInput = {
  create: ContentItemV2CreateWithoutStringTemplateVariableInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutTemplateFieldInput = {
  create: ContentItemV2CreateWithoutTemplateFieldInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutTemplateInput = {
  create: ContentItemV2CreateWithoutTemplateInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateOrConnectWithoutVerticalInput = {
  create: ContentItemV2CreateWithoutVerticalInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2CreateWithoutFieldInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutFilterTaxonomyRuleInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutLanguageInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutMenuItemInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutNetworkInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutProviderTaxonomyConnectionInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutRouteResourceInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutSiteInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutStringTemplateInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutStringTemplateVariableInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutTemplateFieldInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutTemplateInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutContentInput>;
};

export type ContentItemV2CreateWithoutVerticalInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutRelatedContentInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutContentInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language: LanguageCreateNestedOneWithoutContentItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutContentInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutContentInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput>;
  routeResource?: InputMaybe<RouteResourceCreateNestedOneWithoutContentInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutContentInput>;
  status?: InputMaybe<StringItemStatus>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutContentInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutContentInput>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutContentInput>;
  templateField?: InputMaybe<TemplateFieldCreateNestedOneWithoutContentInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  translationType?: InputMaybe<ContentItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContentItemV2DataType {
  Markdown = 'MARKDOWN',
  PortableText = 'PORTABLE_TEXT'
}

export type ContentItemV2ListRelationFilter = {
  every?: InputMaybe<ContentItemV2WhereInput>;
  none?: InputMaybe<ContentItemV2WhereInput>;
  some?: InputMaybe<ContentItemV2WhereInput>;
};

export type ContentItemV2OrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ContentItemV2OrderByWithRelationInput = {
  contextId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  field?: InputMaybe<TemplateFieldOrderByWithRelationInput>;
  fieldId?: InputMaybe<SortOrderInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleOrderByWithRelationInput>;
  filterTaxonomyRuleId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  language?: InputMaybe<LanguageOrderByWithRelationInput>;
  languageId?: InputMaybe<SortOrder>;
  list?: InputMaybe<SortOrder>;
  menuItem?: InputMaybe<MenuItemOrderByWithRelationInput>;
  menuItemId?: InputMaybe<SortOrderInput>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionOrderByWithRelationInput>;
  providerTaxonomyConnectionId?: InputMaybe<SortOrderInput>;
  routeResource?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  routeResourceId?: InputMaybe<SortOrderInput>;
  site?: InputMaybe<SiteOrderByWithRelationInput>;
  siteId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  stringTemplate?: InputMaybe<StringTemplateOrderByWithRelationInput>;
  stringTemplateId?: InputMaybe<SortOrderInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableOrderByWithRelationInput>;
  stringTemplateVariableId?: InputMaybe<SortOrderInput>;
  syncStatus?: InputMaybe<SortOrder>;
  template?: InputMaybe<TemplateOrderByWithRelationInput>;
  templateField?: InputMaybe<TemplateFieldOrderByWithRelationInput>;
  templateFieldId?: InputMaybe<SortOrderInput>;
  templateId?: InputMaybe<SortOrderInput>;
  text?: InputMaybe<SortOrderInput>;
  translatedAt?: InputMaybe<SortOrderInput>;
  translation?: InputMaybe<SortOrder>;
  translationType?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrder>;
  variant?: InputMaybe<SortOrder>;
  vertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  verticalId?: InputMaybe<SortOrderInput>;
};

export type ContentItemV2ScalarWhereInput = {
  AND?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  NOT?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  OR?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonFilter>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  languageId?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  routeResourceId?: InputMaybe<StringNullableFilter>;
  siteId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFilter>;
  templateFieldId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  text?: InputMaybe<StringNullableFilter>;
  translatedAt?: InputMaybe<DateTimeNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  variant?: InputMaybe<IntFilter>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type ContentItemV2UpdateInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateManyMutationInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ContentItemV2UpdateManyWithWhereWithoutFieldInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutFilterTaxonomyRuleInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutLanguageInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutMenuItemInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutNetworkInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutProviderTaxonomyConnectionInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutRouteResourceInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutSiteInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutStringTemplateInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutStringTemplateVariableInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutTemplateFieldInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutTemplateInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithWhereWithoutVerticalInput = {
  data: ContentItemV2UpdateManyMutationInput;
  where: ContentItemV2ScalarWhereInput;
};

export type ContentItemV2UpdateManyWithoutFieldNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutFieldInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutFieldInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyFieldInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutFieldInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutFieldInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutFieldInput>>;
};

export type ContentItemV2UpdateManyWithoutFilterTaxonomyRuleNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutFilterTaxonomyRuleInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutFilterTaxonomyRuleInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyFilterTaxonomyRuleInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutFilterTaxonomyRuleInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutFilterTaxonomyRuleInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutFilterTaxonomyRuleInput>>;
};

export type ContentItemV2UpdateManyWithoutLanguageNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutLanguageInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyLanguageInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutLanguageInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutLanguageInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutLanguageInput>>;
};

export type ContentItemV2UpdateManyWithoutMenuItemNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutMenuItemInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutMenuItemInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyMenuItemInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutMenuItemInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutMenuItemInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutMenuItemInput>>;
};

export type ContentItemV2UpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type ContentItemV2UpdateManyWithoutProviderTaxonomyConnectionNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutProviderTaxonomyConnectionInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutProviderTaxonomyConnectionInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyProviderTaxonomyConnectionInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutProviderTaxonomyConnectionInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutProviderTaxonomyConnectionInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutProviderTaxonomyConnectionInput>>;
};

export type ContentItemV2UpdateManyWithoutRouteResourceNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutRouteResourceInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutRouteResourceInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyRouteResourceInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutRouteResourceInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutRouteResourceInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutRouteResourceInput>>;
};

export type ContentItemV2UpdateManyWithoutSiteNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutSiteInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutSiteInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManySiteInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutSiteInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutSiteInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutSiteInput>>;
};

export type ContentItemV2UpdateManyWithoutStringTemplateNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutStringTemplateInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutStringTemplateInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyStringTemplateInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutStringTemplateInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutStringTemplateInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutStringTemplateInput>>;
};

export type ContentItemV2UpdateManyWithoutStringTemplateVariableNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutStringTemplateVariableInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutStringTemplateVariableInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyStringTemplateVariableInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutStringTemplateVariableInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutStringTemplateVariableInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutStringTemplateVariableInput>>;
};

export type ContentItemV2UpdateManyWithoutTemplateFieldNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutTemplateFieldInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutTemplateFieldInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyTemplateFieldInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutTemplateFieldInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutTemplateFieldInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutTemplateFieldInput>>;
};

export type ContentItemV2UpdateManyWithoutTemplateNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutTemplateInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type ContentItemV2UpdateManyWithoutVerticalNestedInput = {
  connect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentItemV2CreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<ContentItemV2CreateWithoutVerticalInput>>;
  createMany?: InputMaybe<ContentItemV2CreateManyVerticalInputEnvelope>;
  delete?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentItemV2ScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  set?: InputMaybe<Array<ContentItemV2WhereUniqueInput>>;
  update?: InputMaybe<Array<ContentItemV2UpdateWithWhereUniqueWithoutVerticalInput>>;
  updateMany?: InputMaybe<Array<ContentItemV2UpdateManyWithWhereWithoutVerticalInput>>;
  upsert?: InputMaybe<Array<ContentItemV2UpsertWithWhereUniqueWithoutVerticalInput>>;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutFieldInput = {
  data: ContentItemV2UpdateWithoutFieldInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutFilterTaxonomyRuleInput = {
  data: ContentItemV2UpdateWithoutFilterTaxonomyRuleInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutLanguageInput = {
  data: ContentItemV2UpdateWithoutLanguageInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutMenuItemInput = {
  data: ContentItemV2UpdateWithoutMenuItemInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutNetworkInput = {
  data: ContentItemV2UpdateWithoutNetworkInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutProviderTaxonomyConnectionInput = {
  data: ContentItemV2UpdateWithoutProviderTaxonomyConnectionInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutRouteResourceInput = {
  data: ContentItemV2UpdateWithoutRouteResourceInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutSiteInput = {
  data: ContentItemV2UpdateWithoutSiteInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutStringTemplateInput = {
  data: ContentItemV2UpdateWithoutStringTemplateInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutStringTemplateVariableInput = {
  data: ContentItemV2UpdateWithoutStringTemplateVariableInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutTemplateFieldInput = {
  data: ContentItemV2UpdateWithoutTemplateFieldInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutTemplateInput = {
  data: ContentItemV2UpdateWithoutTemplateInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithWhereUniqueWithoutVerticalInput = {
  data: ContentItemV2UpdateWithoutVerticalInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpdateWithoutFieldInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutFilterTaxonomyRuleInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutLanguageInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutMenuItemInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutNetworkInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutProviderTaxonomyConnectionInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutRouteResourceInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutSiteInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutStringTemplateInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutStringTemplateVariableInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutTemplateFieldInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutTemplateInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutContentNestedInput>;
};

export type ContentItemV2UpdateWithoutVerticalInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutRelatedContentNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutContentNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutContentItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutContentNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutContentNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput>;
  routeResource?: InputMaybe<RouteResourceUpdateOneWithoutContentNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutContentNestedInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutContentNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutContentNestedInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutContentNestedInput>;
  templateField?: InputMaybe<TemplateFieldUpdateOneWithoutContentNestedInput>;
  text?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutFieldInput = {
  create: ContentItemV2CreateWithoutFieldInput;
  update: ContentItemV2UpdateWithoutFieldInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutFilterTaxonomyRuleInput = {
  create: ContentItemV2CreateWithoutFilterTaxonomyRuleInput;
  update: ContentItemV2UpdateWithoutFilterTaxonomyRuleInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutLanguageInput = {
  create: ContentItemV2CreateWithoutLanguageInput;
  update: ContentItemV2UpdateWithoutLanguageInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutMenuItemInput = {
  create: ContentItemV2CreateWithoutMenuItemInput;
  update: ContentItemV2UpdateWithoutMenuItemInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutNetworkInput = {
  create: ContentItemV2CreateWithoutNetworkInput;
  update: ContentItemV2UpdateWithoutNetworkInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutProviderTaxonomyConnectionInput = {
  create: ContentItemV2CreateWithoutProviderTaxonomyConnectionInput;
  update: ContentItemV2UpdateWithoutProviderTaxonomyConnectionInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutRouteResourceInput = {
  create: ContentItemV2CreateWithoutRouteResourceInput;
  update: ContentItemV2UpdateWithoutRouteResourceInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutSiteInput = {
  create: ContentItemV2CreateWithoutSiteInput;
  update: ContentItemV2UpdateWithoutSiteInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutStringTemplateInput = {
  create: ContentItemV2CreateWithoutStringTemplateInput;
  update: ContentItemV2UpdateWithoutStringTemplateInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutStringTemplateVariableInput = {
  create: ContentItemV2CreateWithoutStringTemplateVariableInput;
  update: ContentItemV2UpdateWithoutStringTemplateVariableInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutTemplateFieldInput = {
  create: ContentItemV2CreateWithoutTemplateFieldInput;
  update: ContentItemV2UpdateWithoutTemplateFieldInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutTemplateInput = {
  create: ContentItemV2CreateWithoutTemplateInput;
  update: ContentItemV2UpdateWithoutTemplateInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2UpsertWithWhereUniqueWithoutVerticalInput = {
  create: ContentItemV2CreateWithoutVerticalInput;
  update: ContentItemV2UpdateWithoutVerticalInput;
  where: ContentItemV2WhereUniqueInput;
};

export type ContentItemV2WhereInput = {
  AND?: InputMaybe<Array<ContentItemV2WhereInput>>;
  NOT?: InputMaybe<Array<ContentItemV2WhereInput>>;
  OR?: InputMaybe<Array<ContentItemV2WhereInput>>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonFilter>;
  field?: InputMaybe<TemplateFieldWhereInput>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  language?: InputMaybe<LanguageWhereInput>;
  languageId?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  menuItem?: InputMaybe<MenuItemWhereInput>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  routeResource?: InputMaybe<RouteResourceWhereInput>;
  routeResourceId?: InputMaybe<StringNullableFilter>;
  site?: InputMaybe<SiteWhereInput>;
  siteId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  stringTemplate?: InputMaybe<StringTemplateWhereInput>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableWhereInput>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateField?: InputMaybe<TemplateFieldWhereInput>;
  templateFieldId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  text?: InputMaybe<StringNullableFilter>;
  translatedAt?: InputMaybe<DateTimeNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  variant?: InputMaybe<IntFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type ContentItemV2WhereUniqueInput = {
  AND?: InputMaybe<Array<ContentItemV2WhereInput>>;
  NOT?: InputMaybe<Array<ContentItemV2WhereInput>>;
  OR?: InputMaybe<Array<ContentItemV2WhereInput>>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonFilter>;
  field?: InputMaybe<TemplateFieldWhereInput>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id: Scalars['String']['input'];
  key?: InputMaybe<StringFilter>;
  language?: InputMaybe<LanguageWhereInput>;
  languageId?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  menuItem?: InputMaybe<MenuItemWhereInput>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  routeResource?: InputMaybe<RouteResourceWhereInput>;
  routeResourceId?: InputMaybe<StringNullableFilter>;
  site?: InputMaybe<SiteWhereInput>;
  siteId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  stringTemplate?: InputMaybe<StringTemplateWhereInput>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableWhereInput>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateField?: InputMaybe<TemplateFieldWhereInput>;
  templateFieldId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  text?: InputMaybe<StringNullableFilter>;
  translatedAt?: InputMaybe<DateTimeNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  variant?: InputMaybe<IntFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type ContentItemWhereInput = {
  AND?: InputMaybe<Array<ContentItemWhereInput>>;
  Author?: InputMaybe<AuthorWhereInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemWhereInput>;
  NOT?: InputMaybe<Array<ContentItemWhereInput>>;
  OR?: InputMaybe<Array<ContentItemWhereInput>>;
  authorId?: InputMaybe<StringNullableFilter>;
  field?: InputMaybe<TemplateFieldWhereInput>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyItemId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  menuItem?: InputMaybe<MenuItemWhereInput>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkContent?: InputMaybe<NetworkWhereInput>;
  networkContentId?: InputMaybe<StringNullableFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  post?: InputMaybe<PostWhereInput>;
  postId?: InputMaybe<StringNullableFilter>;
  product?: InputMaybe<ProductWhereInput>;
  productId?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<ProviderWhereInput>;
  providerId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  site?: InputMaybe<SiteWhereInput>;
  siteId?: InputMaybe<StringNullableFilter>;
  stringTemplate?: InputMaybe<StringTemplateWhereInput>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableWhereInput>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  strings?: InputMaybe<StringItemListRelationFilter>;
  taxonomyItem?: InputMaybe<TaxonomyItemWhereInput>;
  taxonomyItemId?: InputMaybe<StringNullableFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateField?: InputMaybe<TemplateFieldWhereInput>;
  templateFieldId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type ContentItemWhereUniqueInput = {
  AND?: InputMaybe<Array<ContentItemWhereInput>>;
  Author?: InputMaybe<AuthorWhereInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemWhereInput>;
  NOT?: InputMaybe<Array<ContentItemWhereInput>>;
  OR?: InputMaybe<Array<ContentItemWhereInput>>;
  authorId?: InputMaybe<StringNullableFilter>;
  field?: InputMaybe<TemplateFieldWhereInput>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyItemId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id: Scalars['String']['input'];
  key?: InputMaybe<StringFilter>;
  menuItem?: InputMaybe<MenuItemWhereInput>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkContent?: InputMaybe<NetworkWhereInput>;
  networkContentId?: InputMaybe<StringNullableFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  post?: InputMaybe<PostWhereInput>;
  postId?: InputMaybe<StringNullableFilter>;
  product?: InputMaybe<ProductWhereInput>;
  productId?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<ProviderWhereInput>;
  providerId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  site?: InputMaybe<SiteWhereInput>;
  siteId?: InputMaybe<StringNullableFilter>;
  stringTemplate?: InputMaybe<StringTemplateWhereInput>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableWhereInput>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  strings?: InputMaybe<StringItemListRelationFilter>;
  taxonomyItem?: InputMaybe<TaxonomyItemWhereInput>;
  taxonomyItemId?: InputMaybe<StringNullableFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateField?: InputMaybe<TemplateFieldWhereInput>;
  templateFieldId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  translationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export enum ContextType {
  Company = 'COMPANY',
  Global = 'GLOBAL',
  Network = 'NETWORK',
  Site = 'SITE',
  Vertical = 'VERTICAL'
}

export type Country = {
  __typename?: 'Country';
  countryCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  languages: Array<Language>;
  name: Scalars['String']['output'];
  region?: Maybe<Region>;
  states: Array<State>;
  subregion?: Maybe<Subregion>;
};


export type CountryLanguagesArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type CountryRegionArgs = {
  where?: InputMaybe<RegionWhereInput>;
};


export type CountryStatesArgs = {
  cursor?: InputMaybe<StateWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateWhereInput>;
};


export type CountrySubregionArgs = {
  where?: InputMaybe<SubregionWhereInput>;
};

export type CountryCreateManyRegionInput = {
  countryCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subregionId?: InputMaybe<Scalars['String']['input']>;
  translatedDemonym: Scalars['Json']['input'];
};

export type CountryCreateManyRegionInputEnvelope = {
  data?: InputMaybe<Array<CountryCreateManyRegionInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryCreateManySubregionInput = {
  countryCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  regionId?: InputMaybe<Scalars['String']['input']>;
  translatedDemonym: Scalars['Json']['input'];
};

export type CountryCreateManySubregionInputEnvelope = {
  data?: InputMaybe<Array<CountryCreateManySubregionInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryCreateNestedManyWithoutLanguagesInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutLanguagesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutLanguagesInput>>;
};

export type CountryCreateNestedManyWithoutRegionInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutRegionInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutRegionInput>>;
  createMany?: InputMaybe<CountryCreateManyRegionInputEnvelope>;
};

export type CountryCreateNestedManyWithoutSubregionInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutSubregionInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutSubregionInput>>;
  createMany?: InputMaybe<CountryCreateManySubregionInputEnvelope>;
};

export type CountryCreateNestedOneWithoutSiteInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutSiteInput>;
  create?: InputMaybe<CountryCreateWithoutSiteInput>;
};

export type CountryCreateNestedOneWithoutStatesInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutStatesInput>;
  create?: InputMaybe<CountryCreateWithoutStatesInput>;
};

export type CountryCreateOrConnectWithoutLanguagesInput = {
  create: CountryCreateWithoutLanguagesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutRegionInput = {
  create: CountryCreateWithoutRegionInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutSiteInput = {
  create: CountryCreateWithoutSiteInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutStatesInput = {
  create: CountryCreateWithoutStatesInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateOrConnectWithoutSubregionInput = {
  create: CountryCreateWithoutSubregionInput;
  where: CountryWhereUniqueInput;
};

export type CountryCreateWithoutLanguagesInput = {
  Site?: InputMaybe<SiteCreateNestedManyWithoutCountryInput>;
  countryCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  region?: InputMaybe<RegionCreateNestedOneWithoutCountriesInput>;
  states?: InputMaybe<StateCreateNestedManyWithoutCountryInput>;
  subregion?: InputMaybe<SubregionCreateNestedOneWithoutCountriesInput>;
  translatedDemonym: Scalars['Json']['input'];
};

export type CountryCreateWithoutRegionInput = {
  Site?: InputMaybe<SiteCreateNestedManyWithoutCountryInput>;
  countryCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<LanguageCreateNestedManyWithoutCountriesInput>;
  name: Scalars['String']['input'];
  states?: InputMaybe<StateCreateNestedManyWithoutCountryInput>;
  subregion?: InputMaybe<SubregionCreateNestedOneWithoutCountriesInput>;
  translatedDemonym: Scalars['Json']['input'];
};

export type CountryCreateWithoutSiteInput = {
  countryCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<LanguageCreateNestedManyWithoutCountriesInput>;
  name: Scalars['String']['input'];
  region?: InputMaybe<RegionCreateNestedOneWithoutCountriesInput>;
  states?: InputMaybe<StateCreateNestedManyWithoutCountryInput>;
  subregion?: InputMaybe<SubregionCreateNestedOneWithoutCountriesInput>;
  translatedDemonym: Scalars['Json']['input'];
};

export type CountryCreateWithoutStatesInput = {
  Site?: InputMaybe<SiteCreateNestedManyWithoutCountryInput>;
  countryCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<LanguageCreateNestedManyWithoutCountriesInput>;
  name: Scalars['String']['input'];
  region?: InputMaybe<RegionCreateNestedOneWithoutCountriesInput>;
  subregion?: InputMaybe<SubregionCreateNestedOneWithoutCountriesInput>;
  translatedDemonym: Scalars['Json']['input'];
};

export type CountryCreateWithoutSubregionInput = {
  Site?: InputMaybe<SiteCreateNestedManyWithoutCountryInput>;
  countryCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  languages?: InputMaybe<LanguageCreateNestedManyWithoutCountriesInput>;
  name: Scalars['String']['input'];
  region?: InputMaybe<RegionCreateNestedOneWithoutCountriesInput>;
  states?: InputMaybe<StateCreateNestedManyWithoutCountryInput>;
  translatedDemonym: Scalars['Json']['input'];
};

export type CountryListRelationFilter = {
  every?: InputMaybe<CountryWhereInput>;
  none?: InputMaybe<CountryWhereInput>;
  some?: InputMaybe<CountryWhereInput>;
};

export type CountryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CountryOrderByWithRelationInput = {
  Site?: InputMaybe<SiteOrderByRelationAggregateInput>;
  countryCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languages?: InputMaybe<LanguageOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  region?: InputMaybe<RegionOrderByWithRelationInput>;
  regionId?: InputMaybe<SortOrderInput>;
  states?: InputMaybe<StateOrderByRelationAggregateInput>;
  subregion?: InputMaybe<SubregionOrderByWithRelationInput>;
  subregionId?: InputMaybe<SortOrderInput>;
  translatedDemonym?: InputMaybe<SortOrder>;
};

export type CountryScalarWhereInput = {
  AND?: InputMaybe<Array<CountryScalarWhereInput>>;
  NOT?: InputMaybe<Array<CountryScalarWhereInput>>;
  OR?: InputMaybe<Array<CountryScalarWhereInput>>;
  countryCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  regionId?: InputMaybe<StringNullableFilter>;
  subregionId?: InputMaybe<StringNullableFilter>;
  translatedDemonym?: InputMaybe<JsonFilter>;
};

export type CountryUpdateManyMutationInput = {
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  translatedDemonym?: InputMaybe<Scalars['Json']['input']>;
};

export type CountryUpdateManyWithWhereWithoutLanguagesInput = {
  data: CountryUpdateManyMutationInput;
  where: CountryScalarWhereInput;
};

export type CountryUpdateManyWithWhereWithoutRegionInput = {
  data: CountryUpdateManyMutationInput;
  where: CountryScalarWhereInput;
};

export type CountryUpdateManyWithWhereWithoutSubregionInput = {
  data: CountryUpdateManyMutationInput;
  where: CountryScalarWhereInput;
};

export type CountryUpdateManyWithoutLanguagesNestedInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutLanguagesInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutLanguagesInput>>;
  delete?: InputMaybe<Array<CountryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CountryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  set?: InputMaybe<Array<CountryWhereUniqueInput>>;
  update?: InputMaybe<Array<CountryUpdateWithWhereUniqueWithoutLanguagesInput>>;
  updateMany?: InputMaybe<Array<CountryUpdateManyWithWhereWithoutLanguagesInput>>;
  upsert?: InputMaybe<Array<CountryUpsertWithWhereUniqueWithoutLanguagesInput>>;
};

export type CountryUpdateManyWithoutRegionNestedInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutRegionInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutRegionInput>>;
  createMany?: InputMaybe<CountryCreateManyRegionInputEnvelope>;
  delete?: InputMaybe<Array<CountryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CountryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  set?: InputMaybe<Array<CountryWhereUniqueInput>>;
  update?: InputMaybe<Array<CountryUpdateWithWhereUniqueWithoutRegionInput>>;
  updateMany?: InputMaybe<Array<CountryUpdateManyWithWhereWithoutRegionInput>>;
  upsert?: InputMaybe<Array<CountryUpsertWithWhereUniqueWithoutRegionInput>>;
};

export type CountryUpdateManyWithoutSubregionNestedInput = {
  connect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CountryCreateOrConnectWithoutSubregionInput>>;
  create?: InputMaybe<Array<CountryCreateWithoutSubregionInput>>;
  createMany?: InputMaybe<CountryCreateManySubregionInputEnvelope>;
  delete?: InputMaybe<Array<CountryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CountryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CountryWhereUniqueInput>>;
  set?: InputMaybe<Array<CountryWhereUniqueInput>>;
  update?: InputMaybe<Array<CountryUpdateWithWhereUniqueWithoutSubregionInput>>;
  updateMany?: InputMaybe<Array<CountryUpdateManyWithWhereWithoutSubregionInput>>;
  upsert?: InputMaybe<Array<CountryUpsertWithWhereUniqueWithoutSubregionInput>>;
};

export type CountryUpdateOneWithoutSiteNestedInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutSiteInput>;
  create?: InputMaybe<CountryCreateWithoutSiteInput>;
  delete?: InputMaybe<CountryWhereInput>;
  disconnect?: InputMaybe<CountryWhereInput>;
  update?: InputMaybe<CountryUpdateToOneWithWhereWithoutSiteInput>;
  upsert?: InputMaybe<CountryUpsertWithoutSiteInput>;
};

export type CountryUpdateOneWithoutStatesNestedInput = {
  connect?: InputMaybe<CountryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CountryCreateOrConnectWithoutStatesInput>;
  create?: InputMaybe<CountryCreateWithoutStatesInput>;
  delete?: InputMaybe<CountryWhereInput>;
  disconnect?: InputMaybe<CountryWhereInput>;
  update?: InputMaybe<CountryUpdateToOneWithWhereWithoutStatesInput>;
  upsert?: InputMaybe<CountryUpsertWithoutStatesInput>;
};

export type CountryUpdateToOneWithWhereWithoutSiteInput = {
  data: CountryUpdateWithoutSiteInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryUpdateToOneWithWhereWithoutStatesInput = {
  data: CountryUpdateWithoutStatesInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryUpdateWithWhereUniqueWithoutLanguagesInput = {
  data: CountryUpdateWithoutLanguagesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateWithWhereUniqueWithoutRegionInput = {
  data: CountryUpdateWithoutRegionInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateWithWhereUniqueWithoutSubregionInput = {
  data: CountryUpdateWithoutSubregionInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpdateWithoutLanguagesInput = {
  Site?: InputMaybe<SiteUpdateManyWithoutCountryNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  region?: InputMaybe<RegionUpdateOneWithoutCountriesNestedInput>;
  states?: InputMaybe<StateUpdateManyWithoutCountryNestedInput>;
  subregion?: InputMaybe<SubregionUpdateOneWithoutCountriesNestedInput>;
  translatedDemonym?: InputMaybe<Scalars['Json']['input']>;
};

export type CountryUpdateWithoutRegionInput = {
  Site?: InputMaybe<SiteUpdateManyWithoutCountryNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languages?: InputMaybe<LanguageUpdateManyWithoutCountriesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  states?: InputMaybe<StateUpdateManyWithoutCountryNestedInput>;
  subregion?: InputMaybe<SubregionUpdateOneWithoutCountriesNestedInput>;
  translatedDemonym?: InputMaybe<Scalars['Json']['input']>;
};

export type CountryUpdateWithoutSiteInput = {
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languages?: InputMaybe<LanguageUpdateManyWithoutCountriesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  region?: InputMaybe<RegionUpdateOneWithoutCountriesNestedInput>;
  states?: InputMaybe<StateUpdateManyWithoutCountryNestedInput>;
  subregion?: InputMaybe<SubregionUpdateOneWithoutCountriesNestedInput>;
  translatedDemonym?: InputMaybe<Scalars['Json']['input']>;
};

export type CountryUpdateWithoutStatesInput = {
  Site?: InputMaybe<SiteUpdateManyWithoutCountryNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languages?: InputMaybe<LanguageUpdateManyWithoutCountriesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  region?: InputMaybe<RegionUpdateOneWithoutCountriesNestedInput>;
  subregion?: InputMaybe<SubregionUpdateOneWithoutCountriesNestedInput>;
  translatedDemonym?: InputMaybe<Scalars['Json']['input']>;
};

export type CountryUpdateWithoutSubregionInput = {
  Site?: InputMaybe<SiteUpdateManyWithoutCountryNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languages?: InputMaybe<LanguageUpdateManyWithoutCountriesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  region?: InputMaybe<RegionUpdateOneWithoutCountriesNestedInput>;
  states?: InputMaybe<StateUpdateManyWithoutCountryNestedInput>;
  translatedDemonym?: InputMaybe<Scalars['Json']['input']>;
};

export type CountryUpsertWithWhereUniqueWithoutLanguagesInput = {
  create: CountryCreateWithoutLanguagesInput;
  update: CountryUpdateWithoutLanguagesInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpsertWithWhereUniqueWithoutRegionInput = {
  create: CountryCreateWithoutRegionInput;
  update: CountryUpdateWithoutRegionInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpsertWithWhereUniqueWithoutSubregionInput = {
  create: CountryCreateWithoutSubregionInput;
  update: CountryUpdateWithoutSubregionInput;
  where: CountryWhereUniqueInput;
};

export type CountryUpsertWithoutSiteInput = {
  create: CountryCreateWithoutSiteInput;
  update: CountryUpdateWithoutSiteInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryUpsertWithoutStatesInput = {
  create: CountryCreateWithoutStatesInput;
  update: CountryUpdateWithoutStatesInput;
  where?: InputMaybe<CountryWhereInput>;
};

export type CountryWhereInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>;
  NOT?: InputMaybe<Array<CountryWhereInput>>;
  OR?: InputMaybe<Array<CountryWhereInput>>;
  Site?: InputMaybe<SiteListRelationFilter>;
  countryCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  languages?: InputMaybe<LanguageListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  region?: InputMaybe<RegionWhereInput>;
  regionId?: InputMaybe<StringNullableFilter>;
  states?: InputMaybe<StateListRelationFilter>;
  subregion?: InputMaybe<SubregionWhereInput>;
  subregionId?: InputMaybe<StringNullableFilter>;
  translatedDemonym?: InputMaybe<JsonFilter>;
};

export type CountryWhereUniqueInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>;
  NOT?: InputMaybe<Array<CountryWhereInput>>;
  OR?: InputMaybe<Array<CountryWhereInput>>;
  Site?: InputMaybe<SiteListRelationFilter>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  languages?: InputMaybe<LanguageListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  region?: InputMaybe<RegionWhereInput>;
  regionId?: InputMaybe<StringNullableFilter>;
  states?: InputMaybe<StateListRelationFilter>;
  subregion?: InputMaybe<SubregionWhereInput>;
  subregionId?: InputMaybe<StringNullableFilter>;
  translatedDemonym?: InputMaybe<JsonFilter>;
};

export type CreateDeployJobSite = {
  options?: InputMaybe<CreateDeployJobSiteOptions>;
  url: Scalars['String']['input'];
};

export type CreateDeployJobSiteOptions = {
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DeployJob = {
  __typename?: 'DeployJob';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<DeployJobStatusEnum>;
};

export enum DeployJobStatusEnum {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Runnable = 'RUNNABLE',
  Running = 'RUNNING',
  Starting = 'STARTING',
  Submitted = 'SUBMITTED',
  Succeeded = 'SUCCEEDED'
}

export enum DisplayType {
  Meta = 'META',
  Ui = 'UI'
}

export type EnumContentItemTranslationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ContentItemTranslationType>;
};

export type EnumContentItemTranslationTypeFilter = {
  equals?: InputMaybe<ContentItemTranslationType>;
  in?: InputMaybe<Array<ContentItemTranslationType>>;
  not?: InputMaybe<NestedEnumContentItemTranslationTypeFilter>;
  notIn?: InputMaybe<Array<ContentItemTranslationType>>;
};

export type EnumContextTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ContextType>;
};

export type EnumContextTypeFilter = {
  equals?: InputMaybe<ContextType>;
  in?: InputMaybe<Array<ContextType>>;
  not?: InputMaybe<NestedEnumContextTypeFilter>;
  notIn?: InputMaybe<Array<ContextType>>;
};

export type EnumDisplayTypeNullableFilter = {
  equals?: InputMaybe<DisplayType>;
  in?: InputMaybe<Array<DisplayType>>;
  not?: InputMaybe<NestedEnumDisplayTypeNullableFilter>;
  notIn?: InputMaybe<Array<DisplayType>>;
};

export type EnumFieldTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<FieldType>;
};

export type EnumFieldTypeFilter = {
  equals?: InputMaybe<FieldType>;
  in?: InputMaybe<Array<FieldType>>;
  not?: InputMaybe<NestedEnumFieldTypeFilter>;
  notIn?: InputMaybe<Array<FieldType>>;
};

export type EnumGeoModeFieldUpdateOperationsInput = {
  set?: InputMaybe<GeoMode>;
};

export type EnumGeoModeFilter = {
  equals?: InputMaybe<GeoMode>;
  in?: InputMaybe<Array<GeoMode>>;
  not?: InputMaybe<NestedEnumGeoModeFilter>;
  notIn?: InputMaybe<Array<GeoMode>>;
};

export type EnumMenuTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<MenuType>;
};

export type EnumMenuTypeFilter = {
  equals?: InputMaybe<MenuType>;
  in?: InputMaybe<Array<MenuType>>;
  not?: InputMaybe<NestedEnumMenuTypeFilter>;
  notIn?: InputMaybe<Array<MenuType>>;
};

export type EnumPostTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PostType>;
};

export type EnumPostTypeFilter = {
  equals?: InputMaybe<PostType>;
  in?: InputMaybe<Array<PostType>>;
  not?: InputMaybe<NestedEnumPostTypeFilter>;
  notIn?: InputMaybe<Array<PostType>>;
};

export type EnumRedirectKindFieldUpdateOperationsInput = {
  set?: InputMaybe<RedirectKind>;
};

export type EnumRedirectKindFilter = {
  equals?: InputMaybe<RedirectKind>;
  in?: InputMaybe<Array<RedirectKind>>;
  not?: InputMaybe<NestedEnumRedirectKindFilter>;
  notIn?: InputMaybe<Array<RedirectKind>>;
};

export type EnumRedirectScopeFieldUpdateOperationsInput = {
  set?: InputMaybe<RedirectScope>;
};

export type EnumRedirectScopeFilter = {
  equals?: InputMaybe<RedirectScope>;
  in?: InputMaybe<Array<RedirectScope>>;
  not?: InputMaybe<NestedEnumRedirectScopeFilter>;
  notIn?: InputMaybe<Array<RedirectScope>>;
};

export type EnumResourceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ResourceType>;
};

export type EnumResourceTypeFilter = {
  equals?: InputMaybe<ResourceType>;
  in?: InputMaybe<Array<ResourceType>>;
  not?: InputMaybe<NestedEnumResourceTypeFilter>;
  notIn?: InputMaybe<Array<ResourceType>>;
};

export type EnumRouteResourceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<RouteResourceType>;
};

export type EnumRouteResourceTypeFilter = {
  equals?: InputMaybe<RouteResourceType>;
  in?: InputMaybe<Array<RouteResourceType>>;
  not?: InputMaybe<NestedEnumRouteResourceTypeFilter>;
  notIn?: InputMaybe<Array<RouteResourceType>>;
};

export type EnumRouteResourceTypeNullableFilter = {
  equals?: InputMaybe<RouteResourceType>;
  in?: InputMaybe<Array<RouteResourceType>>;
  not?: InputMaybe<NestedEnumRouteResourceTypeNullableFilter>;
  notIn?: InputMaybe<Array<RouteResourceType>>;
};

export type EnumStringItemStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<StringItemStatus>;
};

export type EnumStringItemStatusFilter = {
  equals?: InputMaybe<StringItemStatus>;
  in?: InputMaybe<Array<StringItemStatus>>;
  not?: InputMaybe<NestedEnumStringItemStatusFilter>;
  notIn?: InputMaybe<Array<StringItemStatus>>;
};

export type EnumStringItemSyncStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<StringItemSyncStatus>;
};

export type EnumStringItemSyncStatusFilter = {
  equals?: InputMaybe<StringItemSyncStatus>;
  in?: InputMaybe<Array<StringItemSyncStatus>>;
  not?: InputMaybe<NestedEnumStringItemSyncStatusFilter>;
  notIn?: InputMaybe<Array<StringItemSyncStatus>>;
};

export type EnumStringItemTranslationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<StringItemTranslationType>;
};

export type EnumStringItemTranslationTypeFilter = {
  equals?: InputMaybe<StringItemTranslationType>;
  in?: InputMaybe<Array<StringItemTranslationType>>;
  not?: InputMaybe<NestedEnumStringItemTranslationTypeFilter>;
  notIn?: InputMaybe<Array<StringItemTranslationType>>;
};

export type EnumStringTemplateVariableResolveLocationFieldUpdateOperationsInput = {
  set?: InputMaybe<StringTemplateVariableResolveLocation>;
};

export type EnumStringTemplateVariableResolveLocationFilter = {
  equals?: InputMaybe<StringTemplateVariableResolveLocation>;
  in?: InputMaybe<Array<StringTemplateVariableResolveLocation>>;
  not?: InputMaybe<NestedEnumStringTemplateVariableResolveLocationFilter>;
  notIn?: InputMaybe<Array<StringTemplateVariableResolveLocation>>;
};

export type EnumStringTemplateVariableTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<StringTemplateVariableType>;
};

export type EnumStringTemplateVariableTypeFilter = {
  equals?: InputMaybe<StringTemplateVariableType>;
  in?: InputMaybe<Array<StringTemplateVariableType>>;
  not?: InputMaybe<NestedEnumStringTemplateVariableTypeFilter>;
  notIn?: InputMaybe<Array<StringTemplateVariableType>>;
};

export type EnumTemplateTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<TemplateType>;
};

export type EnumTemplateTypeFilter = {
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export enum FieldType {
  Author = 'AUTHOR',
  Boolean = 'BOOLEAN',
  Country = 'COUNTRY',
  Date = 'DATE',
  Filtertaxonomyrule = 'FILTERTAXONOMYRULE',
  Html = 'HTML',
  Json = 'JSON',
  Language = 'LANGUAGE',
  Level = 'LEVEL',
  LmsLink = 'LMS_LINK',
  Markdown = 'MARKDOWN',
  Mediaitem = 'MEDIAITEM',
  Multiline = 'MULTILINE',
  Network = 'NETWORK',
  Number = 'NUMBER',
  Offers = 'OFFERS',
  Page = 'PAGE',
  Pillarsection = 'PILLARSECTION',
  Pool = 'POOL',
  PortableText = 'PORTABLE_TEXT',
  PortableTextMultiline = 'PORTABLE_TEXT_MULTILINE',
  PortableTextSingleline = 'PORTABLE_TEXT_SINGLELINE',
  Post = 'POST',
  Product = 'PRODUCT',
  Property = 'PROPERTY',
  Provider = 'PROVIDER',
  Resource = 'RESOURCE',
  Select = 'SELECT',
  Singleline = 'SINGLELINE',
  Site = 'SITE',
  Slug = 'SLUG',
  String = 'STRING',
  Stringtemplate = 'STRINGTEMPLATE',
  Taxonomyitem = 'TAXONOMYITEM',
  Template = 'TEMPLATE',
  Templatefield = 'TEMPLATEFIELD',
  Url = 'URL',
  UrlContent = 'URL_CONTENT',
  Vertical = 'VERTICAL'
}

export type FilterTaxonomyItem = {
  __typename?: 'FilterTaxonomyItem';
  baseTaxonomy: TaxonomyItem;
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['Json']['output']>;
  filterTaxonomy: TaxonomyItem;
  filterTaxonomyRule?: Maybe<FilterTaxonomyRule>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Network>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  resourceType?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type FilterTaxonomyItemContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type FilterTaxonomyItemHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type FilterTaxonomyItemPropertiesArgs = {
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type FilterTaxonomyItemCreateManyBaseTaxonomyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyId: Scalars['String']['input'];
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateManyBaseTaxonomyInputEnvelope = {
  data?: InputMaybe<Array<FilterTaxonomyItemCreateManyBaseTaxonomyInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterTaxonomyItemCreateManyFilterTaxonomyInput = {
  baseTaxonomyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateManyFilterTaxonomyInputEnvelope = {
  data?: InputMaybe<Array<FilterTaxonomyItemCreateManyFilterTaxonomyInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterTaxonomyItemCreateManyFilterTaxonomyRuleInput = {
  baseTaxonomyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateManyFilterTaxonomyRuleInputEnvelope = {
  data?: InputMaybe<Array<FilterTaxonomyItemCreateManyFilterTaxonomyRuleInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterTaxonomyItemCreateManyNetworkInput = {
  baseTaxonomyId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyId: Scalars['String']['input'];
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<FilterTaxonomyItemCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput = {
  connect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyItemCreateOrConnectWithoutBaseTaxonomyInput>>;
  create?: InputMaybe<Array<FilterTaxonomyItemCreateWithoutBaseTaxonomyInput>>;
  createMany?: InputMaybe<FilterTaxonomyItemCreateManyBaseTaxonomyInputEnvelope>;
};

export type FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput = {
  connect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyItemCreateOrConnectWithoutFilterTaxonomyInput>>;
  create?: InputMaybe<Array<FilterTaxonomyItemCreateWithoutFilterTaxonomyInput>>;
  createMany?: InputMaybe<FilterTaxonomyItemCreateManyFilterTaxonomyInputEnvelope>;
};

export type FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyRuleInput = {
  connect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyItemCreateOrConnectWithoutFilterTaxonomyRuleInput>>;
  create?: InputMaybe<Array<FilterTaxonomyItemCreateWithoutFilterTaxonomyRuleInput>>;
  createMany?: InputMaybe<FilterTaxonomyItemCreateManyFilterTaxonomyRuleInputEnvelope>;
};

export type FilterTaxonomyItemCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<FilterTaxonomyItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<FilterTaxonomyItemCreateManyNetworkInputEnvelope>;
};

export type FilterTaxonomyItemCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<FilterTaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyItemCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<FilterTaxonomyItemCreateWithoutContentInput>;
};

export type FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<FilterTaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyItemCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<FilterTaxonomyItemCreateWithoutPropertiesInput>;
};

export type FilterTaxonomyItemCreateOrConnectWithoutBaseTaxonomyInput = {
  create: FilterTaxonomyItemCreateWithoutBaseTaxonomyInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemCreateOrConnectWithoutContentInput = {
  create: FilterTaxonomyItemCreateWithoutContentInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemCreateOrConnectWithoutFilterTaxonomyInput = {
  create: FilterTaxonomyItemCreateWithoutFilterTaxonomyInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemCreateOrConnectWithoutFilterTaxonomyRuleInput = {
  create: FilterTaxonomyItemCreateWithoutFilterTaxonomyRuleInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemCreateOrConnectWithoutNetworkInput = {
  create: FilterTaxonomyItemCreateWithoutNetworkInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemCreateOrConnectWithoutPropertiesInput = {
  create: FilterTaxonomyItemCreateWithoutPropertiesInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemCreateWithoutBaseTaxonomyInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyFilterItemsInput;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutFilterTaxonomyItemsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyItemInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateWithoutContentInput = {
  baseTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyBaseItemsInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyFilterItemsInput;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutFilterTaxonomyItemsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyItemInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateWithoutFilterTaxonomyInput = {
  baseTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyBaseItemsInput;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutFilterTaxonomyItemsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyItemInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateWithoutFilterTaxonomyRuleInput = {
  baseTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyBaseItemsInput;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyFilterItemsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyItemInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateWithoutNetworkInput = {
  baseTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyBaseItemsInput;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyFilterItemsInput;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutFilterTaxonomyItemsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemCreateWithoutPropertiesInput = {
  baseTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyBaseItemsInput;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomy: RouteResourceCreateNestedOneWithoutFilterTaxonomyFilterItemsInput;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutFilterTaxonomyItemsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyItemInput;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyItemListRelationFilter = {
  every?: InputMaybe<FilterTaxonomyItemWhereInput>;
  none?: InputMaybe<FilterTaxonomyItemWhereInput>;
  some?: InputMaybe<FilterTaxonomyItemWhereInput>;
};

export type FilterTaxonomyItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FilterTaxonomyItemOrderByWithRelationInput = {
  baseTaxonomy?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  baseTaxonomyId?: InputMaybe<SortOrder>;
  content?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  filterTaxonomy?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  filterTaxonomyId?: InputMaybe<SortOrder>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleOrderByWithRelationInput>;
  filterTaxonomyRuleId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrder>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FilterTaxonomyItemScalarWhereInput = {
  AND?: InputMaybe<Array<FilterTaxonomyItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<FilterTaxonomyItemScalarWhereInput>>;
  OR?: InputMaybe<Array<FilterTaxonomyItemScalarWhereInput>>;
  baseTaxonomyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  filterTaxonomyId?: InputMaybe<StringFilter>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FilterTaxonomyItemUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyItemUpdateManyWithWhereWithoutBaseTaxonomyInput = {
  data: FilterTaxonomyItemUpdateManyMutationInput;
  where: FilterTaxonomyItemScalarWhereInput;
};

export type FilterTaxonomyItemUpdateManyWithWhereWithoutFilterTaxonomyInput = {
  data: FilterTaxonomyItemUpdateManyMutationInput;
  where: FilterTaxonomyItemScalarWhereInput;
};

export type FilterTaxonomyItemUpdateManyWithWhereWithoutFilterTaxonomyRuleInput = {
  data: FilterTaxonomyItemUpdateManyMutationInput;
  where: FilterTaxonomyItemScalarWhereInput;
};

export type FilterTaxonomyItemUpdateManyWithWhereWithoutNetworkInput = {
  data: FilterTaxonomyItemUpdateManyMutationInput;
  where: FilterTaxonomyItemScalarWhereInput;
};

export type FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput = {
  connect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyItemCreateOrConnectWithoutBaseTaxonomyInput>>;
  create?: InputMaybe<Array<FilterTaxonomyItemCreateWithoutBaseTaxonomyInput>>;
  createMany?: InputMaybe<FilterTaxonomyItemCreateManyBaseTaxonomyInputEnvelope>;
  delete?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FilterTaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<FilterTaxonomyItemUpdateWithWhereUniqueWithoutBaseTaxonomyInput>>;
  updateMany?: InputMaybe<Array<FilterTaxonomyItemUpdateManyWithWhereWithoutBaseTaxonomyInput>>;
  upsert?: InputMaybe<Array<FilterTaxonomyItemUpsertWithWhereUniqueWithoutBaseTaxonomyInput>>;
};

export type FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput = {
  connect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyItemCreateOrConnectWithoutFilterTaxonomyInput>>;
  create?: InputMaybe<Array<FilterTaxonomyItemCreateWithoutFilterTaxonomyInput>>;
  createMany?: InputMaybe<FilterTaxonomyItemCreateManyFilterTaxonomyInputEnvelope>;
  delete?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FilterTaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<FilterTaxonomyItemUpdateWithWhereUniqueWithoutFilterTaxonomyInput>>;
  updateMany?: InputMaybe<Array<FilterTaxonomyItemUpdateManyWithWhereWithoutFilterTaxonomyInput>>;
  upsert?: InputMaybe<Array<FilterTaxonomyItemUpsertWithWhereUniqueWithoutFilterTaxonomyInput>>;
};

export type FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput = {
  connect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyItemCreateOrConnectWithoutFilterTaxonomyRuleInput>>;
  create?: InputMaybe<Array<FilterTaxonomyItemCreateWithoutFilterTaxonomyRuleInput>>;
  createMany?: InputMaybe<FilterTaxonomyItemCreateManyFilterTaxonomyRuleInputEnvelope>;
  delete?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FilterTaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<FilterTaxonomyItemUpdateWithWhereUniqueWithoutFilterTaxonomyRuleInput>>;
  updateMany?: InputMaybe<Array<FilterTaxonomyItemUpdateManyWithWhereWithoutFilterTaxonomyRuleInput>>;
  upsert?: InputMaybe<Array<FilterTaxonomyItemUpsertWithWhereUniqueWithoutFilterTaxonomyRuleInput>>;
};

export type FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<FilterTaxonomyItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<FilterTaxonomyItemCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FilterTaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<FilterTaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<FilterTaxonomyItemUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<FilterTaxonomyItemUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<FilterTaxonomyItemUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type FilterTaxonomyItemUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<FilterTaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyItemCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<FilterTaxonomyItemCreateWithoutContentInput>;
  delete?: InputMaybe<FilterTaxonomyItemWhereInput>;
  disconnect?: InputMaybe<FilterTaxonomyItemWhereInput>;
  update?: InputMaybe<FilterTaxonomyItemUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<FilterTaxonomyItemUpsertWithoutContentInput>;
};

export type FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<FilterTaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyItemCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<FilterTaxonomyItemCreateWithoutPropertiesInput>;
  delete?: InputMaybe<FilterTaxonomyItemWhereInput>;
  disconnect?: InputMaybe<FilterTaxonomyItemWhereInput>;
  update?: InputMaybe<FilterTaxonomyItemUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<FilterTaxonomyItemUpsertWithoutPropertiesInput>;
};

export type FilterTaxonomyItemUpdateToOneWithWhereWithoutContentInput = {
  data: FilterTaxonomyItemUpdateWithoutContentInput;
  where?: InputMaybe<FilterTaxonomyItemWhereInput>;
};

export type FilterTaxonomyItemUpdateToOneWithWhereWithoutPropertiesInput = {
  data: FilterTaxonomyItemUpdateWithoutPropertiesInput;
  where?: InputMaybe<FilterTaxonomyItemWhereInput>;
};

export type FilterTaxonomyItemUpdateWithWhereUniqueWithoutBaseTaxonomyInput = {
  data: FilterTaxonomyItemUpdateWithoutBaseTaxonomyInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemUpdateWithWhereUniqueWithoutFilterTaxonomyInput = {
  data: FilterTaxonomyItemUpdateWithoutFilterTaxonomyInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemUpdateWithWhereUniqueWithoutFilterTaxonomyRuleInput = {
  data: FilterTaxonomyItemUpdateWithoutFilterTaxonomyRuleInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemUpdateWithWhereUniqueWithoutNetworkInput = {
  data: FilterTaxonomyItemUpdateWithoutNetworkInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemUpdateWithoutBaseTaxonomyInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyFilterItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutFilterTaxonomyItemsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyItemNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyItemUpdateWithoutContentInput = {
  baseTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyBaseItemsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyFilterItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutFilterTaxonomyItemsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyItemNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyItemUpdateWithoutFilterTaxonomyInput = {
  baseTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyBaseItemsNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutFilterTaxonomyItemsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyItemNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyItemUpdateWithoutFilterTaxonomyRuleInput = {
  baseTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyBaseItemsNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyFilterItemsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyItemNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyItemUpdateWithoutNetworkInput = {
  baseTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyBaseItemsNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyFilterItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutFilterTaxonomyItemsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyItemUpdateWithoutPropertiesInput = {
  baseTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyBaseItemsNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomy?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyFilterItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutFilterTaxonomyItemsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyItemNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyItemUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type FilterTaxonomyItemUpsertWithWhereUniqueWithoutBaseTaxonomyInput = {
  create: FilterTaxonomyItemCreateWithoutBaseTaxonomyInput;
  update: FilterTaxonomyItemUpdateWithoutBaseTaxonomyInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemUpsertWithWhereUniqueWithoutFilterTaxonomyInput = {
  create: FilterTaxonomyItemCreateWithoutFilterTaxonomyInput;
  update: FilterTaxonomyItemUpdateWithoutFilterTaxonomyInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemUpsertWithWhereUniqueWithoutFilterTaxonomyRuleInput = {
  create: FilterTaxonomyItemCreateWithoutFilterTaxonomyRuleInput;
  update: FilterTaxonomyItemUpdateWithoutFilterTaxonomyRuleInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemUpsertWithWhereUniqueWithoutNetworkInput = {
  create: FilterTaxonomyItemCreateWithoutNetworkInput;
  update: FilterTaxonomyItemUpdateWithoutNetworkInput;
  where: FilterTaxonomyItemWhereUniqueInput;
};

export type FilterTaxonomyItemUpsertWithoutContentInput = {
  create: FilterTaxonomyItemCreateWithoutContentInput;
  update: FilterTaxonomyItemUpdateWithoutContentInput;
  where?: InputMaybe<FilterTaxonomyItemWhereInput>;
};

export type FilterTaxonomyItemUpsertWithoutPropertiesInput = {
  create: FilterTaxonomyItemCreateWithoutPropertiesInput;
  update: FilterTaxonomyItemUpdateWithoutPropertiesInput;
  where?: InputMaybe<FilterTaxonomyItemWhereInput>;
};

export type FilterTaxonomyItemWhereInput = {
  AND?: InputMaybe<Array<FilterTaxonomyItemWhereInput>>;
  NOT?: InputMaybe<Array<FilterTaxonomyItemWhereInput>>;
  OR?: InputMaybe<Array<FilterTaxonomyItemWhereInput>>;
  baseTaxonomy?: InputMaybe<RouteResourceWhereInput>;
  baseTaxonomyId?: InputMaybe<StringFilter>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  filterTaxonomy?: InputMaybe<RouteResourceWhereInput>;
  filterTaxonomyId?: InputMaybe<StringFilter>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FilterTaxonomyItemWhereUniqueInput = {
  AND?: InputMaybe<Array<FilterTaxonomyItemWhereInput>>;
  NOT?: InputMaybe<Array<FilterTaxonomyItemWhereInput>>;
  OR?: InputMaybe<Array<FilterTaxonomyItemWhereInput>>;
  baseTaxonomy?: InputMaybe<RouteResourceWhereInput>;
  baseTaxonomyId?: InputMaybe<StringFilter>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  filterTaxonomy?: InputMaybe<RouteResourceWhereInput>;
  filterTaxonomyId?: InputMaybe<StringFilter>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FilterTaxonomyRule = {
  __typename?: 'FilterTaxonomyRule';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  filterTaxonomyItems: Array<FilterTaxonomyItem>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id: Scalars['String']['output'];
  network: Network;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  taxonomyBase: RouteResource;
  taxonomyFilter: RouteResource;
  updatedAt: Scalars['DateTime']['output'];
};


export type FilterTaxonomyRuleContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type FilterTaxonomyRuleFilterTaxonomyItemsArgs = {
  cursor?: InputMaybe<FilterTaxonomyItemWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FilterTaxonomyItemWhereInput>;
};


export type FilterTaxonomyRuleHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type FilterTaxonomyRulePropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type FilterTaxonomyRuleCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  taxonomyBaseId: Scalars['String']['input'];
  taxonomyFilterId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<FilterTaxonomyRuleCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterTaxonomyRuleCreateManyTaxonomyBaseInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['String']['input'];
  taxonomyFilterId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateManyTaxonomyBaseInputEnvelope = {
  data?: InputMaybe<Array<FilterTaxonomyRuleCreateManyTaxonomyBaseInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterTaxonomyRuleCreateManyTaxonomyFilterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['String']['input'];
  taxonomyBaseId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateManyTaxonomyFilterInputEnvelope = {
  data?: InputMaybe<Array<FilterTaxonomyRuleCreateManyTaxonomyFilterInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyRuleCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<FilterTaxonomyRuleCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<FilterTaxonomyRuleCreateManyNetworkInputEnvelope>;
};

export type FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput = {
  connect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyRuleCreateOrConnectWithoutTaxonomyBaseInput>>;
  create?: InputMaybe<Array<FilterTaxonomyRuleCreateWithoutTaxonomyBaseInput>>;
  createMany?: InputMaybe<FilterTaxonomyRuleCreateManyTaxonomyBaseInputEnvelope>;
};

export type FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput = {
  connect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyRuleCreateOrConnectWithoutTaxonomyFilterInput>>;
  create?: InputMaybe<Array<FilterTaxonomyRuleCreateWithoutTaxonomyFilterInput>>;
  createMany?: InputMaybe<FilterTaxonomyRuleCreateManyTaxonomyFilterInputEnvelope>;
};

export type FilterTaxonomyRuleCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyRuleCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<FilterTaxonomyRuleCreateWithoutContentInput>;
};

export type FilterTaxonomyRuleCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyRuleCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<FilterTaxonomyRuleCreateWithoutContentOldInput>;
};

export type FilterTaxonomyRuleCreateNestedOneWithoutFilterTaxonomyItemsInput = {
  connect?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyRuleCreateOrConnectWithoutFilterTaxonomyItemsInput>;
  create?: InputMaybe<FilterTaxonomyRuleCreateWithoutFilterTaxonomyItemsInput>;
};

export type FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyRuleCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<FilterTaxonomyRuleCreateWithoutPropertiesInput>;
};

export type FilterTaxonomyRuleCreateOrConnectWithoutContentInput = {
  create: FilterTaxonomyRuleCreateWithoutContentInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleCreateOrConnectWithoutContentOldInput = {
  create: FilterTaxonomyRuleCreateWithoutContentOldInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleCreateOrConnectWithoutFilterTaxonomyItemsInput = {
  create: FilterTaxonomyRuleCreateWithoutFilterTaxonomyItemsInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleCreateOrConnectWithoutNetworkInput = {
  create: FilterTaxonomyRuleCreateWithoutNetworkInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleCreateOrConnectWithoutPropertiesInput = {
  create: FilterTaxonomyRuleCreateWithoutPropertiesInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleCreateOrConnectWithoutTaxonomyBaseInput = {
  create: FilterTaxonomyRuleCreateWithoutTaxonomyBaseInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleCreateOrConnectWithoutTaxonomyFilterInput = {
  create: FilterTaxonomyRuleCreateWithoutTaxonomyFilterInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleCreateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyRuleInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  taxonomyBase: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleBaseInput;
  taxonomyFilter: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleFilterInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutFilterTaxonomyRuleInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyRuleInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  taxonomyBase: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleBaseInput;
  taxonomyFilter: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleFilterInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateWithoutFilterTaxonomyItemsInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutFilterTaxonomyRuleInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyRuleInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  taxonomyBase: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleBaseInput;
  taxonomyFilter: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleFilterInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutFilterTaxonomyRuleInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  taxonomyBase: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleBaseInput;
  taxonomyFilter: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleFilterInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutFilterTaxonomyRuleInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyRuleInput;
  taxonomyBase: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleBaseInput;
  taxonomyFilter: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleFilterInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateWithoutTaxonomyBaseInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutFilterTaxonomyRuleInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyRuleInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  taxonomyFilter: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleFilterInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleCreateWithoutTaxonomyFilterInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutFilterTaxonomyRuleInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutFilterTaxonomyRuleInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutFilterTaxonomyRuleInput>;
  taxonomyBase: RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleBaseInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FilterTaxonomyRuleListRelationFilter = {
  every?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  none?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  some?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FilterTaxonomyRuleOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrder>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  taxonomyBase?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  taxonomyBaseId?: InputMaybe<SortOrder>;
  taxonomyFilter?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  taxonomyFilterId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FilterTaxonomyRuleScalarWhereInput = {
  AND?: InputMaybe<Array<FilterTaxonomyRuleScalarWhereInput>>;
  NOT?: InputMaybe<Array<FilterTaxonomyRuleScalarWhereInput>>;
  OR?: InputMaybe<Array<FilterTaxonomyRuleScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringFilter>;
  taxonomyBaseId?: InputMaybe<StringFilter>;
  taxonomyFilterId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FilterTaxonomyRuleUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyRuleUpdateManyWithWhereWithoutNetworkInput = {
  data: FilterTaxonomyRuleUpdateManyMutationInput;
  where: FilterTaxonomyRuleScalarWhereInput;
};

export type FilterTaxonomyRuleUpdateManyWithWhereWithoutTaxonomyBaseInput = {
  data: FilterTaxonomyRuleUpdateManyMutationInput;
  where: FilterTaxonomyRuleScalarWhereInput;
};

export type FilterTaxonomyRuleUpdateManyWithWhereWithoutTaxonomyFilterInput = {
  data: FilterTaxonomyRuleUpdateManyMutationInput;
  where: FilterTaxonomyRuleScalarWhereInput;
};

export type FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyRuleCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<FilterTaxonomyRuleCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<FilterTaxonomyRuleCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FilterTaxonomyRuleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  set?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  update?: InputMaybe<Array<FilterTaxonomyRuleUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<FilterTaxonomyRuleUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<FilterTaxonomyRuleUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput = {
  connect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyRuleCreateOrConnectWithoutTaxonomyBaseInput>>;
  create?: InputMaybe<Array<FilterTaxonomyRuleCreateWithoutTaxonomyBaseInput>>;
  createMany?: InputMaybe<FilterTaxonomyRuleCreateManyTaxonomyBaseInputEnvelope>;
  delete?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FilterTaxonomyRuleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  set?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  update?: InputMaybe<Array<FilterTaxonomyRuleUpdateWithWhereUniqueWithoutTaxonomyBaseInput>>;
  updateMany?: InputMaybe<Array<FilterTaxonomyRuleUpdateManyWithWhereWithoutTaxonomyBaseInput>>;
  upsert?: InputMaybe<Array<FilterTaxonomyRuleUpsertWithWhereUniqueWithoutTaxonomyBaseInput>>;
};

export type FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput = {
  connect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FilterTaxonomyRuleCreateOrConnectWithoutTaxonomyFilterInput>>;
  create?: InputMaybe<Array<FilterTaxonomyRuleCreateWithoutTaxonomyFilterInput>>;
  createMany?: InputMaybe<FilterTaxonomyRuleCreateManyTaxonomyFilterInputEnvelope>;
  delete?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FilterTaxonomyRuleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  set?: InputMaybe<Array<FilterTaxonomyRuleWhereUniqueInput>>;
  update?: InputMaybe<Array<FilterTaxonomyRuleUpdateWithWhereUniqueWithoutTaxonomyFilterInput>>;
  updateMany?: InputMaybe<Array<FilterTaxonomyRuleUpdateManyWithWhereWithoutTaxonomyFilterInput>>;
  upsert?: InputMaybe<Array<FilterTaxonomyRuleUpsertWithWhereUniqueWithoutTaxonomyFilterInput>>;
};

export type FilterTaxonomyRuleUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyRuleCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<FilterTaxonomyRuleCreateWithoutContentInput>;
  delete?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  disconnect?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  update?: InputMaybe<FilterTaxonomyRuleUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<FilterTaxonomyRuleUpsertWithoutContentInput>;
};

export type FilterTaxonomyRuleUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyRuleCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<FilterTaxonomyRuleCreateWithoutContentOldInput>;
  delete?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  disconnect?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  update?: InputMaybe<FilterTaxonomyRuleUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<FilterTaxonomyRuleUpsertWithoutContentOldInput>;
};

export type FilterTaxonomyRuleUpdateOneWithoutFilterTaxonomyItemsNestedInput = {
  connect?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyRuleCreateOrConnectWithoutFilterTaxonomyItemsInput>;
  create?: InputMaybe<FilterTaxonomyRuleCreateWithoutFilterTaxonomyItemsInput>;
  delete?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  disconnect?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  update?: InputMaybe<FilterTaxonomyRuleUpdateToOneWithWhereWithoutFilterTaxonomyItemsInput>;
  upsert?: InputMaybe<FilterTaxonomyRuleUpsertWithoutFilterTaxonomyItemsInput>;
};

export type FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FilterTaxonomyRuleCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<FilterTaxonomyRuleCreateWithoutPropertiesInput>;
  delete?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  disconnect?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  update?: InputMaybe<FilterTaxonomyRuleUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<FilterTaxonomyRuleUpsertWithoutPropertiesInput>;
};

export type FilterTaxonomyRuleUpdateToOneWithWhereWithoutContentInput = {
  data: FilterTaxonomyRuleUpdateWithoutContentInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleUpdateToOneWithWhereWithoutContentOldInput = {
  data: FilterTaxonomyRuleUpdateWithoutContentOldInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleUpdateToOneWithWhereWithoutFilterTaxonomyItemsInput = {
  data: FilterTaxonomyRuleUpdateWithoutFilterTaxonomyItemsInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleUpdateToOneWithWhereWithoutPropertiesInput = {
  data: FilterTaxonomyRuleUpdateWithoutPropertiesInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleUpdateWithWhereUniqueWithoutNetworkInput = {
  data: FilterTaxonomyRuleUpdateWithoutNetworkInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleUpdateWithWhereUniqueWithoutTaxonomyBaseInput = {
  data: FilterTaxonomyRuleUpdateWithoutTaxonomyBaseInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleUpdateWithWhereUniqueWithoutTaxonomyFilterInput = {
  data: FilterTaxonomyRuleUpdateWithoutTaxonomyFilterInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleUpdateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyRuleNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  taxonomyBase?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleBaseNestedInput>;
  taxonomyFilter?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleFilterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyRuleUpdateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyRuleNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  taxonomyBase?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleBaseNestedInput>;
  taxonomyFilter?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleFilterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyRuleUpdateWithoutFilterTaxonomyItemsInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyRuleNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  taxonomyBase?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleBaseNestedInput>;
  taxonomyFilter?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleFilterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyRuleUpdateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  taxonomyBase?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleBaseNestedInput>;
  taxonomyFilter?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleFilterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyRuleUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyRuleNestedInput>;
  taxonomyBase?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleBaseNestedInput>;
  taxonomyFilter?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleFilterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyRuleUpdateWithoutTaxonomyBaseInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyRuleNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  taxonomyFilter?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleFilterNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyRuleUpdateWithoutTaxonomyFilterInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutFilterTaxonomyRuleNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput>;
  taxonomyBase?: InputMaybe<RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleBaseNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type FilterTaxonomyRuleUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type FilterTaxonomyRuleUpsertWithWhereUniqueWithoutNetworkInput = {
  create: FilterTaxonomyRuleCreateWithoutNetworkInput;
  update: FilterTaxonomyRuleUpdateWithoutNetworkInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleUpsertWithWhereUniqueWithoutTaxonomyBaseInput = {
  create: FilterTaxonomyRuleCreateWithoutTaxonomyBaseInput;
  update: FilterTaxonomyRuleUpdateWithoutTaxonomyBaseInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleUpsertWithWhereUniqueWithoutTaxonomyFilterInput = {
  create: FilterTaxonomyRuleCreateWithoutTaxonomyFilterInput;
  update: FilterTaxonomyRuleUpdateWithoutTaxonomyFilterInput;
  where: FilterTaxonomyRuleWhereUniqueInput;
};

export type FilterTaxonomyRuleUpsertWithoutContentInput = {
  create: FilterTaxonomyRuleCreateWithoutContentInput;
  update: FilterTaxonomyRuleUpdateWithoutContentInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleUpsertWithoutContentOldInput = {
  create: FilterTaxonomyRuleCreateWithoutContentOldInput;
  update: FilterTaxonomyRuleUpdateWithoutContentOldInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleUpsertWithoutFilterTaxonomyItemsInput = {
  create: FilterTaxonomyRuleCreateWithoutFilterTaxonomyItemsInput;
  update: FilterTaxonomyRuleUpdateWithoutFilterTaxonomyItemsInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleUpsertWithoutPropertiesInput = {
  create: FilterTaxonomyRuleCreateWithoutPropertiesInput;
  update: FilterTaxonomyRuleUpdateWithoutPropertiesInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};

export type FilterTaxonomyRuleWhereInput = {
  AND?: InputMaybe<Array<FilterTaxonomyRuleWhereInput>>;
  NOT?: InputMaybe<Array<FilterTaxonomyRuleWhereInput>>;
  OR?: InputMaybe<Array<FilterTaxonomyRuleWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  taxonomyBase?: InputMaybe<RouteResourceWhereInput>;
  taxonomyBaseId?: InputMaybe<StringFilter>;
  taxonomyFilter?: InputMaybe<RouteResourceWhereInput>;
  taxonomyFilterId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type FilterTaxonomyRuleWhereUniqueInput = {
  AND?: InputMaybe<Array<FilterTaxonomyRuleWhereInput>>;
  NOT?: InputMaybe<Array<FilterTaxonomyRuleWhereInput>>;
  OR?: InputMaybe<Array<FilterTaxonomyRuleWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  filterTaxonomyItems?: InputMaybe<FilterTaxonomyItemListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  taxonomyBase?: InputMaybe<RouteResourceWhereInput>;
  taxonomyBaseId?: InputMaybe<StringFilter>;
  taxonomyFilter?: InputMaybe<RouteResourceWhereInput>;
  taxonomyFilterId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type GeneralTemplateFieldGroup = {
  __typename?: 'GeneralTemplateFieldGroup';
  groups: Array<TemplateFieldGroup>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};


export type GeneralTemplateFieldGroupGroupsArgs = {
  cursor?: InputMaybe<TemplateFieldGroupWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateFieldGroupWhereInput>;
};

export type GeneralTemplateFieldGroupCreateInput = {
  groups?: InputMaybe<TemplateFieldGroupCreateNestedManyWithoutGeneralGroupInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type GeneralTemplateFieldGroupCreateNestedOneWithoutGroupsInput = {
  connect?: InputMaybe<GeneralTemplateFieldGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GeneralTemplateFieldGroupCreateOrConnectWithoutGroupsInput>;
  create?: InputMaybe<GeneralTemplateFieldGroupCreateWithoutGroupsInput>;
};

export type GeneralTemplateFieldGroupCreateOrConnectWithoutGroupsInput = {
  create: GeneralTemplateFieldGroupCreateWithoutGroupsInput;
  where: GeneralTemplateFieldGroupWhereUniqueInput;
};

export type GeneralTemplateFieldGroupCreateWithoutGroupsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type GeneralTemplateFieldGroupOrderByWithRelationInput = {
  groups?: InputMaybe<TemplateFieldGroupOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  index?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type GeneralTemplateFieldGroupUpdateInput = {
  groups?: InputMaybe<TemplateFieldGroupUpdateManyWithoutGeneralGroupNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GeneralTemplateFieldGroupUpdateOneWithoutGroupsNestedInput = {
  connect?: InputMaybe<GeneralTemplateFieldGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GeneralTemplateFieldGroupCreateOrConnectWithoutGroupsInput>;
  create?: InputMaybe<GeneralTemplateFieldGroupCreateWithoutGroupsInput>;
  delete?: InputMaybe<GeneralTemplateFieldGroupWhereInput>;
  disconnect?: InputMaybe<GeneralTemplateFieldGroupWhereInput>;
  update?: InputMaybe<GeneralTemplateFieldGroupUpdateToOneWithWhereWithoutGroupsInput>;
  upsert?: InputMaybe<GeneralTemplateFieldGroupUpsertWithoutGroupsInput>;
};

export type GeneralTemplateFieldGroupUpdateToOneWithWhereWithoutGroupsInput = {
  data: GeneralTemplateFieldGroupUpdateWithoutGroupsInput;
  where?: InputMaybe<GeneralTemplateFieldGroupWhereInput>;
};

export type GeneralTemplateFieldGroupUpdateWithoutGroupsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GeneralTemplateFieldGroupUpsertWithoutGroupsInput = {
  create: GeneralTemplateFieldGroupCreateWithoutGroupsInput;
  update: GeneralTemplateFieldGroupUpdateWithoutGroupsInput;
  where?: InputMaybe<GeneralTemplateFieldGroupWhereInput>;
};

export type GeneralTemplateFieldGroupWhereInput = {
  AND?: InputMaybe<Array<GeneralTemplateFieldGroupWhereInput>>;
  NOT?: InputMaybe<Array<GeneralTemplateFieldGroupWhereInput>>;
  OR?: InputMaybe<Array<GeneralTemplateFieldGroupWhereInput>>;
  groups?: InputMaybe<TemplateFieldGroupListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  index?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type GeneralTemplateFieldGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<GeneralTemplateFieldGroupWhereInput>>;
  NOT?: InputMaybe<Array<GeneralTemplateFieldGroupWhereInput>>;
  OR?: InputMaybe<Array<GeneralTemplateFieldGroupWhereInput>>;
  groups?: InputMaybe<TemplateFieldGroupListRelationFilter>;
  id: Scalars['String']['input'];
  index?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export enum GeoMode {
  None = 'NONE',
  PerGeo = 'PER_GEO'
}

export type HistoryChangedKeys = {
  __typename?: 'HistoryChangedKeys';
  content?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  properties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum HistoryResourceType {
  FilterTaxonomyItem = 'filterTaxonomyItem',
  FilterTaxonomyRule = 'filterTaxonomyRule',
  Network = 'network',
  Post = 'post',
  Product = 'product',
  Provider = 'provider',
  Site = 'site',
  StringTemplate = 'stringTemplate',
  TaxonomyItem = 'taxonomyItem',
  Vertical = 'vertical'
}

export type ImportCldrDataResponse = {
  __typename?: 'ImportCldrDataResponse';
  error?: Maybe<Scalars['JSON']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  array_ends_with?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  array_starts_with?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  mode?: InputMaybe<JsonFilterMode>;
  not?: InputMaybe<JsonFilter>;
  path?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum JsonFilterMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['Json']['input']>;
  array_ends_with?: InputMaybe<Scalars['Json']['input']>;
  array_starts_with?: InputMaybe<Scalars['Json']['input']>;
  equals?: InputMaybe<Scalars['Json']['input']>;
  gt?: InputMaybe<Scalars['Json']['input']>;
  gte?: InputMaybe<Scalars['Json']['input']>;
  lt?: InputMaybe<Scalars['Json']['input']>;
  lte?: InputMaybe<Scalars['Json']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['Json']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type Language = {
  __typename?: 'Language';
  countries: Array<Country>;
  countryCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  languageCode: Scalars['String']['output'];
  languageTag: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
  shortNameEng?: Maybe<Scalars['String']['output']>;
  variantName?: Maybe<Scalars['String']['output']>;
};


export type LanguageCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};

export type LanguageCreateInput = {
  Site?: InputMaybe<SiteCreateNestedManyWithoutLanguageInput>;
  contentItems?: InputMaybe<ContentItemV2CreateNestedManyWithoutLanguageInput>;
  countries?: InputMaybe<CountryCreateNestedManyWithoutLanguagesInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  languageTag: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  shortNameEng?: InputMaybe<Scalars['String']['input']>;
  stringItems?: InputMaybe<StringItemCreateNestedManyWithoutLanguageInput>;
  variantName?: InputMaybe<Scalars['String']['input']>;
};

export type LanguageCreateNestedManyWithoutCountriesInput = {
  connect?: InputMaybe<Array<LanguageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LanguageCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<LanguageCreateWithoutCountriesInput>>;
};

export type LanguageCreateNestedOneWithoutContentItemsInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutContentItemsInput>;
  create?: InputMaybe<LanguageCreateWithoutContentItemsInput>;
};

export type LanguageCreateNestedOneWithoutSiteInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutSiteInput>;
  create?: InputMaybe<LanguageCreateWithoutSiteInput>;
};

export type LanguageCreateNestedOneWithoutStringItemsInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutStringItemsInput>;
  create?: InputMaybe<LanguageCreateWithoutStringItemsInput>;
};

export type LanguageCreateOrConnectWithoutContentItemsInput = {
  create: LanguageCreateWithoutContentItemsInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageCreateOrConnectWithoutCountriesInput = {
  create: LanguageCreateWithoutCountriesInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageCreateOrConnectWithoutSiteInput = {
  create: LanguageCreateWithoutSiteInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageCreateOrConnectWithoutStringItemsInput = {
  create: LanguageCreateWithoutStringItemsInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageCreateWithoutContentItemsInput = {
  Site?: InputMaybe<SiteCreateNestedManyWithoutLanguageInput>;
  countries?: InputMaybe<CountryCreateNestedManyWithoutLanguagesInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  languageTag: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  shortNameEng?: InputMaybe<Scalars['String']['input']>;
  stringItems?: InputMaybe<StringItemCreateNestedManyWithoutLanguageInput>;
  variantName?: InputMaybe<Scalars['String']['input']>;
};

export type LanguageCreateWithoutCountriesInput = {
  Site?: InputMaybe<SiteCreateNestedManyWithoutLanguageInput>;
  contentItems?: InputMaybe<ContentItemV2CreateNestedManyWithoutLanguageInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  languageTag: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  shortNameEng?: InputMaybe<Scalars['String']['input']>;
  stringItems?: InputMaybe<StringItemCreateNestedManyWithoutLanguageInput>;
  variantName?: InputMaybe<Scalars['String']['input']>;
};

export type LanguageCreateWithoutSiteInput = {
  contentItems?: InputMaybe<ContentItemV2CreateNestedManyWithoutLanguageInput>;
  countries?: InputMaybe<CountryCreateNestedManyWithoutLanguagesInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  languageTag: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  shortNameEng?: InputMaybe<Scalars['String']['input']>;
  stringItems?: InputMaybe<StringItemCreateNestedManyWithoutLanguageInput>;
  variantName?: InputMaybe<Scalars['String']['input']>;
};

export type LanguageCreateWithoutStringItemsInput = {
  Site?: InputMaybe<SiteCreateNestedManyWithoutLanguageInput>;
  contentItems?: InputMaybe<ContentItemV2CreateNestedManyWithoutLanguageInput>;
  countries?: InputMaybe<CountryCreateNestedManyWithoutLanguagesInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  languageCode: Scalars['String']['input'];
  languageTag: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortName: Scalars['String']['input'];
  shortNameEng?: InputMaybe<Scalars['String']['input']>;
  variantName?: InputMaybe<Scalars['String']['input']>;
};

export type LanguageListRelationFilter = {
  every?: InputMaybe<LanguageWhereInput>;
  none?: InputMaybe<LanguageWhereInput>;
  some?: InputMaybe<LanguageWhereInput>;
};

export type LanguageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LanguageOrderByWithRelationInput = {
  Site?: InputMaybe<SiteOrderByRelationAggregateInput>;
  contentItems?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  countries?: InputMaybe<CountryOrderByRelationAggregateInput>;
  countryCode?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  languageCode?: InputMaybe<SortOrder>;
  languageTag?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  shortName?: InputMaybe<SortOrder>;
  shortNameEng?: InputMaybe<SortOrderInput>;
  stringItems?: InputMaybe<StringItemOrderByRelationAggregateInput>;
  variantName?: InputMaybe<SortOrderInput>;
};

export type LanguageScalarWhereInput = {
  AND?: InputMaybe<Array<LanguageScalarWhereInput>>;
  NOT?: InputMaybe<Array<LanguageScalarWhereInput>>;
  OR?: InputMaybe<Array<LanguageScalarWhereInput>>;
  countryCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  languageCode?: InputMaybe<StringFilter>;
  languageTag?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  shortName?: InputMaybe<StringFilter>;
  shortNameEng?: InputMaybe<StringNullableFilter>;
  variantName?: InputMaybe<StringNullableFilter>;
};

export type LanguageUpdateInput = {
  Site?: InputMaybe<SiteUpdateManyWithoutLanguageNestedInput>;
  contentItems?: InputMaybe<ContentItemV2UpdateManyWithoutLanguageNestedInput>;
  countries?: InputMaybe<CountryUpdateManyWithoutLanguagesNestedInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageTag?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortNameEng?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stringItems?: InputMaybe<StringItemUpdateManyWithoutLanguageNestedInput>;
  variantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LanguageUpdateManyMutationInput = {
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageTag?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortNameEng?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LanguageUpdateManyWithWhereWithoutCountriesInput = {
  data: LanguageUpdateManyMutationInput;
  where: LanguageScalarWhereInput;
};

export type LanguageUpdateManyWithoutCountriesNestedInput = {
  connect?: InputMaybe<Array<LanguageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LanguageCreateOrConnectWithoutCountriesInput>>;
  create?: InputMaybe<Array<LanguageCreateWithoutCountriesInput>>;
  delete?: InputMaybe<Array<LanguageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LanguageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LanguageWhereUniqueInput>>;
  set?: InputMaybe<Array<LanguageWhereUniqueInput>>;
  update?: InputMaybe<Array<LanguageUpdateWithWhereUniqueWithoutCountriesInput>>;
  updateMany?: InputMaybe<Array<LanguageUpdateManyWithWhereWithoutCountriesInput>>;
  upsert?: InputMaybe<Array<LanguageUpsertWithWhereUniqueWithoutCountriesInput>>;
};

export type LanguageUpdateOneRequiredWithoutContentItemsNestedInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutContentItemsInput>;
  create?: InputMaybe<LanguageCreateWithoutContentItemsInput>;
  update?: InputMaybe<LanguageUpdateToOneWithWhereWithoutContentItemsInput>;
  upsert?: InputMaybe<LanguageUpsertWithoutContentItemsInput>;
};

export type LanguageUpdateOneRequiredWithoutSiteNestedInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutSiteInput>;
  create?: InputMaybe<LanguageCreateWithoutSiteInput>;
  update?: InputMaybe<LanguageUpdateToOneWithWhereWithoutSiteInput>;
  upsert?: InputMaybe<LanguageUpsertWithoutSiteInput>;
};

export type LanguageUpdateOneRequiredWithoutStringItemsNestedInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutStringItemsInput>;
  create?: InputMaybe<LanguageCreateWithoutStringItemsInput>;
  update?: InputMaybe<LanguageUpdateToOneWithWhereWithoutStringItemsInput>;
  upsert?: InputMaybe<LanguageUpsertWithoutStringItemsInput>;
};

export type LanguageUpdateToOneWithWhereWithoutContentItemsInput = {
  data: LanguageUpdateWithoutContentItemsInput;
  where?: InputMaybe<LanguageWhereInput>;
};

export type LanguageUpdateToOneWithWhereWithoutSiteInput = {
  data: LanguageUpdateWithoutSiteInput;
  where?: InputMaybe<LanguageWhereInput>;
};

export type LanguageUpdateToOneWithWhereWithoutStringItemsInput = {
  data: LanguageUpdateWithoutStringItemsInput;
  where?: InputMaybe<LanguageWhereInput>;
};

export type LanguageUpdateWithWhereUniqueWithoutCountriesInput = {
  data: LanguageUpdateWithoutCountriesInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageUpdateWithoutContentItemsInput = {
  Site?: InputMaybe<SiteUpdateManyWithoutLanguageNestedInput>;
  countries?: InputMaybe<CountryUpdateManyWithoutLanguagesNestedInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageTag?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortNameEng?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stringItems?: InputMaybe<StringItemUpdateManyWithoutLanguageNestedInput>;
  variantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LanguageUpdateWithoutCountriesInput = {
  Site?: InputMaybe<SiteUpdateManyWithoutLanguageNestedInput>;
  contentItems?: InputMaybe<ContentItemV2UpdateManyWithoutLanguageNestedInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageTag?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortNameEng?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stringItems?: InputMaybe<StringItemUpdateManyWithoutLanguageNestedInput>;
  variantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LanguageUpdateWithoutSiteInput = {
  contentItems?: InputMaybe<ContentItemV2UpdateManyWithoutLanguageNestedInput>;
  countries?: InputMaybe<CountryUpdateManyWithoutLanguagesNestedInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageTag?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortNameEng?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stringItems?: InputMaybe<StringItemUpdateManyWithoutLanguageNestedInput>;
  variantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LanguageUpdateWithoutStringItemsInput = {
  Site?: InputMaybe<SiteUpdateManyWithoutLanguageNestedInput>;
  contentItems?: InputMaybe<ContentItemV2UpdateManyWithoutLanguageNestedInput>;
  countries?: InputMaybe<CountryUpdateManyWithoutLanguagesNestedInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  languageTag?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortName?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortNameEng?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LanguageUpsertWithWhereUniqueWithoutCountriesInput = {
  create: LanguageCreateWithoutCountriesInput;
  update: LanguageUpdateWithoutCountriesInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageUpsertWithoutContentItemsInput = {
  create: LanguageCreateWithoutContentItemsInput;
  update: LanguageUpdateWithoutContentItemsInput;
  where?: InputMaybe<LanguageWhereInput>;
};

export type LanguageUpsertWithoutSiteInput = {
  create: LanguageCreateWithoutSiteInput;
  update: LanguageUpdateWithoutSiteInput;
  where?: InputMaybe<LanguageWhereInput>;
};

export type LanguageUpsertWithoutStringItemsInput = {
  create: LanguageCreateWithoutStringItemsInput;
  update: LanguageUpdateWithoutStringItemsInput;
  where?: InputMaybe<LanguageWhereInput>;
};

export type LanguageWhereInput = {
  AND?: InputMaybe<Array<LanguageWhereInput>>;
  NOT?: InputMaybe<Array<LanguageWhereInput>>;
  OR?: InputMaybe<Array<LanguageWhereInput>>;
  Site?: InputMaybe<SiteListRelationFilter>;
  contentItems?: InputMaybe<ContentItemV2ListRelationFilter>;
  countries?: InputMaybe<CountryListRelationFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  languageCode?: InputMaybe<StringFilter>;
  languageTag?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  shortName?: InputMaybe<StringFilter>;
  shortNameEng?: InputMaybe<StringNullableFilter>;
  stringItems?: InputMaybe<StringItemListRelationFilter>;
  variantName?: InputMaybe<StringNullableFilter>;
};

export type LanguageWhereUniqueInput = {
  AND?: InputMaybe<Array<LanguageWhereInput>>;
  NOT?: InputMaybe<Array<LanguageWhereInput>>;
  OR?: InputMaybe<Array<LanguageWhereInput>>;
  Site?: InputMaybe<SiteListRelationFilter>;
  contentItems?: InputMaybe<ContentItemV2ListRelationFilter>;
  countries?: InputMaybe<CountryListRelationFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  id: Scalars['String']['input'];
  languageCode?: InputMaybe<StringFilter>;
  languageTag?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  shortName?: InputMaybe<StringFilter>;
  shortNameEng?: InputMaybe<StringNullableFilter>;
  stringItems?: InputMaybe<StringItemListRelationFilter>;
  variantName?: InputMaybe<StringNullableFilter>;
};

export type Link = {
  __typename?: 'Link';
  campaignId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LinkCampaign = {
  __typename?: 'LinkCampaign';
  id?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<Maybe<Link>>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type LocalizeForType = {
  country?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type MediaItem = {
  __typename?: 'MediaItem';
  alt?: Maybe<Scalars['String']['output']>;
  checksum: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Network>;
  tags: Array<Tag>;
  url: Scalars['String']['output'];
};


export type MediaItemNetworkArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type MediaItemTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagWhereInput>;
};

export type MediaItemCreateManyNetworkInput = {
  alt?: InputMaybe<Scalars['String']['input']>;
  checksum: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type MediaItemCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<MediaItemCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MediaItemCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MediaItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<MediaItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<MediaItemCreateManyNetworkInputEnvelope>;
};

export type MediaItemCreateNestedManyWithoutTagsInput = {
  connect?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MediaItemCreateOrConnectWithoutTagsInput>>;
  create?: InputMaybe<Array<MediaItemCreateWithoutTagsInput>>;
};

export type MediaItemCreateNestedOneWithoutRegulatoryHelpOrganizationInput = {
  connect?: InputMaybe<MediaItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MediaItemCreateOrConnectWithoutRegulatoryHelpOrganizationInput>;
  create?: InputMaybe<MediaItemCreateWithoutRegulatoryHelpOrganizationInput>;
};

export type MediaItemCreateNestedOneWithoutRegulatoryMarketInput = {
  connect?: InputMaybe<MediaItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MediaItemCreateOrConnectWithoutRegulatoryMarketInput>;
  create?: InputMaybe<MediaItemCreateWithoutRegulatoryMarketInput>;
};

export type MediaItemCreateOrConnectWithoutNetworkInput = {
  create: MediaItemCreateWithoutNetworkInput;
  where: MediaItemWhereUniqueInput;
};

export type MediaItemCreateOrConnectWithoutRegulatoryHelpOrganizationInput = {
  create: MediaItemCreateWithoutRegulatoryHelpOrganizationInput;
  where: MediaItemWhereUniqueInput;
};

export type MediaItemCreateOrConnectWithoutRegulatoryMarketInput = {
  create: MediaItemCreateWithoutRegulatoryMarketInput;
  where: MediaItemWhereUniqueInput;
};

export type MediaItemCreateOrConnectWithoutTagsInput = {
  create: MediaItemCreateWithoutTagsInput;
  where: MediaItemWhereUniqueInput;
};

export type MediaItemCreateWithoutNetworkInput = {
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationCreateNestedManyWithoutLogoInput>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketCreateNestedManyWithoutAgeLimitLogoInput>;
  alt?: InputMaybe<Scalars['String']['input']>;
  checksum: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<TagCreateNestedManyWithoutMediaItemsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type MediaItemCreateWithoutRegulatoryHelpOrganizationInput = {
  RegulatoryMarket?: InputMaybe<RegulatoryMarketCreateNestedManyWithoutAgeLimitLogoInput>;
  alt?: InputMaybe<Scalars['String']['input']>;
  checksum: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutMediaItemInput>;
  tags?: InputMaybe<TagCreateNestedManyWithoutMediaItemsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type MediaItemCreateWithoutRegulatoryMarketInput = {
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationCreateNestedManyWithoutLogoInput>;
  alt?: InputMaybe<Scalars['String']['input']>;
  checksum: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutMediaItemInput>;
  tags?: InputMaybe<TagCreateNestedManyWithoutMediaItemsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type MediaItemCreateWithoutTagsInput = {
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationCreateNestedManyWithoutLogoInput>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketCreateNestedManyWithoutAgeLimitLogoInput>;
  alt?: InputMaybe<Scalars['String']['input']>;
  checksum: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutMediaItemInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type MediaItemListRelationFilter = {
  every?: InputMaybe<MediaItemWhereInput>;
  none?: InputMaybe<MediaItemWhereInput>;
  some?: InputMaybe<MediaItemWhereInput>;
};

export type MediaItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MediaItemOrderByWithRelationInput = {
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationOrderByRelationAggregateInput>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketOrderByRelationAggregateInput>;
  alt?: InputMaybe<SortOrderInput>;
  checksum?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  mimetype?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrderInput>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  tags?: InputMaybe<TagOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type MediaItemScalarWhereInput = {
  AND?: InputMaybe<Array<MediaItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<MediaItemScalarWhereInput>>;
  OR?: InputMaybe<Array<MediaItemScalarWhereInput>>;
  alt?: InputMaybe<StringNullableFilter>;
  checksum?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<StringNullableFilter>;
  mimetype?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type MediaItemUpdateInput = {
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationUpdateManyWithoutLogoNestedInput>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketUpdateManyWithoutAgeLimitLogoNestedInput>;
  alt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checksum?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mimetype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutMediaItemNestedInput>;
  tags?: InputMaybe<TagUpdateManyWithoutMediaItemsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MediaItemUpdateManyMutationInput = {
  alt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checksum?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mimetype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MediaItemUpdateManyWithWhereWithoutNetworkInput = {
  data: MediaItemUpdateManyMutationInput;
  where: MediaItemScalarWhereInput;
};

export type MediaItemUpdateManyWithWhereWithoutTagsInput = {
  data: MediaItemUpdateManyMutationInput;
  where: MediaItemScalarWhereInput;
};

export type MediaItemUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MediaItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<MediaItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<MediaItemCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MediaItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MediaItemUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<MediaItemUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<MediaItemUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type MediaItemUpdateManyWithoutTagsNestedInput = {
  connect?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MediaItemCreateOrConnectWithoutTagsInput>>;
  create?: InputMaybe<Array<MediaItemCreateWithoutTagsInput>>;
  delete?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MediaItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MediaItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MediaItemUpdateWithWhereUniqueWithoutTagsInput>>;
  updateMany?: InputMaybe<Array<MediaItemUpdateManyWithWhereWithoutTagsInput>>;
  upsert?: InputMaybe<Array<MediaItemUpsertWithWhereUniqueWithoutTagsInput>>;
};

export type MediaItemUpdateOneRequiredWithoutRegulatoryHelpOrganizationNestedInput = {
  connect?: InputMaybe<MediaItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MediaItemCreateOrConnectWithoutRegulatoryHelpOrganizationInput>;
  create?: InputMaybe<MediaItemCreateWithoutRegulatoryHelpOrganizationInput>;
  update?: InputMaybe<MediaItemUpdateToOneWithWhereWithoutRegulatoryHelpOrganizationInput>;
  upsert?: InputMaybe<MediaItemUpsertWithoutRegulatoryHelpOrganizationInput>;
};

export type MediaItemUpdateOneRequiredWithoutRegulatoryMarketNestedInput = {
  connect?: InputMaybe<MediaItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MediaItemCreateOrConnectWithoutRegulatoryMarketInput>;
  create?: InputMaybe<MediaItemCreateWithoutRegulatoryMarketInput>;
  update?: InputMaybe<MediaItemUpdateToOneWithWhereWithoutRegulatoryMarketInput>;
  upsert?: InputMaybe<MediaItemUpsertWithoutRegulatoryMarketInput>;
};

export type MediaItemUpdateToOneWithWhereWithoutRegulatoryHelpOrganizationInput = {
  data: MediaItemUpdateWithoutRegulatoryHelpOrganizationInput;
  where?: InputMaybe<MediaItemWhereInput>;
};

export type MediaItemUpdateToOneWithWhereWithoutRegulatoryMarketInput = {
  data: MediaItemUpdateWithoutRegulatoryMarketInput;
  where?: InputMaybe<MediaItemWhereInput>;
};

export type MediaItemUpdateWithWhereUniqueWithoutNetworkInput = {
  data: MediaItemUpdateWithoutNetworkInput;
  where: MediaItemWhereUniqueInput;
};

export type MediaItemUpdateWithWhereUniqueWithoutTagsInput = {
  data: MediaItemUpdateWithoutTagsInput;
  where: MediaItemWhereUniqueInput;
};

export type MediaItemUpdateWithoutNetworkInput = {
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationUpdateManyWithoutLogoNestedInput>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketUpdateManyWithoutAgeLimitLogoNestedInput>;
  alt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checksum?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mimetype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<TagUpdateManyWithoutMediaItemsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MediaItemUpdateWithoutRegulatoryHelpOrganizationInput = {
  RegulatoryMarket?: InputMaybe<RegulatoryMarketUpdateManyWithoutAgeLimitLogoNestedInput>;
  alt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checksum?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mimetype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutMediaItemNestedInput>;
  tags?: InputMaybe<TagUpdateManyWithoutMediaItemsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MediaItemUpdateWithoutRegulatoryMarketInput = {
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationUpdateManyWithoutLogoNestedInput>;
  alt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checksum?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mimetype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutMediaItemNestedInput>;
  tags?: InputMaybe<TagUpdateManyWithoutMediaItemsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MediaItemUpdateWithoutTagsInput = {
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationUpdateManyWithoutLogoNestedInput>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketUpdateManyWithoutAgeLimitLogoNestedInput>;
  alt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  checksum?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  mimetype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutMediaItemNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MediaItemUpsertWithWhereUniqueWithoutNetworkInput = {
  create: MediaItemCreateWithoutNetworkInput;
  update: MediaItemUpdateWithoutNetworkInput;
  where: MediaItemWhereUniqueInput;
};

export type MediaItemUpsertWithWhereUniqueWithoutTagsInput = {
  create: MediaItemCreateWithoutTagsInput;
  update: MediaItemUpdateWithoutTagsInput;
  where: MediaItemWhereUniqueInput;
};

export type MediaItemUpsertWithoutRegulatoryHelpOrganizationInput = {
  create: MediaItemCreateWithoutRegulatoryHelpOrganizationInput;
  update: MediaItemUpdateWithoutRegulatoryHelpOrganizationInput;
  where?: InputMaybe<MediaItemWhereInput>;
};

export type MediaItemUpsertWithoutRegulatoryMarketInput = {
  create: MediaItemCreateWithoutRegulatoryMarketInput;
  update: MediaItemUpdateWithoutRegulatoryMarketInput;
  where?: InputMaybe<MediaItemWhereInput>;
};

export type MediaItemWhereInput = {
  AND?: InputMaybe<Array<MediaItemWhereInput>>;
  NOT?: InputMaybe<Array<MediaItemWhereInput>>;
  OR?: InputMaybe<Array<MediaItemWhereInput>>;
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationListRelationFilter>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketListRelationFilter>;
  alt?: InputMaybe<StringNullableFilter>;
  checksum?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<StringNullableFilter>;
  mimetype?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<TagListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type MediaItemWhereUniqueInput = {
  AND?: InputMaybe<Array<MediaItemWhereInput>>;
  NOT?: InputMaybe<Array<MediaItemWhereInput>>;
  OR?: InputMaybe<Array<MediaItemWhereInput>>;
  RegulatoryHelpOrganization?: InputMaybe<RegulatoryHelpOrganizationListRelationFilter>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketListRelationFilter>;
  alt?: InputMaybe<StringNullableFilter>;
  checksum?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id: Scalars['String']['input'];
  metadata?: InputMaybe<StringNullableFilter>;
  mimetype?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<TagListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type Menu = {
  __typename?: 'Menu';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['String']['output'];
  items: Array<MenuItem>;
  key: Scalars['String']['output'];
  network: Network;
  site?: Maybe<Site>;
  updatedAt: Scalars['DateTime']['output'];
  vertical?: Maybe<Vertical>;
};


export type MenuItemsArgs = {
  cursor?: InputMaybe<MenuItemWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuItemWhereInput>;
};


export type MenuSiteArgs = {
  where?: InputMaybe<SiteWhereInput>;
};


export type MenuVerticalArgs = {
  where?: InputMaybe<VerticalWhereInput>;
};

export type MenuCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<MenuItemCreateNestedManyWithoutMenuInput>;
  key: Scalars['String']['input'];
  network: NetworkCreateNestedOneWithoutMenusInput;
  site?: InputMaybe<SiteCreateNestedOneWithoutMenusInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutMenusInput>;
};

export type MenuCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type MenuCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<MenuCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuCreateManySiteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type MenuCreateManySiteInputEnvelope = {
  data?: InputMaybe<Array<MenuCreateManySiteInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuCreateManyVerticalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuCreateManyVerticalInputEnvelope = {
  data?: InputMaybe<Array<MenuCreateManyVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<MenuCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<MenuCreateManyNetworkInputEnvelope>;
};

export type MenuCreateNestedManyWithoutSiteInput = {
  connect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuCreateOrConnectWithoutSiteInput>>;
  create?: InputMaybe<Array<MenuCreateWithoutSiteInput>>;
  createMany?: InputMaybe<MenuCreateManySiteInputEnvelope>;
};

export type MenuCreateNestedManyWithoutVerticalInput = {
  connect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<MenuCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<MenuCreateManyVerticalInputEnvelope>;
};

export type MenuCreateNestedOneWithoutItemsInput = {
  connect?: InputMaybe<MenuWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuCreateOrConnectWithoutItemsInput>;
  create?: InputMaybe<MenuCreateWithoutItemsInput>;
};

export type MenuCreateOrConnectWithoutItemsInput = {
  create: MenuCreateWithoutItemsInput;
  where: MenuWhereUniqueInput;
};

export type MenuCreateOrConnectWithoutNetworkInput = {
  create: MenuCreateWithoutNetworkInput;
  where: MenuWhereUniqueInput;
};

export type MenuCreateOrConnectWithoutSiteInput = {
  create: MenuCreateWithoutSiteInput;
  where: MenuWhereUniqueInput;
};

export type MenuCreateOrConnectWithoutVerticalInput = {
  create: MenuCreateWithoutVerticalInput;
  where: MenuWhereUniqueInput;
};

export type MenuCreateWithoutItemsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  network: NetworkCreateNestedOneWithoutMenusInput;
  site?: InputMaybe<SiteCreateNestedOneWithoutMenusInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutMenusInput>;
};

export type MenuCreateWithoutNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<MenuItemCreateNestedManyWithoutMenuInput>;
  key: Scalars['String']['input'];
  site?: InputMaybe<SiteCreateNestedOneWithoutMenusInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutMenusInput>;
};

export type MenuCreateWithoutSiteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<MenuItemCreateNestedManyWithoutMenuInput>;
  key: Scalars['String']['input'];
  network: NetworkCreateNestedOneWithoutMenusInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutMenusInput>;
};

export type MenuCreateWithoutVerticalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<MenuItemCreateNestedManyWithoutMenuInput>;
  key: Scalars['String']['input'];
  network: NetworkCreateNestedOneWithoutMenusInput;
  site?: InputMaybe<SiteCreateNestedOneWithoutMenusInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<MenuItemInput>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereUniqueInput>;
  site?: InputMaybe<SiteWhereUniqueInput>;
  vertical?: InputMaybe<VerticalWhereUniqueInput>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  children: Array<MenuItem>;
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  menu: Menu;
  parent?: Maybe<MenuItem>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  type: MenuType;
  updatedAt: Scalars['DateTime']['output'];
};


export type MenuItemChildrenArgs = {
  cursor?: InputMaybe<MenuItemWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuItemWhereInput>;
};


export type MenuItemContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type MenuItemParentArgs = {
  where?: InputMaybe<MenuItemWhereInput>;
};


export type MenuItemPropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type MenuItemContentInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  language?: InputMaybe<LanguageWhereUniqueInput>;
};

export type MenuItemCreateManyMenuInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  type: MenuType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuItemCreateManyMenuInputEnvelope = {
  data?: InputMaybe<Array<MenuItemCreateManyMenuInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuItemCreateManyParentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  menuId: Scalars['String']['input'];
  type: MenuType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuItemCreateManyParentInputEnvelope = {
  data?: InputMaybe<Array<MenuItemCreateManyParentInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuItemCreateNestedManyWithoutMenuInput = {
  connect?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuItemCreateOrConnectWithoutMenuInput>>;
  create?: InputMaybe<Array<MenuItemCreateWithoutMenuInput>>;
  createMany?: InputMaybe<MenuItemCreateManyMenuInputEnvelope>;
};

export type MenuItemCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuItemCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<MenuItemCreateWithoutParentInput>>;
  createMany?: InputMaybe<MenuItemCreateManyParentInputEnvelope>;
};

export type MenuItemCreateNestedOneWithoutChildrenInput = {
  connect?: InputMaybe<MenuItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuItemCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<MenuItemCreateWithoutChildrenInput>;
};

export type MenuItemCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<MenuItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuItemCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<MenuItemCreateWithoutContentInput>;
};

export type MenuItemCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<MenuItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuItemCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<MenuItemCreateWithoutContentOldInput>;
};

export type MenuItemCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<MenuItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuItemCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<MenuItemCreateWithoutPropertiesInput>;
};

export type MenuItemCreateOrConnectWithoutChildrenInput = {
  create: MenuItemCreateWithoutChildrenInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemCreateOrConnectWithoutContentInput = {
  create: MenuItemCreateWithoutContentInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemCreateOrConnectWithoutContentOldInput = {
  create: MenuItemCreateWithoutContentOldInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemCreateOrConnectWithoutMenuInput = {
  create: MenuItemCreateWithoutMenuInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemCreateOrConnectWithoutParentInput = {
  create: MenuItemCreateWithoutParentInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemCreateOrConnectWithoutPropertiesInput = {
  create: MenuItemCreateWithoutPropertiesInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemCreateWithoutChildrenInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutMenuItemInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutMenuItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  menu: MenuCreateNestedOneWithoutItemsInput;
  parent?: InputMaybe<MenuItemCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutMenuItemInput>;
  type: MenuType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuItemCreateWithoutContentInput = {
  children?: InputMaybe<MenuItemCreateNestedManyWithoutParentInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutMenuItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  menu: MenuCreateNestedOneWithoutItemsInput;
  parent?: InputMaybe<MenuItemCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutMenuItemInput>;
  type: MenuType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuItemCreateWithoutContentOldInput = {
  children?: InputMaybe<MenuItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutMenuItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  menu: MenuCreateNestedOneWithoutItemsInput;
  parent?: InputMaybe<MenuItemCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutMenuItemInput>;
  type: MenuType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuItemCreateWithoutMenuInput = {
  children?: InputMaybe<MenuItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutMenuItemInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutMenuItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  parent?: InputMaybe<MenuItemCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutMenuItemInput>;
  type: MenuType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuItemCreateWithoutParentInput = {
  children?: InputMaybe<MenuItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutMenuItemInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutMenuItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  menu: MenuCreateNestedOneWithoutItemsInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutMenuItemInput>;
  type: MenuType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuItemCreateWithoutPropertiesInput = {
  children?: InputMaybe<MenuItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutMenuItemInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutMenuItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  menu: MenuCreateNestedOneWithoutItemsInput;
  parent?: InputMaybe<MenuItemCreateNestedOneWithoutChildrenInput>;
  type: MenuType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MenuItemInput = {
  children?: InputMaybe<Array<InputMaybe<MenuItemInput>>>;
  content?: InputMaybe<Array<InputMaybe<MenuItemContentInput>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  properties?: InputMaybe<Array<InputMaybe<MenuItemPropertyInput>>>;
  type: MenuType;
};

export type MenuItemListRelationFilter = {
  every?: InputMaybe<MenuItemWhereInput>;
  none?: InputMaybe<MenuItemWhereInput>;
  some?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MenuItemOrderByWithRelationInput = {
  children?: InputMaybe<MenuItemOrderByRelationAggregateInput>;
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  index?: InputMaybe<SortOrder>;
  menu?: InputMaybe<MenuOrderByWithRelationInput>;
  menuId?: InputMaybe<SortOrder>;
  parent?: InputMaybe<MenuItemOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrderInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type MenuItemPropertyInput = {
  data: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  type: FieldType;
};

export type MenuItemScalarWhereInput = {
  AND?: InputMaybe<Array<MenuItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<MenuItemScalarWhereInput>>;
  OR?: InputMaybe<Array<MenuItemScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  index?: InputMaybe<IntFilter>;
  menuId?: InputMaybe<StringFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumMenuTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MenuItemUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumMenuTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuItemUpdateManyWithWhereWithoutMenuInput = {
  data: MenuItemUpdateManyMutationInput;
  where: MenuItemScalarWhereInput;
};

export type MenuItemUpdateManyWithWhereWithoutParentInput = {
  data: MenuItemUpdateManyMutationInput;
  where: MenuItemScalarWhereInput;
};

export type MenuItemUpdateManyWithoutMenuNestedInput = {
  connect?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuItemCreateOrConnectWithoutMenuInput>>;
  create?: InputMaybe<Array<MenuItemCreateWithoutMenuInput>>;
  createMany?: InputMaybe<MenuItemCreateManyMenuInputEnvelope>;
  delete?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MenuItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MenuItemUpdateWithWhereUniqueWithoutMenuInput>>;
  updateMany?: InputMaybe<Array<MenuItemUpdateManyWithWhereWithoutMenuInput>>;
  upsert?: InputMaybe<Array<MenuItemUpsertWithWhereUniqueWithoutMenuInput>>;
};

export type MenuItemUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuItemCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<MenuItemCreateWithoutParentInput>>;
  createMany?: InputMaybe<MenuItemCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MenuItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MenuItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MenuItemUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<MenuItemUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<MenuItemUpsertWithWhereUniqueWithoutParentInput>>;
};

export type MenuItemUpdateOneWithoutChildrenNestedInput = {
  connect?: InputMaybe<MenuItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuItemCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<MenuItemCreateWithoutChildrenInput>;
  delete?: InputMaybe<MenuItemWhereInput>;
  disconnect?: InputMaybe<MenuItemWhereInput>;
  update?: InputMaybe<MenuItemUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: InputMaybe<MenuItemUpsertWithoutChildrenInput>;
};

export type MenuItemUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<MenuItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuItemCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<MenuItemCreateWithoutContentInput>;
  delete?: InputMaybe<MenuItemWhereInput>;
  disconnect?: InputMaybe<MenuItemWhereInput>;
  update?: InputMaybe<MenuItemUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<MenuItemUpsertWithoutContentInput>;
};

export type MenuItemUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<MenuItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuItemCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<MenuItemCreateWithoutContentOldInput>;
  delete?: InputMaybe<MenuItemWhereInput>;
  disconnect?: InputMaybe<MenuItemWhereInput>;
  update?: InputMaybe<MenuItemUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<MenuItemUpsertWithoutContentOldInput>;
};

export type MenuItemUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<MenuItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuItemCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<MenuItemCreateWithoutPropertiesInput>;
  delete?: InputMaybe<MenuItemWhereInput>;
  disconnect?: InputMaybe<MenuItemWhereInput>;
  update?: InputMaybe<MenuItemUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<MenuItemUpsertWithoutPropertiesInput>;
};

export type MenuItemUpdateToOneWithWhereWithoutChildrenInput = {
  data: MenuItemUpdateWithoutChildrenInput;
  where?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemUpdateToOneWithWhereWithoutContentInput = {
  data: MenuItemUpdateWithoutContentInput;
  where?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemUpdateToOneWithWhereWithoutContentOldInput = {
  data: MenuItemUpdateWithoutContentOldInput;
  where?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemUpdateToOneWithWhereWithoutPropertiesInput = {
  data: MenuItemUpdateWithoutPropertiesInput;
  where?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemUpdateWithWhereUniqueWithoutMenuInput = {
  data: MenuItemUpdateWithoutMenuInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemUpdateWithWhereUniqueWithoutParentInput = {
  data: MenuItemUpdateWithoutParentInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemUpdateWithoutChildrenInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutMenuItemNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutMenuItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  menu?: InputMaybe<MenuUpdateOneRequiredWithoutItemsNestedInput>;
  parent?: InputMaybe<MenuItemUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutMenuItemNestedInput>;
  type?: InputMaybe<EnumMenuTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuItemUpdateWithoutContentInput = {
  children?: InputMaybe<MenuItemUpdateManyWithoutParentNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutMenuItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  menu?: InputMaybe<MenuUpdateOneRequiredWithoutItemsNestedInput>;
  parent?: InputMaybe<MenuItemUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutMenuItemNestedInput>;
  type?: InputMaybe<EnumMenuTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuItemUpdateWithoutContentOldInput = {
  children?: InputMaybe<MenuItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutMenuItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  menu?: InputMaybe<MenuUpdateOneRequiredWithoutItemsNestedInput>;
  parent?: InputMaybe<MenuItemUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutMenuItemNestedInput>;
  type?: InputMaybe<EnumMenuTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuItemUpdateWithoutMenuInput = {
  children?: InputMaybe<MenuItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutMenuItemNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutMenuItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  parent?: InputMaybe<MenuItemUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutMenuItemNestedInput>;
  type?: InputMaybe<EnumMenuTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuItemUpdateWithoutParentInput = {
  children?: InputMaybe<MenuItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutMenuItemNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutMenuItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  menu?: InputMaybe<MenuUpdateOneRequiredWithoutItemsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutMenuItemNestedInput>;
  type?: InputMaybe<EnumMenuTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuItemUpdateWithoutPropertiesInput = {
  children?: InputMaybe<MenuItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutMenuItemNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutMenuItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  menu?: InputMaybe<MenuUpdateOneRequiredWithoutItemsNestedInput>;
  parent?: InputMaybe<MenuItemUpdateOneWithoutChildrenNestedInput>;
  type?: InputMaybe<EnumMenuTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuItemUpsertWithWhereUniqueWithoutMenuInput = {
  create: MenuItemCreateWithoutMenuInput;
  update: MenuItemUpdateWithoutMenuInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemUpsertWithWhereUniqueWithoutParentInput = {
  create: MenuItemCreateWithoutParentInput;
  update: MenuItemUpdateWithoutParentInput;
  where: MenuItemWhereUniqueInput;
};

export type MenuItemUpsertWithoutChildrenInput = {
  create: MenuItemCreateWithoutChildrenInput;
  update: MenuItemUpdateWithoutChildrenInput;
  where?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemUpsertWithoutContentInput = {
  create: MenuItemCreateWithoutContentInput;
  update: MenuItemUpdateWithoutContentInput;
  where?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemUpsertWithoutContentOldInput = {
  create: MenuItemCreateWithoutContentOldInput;
  update: MenuItemUpdateWithoutContentOldInput;
  where?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemUpsertWithoutPropertiesInput = {
  create: MenuItemCreateWithoutPropertiesInput;
  update: MenuItemUpdateWithoutPropertiesInput;
  where?: InputMaybe<MenuItemWhereInput>;
};

export type MenuItemWhereInput = {
  AND?: InputMaybe<Array<MenuItemWhereInput>>;
  NOT?: InputMaybe<Array<MenuItemWhereInput>>;
  OR?: InputMaybe<Array<MenuItemWhereInput>>;
  children?: InputMaybe<MenuItemListRelationFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  index?: InputMaybe<IntFilter>;
  menu?: InputMaybe<MenuWhereInput>;
  menuId?: InputMaybe<StringFilter>;
  parent?: InputMaybe<MenuItemWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  type?: InputMaybe<EnumMenuTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MenuItemWhereUniqueInput = {
  AND?: InputMaybe<Array<MenuItemWhereInput>>;
  NOT?: InputMaybe<Array<MenuItemWhereInput>>;
  OR?: InputMaybe<Array<MenuItemWhereInput>>;
  children?: InputMaybe<MenuItemListRelationFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<IntFilter>;
  menu?: InputMaybe<MenuWhereInput>;
  menuId?: InputMaybe<StringFilter>;
  parent?: InputMaybe<MenuItemWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  type?: InputMaybe<EnumMenuTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MenuListRelationFilter = {
  every?: InputMaybe<MenuWhereInput>;
  none?: InputMaybe<MenuWhereInput>;
  some?: InputMaybe<MenuWhereInput>;
};

export type MenuOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MenuOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  items?: InputMaybe<MenuItemOrderByRelationAggregateInput>;
  key?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrder>;
  site?: InputMaybe<SiteOrderByWithRelationInput>;
  siteId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  verticalId?: InputMaybe<SortOrderInput>;
};

export type MenuScalarWhereInput = {
  AND?: InputMaybe<Array<MenuScalarWhereInput>>;
  NOT?: InputMaybe<Array<MenuScalarWhereInput>>;
  OR?: InputMaybe<Array<MenuScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringFilter>;
  siteId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export enum MenuType {
  Custom = 'CUSTOM',
  Page = 'PAGE',
  Post = 'POST',
  Product = 'PRODUCT',
  Productlist = 'PRODUCTLIST',
  Provider = 'PROVIDER',
  Providerlist = 'PROVIDERLIST',
  Site = 'SITE',
  Taxonomyitem = 'TAXONOMYITEM',
  Taxonomyitemchildren = 'TAXONOMYITEMCHILDREN',
  Title = 'TITLE',
  Vertical = 'VERTICAL'
}

export type MenuUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  items?: InputMaybe<MenuItemUpdateManyWithoutMenuNestedInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutMenusNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutMenusNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutMenusNestedInput>;
};

export type MenuUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuUpdateManyWithWhereWithoutNetworkInput = {
  data: MenuUpdateManyMutationInput;
  where: MenuScalarWhereInput;
};

export type MenuUpdateManyWithWhereWithoutSiteInput = {
  data: MenuUpdateManyMutationInput;
  where: MenuScalarWhereInput;
};

export type MenuUpdateManyWithWhereWithoutVerticalInput = {
  data: MenuUpdateManyMutationInput;
  where: MenuScalarWhereInput;
};

export type MenuUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<MenuCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<MenuCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<MenuWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MenuScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  set?: InputMaybe<Array<MenuWhereUniqueInput>>;
  update?: InputMaybe<Array<MenuUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<MenuUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<MenuUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type MenuUpdateManyWithoutSiteNestedInput = {
  connect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuCreateOrConnectWithoutSiteInput>>;
  create?: InputMaybe<Array<MenuCreateWithoutSiteInput>>;
  createMany?: InputMaybe<MenuCreateManySiteInputEnvelope>;
  delete?: InputMaybe<Array<MenuWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MenuScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  set?: InputMaybe<Array<MenuWhereUniqueInput>>;
  update?: InputMaybe<Array<MenuUpdateWithWhereUniqueWithoutSiteInput>>;
  updateMany?: InputMaybe<Array<MenuUpdateManyWithWhereWithoutSiteInput>>;
  upsert?: InputMaybe<Array<MenuUpsertWithWhereUniqueWithoutSiteInput>>;
};

export type MenuUpdateManyWithoutVerticalNestedInput = {
  connect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MenuCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<MenuCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<MenuCreateManyVerticalInputEnvelope>;
  delete?: InputMaybe<Array<MenuWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MenuScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MenuWhereUniqueInput>>;
  set?: InputMaybe<Array<MenuWhereUniqueInput>>;
  update?: InputMaybe<Array<MenuUpdateWithWhereUniqueWithoutVerticalInput>>;
  updateMany?: InputMaybe<Array<MenuUpdateManyWithWhereWithoutVerticalInput>>;
  upsert?: InputMaybe<Array<MenuUpsertWithWhereUniqueWithoutVerticalInput>>;
};

export type MenuUpdateOneRequiredWithoutItemsNestedInput = {
  connect?: InputMaybe<MenuWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MenuCreateOrConnectWithoutItemsInput>;
  create?: InputMaybe<MenuCreateWithoutItemsInput>;
  update?: InputMaybe<MenuUpdateToOneWithWhereWithoutItemsInput>;
  upsert?: InputMaybe<MenuUpsertWithoutItemsInput>;
};

export type MenuUpdateToOneWithWhereWithoutItemsInput = {
  data: MenuUpdateWithoutItemsInput;
  where?: InputMaybe<MenuWhereInput>;
};

export type MenuUpdateWithWhereUniqueWithoutNetworkInput = {
  data: MenuUpdateWithoutNetworkInput;
  where: MenuWhereUniqueInput;
};

export type MenuUpdateWithWhereUniqueWithoutSiteInput = {
  data: MenuUpdateWithoutSiteInput;
  where: MenuWhereUniqueInput;
};

export type MenuUpdateWithWhereUniqueWithoutVerticalInput = {
  data: MenuUpdateWithoutVerticalInput;
  where: MenuWhereUniqueInput;
};

export type MenuUpdateWithoutItemsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutMenusNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutMenusNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutMenusNestedInput>;
};

export type MenuUpdateWithoutNetworkInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  items?: InputMaybe<MenuItemUpdateManyWithoutMenuNestedInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  site?: InputMaybe<SiteUpdateOneWithoutMenusNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutMenusNestedInput>;
};

export type MenuUpdateWithoutSiteInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  items?: InputMaybe<MenuItemUpdateManyWithoutMenuNestedInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutMenusNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutMenusNestedInput>;
};

export type MenuUpdateWithoutVerticalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  items?: InputMaybe<MenuItemUpdateManyWithoutMenuNestedInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutMenusNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutMenusNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MenuUpsertWithWhereUniqueWithoutNetworkInput = {
  create: MenuCreateWithoutNetworkInput;
  update: MenuUpdateWithoutNetworkInput;
  where: MenuWhereUniqueInput;
};

export type MenuUpsertWithWhereUniqueWithoutSiteInput = {
  create: MenuCreateWithoutSiteInput;
  update: MenuUpdateWithoutSiteInput;
  where: MenuWhereUniqueInput;
};

export type MenuUpsertWithWhereUniqueWithoutVerticalInput = {
  create: MenuCreateWithoutVerticalInput;
  update: MenuUpdateWithoutVerticalInput;
  where: MenuWhereUniqueInput;
};

export type MenuUpsertWithoutItemsInput = {
  create: MenuCreateWithoutItemsInput;
  update: MenuUpdateWithoutItemsInput;
  where?: InputMaybe<MenuWhereInput>;
};

export type MenuWhereInput = {
  AND?: InputMaybe<Array<MenuWhereInput>>;
  NOT?: InputMaybe<Array<MenuWhereInput>>;
  OR?: InputMaybe<Array<MenuWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  items?: InputMaybe<MenuItemListRelationFilter>;
  key?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  site?: InputMaybe<SiteWhereInput>;
  siteId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type MenuWhereUniqueInput = {
  AND?: InputMaybe<Array<MenuWhereInput>>;
  NOT?: InputMaybe<Array<MenuWhereInput>>;
  OR?: InputMaybe<Array<MenuWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<MenuItemListRelationFilter>;
  key?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  site?: InputMaybe<SiteWhereInput>;
  siteId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addTemplateField?: Maybe<TemplateField>;
  addTemplateFieldMany?: Maybe<Array<Maybe<TemplateField>>>;
  addUIString?: Maybe<Scalars['Boolean']['output']>;
  createContentItem: ContentItem;
  createContentItemV2: Network;
  createDeployJobs?: Maybe<Array<Maybe<DeployJob>>>;
  createGeneralTemplateFieldGroup: GeneralTemplateFieldGroup;
  createLanguage: Language;
  /** @deprecated This is deprecated, use upsertMenuCustom instead */
  createMenu: Menu;
  createPropertyItem: PropertyItem;
  createRanking: Ranking;
  createRedirect: Redirect;
  createRegion: Region;
  createState: State;
  createStringItem: StringItem;
  createSubregion: Subregion;
  createTemplateFieldGroup: TemplateFieldGroup;
  createTranslationJobs?: Maybe<Array<Maybe<TranslationJob>>>;
  deleteAuthor?: Maybe<Author>;
  deleteContentItem?: Maybe<ContentItem>;
  deleteContentItemV2?: Maybe<Network>;
  deleteFile?: Maybe<MediaItem>;
  deleteFilterTaxonomyItem?: Maybe<FilterTaxonomyItem>;
  deleteFilterTaxonomyRule?: Maybe<FilterTaxonomyRule>;
  deleteGeneralTemplateFieldGroup?: Maybe<GeneralTemplateFieldGroup>;
  deleteLanguage?: Maybe<Language>;
  deleteMenu?: Maybe<Menu>;
  /** @deprecated This is deprecated, use deleteMenu instead */
  deleteMenus: AffectedRowsOutput;
  deleteNetwork?: Maybe<Network>;
  deletePage?: Maybe<Page>;
  deletePost?: Maybe<Post>;
  deleteProduct?: Maybe<Product>;
  deleteProductPool?: Maybe<ProductPool>;
  deleteProvider?: Maybe<Provider>;
  deleteProviderPool?: Maybe<ProviderPool>;
  deleteProviderTaxonomyConnection?: Maybe<ProviderTaxonomyConnection>;
  deleteRanking?: Maybe<Ranking>;
  deleteRedirect?: Maybe<Redirect>;
  deleteRegion?: Maybe<Region>;
  deleteRegions: AffectedRowsOutput;
  deleteSite?: Maybe<Site>;
  deleteState?: Maybe<State>;
  deleteStates: AffectedRowsOutput;
  deleteStringItem?: Maybe<StringItem>;
  deleteStringTemplate?: Maybe<StringTemplate>;
  deleteSubregion?: Maybe<Subregion>;
  deleteSubregions: AffectedRowsOutput;
  deleteTaxonomyItem?: Maybe<TaxonomyItem>;
  deleteTaxonomyItemPool?: Maybe<TaxonomyItemPool>;
  deleteVertical?: Maybe<Vertical>;
  importCldrData?: Maybe<ImportCldrDataResponse>;
  setStringItemOnContentItem?: Maybe<ContentItem>;
  stringImport?: Maybe<StringImportResponse>;
  translateCldrData?: Maybe<ImportCldrDataResponse>;
  updateContentItem?: Maybe<ContentItem>;
  updateContentItemV2?: Maybe<Network>;
  updateGeneralTemplateFieldGroup?: Maybe<GeneralTemplateFieldGroup>;
  updateLanguage?: Maybe<Language>;
  updateManyContentItemV2s: AffectedRowsOutput;
  updateManyContentItems: AffectedRowsOutput;
  updateManyPropertyItems: AffectedRowsOutput;
  updateManyStringItem: AffectedRowsOutput;
  updateMediaItem?: Maybe<MediaItem>;
  /** @deprecated This is deprecated, use upsertMenuCustom instead */
  updateMenu?: Maybe<Menu>;
  updatePropertyItem?: Maybe<PropertyItem>;
  updateRanking?: Maybe<Ranking>;
  updateRedirect?: Maybe<Redirect>;
  updateRegion?: Maybe<Region>;
  updateRegions: AffectedRowsOutput;
  updateState?: Maybe<State>;
  updateStates: AffectedRowsOutput;
  updateStringItem?: Maybe<StringItem>;
  updateSubregion?: Maybe<Subregion>;
  updateSubregions: AffectedRowsOutput;
  updateTemplateFieldGroup?: Maybe<TemplateFieldGroup>;
  updateUser?: Maybe<User>;
  uploadFile?: Maybe<MediaItem>;
  uploadFileWithCloudinaryWidget?: Maybe<MediaItem>;
  uploadFileWithURL?: Maybe<MediaItem>;
  uploadVideo?: Maybe<MediaItem>;
  upsertAuthor?: Maybe<Author>;
  upsertAuthorSection?: Maybe<Author>;
  upsertCompany: Company;
  upsertContentItem: ContentItem;
  upsertContentItemV2: Network;
  upsertFilterTaxonomyItem?: Maybe<FilterTaxonomyItem>;
  upsertFilterTaxonomyItemSection?: Maybe<FilterTaxonomyItem>;
  upsertFilterTaxonomyRule?: Maybe<FilterTaxonomyRule>;
  upsertGeneralTemplateFieldGroup: GeneralTemplateFieldGroup;
  upsertLanguage: Language;
  /** @deprecated This is deprecated, use upsertMenuCustom instead */
  upsertMenu: Menu;
  upsertMenuCustom?: Maybe<Menu>;
  upsertNetwork?: Maybe<Network>;
  upsertOnePropertyItemCustom?: Maybe<PropertyItem>;
  upsertPage?: Maybe<Page>;
  upsertPageSection?: Maybe<Page>;
  upsertPost?: Maybe<Post>;
  upsertPostSection?: Maybe<Post>;
  upsertProduct?: Maybe<Product>;
  upsertProductPool?: Maybe<ProductPool>;
  upsertProductSection?: Maybe<Product>;
  upsertPropertyItem: PropertyItem;
  upsertProvider?: Maybe<Provider>;
  upsertProviderPool?: Maybe<ProviderPool>;
  upsertProviderSection?: Maybe<Provider>;
  upsertProviderTaxonomyConnection?: Maybe<ProviderTaxonomyConnection>;
  upsertRanking: Ranking;
  upsertRedirect: Redirect;
  upsertRegion: Region;
  upsertSite?: Maybe<Site>;
  upsertState: State;
  upsertStringItem: StringItem;
  upsertStringTemplate?: Maybe<StringTemplate>;
  upsertSubregion: Subregion;
  upsertTag: Tag;
  upsertTaxonomyItem?: Maybe<TaxonomyItem>;
  upsertTaxonomyItemPool?: Maybe<TaxonomyItemPool>;
  upsertTaxonomyItemSection?: Maybe<TaxonomyItem>;
  upsertTemplateFieldGroup: TemplateFieldGroup;
  upsertVertical?: Maybe<Vertical>;
};


export type MutationAddTemplateFieldArgs = {
  data?: InputMaybe<AddTemplateFieldInput>;
  where?: InputMaybe<TemplateWhereUniqueInput>;
};


export type MutationAddTemplateFieldManyArgs = {
  data?: InputMaybe<AddTemplateFieldInput>;
  where?: InputMaybe<TemplateWhereInput>;
};


export type MutationAddUiStringArgs = {
  key: Scalars['String']['input'];
  network: NetworkWhereUniqueInput;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateContentItemArgs = {
  data: ContentItemCreateInput;
};


export type MutationCreateContentItemV2Args = {
  data: ContentItemV2CreateInput;
};


export type MutationCreateDeployJobsArgs = {
  sites: Array<CreateDeployJobSite>;
};


export type MutationCreateGeneralTemplateFieldGroupArgs = {
  data: GeneralTemplateFieldGroupCreateInput;
};


export type MutationCreateLanguageArgs = {
  data: LanguageCreateInput;
};


export type MutationCreateMenuArgs = {
  data: MenuCreateInput;
};


export type MutationCreatePropertyItemArgs = {
  data: PropertyItemCreateInput;
};


export type MutationCreateRankingArgs = {
  data: RankingCreateInput;
};


export type MutationCreateRedirectArgs = {
  data: RedirectCreateInput;
};


export type MutationCreateRegionArgs = {
  data: RegionCreateInput;
};


export type MutationCreateStateArgs = {
  data: StateCreateInput;
};


export type MutationCreateStringItemArgs = {
  data: StringItemCreateInput;
};


export type MutationCreateSubregionArgs = {
  data: SubregionCreateInput;
};


export type MutationCreateTemplateFieldGroupArgs = {
  data: TemplateFieldGroupCreateInput;
};


export type MutationCreateTranslationJobsArgs = {
  jobs: Array<TranslationJobData>;
};


export type MutationDeleteAuthorArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationDeleteContentItemArgs = {
  where: ContentItemWhereUniqueInput;
};


export type MutationDeleteContentItemV2Args = {
  where: ContentItemV2WhereUniqueInput;
};


export type MutationDeleteFileArgs = {
  where?: InputMaybe<MediaItemWhereUniqueInput>;
};


export type MutationDeleteFilterTaxonomyItemArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationDeleteFilterTaxonomyRuleArgs = {
  where?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
};


export type MutationDeleteGeneralTemplateFieldGroupArgs = {
  where: GeneralTemplateFieldGroupWhereUniqueInput;
};


export type MutationDeleteLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type MutationDeleteMenuArgs = {
  where?: InputMaybe<MenuWhereUniqueInput>;
};


export type MutationDeleteMenusArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuWhereInput>;
};


export type MutationDeleteNetworkArgs = {
  where?: InputMaybe<NetworkWhereUniqueInput>;
};


export type MutationDeletePageArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationDeletePostArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationDeleteProductArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationDeleteProductPoolArgs = {
  where?: InputMaybe<ProductPoolWhereUniqueInput>;
};


export type MutationDeleteProviderArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationDeleteProviderPoolArgs = {
  where?: InputMaybe<ProviderPoolWhereUniqueInput>;
};


export type MutationDeleteProviderTaxonomyConnectionArgs = {
  where?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
};


export type MutationDeleteRankingArgs = {
  where: RankingWhereUniqueInput;
};


export type MutationDeleteRedirectArgs = {
  where: RedirectWhereUniqueInput;
};


export type MutationDeleteRegionArgs = {
  where: RegionWhereUniqueInput;
};


export type MutationDeleteRegionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegionWhereInput>;
};


export type MutationDeleteSiteArgs = {
  where?: InputMaybe<SiteWhereUniqueInput>;
};


export type MutationDeleteStateArgs = {
  where: StateWhereUniqueInput;
};


export type MutationDeleteStatesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateWhereInput>;
};


export type MutationDeleteStringItemArgs = {
  where: StringItemWhereUniqueInput;
};


export type MutationDeleteStringTemplateArgs = {
  where?: InputMaybe<StringTemplateWhereUniqueInput>;
};


export type MutationDeleteSubregionArgs = {
  where: SubregionWhereUniqueInput;
};


export type MutationDeleteSubregionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubregionWhereInput>;
};


export type MutationDeleteTaxonomyItemArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationDeleteTaxonomyItemPoolArgs = {
  where?: InputMaybe<TaxonomyItemPoolWhereUniqueInput>;
};


export type MutationDeleteVerticalArgs = {
  where?: InputMaybe<VerticalWhereUniqueInput>;
};


export type MutationImportCldrDataArgs = {
  language: Scalars['String']['input'];
  network: Scalars['String']['input'];
};


export type MutationSetStringItemOnContentItemArgs = {
  contentItem: ContentItemWhereUniqueInput;
  context: Scalars['String']['input'];
  language: LanguageWhereUniqueInput;
  value: Scalars['JSON']['input'];
  variant?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationStringImportArgs = {
  config?: InputMaybe<StringImportConfig>;
  data: Scalars['JSON']['input'];
};


export type MutationTranslateCldrDataArgs = {
  language: Scalars['String']['input'];
  network: Scalars['String']['input'];
};


export type MutationUpdateContentItemArgs = {
  data: ContentItemUpdateInput;
  where: ContentItemWhereUniqueInput;
};


export type MutationUpdateContentItemV2Args = {
  data: ContentItemV2UpdateInput;
  where: ContentItemV2WhereUniqueInput;
};


export type MutationUpdateGeneralTemplateFieldGroupArgs = {
  data: GeneralTemplateFieldGroupUpdateInput;
  where: GeneralTemplateFieldGroupWhereUniqueInput;
};


export type MutationUpdateLanguageArgs = {
  data: LanguageUpdateInput;
  where: LanguageWhereUniqueInput;
};


export type MutationUpdateManyContentItemV2sArgs = {
  data: ContentItemV2UpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type MutationUpdateManyContentItemsArgs = {
  data: ContentItemUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemWhereInput>;
};


export type MutationUpdateManyPropertyItemsArgs = {
  data: PropertyItemUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};


export type MutationUpdateManyStringItemArgs = {
  data: StringItemUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StringItemWhereInput>;
};


export type MutationUpdateMediaItemArgs = {
  data: MediaItemUpdateInput;
  where: MediaItemWhereUniqueInput;
};


export type MutationUpdateMenuArgs = {
  data: MenuUpdateInput;
  where: MenuWhereUniqueInput;
};


export type MutationUpdatePropertyItemArgs = {
  data: PropertyItemUpdateInput;
  where: PropertyItemWhereUniqueInput;
};


export type MutationUpdateRankingArgs = {
  data: RankingUpdateInput;
  where: RankingWhereUniqueInput;
};


export type MutationUpdateRedirectArgs = {
  data: RedirectUpdateInput;
  where: RedirectWhereUniqueInput;
};


export type MutationUpdateRegionArgs = {
  data: RegionUpdateInput;
  where: RegionWhereUniqueInput;
};


export type MutationUpdateRegionsArgs = {
  data: RegionUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegionWhereInput>;
};


export type MutationUpdateStateArgs = {
  data: StateUpdateInput;
  where: StateWhereUniqueInput;
};


export type MutationUpdateStatesArgs = {
  data: StateUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateWhereInput>;
};


export type MutationUpdateStringItemArgs = {
  data: StringItemUpdateInput;
  where: StringItemWhereUniqueInput;
};


export type MutationUpdateSubregionArgs = {
  data: SubregionUpdateInput;
  where: SubregionWhereUniqueInput;
};


export type MutationUpdateSubregionsArgs = {
  data: SubregionUpdateManyMutationInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubregionWhereInput>;
};


export type MutationUpdateTemplateFieldGroupArgs = {
  data: TemplateFieldGroupUpdateInput;
  where: TemplateFieldGroupWhereUniqueInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUploadFileWithCloudinaryWidgetArgs = {
  cloudinaryFileObject: CloudinaryFileInput;
  name?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUploadFileWithUrlArgs = {
  networkId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: Scalars['String']['input'];
};


export type MutationUploadVideoArgs = {
  file: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpsertAuthorArgs = {
  current: ResourceCurrentInput;
  data: AuthorUpsertDataInput;
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationUpsertAuthorSectionArgs = {
  current: ResourceCurrentInput;
  data: UpsertSectionInput;
  where: RouteResourceWhereUniqueInput;
};


export type MutationUpsertCompanyArgs = {
  create: CompanyCreateInput;
  update: CompanyUpdateInput;
  where: CompanyWhereUniqueInput;
};


export type MutationUpsertContentItemArgs = {
  create: ContentItemCreateInput;
  update: ContentItemUpdateInput;
  where: ContentItemWhereUniqueInput;
};


export type MutationUpsertContentItemV2Args = {
  create: ContentItemV2CreateInput;
  update: ContentItemV2UpdateInput;
  where: ContentItemV2WhereUniqueInput;
};


export type MutationUpsertFilterTaxonomyItemArgs = {
  current: ResourceCurrentInput;
  data: FilterTaxonomyItemUpsertDataInput;
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationUpsertFilterTaxonomyItemSectionArgs = {
  current: ResourceCurrentInput;
  data: UpsertSectionInput;
  where: RouteResourceWhereUniqueInput;
};


export type MutationUpsertFilterTaxonomyRuleArgs = {
  current: ResourceCurrentInput;
  data: FilterTaxonomyRuleUpsertDataInput;
  where?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
};


export type MutationUpsertGeneralTemplateFieldGroupArgs = {
  create: GeneralTemplateFieldGroupCreateInput;
  update: GeneralTemplateFieldGroupUpdateInput;
  where: GeneralTemplateFieldGroupWhereUniqueInput;
};


export type MutationUpsertLanguageArgs = {
  create: LanguageCreateInput;
  update: LanguageUpdateInput;
  where: LanguageWhereUniqueInput;
};


export type MutationUpsertMenuArgs = {
  create: MenuCreateInput;
  update: MenuUpdateInput;
  where: MenuWhereUniqueInput;
};


export type MutationUpsertMenuCustomArgs = {
  menu?: InputMaybe<MenuInput>;
  menuItemsDelete?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpsertNetworkArgs = {
  data: NetworkUpsertDataInput;
  where?: InputMaybe<NetworkWhereUniqueInput>;
};


export type MutationUpsertOnePropertyItemCustomArgs = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  fieldId?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpsertPageArgs = {
  current: ResourceCurrentInput;
  data: PageUpsertDataInput;
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationUpsertPageSectionArgs = {
  current: ResourceCurrentInput;
  data: UpsertSectionInput;
  where: RouteResourceWhereUniqueInput;
};


export type MutationUpsertPostArgs = {
  current: ResourceCurrentInput;
  data: PostUpsertDataInput;
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationUpsertPostSectionArgs = {
  current: ResourceCurrentInput;
  data: UpsertSectionInput;
  where: RouteResourceWhereUniqueInput;
};


export type MutationUpsertProductArgs = {
  current: ResourceCurrentInput;
  data: ProductUpsertDataInput;
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationUpsertProductPoolArgs = {
  data: RouteResourcePoolUpsertDataInput;
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
};


export type MutationUpsertProductSectionArgs = {
  current: ResourceCurrentInput;
  data: UpsertSectionInput;
  where: RouteResourceWhereUniqueInput;
};


export type MutationUpsertPropertyItemArgs = {
  create: PropertyItemCreateInput;
  update: PropertyItemUpdateInput;
  where: PropertyItemWhereUniqueInput;
};


export type MutationUpsertProviderArgs = {
  current: ResourceCurrentInput;
  data: ProviderUpsertDataInput;
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationUpsertProviderPoolArgs = {
  data: RouteResourcePoolUpsertDataInput;
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
};


export type MutationUpsertProviderSectionArgs = {
  current: ResourceCurrentInput;
  data: UpsertSectionInput;
  where: RouteResourceWhereUniqueInput;
};


export type MutationUpsertProviderTaxonomyConnectionArgs = {
  current: ResourceCurrentInput;
  data: ProviderTaxonomyConnectionUpsertDataInput;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
};


export type MutationUpsertRankingArgs = {
  create: RankingCreateInput;
  update: RankingUpdateInput;
  where: RankingWhereUniqueInput;
};


export type MutationUpsertRedirectArgs = {
  create: RedirectCreateInput;
  update: RedirectUpdateInput;
  where: RedirectWhereUniqueInput;
};


export type MutationUpsertRegionArgs = {
  create: RegionCreateInput;
  update: RegionUpdateInput;
  where: RegionWhereUniqueInput;
};


export type MutationUpsertSiteArgs = {
  current: SiteCurrentInput;
  data: SiteUpsertDataInput;
  where?: InputMaybe<SiteWhereUniqueInput>;
};


export type MutationUpsertStateArgs = {
  create: StateCreateInput;
  update: StateUpdateInput;
  where: StateWhereUniqueInput;
};


export type MutationUpsertStringItemArgs = {
  create: StringItemCreateInput;
  update: StringItemUpdateInput;
  where: StringItemWhereUniqueInput;
};


export type MutationUpsertStringTemplateArgs = {
  current: ResourceCurrentInput;
  data: StringTemplateUpsertDataInput;
  where?: InputMaybe<StringTemplateWhereUniqueInput>;
};


export type MutationUpsertSubregionArgs = {
  create: SubregionCreateInput;
  update: SubregionUpdateInput;
  where: SubregionWhereUniqueInput;
};


export type MutationUpsertTagArgs = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};


export type MutationUpsertTaxonomyItemArgs = {
  current: ResourceCurrentInput;
  data: TaxonomyItemUpsertDataInput;
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type MutationUpsertTaxonomyItemPoolArgs = {
  data: RouteResourcePoolUpsertDataInput;
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
};


export type MutationUpsertTaxonomyItemSectionArgs = {
  current: ResourceCurrentInput;
  data: UpsertSectionInput;
  where: RouteResourceWhereUniqueInput;
};


export type MutationUpsertTemplateFieldGroupArgs = {
  create: TemplateFieldGroupCreateInput;
  update: TemplateFieldGroupUpdateInput;
  where: TemplateFieldGroupWhereUniqueInput;
};


export type MutationUpsertVerticalArgs = {
  current: VerticalCurrentInput;
  data: VerticalUpsertDataInput;
  where?: InputMaybe<VerticalWhereUniqueInput>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumContentItemTranslationTypeFilter = {
  equals?: InputMaybe<ContentItemTranslationType>;
  in?: InputMaybe<Array<ContentItemTranslationType>>;
  not?: InputMaybe<NestedEnumContentItemTranslationTypeFilter>;
  notIn?: InputMaybe<Array<ContentItemTranslationType>>;
};

export type NestedEnumContextTypeFilter = {
  equals?: InputMaybe<ContextType>;
  in?: InputMaybe<Array<ContextType>>;
  not?: InputMaybe<NestedEnumContextTypeFilter>;
  notIn?: InputMaybe<Array<ContextType>>;
};

export type NestedEnumDisplayTypeNullableFilter = {
  equals?: InputMaybe<DisplayType>;
  in?: InputMaybe<Array<DisplayType>>;
  not?: InputMaybe<NestedEnumDisplayTypeNullableFilter>;
  notIn?: InputMaybe<Array<DisplayType>>;
};

export type NestedEnumFieldTypeFilter = {
  equals?: InputMaybe<FieldType>;
  in?: InputMaybe<Array<FieldType>>;
  not?: InputMaybe<NestedEnumFieldTypeFilter>;
  notIn?: InputMaybe<Array<FieldType>>;
};

export type NestedEnumGeoModeFilter = {
  equals?: InputMaybe<GeoMode>;
  in?: InputMaybe<Array<GeoMode>>;
  not?: InputMaybe<NestedEnumGeoModeFilter>;
  notIn?: InputMaybe<Array<GeoMode>>;
};

export type NestedEnumMenuTypeFilter = {
  equals?: InputMaybe<MenuType>;
  in?: InputMaybe<Array<MenuType>>;
  not?: InputMaybe<NestedEnumMenuTypeFilter>;
  notIn?: InputMaybe<Array<MenuType>>;
};

export type NestedEnumPostTypeFilter = {
  equals?: InputMaybe<PostType>;
  in?: InputMaybe<Array<PostType>>;
  not?: InputMaybe<NestedEnumPostTypeFilter>;
  notIn?: InputMaybe<Array<PostType>>;
};

export type NestedEnumRedirectKindFilter = {
  equals?: InputMaybe<RedirectKind>;
  in?: InputMaybe<Array<RedirectKind>>;
  not?: InputMaybe<NestedEnumRedirectKindFilter>;
  notIn?: InputMaybe<Array<RedirectKind>>;
};

export type NestedEnumRedirectScopeFilter = {
  equals?: InputMaybe<RedirectScope>;
  in?: InputMaybe<Array<RedirectScope>>;
  not?: InputMaybe<NestedEnumRedirectScopeFilter>;
  notIn?: InputMaybe<Array<RedirectScope>>;
};

export type NestedEnumResourceTypeFilter = {
  equals?: InputMaybe<ResourceType>;
  in?: InputMaybe<Array<ResourceType>>;
  not?: InputMaybe<NestedEnumResourceTypeFilter>;
  notIn?: InputMaybe<Array<ResourceType>>;
};

export type NestedEnumRouteResourceTypeFilter = {
  equals?: InputMaybe<RouteResourceType>;
  in?: InputMaybe<Array<RouteResourceType>>;
  not?: InputMaybe<NestedEnumRouteResourceTypeFilter>;
  notIn?: InputMaybe<Array<RouteResourceType>>;
};

export type NestedEnumRouteResourceTypeNullableFilter = {
  equals?: InputMaybe<RouteResourceType>;
  in?: InputMaybe<Array<RouteResourceType>>;
  not?: InputMaybe<NestedEnumRouteResourceTypeNullableFilter>;
  notIn?: InputMaybe<Array<RouteResourceType>>;
};

export type NestedEnumStringItemStatusFilter = {
  equals?: InputMaybe<StringItemStatus>;
  in?: InputMaybe<Array<StringItemStatus>>;
  not?: InputMaybe<NestedEnumStringItemStatusFilter>;
  notIn?: InputMaybe<Array<StringItemStatus>>;
};

export type NestedEnumStringItemSyncStatusFilter = {
  equals?: InputMaybe<StringItemSyncStatus>;
  in?: InputMaybe<Array<StringItemSyncStatus>>;
  not?: InputMaybe<NestedEnumStringItemSyncStatusFilter>;
  notIn?: InputMaybe<Array<StringItemSyncStatus>>;
};

export type NestedEnumStringItemTranslationTypeFilter = {
  equals?: InputMaybe<StringItemTranslationType>;
  in?: InputMaybe<Array<StringItemTranslationType>>;
  not?: InputMaybe<NestedEnumStringItemTranslationTypeFilter>;
  notIn?: InputMaybe<Array<StringItemTranslationType>>;
};

export type NestedEnumStringTemplateVariableResolveLocationFilter = {
  equals?: InputMaybe<StringTemplateVariableResolveLocation>;
  in?: InputMaybe<Array<StringTemplateVariableResolveLocation>>;
  not?: InputMaybe<NestedEnumStringTemplateVariableResolveLocationFilter>;
  notIn?: InputMaybe<Array<StringTemplateVariableResolveLocation>>;
};

export type NestedEnumStringTemplateVariableTypeFilter = {
  equals?: InputMaybe<StringTemplateVariableType>;
  in?: InputMaybe<Array<StringTemplateVariableType>>;
  not?: InputMaybe<NestedEnumStringTemplateVariableTypeFilter>;
  notIn?: InputMaybe<Array<StringTemplateVariableType>>;
};

export type NestedEnumTemplateTypeFilter = {
  equals?: InputMaybe<TemplateType>;
  in?: InputMaybe<Array<TemplateType>>;
  not?: InputMaybe<NestedEnumTemplateTypeFilter>;
  notIn?: InputMaybe<Array<TemplateType>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Network = {
  __typename?: 'Network';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id: Scalars['String']['output'];
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  templates: Array<Template>;
  updatedAt: Scalars['DateTime']['output'];
  verticals: Array<Vertical>;
};


export type NetworkCompanyArgs = {
  where?: InputMaybe<CompanyWhereInput>;
};


export type NetworkContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type NetworkHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type NetworkPropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};


export type NetworkTemplatesArgs = {
  cursor?: InputMaybe<TemplateWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateWhereInput>;
};


export type NetworkVerticalsArgs = {
  cursor?: InputMaybe<VerticalWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalWhereInput>;
};

export type NetworkCreateManyCompanyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NetworkCreateManyCompanyInputEnvelope = {
  data?: InputMaybe<Array<NetworkCreateManyCompanyInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NetworkCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutCompanyInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutCompanyInput>>;
  createMany?: InputMaybe<NetworkCreateManyCompanyInputEnvelope>;
};

export type NetworkCreateNestedManyWithoutProductPoolsInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutProductPoolsInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutProductPoolsInput>>;
};

export type NetworkCreateNestedManyWithoutProviderPoolsInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutProviderPoolsInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutProviderPoolsInput>>;
};

export type NetworkCreateNestedManyWithoutRouteResourcePoolsInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutRouteResourcePoolsInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutRouteResourcePoolsInput>>;
};

export type NetworkCreateNestedManyWithoutTaxonomyItemPoolsInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutTaxonomyItemPoolsInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutTaxonomyItemPoolsInput>>;
};

export type NetworkCreateNestedOneWithoutAuthorInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutAuthorInput>;
  create?: InputMaybe<NetworkCreateWithoutAuthorInput>;
};

export type NetworkCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<NetworkCreateWithoutContentInput>;
};

export type NetworkCreateNestedOneWithoutContentItemInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutContentItemInput>;
  create?: InputMaybe<NetworkCreateWithoutContentItemInput>;
};

export type NetworkCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<NetworkCreateWithoutContentOldInput>;
};

export type NetworkCreateNestedOneWithoutFilterTaxonomyItemInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutFilterTaxonomyItemInput>;
  create?: InputMaybe<NetworkCreateWithoutFilterTaxonomyItemInput>;
};

export type NetworkCreateNestedOneWithoutFilterTaxonomyRuleInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutFilterTaxonomyRuleInput>;
  create?: InputMaybe<NetworkCreateWithoutFilterTaxonomyRuleInput>;
};

export type NetworkCreateNestedOneWithoutMediaItemInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutMediaItemInput>;
  create?: InputMaybe<NetworkCreateWithoutMediaItemInput>;
};

export type NetworkCreateNestedOneWithoutMenusInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutMenusInput>;
  create?: InputMaybe<NetworkCreateWithoutMenusInput>;
};

export type NetworkCreateNestedOneWithoutProductInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutProductInput>;
  create?: InputMaybe<NetworkCreateWithoutProductInput>;
};

export type NetworkCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<NetworkCreateWithoutPropertiesInput>;
};

export type NetworkCreateNestedOneWithoutProviderInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutProviderInput>;
  create?: InputMaybe<NetworkCreateWithoutProviderInput>;
};

export type NetworkCreateNestedOneWithoutProviderTaxonomyConnectionsInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutProviderTaxonomyConnectionsInput>;
  create?: InputMaybe<NetworkCreateWithoutProviderTaxonomyConnectionsInput>;
};

export type NetworkCreateNestedOneWithoutRankingInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutRankingInput>;
  create?: InputMaybe<NetworkCreateWithoutRankingInput>;
};

export type NetworkCreateNestedOneWithoutRouteResourcesInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutRouteResourcesInput>;
  create?: InputMaybe<NetworkCreateWithoutRouteResourcesInput>;
};

export type NetworkCreateNestedOneWithoutSourceRedirectsInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutSourceRedirectsInput>;
  create?: InputMaybe<NetworkCreateWithoutSourceRedirectsInput>;
};

export type NetworkCreateNestedOneWithoutStringTemplateInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutStringTemplateInput>;
  create?: InputMaybe<NetworkCreateWithoutStringTemplateInput>;
};

export type NetworkCreateNestedOneWithoutStringTemplateVariableInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutStringTemplateVariableInput>;
  create?: InputMaybe<NetworkCreateWithoutStringTemplateVariableInput>;
};

export type NetworkCreateNestedOneWithoutTargetRedirectsInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutTargetRedirectsInput>;
  create?: InputMaybe<NetworkCreateWithoutTargetRedirectsInput>;
};

export type NetworkCreateNestedOneWithoutTaxonomyItemInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutTaxonomyItemInput>;
  create?: InputMaybe<NetworkCreateWithoutTaxonomyItemInput>;
};

export type NetworkCreateNestedOneWithoutTemplatesInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutTemplatesInput>;
  create?: InputMaybe<NetworkCreateWithoutTemplatesInput>;
};

export type NetworkCreateNestedOneWithoutVerticalsInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutVerticalsInput>;
  create?: InputMaybe<NetworkCreateWithoutVerticalsInput>;
};

export type NetworkCreateOrConnectWithoutAuthorInput = {
  create: NetworkCreateWithoutAuthorInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutCompanyInput = {
  create: NetworkCreateWithoutCompanyInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutContentInput = {
  create: NetworkCreateWithoutContentInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutContentItemInput = {
  create: NetworkCreateWithoutContentItemInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutContentOldInput = {
  create: NetworkCreateWithoutContentOldInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutFilterTaxonomyItemInput = {
  create: NetworkCreateWithoutFilterTaxonomyItemInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutFilterTaxonomyRuleInput = {
  create: NetworkCreateWithoutFilterTaxonomyRuleInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutMediaItemInput = {
  create: NetworkCreateWithoutMediaItemInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutMenusInput = {
  create: NetworkCreateWithoutMenusInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutProductInput = {
  create: NetworkCreateWithoutProductInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutProductPoolsInput = {
  create: NetworkCreateWithoutProductPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutPropertiesInput = {
  create: NetworkCreateWithoutPropertiesInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutProviderInput = {
  create: NetworkCreateWithoutProviderInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutProviderPoolsInput = {
  create: NetworkCreateWithoutProviderPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutProviderTaxonomyConnectionsInput = {
  create: NetworkCreateWithoutProviderTaxonomyConnectionsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutRankingInput = {
  create: NetworkCreateWithoutRankingInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutRouteResourcePoolsInput = {
  create: NetworkCreateWithoutRouteResourcePoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutRouteResourcesInput = {
  create: NetworkCreateWithoutRouteResourcesInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutSourceRedirectsInput = {
  create: NetworkCreateWithoutSourceRedirectsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutStringTemplateInput = {
  create: NetworkCreateWithoutStringTemplateInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutStringTemplateVariableInput = {
  create: NetworkCreateWithoutStringTemplateVariableInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutTargetRedirectsInput = {
  create: NetworkCreateWithoutTargetRedirectsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutTaxonomyItemInput = {
  create: NetworkCreateWithoutTaxonomyItemInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutTaxonomyItemPoolsInput = {
  create: NetworkCreateWithoutTaxonomyItemPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutTemplatesInput = {
  create: NetworkCreateWithoutTemplatesInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateOrConnectWithoutVerticalsInput = {
  create: NetworkCreateWithoutVerticalsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkCreateWithoutAuthorInput = {
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutCompanyInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutContentInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutContentItemInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutContentOldInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutFilterTaxonomyItemInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutFilterTaxonomyRuleInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutMediaItemInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutMenusInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutProductInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutProductPoolsInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutPropertiesInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutProviderInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutProviderPoolsInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutProviderTaxonomyConnectionsInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutRankingInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutRouteResourcePoolsInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutRouteResourcesInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutSourceRedirectsInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutStringTemplateInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutStringTemplateVariableInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutTargetRedirectsInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutTaxonomyItemInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutTaxonomyItemPoolsInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutTemplatesInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticals?: InputMaybe<VerticalCreateNestedManyWithoutNetworkInput>;
};

export type NetworkCreateWithoutVerticalsInput = {
  Author?: InputMaybe<AuthorCreateNestedManyWithoutNetworkInput>;
  ContentItem?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutNetworkInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutNetworkInput>;
  MediaItem?: InputMaybe<MediaItemCreateNestedManyWithoutNetworkInput>;
  Product?: InputMaybe<ProductCreateNestedManyWithoutNetworkInput>;
  Provider?: InputMaybe<ProviderCreateNestedManyWithoutNetworkInput>;
  Ranking?: InputMaybe<RankingCreateNestedOneWithoutNetworkInput>;
  StringTemplate?: InputMaybe<StringTemplateCreateNestedManyWithoutNetworkInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemCreateNestedManyWithoutNetworkInput>;
  company?: InputMaybe<CompanyCreateNestedOneWithoutNetworksInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutNetworkInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutNetworkContentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutNetworkInput>;
  productPools?: InputMaybe<ProductPoolCreateNestedManyWithoutNetworksInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutNetworkInput>;
  providerPools?: InputMaybe<ProviderPoolCreateNestedManyWithoutNetworksInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutNetworksInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutNetworkInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceNetworkInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedManyWithoutNetworkInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetNetworkInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutNetworksInput>;
  templates?: InputMaybe<TemplateCreateNestedManyWithoutNetworkInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NetworkListRelationFilter = {
  every?: InputMaybe<NetworkWhereInput>;
  none?: InputMaybe<NetworkWhereInput>;
  some?: InputMaybe<NetworkWhereInput>;
};

export type NetworkOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NetworkOrderByWithRelationInput = {
  Author?: InputMaybe<AuthorOrderByRelationAggregateInput>;
  ContentItem?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemOrderByRelationAggregateInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleOrderByRelationAggregateInput>;
  MediaItem?: InputMaybe<MediaItemOrderByRelationAggregateInput>;
  Product?: InputMaybe<ProductOrderByRelationAggregateInput>;
  Provider?: InputMaybe<ProviderOrderByRelationAggregateInput>;
  Ranking?: InputMaybe<RankingOrderByWithRelationInput>;
  StringTemplate?: InputMaybe<StringTemplateOrderByRelationAggregateInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemOrderByRelationAggregateInput>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  menus?: InputMaybe<MenuOrderByRelationAggregateInput>;
  productPools?: InputMaybe<ProductPoolOrderByRelationAggregateInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  providerPools?: InputMaybe<ProviderPoolOrderByRelationAggregateInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionOrderByRelationAggregateInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolOrderByRelationAggregateInput>;
  routeResources?: InputMaybe<RouteResourceOrderByRelationAggregateInput>;
  sourceRedirects?: InputMaybe<RedirectOrderByRelationAggregateInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableOrderByRelationAggregateInput>;
  targetRedirects?: InputMaybe<RedirectOrderByRelationAggregateInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolOrderByRelationAggregateInput>;
  templates?: InputMaybe<TemplateOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verticals?: InputMaybe<VerticalOrderByRelationAggregateInput>;
};

export type NetworkScalarWhereInput = {
  AND?: InputMaybe<Array<NetworkScalarWhereInput>>;
  NOT?: InputMaybe<Array<NetworkScalarWhereInput>>;
  OR?: InputMaybe<Array<NetworkScalarWhereInput>>;
  companyId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type NetworkUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NetworkUpdateManyWithWhereWithoutCompanyInput = {
  data: NetworkUpdateManyMutationInput;
  where: NetworkScalarWhereInput;
};

export type NetworkUpdateManyWithWhereWithoutProductPoolsInput = {
  data: NetworkUpdateManyMutationInput;
  where: NetworkScalarWhereInput;
};

export type NetworkUpdateManyWithWhereWithoutProviderPoolsInput = {
  data: NetworkUpdateManyMutationInput;
  where: NetworkScalarWhereInput;
};

export type NetworkUpdateManyWithWhereWithoutRouteResourcePoolsInput = {
  data: NetworkUpdateManyMutationInput;
  where: NetworkScalarWhereInput;
};

export type NetworkUpdateManyWithWhereWithoutTaxonomyItemPoolsInput = {
  data: NetworkUpdateManyMutationInput;
  where: NetworkScalarWhereInput;
};

export type NetworkUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutCompanyInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutCompanyInput>>;
  createMany?: InputMaybe<NetworkCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NetworkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  set?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  update?: InputMaybe<Array<NetworkUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: InputMaybe<Array<NetworkUpdateManyWithWhereWithoutCompanyInput>>;
  upsert?: InputMaybe<Array<NetworkUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type NetworkUpdateManyWithoutProductPoolsNestedInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutProductPoolsInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutProductPoolsInput>>;
  delete?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NetworkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  set?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  update?: InputMaybe<Array<NetworkUpdateWithWhereUniqueWithoutProductPoolsInput>>;
  updateMany?: InputMaybe<Array<NetworkUpdateManyWithWhereWithoutProductPoolsInput>>;
  upsert?: InputMaybe<Array<NetworkUpsertWithWhereUniqueWithoutProductPoolsInput>>;
};

export type NetworkUpdateManyWithoutProviderPoolsNestedInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutProviderPoolsInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutProviderPoolsInput>>;
  delete?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NetworkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  set?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  update?: InputMaybe<Array<NetworkUpdateWithWhereUniqueWithoutProviderPoolsInput>>;
  updateMany?: InputMaybe<Array<NetworkUpdateManyWithWhereWithoutProviderPoolsInput>>;
  upsert?: InputMaybe<Array<NetworkUpsertWithWhereUniqueWithoutProviderPoolsInput>>;
};

export type NetworkUpdateManyWithoutRouteResourcePoolsNestedInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutRouteResourcePoolsInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutRouteResourcePoolsInput>>;
  delete?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NetworkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  set?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  update?: InputMaybe<Array<NetworkUpdateWithWhereUniqueWithoutRouteResourcePoolsInput>>;
  updateMany?: InputMaybe<Array<NetworkUpdateManyWithWhereWithoutRouteResourcePoolsInput>>;
  upsert?: InputMaybe<Array<NetworkUpsertWithWhereUniqueWithoutRouteResourcePoolsInput>>;
};

export type NetworkUpdateManyWithoutTaxonomyItemPoolsNestedInput = {
  connect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NetworkCreateOrConnectWithoutTaxonomyItemPoolsInput>>;
  create?: InputMaybe<Array<NetworkCreateWithoutTaxonomyItemPoolsInput>>;
  delete?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NetworkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  set?: InputMaybe<Array<NetworkWhereUniqueInput>>;
  update?: InputMaybe<Array<NetworkUpdateWithWhereUniqueWithoutTaxonomyItemPoolsInput>>;
  updateMany?: InputMaybe<Array<NetworkUpdateManyWithWhereWithoutTaxonomyItemPoolsInput>>;
  upsert?: InputMaybe<Array<NetworkUpsertWithWhereUniqueWithoutTaxonomyItemPoolsInput>>;
};

export type NetworkUpdateOneRequiredWithoutAuthorNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutAuthorInput>;
  create?: InputMaybe<NetworkCreateWithoutAuthorInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutAuthorInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutAuthorInput>;
};

export type NetworkUpdateOneRequiredWithoutFilterTaxonomyItemNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutFilterTaxonomyItemInput>;
  create?: InputMaybe<NetworkCreateWithoutFilterTaxonomyItemInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutFilterTaxonomyItemInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutFilterTaxonomyItemInput>;
};

export type NetworkUpdateOneRequiredWithoutFilterTaxonomyRuleNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutFilterTaxonomyRuleInput>;
  create?: InputMaybe<NetworkCreateWithoutFilterTaxonomyRuleInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutFilterTaxonomyRuleInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutFilterTaxonomyRuleInput>;
};

export type NetworkUpdateOneRequiredWithoutMenusNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutMenusInput>;
  create?: InputMaybe<NetworkCreateWithoutMenusInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutMenusInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutMenusInput>;
};

export type NetworkUpdateOneRequiredWithoutRankingNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutRankingInput>;
  create?: InputMaybe<NetworkCreateWithoutRankingInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutRankingInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutRankingInput>;
};

export type NetworkUpdateOneRequiredWithoutStringTemplateNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutStringTemplateInput>;
  create?: InputMaybe<NetworkCreateWithoutStringTemplateInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutStringTemplateInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutStringTemplateInput>;
};

export type NetworkUpdateOneRequiredWithoutStringTemplateVariableNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutStringTemplateVariableInput>;
  create?: InputMaybe<NetworkCreateWithoutStringTemplateVariableInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutStringTemplateVariableInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutStringTemplateVariableInput>;
};

export type NetworkUpdateOneWithoutContentItemNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutContentItemInput>;
  create?: InputMaybe<NetworkCreateWithoutContentItemInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutContentItemInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutContentItemInput>;
};

export type NetworkUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<NetworkCreateWithoutContentInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutContentInput>;
};

export type NetworkUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<NetworkCreateWithoutContentOldInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutContentOldInput>;
};

export type NetworkUpdateOneWithoutMediaItemNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutMediaItemInput>;
  create?: InputMaybe<NetworkCreateWithoutMediaItemInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutMediaItemInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutMediaItemInput>;
};

export type NetworkUpdateOneWithoutProductNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutProductInput>;
  create?: InputMaybe<NetworkCreateWithoutProductInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutProductInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutProductInput>;
};

export type NetworkUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<NetworkCreateWithoutPropertiesInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutPropertiesInput>;
};

export type NetworkUpdateOneWithoutProviderNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutProviderInput>;
  create?: InputMaybe<NetworkCreateWithoutProviderInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutProviderInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutProviderInput>;
};

export type NetworkUpdateOneWithoutProviderTaxonomyConnectionsNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutProviderTaxonomyConnectionsInput>;
  create?: InputMaybe<NetworkCreateWithoutProviderTaxonomyConnectionsInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutProviderTaxonomyConnectionsInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutProviderTaxonomyConnectionsInput>;
};

export type NetworkUpdateOneWithoutRouteResourcesNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutRouteResourcesInput>;
  create?: InputMaybe<NetworkCreateWithoutRouteResourcesInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutRouteResourcesInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutRouteResourcesInput>;
};

export type NetworkUpdateOneWithoutSourceRedirectsNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutSourceRedirectsInput>;
  create?: InputMaybe<NetworkCreateWithoutSourceRedirectsInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutSourceRedirectsInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutSourceRedirectsInput>;
};

export type NetworkUpdateOneWithoutTargetRedirectsNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutTargetRedirectsInput>;
  create?: InputMaybe<NetworkCreateWithoutTargetRedirectsInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutTargetRedirectsInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutTargetRedirectsInput>;
};

export type NetworkUpdateOneWithoutTaxonomyItemNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutTaxonomyItemInput>;
  create?: InputMaybe<NetworkCreateWithoutTaxonomyItemInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutTaxonomyItemInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutTaxonomyItemInput>;
};

export type NetworkUpdateOneWithoutTemplatesNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutTemplatesInput>;
  create?: InputMaybe<NetworkCreateWithoutTemplatesInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutTemplatesInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutTemplatesInput>;
};

export type NetworkUpdateOneWithoutVerticalsNestedInput = {
  connect?: InputMaybe<NetworkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NetworkCreateOrConnectWithoutVerticalsInput>;
  create?: InputMaybe<NetworkCreateWithoutVerticalsInput>;
  delete?: InputMaybe<NetworkWhereInput>;
  disconnect?: InputMaybe<NetworkWhereInput>;
  update?: InputMaybe<NetworkUpdateToOneWithWhereWithoutVerticalsInput>;
  upsert?: InputMaybe<NetworkUpsertWithoutVerticalsInput>;
};

export type NetworkUpdateToOneWithWhereWithoutAuthorInput = {
  data: NetworkUpdateWithoutAuthorInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutContentInput = {
  data: NetworkUpdateWithoutContentInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutContentItemInput = {
  data: NetworkUpdateWithoutContentItemInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutContentOldInput = {
  data: NetworkUpdateWithoutContentOldInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutFilterTaxonomyItemInput = {
  data: NetworkUpdateWithoutFilterTaxonomyItemInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutFilterTaxonomyRuleInput = {
  data: NetworkUpdateWithoutFilterTaxonomyRuleInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutMediaItemInput = {
  data: NetworkUpdateWithoutMediaItemInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutMenusInput = {
  data: NetworkUpdateWithoutMenusInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutProductInput = {
  data: NetworkUpdateWithoutProductInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutPropertiesInput = {
  data: NetworkUpdateWithoutPropertiesInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutProviderInput = {
  data: NetworkUpdateWithoutProviderInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutProviderTaxonomyConnectionsInput = {
  data: NetworkUpdateWithoutProviderTaxonomyConnectionsInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutRankingInput = {
  data: NetworkUpdateWithoutRankingInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutRouteResourcesInput = {
  data: NetworkUpdateWithoutRouteResourcesInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutSourceRedirectsInput = {
  data: NetworkUpdateWithoutSourceRedirectsInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutStringTemplateInput = {
  data: NetworkUpdateWithoutStringTemplateInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutStringTemplateVariableInput = {
  data: NetworkUpdateWithoutStringTemplateVariableInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutTargetRedirectsInput = {
  data: NetworkUpdateWithoutTargetRedirectsInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutTaxonomyItemInput = {
  data: NetworkUpdateWithoutTaxonomyItemInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutTemplatesInput = {
  data: NetworkUpdateWithoutTemplatesInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateToOneWithWhereWithoutVerticalsInput = {
  data: NetworkUpdateWithoutVerticalsInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpdateWithWhereUniqueWithoutCompanyInput = {
  data: NetworkUpdateWithoutCompanyInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpdateWithWhereUniqueWithoutProductPoolsInput = {
  data: NetworkUpdateWithoutProductPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpdateWithWhereUniqueWithoutProviderPoolsInput = {
  data: NetworkUpdateWithoutProviderPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpdateWithWhereUniqueWithoutRouteResourcePoolsInput = {
  data: NetworkUpdateWithoutRouteResourcePoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpdateWithWhereUniqueWithoutTaxonomyItemPoolsInput = {
  data: NetworkUpdateWithoutTaxonomyItemPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpdateWithoutAuthorInput = {
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutCompanyInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutContentInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutContentItemInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutContentOldInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutFilterTaxonomyItemInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutFilterTaxonomyRuleInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutMediaItemInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutMenusInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutProductInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutProductPoolsInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutPropertiesInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutProviderInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutProviderPoolsInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutProviderTaxonomyConnectionsInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutRankingInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutRouteResourcePoolsInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutRouteResourcesInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutSourceRedirectsInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutStringTemplateInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutStringTemplateVariableInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutTargetRedirectsInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutTaxonomyItemInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutTaxonomyItemPoolsInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutTemplatesInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verticals?: InputMaybe<VerticalUpdateManyWithoutNetworkNestedInput>;
};

export type NetworkUpdateWithoutVerticalsInput = {
  Author?: InputMaybe<AuthorUpdateManyWithoutNetworkNestedInput>;
  ContentItem?: InputMaybe<ContentItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutNetworkNestedInput>;
  MediaItem?: InputMaybe<MediaItemUpdateManyWithoutNetworkNestedInput>;
  Product?: InputMaybe<ProductUpdateManyWithoutNetworkNestedInput>;
  Provider?: InputMaybe<ProviderUpdateManyWithoutNetworkNestedInput>;
  Ranking?: InputMaybe<RankingUpdateOneWithoutNetworkNestedInput>;
  StringTemplate?: InputMaybe<StringTemplateUpdateManyWithoutNetworkNestedInput>;
  TaxonomyItem?: InputMaybe<TaxonomyItemUpdateManyWithoutNetworkNestedInput>;
  company?: InputMaybe<CompanyUpdateOneWithoutNetworksNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutNetworkNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutNetworkContentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutNetworkNestedInput>;
  productPools?: InputMaybe<ProductPoolUpdateManyWithoutNetworksNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutNetworkNestedInput>;
  providerPools?: InputMaybe<ProviderPoolUpdateManyWithoutNetworksNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput>;
  routeResourcePools?: InputMaybe<RouteResourcePoolUpdateManyWithoutNetworksNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutNetworkNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceNetworkNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateManyWithoutNetworkNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetNetworkNestedInput>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput>;
  templates?: InputMaybe<TemplateUpdateManyWithoutNetworkNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type NetworkUpsertDataInput = {
  company?: InputMaybe<CompanyWhereUniqueInput>;
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type NetworkUpsertWithWhereUniqueWithoutCompanyInput = {
  create: NetworkCreateWithoutCompanyInput;
  update: NetworkUpdateWithoutCompanyInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpsertWithWhereUniqueWithoutProductPoolsInput = {
  create: NetworkCreateWithoutProductPoolsInput;
  update: NetworkUpdateWithoutProductPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpsertWithWhereUniqueWithoutProviderPoolsInput = {
  create: NetworkCreateWithoutProviderPoolsInput;
  update: NetworkUpdateWithoutProviderPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpsertWithWhereUniqueWithoutRouteResourcePoolsInput = {
  create: NetworkCreateWithoutRouteResourcePoolsInput;
  update: NetworkUpdateWithoutRouteResourcePoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpsertWithWhereUniqueWithoutTaxonomyItemPoolsInput = {
  create: NetworkCreateWithoutTaxonomyItemPoolsInput;
  update: NetworkUpdateWithoutTaxonomyItemPoolsInput;
  where: NetworkWhereUniqueInput;
};

export type NetworkUpsertWithoutAuthorInput = {
  create: NetworkCreateWithoutAuthorInput;
  update: NetworkUpdateWithoutAuthorInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutContentInput = {
  create: NetworkCreateWithoutContentInput;
  update: NetworkUpdateWithoutContentInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutContentItemInput = {
  create: NetworkCreateWithoutContentItemInput;
  update: NetworkUpdateWithoutContentItemInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutContentOldInput = {
  create: NetworkCreateWithoutContentOldInput;
  update: NetworkUpdateWithoutContentOldInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutFilterTaxonomyItemInput = {
  create: NetworkCreateWithoutFilterTaxonomyItemInput;
  update: NetworkUpdateWithoutFilterTaxonomyItemInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutFilterTaxonomyRuleInput = {
  create: NetworkCreateWithoutFilterTaxonomyRuleInput;
  update: NetworkUpdateWithoutFilterTaxonomyRuleInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutMediaItemInput = {
  create: NetworkCreateWithoutMediaItemInput;
  update: NetworkUpdateWithoutMediaItemInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutMenusInput = {
  create: NetworkCreateWithoutMenusInput;
  update: NetworkUpdateWithoutMenusInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutProductInput = {
  create: NetworkCreateWithoutProductInput;
  update: NetworkUpdateWithoutProductInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutPropertiesInput = {
  create: NetworkCreateWithoutPropertiesInput;
  update: NetworkUpdateWithoutPropertiesInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutProviderInput = {
  create: NetworkCreateWithoutProviderInput;
  update: NetworkUpdateWithoutProviderInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutProviderTaxonomyConnectionsInput = {
  create: NetworkCreateWithoutProviderTaxonomyConnectionsInput;
  update: NetworkUpdateWithoutProviderTaxonomyConnectionsInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutRankingInput = {
  create: NetworkCreateWithoutRankingInput;
  update: NetworkUpdateWithoutRankingInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutRouteResourcesInput = {
  create: NetworkCreateWithoutRouteResourcesInput;
  update: NetworkUpdateWithoutRouteResourcesInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutSourceRedirectsInput = {
  create: NetworkCreateWithoutSourceRedirectsInput;
  update: NetworkUpdateWithoutSourceRedirectsInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutStringTemplateInput = {
  create: NetworkCreateWithoutStringTemplateInput;
  update: NetworkUpdateWithoutStringTemplateInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutStringTemplateVariableInput = {
  create: NetworkCreateWithoutStringTemplateVariableInput;
  update: NetworkUpdateWithoutStringTemplateVariableInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutTargetRedirectsInput = {
  create: NetworkCreateWithoutTargetRedirectsInput;
  update: NetworkUpdateWithoutTargetRedirectsInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutTaxonomyItemInput = {
  create: NetworkCreateWithoutTaxonomyItemInput;
  update: NetworkUpdateWithoutTaxonomyItemInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutTemplatesInput = {
  create: NetworkCreateWithoutTemplatesInput;
  update: NetworkUpdateWithoutTemplatesInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkUpsertWithoutVerticalsInput = {
  create: NetworkCreateWithoutVerticalsInput;
  update: NetworkUpdateWithoutVerticalsInput;
  where?: InputMaybe<NetworkWhereInput>;
};

export type NetworkWhereInput = {
  AND?: InputMaybe<Array<NetworkWhereInput>>;
  Author?: InputMaybe<AuthorListRelationFilter>;
  ContentItem?: InputMaybe<ContentItemListRelationFilter>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemListRelationFilter>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleListRelationFilter>;
  MediaItem?: InputMaybe<MediaItemListRelationFilter>;
  NOT?: InputMaybe<Array<NetworkWhereInput>>;
  OR?: InputMaybe<Array<NetworkWhereInput>>;
  Product?: InputMaybe<ProductListRelationFilter>;
  Provider?: InputMaybe<ProviderListRelationFilter>;
  Ranking?: InputMaybe<RankingWhereInput>;
  StringTemplate?: InputMaybe<StringTemplateListRelationFilter>;
  TaxonomyItem?: InputMaybe<TaxonomyItemListRelationFilter>;
  company?: InputMaybe<CompanyWhereInput>;
  companyId?: InputMaybe<StringNullableFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  menus?: InputMaybe<MenuListRelationFilter>;
  productPools?: InputMaybe<ProductPoolListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  providerPools?: InputMaybe<ProviderPoolListRelationFilter>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionListRelationFilter>;
  routeResourcePools?: InputMaybe<RouteResourcePoolListRelationFilter>;
  routeResources?: InputMaybe<RouteResourceListRelationFilter>;
  sourceRedirects?: InputMaybe<RedirectListRelationFilter>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableListRelationFilter>;
  targetRedirects?: InputMaybe<RedirectListRelationFilter>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolListRelationFilter>;
  templates?: InputMaybe<TemplateListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verticals?: InputMaybe<VerticalListRelationFilter>;
};

export type NetworkWhereUniqueInput = {
  AND?: InputMaybe<Array<NetworkWhereInput>>;
  Author?: InputMaybe<AuthorListRelationFilter>;
  ContentItem?: InputMaybe<ContentItemListRelationFilter>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemListRelationFilter>;
  FilterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleListRelationFilter>;
  MediaItem?: InputMaybe<MediaItemListRelationFilter>;
  NOT?: InputMaybe<Array<NetworkWhereInput>>;
  OR?: InputMaybe<Array<NetworkWhereInput>>;
  Product?: InputMaybe<ProductListRelationFilter>;
  Provider?: InputMaybe<ProviderListRelationFilter>;
  Ranking?: InputMaybe<RankingWhereInput>;
  StringTemplate?: InputMaybe<StringTemplateListRelationFilter>;
  TaxonomyItem?: InputMaybe<TaxonomyItemListRelationFilter>;
  company?: InputMaybe<CompanyWhereInput>;
  companyId?: InputMaybe<StringNullableFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuListRelationFilter>;
  productPools?: InputMaybe<ProductPoolListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  providerPools?: InputMaybe<ProviderPoolListRelationFilter>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionListRelationFilter>;
  routeResourcePools?: InputMaybe<RouteResourcePoolListRelationFilter>;
  routeResources?: InputMaybe<RouteResourceListRelationFilter>;
  sourceRedirects?: InputMaybe<RedirectListRelationFilter>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableListRelationFilter>;
  targetRedirects?: InputMaybe<RedirectListRelationFilter>;
  taxonomyItemPools?: InputMaybe<TaxonomyItemPoolListRelationFilter>;
  templates?: InputMaybe<TemplateListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verticals?: InputMaybe<VerticalListRelationFilter>;
};

export type NewResourceCounts = {
  __typename?: 'NewResourceCounts';
  providersCount: Scalars['Int']['output'];
  taxonomyItemsCount: Scalars['Int']['output'];
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableEnumDisplayTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DisplayType>;
};

export type NullableEnumRouteResourceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<RouteResourceType>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Page = {
  __typename?: 'Page';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['Json']['output']>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vertical?: Maybe<Vertical>;
};


export type PageContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type PageHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type PagePropertiesArgs = {
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type PageUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type Plugin = {
  __typename?: 'Plugin';
  author?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Post = {
  __typename?: 'Post';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['Json']['output']>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vertical?: Maybe<Vertical>;
};


export type PostContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type PostHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type PostPropertiesArgs = {
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type PostCreateManyVerticalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostCreateManyVerticalInputEnvelope = {
  data?: InputMaybe<Array<PostCreateManyVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostCreateNestedManyWithoutTaxonomiesInput = {
  connect?: InputMaybe<Array<PostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PostCreateOrConnectWithoutTaxonomiesInput>>;
  create?: InputMaybe<Array<PostCreateWithoutTaxonomiesInput>>;
};

export type PostCreateNestedManyWithoutVerticalInput = {
  connect?: InputMaybe<Array<PostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PostCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<PostCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<PostCreateManyVerticalInputEnvelope>;
};

export type PostCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<PostCreateWithoutContentInput>;
};

export type PostCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<PostCreateWithoutPropertiesInput>;
};

export type PostCreateOrConnectWithoutContentInput = {
  create: PostCreateWithoutContentInput;
  where: PostWhereUniqueInput;
};

export type PostCreateOrConnectWithoutPropertiesInput = {
  create: PostCreateWithoutPropertiesInput;
  where: PostWhereUniqueInput;
};

export type PostCreateOrConnectWithoutTaxonomiesInput = {
  create: PostCreateWithoutTaxonomiesInput;
  where: PostWhereUniqueInput;
};

export type PostCreateOrConnectWithoutVerticalInput = {
  create: PostCreateWithoutVerticalInput;
  where: PostWhereUniqueInput;
};

export type PostCreateWithoutContentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutPostInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutPostsInput>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutPostInput>;
};

export type PostCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutPostInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutPostsInput>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutPostInput>;
};

export type PostCreateWithoutTaxonomiesInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutPostInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutPostInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutPostInput>;
};

export type PostCreateWithoutVerticalInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutPostInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutPostInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutPostsInput>;
  type?: InputMaybe<PostType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PostListRelationFilter = {
  every?: InputMaybe<PostWhereInput>;
  none?: InputMaybe<PostWhereInput>;
  some?: InputMaybe<PostWhereInput>;
};

export type PostOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PostOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  publishedAt?: InputMaybe<SortOrderInput>;
  taxonomies?: InputMaybe<TaxonomyItemOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  verticalId?: InputMaybe<SortOrderInput>;
};

export type PostScalarWhereInput = {
  AND?: InputMaybe<Array<PostScalarWhereInput>>;
  NOT?: InputMaybe<Array<PostScalarWhereInput>>;
  OR?: InputMaybe<Array<PostScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  type?: InputMaybe<EnumPostTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export enum PostType {
  Page = 'PAGE',
  Post = 'POST'
}

export type PostUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumPostTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PostUpdateManyWithWhereWithoutTaxonomiesInput = {
  data: PostUpdateManyMutationInput;
  where: PostScalarWhereInput;
};

export type PostUpdateManyWithWhereWithoutVerticalInput = {
  data: PostUpdateManyMutationInput;
  where: PostScalarWhereInput;
};

export type PostUpdateManyWithoutTaxonomiesNestedInput = {
  connect?: InputMaybe<Array<PostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PostCreateOrConnectWithoutTaxonomiesInput>>;
  create?: InputMaybe<Array<PostCreateWithoutTaxonomiesInput>>;
  delete?: InputMaybe<Array<PostWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PostScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PostWhereUniqueInput>>;
  set?: InputMaybe<Array<PostWhereUniqueInput>>;
  update?: InputMaybe<Array<PostUpdateWithWhereUniqueWithoutTaxonomiesInput>>;
  updateMany?: InputMaybe<Array<PostUpdateManyWithWhereWithoutTaxonomiesInput>>;
  upsert?: InputMaybe<Array<PostUpsertWithWhereUniqueWithoutTaxonomiesInput>>;
};

export type PostUpdateManyWithoutVerticalNestedInput = {
  connect?: InputMaybe<Array<PostWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PostCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<PostCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<PostCreateManyVerticalInputEnvelope>;
  delete?: InputMaybe<Array<PostWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PostScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PostWhereUniqueInput>>;
  set?: InputMaybe<Array<PostWhereUniqueInput>>;
  update?: InputMaybe<Array<PostUpdateWithWhereUniqueWithoutVerticalInput>>;
  updateMany?: InputMaybe<Array<PostUpdateManyWithWhereWithoutVerticalInput>>;
  upsert?: InputMaybe<Array<PostUpsertWithWhereUniqueWithoutVerticalInput>>;
};

export type PostUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<PostCreateWithoutContentInput>;
  delete?: InputMaybe<PostWhereInput>;
  disconnect?: InputMaybe<PostWhereInput>;
  update?: InputMaybe<PostUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<PostUpsertWithoutContentInput>;
};

export type PostUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<PostWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PostCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<PostCreateWithoutPropertiesInput>;
  delete?: InputMaybe<PostWhereInput>;
  disconnect?: InputMaybe<PostWhereInput>;
  update?: InputMaybe<PostUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<PostUpsertWithoutPropertiesInput>;
};

export type PostUpdateToOneWithWhereWithoutContentInput = {
  data: PostUpdateWithoutContentInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostUpdateToOneWithWhereWithoutPropertiesInput = {
  data: PostUpdateWithoutPropertiesInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostUpdateWithWhereUniqueWithoutTaxonomiesInput = {
  data: PostUpdateWithoutTaxonomiesInput;
  where: PostWhereUniqueInput;
};

export type PostUpdateWithWhereUniqueWithoutVerticalInput = {
  data: PostUpdateWithoutVerticalInput;
  where: PostWhereUniqueInput;
};

export type PostUpdateWithoutContentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutPostNestedInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutPostsNestedInput>;
  type?: InputMaybe<EnumPostTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutPostNestedInput>;
};

export type PostUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutPostNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutPostsNestedInput>;
  type?: InputMaybe<EnumPostTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutPostNestedInput>;
};

export type PostUpdateWithoutTaxonomiesInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutPostNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutPostNestedInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumPostTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutPostNestedInput>;
};

export type PostUpdateWithoutVerticalInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutPostNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutPostNestedInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutPostsNestedInput>;
  type?: InputMaybe<EnumPostTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PostUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type PostUpsertWithWhereUniqueWithoutTaxonomiesInput = {
  create: PostCreateWithoutTaxonomiesInput;
  update: PostUpdateWithoutTaxonomiesInput;
  where: PostWhereUniqueInput;
};

export type PostUpsertWithWhereUniqueWithoutVerticalInput = {
  create: PostCreateWithoutVerticalInput;
  update: PostUpdateWithoutVerticalInput;
  where: PostWhereUniqueInput;
};

export type PostUpsertWithoutContentInput = {
  create: PostCreateWithoutContentInput;
  update: PostUpdateWithoutContentInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostUpsertWithoutPropertiesInput = {
  create: PostCreateWithoutPropertiesInput;
  update: PostUpdateWithoutPropertiesInput;
  where?: InputMaybe<PostWhereInput>;
};

export type PostWhereInput = {
  AND?: InputMaybe<Array<PostWhereInput>>;
  NOT?: InputMaybe<Array<PostWhereInput>>;
  OR?: InputMaybe<Array<PostWhereInput>>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  taxonomies?: InputMaybe<TaxonomyItemListRelationFilter>;
  type?: InputMaybe<EnumPostTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type PostWhereUniqueInput = {
  AND?: InputMaybe<Array<PostWhereInput>>;
  NOT?: InputMaybe<Array<PostWhereInput>>;
  OR?: InputMaybe<Array<PostWhereInput>>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  taxonomies?: InputMaybe<TaxonomyItemListRelationFilter>;
  type?: InputMaybe<EnumPostTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type Product = {
  __typename?: 'Product';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['Json']['output']>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Network>;
  pools?: Maybe<Array<Maybe<ProductPool>>>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  resourceType?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProductContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type ProductHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductPropertiesArgs = {
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type ProductCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<ProductCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ProductCreateManyNetworkInputEnvelope>;
};

export type ProductCreateNestedManyWithoutPoolsInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutPoolsInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutPoolsInput>>;
};

export type ProductCreateNestedManyWithoutProvidersInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutProvidersInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutProvidersInput>>;
};

export type ProductCreateNestedManyWithoutTaxonomiesInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutTaxonomiesInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutTaxonomiesInput>>;
};

export type ProductCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<ProductCreateWithoutContentInput>;
};

export type ProductCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<ProductCreateWithoutPropertiesInput>;
};

export type ProductCreateOrConnectWithoutContentInput = {
  create: ProductCreateWithoutContentInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutNetworkInput = {
  create: ProductCreateWithoutNetworkInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutPoolsInput = {
  create: ProductCreateWithoutPoolsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutPropertiesInput = {
  create: ProductCreateWithoutPropertiesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutProvidersInput = {
  create: ProductCreateWithoutProvidersInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutTaxonomiesInput = {
  create: ProductCreateWithoutTaxonomiesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutContentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProductInput>;
  pools?: InputMaybe<ProductPoolCreateNestedManyWithoutProductsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProductInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutProductsInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProductsInput>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCreateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pools?: InputMaybe<ProductPoolCreateNestedManyWithoutProductsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProductInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutProductsInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProductsInput>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCreateWithoutPoolsInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProductInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProductInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutProductsInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProductsInput>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProductInput>;
  pools?: InputMaybe<ProductPoolCreateNestedManyWithoutProductsInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutProductsInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProductsInput>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCreateWithoutProvidersInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProductInput>;
  pools?: InputMaybe<ProductPoolCreateNestedManyWithoutProductsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProductInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProductsInput>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCreateWithoutTaxonomiesInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProductInput>;
  pools?: InputMaybe<ProductPoolCreateNestedManyWithoutProductsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProductInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutProductsInput>;
  type: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductListRelationFilter = {
  every?: InputMaybe<ProductWhereInput>;
  none?: InputMaybe<ProductWhereInput>;
  some?: InputMaybe<ProductWhereInput>;
};

export type ProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  pools?: InputMaybe<ProductPoolOrderByRelationAggregateInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  providers?: InputMaybe<ProviderOrderByRelationAggregateInput>;
  taxonomies?: InputMaybe<TaxonomyItemOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductPool = {
  __typename?: 'ProductPool';
  createdBy?: Maybe<User>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  networks?: Maybe<Array<Maybe<Network>>>;
  products?: Maybe<Array<Maybe<Product>>>;
};


export type ProductPoolHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPoolCreateNestedManyWithoutNetworksInput = {
  connect?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPoolCreateOrConnectWithoutNetworksInput>>;
  create?: InputMaybe<Array<ProductPoolCreateWithoutNetworksInput>>;
};

export type ProductPoolCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPoolCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<ProductPoolCreateWithoutProductsInput>>;
};

export type ProductPoolCreateOrConnectWithoutNetworksInput = {
  create: ProductPoolCreateWithoutNetworksInput;
  where: ProductPoolWhereUniqueInput;
};

export type ProductPoolCreateOrConnectWithoutProductsInput = {
  create: ProductPoolCreateWithoutProductsInput;
  where: ProductPoolWhereUniqueInput;
};

export type ProductPoolCreateWithoutNetworksInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  products?: InputMaybe<ProductCreateNestedManyWithoutPoolsInput>;
};

export type ProductPoolCreateWithoutProductsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  networks?: InputMaybe<NetworkCreateNestedManyWithoutProductPoolsInput>;
};

export type ProductPoolListRelationFilter = {
  every?: InputMaybe<ProductPoolWhereInput>;
  none?: InputMaybe<ProductPoolWhereInput>;
  some?: InputMaybe<ProductPoolWhereInput>;
};

export type ProductPoolOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductPoolScalarWhereInput = {
  AND?: InputMaybe<Array<ProductPoolScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductPoolScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductPoolScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ProductPoolUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductPoolUpdateManyWithWhereWithoutNetworksInput = {
  data: ProductPoolUpdateManyMutationInput;
  where: ProductPoolScalarWhereInput;
};

export type ProductPoolUpdateManyWithWhereWithoutProductsInput = {
  data: ProductPoolUpdateManyMutationInput;
  where: ProductPoolScalarWhereInput;
};

export type ProductPoolUpdateManyWithoutNetworksNestedInput = {
  connect?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPoolCreateOrConnectWithoutNetworksInput>>;
  create?: InputMaybe<Array<ProductPoolCreateWithoutNetworksInput>>;
  delete?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductPoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductPoolUpdateWithWhereUniqueWithoutNetworksInput>>;
  updateMany?: InputMaybe<Array<ProductPoolUpdateManyWithWhereWithoutNetworksInput>>;
  upsert?: InputMaybe<Array<ProductPoolUpsertWithWhereUniqueWithoutNetworksInput>>;
};

export type ProductPoolUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductPoolCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<ProductPoolCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductPoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductPoolWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductPoolUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<ProductPoolUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<ProductPoolUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type ProductPoolUpdateWithWhereUniqueWithoutNetworksInput = {
  data: ProductPoolUpdateWithoutNetworksInput;
  where: ProductPoolWhereUniqueInput;
};

export type ProductPoolUpdateWithWhereUniqueWithoutProductsInput = {
  data: ProductPoolUpdateWithoutProductsInput;
  where: ProductPoolWhereUniqueInput;
};

export type ProductPoolUpdateWithoutNetworksInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductUpdateManyWithoutPoolsNestedInput>;
};

export type ProductPoolUpdateWithoutProductsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  networks?: InputMaybe<NetworkUpdateManyWithoutProductPoolsNestedInput>;
};

export type ProductPoolUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  name: Scalars['String']['input'];
  networks: Array<NetworkWhereUniqueInput>;
  products: Array<ProductWhereUniqueInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type ProductPoolUpsertWithWhereUniqueWithoutNetworksInput = {
  create: ProductPoolCreateWithoutNetworksInput;
  update: ProductPoolUpdateWithoutNetworksInput;
  where: ProductPoolWhereUniqueInput;
};

export type ProductPoolUpsertWithWhereUniqueWithoutProductsInput = {
  create: ProductPoolCreateWithoutProductsInput;
  update: ProductPoolUpdateWithoutProductsInput;
  where: ProductPoolWhereUniqueInput;
};

export type ProductPoolWhereInput = {
  AND?: InputMaybe<Array<ProductPoolWhereInput>>;
  NOT?: InputMaybe<Array<ProductPoolWhereInput>>;
  OR?: InputMaybe<Array<ProductPoolWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
};

export type ProductPoolWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductPoolWhereInput>>;
  NOT?: InputMaybe<Array<ProductPoolWhereInput>>;
  OR?: InputMaybe<Array<ProductPoolWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
};

export type ProductScalarWhereInput = {
  AND?: InputMaybe<Array<ProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateManyWithWhereWithoutNetworkInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithWhereWithoutPoolsInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithWhereWithoutProvidersInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithWhereWithoutTaxonomiesInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ProductCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type ProductUpdateManyWithoutPoolsNestedInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutPoolsInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutPoolsInput>>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutPoolsInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutPoolsInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutPoolsInput>>;
};

export type ProductUpdateManyWithoutProvidersNestedInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutProvidersInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutProvidersInput>>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutProvidersInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutProvidersInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutProvidersInput>>;
};

export type ProductUpdateManyWithoutTaxonomiesNestedInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutTaxonomiesInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutTaxonomiesInput>>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutTaxonomiesInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutTaxonomiesInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutTaxonomiesInput>>;
};

export type ProductUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<ProductCreateWithoutContentInput>;
  delete?: InputMaybe<ProductWhereInput>;
  disconnect?: InputMaybe<ProductWhereInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<ProductUpsertWithoutContentInput>;
};

export type ProductUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<ProductCreateWithoutPropertiesInput>;
  delete?: InputMaybe<ProductWhereInput>;
  disconnect?: InputMaybe<ProductWhereInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutPropertiesInput>;
};

export type ProductUpdateToOneWithWhereWithoutContentInput = {
  data: ProductUpdateWithoutContentInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateToOneWithWhereWithoutPropertiesInput = {
  data: ProductUpdateWithoutPropertiesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateWithWhereUniqueWithoutNetworkInput = {
  data: ProductUpdateWithoutNetworkInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithWhereUniqueWithoutPoolsInput = {
  data: ProductUpdateWithoutPoolsInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithWhereUniqueWithoutProvidersInput = {
  data: ProductUpdateWithoutProvidersInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithWhereUniqueWithoutTaxonomiesInput = {
  data: ProductUpdateWithoutTaxonomiesInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithoutContentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProductNestedInput>;
  pools?: InputMaybe<ProductPoolUpdateManyWithoutProductsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProductNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutProductsNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProductsNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProductNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pools?: InputMaybe<ProductPoolUpdateManyWithoutProductsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProductNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutProductsNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProductsNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutPoolsInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProductNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProductNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProductNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutProductsNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProductsNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProductNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProductNestedInput>;
  pools?: InputMaybe<ProductPoolUpdateManyWithoutProductsNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutProductsNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProductsNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutProvidersInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProductNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProductNestedInput>;
  pools?: InputMaybe<ProductPoolUpdateManyWithoutProductsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProductNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProductsNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutTaxonomiesInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProductNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProductNestedInput>;
  pools?: InputMaybe<ProductPoolUpdateManyWithoutProductsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProductNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutProductsNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
  type: Scalars['String']['input'];
};

export type ProductUpsertWithWhereUniqueWithoutNetworkInput = {
  create: ProductCreateWithoutNetworkInput;
  update: ProductUpdateWithoutNetworkInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithWhereUniqueWithoutPoolsInput = {
  create: ProductCreateWithoutPoolsInput;
  update: ProductUpdateWithoutPoolsInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithWhereUniqueWithoutProvidersInput = {
  create: ProductCreateWithoutProvidersInput;
  update: ProductUpdateWithoutProvidersInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithWhereUniqueWithoutTaxonomiesInput = {
  create: ProductCreateWithoutTaxonomiesInput;
  update: ProductUpdateWithoutTaxonomiesInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithoutContentInput = {
  create: ProductCreateWithoutContentInput;
  update: ProductUpdateWithoutContentInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpsertWithoutPropertiesInput = {
  create: ProductCreateWithoutPropertiesInput;
  update: ProductUpdateWithoutPropertiesInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  pools?: InputMaybe<ProductPoolListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  providers?: InputMaybe<ProviderListRelationFilter>;
  taxonomies?: InputMaybe<TaxonomyItemListRelationFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  pools?: InputMaybe<ProductPoolListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  providers?: InputMaybe<ProviderListRelationFilter>;
  taxonomies?: InputMaybe<TaxonomyItemListRelationFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PropertyItem = {
  __typename?: 'PropertyItem';
  contextId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  field?: Maybe<TemplateField>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  list: Scalars['Boolean']['output'];
  resolvedData?: Maybe<Array<Maybe<ResolvedDataUnion>>>;
  type: FieldType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
};


export type PropertyItemFieldArgs = {
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type PropertyItemCreateInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyAuthorInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyAuthorInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyAuthorInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyFieldInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyFieldInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyFieldInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyFilterTaxonomyItemInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyFilterTaxonomyItemInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyFilterTaxonomyItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyFilterTaxonomyRuleInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyFilterTaxonomyRuleInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyFilterTaxonomyRuleInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyMenuItemInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyMenuItemInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyMenuItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyNetworkInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyPostInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyPostInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyPostInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyProductInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyProductInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyProductInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyProviderInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyProviderInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyProviderInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyProviderTaxonomyConnectionInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyProviderTaxonomyConnectionInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyProviderTaxonomyConnectionInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyRouteResourceInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyRouteResourceInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyRouteResourceInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManySiteInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManySiteInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManySiteInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyStringTemplateInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyStringTemplateInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyStringTemplateInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyStringTemplateVariableInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyStringTemplateVariableInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyStringTemplateVariableInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyTaxonomyItemInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyTaxonomyItemInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyTaxonomyItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyTemplateInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyTemplateInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyTemplateInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateManyVerticalInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  fieldId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  filterTaxonomyRuleId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItemId?: InputMaybe<Scalars['String']['input']>;
  networkPropertyId?: InputMaybe<Scalars['String']['input']>;
  postId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerTaxonomyConnectionId?: InputMaybe<Scalars['String']['input']>;
  routeResourceId?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateId?: InputMaybe<Scalars['String']['input']>;
  stringTemplateVariableId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateManyVerticalInputEnvelope = {
  data?: InputMaybe<Array<PropertyItemCreateManyVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyItemCreateNestedManyWithoutAuthorInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutAuthorInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutAuthorInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyAuthorInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutFieldInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutFieldInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutFieldInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyFieldInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutFilterTaxonomyItemInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutFilterTaxonomyItemInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutFilterTaxonomyItemInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyFilterTaxonomyItemInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutFilterTaxonomyRuleInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutFilterTaxonomyRuleInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutFilterTaxonomyRuleInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyFilterTaxonomyRuleInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutMenuItemInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutMenuItemInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutMenuItemInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyMenuItemInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyNetworkInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutPostInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutPostInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyPostInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyProductInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutProviderInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutProviderInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyProviderInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutProviderTaxonomyConnectionInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutProviderTaxonomyConnectionInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutProviderTaxonomyConnectionInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyProviderTaxonomyConnectionInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutRouteResourceInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutRouteResourceInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutRouteResourceInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyRouteResourceInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutSiteInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutSiteInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutSiteInput>>;
  createMany?: InputMaybe<PropertyItemCreateManySiteInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutStringTemplateInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutStringTemplateInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutStringTemplateInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyStringTemplateInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutStringTemplateVariableInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutStringTemplateVariableInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutStringTemplateVariableInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyStringTemplateVariableInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutTaxonomyItemInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutTaxonomyItemInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutTaxonomyItemInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyTaxonomyItemInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyTemplateInputEnvelope>;
};

export type PropertyItemCreateNestedManyWithoutVerticalInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyVerticalInputEnvelope>;
};

export type PropertyItemCreateOrConnectWithoutAuthorInput = {
  create: PropertyItemCreateWithoutAuthorInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutFieldInput = {
  create: PropertyItemCreateWithoutFieldInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutFilterTaxonomyItemInput = {
  create: PropertyItemCreateWithoutFilterTaxonomyItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutFilterTaxonomyRuleInput = {
  create: PropertyItemCreateWithoutFilterTaxonomyRuleInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutMenuItemInput = {
  create: PropertyItemCreateWithoutMenuItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutNetworkInput = {
  create: PropertyItemCreateWithoutNetworkInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutPostInput = {
  create: PropertyItemCreateWithoutPostInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutProductInput = {
  create: PropertyItemCreateWithoutProductInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutProviderInput = {
  create: PropertyItemCreateWithoutProviderInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutProviderTaxonomyConnectionInput = {
  create: PropertyItemCreateWithoutProviderTaxonomyConnectionInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutRouteResourceInput = {
  create: PropertyItemCreateWithoutRouteResourceInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutSiteInput = {
  create: PropertyItemCreateWithoutSiteInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutStringTemplateInput = {
  create: PropertyItemCreateWithoutStringTemplateInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutStringTemplateVariableInput = {
  create: PropertyItemCreateWithoutStringTemplateVariableInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutTaxonomyItemInput = {
  create: PropertyItemCreateWithoutTaxonomyItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutTemplateInput = {
  create: PropertyItemCreateWithoutTemplateInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateOrConnectWithoutVerticalInput = {
  create: PropertyItemCreateWithoutVerticalInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemCreateWithoutAuthorInput = {
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutFieldInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutFilterTaxonomyItemInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutFilterTaxonomyRuleInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutMenuItemInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutNetworkInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutPostInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutProductInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutProviderInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutProviderTaxonomyConnectionInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutRouteResourceInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutSiteInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutStringTemplateInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutStringTemplateVariableInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutTaxonomyItemInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutTemplateInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  Vertical?: InputMaybe<VerticalCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemCreateWithoutVerticalInput = {
  Author?: InputMaybe<AuthorCreateNestedOneWithoutPropertiesInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  Network?: InputMaybe<NetworkCreateNestedOneWithoutPropertiesInput>;
  RouteResource?: InputMaybe<RouteResourceCreateNestedOneWithoutPropertiesInput>;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data: Scalars['Json']['input'];
  field?: InputMaybe<TemplateFieldCreateNestedOneWithoutPropertyItemsInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleCreateNestedOneWithoutPropertiesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  menuItem?: InputMaybe<MenuItemCreateNestedOneWithoutPropertiesInput>;
  post?: InputMaybe<PostCreateNestedOneWithoutPropertiesInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPropertiesInput>;
  provider?: InputMaybe<ProviderCreateNestedOneWithoutPropertiesInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput>;
  site?: InputMaybe<SiteCreateNestedOneWithoutPropertiesInput>;
  stringTemplate?: InputMaybe<StringTemplateCreateNestedOneWithoutPropertiesInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableCreateNestedOneWithoutPropertiesInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemCreateNestedOneWithoutPropertiesInput>;
  template?: InputMaybe<TemplateCreateNestedOneWithoutPropertiesInput>;
  type: FieldType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyItemListRelationFilter = {
  every?: InputMaybe<PropertyItemWhereInput>;
  none?: InputMaybe<PropertyItemWhereInput>;
  some?: InputMaybe<PropertyItemWhereInput>;
};

export type PropertyItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PropertyItemOrderByWithRelationInput = {
  Author?: InputMaybe<AuthorOrderByWithRelationInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemOrderByWithRelationInput>;
  Network?: InputMaybe<NetworkOrderByWithRelationInput>;
  RouteResource?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  Vertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  authorId?: InputMaybe<SortOrderInput>;
  contextId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  field?: InputMaybe<TemplateFieldOrderByWithRelationInput>;
  fieldId?: InputMaybe<SortOrderInput>;
  filterTaxonomyItemId?: InputMaybe<SortOrderInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleOrderByWithRelationInput>;
  filterTaxonomyRuleId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  list?: InputMaybe<SortOrder>;
  menuItem?: InputMaybe<MenuItemOrderByWithRelationInput>;
  menuItemId?: InputMaybe<SortOrderInput>;
  networkPropertyId?: InputMaybe<SortOrderInput>;
  post?: InputMaybe<PostOrderByWithRelationInput>;
  postId?: InputMaybe<SortOrderInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrderInput>;
  provider?: InputMaybe<ProviderOrderByWithRelationInput>;
  providerId?: InputMaybe<SortOrderInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionOrderByWithRelationInput>;
  providerTaxonomyConnectionId?: InputMaybe<SortOrderInput>;
  routeResourceId?: InputMaybe<SortOrderInput>;
  site?: InputMaybe<SiteOrderByWithRelationInput>;
  siteId?: InputMaybe<SortOrderInput>;
  stringTemplate?: InputMaybe<StringTemplateOrderByWithRelationInput>;
  stringTemplateId?: InputMaybe<SortOrderInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableOrderByWithRelationInput>;
  stringTemplateVariableId?: InputMaybe<SortOrderInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemOrderByWithRelationInput>;
  taxonomyItemId?: InputMaybe<SortOrderInput>;
  template?: InputMaybe<TemplateOrderByWithRelationInput>;
  templateId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrder>;
  verticalId?: InputMaybe<SortOrderInput>;
};

export type PropertyItemScalarWhereInput = {
  AND?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  OR?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  authorId?: InputMaybe<StringNullableFilter>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyItemId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  networkPropertyId?: InputMaybe<StringNullableFilter>;
  postId?: InputMaybe<StringNullableFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  providerId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  routeResourceId?: InputMaybe<StringNullableFilter>;
  siteId?: InputMaybe<StringNullableFilter>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  taxonomyItemId?: InputMaybe<StringNullableFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumFieldTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type PropertyItemUpdateInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateManyMutationInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateManyWithWhereWithoutAuthorInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutFieldInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutFilterTaxonomyItemInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutFilterTaxonomyRuleInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutMenuItemInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutNetworkInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutPostInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutProductInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutProviderInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutProviderTaxonomyConnectionInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutRouteResourceInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutSiteInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutStringTemplateInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutStringTemplateVariableInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutTaxonomyItemInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutTemplateInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithWhereWithoutVerticalInput = {
  data: PropertyItemUpdateManyMutationInput;
  where: PropertyItemScalarWhereInput;
};

export type PropertyItemUpdateManyWithoutAuthorNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutAuthorInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutAuthorInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyAuthorInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutAuthorInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutAuthorInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutAuthorInput>>;
};

export type PropertyItemUpdateManyWithoutFieldNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutFieldInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutFieldInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyFieldInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutFieldInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutFieldInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutFieldInput>>;
};

export type PropertyItemUpdateManyWithoutFilterTaxonomyItemNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutFilterTaxonomyItemInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutFilterTaxonomyItemInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyFilterTaxonomyItemInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutFilterTaxonomyItemInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutFilterTaxonomyItemInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutFilterTaxonomyItemInput>>;
};

export type PropertyItemUpdateManyWithoutFilterTaxonomyRuleNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutFilterTaxonomyRuleInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutFilterTaxonomyRuleInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyFilterTaxonomyRuleInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutFilterTaxonomyRuleInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutFilterTaxonomyRuleInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutFilterTaxonomyRuleInput>>;
};

export type PropertyItemUpdateManyWithoutMenuItemNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutMenuItemInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutMenuItemInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyMenuItemInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutMenuItemInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutMenuItemInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutMenuItemInput>>;
};

export type PropertyItemUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type PropertyItemUpdateManyWithoutPostNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutPostInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutPostInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyPostInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutPostInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutPostInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutPostInput>>;
};

export type PropertyItemUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutProductInput>>;
};

export type PropertyItemUpdateManyWithoutProviderNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutProviderInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyProviderInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutProviderInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutProviderInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutProviderInput>>;
};

export type PropertyItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutProviderTaxonomyConnectionInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutProviderTaxonomyConnectionInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyProviderTaxonomyConnectionInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutProviderTaxonomyConnectionInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutProviderTaxonomyConnectionInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutProviderTaxonomyConnectionInput>>;
};

export type PropertyItemUpdateManyWithoutRouteResourceNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutRouteResourceInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutRouteResourceInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyRouteResourceInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutRouteResourceInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutRouteResourceInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutRouteResourceInput>>;
};

export type PropertyItemUpdateManyWithoutSiteNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutSiteInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutSiteInput>>;
  createMany?: InputMaybe<PropertyItemCreateManySiteInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutSiteInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutSiteInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutSiteInput>>;
};

export type PropertyItemUpdateManyWithoutStringTemplateNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutStringTemplateInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutStringTemplateInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyStringTemplateInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutStringTemplateInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutStringTemplateInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutStringTemplateInput>>;
};

export type PropertyItemUpdateManyWithoutStringTemplateVariableNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutStringTemplateVariableInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutStringTemplateVariableInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyStringTemplateVariableInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutStringTemplateVariableInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutStringTemplateVariableInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutStringTemplateVariableInput>>;
};

export type PropertyItemUpdateManyWithoutTaxonomyItemNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutTaxonomyItemInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutTaxonomyItemInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyTaxonomyItemInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutTaxonomyItemInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutTaxonomyItemInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutTaxonomyItemInput>>;
};

export type PropertyItemUpdateManyWithoutTemplateNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type PropertyItemUpdateManyWithoutVerticalNestedInput = {
  connect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PropertyItemCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<PropertyItemCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<PropertyItemCreateManyVerticalInputEnvelope>;
  delete?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PropertyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<PropertyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<PropertyItemUpdateWithWhereUniqueWithoutVerticalInput>>;
  updateMany?: InputMaybe<Array<PropertyItemUpdateManyWithWhereWithoutVerticalInput>>;
  upsert?: InputMaybe<Array<PropertyItemUpsertWithWhereUniqueWithoutVerticalInput>>;
};

export type PropertyItemUpdateWithWhereUniqueWithoutAuthorInput = {
  data: PropertyItemUpdateWithoutAuthorInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutFieldInput = {
  data: PropertyItemUpdateWithoutFieldInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutFilterTaxonomyItemInput = {
  data: PropertyItemUpdateWithoutFilterTaxonomyItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutFilterTaxonomyRuleInput = {
  data: PropertyItemUpdateWithoutFilterTaxonomyRuleInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutMenuItemInput = {
  data: PropertyItemUpdateWithoutMenuItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutNetworkInput = {
  data: PropertyItemUpdateWithoutNetworkInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutPostInput = {
  data: PropertyItemUpdateWithoutPostInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutProductInput = {
  data: PropertyItemUpdateWithoutProductInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutProviderInput = {
  data: PropertyItemUpdateWithoutProviderInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutProviderTaxonomyConnectionInput = {
  data: PropertyItemUpdateWithoutProviderTaxonomyConnectionInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutRouteResourceInput = {
  data: PropertyItemUpdateWithoutRouteResourceInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutSiteInput = {
  data: PropertyItemUpdateWithoutSiteInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutStringTemplateInput = {
  data: PropertyItemUpdateWithoutStringTemplateInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutStringTemplateVariableInput = {
  data: PropertyItemUpdateWithoutStringTemplateVariableInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutTaxonomyItemInput = {
  data: PropertyItemUpdateWithoutTaxonomyItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutTemplateInput = {
  data: PropertyItemUpdateWithoutTemplateInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithWhereUniqueWithoutVerticalInput = {
  data: PropertyItemUpdateWithoutVerticalInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpdateWithoutAuthorInput = {
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutFieldInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutFilterTaxonomyItemInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutFilterTaxonomyRuleInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutMenuItemInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutNetworkInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutPostInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutProductInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutProviderInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutProviderTaxonomyConnectionInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutRouteResourceInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutSiteInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutStringTemplateInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutStringTemplateVariableInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutTaxonomyItemInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutTemplateInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  Vertical?: InputMaybe<VerticalUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpdateWithoutVerticalInput = {
  Author?: InputMaybe<AuthorUpdateOneWithoutPropertiesNestedInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  Network?: InputMaybe<NetworkUpdateOneWithoutPropertiesNestedInput>;
  RouteResource?: InputMaybe<RouteResourceUpdateOneWithoutPropertiesNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  field?: InputMaybe<TemplateFieldUpdateOneWithoutPropertyItemsNestedInput>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleUpdateOneWithoutPropertiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menuItem?: InputMaybe<MenuItemUpdateOneWithoutPropertiesNestedInput>;
  post?: InputMaybe<PostUpdateOneWithoutPropertiesNestedInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPropertiesNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneWithoutPropertiesNestedInput>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput>;
  site?: InputMaybe<SiteUpdateOneWithoutPropertiesNestedInput>;
  stringTemplate?: InputMaybe<StringTemplateUpdateOneWithoutPropertiesNestedInput>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableUpdateOneWithoutPropertiesNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneWithoutPropertiesNestedInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutPropertiesNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PropertyItemUpsertWithWhereUniqueWithoutAuthorInput = {
  create: PropertyItemCreateWithoutAuthorInput;
  update: PropertyItemUpdateWithoutAuthorInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutFieldInput = {
  create: PropertyItemCreateWithoutFieldInput;
  update: PropertyItemUpdateWithoutFieldInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutFilterTaxonomyItemInput = {
  create: PropertyItemCreateWithoutFilterTaxonomyItemInput;
  update: PropertyItemUpdateWithoutFilterTaxonomyItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutFilterTaxonomyRuleInput = {
  create: PropertyItemCreateWithoutFilterTaxonomyRuleInput;
  update: PropertyItemUpdateWithoutFilterTaxonomyRuleInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutMenuItemInput = {
  create: PropertyItemCreateWithoutMenuItemInput;
  update: PropertyItemUpdateWithoutMenuItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutNetworkInput = {
  create: PropertyItemCreateWithoutNetworkInput;
  update: PropertyItemUpdateWithoutNetworkInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutPostInput = {
  create: PropertyItemCreateWithoutPostInput;
  update: PropertyItemUpdateWithoutPostInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutProductInput = {
  create: PropertyItemCreateWithoutProductInput;
  update: PropertyItemUpdateWithoutProductInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutProviderInput = {
  create: PropertyItemCreateWithoutProviderInput;
  update: PropertyItemUpdateWithoutProviderInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutProviderTaxonomyConnectionInput = {
  create: PropertyItemCreateWithoutProviderTaxonomyConnectionInput;
  update: PropertyItemUpdateWithoutProviderTaxonomyConnectionInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutRouteResourceInput = {
  create: PropertyItemCreateWithoutRouteResourceInput;
  update: PropertyItemUpdateWithoutRouteResourceInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutSiteInput = {
  create: PropertyItemCreateWithoutSiteInput;
  update: PropertyItemUpdateWithoutSiteInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutStringTemplateInput = {
  create: PropertyItemCreateWithoutStringTemplateInput;
  update: PropertyItemUpdateWithoutStringTemplateInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutStringTemplateVariableInput = {
  create: PropertyItemCreateWithoutStringTemplateVariableInput;
  update: PropertyItemUpdateWithoutStringTemplateVariableInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutTaxonomyItemInput = {
  create: PropertyItemCreateWithoutTaxonomyItemInput;
  update: PropertyItemUpdateWithoutTaxonomyItemInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutTemplateInput = {
  create: PropertyItemCreateWithoutTemplateInput;
  update: PropertyItemUpdateWithoutTemplateInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemUpsertWithWhereUniqueWithoutVerticalInput = {
  create: PropertyItemCreateWithoutVerticalInput;
  update: PropertyItemUpdateWithoutVerticalInput;
  where: PropertyItemWhereUniqueInput;
};

export type PropertyItemWhereInput = {
  AND?: InputMaybe<Array<PropertyItemWhereInput>>;
  Author?: InputMaybe<AuthorWhereInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemWhereInput>;
  NOT?: InputMaybe<Array<PropertyItemWhereInput>>;
  Network?: InputMaybe<NetworkWhereInput>;
  OR?: InputMaybe<Array<PropertyItemWhereInput>>;
  RouteResource?: InputMaybe<RouteResourceWhereInput>;
  Vertical?: InputMaybe<VerticalWhereInput>;
  authorId?: InputMaybe<StringNullableFilter>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  field?: InputMaybe<TemplateFieldWhereInput>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyItemId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  menuItem?: InputMaybe<MenuItemWhereInput>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  networkPropertyId?: InputMaybe<StringNullableFilter>;
  post?: InputMaybe<PostWhereInput>;
  postId?: InputMaybe<StringNullableFilter>;
  product?: InputMaybe<ProductWhereInput>;
  productId?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<ProviderWhereInput>;
  providerId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  routeResourceId?: InputMaybe<StringNullableFilter>;
  site?: InputMaybe<SiteWhereInput>;
  siteId?: InputMaybe<StringNullableFilter>;
  stringTemplate?: InputMaybe<StringTemplateWhereInput>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableWhereInput>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  taxonomyItem?: InputMaybe<TaxonomyItemWhereInput>;
  taxonomyItemId?: InputMaybe<StringNullableFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumFieldTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type PropertyItemWhereUniqueInput = {
  AND?: InputMaybe<Array<PropertyItemWhereInput>>;
  Author?: InputMaybe<AuthorWhereInput>;
  FilterTaxonomyItem?: InputMaybe<FilterTaxonomyItemWhereInput>;
  NOT?: InputMaybe<Array<PropertyItemWhereInput>>;
  Network?: InputMaybe<NetworkWhereInput>;
  OR?: InputMaybe<Array<PropertyItemWhereInput>>;
  RouteResource?: InputMaybe<RouteResourceWhereInput>;
  Vertical?: InputMaybe<VerticalWhereInput>;
  authorId?: InputMaybe<StringNullableFilter>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonFilter>;
  field?: InputMaybe<TemplateFieldWhereInput>;
  fieldId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyItemId?: InputMaybe<StringNullableFilter>;
  filterTaxonomyRule?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  filterTaxonomyRuleId?: InputMaybe<StringNullableFilter>;
  id: Scalars['String']['input'];
  key?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  menuItem?: InputMaybe<MenuItemWhereInput>;
  menuItemId?: InputMaybe<StringNullableFilter>;
  networkPropertyId?: InputMaybe<StringNullableFilter>;
  post?: InputMaybe<PostWhereInput>;
  postId?: InputMaybe<StringNullableFilter>;
  product?: InputMaybe<ProductWhereInput>;
  productId?: InputMaybe<StringNullableFilter>;
  provider?: InputMaybe<ProviderWhereInput>;
  providerId?: InputMaybe<StringNullableFilter>;
  providerTaxonomyConnection?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  providerTaxonomyConnectionId?: InputMaybe<StringNullableFilter>;
  routeResourceId?: InputMaybe<StringNullableFilter>;
  site?: InputMaybe<SiteWhereInput>;
  siteId?: InputMaybe<StringNullableFilter>;
  stringTemplate?: InputMaybe<StringTemplateWhereInput>;
  stringTemplateId?: InputMaybe<StringNullableFilter>;
  stringTemplateVariable?: InputMaybe<StringTemplateVariableWhereInput>;
  stringTemplateVariableId?: InputMaybe<StringNullableFilter>;
  taxonomyItem?: InputMaybe<TaxonomyItemWhereInput>;
  taxonomyItemId?: InputMaybe<StringNullableFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumFieldTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type Provider = {
  __typename?: 'Provider';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['Json']['output']>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  pools?: Maybe<Array<Maybe<ProviderPool>>>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  resourceType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProviderContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type ProviderHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderPropertiesArgs = {
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type ProviderCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<ProviderCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ProviderCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ProviderCreateManyNetworkInputEnvelope>;
};

export type ProviderCreateNestedManyWithoutPoolsInput = {
  connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderCreateOrConnectWithoutPoolsInput>>;
  create?: InputMaybe<Array<ProviderCreateWithoutPoolsInput>>;
};

export type ProviderCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<ProviderCreateWithoutProductsInput>>;
};

export type ProviderCreateNestedManyWithoutTaxonomiesInput = {
  connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderCreateOrConnectWithoutTaxonomiesInput>>;
  create?: InputMaybe<Array<ProviderCreateWithoutTaxonomiesInput>>;
};

export type ProviderCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<ProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<ProviderCreateWithoutContentInput>;
};

export type ProviderCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<ProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<ProviderCreateWithoutPropertiesInput>;
};

export type ProviderCreateNestedOneWithoutProviderTaxonomyConnectionsInput = {
  connect?: InputMaybe<ProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderTaxonomyConnectionsInput>;
  create?: InputMaybe<ProviderCreateWithoutProviderTaxonomyConnectionsInput>;
};

export type ProviderCreateOrConnectWithoutContentInput = {
  create: ProviderCreateWithoutContentInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutNetworkInput = {
  create: ProviderCreateWithoutNetworkInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutPoolsInput = {
  create: ProviderCreateWithoutPoolsInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutProductsInput = {
  create: ProviderCreateWithoutProductsInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutPropertiesInput = {
  create: ProviderCreateWithoutPropertiesInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutProviderTaxonomyConnectionsInput = {
  create: ProviderCreateWithoutProviderTaxonomyConnectionsInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderCreateOrConnectWithoutTaxonomiesInput = {
  create: ProviderCreateWithoutTaxonomiesInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderCreateWithoutContentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderInput>;
  pools?: InputMaybe<ProviderPoolCreateNestedManyWithoutProvidersInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutProvidersInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutProviderInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProvidersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderCreateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProviderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  pools?: InputMaybe<ProviderPoolCreateNestedManyWithoutProvidersInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutProvidersInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutProviderInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProvidersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderCreateWithoutPoolsInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProviderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutProvidersInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutProviderInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProvidersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderCreateWithoutProductsInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProviderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderInput>;
  pools?: InputMaybe<ProviderPoolCreateNestedManyWithoutProvidersInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutProviderInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProvidersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProviderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderInput>;
  pools?: InputMaybe<ProviderPoolCreateNestedManyWithoutProvidersInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutProvidersInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutProviderInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProvidersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderCreateWithoutProviderTaxonomyConnectionsInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProviderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderInput>;
  pools?: InputMaybe<ProviderPoolCreateNestedManyWithoutProvidersInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutProvidersInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderInput>;
  taxonomies?: InputMaybe<TaxonomyItemCreateNestedManyWithoutProvidersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderCreateWithoutTaxonomiesInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutProviderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderInput>;
  pools?: InputMaybe<ProviderPoolCreateNestedManyWithoutProvidersInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutProvidersInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutProviderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderListRelationFilter = {
  every?: InputMaybe<ProviderWhereInput>;
  none?: InputMaybe<ProviderWhereInput>;
  some?: InputMaybe<ProviderWhereInput>;
};

export type ProviderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProviderOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  pools?: InputMaybe<ProviderPoolOrderByRelationAggregateInput>;
  products?: InputMaybe<ProductOrderByRelationAggregateInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionOrderByRelationAggregateInput>;
  taxonomies?: InputMaybe<TaxonomyItemOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderPool = {
  __typename?: 'ProviderPool';
  createdBy?: Maybe<User>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  networks?: Maybe<Array<Maybe<Network>>>;
  providers?: Maybe<Array<Maybe<Provider>>>;
};


export type ProviderPoolHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProviderPoolCreateNestedManyWithoutNetworksInput = {
  connect?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderPoolCreateOrConnectWithoutNetworksInput>>;
  create?: InputMaybe<Array<ProviderPoolCreateWithoutNetworksInput>>;
};

export type ProviderPoolCreateNestedManyWithoutProvidersInput = {
  connect?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderPoolCreateOrConnectWithoutProvidersInput>>;
  create?: InputMaybe<Array<ProviderPoolCreateWithoutProvidersInput>>;
};

export type ProviderPoolCreateOrConnectWithoutNetworksInput = {
  create: ProviderPoolCreateWithoutNetworksInput;
  where: ProviderPoolWhereUniqueInput;
};

export type ProviderPoolCreateOrConnectWithoutProvidersInput = {
  create: ProviderPoolCreateWithoutProvidersInput;
  where: ProviderPoolWhereUniqueInput;
};

export type ProviderPoolCreateWithoutNetworksInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  providers?: InputMaybe<ProviderCreateNestedManyWithoutPoolsInput>;
};

export type ProviderPoolCreateWithoutProvidersInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  networks?: InputMaybe<NetworkCreateNestedManyWithoutProviderPoolsInput>;
};

export type ProviderPoolListRelationFilter = {
  every?: InputMaybe<ProviderPoolWhereInput>;
  none?: InputMaybe<ProviderPoolWhereInput>;
  some?: InputMaybe<ProviderPoolWhereInput>;
};

export type ProviderPoolOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProviderPoolScalarWhereInput = {
  AND?: InputMaybe<Array<ProviderPoolScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProviderPoolScalarWhereInput>>;
  OR?: InputMaybe<Array<ProviderPoolScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ProviderPoolUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProviderPoolUpdateManyWithWhereWithoutNetworksInput = {
  data: ProviderPoolUpdateManyMutationInput;
  where: ProviderPoolScalarWhereInput;
};

export type ProviderPoolUpdateManyWithWhereWithoutProvidersInput = {
  data: ProviderPoolUpdateManyMutationInput;
  where: ProviderPoolScalarWhereInput;
};

export type ProviderPoolUpdateManyWithoutNetworksNestedInput = {
  connect?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderPoolCreateOrConnectWithoutNetworksInput>>;
  create?: InputMaybe<Array<ProviderPoolCreateWithoutNetworksInput>>;
  delete?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderPoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderPoolUpdateWithWhereUniqueWithoutNetworksInput>>;
  updateMany?: InputMaybe<Array<ProviderPoolUpdateManyWithWhereWithoutNetworksInput>>;
  upsert?: InputMaybe<Array<ProviderPoolUpsertWithWhereUniqueWithoutNetworksInput>>;
};

export type ProviderPoolUpdateManyWithoutProvidersNestedInput = {
  connect?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderPoolCreateOrConnectWithoutProvidersInput>>;
  create?: InputMaybe<Array<ProviderPoolCreateWithoutProvidersInput>>;
  delete?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderPoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderPoolWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderPoolUpdateWithWhereUniqueWithoutProvidersInput>>;
  updateMany?: InputMaybe<Array<ProviderPoolUpdateManyWithWhereWithoutProvidersInput>>;
  upsert?: InputMaybe<Array<ProviderPoolUpsertWithWhereUniqueWithoutProvidersInput>>;
};

export type ProviderPoolUpdateWithWhereUniqueWithoutNetworksInput = {
  data: ProviderPoolUpdateWithoutNetworksInput;
  where: ProviderPoolWhereUniqueInput;
};

export type ProviderPoolUpdateWithWhereUniqueWithoutProvidersInput = {
  data: ProviderPoolUpdateWithoutProvidersInput;
  where: ProviderPoolWhereUniqueInput;
};

export type ProviderPoolUpdateWithoutNetworksInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutPoolsNestedInput>;
};

export type ProviderPoolUpdateWithoutProvidersInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  networks?: InputMaybe<NetworkUpdateManyWithoutProviderPoolsNestedInput>;
};

export type ProviderPoolUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  name: Scalars['String']['input'];
  networks: Array<NetworkWhereUniqueInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
  providers: Array<ProviderWhereUniqueInput>;
};

export type ProviderPoolUpsertWithWhereUniqueWithoutNetworksInput = {
  create: ProviderPoolCreateWithoutNetworksInput;
  update: ProviderPoolUpdateWithoutNetworksInput;
  where: ProviderPoolWhereUniqueInput;
};

export type ProviderPoolUpsertWithWhereUniqueWithoutProvidersInput = {
  create: ProviderPoolCreateWithoutProvidersInput;
  update: ProviderPoolUpdateWithoutProvidersInput;
  where: ProviderPoolWhereUniqueInput;
};

export type ProviderPoolWhereInput = {
  AND?: InputMaybe<Array<ProviderPoolWhereInput>>;
  NOT?: InputMaybe<Array<ProviderPoolWhereInput>>;
  OR?: InputMaybe<Array<ProviderPoolWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  providers?: InputMaybe<ProviderListRelationFilter>;
};

export type ProviderPoolWhereUniqueInput = {
  AND?: InputMaybe<Array<ProviderPoolWhereInput>>;
  NOT?: InputMaybe<Array<ProviderPoolWhereInput>>;
  OR?: InputMaybe<Array<ProviderPoolWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  providers?: InputMaybe<ProviderListRelationFilter>;
};

export type ProviderScalarWhereInput = {
  AND?: InputMaybe<Array<ProviderScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProviderScalarWhereInput>>;
  OR?: InputMaybe<Array<ProviderScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderTaxonomyConnection = {
  __typename?: 'ProviderTaxonomyConnection';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id: Scalars['String']['output'];
  network?: Maybe<Network>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  providerId: Scalars['String']['output'];
  taxonomyItemId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ProviderTaxonomyConnectionContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type ProviderTaxonomyConnectionHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ProviderTaxonomyConnectionNetworkArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type ProviderTaxonomyConnectionPropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type ProviderTaxonomyConnectionCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  taxonomyItemId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<ProviderTaxonomyConnectionCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderTaxonomyConnectionCreateManyProviderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  taxonomyItemId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionCreateManyProviderInputEnvelope = {
  data?: InputMaybe<Array<ProviderTaxonomyConnectionCreateManyProviderInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderTaxonomyConnectionCreateManyTaxonomyItemInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionCreateManyTaxonomyItemInputEnvelope = {
  data?: InputMaybe<Array<ProviderTaxonomyConnectionCreateManyTaxonomyItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderTaxonomyConnectionCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderTaxonomyConnectionCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ProviderTaxonomyConnectionCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ProviderTaxonomyConnectionCreateManyNetworkInputEnvelope>;
};

export type ProviderTaxonomyConnectionCreateNestedManyWithoutProviderInput = {
  connect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderTaxonomyConnectionCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<ProviderTaxonomyConnectionCreateWithoutProviderInput>>;
  createMany?: InputMaybe<ProviderTaxonomyConnectionCreateManyProviderInputEnvelope>;
};

export type ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput = {
  connect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderTaxonomyConnectionCreateOrConnectWithoutTaxonomyItemInput>>;
  create?: InputMaybe<Array<ProviderTaxonomyConnectionCreateWithoutTaxonomyItemInput>>;
  createMany?: InputMaybe<ProviderTaxonomyConnectionCreateManyTaxonomyItemInputEnvelope>;
};

export type ProviderTaxonomyConnectionCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderTaxonomyConnectionCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<ProviderTaxonomyConnectionCreateWithoutContentInput>;
};

export type ProviderTaxonomyConnectionCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderTaxonomyConnectionCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<ProviderTaxonomyConnectionCreateWithoutContentOldInput>;
};

export type ProviderTaxonomyConnectionCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderTaxonomyConnectionCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<ProviderTaxonomyConnectionCreateWithoutPropertiesInput>;
};

export type ProviderTaxonomyConnectionCreateOrConnectWithoutContentInput = {
  create: ProviderTaxonomyConnectionCreateWithoutContentInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionCreateOrConnectWithoutContentOldInput = {
  create: ProviderTaxonomyConnectionCreateWithoutContentOldInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionCreateOrConnectWithoutNetworkInput = {
  create: ProviderTaxonomyConnectionCreateWithoutNetworkInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionCreateOrConnectWithoutPropertiesInput = {
  create: ProviderTaxonomyConnectionCreateWithoutPropertiesInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionCreateOrConnectWithoutProviderInput = {
  create: ProviderTaxonomyConnectionCreateWithoutProviderInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionCreateOrConnectWithoutTaxonomyItemInput = {
  create: ProviderTaxonomyConnectionCreateWithoutTaxonomyItemInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionCreateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderTaxonomyConnectionsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  provider: ProviderCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  taxonomyItem: TaxonomyItemCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionCreateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderTaxonomyConnectionsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  provider: ProviderCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  taxonomyItem: TaxonomyItemCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionCreateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  provider: ProviderCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  taxonomyItem: TaxonomyItemCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderTaxonomyConnectionsInput>;
  provider: ProviderCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  taxonomyItem: TaxonomyItemCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionCreateWithoutProviderInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderTaxonomyConnectionsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  taxonomyItem: TaxonomyItemCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionCreateWithoutTaxonomyItemInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutProviderTaxonomyConnectionsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutProviderTaxonomyConnectionInput>;
  provider: ProviderCreateNestedOneWithoutProviderTaxonomyConnectionsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProviderTaxonomyConnectionListRelationFilter = {
  every?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  none?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  some?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};

export type ProviderTaxonomyConnectionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProviderTaxonomyConnectionOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  provider?: InputMaybe<ProviderOrderByWithRelationInput>;
  providerId?: InputMaybe<SortOrder>;
  taxonomyItem?: InputMaybe<TaxonomyItemOrderByWithRelationInput>;
  taxonomyItemId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProviderTaxonomyConnectionProviderIdTaxonomyItemIdNetworkIdCompoundUniqueInput = {
  networkId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  taxonomyItemId: Scalars['String']['input'];
};

export type ProviderTaxonomyConnectionScalarWhereInput = {
  AND?: InputMaybe<Array<ProviderTaxonomyConnectionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProviderTaxonomyConnectionScalarWhereInput>>;
  OR?: InputMaybe<Array<ProviderTaxonomyConnectionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  providerId?: InputMaybe<StringFilter>;
  taxonomyItemId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderTaxonomyConnectionUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyConnectionUpdateManyWithWhereWithoutNetworkInput = {
  data: ProviderTaxonomyConnectionUpdateManyMutationInput;
  where: ProviderTaxonomyConnectionScalarWhereInput;
};

export type ProviderTaxonomyConnectionUpdateManyWithWhereWithoutProviderInput = {
  data: ProviderTaxonomyConnectionUpdateManyMutationInput;
  where: ProviderTaxonomyConnectionScalarWhereInput;
};

export type ProviderTaxonomyConnectionUpdateManyWithWhereWithoutTaxonomyItemInput = {
  data: ProviderTaxonomyConnectionUpdateManyMutationInput;
  where: ProviderTaxonomyConnectionScalarWhereInput;
};

export type ProviderTaxonomyConnectionUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderTaxonomyConnectionCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ProviderTaxonomyConnectionCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ProviderTaxonomyConnectionCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderTaxonomyConnectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderTaxonomyConnectionUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<ProviderTaxonomyConnectionUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<ProviderTaxonomyConnectionUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type ProviderTaxonomyConnectionUpdateManyWithoutProviderNestedInput = {
  connect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderTaxonomyConnectionCreateOrConnectWithoutProviderInput>>;
  create?: InputMaybe<Array<ProviderTaxonomyConnectionCreateWithoutProviderInput>>;
  createMany?: InputMaybe<ProviderTaxonomyConnectionCreateManyProviderInputEnvelope>;
  delete?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderTaxonomyConnectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderTaxonomyConnectionUpdateWithWhereUniqueWithoutProviderInput>>;
  updateMany?: InputMaybe<Array<ProviderTaxonomyConnectionUpdateManyWithWhereWithoutProviderInput>>;
  upsert?: InputMaybe<Array<ProviderTaxonomyConnectionUpsertWithWhereUniqueWithoutProviderInput>>;
};

export type ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput = {
  connect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderTaxonomyConnectionCreateOrConnectWithoutTaxonomyItemInput>>;
  create?: InputMaybe<Array<ProviderTaxonomyConnectionCreateWithoutTaxonomyItemInput>>;
  createMany?: InputMaybe<ProviderTaxonomyConnectionCreateManyTaxonomyItemInputEnvelope>;
  delete?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderTaxonomyConnectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderTaxonomyConnectionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderTaxonomyConnectionUpdateWithWhereUniqueWithoutTaxonomyItemInput>>;
  updateMany?: InputMaybe<Array<ProviderTaxonomyConnectionUpdateManyWithWhereWithoutTaxonomyItemInput>>;
  upsert?: InputMaybe<Array<ProviderTaxonomyConnectionUpsertWithWhereUniqueWithoutTaxonomyItemInput>>;
};

export type ProviderTaxonomyConnectionUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderTaxonomyConnectionCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<ProviderTaxonomyConnectionCreateWithoutContentInput>;
  delete?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  disconnect?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  update?: InputMaybe<ProviderTaxonomyConnectionUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<ProviderTaxonomyConnectionUpsertWithoutContentInput>;
};

export type ProviderTaxonomyConnectionUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderTaxonomyConnectionCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<ProviderTaxonomyConnectionCreateWithoutContentOldInput>;
  delete?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  disconnect?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  update?: InputMaybe<ProviderTaxonomyConnectionUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<ProviderTaxonomyConnectionUpsertWithoutContentOldInput>;
};

export type ProviderTaxonomyConnectionUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderTaxonomyConnectionCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<ProviderTaxonomyConnectionCreateWithoutPropertiesInput>;
  delete?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  disconnect?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
  update?: InputMaybe<ProviderTaxonomyConnectionUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<ProviderTaxonomyConnectionUpsertWithoutPropertiesInput>;
};

export type ProviderTaxonomyConnectionUpdateToOneWithWhereWithoutContentInput = {
  data: ProviderTaxonomyConnectionUpdateWithoutContentInput;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};

export type ProviderTaxonomyConnectionUpdateToOneWithWhereWithoutContentOldInput = {
  data: ProviderTaxonomyConnectionUpdateWithoutContentOldInput;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};

export type ProviderTaxonomyConnectionUpdateToOneWithWhereWithoutPropertiesInput = {
  data: ProviderTaxonomyConnectionUpdateWithoutPropertiesInput;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};

export type ProviderTaxonomyConnectionUpdateWithWhereUniqueWithoutNetworkInput = {
  data: ProviderTaxonomyConnectionUpdateWithoutNetworkInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionUpdateWithWhereUniqueWithoutProviderInput = {
  data: ProviderTaxonomyConnectionUpdateWithoutProviderInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionUpdateWithWhereUniqueWithoutTaxonomyItemInput = {
  data: ProviderTaxonomyConnectionUpdateWithoutTaxonomyItemInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionUpdateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderTaxonomyConnectionsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyConnectionUpdateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderTaxonomyConnectionsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyConnectionUpdateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyConnectionUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderTaxonomyConnectionsNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyConnectionUpdateWithoutProviderInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderTaxonomyConnectionsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyConnectionUpdateWithoutTaxonomyItemInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderTaxonomyConnectionsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderTaxonomyConnectionNestedInput>;
  provider?: InputMaybe<ProviderUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderTaxonomyConnectionUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
  provider: RouteResourceWhereUniqueInput;
  taxonomyItem: RouteResourceWhereUniqueInput;
};

export type ProviderTaxonomyConnectionUpsertWithWhereUniqueWithoutNetworkInput = {
  create: ProviderTaxonomyConnectionCreateWithoutNetworkInput;
  update: ProviderTaxonomyConnectionUpdateWithoutNetworkInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionUpsertWithWhereUniqueWithoutProviderInput = {
  create: ProviderTaxonomyConnectionCreateWithoutProviderInput;
  update: ProviderTaxonomyConnectionUpdateWithoutProviderInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionUpsertWithWhereUniqueWithoutTaxonomyItemInput = {
  create: ProviderTaxonomyConnectionCreateWithoutTaxonomyItemInput;
  update: ProviderTaxonomyConnectionUpdateWithoutTaxonomyItemInput;
  where: ProviderTaxonomyConnectionWhereUniqueInput;
};

export type ProviderTaxonomyConnectionUpsertWithoutContentInput = {
  create: ProviderTaxonomyConnectionCreateWithoutContentInput;
  update: ProviderTaxonomyConnectionUpdateWithoutContentInput;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};

export type ProviderTaxonomyConnectionUpsertWithoutContentOldInput = {
  create: ProviderTaxonomyConnectionCreateWithoutContentOldInput;
  update: ProviderTaxonomyConnectionUpdateWithoutContentOldInput;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};

export type ProviderTaxonomyConnectionUpsertWithoutPropertiesInput = {
  create: ProviderTaxonomyConnectionCreateWithoutPropertiesInput;
  update: ProviderTaxonomyConnectionUpdateWithoutPropertiesInput;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};

export type ProviderTaxonomyConnectionWhereInput = {
  AND?: InputMaybe<Array<ProviderTaxonomyConnectionWhereInput>>;
  NOT?: InputMaybe<Array<ProviderTaxonomyConnectionWhereInput>>;
  OR?: InputMaybe<Array<ProviderTaxonomyConnectionWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  provider?: InputMaybe<ProviderWhereInput>;
  providerId?: InputMaybe<StringFilter>;
  taxonomyItem?: InputMaybe<TaxonomyItemWhereInput>;
  taxonomyItemId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderTaxonomyConnectionWhereUniqueInput = {
  AND?: InputMaybe<Array<ProviderTaxonomyConnectionWhereInput>>;
  NOT?: InputMaybe<Array<ProviderTaxonomyConnectionWhereInput>>;
  OR?: InputMaybe<Array<ProviderTaxonomyConnectionWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  provider?: InputMaybe<ProviderWhereInput>;
  providerId?: InputMaybe<StringFilter>;
  providerId_taxonomyItemId_networkId?: InputMaybe<ProviderTaxonomyConnectionProviderIdTaxonomyItemIdNetworkIdCompoundUniqueInput>;
  taxonomyItem?: InputMaybe<TaxonomyItemWhereInput>;
  taxonomyItemId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderUpdateManyWithWhereWithoutNetworkInput = {
  data: ProviderUpdateManyMutationInput;
  where: ProviderScalarWhereInput;
};

export type ProviderUpdateManyWithWhereWithoutPoolsInput = {
  data: ProviderUpdateManyMutationInput;
  where: ProviderScalarWhereInput;
};

export type ProviderUpdateManyWithWhereWithoutProductsInput = {
  data: ProviderUpdateManyMutationInput;
  where: ProviderScalarWhereInput;
};

export type ProviderUpdateManyWithWhereWithoutTaxonomiesInput = {
  data: ProviderUpdateManyMutationInput;
  where: ProviderScalarWhereInput;
};

export type ProviderUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<ProviderCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<ProviderCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<ProviderUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<ProviderUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type ProviderUpdateManyWithoutPoolsNestedInput = {
  connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderCreateOrConnectWithoutPoolsInput>>;
  create?: InputMaybe<Array<ProviderCreateWithoutPoolsInput>>;
  delete?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderUpdateWithWhereUniqueWithoutPoolsInput>>;
  updateMany?: InputMaybe<Array<ProviderUpdateManyWithWhereWithoutPoolsInput>>;
  upsert?: InputMaybe<Array<ProviderUpsertWithWhereUniqueWithoutPoolsInput>>;
};

export type ProviderUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<ProviderCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<ProviderUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<ProviderUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type ProviderUpdateManyWithoutTaxonomiesNestedInput = {
  connect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProviderCreateOrConnectWithoutTaxonomiesInput>>;
  create?: InputMaybe<Array<ProviderCreateWithoutTaxonomiesInput>>;
  delete?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProviderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  set?: InputMaybe<Array<ProviderWhereUniqueInput>>;
  update?: InputMaybe<Array<ProviderUpdateWithWhereUniqueWithoutTaxonomiesInput>>;
  updateMany?: InputMaybe<Array<ProviderUpdateManyWithWhereWithoutTaxonomiesInput>>;
  upsert?: InputMaybe<Array<ProviderUpsertWithWhereUniqueWithoutTaxonomiesInput>>;
};

export type ProviderUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput = {
  connect?: InputMaybe<ProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutProviderTaxonomyConnectionsInput>;
  create?: InputMaybe<ProviderCreateWithoutProviderTaxonomyConnectionsInput>;
  update?: InputMaybe<ProviderUpdateToOneWithWhereWithoutProviderTaxonomyConnectionsInput>;
  upsert?: InputMaybe<ProviderUpsertWithoutProviderTaxonomyConnectionsInput>;
};

export type ProviderUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<ProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<ProviderCreateWithoutContentInput>;
  delete?: InputMaybe<ProviderWhereInput>;
  disconnect?: InputMaybe<ProviderWhereInput>;
  update?: InputMaybe<ProviderUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<ProviderUpsertWithoutContentInput>;
};

export type ProviderUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<ProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProviderCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<ProviderCreateWithoutPropertiesInput>;
  delete?: InputMaybe<ProviderWhereInput>;
  disconnect?: InputMaybe<ProviderWhereInput>;
  update?: InputMaybe<ProviderUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<ProviderUpsertWithoutPropertiesInput>;
};

export type ProviderUpdateToOneWithWhereWithoutContentInput = {
  data: ProviderUpdateWithoutContentInput;
  where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpdateToOneWithWhereWithoutPropertiesInput = {
  data: ProviderUpdateWithoutPropertiesInput;
  where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpdateToOneWithWhereWithoutProviderTaxonomyConnectionsInput = {
  data: ProviderUpdateWithoutProviderTaxonomyConnectionsInput;
  where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpdateWithWhereUniqueWithoutNetworkInput = {
  data: ProviderUpdateWithoutNetworkInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderUpdateWithWhereUniqueWithoutPoolsInput = {
  data: ProviderUpdateWithoutPoolsInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderUpdateWithWhereUniqueWithoutProductsInput = {
  data: ProviderUpdateWithoutProductsInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderUpdateWithWhereUniqueWithoutTaxonomiesInput = {
  data: ProviderUpdateWithoutTaxonomiesInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderUpdateWithoutContentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderNestedInput>;
  pools?: InputMaybe<ProviderPoolUpdateManyWithoutProvidersNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutProvidersNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutProviderNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProvidersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProviderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pools?: InputMaybe<ProviderPoolUpdateManyWithoutProvidersNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutProvidersNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutProviderNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProvidersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutPoolsInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProviderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutProvidersNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutProviderNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProvidersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutProductsInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProviderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderNestedInput>;
  pools?: InputMaybe<ProviderPoolUpdateManyWithoutProvidersNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutProviderNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProvidersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProviderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderNestedInput>;
  pools?: InputMaybe<ProviderPoolUpdateManyWithoutProvidersNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutProvidersNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutProviderNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProvidersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutProviderTaxonomyConnectionsInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProviderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderNestedInput>;
  pools?: InputMaybe<ProviderPoolUpdateManyWithoutProvidersNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutProvidersNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderNestedInput>;
  taxonomies?: InputMaybe<TaxonomyItemUpdateManyWithoutProvidersNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderUpdateWithoutTaxonomiesInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutProviderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutProviderNestedInput>;
  pools?: InputMaybe<ProviderPoolUpdateManyWithoutProvidersNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutProvidersNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutProviderNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutProviderNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProviderUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type ProviderUpsertWithWhereUniqueWithoutNetworkInput = {
  create: ProviderCreateWithoutNetworkInput;
  update: ProviderUpdateWithoutNetworkInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderUpsertWithWhereUniqueWithoutPoolsInput = {
  create: ProviderCreateWithoutPoolsInput;
  update: ProviderUpdateWithoutPoolsInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderUpsertWithWhereUniqueWithoutProductsInput = {
  create: ProviderCreateWithoutProductsInput;
  update: ProviderUpdateWithoutProductsInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderUpsertWithWhereUniqueWithoutTaxonomiesInput = {
  create: ProviderCreateWithoutTaxonomiesInput;
  update: ProviderUpdateWithoutTaxonomiesInput;
  where: ProviderWhereUniqueInput;
};

export type ProviderUpsertWithoutContentInput = {
  create: ProviderCreateWithoutContentInput;
  update: ProviderUpdateWithoutContentInput;
  where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpsertWithoutPropertiesInput = {
  create: ProviderCreateWithoutPropertiesInput;
  update: ProviderUpdateWithoutPropertiesInput;
  where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderUpsertWithoutProviderTaxonomyConnectionsInput = {
  create: ProviderCreateWithoutProviderTaxonomyConnectionsInput;
  update: ProviderUpdateWithoutProviderTaxonomyConnectionsInput;
  where?: InputMaybe<ProviderWhereInput>;
};

export type ProviderWhereInput = {
  AND?: InputMaybe<Array<ProviderWhereInput>>;
  NOT?: InputMaybe<Array<ProviderWhereInput>>;
  OR?: InputMaybe<Array<ProviderWhereInput>>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  pools?: InputMaybe<ProviderPoolListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionListRelationFilter>;
  taxonomies?: InputMaybe<TaxonomyItemListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProviderWhereUniqueInput = {
  AND?: InputMaybe<Array<ProviderWhereInput>>;
  NOT?: InputMaybe<Array<ProviderWhereInput>>;
  OR?: InputMaybe<Array<ProviderWhereInput>>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  pools?: InputMaybe<ProviderPoolListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionListRelationFilter>;
  taxonomies?: InputMaybe<TaxonomyItemListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Query = {
  __typename?: 'Query';
  author?: Maybe<Author>;
  authorCount?: Maybe<Scalars['Int']['output']>;
  authors: Array<Author>;
  authorsSearch: Array<Author>;
  authorsSearchCount: Scalars['Int']['output'];
  companies: Array<Company>;
  company?: Maybe<Company>;
  contentItem?: Maybe<ContentItem>;
  contentItemCount?: Maybe<Scalars['Int']['output']>;
  contentItemV2?: Maybe<Network>;
  contentItemV2Count?: Maybe<Scalars['Int']['output']>;
  contentItemV2S: Array<Network>;
  contentItems: Array<ContentItem>;
  countries: Array<Country>;
  country?: Maybe<Country>;
  deployJobs?: Maybe<Array<Maybe<DeployJob>>>;
  deployJobsCount?: Maybe<Scalars['Int']['output']>;
  filterTaxonomyItem?: Maybe<FilterTaxonomyItem>;
  filterTaxonomyItemCount?: Maybe<Scalars['Int']['output']>;
  filterTaxonomyItems: Array<FilterTaxonomyItem>;
  filterTaxonomyItemsSearch: Array<FilterTaxonomyItem>;
  filterTaxonomyItemsSearchCount: Scalars['Int']['output'];
  filterTaxonomyRule?: Maybe<FilterTaxonomyRule>;
  filterTaxonomyRuleCount?: Maybe<Scalars['Int']['output']>;
  filterTaxonomyRules: Array<FilterTaxonomyRule>;
  filterTaxonomyRulesSearch: Array<FilterTaxonomyRule>;
  filterTaxonomyRulesSearchCount: Scalars['Int']['output'];
  generalTemplateFieldGroup?: Maybe<GeneralTemplateFieldGroup>;
  generalTemplateFieldGroups: Array<GeneralTemplateFieldGroup>;
  historyForResource?: Maybe<Array<Maybe<ResourceHistory>>>;
  language?: Maybe<Language>;
  languages: Array<Language>;
  linkCampaign?: Maybe<LinkCampaign>;
  linkCampaigns?: Maybe<Array<Maybe<LinkCampaign>>>;
  me?: Maybe<User>;
  mediaItem?: Maybe<MediaItem>;
  mediaItemCount?: Maybe<Scalars['Int']['output']>;
  mediaItems: Array<MediaItem>;
  menu?: Maybe<Menu>;
  menuItem?: Maybe<MenuItem>;
  menuItemCount?: Maybe<Scalars['Int']['output']>;
  menuItems: Array<MenuItem>;
  menus: Array<Menu>;
  network?: Maybe<Network>;
  networkCount?: Maybe<Scalars['Int']['output']>;
  networks: Array<Network>;
  newResourceCounts?: Maybe<NewResourceCounts>;
  ok: Scalars['Boolean']['output'];
  page?: Maybe<Page>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  pages: Array<Page>;
  pagesSearch: Array<Page>;
  pagesSearchCount: Scalars['Int']['output'];
  plugins?: Maybe<Array<Maybe<Plugin>>>;
  post?: Maybe<Post>;
  postCount?: Maybe<Scalars['Int']['output']>;
  posts: Array<Post>;
  postsSearch: Array<Post>;
  postsSearchCount: Scalars['Int']['output'];
  product?: Maybe<Product>;
  productCount?: Maybe<Scalars['Int']['output']>;
  productPool?: Maybe<ProductPool>;
  productPools: Array<ProductPool>;
  products: Array<Product>;
  productsSearch: Array<Product>;
  productsSearchCount: Scalars['Int']['output'];
  propertyItem?: Maybe<PropertyItem>;
  propertyItems: Array<PropertyItem>;
  provider?: Maybe<Provider>;
  providerCount?: Maybe<Scalars['Int']['output']>;
  providerPool?: Maybe<ProviderPool>;
  providerPools: Array<ProviderPool>;
  providerTaxonomyConnection?: Maybe<ProviderTaxonomyConnection>;
  providerTaxonomyConnectionCount?: Maybe<Scalars['Int']['output']>;
  providerTaxonomyConnections: Array<ProviderTaxonomyConnection>;
  providerTaxonomyConnectionsSearch: Array<ProviderTaxonomyConnection>;
  providerTaxonomyConnectionsSearchCount: Scalars['Int']['output'];
  providers: Array<Provider>;
  providersSearch: Array<Provider>;
  providersSearchCount: Scalars['Int']['output'];
  publishedPagesCount?: Maybe<Scalars['Int']['output']>;
  ranking?: Maybe<Ranking>;
  rankings: Array<Ranking>;
  redirect?: Maybe<Redirect>;
  redirectCount?: Maybe<Scalars['Int']['output']>;
  redirects: Array<Redirect>;
  region?: Maybe<Region>;
  regions: Array<Region>;
  routeResource?: Maybe<RouteResource>;
  routeResourcePool?: Maybe<RouteResourcePool>;
  routeResourcePools: Array<RouteResourcePool>;
  routeResources: Array<RouteResource>;
  site?: Maybe<Site>;
  siteCount?: Maybe<Scalars['Int']['output']>;
  sites: Array<Site>;
  sitesSearch: Array<Site>;
  sitesSearchCount: Scalars['Int']['output'];
  state?: Maybe<State>;
  states: Array<State>;
  stringItem?: Maybe<StringItem>;
  stringItemCount?: Maybe<Scalars['Int']['output']>;
  stringItems: Array<StringItem>;
  stringTemplate?: Maybe<StringTemplate>;
  stringTemplateCount?: Maybe<Scalars['Int']['output']>;
  stringTemplateVariable?: Maybe<StringTemplateVariable>;
  stringTemplateVariables: Array<StringTemplateVariable>;
  stringTemplates: Array<StringTemplate>;
  subregion?: Maybe<Subregion>;
  subregions: Array<Subregion>;
  tag?: Maybe<Tag>;
  tags: Array<Tag>;
  taxonomyItem?: Maybe<TaxonomyItem>;
  taxonomyItemCount?: Maybe<Scalars['Int']['output']>;
  taxonomyItemPool?: Maybe<TaxonomyItemPool>;
  taxonomyItemPools: Array<TaxonomyItemPool>;
  taxonomyItems: Array<TaxonomyItem>;
  taxonomyItemsSearch: Array<TaxonomyItem>;
  taxonomyItemsSearchCount: Scalars['Int']['output'];
  template?: Maybe<Template>;
  templateCount?: Maybe<Scalars['Int']['output']>;
  templateField?: Maybe<TemplateField>;
  templateFieldCount?: Maybe<Scalars['Int']['output']>;
  templateFieldGroup?: Maybe<TemplateFieldGroup>;
  templateFieldGroupCount?: Maybe<Scalars['Int']['output']>;
  templateFieldGroups: Array<TemplateFieldGroup>;
  templateFields: Array<TemplateField>;
  templates: Array<Template>;
  translationJob?: Maybe<TranslationJob>;
  translationJobs?: Maybe<Array<Maybe<TranslationJob>>>;
  translationJobsByResourceId?: Maybe<Array<Maybe<TranslationJob>>>;
  translationJobsCount?: Maybe<Scalars['Int']['output']>;
  /** Returned float is an estimated translation cost in USD */
  translationJobsEstimatedCost?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
  vertical?: Maybe<Vertical>;
  verticalCount?: Maybe<Scalars['Int']['output']>;
  verticals: Array<Vertical>;
};


export type QueryAuthorArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type QueryAuthorCountArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryAuthorsArgs = {
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryAuthorsSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryAuthorsSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryCompaniesArgs = {
  cursor?: InputMaybe<CompanyWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CompanyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyWhereInput>;
};


export type QueryCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type QueryContentItemArgs = {
  where: ContentItemWhereUniqueInput;
};


export type QueryContentItemCountArgs = {
  where?: InputMaybe<ContentItemWhereInput>;
};


export type QueryContentItemV2Args = {
  where: ContentItemV2WhereUniqueInput;
};


export type QueryContentItemV2CountArgs = {
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type QueryContentItemV2SArgs = {
  cursor?: InputMaybe<ContentItemV2WhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type QueryContentItemsArgs = {
  cursor?: InputMaybe<ContentItemWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemWhereInput>;
};


export type QueryCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};


export type QueryCountryArgs = {
  where: CountryWhereUniqueInput;
};


export type QueryDeployJobsArgs = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DeployJobStatusEnum>;
};


export type QueryDeployJobsCountArgs = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DeployJobStatusEnum>;
};


export type QueryFilterTaxonomyItemArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type QueryFilterTaxonomyItemCountArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryFilterTaxonomyItemsArgs = {
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryFilterTaxonomyItemsSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryFilterTaxonomyItemsSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryFilterTaxonomyRuleArgs = {
  where?: InputMaybe<FilterTaxonomyRuleWhereUniqueInput>;
};


export type QueryFilterTaxonomyRuleCountArgs = {
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};


export type QueryFilterTaxonomyRulesArgs = {
  orderBy?: InputMaybe<Array<FilterTaxonomyRuleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};


export type QueryFilterTaxonomyRulesSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<FilterTaxonomyRuleOrderByWithRelationInput>>;
  search?: InputMaybe<ResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};


export type QueryFilterTaxonomyRulesSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<ResourceSearchWhereInput>;
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
};


export type QueryGeneralTemplateFieldGroupArgs = {
  where: GeneralTemplateFieldGroupWhereUniqueInput;
};


export type QueryGeneralTemplateFieldGroupsArgs = {
  cursor?: InputMaybe<GeneralTemplateFieldGroupWhereUniqueInput>;
  orderBy?: InputMaybe<Array<GeneralTemplateFieldGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GeneralTemplateFieldGroupWhereInput>;
};


export type QueryHistoryForResourceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  resourceType: HistoryResourceType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type QueryLanguagesArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  orderBy?: InputMaybe<Array<LanguageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type QueryLinkCampaignArgs = {
  id: Scalars['String']['input'];
};


export type QueryMediaItemArgs = {
  where: MediaItemWhereUniqueInput;
};


export type QueryMediaItemCountArgs = {
  where?: InputMaybe<MediaItemWhereInput>;
};


export type QueryMediaItemsArgs = {
  cursor?: InputMaybe<MediaItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<MediaItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaItemWhereInput>;
};


export type QueryMenuArgs = {
  where?: InputMaybe<MenuWhereUniqueInput>;
};


export type QueryMenuItemArgs = {
  where?: InputMaybe<MenuItemWhereUniqueInput>;
};


export type QueryMenuItemCountArgs = {
  where?: InputMaybe<MenuItemWhereInput>;
};


export type QueryMenuItemsArgs = {
  orderBy?: InputMaybe<Array<MenuItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuItemWhereInput>;
};


export type QueryMenusArgs = {
  orderBy?: InputMaybe<Array<MenuOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MenuWhereInput>;
};


export type QueryNetworkArgs = {
  where?: InputMaybe<NetworkWhereUniqueInput>;
};


export type QueryNetworkCountArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type QueryNetworksArgs = {
  orderBy?: InputMaybe<Array<NetworkOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NetworkWhereInput>;
};


export type QueryNewResourceCountsArgs = {
  networkId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPageArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type QueryPageCountArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPagesArgs = {
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPagesSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPagesSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPostArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type QueryPostCountArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPostsArgs = {
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPostsSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPostsSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryProductArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type QueryProductCountArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryProductPoolArgs = {
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
};


export type QueryProductPoolsArgs = {
  orderBy?: InputMaybe<Array<RouteResourcePoolOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourcePoolWhereInput>;
};


export type QueryProductsArgs = {
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryProductsSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryProductsSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPropertyItemArgs = {
  where: PropertyItemWhereUniqueInput;
};


export type QueryPropertyItemsArgs = {
  cursor?: InputMaybe<PropertyItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PropertyItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};


export type QueryProviderArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type QueryProviderCountArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryProviderPoolArgs = {
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
};


export type QueryProviderPoolsArgs = {
  orderBy?: InputMaybe<Array<RouteResourcePoolOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourcePoolWhereInput>;
};


export type QueryProviderTaxonomyConnectionArgs = {
  where?: InputMaybe<ProviderTaxonomyConnectionWhereUniqueInput>;
};


export type QueryProviderTaxonomyConnectionCountArgs = {
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};


export type QueryProviderTaxonomyConnectionsArgs = {
  orderBy?: InputMaybe<Array<ProviderTaxonomyConnectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};


export type QueryProviderTaxonomyConnectionsSearchArgs = {
  orderBy?: InputMaybe<Array<ProviderTaxonomyConnectionOrderByWithRelationInput>>;
  search?: InputMaybe<ResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};


export type QueryProviderTaxonomyConnectionsSearchCountArgs = {
  search?: InputMaybe<ResourceSearchWhereInput>;
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
};


export type QueryProvidersArgs = {
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryProvidersSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryProvidersSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryPublishedPagesCountArgs = {
  where?: InputMaybe<SiteWhereInput>;
};


export type QueryRankingArgs = {
  where: RankingWhereUniqueInput;
};


export type QueryRankingsArgs = {
  cursor?: InputMaybe<RankingWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RankingWhereInput>;
};


export type QueryRedirectArgs = {
  where: RedirectWhereUniqueInput;
};


export type QueryRedirectCountArgs = {
  where?: InputMaybe<RedirectWhereInput>;
};


export type QueryRedirectsArgs = {
  cursor?: InputMaybe<RedirectWhereUniqueInput>;
  orderBy?: InputMaybe<Array<RedirectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedirectWhereInput>;
};


export type QueryRegionArgs = {
  where: RegionWhereUniqueInput;
};


export type QueryRegionsArgs = {
  cursor?: InputMaybe<RegionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<RegionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RegionWhereInput>;
};


export type QueryRouteResourceArgs = {
  where: RouteResourceWhereUniqueInput;
};


export type QueryRouteResourcePoolArgs = {
  where: RouteResourcePoolWhereUniqueInput;
};


export type QueryRouteResourcePoolsArgs = {
  cursor?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
  orderBy?: InputMaybe<Array<RouteResourcePoolOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourcePoolWhereInput>;
};


export type QueryRouteResourcesArgs = {
  cursor?: InputMaybe<RouteResourceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QuerySiteArgs = {
  where?: InputMaybe<SiteWhereUniqueInput>;
};


export type QuerySiteCountArgs = {
  where?: InputMaybe<SiteWhereInput>;
};


export type QuerySitesArgs = {
  orderBy?: InputMaybe<Array<SiteOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SiteWhereInput>;
};


export type QuerySitesSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<SiteOrderByWithRelationInput>>;
  search?: InputMaybe<ResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SiteWhereInput>;
};


export type QuerySitesSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<ResourceSearchWhereInput>;
  where?: InputMaybe<SiteWhereInput>;
};


export type QueryStateArgs = {
  where: StateWhereUniqueInput;
};


export type QueryStatesArgs = {
  cursor?: InputMaybe<StateWhereUniqueInput>;
  orderBy?: InputMaybe<Array<StateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateWhereInput>;
};


export type QueryStringItemArgs = {
  where: StringItemWhereUniqueInput;
};


export type QueryStringItemCountArgs = {
  where?: InputMaybe<StringItemWhereInput>;
};


export type QueryStringItemsArgs = {
  cursor?: InputMaybe<StringItemWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StringItemWhereInput>;
};


export type QueryStringTemplateArgs = {
  where?: InputMaybe<StringTemplateWhereUniqueInput>;
};


export type QueryStringTemplateCountArgs = {
  where?: InputMaybe<StringTemplateWhereInput>;
};


export type QueryStringTemplateVariableArgs = {
  where?: InputMaybe<StringTemplateVariableWhereUniqueInput>;
};


export type QueryStringTemplateVariablesArgs = {
  orderBy?: InputMaybe<Array<StringTemplateVariableOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StringTemplateVariableWhereInput>;
};


export type QueryStringTemplatesArgs = {
  orderBy?: InputMaybe<Array<StringTemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StringTemplateWhereInput>;
};


export type QuerySubregionArgs = {
  where: SubregionWhereUniqueInput;
};


export type QuerySubregionsArgs = {
  cursor?: InputMaybe<SubregionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<SubregionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubregionWhereInput>;
};


export type QueryTagArgs = {
  where: TagWhereUniqueInput;
};


export type QueryTagsArgs = {
  cursor?: InputMaybe<TagWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryTaxonomyItemArgs = {
  where?: InputMaybe<RouteResourceWhereUniqueInput>;
};


export type QueryTaxonomyItemCountArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryTaxonomyItemPoolArgs = {
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
};


export type QueryTaxonomyItemPoolsArgs = {
  orderBy?: InputMaybe<Array<RouteResourcePoolOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourcePoolWhereInput>;
};


export type QueryTaxonomyItemsArgs = {
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryTaxonomyItemsSearchArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput>>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryTaxonomyItemsSearchCountArgs = {
  config?: InputMaybe<ResourceConfigInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type QueryTemplateArgs = {
  where?: InputMaybe<TemplateWhereUniqueInput>;
};


export type QueryTemplateCountArgs = {
  where?: InputMaybe<TemplateWhereInput>;
};


export type QueryTemplateFieldArgs = {
  where?: InputMaybe<TemplateFieldWhereUniqueInput>;
};


export type QueryTemplateFieldCountArgs = {
  where?: InputMaybe<TemplateFieldWhereInput>;
};


export type QueryTemplateFieldGroupArgs = {
  where: TemplateFieldGroupWhereUniqueInput;
};


export type QueryTemplateFieldGroupCountArgs = {
  where?: InputMaybe<TemplateFieldGroupWhereInput>;
};


export type QueryTemplateFieldGroupsArgs = {
  cursor?: InputMaybe<TemplateFieldGroupWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateFieldGroupWhereInput>;
};


export type QueryTemplateFieldsArgs = {
  orderBy?: InputMaybe<Array<TemplateFieldOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateFieldWhereInput>;
};


export type QueryTemplatesArgs = {
  orderBy?: InputMaybe<Array<TemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateWhereInput>;
};


export type QueryTranslationJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryTranslationJobsArgs = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<TranslationJobsTypeEnum>>>;
};


export type QueryTranslationJobsByResourceIdArgs = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  start?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<TranslationJobsTypeEnum>>>;
};


export type QueryTranslationJobsCountArgs = {
  asc?: InputMaybe<Scalars['Boolean']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<TranslationJobsTypeEnum>>>;
};


export type QueryTranslationJobsEstimatedCostArgs = {
  jobs: Array<TranslationJobData>;
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryVerticalArgs = {
  where?: InputMaybe<VerticalWhereUniqueInput>;
};


export type QueryVerticalCountArgs = {
  where?: InputMaybe<VerticalWhereInput>;
};


export type QueryVerticalsArgs = {
  orderBy?: InputMaybe<Array<VerticalOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VerticalWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Ranking = {
  __typename?: 'Ranking';
  data: Scalars['String']['output'];
  id: Scalars['String']['output'];
  network: Network;
};

export type RankingCreateInput = {
  data: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network: NetworkCreateNestedOneWithoutRankingInput;
};

export type RankingCreateNestedOneWithoutNetworkInput = {
  connect?: InputMaybe<RankingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RankingCreateOrConnectWithoutNetworkInput>;
  create?: InputMaybe<RankingCreateWithoutNetworkInput>;
};

export type RankingCreateOrConnectWithoutNetworkInput = {
  create: RankingCreateWithoutNetworkInput;
  where: RankingWhereUniqueInput;
};

export type RankingCreateWithoutNetworkInput = {
  data: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type RankingOrderByWithRelationInput = {
  data?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrder>;
};

export type RankingUpdateInput = {
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutRankingNestedInput>;
};

export type RankingUpdateOneWithoutNetworkNestedInput = {
  connect?: InputMaybe<RankingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RankingCreateOrConnectWithoutNetworkInput>;
  create?: InputMaybe<RankingCreateWithoutNetworkInput>;
  delete?: InputMaybe<RankingWhereInput>;
  disconnect?: InputMaybe<RankingWhereInput>;
  update?: InputMaybe<RankingUpdateToOneWithWhereWithoutNetworkInput>;
  upsert?: InputMaybe<RankingUpsertWithoutNetworkInput>;
};

export type RankingUpdateToOneWithWhereWithoutNetworkInput = {
  data: RankingUpdateWithoutNetworkInput;
  where?: InputMaybe<RankingWhereInput>;
};

export type RankingUpdateWithoutNetworkInput = {
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RankingUpsertWithoutNetworkInput = {
  create: RankingCreateWithoutNetworkInput;
  update: RankingUpdateWithoutNetworkInput;
  where?: InputMaybe<RankingWhereInput>;
};

export type RankingWhereInput = {
  AND?: InputMaybe<Array<RankingWhereInput>>;
  NOT?: InputMaybe<Array<RankingWhereInput>>;
  OR?: InputMaybe<Array<RankingWhereInput>>;
  data?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
};

export type RankingWhereUniqueInput = {
  AND?: InputMaybe<Array<RankingWhereInput>>;
  NOT?: InputMaybe<Array<RankingWhereInput>>;
  OR?: InputMaybe<Array<RankingWhereInput>>;
  data?: InputMaybe<StringFilter>;
  id: Scalars['String']['input'];
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<Scalars['String']['input']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  httpCode: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: Maybe<Network>;
  sourceNetworkId?: Maybe<Scalars['String']['output']>;
  sourcePath?: Maybe<Scalars['String']['output']>;
  sourceResource?: Maybe<RouteResource>;
  sourceResourceId?: Maybe<Scalars['String']['output']>;
  sourceResourceType?: Maybe<RouteResourceType>;
  sourceSite?: Maybe<Site>;
  sourceSiteId?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  sourceVertical?: Maybe<Vertical>;
  sourceVerticalId?: Maybe<Scalars['String']['output']>;
  targetKind: RedirectKind;
  targetNetwork?: Maybe<Network>;
  targetNetworkId?: Maybe<Scalars['String']['output']>;
  targetPath?: Maybe<Scalars['String']['output']>;
  targetResource?: Maybe<RouteResource>;
  targetResourceId?: Maybe<Scalars['String']['output']>;
  targetResourceType?: Maybe<RouteResourceType>;
  targetSite?: Maybe<Site>;
  targetSiteId?: Maybe<Scalars['String']['output']>;
  targetUrl?: Maybe<Scalars['String']['output']>;
  targetVertical?: Maybe<Vertical>;
  targetVerticalId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type RedirectHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type RedirectSourceNetworkArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type RedirectSourceResourceArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type RedirectSourceSiteArgs = {
  where?: InputMaybe<SiteWhereInput>;
};


export type RedirectSourceVerticalArgs = {
  where?: InputMaybe<VerticalWhereInput>;
};


export type RedirectTargetNetworkArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type RedirectTargetResourceArgs = {
  where?: InputMaybe<RouteResourceWhereInput>;
};


export type RedirectTargetSiteArgs = {
  where?: InputMaybe<SiteWhereInput>;
};


export type RedirectTargetVerticalArgs = {
  where?: InputMaybe<VerticalWhereInput>;
};

export type RedirectCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: InputMaybe<NetworkCreateNestedOneWithoutSourceRedirectsInput>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResource?: InputMaybe<RouteResourceCreateNestedOneWithoutSourceRedirectsInput>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSite?: InputMaybe<SiteCreateNestedOneWithoutSourceRedirectsInput>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVertical?: InputMaybe<VerticalCreateNestedOneWithoutSourceRedirectsInput>;
  targetKind: RedirectKind;
  targetNetwork?: InputMaybe<NetworkCreateNestedOneWithoutTargetRedirectsInput>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResource?: InputMaybe<RouteResourceCreateNestedOneWithoutTargetRedirectsInput>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSite?: InputMaybe<SiteCreateNestedOneWithoutTargetRedirectsInput>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVertical?: InputMaybe<VerticalCreateNestedOneWithoutTargetRedirectsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManySourceNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceId?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSiteId?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVerticalId?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetNetworkId?: InputMaybe<Scalars['String']['input']>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceId?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSiteId?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVerticalId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManySourceNetworkInputEnvelope = {
  data?: InputMaybe<Array<RedirectCreateManySourceNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCreateManySourceResourceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetworkId?: InputMaybe<Scalars['String']['input']>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSiteId?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVerticalId?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetNetworkId?: InputMaybe<Scalars['String']['input']>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceId?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSiteId?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVerticalId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManySourceResourceInputEnvelope = {
  data?: InputMaybe<Array<RedirectCreateManySourceResourceInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCreateManySourceSiteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetworkId?: InputMaybe<Scalars['String']['input']>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceId?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVerticalId?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetNetworkId?: InputMaybe<Scalars['String']['input']>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceId?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSiteId?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVerticalId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManySourceSiteInputEnvelope = {
  data?: InputMaybe<Array<RedirectCreateManySourceSiteInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCreateManySourceVerticalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetworkId?: InputMaybe<Scalars['String']['input']>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceId?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSiteId?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetNetworkId?: InputMaybe<Scalars['String']['input']>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceId?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSiteId?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVerticalId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManySourceVerticalInputEnvelope = {
  data?: InputMaybe<Array<RedirectCreateManySourceVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCreateManyTargetNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetworkId?: InputMaybe<Scalars['String']['input']>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceId?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSiteId?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVerticalId?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceId?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSiteId?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVerticalId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManyTargetNetworkInputEnvelope = {
  data?: InputMaybe<Array<RedirectCreateManyTargetNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCreateManyTargetResourceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetworkId?: InputMaybe<Scalars['String']['input']>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceId?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSiteId?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVerticalId?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetNetworkId?: InputMaybe<Scalars['String']['input']>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSiteId?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVerticalId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManyTargetResourceInputEnvelope = {
  data?: InputMaybe<Array<RedirectCreateManyTargetResourceInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCreateManyTargetSiteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetworkId?: InputMaybe<Scalars['String']['input']>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceId?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSiteId?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVerticalId?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetNetworkId?: InputMaybe<Scalars['String']['input']>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceId?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVerticalId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManyTargetSiteInputEnvelope = {
  data?: InputMaybe<Array<RedirectCreateManyTargetSiteInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCreateManyTargetVerticalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetworkId?: InputMaybe<Scalars['String']['input']>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceId?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSiteId?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVerticalId?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetNetworkId?: InputMaybe<Scalars['String']['input']>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceId?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSiteId?: InputMaybe<Scalars['String']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateManyTargetVerticalInputEnvelope = {
  data?: InputMaybe<Array<RedirectCreateManyTargetVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RedirectCreateNestedManyWithoutSourceNetworkInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutSourceNetworkInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutSourceNetworkInput>>;
  createMany?: InputMaybe<RedirectCreateManySourceNetworkInputEnvelope>;
};

export type RedirectCreateNestedManyWithoutSourceResourceInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutSourceResourceInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutSourceResourceInput>>;
  createMany?: InputMaybe<RedirectCreateManySourceResourceInputEnvelope>;
};

export type RedirectCreateNestedManyWithoutSourceSiteInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutSourceSiteInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutSourceSiteInput>>;
  createMany?: InputMaybe<RedirectCreateManySourceSiteInputEnvelope>;
};

export type RedirectCreateNestedManyWithoutSourceVerticalInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutSourceVerticalInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutSourceVerticalInput>>;
  createMany?: InputMaybe<RedirectCreateManySourceVerticalInputEnvelope>;
};

export type RedirectCreateNestedManyWithoutTargetNetworkInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutTargetNetworkInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutTargetNetworkInput>>;
  createMany?: InputMaybe<RedirectCreateManyTargetNetworkInputEnvelope>;
};

export type RedirectCreateNestedManyWithoutTargetResourceInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutTargetResourceInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutTargetResourceInput>>;
  createMany?: InputMaybe<RedirectCreateManyTargetResourceInputEnvelope>;
};

export type RedirectCreateNestedManyWithoutTargetSiteInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutTargetSiteInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutTargetSiteInput>>;
  createMany?: InputMaybe<RedirectCreateManyTargetSiteInputEnvelope>;
};

export type RedirectCreateNestedManyWithoutTargetVerticalInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutTargetVerticalInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutTargetVerticalInput>>;
  createMany?: InputMaybe<RedirectCreateManyTargetVerticalInputEnvelope>;
};

export type RedirectCreateOrConnectWithoutSourceNetworkInput = {
  create: RedirectCreateWithoutSourceNetworkInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectCreateOrConnectWithoutSourceResourceInput = {
  create: RedirectCreateWithoutSourceResourceInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectCreateOrConnectWithoutSourceSiteInput = {
  create: RedirectCreateWithoutSourceSiteInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectCreateOrConnectWithoutSourceVerticalInput = {
  create: RedirectCreateWithoutSourceVerticalInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectCreateOrConnectWithoutTargetNetworkInput = {
  create: RedirectCreateWithoutTargetNetworkInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectCreateOrConnectWithoutTargetResourceInput = {
  create: RedirectCreateWithoutTargetResourceInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectCreateOrConnectWithoutTargetSiteInput = {
  create: RedirectCreateWithoutTargetSiteInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectCreateOrConnectWithoutTargetVerticalInput = {
  create: RedirectCreateWithoutTargetVerticalInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectCreateWithoutSourceNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResource?: InputMaybe<RouteResourceCreateNestedOneWithoutSourceRedirectsInput>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSite?: InputMaybe<SiteCreateNestedOneWithoutSourceRedirectsInput>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVertical?: InputMaybe<VerticalCreateNestedOneWithoutSourceRedirectsInput>;
  targetKind: RedirectKind;
  targetNetwork?: InputMaybe<NetworkCreateNestedOneWithoutTargetRedirectsInput>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResource?: InputMaybe<RouteResourceCreateNestedOneWithoutTargetRedirectsInput>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSite?: InputMaybe<SiteCreateNestedOneWithoutTargetRedirectsInput>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVertical?: InputMaybe<VerticalCreateNestedOneWithoutTargetRedirectsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateWithoutSourceResourceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: InputMaybe<NetworkCreateNestedOneWithoutSourceRedirectsInput>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSite?: InputMaybe<SiteCreateNestedOneWithoutSourceRedirectsInput>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVertical?: InputMaybe<VerticalCreateNestedOneWithoutSourceRedirectsInput>;
  targetKind: RedirectKind;
  targetNetwork?: InputMaybe<NetworkCreateNestedOneWithoutTargetRedirectsInput>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResource?: InputMaybe<RouteResourceCreateNestedOneWithoutTargetRedirectsInput>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSite?: InputMaybe<SiteCreateNestedOneWithoutTargetRedirectsInput>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVertical?: InputMaybe<VerticalCreateNestedOneWithoutTargetRedirectsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateWithoutSourceSiteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: InputMaybe<NetworkCreateNestedOneWithoutSourceRedirectsInput>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResource?: InputMaybe<RouteResourceCreateNestedOneWithoutSourceRedirectsInput>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVertical?: InputMaybe<VerticalCreateNestedOneWithoutSourceRedirectsInput>;
  targetKind: RedirectKind;
  targetNetwork?: InputMaybe<NetworkCreateNestedOneWithoutTargetRedirectsInput>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResource?: InputMaybe<RouteResourceCreateNestedOneWithoutTargetRedirectsInput>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSite?: InputMaybe<SiteCreateNestedOneWithoutTargetRedirectsInput>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVertical?: InputMaybe<VerticalCreateNestedOneWithoutTargetRedirectsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateWithoutSourceVerticalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: InputMaybe<NetworkCreateNestedOneWithoutSourceRedirectsInput>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResource?: InputMaybe<RouteResourceCreateNestedOneWithoutSourceRedirectsInput>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSite?: InputMaybe<SiteCreateNestedOneWithoutSourceRedirectsInput>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  targetKind: RedirectKind;
  targetNetwork?: InputMaybe<NetworkCreateNestedOneWithoutTargetRedirectsInput>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResource?: InputMaybe<RouteResourceCreateNestedOneWithoutTargetRedirectsInput>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSite?: InputMaybe<SiteCreateNestedOneWithoutTargetRedirectsInput>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVertical?: InputMaybe<VerticalCreateNestedOneWithoutTargetRedirectsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateWithoutTargetNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: InputMaybe<NetworkCreateNestedOneWithoutSourceRedirectsInput>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResource?: InputMaybe<RouteResourceCreateNestedOneWithoutSourceRedirectsInput>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSite?: InputMaybe<SiteCreateNestedOneWithoutSourceRedirectsInput>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVertical?: InputMaybe<VerticalCreateNestedOneWithoutSourceRedirectsInput>;
  targetKind: RedirectKind;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResource?: InputMaybe<RouteResourceCreateNestedOneWithoutTargetRedirectsInput>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSite?: InputMaybe<SiteCreateNestedOneWithoutTargetRedirectsInput>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVertical?: InputMaybe<VerticalCreateNestedOneWithoutTargetRedirectsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateWithoutTargetResourceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: InputMaybe<NetworkCreateNestedOneWithoutSourceRedirectsInput>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResource?: InputMaybe<RouteResourceCreateNestedOneWithoutSourceRedirectsInput>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSite?: InputMaybe<SiteCreateNestedOneWithoutSourceRedirectsInput>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVertical?: InputMaybe<VerticalCreateNestedOneWithoutSourceRedirectsInput>;
  targetKind: RedirectKind;
  targetNetwork?: InputMaybe<NetworkCreateNestedOneWithoutTargetRedirectsInput>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSite?: InputMaybe<SiteCreateNestedOneWithoutTargetRedirectsInput>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVertical?: InputMaybe<VerticalCreateNestedOneWithoutTargetRedirectsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateWithoutTargetSiteInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: InputMaybe<NetworkCreateNestedOneWithoutSourceRedirectsInput>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResource?: InputMaybe<RouteResourceCreateNestedOneWithoutSourceRedirectsInput>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSite?: InputMaybe<SiteCreateNestedOneWithoutSourceRedirectsInput>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVertical?: InputMaybe<VerticalCreateNestedOneWithoutSourceRedirectsInput>;
  targetKind: RedirectKind;
  targetNetwork?: InputMaybe<NetworkCreateNestedOneWithoutTargetRedirectsInput>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResource?: InputMaybe<RouteResourceCreateNestedOneWithoutTargetRedirectsInput>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  targetVertical?: InputMaybe<VerticalCreateNestedOneWithoutTargetRedirectsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RedirectCreateWithoutTargetVerticalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  httpCode?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  scope: RedirectScope;
  sourceKind: RedirectKind;
  sourceNetwork?: InputMaybe<NetworkCreateNestedOneWithoutSourceRedirectsInput>;
  sourcePath?: InputMaybe<Scalars['String']['input']>;
  sourceResource?: InputMaybe<RouteResourceCreateNestedOneWithoutSourceRedirectsInput>;
  sourceResourceType?: InputMaybe<RouteResourceType>;
  sourceSite?: InputMaybe<SiteCreateNestedOneWithoutSourceRedirectsInput>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  sourceVertical?: InputMaybe<VerticalCreateNestedOneWithoutSourceRedirectsInput>;
  targetKind: RedirectKind;
  targetNetwork?: InputMaybe<NetworkCreateNestedOneWithoutTargetRedirectsInput>;
  targetPath?: InputMaybe<Scalars['String']['input']>;
  targetResource?: InputMaybe<RouteResourceCreateNestedOneWithoutTargetRedirectsInput>;
  targetResourceType?: InputMaybe<RouteResourceType>;
  targetSite?: InputMaybe<SiteCreateNestedOneWithoutTargetRedirectsInput>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum RedirectKind {
  Path = 'path',
  Resource = 'resource',
  Url = 'url'
}

export type RedirectListRelationFilter = {
  every?: InputMaybe<RedirectWhereInput>;
  none?: InputMaybe<RedirectWhereInput>;
  some?: InputMaybe<RedirectWhereInput>;
};

export type RedirectOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RedirectOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  httpCode?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  scope?: InputMaybe<SortOrder>;
  sourceKind?: InputMaybe<SortOrder>;
  sourceNetwork?: InputMaybe<NetworkOrderByWithRelationInput>;
  sourceNetworkId?: InputMaybe<SortOrderInput>;
  sourcePath?: InputMaybe<SortOrderInput>;
  sourceResource?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  sourceResourceId?: InputMaybe<SortOrderInput>;
  sourceResourceType?: InputMaybe<SortOrderInput>;
  sourceSite?: InputMaybe<SiteOrderByWithRelationInput>;
  sourceSiteId?: InputMaybe<SortOrderInput>;
  sourceUrl?: InputMaybe<SortOrderInput>;
  sourceVertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  sourceVerticalId?: InputMaybe<SortOrderInput>;
  targetKind?: InputMaybe<SortOrder>;
  targetNetwork?: InputMaybe<NetworkOrderByWithRelationInput>;
  targetNetworkId?: InputMaybe<SortOrderInput>;
  targetPath?: InputMaybe<SortOrderInput>;
  targetResource?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  targetResourceId?: InputMaybe<SortOrderInput>;
  targetResourceType?: InputMaybe<SortOrderInput>;
  targetSite?: InputMaybe<SiteOrderByWithRelationInput>;
  targetSiteId?: InputMaybe<SortOrderInput>;
  targetUrl?: InputMaybe<SortOrderInput>;
  targetVertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  targetVerticalId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RedirectScalarWhereInput = {
  AND?: InputMaybe<Array<RedirectScalarWhereInput>>;
  NOT?: InputMaybe<Array<RedirectScalarWhereInput>>;
  OR?: InputMaybe<Array<RedirectScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  httpCode?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  scope?: InputMaybe<EnumRedirectScopeFilter>;
  sourceKind?: InputMaybe<EnumRedirectKindFilter>;
  sourceNetworkId?: InputMaybe<StringNullableFilter>;
  sourcePath?: InputMaybe<StringNullableFilter>;
  sourceResourceId?: InputMaybe<StringNullableFilter>;
  sourceResourceType?: InputMaybe<EnumRouteResourceTypeNullableFilter>;
  sourceSiteId?: InputMaybe<StringNullableFilter>;
  sourceUrl?: InputMaybe<StringNullableFilter>;
  sourceVerticalId?: InputMaybe<StringNullableFilter>;
  targetKind?: InputMaybe<EnumRedirectKindFilter>;
  targetNetworkId?: InputMaybe<StringNullableFilter>;
  targetPath?: InputMaybe<StringNullableFilter>;
  targetResourceId?: InputMaybe<StringNullableFilter>;
  targetResourceType?: InputMaybe<EnumRouteResourceTypeNullableFilter>;
  targetSiteId?: InputMaybe<StringNullableFilter>;
  targetUrl?: InputMaybe<StringNullableFilter>;
  targetVerticalId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum RedirectScope {
  Network = 'network',
  Site = 'site',
  Vertical = 'vertical'
}

export type RedirectUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourceNetwork?: InputMaybe<NetworkUpdateOneWithoutSourceRedirectsNestedInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResource?: InputMaybe<RouteResourceUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceSite?: InputMaybe<SiteUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceVertical?: InputMaybe<VerticalUpdateOneWithoutSourceRedirectsNestedInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetNetwork?: InputMaybe<NetworkUpdateOneWithoutTargetRedirectsNestedInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResource?: InputMaybe<RouteResourceUpdateOneWithoutTargetRedirectsNestedInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetSite?: InputMaybe<SiteUpdateOneWithoutTargetRedirectsNestedInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetVertical?: InputMaybe<VerticalUpdateOneWithoutTargetRedirectsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateManyWithWhereWithoutSourceNetworkInput = {
  data: RedirectUpdateManyMutationInput;
  where: RedirectScalarWhereInput;
};

export type RedirectUpdateManyWithWhereWithoutSourceResourceInput = {
  data: RedirectUpdateManyMutationInput;
  where: RedirectScalarWhereInput;
};

export type RedirectUpdateManyWithWhereWithoutSourceSiteInput = {
  data: RedirectUpdateManyMutationInput;
  where: RedirectScalarWhereInput;
};

export type RedirectUpdateManyWithWhereWithoutSourceVerticalInput = {
  data: RedirectUpdateManyMutationInput;
  where: RedirectScalarWhereInput;
};

export type RedirectUpdateManyWithWhereWithoutTargetNetworkInput = {
  data: RedirectUpdateManyMutationInput;
  where: RedirectScalarWhereInput;
};

export type RedirectUpdateManyWithWhereWithoutTargetResourceInput = {
  data: RedirectUpdateManyMutationInput;
  where: RedirectScalarWhereInput;
};

export type RedirectUpdateManyWithWhereWithoutTargetSiteInput = {
  data: RedirectUpdateManyMutationInput;
  where: RedirectScalarWhereInput;
};

export type RedirectUpdateManyWithWhereWithoutTargetVerticalInput = {
  data: RedirectUpdateManyMutationInput;
  where: RedirectScalarWhereInput;
};

export type RedirectUpdateManyWithoutSourceNetworkNestedInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutSourceNetworkInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutSourceNetworkInput>>;
  createMany?: InputMaybe<RedirectCreateManySourceNetworkInputEnvelope>;
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedirectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  update?: InputMaybe<Array<RedirectUpdateWithWhereUniqueWithoutSourceNetworkInput>>;
  updateMany?: InputMaybe<Array<RedirectUpdateManyWithWhereWithoutSourceNetworkInput>>;
  upsert?: InputMaybe<Array<RedirectUpsertWithWhereUniqueWithoutSourceNetworkInput>>;
};

export type RedirectUpdateManyWithoutSourceResourceNestedInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutSourceResourceInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutSourceResourceInput>>;
  createMany?: InputMaybe<RedirectCreateManySourceResourceInputEnvelope>;
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedirectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  update?: InputMaybe<Array<RedirectUpdateWithWhereUniqueWithoutSourceResourceInput>>;
  updateMany?: InputMaybe<Array<RedirectUpdateManyWithWhereWithoutSourceResourceInput>>;
  upsert?: InputMaybe<Array<RedirectUpsertWithWhereUniqueWithoutSourceResourceInput>>;
};

export type RedirectUpdateManyWithoutSourceSiteNestedInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutSourceSiteInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutSourceSiteInput>>;
  createMany?: InputMaybe<RedirectCreateManySourceSiteInputEnvelope>;
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedirectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  update?: InputMaybe<Array<RedirectUpdateWithWhereUniqueWithoutSourceSiteInput>>;
  updateMany?: InputMaybe<Array<RedirectUpdateManyWithWhereWithoutSourceSiteInput>>;
  upsert?: InputMaybe<Array<RedirectUpsertWithWhereUniqueWithoutSourceSiteInput>>;
};

export type RedirectUpdateManyWithoutSourceVerticalNestedInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutSourceVerticalInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutSourceVerticalInput>>;
  createMany?: InputMaybe<RedirectCreateManySourceVerticalInputEnvelope>;
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedirectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  update?: InputMaybe<Array<RedirectUpdateWithWhereUniqueWithoutSourceVerticalInput>>;
  updateMany?: InputMaybe<Array<RedirectUpdateManyWithWhereWithoutSourceVerticalInput>>;
  upsert?: InputMaybe<Array<RedirectUpsertWithWhereUniqueWithoutSourceVerticalInput>>;
};

export type RedirectUpdateManyWithoutTargetNetworkNestedInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutTargetNetworkInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutTargetNetworkInput>>;
  createMany?: InputMaybe<RedirectCreateManyTargetNetworkInputEnvelope>;
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedirectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  update?: InputMaybe<Array<RedirectUpdateWithWhereUniqueWithoutTargetNetworkInput>>;
  updateMany?: InputMaybe<Array<RedirectUpdateManyWithWhereWithoutTargetNetworkInput>>;
  upsert?: InputMaybe<Array<RedirectUpsertWithWhereUniqueWithoutTargetNetworkInput>>;
};

export type RedirectUpdateManyWithoutTargetResourceNestedInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutTargetResourceInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutTargetResourceInput>>;
  createMany?: InputMaybe<RedirectCreateManyTargetResourceInputEnvelope>;
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedirectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  update?: InputMaybe<Array<RedirectUpdateWithWhereUniqueWithoutTargetResourceInput>>;
  updateMany?: InputMaybe<Array<RedirectUpdateManyWithWhereWithoutTargetResourceInput>>;
  upsert?: InputMaybe<Array<RedirectUpsertWithWhereUniqueWithoutTargetResourceInput>>;
};

export type RedirectUpdateManyWithoutTargetSiteNestedInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutTargetSiteInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutTargetSiteInput>>;
  createMany?: InputMaybe<RedirectCreateManyTargetSiteInputEnvelope>;
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedirectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  update?: InputMaybe<Array<RedirectUpdateWithWhereUniqueWithoutTargetSiteInput>>;
  updateMany?: InputMaybe<Array<RedirectUpdateManyWithWhereWithoutTargetSiteInput>>;
  upsert?: InputMaybe<Array<RedirectUpsertWithWhereUniqueWithoutTargetSiteInput>>;
};

export type RedirectUpdateManyWithoutTargetVerticalNestedInput = {
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RedirectCreateOrConnectWithoutTargetVerticalInput>>;
  create?: InputMaybe<Array<RedirectCreateWithoutTargetVerticalInput>>;
  createMany?: InputMaybe<RedirectCreateManyTargetVerticalInputEnvelope>;
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RedirectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  update?: InputMaybe<Array<RedirectUpdateWithWhereUniqueWithoutTargetVerticalInput>>;
  updateMany?: InputMaybe<Array<RedirectUpdateManyWithWhereWithoutTargetVerticalInput>>;
  upsert?: InputMaybe<Array<RedirectUpsertWithWhereUniqueWithoutTargetVerticalInput>>;
};

export type RedirectUpdateWithWhereUniqueWithoutSourceNetworkInput = {
  data: RedirectUpdateWithoutSourceNetworkInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpdateWithWhereUniqueWithoutSourceResourceInput = {
  data: RedirectUpdateWithoutSourceResourceInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpdateWithWhereUniqueWithoutSourceSiteInput = {
  data: RedirectUpdateWithoutSourceSiteInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpdateWithWhereUniqueWithoutSourceVerticalInput = {
  data: RedirectUpdateWithoutSourceVerticalInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpdateWithWhereUniqueWithoutTargetNetworkInput = {
  data: RedirectUpdateWithoutTargetNetworkInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpdateWithWhereUniqueWithoutTargetResourceInput = {
  data: RedirectUpdateWithoutTargetResourceInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpdateWithWhereUniqueWithoutTargetSiteInput = {
  data: RedirectUpdateWithoutTargetSiteInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpdateWithWhereUniqueWithoutTargetVerticalInput = {
  data: RedirectUpdateWithoutTargetVerticalInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpdateWithoutSourceNetworkInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResource?: InputMaybe<RouteResourceUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceSite?: InputMaybe<SiteUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceVertical?: InputMaybe<VerticalUpdateOneWithoutSourceRedirectsNestedInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetNetwork?: InputMaybe<NetworkUpdateOneWithoutTargetRedirectsNestedInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResource?: InputMaybe<RouteResourceUpdateOneWithoutTargetRedirectsNestedInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetSite?: InputMaybe<SiteUpdateOneWithoutTargetRedirectsNestedInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetVertical?: InputMaybe<VerticalUpdateOneWithoutTargetRedirectsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateWithoutSourceResourceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourceNetwork?: InputMaybe<NetworkUpdateOneWithoutSourceRedirectsNestedInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceSite?: InputMaybe<SiteUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceVertical?: InputMaybe<VerticalUpdateOneWithoutSourceRedirectsNestedInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetNetwork?: InputMaybe<NetworkUpdateOneWithoutTargetRedirectsNestedInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResource?: InputMaybe<RouteResourceUpdateOneWithoutTargetRedirectsNestedInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetSite?: InputMaybe<SiteUpdateOneWithoutTargetRedirectsNestedInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetVertical?: InputMaybe<VerticalUpdateOneWithoutTargetRedirectsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateWithoutSourceSiteInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourceNetwork?: InputMaybe<NetworkUpdateOneWithoutSourceRedirectsNestedInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResource?: InputMaybe<RouteResourceUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceVertical?: InputMaybe<VerticalUpdateOneWithoutSourceRedirectsNestedInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetNetwork?: InputMaybe<NetworkUpdateOneWithoutTargetRedirectsNestedInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResource?: InputMaybe<RouteResourceUpdateOneWithoutTargetRedirectsNestedInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetSite?: InputMaybe<SiteUpdateOneWithoutTargetRedirectsNestedInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetVertical?: InputMaybe<VerticalUpdateOneWithoutTargetRedirectsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateWithoutSourceVerticalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourceNetwork?: InputMaybe<NetworkUpdateOneWithoutSourceRedirectsNestedInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResource?: InputMaybe<RouteResourceUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceSite?: InputMaybe<SiteUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetNetwork?: InputMaybe<NetworkUpdateOneWithoutTargetRedirectsNestedInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResource?: InputMaybe<RouteResourceUpdateOneWithoutTargetRedirectsNestedInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetSite?: InputMaybe<SiteUpdateOneWithoutTargetRedirectsNestedInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetVertical?: InputMaybe<VerticalUpdateOneWithoutTargetRedirectsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateWithoutTargetNetworkInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourceNetwork?: InputMaybe<NetworkUpdateOneWithoutSourceRedirectsNestedInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResource?: InputMaybe<RouteResourceUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceSite?: InputMaybe<SiteUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceVertical?: InputMaybe<VerticalUpdateOneWithoutSourceRedirectsNestedInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResource?: InputMaybe<RouteResourceUpdateOneWithoutTargetRedirectsNestedInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetSite?: InputMaybe<SiteUpdateOneWithoutTargetRedirectsNestedInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetVertical?: InputMaybe<VerticalUpdateOneWithoutTargetRedirectsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateWithoutTargetResourceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourceNetwork?: InputMaybe<NetworkUpdateOneWithoutSourceRedirectsNestedInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResource?: InputMaybe<RouteResourceUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceSite?: InputMaybe<SiteUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceVertical?: InputMaybe<VerticalUpdateOneWithoutSourceRedirectsNestedInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetNetwork?: InputMaybe<NetworkUpdateOneWithoutTargetRedirectsNestedInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetSite?: InputMaybe<SiteUpdateOneWithoutTargetRedirectsNestedInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetVertical?: InputMaybe<VerticalUpdateOneWithoutTargetRedirectsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateWithoutTargetSiteInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourceNetwork?: InputMaybe<NetworkUpdateOneWithoutSourceRedirectsNestedInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResource?: InputMaybe<RouteResourceUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceSite?: InputMaybe<SiteUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceVertical?: InputMaybe<VerticalUpdateOneWithoutSourceRedirectsNestedInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetNetwork?: InputMaybe<NetworkUpdateOneWithoutTargetRedirectsNestedInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResource?: InputMaybe<RouteResourceUpdateOneWithoutTargetRedirectsNestedInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetVertical?: InputMaybe<VerticalUpdateOneWithoutTargetRedirectsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpdateWithoutTargetVerticalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  httpCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  scope?: InputMaybe<EnumRedirectScopeFieldUpdateOperationsInput>;
  sourceKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  sourceNetwork?: InputMaybe<NetworkUpdateOneWithoutSourceRedirectsNestedInput>;
  sourcePath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceResource?: InputMaybe<RouteResourceUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  sourceSite?: InputMaybe<SiteUpdateOneWithoutSourceRedirectsNestedInput>;
  sourceUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sourceVertical?: InputMaybe<VerticalUpdateOneWithoutSourceRedirectsNestedInput>;
  targetKind?: InputMaybe<EnumRedirectKindFieldUpdateOperationsInput>;
  targetNetwork?: InputMaybe<NetworkUpdateOneWithoutTargetRedirectsNestedInput>;
  targetPath?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetResource?: InputMaybe<RouteResourceUpdateOneWithoutTargetRedirectsNestedInput>;
  targetResourceType?: InputMaybe<NullableEnumRouteResourceTypeFieldUpdateOperationsInput>;
  targetSite?: InputMaybe<SiteUpdateOneWithoutTargetRedirectsNestedInput>;
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RedirectUpsertWithWhereUniqueWithoutSourceNetworkInput = {
  create: RedirectCreateWithoutSourceNetworkInput;
  update: RedirectUpdateWithoutSourceNetworkInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertWithWhereUniqueWithoutSourceResourceInput = {
  create: RedirectCreateWithoutSourceResourceInput;
  update: RedirectUpdateWithoutSourceResourceInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertWithWhereUniqueWithoutSourceSiteInput = {
  create: RedirectCreateWithoutSourceSiteInput;
  update: RedirectUpdateWithoutSourceSiteInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertWithWhereUniqueWithoutSourceVerticalInput = {
  create: RedirectCreateWithoutSourceVerticalInput;
  update: RedirectUpdateWithoutSourceVerticalInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertWithWhereUniqueWithoutTargetNetworkInput = {
  create: RedirectCreateWithoutTargetNetworkInput;
  update: RedirectUpdateWithoutTargetNetworkInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertWithWhereUniqueWithoutTargetResourceInput = {
  create: RedirectCreateWithoutTargetResourceInput;
  update: RedirectUpdateWithoutTargetResourceInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertWithWhereUniqueWithoutTargetSiteInput = {
  create: RedirectCreateWithoutTargetSiteInput;
  update: RedirectUpdateWithoutTargetSiteInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertWithWhereUniqueWithoutTargetVerticalInput = {
  create: RedirectCreateWithoutTargetVerticalInput;
  update: RedirectUpdateWithoutTargetVerticalInput;
  where: RedirectWhereUniqueInput;
};

export type RedirectWhereInput = {
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  httpCode?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  scope?: InputMaybe<EnumRedirectScopeFilter>;
  sourceKind?: InputMaybe<EnumRedirectKindFilter>;
  sourceNetwork?: InputMaybe<NetworkWhereInput>;
  sourceNetworkId?: InputMaybe<StringNullableFilter>;
  sourcePath?: InputMaybe<StringNullableFilter>;
  sourceResource?: InputMaybe<RouteResourceWhereInput>;
  sourceResourceId?: InputMaybe<StringNullableFilter>;
  sourceResourceType?: InputMaybe<EnumRouteResourceTypeNullableFilter>;
  sourceSite?: InputMaybe<SiteWhereInput>;
  sourceSiteId?: InputMaybe<StringNullableFilter>;
  sourceUrl?: InputMaybe<StringNullableFilter>;
  sourceVertical?: InputMaybe<VerticalWhereInput>;
  sourceVerticalId?: InputMaybe<StringNullableFilter>;
  targetKind?: InputMaybe<EnumRedirectKindFilter>;
  targetNetwork?: InputMaybe<NetworkWhereInput>;
  targetNetworkId?: InputMaybe<StringNullableFilter>;
  targetPath?: InputMaybe<StringNullableFilter>;
  targetResource?: InputMaybe<RouteResourceWhereInput>;
  targetResourceId?: InputMaybe<StringNullableFilter>;
  targetResourceType?: InputMaybe<EnumRouteResourceTypeNullableFilter>;
  targetSite?: InputMaybe<SiteWhereInput>;
  targetSiteId?: InputMaybe<StringNullableFilter>;
  targetUrl?: InputMaybe<StringNullableFilter>;
  targetVertical?: InputMaybe<VerticalWhereInput>;
  targetVerticalId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RedirectWhereUniqueInput = {
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  httpCode?: InputMaybe<IntFilter>;
  id: Scalars['String']['input'];
  scope?: InputMaybe<EnumRedirectScopeFilter>;
  sourceKind?: InputMaybe<EnumRedirectKindFilter>;
  sourceNetwork?: InputMaybe<NetworkWhereInput>;
  sourceNetworkId?: InputMaybe<StringNullableFilter>;
  sourcePath?: InputMaybe<StringNullableFilter>;
  sourceResource?: InputMaybe<RouteResourceWhereInput>;
  sourceResourceId?: InputMaybe<StringNullableFilter>;
  sourceResourceType?: InputMaybe<EnumRouteResourceTypeNullableFilter>;
  sourceSite?: InputMaybe<SiteWhereInput>;
  sourceSiteId?: InputMaybe<StringNullableFilter>;
  sourceUrl?: InputMaybe<StringNullableFilter>;
  sourceVertical?: InputMaybe<VerticalWhereInput>;
  sourceVerticalId?: InputMaybe<StringNullableFilter>;
  targetKind?: InputMaybe<EnumRedirectKindFilter>;
  targetNetwork?: InputMaybe<NetworkWhereInput>;
  targetNetworkId?: InputMaybe<StringNullableFilter>;
  targetPath?: InputMaybe<StringNullableFilter>;
  targetResource?: InputMaybe<RouteResourceWhereInput>;
  targetResourceId?: InputMaybe<StringNullableFilter>;
  targetResourceType?: InputMaybe<EnumRouteResourceTypeNullableFilter>;
  targetSite?: InputMaybe<SiteWhereInput>;
  targetSiteId?: InputMaybe<StringNullableFilter>;
  targetUrl?: InputMaybe<StringNullableFilter>;
  targetVertical?: InputMaybe<VerticalWhereInput>;
  targetVerticalId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subregions: Array<Subregion>;
};


export type RegionSubregionsArgs = {
  cursor?: InputMaybe<SubregionWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubregionWhereInput>;
};

export type RegionCreateInput = {
  countries?: InputMaybe<CountryCreateNestedManyWithoutRegionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subregions?: InputMaybe<SubregionCreateNestedManyWithoutRegionInput>;
};

export type RegionCreateNestedOneWithoutCountriesInput = {
  connect?: InputMaybe<RegionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegionCreateOrConnectWithoutCountriesInput>;
  create?: InputMaybe<RegionCreateWithoutCountriesInput>;
};

export type RegionCreateNestedOneWithoutSubregionsInput = {
  connect?: InputMaybe<RegionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegionCreateOrConnectWithoutSubregionsInput>;
  create?: InputMaybe<RegionCreateWithoutSubregionsInput>;
};

export type RegionCreateOrConnectWithoutCountriesInput = {
  create: RegionCreateWithoutCountriesInput;
  where: RegionWhereUniqueInput;
};

export type RegionCreateOrConnectWithoutSubregionsInput = {
  create: RegionCreateWithoutSubregionsInput;
  where: RegionWhereUniqueInput;
};

export type RegionCreateWithoutCountriesInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subregions?: InputMaybe<SubregionCreateNestedManyWithoutRegionInput>;
};

export type RegionCreateWithoutSubregionsInput = {
  countries?: InputMaybe<CountryCreateNestedManyWithoutRegionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type RegionOrderByWithRelationInput = {
  countries?: InputMaybe<CountryOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  subregions?: InputMaybe<SubregionOrderByRelationAggregateInput>;
};

export type RegionUpdateInput = {
  countries?: InputMaybe<CountryUpdateManyWithoutRegionNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  subregions?: InputMaybe<SubregionUpdateManyWithoutRegionNestedInput>;
};

export type RegionUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegionUpdateOneRequiredWithoutSubregionsNestedInput = {
  connect?: InputMaybe<RegionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegionCreateOrConnectWithoutSubregionsInput>;
  create?: InputMaybe<RegionCreateWithoutSubregionsInput>;
  update?: InputMaybe<RegionUpdateToOneWithWhereWithoutSubregionsInput>;
  upsert?: InputMaybe<RegionUpsertWithoutSubregionsInput>;
};

export type RegionUpdateOneWithoutCountriesNestedInput = {
  connect?: InputMaybe<RegionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegionCreateOrConnectWithoutCountriesInput>;
  create?: InputMaybe<RegionCreateWithoutCountriesInput>;
  delete?: InputMaybe<RegionWhereInput>;
  disconnect?: InputMaybe<RegionWhereInput>;
  update?: InputMaybe<RegionUpdateToOneWithWhereWithoutCountriesInput>;
  upsert?: InputMaybe<RegionUpsertWithoutCountriesInput>;
};

export type RegionUpdateToOneWithWhereWithoutCountriesInput = {
  data: RegionUpdateWithoutCountriesInput;
  where?: InputMaybe<RegionWhereInput>;
};

export type RegionUpdateToOneWithWhereWithoutSubregionsInput = {
  data: RegionUpdateWithoutSubregionsInput;
  where?: InputMaybe<RegionWhereInput>;
};

export type RegionUpdateWithoutCountriesInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  subregions?: InputMaybe<SubregionUpdateManyWithoutRegionNestedInput>;
};

export type RegionUpdateWithoutSubregionsInput = {
  countries?: InputMaybe<CountryUpdateManyWithoutRegionNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegionUpsertWithoutCountriesInput = {
  create: RegionCreateWithoutCountriesInput;
  update: RegionUpdateWithoutCountriesInput;
  where?: InputMaybe<RegionWhereInput>;
};

export type RegionUpsertWithoutSubregionsInput = {
  create: RegionCreateWithoutSubregionsInput;
  update: RegionUpdateWithoutSubregionsInput;
  where?: InputMaybe<RegionWhereInput>;
};

export type RegionWhereInput = {
  AND?: InputMaybe<Array<RegionWhereInput>>;
  NOT?: InputMaybe<Array<RegionWhereInput>>;
  OR?: InputMaybe<Array<RegionWhereInput>>;
  countries?: InputMaybe<CountryListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  subregions?: InputMaybe<SubregionListRelationFilter>;
};

export type RegionWhereUniqueInput = {
  AND?: InputMaybe<Array<RegionWhereInput>>;
  NOT?: InputMaybe<Array<RegionWhereInput>>;
  OR?: InputMaybe<Array<RegionWhereInput>>;
  countries?: InputMaybe<CountryListRelationFilter>;
  id: Scalars['String']['input'];
  name?: InputMaybe<StringFilter>;
  subregions?: InputMaybe<SubregionListRelationFilter>;
};

export type RegulatoryHelpOrganizationCreateManyLogoInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  regulatoryMarketId?: InputMaybe<Scalars['String']['input']>;
};

export type RegulatoryHelpOrganizationCreateManyLogoInputEnvelope = {
  data?: InputMaybe<Array<RegulatoryHelpOrganizationCreateManyLogoInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegulatoryHelpOrganizationCreateNestedManyWithoutLogoInput = {
  connect?: InputMaybe<Array<RegulatoryHelpOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegulatoryHelpOrganizationCreateOrConnectWithoutLogoInput>>;
  create?: InputMaybe<Array<RegulatoryHelpOrganizationCreateWithoutLogoInput>>;
  createMany?: InputMaybe<RegulatoryHelpOrganizationCreateManyLogoInputEnvelope>;
};

export type RegulatoryHelpOrganizationCreateNestedOneWithoutRegulatoryMarketLinkInput = {
  connect?: InputMaybe<RegulatoryHelpOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegulatoryHelpOrganizationCreateOrConnectWithoutRegulatoryMarketLinkInput>;
  create?: InputMaybe<RegulatoryHelpOrganizationCreateWithoutRegulatoryMarketLinkInput>;
};

export type RegulatoryHelpOrganizationCreateOrConnectWithoutLogoInput = {
  create: RegulatoryHelpOrganizationCreateWithoutLogoInput;
  where: RegulatoryHelpOrganizationWhereUniqueInput;
};

export type RegulatoryHelpOrganizationCreateOrConnectWithoutRegulatoryMarketLinkInput = {
  create: RegulatoryHelpOrganizationCreateWithoutRegulatoryMarketLinkInput;
  where: RegulatoryHelpOrganizationWhereUniqueInput;
};

export type RegulatoryHelpOrganizationCreateWithoutLogoInput = {
  RegulatoryMarketLink?: InputMaybe<RegulatoryMarketLinkCreateNestedManyWithoutOrganizationInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  regulatoryMarketId?: InputMaybe<Scalars['String']['input']>;
};

export type RegulatoryHelpOrganizationCreateWithoutRegulatoryMarketLinkInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  logo: MediaItemCreateNestedOneWithoutRegulatoryHelpOrganizationInput;
  name: Scalars['String']['input'];
  regulatoryMarketId?: InputMaybe<Scalars['String']['input']>;
};

export type RegulatoryHelpOrganizationListRelationFilter = {
  every?: InputMaybe<RegulatoryHelpOrganizationWhereInput>;
  none?: InputMaybe<RegulatoryHelpOrganizationWhereInput>;
  some?: InputMaybe<RegulatoryHelpOrganizationWhereInput>;
};

export type RegulatoryHelpOrganizationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RegulatoryHelpOrganizationScalarWhereInput = {
  AND?: InputMaybe<Array<RegulatoryHelpOrganizationScalarWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryHelpOrganizationScalarWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryHelpOrganizationScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  mediaItemId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  regulatoryMarketId?: InputMaybe<StringNullableFilter>;
};

export type RegulatoryHelpOrganizationUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  regulatoryMarketId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RegulatoryHelpOrganizationUpdateManyWithWhereWithoutLogoInput = {
  data: RegulatoryHelpOrganizationUpdateManyMutationInput;
  where: RegulatoryHelpOrganizationScalarWhereInput;
};

export type RegulatoryHelpOrganizationUpdateManyWithoutLogoNestedInput = {
  connect?: InputMaybe<Array<RegulatoryHelpOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegulatoryHelpOrganizationCreateOrConnectWithoutLogoInput>>;
  create?: InputMaybe<Array<RegulatoryHelpOrganizationCreateWithoutLogoInput>>;
  createMany?: InputMaybe<RegulatoryHelpOrganizationCreateManyLogoInputEnvelope>;
  delete?: InputMaybe<Array<RegulatoryHelpOrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RegulatoryHelpOrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RegulatoryHelpOrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<RegulatoryHelpOrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<RegulatoryHelpOrganizationUpdateWithWhereUniqueWithoutLogoInput>>;
  updateMany?: InputMaybe<Array<RegulatoryHelpOrganizationUpdateManyWithWhereWithoutLogoInput>>;
  upsert?: InputMaybe<Array<RegulatoryHelpOrganizationUpsertWithWhereUniqueWithoutLogoInput>>;
};

export type RegulatoryHelpOrganizationUpdateOneRequiredWithoutRegulatoryMarketLinkNestedInput = {
  connect?: InputMaybe<RegulatoryHelpOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegulatoryHelpOrganizationCreateOrConnectWithoutRegulatoryMarketLinkInput>;
  create?: InputMaybe<RegulatoryHelpOrganizationCreateWithoutRegulatoryMarketLinkInput>;
  update?: InputMaybe<RegulatoryHelpOrganizationUpdateToOneWithWhereWithoutRegulatoryMarketLinkInput>;
  upsert?: InputMaybe<RegulatoryHelpOrganizationUpsertWithoutRegulatoryMarketLinkInput>;
};

export type RegulatoryHelpOrganizationUpdateToOneWithWhereWithoutRegulatoryMarketLinkInput = {
  data: RegulatoryHelpOrganizationUpdateWithoutRegulatoryMarketLinkInput;
  where?: InputMaybe<RegulatoryHelpOrganizationWhereInput>;
};

export type RegulatoryHelpOrganizationUpdateWithWhereUniqueWithoutLogoInput = {
  data: RegulatoryHelpOrganizationUpdateWithoutLogoInput;
  where: RegulatoryHelpOrganizationWhereUniqueInput;
};

export type RegulatoryHelpOrganizationUpdateWithoutLogoInput = {
  RegulatoryMarketLink?: InputMaybe<RegulatoryMarketLinkUpdateManyWithoutOrganizationNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  regulatoryMarketId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RegulatoryHelpOrganizationUpdateWithoutRegulatoryMarketLinkInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  logo?: InputMaybe<MediaItemUpdateOneRequiredWithoutRegulatoryHelpOrganizationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  regulatoryMarketId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type RegulatoryHelpOrganizationUpsertWithWhereUniqueWithoutLogoInput = {
  create: RegulatoryHelpOrganizationCreateWithoutLogoInput;
  update: RegulatoryHelpOrganizationUpdateWithoutLogoInput;
  where: RegulatoryHelpOrganizationWhereUniqueInput;
};

export type RegulatoryHelpOrganizationUpsertWithoutRegulatoryMarketLinkInput = {
  create: RegulatoryHelpOrganizationCreateWithoutRegulatoryMarketLinkInput;
  update: RegulatoryHelpOrganizationUpdateWithoutRegulatoryMarketLinkInput;
  where?: InputMaybe<RegulatoryHelpOrganizationWhereInput>;
};

export type RegulatoryHelpOrganizationWhereInput = {
  AND?: InputMaybe<Array<RegulatoryHelpOrganizationWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryHelpOrganizationWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryHelpOrganizationWhereInput>>;
  RegulatoryMarketLink?: InputMaybe<RegulatoryMarketLinkListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  logo?: InputMaybe<MediaItemWhereInput>;
  mediaItemId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  regulatoryMarketId?: InputMaybe<StringNullableFilter>;
};

export type RegulatoryHelpOrganizationWhereUniqueInput = {
  AND?: InputMaybe<Array<RegulatoryHelpOrganizationWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryHelpOrganizationWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryHelpOrganizationWhereInput>>;
  RegulatoryMarketLink?: InputMaybe<RegulatoryMarketLinkListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<MediaItemWhereInput>;
  mediaItemId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  regulatoryMarketId?: InputMaybe<StringNullableFilter>;
};

export type RegulatoryMarketCreateManyAgeLimitLogoInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitorCountry: Scalars['String']['input'];
};

export type RegulatoryMarketCreateManyAgeLimitLogoInputEnvelope = {
  data?: InputMaybe<Array<RegulatoryMarketCreateManyAgeLimitLogoInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegulatoryMarketCreateNestedManyWithoutAgeLimitLogoInput = {
  connect?: InputMaybe<Array<RegulatoryMarketWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegulatoryMarketCreateOrConnectWithoutAgeLimitLogoInput>>;
  create?: InputMaybe<Array<RegulatoryMarketCreateWithoutAgeLimitLogoInput>>;
  createMany?: InputMaybe<RegulatoryMarketCreateManyAgeLimitLogoInputEnvelope>;
};

export type RegulatoryMarketCreateNestedOneWithoutLinksInput = {
  connect?: InputMaybe<RegulatoryMarketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegulatoryMarketCreateOrConnectWithoutLinksInput>;
  create?: InputMaybe<RegulatoryMarketCreateWithoutLinksInput>;
};

export type RegulatoryMarketCreateOrConnectWithoutAgeLimitLogoInput = {
  create: RegulatoryMarketCreateWithoutAgeLimitLogoInput;
  where: RegulatoryMarketWhereUniqueInput;
};

export type RegulatoryMarketCreateOrConnectWithoutLinksInput = {
  create: RegulatoryMarketCreateWithoutLinksInput;
  where: RegulatoryMarketWhereUniqueInput;
};

export type RegulatoryMarketCreateWithoutAgeLimitLogoInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<RegulatoryMarketLinkCreateNestedManyWithoutRegulatoryMarketInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitorCountry: Scalars['String']['input'];
};

export type RegulatoryMarketCreateWithoutLinksInput = {
  ageLimitLogo: MediaItemCreateNestedOneWithoutRegulatoryMarketInput;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  visitorCountry: Scalars['String']['input'];
};

export type RegulatoryMarketLinkCreateManyOrganizationInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  regulatoryMarketId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type RegulatoryMarketLinkCreateManyOrganizationInputEnvelope = {
  data?: InputMaybe<Array<RegulatoryMarketLinkCreateManyOrganizationInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegulatoryMarketLinkCreateManyRegulatoryMarketInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  regulatoryHelpOrganizationId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type RegulatoryMarketLinkCreateManyRegulatoryMarketInputEnvelope = {
  data?: InputMaybe<Array<RegulatoryMarketLinkCreateManyRegulatoryMarketInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegulatoryMarketLinkCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegulatoryMarketLinkCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<RegulatoryMarketLinkCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<RegulatoryMarketLinkCreateManyOrganizationInputEnvelope>;
};

export type RegulatoryMarketLinkCreateNestedManyWithoutRegulatoryMarketInput = {
  connect?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegulatoryMarketLinkCreateOrConnectWithoutRegulatoryMarketInput>>;
  create?: InputMaybe<Array<RegulatoryMarketLinkCreateWithoutRegulatoryMarketInput>>;
  createMany?: InputMaybe<RegulatoryMarketLinkCreateManyRegulatoryMarketInputEnvelope>;
};

export type RegulatoryMarketLinkCreateOrConnectWithoutOrganizationInput = {
  create: RegulatoryMarketLinkCreateWithoutOrganizationInput;
  where: RegulatoryMarketLinkWhereUniqueInput;
};

export type RegulatoryMarketLinkCreateOrConnectWithoutRegulatoryMarketInput = {
  create: RegulatoryMarketLinkCreateWithoutRegulatoryMarketInput;
  where: RegulatoryMarketLinkWhereUniqueInput;
};

export type RegulatoryMarketLinkCreateWithoutOrganizationInput = {
  RegulatoryMarket?: InputMaybe<RegulatoryMarketCreateNestedOneWithoutLinksInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type RegulatoryMarketLinkCreateWithoutRegulatoryMarketInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  organization: RegulatoryHelpOrganizationCreateNestedOneWithoutRegulatoryMarketLinkInput;
  url: Scalars['String']['input'];
};

export type RegulatoryMarketLinkListRelationFilter = {
  every?: InputMaybe<RegulatoryMarketLinkWhereInput>;
  none?: InputMaybe<RegulatoryMarketLinkWhereInput>;
  some?: InputMaybe<RegulatoryMarketLinkWhereInput>;
};

export type RegulatoryMarketLinkScalarWhereInput = {
  AND?: InputMaybe<Array<RegulatoryMarketLinkScalarWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryMarketLinkScalarWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryMarketLinkScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  regulatoryHelpOrganizationId?: InputMaybe<StringFilter>;
  regulatoryMarketId?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

export type RegulatoryMarketLinkUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegulatoryMarketLinkUpdateManyWithWhereWithoutOrganizationInput = {
  data: RegulatoryMarketLinkUpdateManyMutationInput;
  where: RegulatoryMarketLinkScalarWhereInput;
};

export type RegulatoryMarketLinkUpdateManyWithWhereWithoutRegulatoryMarketInput = {
  data: RegulatoryMarketLinkUpdateManyMutationInput;
  where: RegulatoryMarketLinkScalarWhereInput;
};

export type RegulatoryMarketLinkUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegulatoryMarketLinkCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<RegulatoryMarketLinkCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<RegulatoryMarketLinkCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RegulatoryMarketLinkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  set?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  update?: InputMaybe<Array<RegulatoryMarketLinkUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<RegulatoryMarketLinkUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<RegulatoryMarketLinkUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type RegulatoryMarketLinkUpdateManyWithoutRegulatoryMarketNestedInput = {
  connect?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegulatoryMarketLinkCreateOrConnectWithoutRegulatoryMarketInput>>;
  create?: InputMaybe<Array<RegulatoryMarketLinkCreateWithoutRegulatoryMarketInput>>;
  createMany?: InputMaybe<RegulatoryMarketLinkCreateManyRegulatoryMarketInputEnvelope>;
  delete?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RegulatoryMarketLinkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  set?: InputMaybe<Array<RegulatoryMarketLinkWhereUniqueInput>>;
  update?: InputMaybe<Array<RegulatoryMarketLinkUpdateWithWhereUniqueWithoutRegulatoryMarketInput>>;
  updateMany?: InputMaybe<Array<RegulatoryMarketLinkUpdateManyWithWhereWithoutRegulatoryMarketInput>>;
  upsert?: InputMaybe<Array<RegulatoryMarketLinkUpsertWithWhereUniqueWithoutRegulatoryMarketInput>>;
};

export type RegulatoryMarketLinkUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: RegulatoryMarketLinkUpdateWithoutOrganizationInput;
  where: RegulatoryMarketLinkWhereUniqueInput;
};

export type RegulatoryMarketLinkUpdateWithWhereUniqueWithoutRegulatoryMarketInput = {
  data: RegulatoryMarketLinkUpdateWithoutRegulatoryMarketInput;
  where: RegulatoryMarketLinkWhereUniqueInput;
};

export type RegulatoryMarketLinkUpdateWithoutOrganizationInput = {
  RegulatoryMarket?: InputMaybe<RegulatoryMarketUpdateOneWithoutLinksNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegulatoryMarketLinkUpdateWithoutRegulatoryMarketInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  organization?: InputMaybe<RegulatoryHelpOrganizationUpdateOneRequiredWithoutRegulatoryMarketLinkNestedInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegulatoryMarketLinkUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: RegulatoryMarketLinkCreateWithoutOrganizationInput;
  update: RegulatoryMarketLinkUpdateWithoutOrganizationInput;
  where: RegulatoryMarketLinkWhereUniqueInput;
};

export type RegulatoryMarketLinkUpsertWithWhereUniqueWithoutRegulatoryMarketInput = {
  create: RegulatoryMarketLinkCreateWithoutRegulatoryMarketInput;
  update: RegulatoryMarketLinkUpdateWithoutRegulatoryMarketInput;
  where: RegulatoryMarketLinkWhereUniqueInput;
};

export type RegulatoryMarketLinkWhereInput = {
  AND?: InputMaybe<Array<RegulatoryMarketLinkWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryMarketLinkWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryMarketLinkWhereInput>>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketWhereInput>;
  id?: InputMaybe<StringFilter>;
  organization?: InputMaybe<RegulatoryHelpOrganizationWhereInput>;
  regulatoryHelpOrganizationId?: InputMaybe<StringFilter>;
  regulatoryMarketId?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

export type RegulatoryMarketLinkWhereUniqueInput = {
  AND?: InputMaybe<Array<RegulatoryMarketLinkWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryMarketLinkWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryMarketLinkWhereInput>>;
  RegulatoryMarket?: InputMaybe<RegulatoryMarketWhereInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<RegulatoryHelpOrganizationWhereInput>;
  regulatoryHelpOrganizationId?: InputMaybe<StringFilter>;
  regulatoryMarketId?: InputMaybe<StringNullableFilter>;
  url?: InputMaybe<StringFilter>;
};

export type RegulatoryMarketListRelationFilter = {
  every?: InputMaybe<RegulatoryMarketWhereInput>;
  none?: InputMaybe<RegulatoryMarketWhereInput>;
  some?: InputMaybe<RegulatoryMarketWhereInput>;
};

export type RegulatoryMarketOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RegulatoryMarketScalarWhereInput = {
  AND?: InputMaybe<Array<RegulatoryMarketScalarWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryMarketScalarWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryMarketScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  mediaItemId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visitorCountry?: InputMaybe<StringFilter>;
};

export type RegulatoryMarketUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitorCountry?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegulatoryMarketUpdateManyWithWhereWithoutAgeLimitLogoInput = {
  data: RegulatoryMarketUpdateManyMutationInput;
  where: RegulatoryMarketScalarWhereInput;
};

export type RegulatoryMarketUpdateManyWithoutAgeLimitLogoNestedInput = {
  connect?: InputMaybe<Array<RegulatoryMarketWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RegulatoryMarketCreateOrConnectWithoutAgeLimitLogoInput>>;
  create?: InputMaybe<Array<RegulatoryMarketCreateWithoutAgeLimitLogoInput>>;
  createMany?: InputMaybe<RegulatoryMarketCreateManyAgeLimitLogoInputEnvelope>;
  delete?: InputMaybe<Array<RegulatoryMarketWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RegulatoryMarketScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RegulatoryMarketWhereUniqueInput>>;
  set?: InputMaybe<Array<RegulatoryMarketWhereUniqueInput>>;
  update?: InputMaybe<Array<RegulatoryMarketUpdateWithWhereUniqueWithoutAgeLimitLogoInput>>;
  updateMany?: InputMaybe<Array<RegulatoryMarketUpdateManyWithWhereWithoutAgeLimitLogoInput>>;
  upsert?: InputMaybe<Array<RegulatoryMarketUpsertWithWhereUniqueWithoutAgeLimitLogoInput>>;
};

export type RegulatoryMarketUpdateOneWithoutLinksNestedInput = {
  connect?: InputMaybe<RegulatoryMarketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RegulatoryMarketCreateOrConnectWithoutLinksInput>;
  create?: InputMaybe<RegulatoryMarketCreateWithoutLinksInput>;
  delete?: InputMaybe<RegulatoryMarketWhereInput>;
  disconnect?: InputMaybe<RegulatoryMarketWhereInput>;
  update?: InputMaybe<RegulatoryMarketUpdateToOneWithWhereWithoutLinksInput>;
  upsert?: InputMaybe<RegulatoryMarketUpsertWithoutLinksInput>;
};

export type RegulatoryMarketUpdateToOneWithWhereWithoutLinksInput = {
  data: RegulatoryMarketUpdateWithoutLinksInput;
  where?: InputMaybe<RegulatoryMarketWhereInput>;
};

export type RegulatoryMarketUpdateWithWhereUniqueWithoutAgeLimitLogoInput = {
  data: RegulatoryMarketUpdateWithoutAgeLimitLogoInput;
  where: RegulatoryMarketWhereUniqueInput;
};

export type RegulatoryMarketUpdateWithoutAgeLimitLogoInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  links?: InputMaybe<RegulatoryMarketLinkUpdateManyWithoutRegulatoryMarketNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitorCountry?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegulatoryMarketUpdateWithoutLinksInput = {
  ageLimitLogo?: InputMaybe<MediaItemUpdateOneRequiredWithoutRegulatoryMarketNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  visitorCountry?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegulatoryMarketUpsertWithWhereUniqueWithoutAgeLimitLogoInput = {
  create: RegulatoryMarketCreateWithoutAgeLimitLogoInput;
  update: RegulatoryMarketUpdateWithoutAgeLimitLogoInput;
  where: RegulatoryMarketWhereUniqueInput;
};

export type RegulatoryMarketUpsertWithoutLinksInput = {
  create: RegulatoryMarketCreateWithoutLinksInput;
  update: RegulatoryMarketUpdateWithoutLinksInput;
  where?: InputMaybe<RegulatoryMarketWhereInput>;
};

export type RegulatoryMarketWhereInput = {
  AND?: InputMaybe<Array<RegulatoryMarketWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryMarketWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryMarketWhereInput>>;
  ageLimitLogo?: InputMaybe<MediaItemWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  links?: InputMaybe<RegulatoryMarketLinkListRelationFilter>;
  mediaItemId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visitorCountry?: InputMaybe<StringFilter>;
};

export type RegulatoryMarketWhereUniqueInput = {
  AND?: InputMaybe<Array<RegulatoryMarketWhereInput>>;
  NOT?: InputMaybe<Array<RegulatoryMarketWhereInput>>;
  OR?: InputMaybe<Array<RegulatoryMarketWhereInput>>;
  ageLimitLogo?: InputMaybe<MediaItemWhereInput>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<RegulatoryMarketLinkListRelationFilter>;
  mediaItemId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  visitorCountry?: InputMaybe<StringFilter>;
};

export type ResolvedDataUnion = MediaItem | Product | TaxonomyItem;

/** Current context for the resource */
export type ResourceConfigInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  vertical?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceContentInput = {
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  items?: InputMaybe<Array<InputMaybe<ResourceContentItemInput>>>;
  language: LanguageWhereUniqueInput;
  shouldBeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCreateInlineImages?: InputMaybe<Scalars['Boolean']['input']>;
  translate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResourceContentItemInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  shouldBeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCreateInlineImages?: InputMaybe<Scalars['Boolean']['input']>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation: StringItemTranslationType;
  variant: Scalars['Int']['input'];
};

export type ResourceCurrentInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  vertical?: InputMaybe<Scalars['String']['input']>;
};

/** Type for Filters. Use "properties" to send a properties for filtering! */
export type ResourceFiltersInput = {
  properties?: InputMaybe<Array<InputMaybe<ResourceFiltersInputProperties>>>;
};

export type ResourceFiltersInputProperties = {
  arrayValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  networkIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ResourcePropertyType>;
};

export type ResourceHistory = {
  __typename?: 'ResourceHistory';
  changedKeys?: Maybe<HistoryChangedKeys>;
  data?: Maybe<Scalars['JSON']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  previousData?: Maybe<Scalars['JSON']['output']>;
  user?: Maybe<User>;
};

export type ResourcePropertyInput = {
  items?: InputMaybe<Array<InputMaybe<ResourcePropertyItemInput>>>;
};

export type ResourcePropertyItemInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  key: Scalars['String']['input'];
};

export enum ResourcePropertyType {
  Array = 'array',
  Boolean = 'boolean',
  GlobalPublished = 'globalPublished',
  String = 'string',
  Vertical = 'vertical'
}

/** Type for Search By Text. Use "content & strings" OR "properties" but not both! */
export type ResourceSearchWhereInput = {
  content?: InputMaybe<ContentItemWhereInput>;
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  properties?: InputMaybe<ResourceSearchWhereInputProperties>;
  string?: InputMaybe<Scalars['String']['input']>;
};

export type ResourceSearchWhereInputProperties = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ResourceType {
  Content = 'CONTENT',
  Property = 'PROPERTY'
}

export type RouteResource = {
  __typename?: 'RouteResource';
  content: Array<ContentItemV2>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['String']['output'];
  network?: Maybe<Network>;
  networkId?: Maybe<Scalars['String']['output']>;
  properties: Array<PropertyItem>;
  resourceType: RouteResourceType;
  updatedAt: Scalars['DateTime']['output'];
  vertical?: Maybe<Vertical>;
  verticalId?: Maybe<Scalars['String']['output']>;
};


export type RouteResourceContentArgs = {
  cursor?: InputMaybe<ContentItemV2WhereUniqueInput>;
  orderBy?: InputMaybe<Array<ContentItemV2OrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type RouteResourceNetworkArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type RouteResourcePropertiesArgs = {
  cursor?: InputMaybe<PropertyItemWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};


export type RouteResourceVerticalArgs = {
  where?: InputMaybe<VerticalWhereInput>;
};

export type RouteResourceCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  resourceType: RouteResourceType;
  secondaryParentId?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type RouteResourceCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<RouteResourceCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RouteResourceCreateManyParentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  resourceType: RouteResourceType;
  secondaryParentId?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type RouteResourceCreateManyParentInputEnvelope = {
  data?: InputMaybe<Array<RouteResourceCreateManyParentInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RouteResourceCreateManySecondaryParentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  resourceType: RouteResourceType;
  subtype?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalId?: InputMaybe<Scalars['String']['input']>;
};

export type RouteResourceCreateManySecondaryParentInputEnvelope = {
  data?: InputMaybe<Array<RouteResourceCreateManySecondaryParentInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RouteResourceCreateManyVerticalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  resourceType: RouteResourceType;
  secondaryParentId?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RouteResourceCreateManyVerticalInputEnvelope = {
  data?: InputMaybe<Array<RouteResourceCreateManyVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RouteResourceCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<RouteResourceCreateManyNetworkInputEnvelope>;
};

export type RouteResourceCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutParentInput>>;
  createMany?: InputMaybe<RouteResourceCreateManyParentInputEnvelope>;
};

export type RouteResourceCreateNestedManyWithoutPoolsInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutPoolsInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutPoolsInput>>;
};

export type RouteResourceCreateNestedManyWithoutSecondaryParentInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutSecondaryParentInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutSecondaryParentInput>>;
  createMany?: InputMaybe<RouteResourceCreateManySecondaryParentInputEnvelope>;
};

export type RouteResourceCreateNestedManyWithoutVerticalInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<RouteResourceCreateManyVerticalInputEnvelope>;
};

export type RouteResourceCreateNestedOneWithoutChildrenInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<RouteResourceCreateWithoutChildrenInput>;
};

export type RouteResourceCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<RouteResourceCreateWithoutContentInput>;
};

export type RouteResourceCreateNestedOneWithoutFilterTaxonomyBaseItemsInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutFilterTaxonomyBaseItemsInput>;
  create?: InputMaybe<RouteResourceCreateWithoutFilterTaxonomyBaseItemsInput>;
};

export type RouteResourceCreateNestedOneWithoutFilterTaxonomyFilterItemsInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutFilterTaxonomyFilterItemsInput>;
  create?: InputMaybe<RouteResourceCreateWithoutFilterTaxonomyFilterItemsInput>;
};

export type RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleBaseInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutFilterTaxonomyRuleBaseInput>;
  create?: InputMaybe<RouteResourceCreateWithoutFilterTaxonomyRuleBaseInput>;
};

export type RouteResourceCreateNestedOneWithoutFilterTaxonomyRuleFilterInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutFilterTaxonomyRuleFilterInput>;
  create?: InputMaybe<RouteResourceCreateWithoutFilterTaxonomyRuleFilterInput>;
};

export type RouteResourceCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<RouteResourceCreateWithoutPropertiesInput>;
};

export type RouteResourceCreateNestedOneWithoutSecondaryChildrenInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutSecondaryChildrenInput>;
  create?: InputMaybe<RouteResourceCreateWithoutSecondaryChildrenInput>;
};

export type RouteResourceCreateNestedOneWithoutSourceRedirectsInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutSourceRedirectsInput>;
  create?: InputMaybe<RouteResourceCreateWithoutSourceRedirectsInput>;
};

export type RouteResourceCreateNestedOneWithoutTargetRedirectsInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutTargetRedirectsInput>;
  create?: InputMaybe<RouteResourceCreateWithoutTargetRedirectsInput>;
};

export type RouteResourceCreateOrConnectWithoutChildrenInput = {
  create: RouteResourceCreateWithoutChildrenInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutContentInput = {
  create: RouteResourceCreateWithoutContentInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutFilterTaxonomyBaseItemsInput = {
  create: RouteResourceCreateWithoutFilterTaxonomyBaseItemsInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutFilterTaxonomyFilterItemsInput = {
  create: RouteResourceCreateWithoutFilterTaxonomyFilterItemsInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutFilterTaxonomyRuleBaseInput = {
  create: RouteResourceCreateWithoutFilterTaxonomyRuleBaseInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutFilterTaxonomyRuleFilterInput = {
  create: RouteResourceCreateWithoutFilterTaxonomyRuleFilterInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutNetworkInput = {
  create: RouteResourceCreateWithoutNetworkInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutParentInput = {
  create: RouteResourceCreateWithoutParentInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutPoolsInput = {
  create: RouteResourceCreateWithoutPoolsInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutPropertiesInput = {
  create: RouteResourceCreateWithoutPropertiesInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutSecondaryChildrenInput = {
  create: RouteResourceCreateWithoutSecondaryChildrenInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutSecondaryParentInput = {
  create: RouteResourceCreateWithoutSecondaryParentInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutSourceRedirectsInput = {
  create: RouteResourceCreateWithoutSourceRedirectsInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutTargetRedirectsInput = {
  create: RouteResourceCreateWithoutTargetRedirectsInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateOrConnectWithoutVerticalInput = {
  create: RouteResourceCreateWithoutVerticalInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceCreateWithoutChildrenInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutContentInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutFilterTaxonomyBaseItemsInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutFilterTaxonomyFilterItemsInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutFilterTaxonomyRuleBaseInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutFilterTaxonomyRuleFilterInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutNetworkInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutParentInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutPoolsInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutPropertiesInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutSecondaryChildrenInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutSecondaryParentInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutSourceRedirectsInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutTargetRedirectsInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  vertical?: InputMaybe<VerticalCreateNestedOneWithoutRouteResourcesInput>;
};

export type RouteResourceCreateWithoutVerticalInput = {
  children?: InputMaybe<RouteResourceCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutRouteResourceInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutBaseTaxonomyInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemCreateNestedManyWithoutFilterTaxonomyInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyBaseInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleCreateNestedManyWithoutTaxonomyFilterInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutRouteResourcesInput>;
  parent?: InputMaybe<RouteResourceCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<RouteResourcePoolCreateNestedManyWithoutResourcesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutRouteResourceInput>;
  resourceType: RouteResourceType;
  secondaryChildren?: InputMaybe<RouteResourceCreateNestedManyWithoutSecondaryParentInput>;
  secondaryParent?: InputMaybe<RouteResourceCreateNestedOneWithoutSecondaryChildrenInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceResourceInput>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetResourceInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RouteResourceListRelationFilter = {
  every?: InputMaybe<RouteResourceWhereInput>;
  none?: InputMaybe<RouteResourceWhereInput>;
  some?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RouteResourceOrderByWithRelationInput = {
  children?: InputMaybe<RouteResourceOrderByRelationAggregateInput>;
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrderInput>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemOrderByRelationAggregateInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemOrderByRelationAggregateInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleOrderByRelationAggregateInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  parent?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrderInput>;
  pools?: InputMaybe<RouteResourcePoolOrderByRelationAggregateInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  resourceType?: InputMaybe<SortOrder>;
  secondaryChildren?: InputMaybe<RouteResourceOrderByRelationAggregateInput>;
  secondaryParent?: InputMaybe<RouteResourceOrderByWithRelationInput>;
  secondaryParentId?: InputMaybe<SortOrderInput>;
  sourceRedirects?: InputMaybe<RedirectOrderByRelationAggregateInput>;
  subtype?: InputMaybe<SortOrderInput>;
  targetRedirects?: InputMaybe<RedirectOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  verticalId?: InputMaybe<SortOrderInput>;
};

export type RouteResourcePool = {
  __typename?: 'RouteResourcePool';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  networks?: Maybe<Array<Maybe<Network>>>;
  resourceType?: Maybe<RouteResourceType>;
  resources?: Maybe<Array<Maybe<RouteResource>>>;
};

export type RouteResourcePoolCreateNestedManyWithoutNetworksInput = {
  connect?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourcePoolCreateOrConnectWithoutNetworksInput>>;
  create?: InputMaybe<Array<RouteResourcePoolCreateWithoutNetworksInput>>;
};

export type RouteResourcePoolCreateNestedManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourcePoolCreateOrConnectWithoutResourcesInput>>;
  create?: InputMaybe<Array<RouteResourcePoolCreateWithoutResourcesInput>>;
};

export type RouteResourcePoolCreateOrConnectWithoutNetworksInput = {
  create: RouteResourcePoolCreateWithoutNetworksInput;
  where: RouteResourcePoolWhereUniqueInput;
};

export type RouteResourcePoolCreateOrConnectWithoutResourcesInput = {
  create: RouteResourcePoolCreateWithoutResourcesInput;
  where: RouteResourcePoolWhereUniqueInput;
};

export type RouteResourcePoolCreateWithoutNetworksInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resourceType: RouteResourceType;
  resources?: InputMaybe<RouteResourceCreateNestedManyWithoutPoolsInput>;
};

export type RouteResourcePoolCreateWithoutResourcesInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  networks?: InputMaybe<NetworkCreateNestedManyWithoutRouteResourcePoolsInput>;
  resourceType: RouteResourceType;
};

export type RouteResourcePoolListRelationFilter = {
  every?: InputMaybe<RouteResourcePoolWhereInput>;
  none?: InputMaybe<RouteResourcePoolWhereInput>;
  some?: InputMaybe<RouteResourcePoolWhereInput>;
};

export type RouteResourcePoolOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RouteResourcePoolOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  networks?: InputMaybe<NetworkOrderByRelationAggregateInput>;
  resourceType?: InputMaybe<SortOrder>;
  resources?: InputMaybe<RouteResourceOrderByRelationAggregateInput>;
};

export type RouteResourcePoolScalarWhereInput = {
  AND?: InputMaybe<Array<RouteResourcePoolScalarWhereInput>>;
  NOT?: InputMaybe<Array<RouteResourcePoolScalarWhereInput>>;
  OR?: InputMaybe<Array<RouteResourcePoolScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFilter>;
};

export type RouteResourcePoolUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
};

export type RouteResourcePoolUpdateManyWithWhereWithoutNetworksInput = {
  data: RouteResourcePoolUpdateManyMutationInput;
  where: RouteResourcePoolScalarWhereInput;
};

export type RouteResourcePoolUpdateManyWithWhereWithoutResourcesInput = {
  data: RouteResourcePoolUpdateManyMutationInput;
  where: RouteResourcePoolScalarWhereInput;
};

export type RouteResourcePoolUpdateManyWithoutNetworksNestedInput = {
  connect?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourcePoolCreateOrConnectWithoutNetworksInput>>;
  create?: InputMaybe<Array<RouteResourcePoolCreateWithoutNetworksInput>>;
  delete?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RouteResourcePoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  set?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  update?: InputMaybe<Array<RouteResourcePoolUpdateWithWhereUniqueWithoutNetworksInput>>;
  updateMany?: InputMaybe<Array<RouteResourcePoolUpdateManyWithWhereWithoutNetworksInput>>;
  upsert?: InputMaybe<Array<RouteResourcePoolUpsertWithWhereUniqueWithoutNetworksInput>>;
};

export type RouteResourcePoolUpdateManyWithoutResourcesNestedInput = {
  connect?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourcePoolCreateOrConnectWithoutResourcesInput>>;
  create?: InputMaybe<Array<RouteResourcePoolCreateWithoutResourcesInput>>;
  delete?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RouteResourcePoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  set?: InputMaybe<Array<RouteResourcePoolWhereUniqueInput>>;
  update?: InputMaybe<Array<RouteResourcePoolUpdateWithWhereUniqueWithoutResourcesInput>>;
  updateMany?: InputMaybe<Array<RouteResourcePoolUpdateManyWithWhereWithoutResourcesInput>>;
  upsert?: InputMaybe<Array<RouteResourcePoolUpsertWithWhereUniqueWithoutResourcesInput>>;
};

export type RouteResourcePoolUpdateWithWhereUniqueWithoutNetworksInput = {
  data: RouteResourcePoolUpdateWithoutNetworksInput;
  where: RouteResourcePoolWhereUniqueInput;
};

export type RouteResourcePoolUpdateWithWhereUniqueWithoutResourcesInput = {
  data: RouteResourcePoolUpdateWithoutResourcesInput;
  where: RouteResourcePoolWhereUniqueInput;
};

export type RouteResourcePoolUpdateWithoutNetworksInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  resources?: InputMaybe<RouteResourceUpdateManyWithoutPoolsNestedInput>;
};

export type RouteResourcePoolUpdateWithoutResourcesInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  networks?: InputMaybe<NetworkUpdateManyWithoutRouteResourcePoolsNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
};

export type RouteResourcePoolUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  name: Scalars['String']['input'];
  networks: Array<NetworkWhereUniqueInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
  resources: Array<RouteResourceWhereUniqueInput>;
};

export type RouteResourcePoolUpsertWithWhereUniqueWithoutNetworksInput = {
  create: RouteResourcePoolCreateWithoutNetworksInput;
  update: RouteResourcePoolUpdateWithoutNetworksInput;
  where: RouteResourcePoolWhereUniqueInput;
};

export type RouteResourcePoolUpsertWithWhereUniqueWithoutResourcesInput = {
  create: RouteResourcePoolCreateWithoutResourcesInput;
  update: RouteResourcePoolUpdateWithoutResourcesInput;
  where: RouteResourcePoolWhereUniqueInput;
};

export type RouteResourcePoolWhereInput = {
  AND?: InputMaybe<Array<RouteResourcePoolWhereInput>>;
  NOT?: InputMaybe<Array<RouteResourcePoolWhereInput>>;
  OR?: InputMaybe<Array<RouteResourcePoolWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFilter>;
  resources?: InputMaybe<RouteResourceListRelationFilter>;
};

export type RouteResourcePoolWhereUniqueInput = {
  AND?: InputMaybe<Array<RouteResourcePoolWhereInput>>;
  NOT?: InputMaybe<Array<RouteResourcePoolWhereInput>>;
  OR?: InputMaybe<Array<RouteResourcePoolWhereInput>>;
  id: Scalars['String']['input'];
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFilter>;
  resources?: InputMaybe<RouteResourceListRelationFilter>;
};

export type RouteResourceScalarWhereInput = {
  AND?: InputMaybe<Array<RouteResourceScalarWhereInput>>;
  NOT?: InputMaybe<Array<RouteResourceScalarWhereInput>>;
  OR?: InputMaybe<Array<RouteResourceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFilter>;
  secondaryParentId?: InputMaybe<StringNullableFilter>;
  subtype?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

/** Type for Search By Text. Use "content & strings" OR "properties" but not both! */
export type RouteResourceSearchWhereInput = {
  content?: InputMaybe<ContentItemV2WhereInput>;
  properties?: InputMaybe<RouteResourceSearchWhereInputProperties>;
  string?: InputMaybe<Scalars['String']['input']>;
};

export type RouteResourceSearchWhereInputProperties = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum RouteResourceType {
  Author = 'author',
  FilterTaxonomyItem = 'filterTaxonomyItem',
  Page = 'page',
  Post = 'post',
  Product = 'product',
  Provider = 'provider',
  TaxonomyItem = 'taxonomyItem'
}

export type RouteResourceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RouteResourceUpdateManyWithWhereWithoutNetworkInput = {
  data: RouteResourceUpdateManyMutationInput;
  where: RouteResourceScalarWhereInput;
};

export type RouteResourceUpdateManyWithWhereWithoutParentInput = {
  data: RouteResourceUpdateManyMutationInput;
  where: RouteResourceScalarWhereInput;
};

export type RouteResourceUpdateManyWithWhereWithoutPoolsInput = {
  data: RouteResourceUpdateManyMutationInput;
  where: RouteResourceScalarWhereInput;
};

export type RouteResourceUpdateManyWithWhereWithoutSecondaryParentInput = {
  data: RouteResourceUpdateManyMutationInput;
  where: RouteResourceScalarWhereInput;
};

export type RouteResourceUpdateManyWithWhereWithoutVerticalInput = {
  data: RouteResourceUpdateManyMutationInput;
  where: RouteResourceScalarWhereInput;
};

export type RouteResourceUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<RouteResourceCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RouteResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<RouteResourceUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<RouteResourceUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<RouteResourceUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type RouteResourceUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutParentInput>>;
  createMany?: InputMaybe<RouteResourceCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RouteResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<RouteResourceUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<RouteResourceUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<RouteResourceUpsertWithWhereUniqueWithoutParentInput>>;
};

export type RouteResourceUpdateManyWithoutPoolsNestedInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutPoolsInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutPoolsInput>>;
  delete?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RouteResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<RouteResourceUpdateWithWhereUniqueWithoutPoolsInput>>;
  updateMany?: InputMaybe<Array<RouteResourceUpdateManyWithWhereWithoutPoolsInput>>;
  upsert?: InputMaybe<Array<RouteResourceUpsertWithWhereUniqueWithoutPoolsInput>>;
};

export type RouteResourceUpdateManyWithoutSecondaryParentNestedInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutSecondaryParentInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutSecondaryParentInput>>;
  createMany?: InputMaybe<RouteResourceCreateManySecondaryParentInputEnvelope>;
  delete?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RouteResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<RouteResourceUpdateWithWhereUniqueWithoutSecondaryParentInput>>;
  updateMany?: InputMaybe<Array<RouteResourceUpdateManyWithWhereWithoutSecondaryParentInput>>;
  upsert?: InputMaybe<Array<RouteResourceUpsertWithWhereUniqueWithoutSecondaryParentInput>>;
};

export type RouteResourceUpdateManyWithoutVerticalNestedInput = {
  connect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RouteResourceCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<RouteResourceCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<RouteResourceCreateManyVerticalInputEnvelope>;
  delete?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RouteResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<RouteResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<RouteResourceUpdateWithWhereUniqueWithoutVerticalInput>>;
  updateMany?: InputMaybe<Array<RouteResourceUpdateManyWithWhereWithoutVerticalInput>>;
  upsert?: InputMaybe<Array<RouteResourceUpsertWithWhereUniqueWithoutVerticalInput>>;
};

export type RouteResourceUpdateOneRequiredWithoutFilterTaxonomyBaseItemsNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutFilterTaxonomyBaseItemsInput>;
  create?: InputMaybe<RouteResourceCreateWithoutFilterTaxonomyBaseItemsInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutFilterTaxonomyBaseItemsInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutFilterTaxonomyBaseItemsInput>;
};

export type RouteResourceUpdateOneRequiredWithoutFilterTaxonomyFilterItemsNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutFilterTaxonomyFilterItemsInput>;
  create?: InputMaybe<RouteResourceCreateWithoutFilterTaxonomyFilterItemsInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutFilterTaxonomyFilterItemsInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutFilterTaxonomyFilterItemsInput>;
};

export type RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleBaseNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutFilterTaxonomyRuleBaseInput>;
  create?: InputMaybe<RouteResourceCreateWithoutFilterTaxonomyRuleBaseInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutFilterTaxonomyRuleBaseInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutFilterTaxonomyRuleBaseInput>;
};

export type RouteResourceUpdateOneRequiredWithoutFilterTaxonomyRuleFilterNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutFilterTaxonomyRuleFilterInput>;
  create?: InputMaybe<RouteResourceCreateWithoutFilterTaxonomyRuleFilterInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutFilterTaxonomyRuleFilterInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutFilterTaxonomyRuleFilterInput>;
};

export type RouteResourceUpdateOneWithoutChildrenNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<RouteResourceCreateWithoutChildrenInput>;
  delete?: InputMaybe<RouteResourceWhereInput>;
  disconnect?: InputMaybe<RouteResourceWhereInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutChildrenInput>;
};

export type RouteResourceUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<RouteResourceCreateWithoutContentInput>;
  delete?: InputMaybe<RouteResourceWhereInput>;
  disconnect?: InputMaybe<RouteResourceWhereInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutContentInput>;
};

export type RouteResourceUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<RouteResourceCreateWithoutPropertiesInput>;
  delete?: InputMaybe<RouteResourceWhereInput>;
  disconnect?: InputMaybe<RouteResourceWhereInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutPropertiesInput>;
};

export type RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutSecondaryChildrenInput>;
  create?: InputMaybe<RouteResourceCreateWithoutSecondaryChildrenInput>;
  delete?: InputMaybe<RouteResourceWhereInput>;
  disconnect?: InputMaybe<RouteResourceWhereInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutSecondaryChildrenInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutSecondaryChildrenInput>;
};

export type RouteResourceUpdateOneWithoutSourceRedirectsNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutSourceRedirectsInput>;
  create?: InputMaybe<RouteResourceCreateWithoutSourceRedirectsInput>;
  delete?: InputMaybe<RouteResourceWhereInput>;
  disconnect?: InputMaybe<RouteResourceWhereInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutSourceRedirectsInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutSourceRedirectsInput>;
};

export type RouteResourceUpdateOneWithoutTargetRedirectsNestedInput = {
  connect?: InputMaybe<RouteResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RouteResourceCreateOrConnectWithoutTargetRedirectsInput>;
  create?: InputMaybe<RouteResourceCreateWithoutTargetRedirectsInput>;
  delete?: InputMaybe<RouteResourceWhereInput>;
  disconnect?: InputMaybe<RouteResourceWhereInput>;
  update?: InputMaybe<RouteResourceUpdateToOneWithWhereWithoutTargetRedirectsInput>;
  upsert?: InputMaybe<RouteResourceUpsertWithoutTargetRedirectsInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutChildrenInput = {
  data: RouteResourceUpdateWithoutChildrenInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutContentInput = {
  data: RouteResourceUpdateWithoutContentInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutFilterTaxonomyBaseItemsInput = {
  data: RouteResourceUpdateWithoutFilterTaxonomyBaseItemsInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutFilterTaxonomyFilterItemsInput = {
  data: RouteResourceUpdateWithoutFilterTaxonomyFilterItemsInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutFilterTaxonomyRuleBaseInput = {
  data: RouteResourceUpdateWithoutFilterTaxonomyRuleBaseInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutFilterTaxonomyRuleFilterInput = {
  data: RouteResourceUpdateWithoutFilterTaxonomyRuleFilterInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutPropertiesInput = {
  data: RouteResourceUpdateWithoutPropertiesInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutSecondaryChildrenInput = {
  data: RouteResourceUpdateWithoutSecondaryChildrenInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutSourceRedirectsInput = {
  data: RouteResourceUpdateWithoutSourceRedirectsInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateToOneWithWhereWithoutTargetRedirectsInput = {
  data: RouteResourceUpdateWithoutTargetRedirectsInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpdateWithWhereUniqueWithoutNetworkInput = {
  data: RouteResourceUpdateWithoutNetworkInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpdateWithWhereUniqueWithoutParentInput = {
  data: RouteResourceUpdateWithoutParentInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpdateWithWhereUniqueWithoutPoolsInput = {
  data: RouteResourceUpdateWithoutPoolsInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpdateWithWhereUniqueWithoutSecondaryParentInput = {
  data: RouteResourceUpdateWithoutSecondaryParentInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpdateWithWhereUniqueWithoutVerticalInput = {
  data: RouteResourceUpdateWithoutVerticalInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpdateWithoutChildrenInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutContentInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutFilterTaxonomyBaseItemsInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutFilterTaxonomyFilterItemsInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutFilterTaxonomyRuleBaseInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutFilterTaxonomyRuleFilterInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutNetworkInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutParentInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutPoolsInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutPropertiesInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutSecondaryChildrenInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutSecondaryParentInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutSourceRedirectsInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutTargetRedirectsInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneWithoutRouteResourcesNestedInput>;
};

export type RouteResourceUpdateWithoutVerticalInput = {
  children?: InputMaybe<RouteResourceUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutRouteResourceNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutBaseTaxonomyNestedInput>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemUpdateManyWithoutFilterTaxonomyNestedInput>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyBaseNestedInput>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleUpdateManyWithoutTaxonomyFilterNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutRouteResourcesNestedInput>;
  parent?: InputMaybe<RouteResourceUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<RouteResourcePoolUpdateManyWithoutResourcesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutRouteResourceNestedInput>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFieldUpdateOperationsInput>;
  secondaryChildren?: InputMaybe<RouteResourceUpdateManyWithoutSecondaryParentNestedInput>;
  secondaryParent?: InputMaybe<RouteResourceUpdateOneWithoutSecondaryChildrenNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceResourceNestedInput>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetResourceNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RouteResourceUpsertWithWhereUniqueWithoutNetworkInput = {
  create: RouteResourceCreateWithoutNetworkInput;
  update: RouteResourceUpdateWithoutNetworkInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpsertWithWhereUniqueWithoutParentInput = {
  create: RouteResourceCreateWithoutParentInput;
  update: RouteResourceUpdateWithoutParentInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpsertWithWhereUniqueWithoutPoolsInput = {
  create: RouteResourceCreateWithoutPoolsInput;
  update: RouteResourceUpdateWithoutPoolsInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpsertWithWhereUniqueWithoutSecondaryParentInput = {
  create: RouteResourceCreateWithoutSecondaryParentInput;
  update: RouteResourceUpdateWithoutSecondaryParentInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpsertWithWhereUniqueWithoutVerticalInput = {
  create: RouteResourceCreateWithoutVerticalInput;
  update: RouteResourceUpdateWithoutVerticalInput;
  where: RouteResourceWhereUniqueInput;
};

export type RouteResourceUpsertWithoutChildrenInput = {
  create: RouteResourceCreateWithoutChildrenInput;
  update: RouteResourceUpdateWithoutChildrenInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutContentInput = {
  create: RouteResourceCreateWithoutContentInput;
  update: RouteResourceUpdateWithoutContentInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutFilterTaxonomyBaseItemsInput = {
  create: RouteResourceCreateWithoutFilterTaxonomyBaseItemsInput;
  update: RouteResourceUpdateWithoutFilterTaxonomyBaseItemsInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutFilterTaxonomyFilterItemsInput = {
  create: RouteResourceCreateWithoutFilterTaxonomyFilterItemsInput;
  update: RouteResourceUpdateWithoutFilterTaxonomyFilterItemsInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutFilterTaxonomyRuleBaseInput = {
  create: RouteResourceCreateWithoutFilterTaxonomyRuleBaseInput;
  update: RouteResourceUpdateWithoutFilterTaxonomyRuleBaseInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutFilterTaxonomyRuleFilterInput = {
  create: RouteResourceCreateWithoutFilterTaxonomyRuleFilterInput;
  update: RouteResourceUpdateWithoutFilterTaxonomyRuleFilterInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutPropertiesInput = {
  create: RouteResourceCreateWithoutPropertiesInput;
  update: RouteResourceUpdateWithoutPropertiesInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutSecondaryChildrenInput = {
  create: RouteResourceCreateWithoutSecondaryChildrenInput;
  update: RouteResourceUpdateWithoutSecondaryChildrenInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutSourceRedirectsInput = {
  create: RouteResourceCreateWithoutSourceRedirectsInput;
  update: RouteResourceUpdateWithoutSourceRedirectsInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceUpsertWithoutTargetRedirectsInput = {
  create: RouteResourceCreateWithoutTargetRedirectsInput;
  update: RouteResourceUpdateWithoutTargetRedirectsInput;
  where?: InputMaybe<RouteResourceWhereInput>;
};

export type RouteResourceWhereInput = {
  AND?: InputMaybe<Array<RouteResourceWhereInput>>;
  NOT?: InputMaybe<Array<RouteResourceWhereInput>>;
  OR?: InputMaybe<Array<RouteResourceWhereInput>>;
  children?: InputMaybe<RouteResourceListRelationFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemListRelationFilter>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemListRelationFilter>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleListRelationFilter>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  parent?: InputMaybe<RouteResourceWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  pools?: InputMaybe<RouteResourcePoolListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFilter>;
  secondaryChildren?: InputMaybe<RouteResourceListRelationFilter>;
  secondaryParent?: InputMaybe<RouteResourceWhereInput>;
  secondaryParentId?: InputMaybe<StringNullableFilter>;
  sourceRedirects?: InputMaybe<RedirectListRelationFilter>;
  subtype?: InputMaybe<StringNullableFilter>;
  targetRedirects?: InputMaybe<RedirectListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type RouteResourceWhereUniqueInput = {
  AND?: InputMaybe<Array<RouteResourceWhereInput>>;
  NOT?: InputMaybe<Array<RouteResourceWhereInput>>;
  OR?: InputMaybe<Array<RouteResourceWhereInput>>;
  children?: InputMaybe<RouteResourceListRelationFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  filterTaxonomyBaseItems?: InputMaybe<FilterTaxonomyItemListRelationFilter>;
  filterTaxonomyFilterItems?: InputMaybe<FilterTaxonomyItemListRelationFilter>;
  filterTaxonomyRuleBase?: InputMaybe<FilterTaxonomyRuleListRelationFilter>;
  filterTaxonomyRuleFilter?: InputMaybe<FilterTaxonomyRuleListRelationFilter>;
  id: Scalars['String']['input'];
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  parent?: InputMaybe<RouteResourceWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  pools?: InputMaybe<RouteResourcePoolListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  resourceType?: InputMaybe<EnumRouteResourceTypeFilter>;
  secondaryChildren?: InputMaybe<RouteResourceListRelationFilter>;
  secondaryParent?: InputMaybe<RouteResourceWhereInput>;
  secondaryParentId?: InputMaybe<StringNullableFilter>;
  sourceRedirects?: InputMaybe<RedirectListRelationFilter>;
  subtype?: InputMaybe<StringNullableFilter>;
  targetRedirects?: InputMaybe<RedirectListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringNullableFilter>;
};

export type Site = {
  __typename?: 'Site';
  canonicalChildren: Array<Site>;
  canonicalSite?: Maybe<Site>;
  children: Array<Site>;
  computedRedirects?: Maybe<Scalars['Json']['output']>;
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  country?: Maybe<Country>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  deployedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id: Scalars['String']['output'];
  isCanonical: Scalars['Boolean']['output'];
  language: Language;
  parent?: Maybe<Site>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  redirects?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['String']['output'];
  vertical: Vertical;
};


export type SiteCanonicalChildrenArgs = {
  cursor?: InputMaybe<SiteWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SiteWhereInput>;
};


export type SiteCanonicalSiteArgs = {
  where?: InputMaybe<SiteWhereInput>;
};


export type SiteChildrenArgs = {
  cursor?: InputMaybe<SiteWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SiteWhereInput>;
};


export type SiteContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type SiteCountryArgs = {
  where?: InputMaybe<CountryWhereInput>;
};


export type SiteHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteParentArgs = {
  where?: InputMaybe<SiteWhereInput>;
};


export type SitePropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type SiteCreateManyCanonicalSiteInput = {
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  languageId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  verticalId: Scalars['String']['input'];
};

export type SiteCreateManyCanonicalSiteInputEnvelope = {
  data?: InputMaybe<Array<SiteCreateManyCanonicalSiteInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteCreateManyCountryInput = {
  canonicalSiteId?: InputMaybe<Scalars['String']['input']>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  languageId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  verticalId: Scalars['String']['input'];
};

export type SiteCreateManyCountryInputEnvelope = {
  data?: InputMaybe<Array<SiteCreateManyCountryInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteCreateManyLanguageInput = {
  canonicalSiteId?: InputMaybe<Scalars['String']['input']>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  verticalId: Scalars['String']['input'];
};

export type SiteCreateManyLanguageInputEnvelope = {
  data?: InputMaybe<Array<SiteCreateManyLanguageInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteCreateManyParentInput = {
  canonicalSiteId?: InputMaybe<Scalars['String']['input']>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  languageId: Scalars['String']['input'];
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  verticalId: Scalars['String']['input'];
};

export type SiteCreateManyParentInputEnvelope = {
  data?: InputMaybe<Array<SiteCreateManyParentInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteCreateManyVerticalInput = {
  canonicalSiteId?: InputMaybe<Scalars['String']['input']>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  languageId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type SiteCreateManyVerticalInputEnvelope = {
  data?: InputMaybe<Array<SiteCreateManyVerticalInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteCreateNestedManyWithoutCanonicalSiteInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutCanonicalSiteInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutCanonicalSiteInput>>;
  createMany?: InputMaybe<SiteCreateManyCanonicalSiteInputEnvelope>;
};

export type SiteCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutCountryInput>>;
  createMany?: InputMaybe<SiteCreateManyCountryInputEnvelope>;
};

export type SiteCreateNestedManyWithoutLanguageInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutLanguageInput>>;
  createMany?: InputMaybe<SiteCreateManyLanguageInputEnvelope>;
};

export type SiteCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutParentInput>>;
  createMany?: InputMaybe<SiteCreateManyParentInputEnvelope>;
};

export type SiteCreateNestedManyWithoutVerticalInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<SiteCreateManyVerticalInputEnvelope>;
};

export type SiteCreateNestedOneWithoutCanonicalChildrenInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutCanonicalChildrenInput>;
  create?: InputMaybe<SiteCreateWithoutCanonicalChildrenInput>;
};

export type SiteCreateNestedOneWithoutChildrenInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<SiteCreateWithoutChildrenInput>;
};

export type SiteCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<SiteCreateWithoutContentInput>;
};

export type SiteCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<SiteCreateWithoutContentOldInput>;
};

export type SiteCreateNestedOneWithoutMenusInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutMenusInput>;
  create?: InputMaybe<SiteCreateWithoutMenusInput>;
};

export type SiteCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<SiteCreateWithoutPropertiesInput>;
};

export type SiteCreateNestedOneWithoutSourceRedirectsInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutSourceRedirectsInput>;
  create?: InputMaybe<SiteCreateWithoutSourceRedirectsInput>;
};

export type SiteCreateNestedOneWithoutTargetRedirectsInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutTargetRedirectsInput>;
  create?: InputMaybe<SiteCreateWithoutTargetRedirectsInput>;
};

export type SiteCreateOrConnectWithoutCanonicalChildrenInput = {
  create: SiteCreateWithoutCanonicalChildrenInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutCanonicalSiteInput = {
  create: SiteCreateWithoutCanonicalSiteInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutChildrenInput = {
  create: SiteCreateWithoutChildrenInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutContentInput = {
  create: SiteCreateWithoutContentInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutContentOldInput = {
  create: SiteCreateWithoutContentOldInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutCountryInput = {
  create: SiteCreateWithoutCountryInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutLanguageInput = {
  create: SiteCreateWithoutLanguageInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutMenusInput = {
  create: SiteCreateWithoutMenusInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutParentInput = {
  create: SiteCreateWithoutParentInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutPropertiesInput = {
  create: SiteCreateWithoutPropertiesInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutSourceRedirectsInput = {
  create: SiteCreateWithoutSourceRedirectsInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutTargetRedirectsInput = {
  create: SiteCreateWithoutTargetRedirectsInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateOrConnectWithoutVerticalInput = {
  create: SiteCreateWithoutVerticalInput;
  where: SiteWhereUniqueInput;
};

export type SiteCreateWithoutCanonicalChildrenInput = {
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutCanonicalSiteInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutChildrenInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutContentInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutContentOldInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutCountryInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutLanguageInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutMenusInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutParentInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutPropertiesInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutSourceRedirectsInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutTargetRedirectsInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
  vertical: VerticalCreateNestedOneWithoutSitesInput;
};

export type SiteCreateWithoutVerticalInput = {
  canonicalChildren?: InputMaybe<SiteCreateNestedManyWithoutCanonicalSiteInput>;
  canonicalSite?: InputMaybe<SiteCreateNestedOneWithoutCanonicalChildrenInput>;
  children?: InputMaybe<SiteCreateNestedManyWithoutParentInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutSiteInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutSiteInput>;
  country?: InputMaybe<CountryCreateNestedOneWithoutSiteInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  deployedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<Scalars['Boolean']['input']>;
  isMain?: InputMaybe<Scalars['Boolean']['input']>;
  language: LanguageCreateNestedOneWithoutSiteInput;
  menus?: InputMaybe<MenuCreateNestedManyWithoutSiteInput>;
  parent?: InputMaybe<SiteCreateNestedOneWithoutChildrenInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutSiteInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceSiteInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetSiteInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type SiteCurrentInput = {
  network?: InputMaybe<Scalars['String']['input']>;
  vertical?: InputMaybe<Scalars['String']['input']>;
};

export type SiteListRelationFilter = {
  every?: InputMaybe<SiteWhereInput>;
  none?: InputMaybe<SiteWhereInput>;
  some?: InputMaybe<SiteWhereInput>;
};

export type SiteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SiteOrderByWithRelationInput = {
  canonicalChildren?: InputMaybe<SiteOrderByRelationAggregateInput>;
  canonicalSite?: InputMaybe<SiteOrderByWithRelationInput>;
  canonicalSiteId?: InputMaybe<SortOrderInput>;
  children?: InputMaybe<SiteOrderByRelationAggregateInput>;
  computedRedirects?: InputMaybe<SortOrderInput>;
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  country?: InputMaybe<CountryOrderByWithRelationInput>;
  countryId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deployedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isCanonical?: InputMaybe<SortOrder>;
  isMain?: InputMaybe<SortOrder>;
  language?: InputMaybe<LanguageOrderByWithRelationInput>;
  languageId?: InputMaybe<SortOrder>;
  menus?: InputMaybe<MenuOrderByRelationAggregateInput>;
  parent?: InputMaybe<SiteOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrderInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  sitemap?: InputMaybe<SortOrderInput>;
  sourceRedirects?: InputMaybe<RedirectOrderByRelationAggregateInput>;
  targetRedirects?: InputMaybe<RedirectOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
  vertical?: InputMaybe<VerticalOrderByWithRelationInput>;
  verticalId?: InputMaybe<SortOrder>;
};

export type SiteScalarWhereInput = {
  AND?: InputMaybe<Array<SiteScalarWhereInput>>;
  NOT?: InputMaybe<Array<SiteScalarWhereInput>>;
  OR?: InputMaybe<Array<SiteScalarWhereInput>>;
  canonicalSiteId?: InputMaybe<StringNullableFilter>;
  computedRedirects?: InputMaybe<JsonNullableFilter>;
  countryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deployedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isCanonical?: InputMaybe<BoolFilter>;
  isMain?: InputMaybe<BoolFilter>;
  languageId?: InputMaybe<StringFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  sitemap?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
  verticalId?: InputMaybe<StringFilter>;
};

export type SiteUpdateManyMutationInput = {
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SiteUpdateManyWithWhereWithoutCanonicalSiteInput = {
  data: SiteUpdateManyMutationInput;
  where: SiteScalarWhereInput;
};

export type SiteUpdateManyWithWhereWithoutCountryInput = {
  data: SiteUpdateManyMutationInput;
  where: SiteScalarWhereInput;
};

export type SiteUpdateManyWithWhereWithoutLanguageInput = {
  data: SiteUpdateManyMutationInput;
  where: SiteScalarWhereInput;
};

export type SiteUpdateManyWithWhereWithoutParentInput = {
  data: SiteUpdateManyMutationInput;
  where: SiteScalarWhereInput;
};

export type SiteUpdateManyWithWhereWithoutVerticalInput = {
  data: SiteUpdateManyMutationInput;
  where: SiteScalarWhereInput;
};

export type SiteUpdateManyWithoutCanonicalSiteNestedInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutCanonicalSiteInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutCanonicalSiteInput>>;
  createMany?: InputMaybe<SiteCreateManyCanonicalSiteInputEnvelope>;
  delete?: InputMaybe<Array<SiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  set?: InputMaybe<Array<SiteWhereUniqueInput>>;
  update?: InputMaybe<Array<SiteUpdateWithWhereUniqueWithoutCanonicalSiteInput>>;
  updateMany?: InputMaybe<Array<SiteUpdateManyWithWhereWithoutCanonicalSiteInput>>;
  upsert?: InputMaybe<Array<SiteUpsertWithWhereUniqueWithoutCanonicalSiteInput>>;
};

export type SiteUpdateManyWithoutCountryNestedInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutCountryInput>>;
  createMany?: InputMaybe<SiteCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<SiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  set?: InputMaybe<Array<SiteWhereUniqueInput>>;
  update?: InputMaybe<Array<SiteUpdateWithWhereUniqueWithoutCountryInput>>;
  updateMany?: InputMaybe<Array<SiteUpdateManyWithWhereWithoutCountryInput>>;
  upsert?: InputMaybe<Array<SiteUpsertWithWhereUniqueWithoutCountryInput>>;
};

export type SiteUpdateManyWithoutLanguageNestedInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutLanguageInput>>;
  createMany?: InputMaybe<SiteCreateManyLanguageInputEnvelope>;
  delete?: InputMaybe<Array<SiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  set?: InputMaybe<Array<SiteWhereUniqueInput>>;
  update?: InputMaybe<Array<SiteUpdateWithWhereUniqueWithoutLanguageInput>>;
  updateMany?: InputMaybe<Array<SiteUpdateManyWithWhereWithoutLanguageInput>>;
  upsert?: InputMaybe<Array<SiteUpsertWithWhereUniqueWithoutLanguageInput>>;
};

export type SiteUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutParentInput>>;
  createMany?: InputMaybe<SiteCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<SiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  set?: InputMaybe<Array<SiteWhereUniqueInput>>;
  update?: InputMaybe<Array<SiteUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<SiteUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<SiteUpsertWithWhereUniqueWithoutParentInput>>;
};

export type SiteUpdateManyWithoutVerticalNestedInput = {
  connect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SiteCreateOrConnectWithoutVerticalInput>>;
  create?: InputMaybe<Array<SiteCreateWithoutVerticalInput>>;
  createMany?: InputMaybe<SiteCreateManyVerticalInputEnvelope>;
  delete?: InputMaybe<Array<SiteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SiteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SiteWhereUniqueInput>>;
  set?: InputMaybe<Array<SiteWhereUniqueInput>>;
  update?: InputMaybe<Array<SiteUpdateWithWhereUniqueWithoutVerticalInput>>;
  updateMany?: InputMaybe<Array<SiteUpdateManyWithWhereWithoutVerticalInput>>;
  upsert?: InputMaybe<Array<SiteUpsertWithWhereUniqueWithoutVerticalInput>>;
};

export type SiteUpdateOneWithoutCanonicalChildrenNestedInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutCanonicalChildrenInput>;
  create?: InputMaybe<SiteCreateWithoutCanonicalChildrenInput>;
  delete?: InputMaybe<SiteWhereInput>;
  disconnect?: InputMaybe<SiteWhereInput>;
  update?: InputMaybe<SiteUpdateToOneWithWhereWithoutCanonicalChildrenInput>;
  upsert?: InputMaybe<SiteUpsertWithoutCanonicalChildrenInput>;
};

export type SiteUpdateOneWithoutChildrenNestedInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<SiteCreateWithoutChildrenInput>;
  delete?: InputMaybe<SiteWhereInput>;
  disconnect?: InputMaybe<SiteWhereInput>;
  update?: InputMaybe<SiteUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: InputMaybe<SiteUpsertWithoutChildrenInput>;
};

export type SiteUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<SiteCreateWithoutContentInput>;
  delete?: InputMaybe<SiteWhereInput>;
  disconnect?: InputMaybe<SiteWhereInput>;
  update?: InputMaybe<SiteUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<SiteUpsertWithoutContentInput>;
};

export type SiteUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<SiteCreateWithoutContentOldInput>;
  delete?: InputMaybe<SiteWhereInput>;
  disconnect?: InputMaybe<SiteWhereInput>;
  update?: InputMaybe<SiteUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<SiteUpsertWithoutContentOldInput>;
};

export type SiteUpdateOneWithoutMenusNestedInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutMenusInput>;
  create?: InputMaybe<SiteCreateWithoutMenusInput>;
  delete?: InputMaybe<SiteWhereInput>;
  disconnect?: InputMaybe<SiteWhereInput>;
  update?: InputMaybe<SiteUpdateToOneWithWhereWithoutMenusInput>;
  upsert?: InputMaybe<SiteUpsertWithoutMenusInput>;
};

export type SiteUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<SiteCreateWithoutPropertiesInput>;
  delete?: InputMaybe<SiteWhereInput>;
  disconnect?: InputMaybe<SiteWhereInput>;
  update?: InputMaybe<SiteUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<SiteUpsertWithoutPropertiesInput>;
};

export type SiteUpdateOneWithoutSourceRedirectsNestedInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutSourceRedirectsInput>;
  create?: InputMaybe<SiteCreateWithoutSourceRedirectsInput>;
  delete?: InputMaybe<SiteWhereInput>;
  disconnect?: InputMaybe<SiteWhereInput>;
  update?: InputMaybe<SiteUpdateToOneWithWhereWithoutSourceRedirectsInput>;
  upsert?: InputMaybe<SiteUpsertWithoutSourceRedirectsInput>;
};

export type SiteUpdateOneWithoutTargetRedirectsNestedInput = {
  connect?: InputMaybe<SiteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SiteCreateOrConnectWithoutTargetRedirectsInput>;
  create?: InputMaybe<SiteCreateWithoutTargetRedirectsInput>;
  delete?: InputMaybe<SiteWhereInput>;
  disconnect?: InputMaybe<SiteWhereInput>;
  update?: InputMaybe<SiteUpdateToOneWithWhereWithoutTargetRedirectsInput>;
  upsert?: InputMaybe<SiteUpsertWithoutTargetRedirectsInput>;
};

export type SiteUpdateToOneWithWhereWithoutCanonicalChildrenInput = {
  data: SiteUpdateWithoutCanonicalChildrenInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpdateToOneWithWhereWithoutChildrenInput = {
  data: SiteUpdateWithoutChildrenInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpdateToOneWithWhereWithoutContentInput = {
  data: SiteUpdateWithoutContentInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpdateToOneWithWhereWithoutContentOldInput = {
  data: SiteUpdateWithoutContentOldInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpdateToOneWithWhereWithoutMenusInput = {
  data: SiteUpdateWithoutMenusInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpdateToOneWithWhereWithoutPropertiesInput = {
  data: SiteUpdateWithoutPropertiesInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpdateToOneWithWhereWithoutSourceRedirectsInput = {
  data: SiteUpdateWithoutSourceRedirectsInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpdateToOneWithWhereWithoutTargetRedirectsInput = {
  data: SiteUpdateWithoutTargetRedirectsInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpdateWithWhereUniqueWithoutCanonicalSiteInput = {
  data: SiteUpdateWithoutCanonicalSiteInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpdateWithWhereUniqueWithoutCountryInput = {
  data: SiteUpdateWithoutCountryInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpdateWithWhereUniqueWithoutLanguageInput = {
  data: SiteUpdateWithoutLanguageInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpdateWithWhereUniqueWithoutParentInput = {
  data: SiteUpdateWithoutParentInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpdateWithWhereUniqueWithoutVerticalInput = {
  data: SiteUpdateWithoutVerticalInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpdateWithoutCanonicalChildrenInput = {
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutCanonicalSiteInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutChildrenInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutContentInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutContentOldInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutCountryInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutLanguageInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutMenusInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutParentInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutPropertiesInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutSourceRedirectsInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutTargetRedirectsInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
  vertical?: InputMaybe<VerticalUpdateOneRequiredWithoutSitesNestedInput>;
};

export type SiteUpdateWithoutVerticalInput = {
  canonicalChildren?: InputMaybe<SiteUpdateManyWithoutCanonicalSiteNestedInput>;
  canonicalSite?: InputMaybe<SiteUpdateOneWithoutCanonicalChildrenNestedInput>;
  children?: InputMaybe<SiteUpdateManyWithoutParentNestedInput>;
  computedRedirects?: InputMaybe<Scalars['Json']['input']>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutSiteNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutSiteNestedInput>;
  country?: InputMaybe<CountryUpdateOneWithoutSiteNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deployedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isCanonical?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isMain?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutSiteNestedInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutSiteNestedInput>;
  parent?: InputMaybe<SiteUpdateOneWithoutChildrenNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutSiteNestedInput>;
  sitemap?: InputMaybe<Scalars['Json']['input']>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceSiteNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetSiteNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SiteUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type SiteUpsertWithWhereUniqueWithoutCanonicalSiteInput = {
  create: SiteCreateWithoutCanonicalSiteInput;
  update: SiteUpdateWithoutCanonicalSiteInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpsertWithWhereUniqueWithoutCountryInput = {
  create: SiteCreateWithoutCountryInput;
  update: SiteUpdateWithoutCountryInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpsertWithWhereUniqueWithoutLanguageInput = {
  create: SiteCreateWithoutLanguageInput;
  update: SiteUpdateWithoutLanguageInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpsertWithWhereUniqueWithoutParentInput = {
  create: SiteCreateWithoutParentInput;
  update: SiteUpdateWithoutParentInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpsertWithWhereUniqueWithoutVerticalInput = {
  create: SiteCreateWithoutVerticalInput;
  update: SiteUpdateWithoutVerticalInput;
  where: SiteWhereUniqueInput;
};

export type SiteUpsertWithoutCanonicalChildrenInput = {
  create: SiteCreateWithoutCanonicalChildrenInput;
  update: SiteUpdateWithoutCanonicalChildrenInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpsertWithoutChildrenInput = {
  create: SiteCreateWithoutChildrenInput;
  update: SiteUpdateWithoutChildrenInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpsertWithoutContentInput = {
  create: SiteCreateWithoutContentInput;
  update: SiteUpdateWithoutContentInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpsertWithoutContentOldInput = {
  create: SiteCreateWithoutContentOldInput;
  update: SiteUpdateWithoutContentOldInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpsertWithoutMenusInput = {
  create: SiteCreateWithoutMenusInput;
  update: SiteUpdateWithoutMenusInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpsertWithoutPropertiesInput = {
  create: SiteCreateWithoutPropertiesInput;
  update: SiteUpdateWithoutPropertiesInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpsertWithoutSourceRedirectsInput = {
  create: SiteCreateWithoutSourceRedirectsInput;
  update: SiteUpdateWithoutSourceRedirectsInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteUpsertWithoutTargetRedirectsInput = {
  create: SiteCreateWithoutTargetRedirectsInput;
  update: SiteUpdateWithoutTargetRedirectsInput;
  where?: InputMaybe<SiteWhereInput>;
};

export type SiteWhereInput = {
  AND?: InputMaybe<Array<SiteWhereInput>>;
  NOT?: InputMaybe<Array<SiteWhereInput>>;
  OR?: InputMaybe<Array<SiteWhereInput>>;
  canonicalChildren?: InputMaybe<SiteListRelationFilter>;
  canonicalSite?: InputMaybe<SiteWhereInput>;
  canonicalSiteId?: InputMaybe<StringNullableFilter>;
  children?: InputMaybe<SiteListRelationFilter>;
  computedRedirects?: InputMaybe<JsonNullableFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  country?: InputMaybe<CountryWhereInput>;
  countryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deployedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isCanonical?: InputMaybe<BoolFilter>;
  isMain?: InputMaybe<BoolFilter>;
  language?: InputMaybe<LanguageWhereInput>;
  languageId?: InputMaybe<StringFilter>;
  menus?: InputMaybe<MenuListRelationFilter>;
  parent?: InputMaybe<SiteWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  sitemap?: InputMaybe<JsonNullableFilter>;
  sourceRedirects?: InputMaybe<RedirectListRelationFilter>;
  targetRedirects?: InputMaybe<RedirectListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringFilter>;
};

export type SiteWhereUniqueInput = {
  AND?: InputMaybe<Array<SiteWhereInput>>;
  NOT?: InputMaybe<Array<SiteWhereInput>>;
  OR?: InputMaybe<Array<SiteWhereInput>>;
  canonicalChildren?: InputMaybe<SiteListRelationFilter>;
  canonicalSite?: InputMaybe<SiteWhereInput>;
  canonicalSiteId?: InputMaybe<StringNullableFilter>;
  children?: InputMaybe<SiteListRelationFilter>;
  computedRedirects?: InputMaybe<JsonNullableFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  country?: InputMaybe<CountryWhereInput>;
  countryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deployedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isCanonical?: InputMaybe<BoolFilter>;
  isMain?: InputMaybe<BoolFilter>;
  language?: InputMaybe<LanguageWhereInput>;
  languageId?: InputMaybe<StringFilter>;
  menus?: InputMaybe<MenuListRelationFilter>;
  parent?: InputMaybe<SiteWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  sitemap?: InputMaybe<JsonNullableFilter>;
  sourceRedirects?: InputMaybe<RedirectListRelationFilter>;
  targetRedirects?: InputMaybe<RedirectListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<Scalars['String']['input']>;
  vertical?: InputMaybe<VerticalWhereInput>;
  verticalId?: InputMaybe<StringFilter>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type State = {
  __typename?: 'State';
  country?: Maybe<Country>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type StateCountryArgs = {
  where?: InputMaybe<CountryWhereInput>;
};

export type StateCreateInput = {
  country?: InputMaybe<CountryCreateNestedOneWithoutStatesInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type StateCreateManyCountryInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type StateCreateManyCountryInputEnvelope = {
  data?: InputMaybe<Array<StateCreateManyCountryInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StateCreateNestedManyWithoutCountryInput = {
  connect?: InputMaybe<Array<StateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StateCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<StateCreateWithoutCountryInput>>;
  createMany?: InputMaybe<StateCreateManyCountryInputEnvelope>;
};

export type StateCreateOrConnectWithoutCountryInput = {
  create: StateCreateWithoutCountryInput;
  where: StateWhereUniqueInput;
};

export type StateCreateWithoutCountryInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type StateListRelationFilter = {
  every?: InputMaybe<StateWhereInput>;
  none?: InputMaybe<StateWhereInput>;
  some?: InputMaybe<StateWhereInput>;
};

export type StateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StateOrderByWithRelationInput = {
  country?: InputMaybe<CountryOrderByWithRelationInput>;
  countryId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type StateScalarWhereInput = {
  AND?: InputMaybe<Array<StateScalarWhereInput>>;
  NOT?: InputMaybe<Array<StateScalarWhereInput>>;
  OR?: InputMaybe<Array<StateScalarWhereInput>>;
  countryId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type StateUpdateInput = {
  country?: InputMaybe<CountryUpdateOneWithoutStatesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StateUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StateUpdateManyWithWhereWithoutCountryInput = {
  data: StateUpdateManyMutationInput;
  where: StateScalarWhereInput;
};

export type StateUpdateManyWithoutCountryNestedInput = {
  connect?: InputMaybe<Array<StateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StateCreateOrConnectWithoutCountryInput>>;
  create?: InputMaybe<Array<StateCreateWithoutCountryInput>>;
  createMany?: InputMaybe<StateCreateManyCountryInputEnvelope>;
  delete?: InputMaybe<Array<StateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StateWhereUniqueInput>>;
  set?: InputMaybe<Array<StateWhereUniqueInput>>;
  update?: InputMaybe<Array<StateUpdateWithWhereUniqueWithoutCountryInput>>;
  updateMany?: InputMaybe<Array<StateUpdateManyWithWhereWithoutCountryInput>>;
  upsert?: InputMaybe<Array<StateUpsertWithWhereUniqueWithoutCountryInput>>;
};

export type StateUpdateWithWhereUniqueWithoutCountryInput = {
  data: StateUpdateWithoutCountryInput;
  where: StateWhereUniqueInput;
};

export type StateUpdateWithoutCountryInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StateUpsertWithWhereUniqueWithoutCountryInput = {
  create: StateCreateWithoutCountryInput;
  update: StateUpdateWithoutCountryInput;
  where: StateWhereUniqueInput;
};

export type StateWhereInput = {
  AND?: InputMaybe<Array<StateWhereInput>>;
  NOT?: InputMaybe<Array<StateWhereInput>>;
  OR?: InputMaybe<Array<StateWhereInput>>;
  country?: InputMaybe<CountryWhereInput>;
  countryId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type StateWhereUniqueInput = {
  AND?: InputMaybe<Array<StateWhereInput>>;
  NOT?: InputMaybe<Array<StateWhereInput>>;
  OR?: InputMaybe<Array<StateWhereInput>>;
  country?: InputMaybe<CountryWhereInput>;
  countryId?: InputMaybe<StringNullableFilter>;
  id: Scalars['String']['input'];
  name?: InputMaybe<StringFilter>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringImportConfig = {
  network: Scalars['String']['input'];
};

export type StringImportResponse = {
  __typename?: 'StringImportResponse';
  ok?: Maybe<Scalars['Boolean']['output']>;
  stringCount?: Maybe<Scalars['Int']['output']>;
};

export type StringItem = {
  __typename?: 'StringItem';
  contentItem: ContentItem;
  contextId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  language: Language;
  list: Scalars['Boolean']['output'];
  status: StringItemStatus;
  translatedAt?: Maybe<Scalars['DateTime']['output']>;
  translation: StringItemTranslationType;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<User>;
  variant: Scalars['Int']['output'];
};

export type StringItemCreateInput = {
  contentItem: ContentItemCreateNestedOneWithoutStringsInput;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  history?: InputMaybe<StringItemHistoryCreateNestedManyWithoutStringItemInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  language: LanguageCreateNestedOneWithoutStringItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StringItemStatus>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
};

export type StringItemCreateManyContentItemInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  languageId: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StringItemStatus>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
};

export type StringItemCreateManyContentItemInputEnvelope = {
  data?: InputMaybe<Array<StringItemCreateManyContentItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringItemCreateManyLanguageInput = {
  contentItemId: Scalars['String']['input'];
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StringItemStatus>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
};

export type StringItemCreateManyLanguageInputEnvelope = {
  data?: InputMaybe<Array<StringItemCreateManyLanguageInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringItemCreateNestedManyWithoutContentItemInput = {
  connect?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringItemCreateOrConnectWithoutContentItemInput>>;
  create?: InputMaybe<Array<StringItemCreateWithoutContentItemInput>>;
  createMany?: InputMaybe<StringItemCreateManyContentItemInputEnvelope>;
};

export type StringItemCreateNestedManyWithoutLanguageInput = {
  connect?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringItemCreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<StringItemCreateWithoutLanguageInput>>;
  createMany?: InputMaybe<StringItemCreateManyLanguageInputEnvelope>;
};

export type StringItemCreateOrConnectWithoutContentItemInput = {
  create: StringItemCreateWithoutContentItemInput;
  where: StringItemWhereUniqueInput;
};

export type StringItemCreateOrConnectWithoutLanguageInput = {
  create: StringItemCreateWithoutLanguageInput;
  where: StringItemWhereUniqueInput;
};

export type StringItemCreateWithoutContentItemInput = {
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  history?: InputMaybe<StringItemHistoryCreateNestedManyWithoutStringItemInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  language: LanguageCreateNestedOneWithoutStringItemsInput;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StringItemStatus>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
};

export type StringItemCreateWithoutLanguageInput = {
  contentItem: ContentItemCreateNestedOneWithoutStringsInput;
  contextId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  data: Scalars['Json']['input'];
  history?: InputMaybe<StringItemHistoryCreateNestedManyWithoutStringItemInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<StringItemStatus>;
  syncStatus?: InputMaybe<StringItemSyncStatus>;
  translatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translation?: InputMaybe<StringItemTranslationType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['Int']['input']>;
};

export type StringItemHistoryCreateManyStringItemInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  translation?: InputMaybe<StringItemTranslationType>;
  value: Scalars['String']['input'];
};

export type StringItemHistoryCreateManyStringItemInputEnvelope = {
  data?: InputMaybe<Array<StringItemHistoryCreateManyStringItemInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringItemHistoryCreateNestedManyWithoutStringItemInput = {
  connect?: InputMaybe<Array<StringItemHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringItemHistoryCreateOrConnectWithoutStringItemInput>>;
  create?: InputMaybe<Array<StringItemHistoryCreateWithoutStringItemInput>>;
  createMany?: InputMaybe<StringItemHistoryCreateManyStringItemInputEnvelope>;
};

export type StringItemHistoryCreateOrConnectWithoutStringItemInput = {
  create: StringItemHistoryCreateWithoutStringItemInput;
  where: StringItemHistoryWhereUniqueInput;
};

export type StringItemHistoryCreateWithoutStringItemInput = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StringItemStatus>;
  translation?: InputMaybe<StringItemTranslationType>;
  value: Scalars['String']['input'];
};

export type StringItemHistoryListRelationFilter = {
  every?: InputMaybe<StringItemHistoryWhereInput>;
  none?: InputMaybe<StringItemHistoryWhereInput>;
  some?: InputMaybe<StringItemHistoryWhereInput>;
};

export type StringItemHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StringItemHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<StringItemHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<StringItemHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<StringItemHistoryScalarWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  stringItemId?: InputMaybe<StringNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  value?: InputMaybe<StringFilter>;
};

export type StringItemHistoryUpdateManyMutationInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StringItemHistoryUpdateManyWithWhereWithoutStringItemInput = {
  data: StringItemHistoryUpdateManyMutationInput;
  where: StringItemHistoryScalarWhereInput;
};

export type StringItemHistoryUpdateManyWithoutStringItemNestedInput = {
  connect?: InputMaybe<Array<StringItemHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringItemHistoryCreateOrConnectWithoutStringItemInput>>;
  create?: InputMaybe<Array<StringItemHistoryCreateWithoutStringItemInput>>;
  createMany?: InputMaybe<StringItemHistoryCreateManyStringItemInputEnvelope>;
  delete?: InputMaybe<Array<StringItemHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StringItemHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StringItemHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<StringItemHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<StringItemHistoryUpdateWithWhereUniqueWithoutStringItemInput>>;
  updateMany?: InputMaybe<Array<StringItemHistoryUpdateManyWithWhereWithoutStringItemInput>>;
  upsert?: InputMaybe<Array<StringItemHistoryUpsertWithWhereUniqueWithoutStringItemInput>>;
};

export type StringItemHistoryUpdateWithWhereUniqueWithoutStringItemInput = {
  data: StringItemHistoryUpdateWithoutStringItemInput;
  where: StringItemHistoryWhereUniqueInput;
};

export type StringItemHistoryUpdateWithoutStringItemInput = {
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StringItemHistoryUpsertWithWhereUniqueWithoutStringItemInput = {
  create: StringItemHistoryCreateWithoutStringItemInput;
  update: StringItemHistoryUpdateWithoutStringItemInput;
  where: StringItemHistoryWhereUniqueInput;
};

export type StringItemHistoryWhereInput = {
  AND?: InputMaybe<Array<StringItemHistoryWhereInput>>;
  NOT?: InputMaybe<Array<StringItemHistoryWhereInput>>;
  OR?: InputMaybe<Array<StringItemHistoryWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  stringItem?: InputMaybe<StringItemWhereInput>;
  stringItemId?: InputMaybe<StringNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  value?: InputMaybe<StringFilter>;
};

export type StringItemHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<StringItemHistoryWhereInput>>;
  NOT?: InputMaybe<Array<StringItemHistoryWhereInput>>;
  OR?: InputMaybe<Array<StringItemHistoryWhereInput>>;
  date?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  stringItem?: InputMaybe<StringItemWhereInput>;
  stringItemId?: InputMaybe<StringNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  value?: InputMaybe<StringFilter>;
};

export type StringItemListRelationFilter = {
  every?: InputMaybe<StringItemWhereInput>;
  none?: InputMaybe<StringItemWhereInput>;
  some?: InputMaybe<StringItemWhereInput>;
};

export type StringItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StringItemOrderByWithRelationInput = {
  contentItem?: InputMaybe<ContentItemOrderByWithRelationInput>;
  contentItemId?: InputMaybe<SortOrder>;
  contextId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  history?: InputMaybe<StringItemHistoryOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<LanguageOrderByWithRelationInput>;
  languageId?: InputMaybe<SortOrder>;
  list?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  syncStatus?: InputMaybe<SortOrder>;
  translatedAt?: InputMaybe<SortOrderInput>;
  translation?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  updatedBy?: InputMaybe<SortOrder>;
  variant?: InputMaybe<SortOrder>;
};

export type StringItemScalarWhereInput = {
  AND?: InputMaybe<Array<StringItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<StringItemScalarWhereInput>>;
  OR?: InputMaybe<Array<StringItemScalarWhereInput>>;
  contentItemId?: InputMaybe<StringFilter>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonFilter>;
  id?: InputMaybe<StringFilter>;
  languageId?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFilter>;
  translatedAt?: InputMaybe<DateTimeNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  variant?: InputMaybe<IntFilter>;
};

export enum StringItemStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT'
}

export enum StringItemSyncStatus {
  AwaitingSync = 'AWAITING_SYNC',
  Failed = 'FAILED',
  Pending = 'PENDING',
  UpToDate = 'UP_TO_DATE'
}

export enum StringItemTranslationType {
  Human = 'HUMAN',
  Localized = 'LOCALIZED',
  Machine = 'MACHINE'
}

export type StringItemUpdateInput = {
  contentItem?: InputMaybe<ContentItemUpdateOneRequiredWithoutStringsNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  history?: InputMaybe<StringItemHistoryUpdateManyWithoutStringItemNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutStringItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type StringItemUpdateManyMutationInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type StringItemUpdateManyWithWhereWithoutContentItemInput = {
  data: StringItemUpdateManyMutationInput;
  where: StringItemScalarWhereInput;
};

export type StringItemUpdateManyWithWhereWithoutLanguageInput = {
  data: StringItemUpdateManyMutationInput;
  where: StringItemScalarWhereInput;
};

export type StringItemUpdateManyWithoutContentItemNestedInput = {
  connect?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringItemCreateOrConnectWithoutContentItemInput>>;
  create?: InputMaybe<Array<StringItemCreateWithoutContentItemInput>>;
  createMany?: InputMaybe<StringItemCreateManyContentItemInputEnvelope>;
  delete?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StringItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  set?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  update?: InputMaybe<Array<StringItemUpdateWithWhereUniqueWithoutContentItemInput>>;
  updateMany?: InputMaybe<Array<StringItemUpdateManyWithWhereWithoutContentItemInput>>;
  upsert?: InputMaybe<Array<StringItemUpsertWithWhereUniqueWithoutContentItemInput>>;
};

export type StringItemUpdateManyWithoutLanguageNestedInput = {
  connect?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringItemCreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<StringItemCreateWithoutLanguageInput>>;
  createMany?: InputMaybe<StringItemCreateManyLanguageInputEnvelope>;
  delete?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StringItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  set?: InputMaybe<Array<StringItemWhereUniqueInput>>;
  update?: InputMaybe<Array<StringItemUpdateWithWhereUniqueWithoutLanguageInput>>;
  updateMany?: InputMaybe<Array<StringItemUpdateManyWithWhereWithoutLanguageInput>>;
  upsert?: InputMaybe<Array<StringItemUpsertWithWhereUniqueWithoutLanguageInput>>;
};

export type StringItemUpdateWithWhereUniqueWithoutContentItemInput = {
  data: StringItemUpdateWithoutContentItemInput;
  where: StringItemWhereUniqueInput;
};

export type StringItemUpdateWithWhereUniqueWithoutLanguageInput = {
  data: StringItemUpdateWithoutLanguageInput;
  where: StringItemWhereUniqueInput;
};

export type StringItemUpdateWithoutContentItemInput = {
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  history?: InputMaybe<StringItemHistoryUpdateManyWithoutStringItemNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutStringItemsNestedInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type StringItemUpdateWithoutLanguageInput = {
  contentItem?: InputMaybe<ContentItemUpdateOneRequiredWithoutStringsNestedInput>;
  contextId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  history?: InputMaybe<StringItemHistoryUpdateManyWithoutStringItemNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumStringItemStatusFieldUpdateOperationsInput>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFieldUpdateOperationsInput>;
  translatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  variant?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type StringItemUpsertWithWhereUniqueWithoutContentItemInput = {
  create: StringItemCreateWithoutContentItemInput;
  update: StringItemUpdateWithoutContentItemInput;
  where: StringItemWhereUniqueInput;
};

export type StringItemUpsertWithWhereUniqueWithoutLanguageInput = {
  create: StringItemCreateWithoutLanguageInput;
  update: StringItemUpdateWithoutLanguageInput;
  where: StringItemWhereUniqueInput;
};

export type StringItemWhereInput = {
  AND?: InputMaybe<Array<StringItemWhereInput>>;
  NOT?: InputMaybe<Array<StringItemWhereInput>>;
  OR?: InputMaybe<Array<StringItemWhereInput>>;
  contentItem?: InputMaybe<ContentItemWhereInput>;
  contentItemId?: InputMaybe<StringFilter>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonFilter>;
  history?: InputMaybe<StringItemHistoryListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  language?: InputMaybe<LanguageWhereInput>;
  languageId?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFilter>;
  translatedAt?: InputMaybe<DateTimeNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  variant?: InputMaybe<IntFilter>;
};

export type StringItemWhereUniqueInput = {
  AND?: InputMaybe<Array<StringItemWhereInput>>;
  NOT?: InputMaybe<Array<StringItemWhereInput>>;
  OR?: InputMaybe<Array<StringItemWhereInput>>;
  contentItem?: InputMaybe<ContentItemWhereInput>;
  contentItemId?: InputMaybe<StringFilter>;
  contextId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  data?: InputMaybe<JsonFilter>;
  history?: InputMaybe<StringItemHistoryListRelationFilter>;
  id: Scalars['String']['input'];
  language?: InputMaybe<LanguageWhereInput>;
  languageId?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  status?: InputMaybe<EnumStringItemStatusFilter>;
  syncStatus?: InputMaybe<EnumStringItemSyncStatusFilter>;
  translatedAt?: InputMaybe<DateTimeNullableFilter>;
  translation?: InputMaybe<EnumStringItemTranslationTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  updatedBy?: InputMaybe<StringFilter>;
  variant?: InputMaybe<IntFilter>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringTemplate = {
  __typename?: 'StringTemplate';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  level: ContextType;
  network: Network;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  updatedAt: Scalars['DateTime']['output'];
};


export type StringTemplateContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type StringTemplateHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type StringTemplatePropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type StringTemplateCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  level?: InputMaybe<ContextType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StringTemplateCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<StringTemplateCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringTemplateCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<StringTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringTemplateCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<StringTemplateCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<StringTemplateCreateManyNetworkInputEnvelope>;
};

export type StringTemplateCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<StringTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<StringTemplateCreateWithoutContentInput>;
};

export type StringTemplateCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<StringTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<StringTemplateCreateWithoutContentOldInput>;
};

export type StringTemplateCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<StringTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<StringTemplateCreateWithoutPropertiesInput>;
};

export type StringTemplateCreateOrConnectWithoutContentInput = {
  create: StringTemplateCreateWithoutContentInput;
  where: StringTemplateWhereUniqueInput;
};

export type StringTemplateCreateOrConnectWithoutContentOldInput = {
  create: StringTemplateCreateWithoutContentOldInput;
  where: StringTemplateWhereUniqueInput;
};

export type StringTemplateCreateOrConnectWithoutNetworkInput = {
  create: StringTemplateCreateWithoutNetworkInput;
  where: StringTemplateWhereUniqueInput;
};

export type StringTemplateCreateOrConnectWithoutPropertiesInput = {
  create: StringTemplateCreateWithoutPropertiesInput;
  where: StringTemplateWhereUniqueInput;
};

export type StringTemplateCreateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutStringTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  level?: InputMaybe<ContextType>;
  network: NetworkCreateNestedOneWithoutStringTemplateInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutStringTemplateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StringTemplateCreateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutStringTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  level?: InputMaybe<ContextType>;
  network: NetworkCreateNestedOneWithoutStringTemplateInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutStringTemplateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StringTemplateCreateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutStringTemplateInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutStringTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  level?: InputMaybe<ContextType>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutStringTemplateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StringTemplateCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutStringTemplateInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutStringTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  level?: InputMaybe<ContextType>;
  network: NetworkCreateNestedOneWithoutStringTemplateInput;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StringTemplateListRelationFilter = {
  every?: InputMaybe<StringTemplateWhereInput>;
  none?: InputMaybe<StringTemplateWhereInput>;
  some?: InputMaybe<StringTemplateWhereInput>;
};

export type StringTemplateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StringTemplateOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  level?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrder>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type StringTemplateScalarWhereInput = {
  AND?: InputMaybe<Array<StringTemplateScalarWhereInput>>;
  NOT?: InputMaybe<Array<StringTemplateScalarWhereInput>>;
  OR?: InputMaybe<Array<StringTemplateScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  level?: InputMaybe<EnumContextTypeFilter>;
  networkId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StringTemplateUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  level?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StringTemplateUpdateManyWithWhereWithoutNetworkInput = {
  data: StringTemplateUpdateManyMutationInput;
  where: StringTemplateScalarWhereInput;
};

export type StringTemplateUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<StringTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringTemplateCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<StringTemplateCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<StringTemplateCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<StringTemplateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StringTemplateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StringTemplateWhereUniqueInput>>;
  set?: InputMaybe<Array<StringTemplateWhereUniqueInput>>;
  update?: InputMaybe<Array<StringTemplateUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<StringTemplateUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<StringTemplateUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type StringTemplateUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<StringTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<StringTemplateCreateWithoutContentInput>;
  delete?: InputMaybe<StringTemplateWhereInput>;
  disconnect?: InputMaybe<StringTemplateWhereInput>;
  update?: InputMaybe<StringTemplateUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<StringTemplateUpsertWithoutContentInput>;
};

export type StringTemplateUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<StringTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<StringTemplateCreateWithoutContentOldInput>;
  delete?: InputMaybe<StringTemplateWhereInput>;
  disconnect?: InputMaybe<StringTemplateWhereInput>;
  update?: InputMaybe<StringTemplateUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<StringTemplateUpsertWithoutContentOldInput>;
};

export type StringTemplateUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<StringTemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<StringTemplateCreateWithoutPropertiesInput>;
  delete?: InputMaybe<StringTemplateWhereInput>;
  disconnect?: InputMaybe<StringTemplateWhereInput>;
  update?: InputMaybe<StringTemplateUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<StringTemplateUpsertWithoutPropertiesInput>;
};

export type StringTemplateUpdateToOneWithWhereWithoutContentInput = {
  data: StringTemplateUpdateWithoutContentInput;
  where?: InputMaybe<StringTemplateWhereInput>;
};

export type StringTemplateUpdateToOneWithWhereWithoutContentOldInput = {
  data: StringTemplateUpdateWithoutContentOldInput;
  where?: InputMaybe<StringTemplateWhereInput>;
};

export type StringTemplateUpdateToOneWithWhereWithoutPropertiesInput = {
  data: StringTemplateUpdateWithoutPropertiesInput;
  where?: InputMaybe<StringTemplateWhereInput>;
};

export type StringTemplateUpdateWithWhereUniqueWithoutNetworkInput = {
  data: StringTemplateUpdateWithoutNetworkInput;
  where: StringTemplateWhereUniqueInput;
};

export type StringTemplateUpdateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutStringTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  level?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutStringTemplateNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutStringTemplateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StringTemplateUpdateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutStringTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  level?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutStringTemplateNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutStringTemplateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StringTemplateUpdateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutStringTemplateNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutStringTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  level?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutStringTemplateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StringTemplateUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutStringTemplateNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutStringTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  level?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutStringTemplateNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type StringTemplateUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type StringTemplateUpsertWithWhereUniqueWithoutNetworkInput = {
  create: StringTemplateCreateWithoutNetworkInput;
  update: StringTemplateUpdateWithoutNetworkInput;
  where: StringTemplateWhereUniqueInput;
};

export type StringTemplateUpsertWithoutContentInput = {
  create: StringTemplateCreateWithoutContentInput;
  update: StringTemplateUpdateWithoutContentInput;
  where?: InputMaybe<StringTemplateWhereInput>;
};

export type StringTemplateUpsertWithoutContentOldInput = {
  create: StringTemplateCreateWithoutContentOldInput;
  update: StringTemplateUpdateWithoutContentOldInput;
  where?: InputMaybe<StringTemplateWhereInput>;
};

export type StringTemplateUpsertWithoutPropertiesInput = {
  create: StringTemplateCreateWithoutPropertiesInput;
  update: StringTemplateUpdateWithoutPropertiesInput;
  where?: InputMaybe<StringTemplateWhereInput>;
};

export type StringTemplateVariable = {
  __typename?: 'StringTemplateVariable';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  data?: Maybe<Scalars['Json']['output']>;
  enabled: Scalars['Boolean']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  network: Network;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  type: StringTemplateVariableType;
};


export type StringTemplateVariableContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type StringTemplateVariablePropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type StringTemplateVariableCreateManyNetworkInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  resolvedIn?: InputMaybe<StringTemplateVariableResolveLocation>;
  type: StringTemplateVariableType;
};

export type StringTemplateVariableCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<StringTemplateVariableCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StringTemplateVariableCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<StringTemplateVariableWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringTemplateVariableCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<StringTemplateVariableCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<StringTemplateVariableCreateManyNetworkInputEnvelope>;
};

export type StringTemplateVariableCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<StringTemplateVariableWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateVariableCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<StringTemplateVariableCreateWithoutContentInput>;
};

export type StringTemplateVariableCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<StringTemplateVariableWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateVariableCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<StringTemplateVariableCreateWithoutContentOldInput>;
};

export type StringTemplateVariableCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<StringTemplateVariableWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateVariableCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<StringTemplateVariableCreateWithoutPropertiesInput>;
};

export type StringTemplateVariableCreateOrConnectWithoutContentInput = {
  create: StringTemplateVariableCreateWithoutContentInput;
  where: StringTemplateVariableWhereUniqueInput;
};

export type StringTemplateVariableCreateOrConnectWithoutContentOldInput = {
  create: StringTemplateVariableCreateWithoutContentOldInput;
  where: StringTemplateVariableWhereUniqueInput;
};

export type StringTemplateVariableCreateOrConnectWithoutNetworkInput = {
  create: StringTemplateVariableCreateWithoutNetworkInput;
  where: StringTemplateVariableWhereUniqueInput;
};

export type StringTemplateVariableCreateOrConnectWithoutPropertiesInput = {
  create: StringTemplateVariableCreateWithoutPropertiesInput;
  where: StringTemplateVariableWhereUniqueInput;
};

export type StringTemplateVariableCreateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutStringTemplateVariableInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  network: NetworkCreateNestedOneWithoutStringTemplateVariableInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutStringTemplateVariableInput>;
  resolvedIn?: InputMaybe<StringTemplateVariableResolveLocation>;
  type: StringTemplateVariableType;
};

export type StringTemplateVariableCreateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutStringTemplateVariableInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  network: NetworkCreateNestedOneWithoutStringTemplateVariableInput;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutStringTemplateVariableInput>;
  resolvedIn?: InputMaybe<StringTemplateVariableResolveLocation>;
  type: StringTemplateVariableType;
};

export type StringTemplateVariableCreateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutStringTemplateVariableInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutStringTemplateVariableInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutStringTemplateVariableInput>;
  resolvedIn?: InputMaybe<StringTemplateVariableResolveLocation>;
  type: StringTemplateVariableType;
};

export type StringTemplateVariableCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutStringTemplateVariableInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutStringTemplateVariableInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  network: NetworkCreateNestedOneWithoutStringTemplateVariableInput;
  resolvedIn?: InputMaybe<StringTemplateVariableResolveLocation>;
  type: StringTemplateVariableType;
};

export type StringTemplateVariableListRelationFilter = {
  every?: InputMaybe<StringTemplateVariableWhereInput>;
  none?: InputMaybe<StringTemplateVariableWhereInput>;
  some?: InputMaybe<StringTemplateVariableWhereInput>;
};

export type StringTemplateVariableOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StringTemplateVariableOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  data?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  enabled?: InputMaybe<SortOrder>;
  group?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrder>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  resolvedIn?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum StringTemplateVariableResolveLocation {
  Backend = 'BACKEND',
  Frontend = 'FRONTEND'
}

export type StringTemplateVariableScalarWhereInput = {
  AND?: InputMaybe<Array<StringTemplateVariableScalarWhereInput>>;
  NOT?: InputMaybe<Array<StringTemplateVariableScalarWhereInput>>;
  OR?: InputMaybe<Array<StringTemplateVariableScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  group?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringFilter>;
  resolvedIn?: InputMaybe<EnumStringTemplateVariableResolveLocationFilter>;
  type?: InputMaybe<EnumStringTemplateVariableTypeFilter>;
};

export enum StringTemplateVariableType {
  Content = 'CONTENT',
  Property = 'PROPERTY'
}

export type StringTemplateVariableUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resolvedIn?: InputMaybe<EnumStringTemplateVariableResolveLocationFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumStringTemplateVariableTypeFieldUpdateOperationsInput>;
};

export type StringTemplateVariableUpdateManyWithWhereWithoutNetworkInput = {
  data: StringTemplateVariableUpdateManyMutationInput;
  where: StringTemplateVariableScalarWhereInput;
};

export type StringTemplateVariableUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<StringTemplateVariableWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StringTemplateVariableCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<StringTemplateVariableCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<StringTemplateVariableCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<StringTemplateVariableWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StringTemplateVariableScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StringTemplateVariableWhereUniqueInput>>;
  set?: InputMaybe<Array<StringTemplateVariableWhereUniqueInput>>;
  update?: InputMaybe<Array<StringTemplateVariableUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<StringTemplateVariableUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<StringTemplateVariableUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type StringTemplateVariableUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<StringTemplateVariableWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateVariableCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<StringTemplateVariableCreateWithoutContentInput>;
  delete?: InputMaybe<StringTemplateVariableWhereInput>;
  disconnect?: InputMaybe<StringTemplateVariableWhereInput>;
  update?: InputMaybe<StringTemplateVariableUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<StringTemplateVariableUpsertWithoutContentInput>;
};

export type StringTemplateVariableUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<StringTemplateVariableWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateVariableCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<StringTemplateVariableCreateWithoutContentOldInput>;
  delete?: InputMaybe<StringTemplateVariableWhereInput>;
  disconnect?: InputMaybe<StringTemplateVariableWhereInput>;
  update?: InputMaybe<StringTemplateVariableUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<StringTemplateVariableUpsertWithoutContentOldInput>;
};

export type StringTemplateVariableUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<StringTemplateVariableWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StringTemplateVariableCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<StringTemplateVariableCreateWithoutPropertiesInput>;
  delete?: InputMaybe<StringTemplateVariableWhereInput>;
  disconnect?: InputMaybe<StringTemplateVariableWhereInput>;
  update?: InputMaybe<StringTemplateVariableUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<StringTemplateVariableUpsertWithoutPropertiesInput>;
};

export type StringTemplateVariableUpdateToOneWithWhereWithoutContentInput = {
  data: StringTemplateVariableUpdateWithoutContentInput;
  where?: InputMaybe<StringTemplateVariableWhereInput>;
};

export type StringTemplateVariableUpdateToOneWithWhereWithoutContentOldInput = {
  data: StringTemplateVariableUpdateWithoutContentOldInput;
  where?: InputMaybe<StringTemplateVariableWhereInput>;
};

export type StringTemplateVariableUpdateToOneWithWhereWithoutPropertiesInput = {
  data: StringTemplateVariableUpdateWithoutPropertiesInput;
  where?: InputMaybe<StringTemplateVariableWhereInput>;
};

export type StringTemplateVariableUpdateWithWhereUniqueWithoutNetworkInput = {
  data: StringTemplateVariableUpdateWithoutNetworkInput;
  where: StringTemplateVariableWhereUniqueInput;
};

export type StringTemplateVariableUpdateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutStringTemplateVariableNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutStringTemplateVariableNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutStringTemplateVariableNestedInput>;
  resolvedIn?: InputMaybe<EnumStringTemplateVariableResolveLocationFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumStringTemplateVariableTypeFieldUpdateOperationsInput>;
};

export type StringTemplateVariableUpdateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutStringTemplateVariableNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutStringTemplateVariableNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutStringTemplateVariableNestedInput>;
  resolvedIn?: InputMaybe<EnumStringTemplateVariableResolveLocationFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumStringTemplateVariableTypeFieldUpdateOperationsInput>;
};

export type StringTemplateVariableUpdateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutStringTemplateVariableNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutStringTemplateVariableNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutStringTemplateVariableNestedInput>;
  resolvedIn?: InputMaybe<EnumStringTemplateVariableResolveLocationFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumStringTemplateVariableTypeFieldUpdateOperationsInput>;
};

export type StringTemplateVariableUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutStringTemplateVariableNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutStringTemplateVariableNestedInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneRequiredWithoutStringTemplateVariableNestedInput>;
  resolvedIn?: InputMaybe<EnumStringTemplateVariableResolveLocationFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumStringTemplateVariableTypeFieldUpdateOperationsInput>;
};

export type StringTemplateVariableUpsertWithWhereUniqueWithoutNetworkInput = {
  create: StringTemplateVariableCreateWithoutNetworkInput;
  update: StringTemplateVariableUpdateWithoutNetworkInput;
  where: StringTemplateVariableWhereUniqueInput;
};

export type StringTemplateVariableUpsertWithoutContentInput = {
  create: StringTemplateVariableCreateWithoutContentInput;
  update: StringTemplateVariableUpdateWithoutContentInput;
  where?: InputMaybe<StringTemplateVariableWhereInput>;
};

export type StringTemplateVariableUpsertWithoutContentOldInput = {
  create: StringTemplateVariableCreateWithoutContentOldInput;
  update: StringTemplateVariableUpdateWithoutContentOldInput;
  where?: InputMaybe<StringTemplateVariableWhereInput>;
};

export type StringTemplateVariableUpsertWithoutPropertiesInput = {
  create: StringTemplateVariableCreateWithoutPropertiesInput;
  update: StringTemplateVariableUpdateWithoutPropertiesInput;
  where?: InputMaybe<StringTemplateVariableWhereInput>;
};

export type StringTemplateVariableWhereInput = {
  AND?: InputMaybe<Array<StringTemplateVariableWhereInput>>;
  NOT?: InputMaybe<Array<StringTemplateVariableWhereInput>>;
  OR?: InputMaybe<Array<StringTemplateVariableWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  group?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  resolvedIn?: InputMaybe<EnumStringTemplateVariableResolveLocationFilter>;
  type?: InputMaybe<EnumStringTemplateVariableTypeFilter>;
};

export type StringTemplateVariableWhereUniqueInput = {
  AND?: InputMaybe<Array<StringTemplateVariableWhereInput>>;
  NOT?: InputMaybe<Array<StringTemplateVariableWhereInput>>;
  OR?: InputMaybe<Array<StringTemplateVariableWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enabled?: InputMaybe<BoolFilter>;
  group?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  resolvedIn?: InputMaybe<EnumStringTemplateVariableResolveLocationFilter>;
  type?: InputMaybe<EnumStringTemplateVariableTypeFilter>;
};

export type StringTemplateWhereInput = {
  AND?: InputMaybe<Array<StringTemplateWhereInput>>;
  NOT?: InputMaybe<Array<StringTemplateWhereInput>>;
  OR?: InputMaybe<Array<StringTemplateWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  key?: InputMaybe<StringFilter>;
  level?: InputMaybe<EnumContextTypeFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type StringTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<StringTemplateWhereInput>>;
  NOT?: InputMaybe<Array<StringTemplateWhereInput>>;
  OR?: InputMaybe<Array<StringTemplateWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<StringFilter>;
  level?: InputMaybe<EnumContextTypeFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Subregion = {
  __typename?: 'Subregion';
  countries: Array<Country>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region: Region;
};


export type SubregionCountriesArgs = {
  cursor?: InputMaybe<CountryWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountryWhereInput>;
};

export type SubregionCreateInput = {
  countries?: InputMaybe<CountryCreateNestedManyWithoutSubregionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  region: RegionCreateNestedOneWithoutSubregionsInput;
};

export type SubregionCreateManyRegionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SubregionCreateManyRegionInputEnvelope = {
  data?: InputMaybe<Array<SubregionCreateManyRegionInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubregionCreateNestedManyWithoutRegionInput = {
  connect?: InputMaybe<Array<SubregionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubregionCreateOrConnectWithoutRegionInput>>;
  create?: InputMaybe<Array<SubregionCreateWithoutRegionInput>>;
  createMany?: InputMaybe<SubregionCreateManyRegionInputEnvelope>;
};

export type SubregionCreateNestedOneWithoutCountriesInput = {
  connect?: InputMaybe<SubregionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SubregionCreateOrConnectWithoutCountriesInput>;
  create?: InputMaybe<SubregionCreateWithoutCountriesInput>;
};

export type SubregionCreateOrConnectWithoutCountriesInput = {
  create: SubregionCreateWithoutCountriesInput;
  where: SubregionWhereUniqueInput;
};

export type SubregionCreateOrConnectWithoutRegionInput = {
  create: SubregionCreateWithoutRegionInput;
  where: SubregionWhereUniqueInput;
};

export type SubregionCreateWithoutCountriesInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  region: RegionCreateNestedOneWithoutSubregionsInput;
};

export type SubregionCreateWithoutRegionInput = {
  countries?: InputMaybe<CountryCreateNestedManyWithoutSubregionInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SubregionListRelationFilter = {
  every?: InputMaybe<SubregionWhereInput>;
  none?: InputMaybe<SubregionWhereInput>;
  some?: InputMaybe<SubregionWhereInput>;
};

export type SubregionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SubregionOrderByWithRelationInput = {
  countries?: InputMaybe<CountryOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  region?: InputMaybe<RegionOrderByWithRelationInput>;
  regionId?: InputMaybe<SortOrder>;
};

export type SubregionScalarWhereInput = {
  AND?: InputMaybe<Array<SubregionScalarWhereInput>>;
  NOT?: InputMaybe<Array<SubregionScalarWhereInput>>;
  OR?: InputMaybe<Array<SubregionScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  regionId?: InputMaybe<StringFilter>;
};

export type SubregionUpdateInput = {
  countries?: InputMaybe<CountryUpdateManyWithoutSubregionNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  region?: InputMaybe<RegionUpdateOneRequiredWithoutSubregionsNestedInput>;
};

export type SubregionUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SubregionUpdateManyWithWhereWithoutRegionInput = {
  data: SubregionUpdateManyMutationInput;
  where: SubregionScalarWhereInput;
};

export type SubregionUpdateManyWithoutRegionNestedInput = {
  connect?: InputMaybe<Array<SubregionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SubregionCreateOrConnectWithoutRegionInput>>;
  create?: InputMaybe<Array<SubregionCreateWithoutRegionInput>>;
  createMany?: InputMaybe<SubregionCreateManyRegionInputEnvelope>;
  delete?: InputMaybe<Array<SubregionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SubregionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SubregionWhereUniqueInput>>;
  set?: InputMaybe<Array<SubregionWhereUniqueInput>>;
  update?: InputMaybe<Array<SubregionUpdateWithWhereUniqueWithoutRegionInput>>;
  updateMany?: InputMaybe<Array<SubregionUpdateManyWithWhereWithoutRegionInput>>;
  upsert?: InputMaybe<Array<SubregionUpsertWithWhereUniqueWithoutRegionInput>>;
};

export type SubregionUpdateOneWithoutCountriesNestedInput = {
  connect?: InputMaybe<SubregionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SubregionCreateOrConnectWithoutCountriesInput>;
  create?: InputMaybe<SubregionCreateWithoutCountriesInput>;
  delete?: InputMaybe<SubregionWhereInput>;
  disconnect?: InputMaybe<SubregionWhereInput>;
  update?: InputMaybe<SubregionUpdateToOneWithWhereWithoutCountriesInput>;
  upsert?: InputMaybe<SubregionUpsertWithoutCountriesInput>;
};

export type SubregionUpdateToOneWithWhereWithoutCountriesInput = {
  data: SubregionUpdateWithoutCountriesInput;
  where?: InputMaybe<SubregionWhereInput>;
};

export type SubregionUpdateWithWhereUniqueWithoutRegionInput = {
  data: SubregionUpdateWithoutRegionInput;
  where: SubregionWhereUniqueInput;
};

export type SubregionUpdateWithoutCountriesInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  region?: InputMaybe<RegionUpdateOneRequiredWithoutSubregionsNestedInput>;
};

export type SubregionUpdateWithoutRegionInput = {
  countries?: InputMaybe<CountryUpdateManyWithoutSubregionNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SubregionUpsertWithWhereUniqueWithoutRegionInput = {
  create: SubregionCreateWithoutRegionInput;
  update: SubregionUpdateWithoutRegionInput;
  where: SubregionWhereUniqueInput;
};

export type SubregionUpsertWithoutCountriesInput = {
  create: SubregionCreateWithoutCountriesInput;
  update: SubregionUpdateWithoutCountriesInput;
  where?: InputMaybe<SubregionWhereInput>;
};

export type SubregionWhereInput = {
  AND?: InputMaybe<Array<SubregionWhereInput>>;
  NOT?: InputMaybe<Array<SubregionWhereInput>>;
  OR?: InputMaybe<Array<SubregionWhereInput>>;
  countries?: InputMaybe<CountryListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  region?: InputMaybe<RegionWhereInput>;
  regionId?: InputMaybe<StringFilter>;
};

export type SubregionWhereUniqueInput = {
  AND?: InputMaybe<Array<SubregionWhereInput>>;
  NOT?: InputMaybe<Array<SubregionWhereInput>>;
  OR?: InputMaybe<Array<SubregionWhereInput>>;
  countries?: InputMaybe<CountryListRelationFilter>;
  id: Scalars['String']['input'];
  name?: InputMaybe<StringFilter>;
  region?: InputMaybe<RegionWhereInput>;
  regionId?: InputMaybe<StringFilter>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['String']['output'];
  mediaItems: Array<MediaItem>;
  name: Scalars['String']['output'];
};


export type TagMediaItemsArgs = {
  cursor?: InputMaybe<MediaItemWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaItemWhereInput>;
};

export type TagCreateInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  mediaItems?: InputMaybe<MediaItemCreateNestedManyWithoutTagsInput>;
  name: Scalars['String']['input'];
};

export type TagCreateNestedManyWithoutMediaItemsInput = {
  connect?: InputMaybe<Array<TagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TagCreateOrConnectWithoutMediaItemsInput>>;
  create?: InputMaybe<Array<TagCreateWithoutMediaItemsInput>>;
};

export type TagCreateOrConnectWithoutMediaItemsInput = {
  create: TagCreateWithoutMediaItemsInput;
  where: TagWhereUniqueInput;
};

export type TagCreateWithoutMediaItemsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TagListRelationFilter = {
  every?: InputMaybe<TagWhereInput>;
  none?: InputMaybe<TagWhereInput>;
  some?: InputMaybe<TagWhereInput>;
};

export type TagOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TagOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  mediaItems?: InputMaybe<MediaItemOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
};

export type TagScalarWhereInput = {
  AND?: InputMaybe<Array<TagScalarWhereInput>>;
  NOT?: InputMaybe<Array<TagScalarWhereInput>>;
  OR?: InputMaybe<Array<TagScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type TagUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaItems?: InputMaybe<MediaItemUpdateManyWithoutTagsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TagUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TagUpdateManyWithWhereWithoutMediaItemsInput = {
  data: TagUpdateManyMutationInput;
  where: TagScalarWhereInput;
};

export type TagUpdateManyWithoutMediaItemsNestedInput = {
  connect?: InputMaybe<Array<TagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TagCreateOrConnectWithoutMediaItemsInput>>;
  create?: InputMaybe<Array<TagCreateWithoutMediaItemsInput>>;
  delete?: InputMaybe<Array<TagWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TagScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TagWhereUniqueInput>>;
  set?: InputMaybe<Array<TagWhereUniqueInput>>;
  update?: InputMaybe<Array<TagUpdateWithWhereUniqueWithoutMediaItemsInput>>;
  updateMany?: InputMaybe<Array<TagUpdateManyWithWhereWithoutMediaItemsInput>>;
  upsert?: InputMaybe<Array<TagUpsertWithWhereUniqueWithoutMediaItemsInput>>;
};

export type TagUpdateWithWhereUniqueWithoutMediaItemsInput = {
  data: TagUpdateWithoutMediaItemsInput;
  where: TagWhereUniqueInput;
};

export type TagUpdateWithoutMediaItemsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TagUpsertWithWhereUniqueWithoutMediaItemsInput = {
  create: TagCreateWithoutMediaItemsInput;
  update: TagUpdateWithoutMediaItemsInput;
  where: TagWhereUniqueInput;
};

export type TagWhereInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<Array<TagWhereInput>>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  id?: InputMaybe<StringFilter>;
  mediaItems?: InputMaybe<MediaItemListRelationFilter>;
  name?: InputMaybe<StringFilter>;
};

export type TagWhereUniqueInput = {
  AND?: InputMaybe<Array<TagWhereInput>>;
  NOT?: InputMaybe<Array<TagWhereInput>>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  id: Scalars['String']['input'];
  mediaItems?: InputMaybe<MediaItemListRelationFilter>;
  name?: InputMaybe<StringFilter>;
};

export type TaxonomyItem = {
  __typename?: 'TaxonomyItem';
  children?: Maybe<Array<Maybe<TaxonomyItem>>>;
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  data?: Maybe<Scalars['Json']['output']>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Network>;
  parent?: Maybe<TaxonomyItem>;
  parentId?: Maybe<Scalars['String']['output']>;
  pools?: Maybe<Array<Maybe<TaxonomyItemPool>>>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  resourceType?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TaxonomyItemChildrenArgs = {
  orderBy?: InputMaybe<TaxonomyItemOrderByWithRelationInput>;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};


export type TaxonomyItemContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type TaxonomyItemHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TaxonomyItemPropertiesArgs = {
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type TaxonomyItemCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<TaxonomyItemCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxonomyItemCreateManyParentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  networkId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateManyParentInputEnvelope = {
  data?: InputMaybe<Array<TaxonomyItemCreateManyParentInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TaxonomyItemCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<TaxonomyItemCreateManyNetworkInputEnvelope>;
};

export type TaxonomyItemCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutParentInput>>;
  createMany?: InputMaybe<TaxonomyItemCreateManyParentInputEnvelope>;
};

export type TaxonomyItemCreateNestedManyWithoutPoolsInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutPoolsInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutPoolsInput>>;
};

export type TaxonomyItemCreateNestedManyWithoutPostsInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutPostsInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutPostsInput>>;
};

export type TaxonomyItemCreateNestedManyWithoutProductsInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutProductsInput>>;
};

export type TaxonomyItemCreateNestedManyWithoutProvidersInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutProvidersInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutProvidersInput>>;
};

export type TaxonomyItemCreateNestedOneWithoutChildrenInput = {
  connect?: InputMaybe<TaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TaxonomyItemCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<TaxonomyItemCreateWithoutChildrenInput>;
};

export type TaxonomyItemCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<TaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TaxonomyItemCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<TaxonomyItemCreateWithoutContentInput>;
};

export type TaxonomyItemCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<TaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TaxonomyItemCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<TaxonomyItemCreateWithoutPropertiesInput>;
};

export type TaxonomyItemCreateNestedOneWithoutProviderTaxonomyConnectionsInput = {
  connect?: InputMaybe<TaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TaxonomyItemCreateOrConnectWithoutProviderTaxonomyConnectionsInput>;
  create?: InputMaybe<TaxonomyItemCreateWithoutProviderTaxonomyConnectionsInput>;
};

export type TaxonomyItemCreateOrConnectWithoutChildrenInput = {
  create: TaxonomyItemCreateWithoutChildrenInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutContentInput = {
  create: TaxonomyItemCreateWithoutContentInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutNetworkInput = {
  create: TaxonomyItemCreateWithoutNetworkInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutParentInput = {
  create: TaxonomyItemCreateWithoutParentInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutPoolsInput = {
  create: TaxonomyItemCreateWithoutPoolsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutPostsInput = {
  create: TaxonomyItemCreateWithoutPostsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutProductsInput = {
  create: TaxonomyItemCreateWithoutProductsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutPropertiesInput = {
  create: TaxonomyItemCreateWithoutPropertiesInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutProviderTaxonomyConnectionsInput = {
  create: TaxonomyItemCreateWithoutProviderTaxonomyConnectionsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateOrConnectWithoutProvidersInput = {
  create: TaxonomyItemCreateWithoutProvidersInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemCreateWithoutChildrenInput = {
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutContentInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutNetworkInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutParentInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutPoolsInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutPostsInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutProductsInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutPropertiesInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutProviderTaxonomyConnectionsInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providers?: InputMaybe<ProviderCreateNestedManyWithoutTaxonomiesInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemCreateWithoutProvidersInput = {
  children?: InputMaybe<TaxonomyItemCreateNestedManyWithoutParentInput>;
  content?: InputMaybe<ContentItemCreateNestedManyWithoutTaxonomyItemInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTaxonomyItemInput>;
  parent?: InputMaybe<TaxonomyItemCreateNestedOneWithoutChildrenInput>;
  pools?: InputMaybe<TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput>;
  posts?: InputMaybe<PostCreateNestedManyWithoutTaxonomiesInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutTaxonomiesInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTaxonomyItemInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionCreateNestedManyWithoutTaxonomyItemInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TaxonomyItemListRelationFilter = {
  every?: InputMaybe<TaxonomyItemWhereInput>;
  none?: InputMaybe<TaxonomyItemWhereInput>;
  some?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TaxonomyItemOrderByWithRelationInput = {
  children?: InputMaybe<TaxonomyItemOrderByRelationAggregateInput>;
  content?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  parent?: InputMaybe<TaxonomyItemOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrderInput>;
  pools?: InputMaybe<TaxonomyItemPoolOrderByRelationAggregateInput>;
  posts?: InputMaybe<PostOrderByRelationAggregateInput>;
  products?: InputMaybe<ProductOrderByRelationAggregateInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionOrderByRelationAggregateInput>;
  providers?: InputMaybe<ProviderOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TaxonomyItemPool = {
  __typename?: 'TaxonomyItemPool';
  createdBy?: Maybe<User>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  networks?: Maybe<Array<Maybe<Network>>>;
  taxonomyItems?: Maybe<Array<Maybe<TaxonomyItem>>>;
};


export type TaxonomyItemPoolHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TaxonomyItemPoolCreateNestedManyWithoutNetworksInput = {
  connect?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemPoolCreateOrConnectWithoutNetworksInput>>;
  create?: InputMaybe<Array<TaxonomyItemPoolCreateWithoutNetworksInput>>;
};

export type TaxonomyItemPoolCreateNestedManyWithoutTaxonomyItemsInput = {
  connect?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemPoolCreateOrConnectWithoutTaxonomyItemsInput>>;
  create?: InputMaybe<Array<TaxonomyItemPoolCreateWithoutTaxonomyItemsInput>>;
};

export type TaxonomyItemPoolCreateOrConnectWithoutNetworksInput = {
  create: TaxonomyItemPoolCreateWithoutNetworksInput;
  where: TaxonomyItemPoolWhereUniqueInput;
};

export type TaxonomyItemPoolCreateOrConnectWithoutTaxonomyItemsInput = {
  create: TaxonomyItemPoolCreateWithoutTaxonomyItemsInput;
  where: TaxonomyItemPoolWhereUniqueInput;
};

export type TaxonomyItemPoolCreateWithoutNetworksInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taxonomyItems?: InputMaybe<TaxonomyItemCreateNestedManyWithoutPoolsInput>;
};

export type TaxonomyItemPoolCreateWithoutTaxonomyItemsInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  networks?: InputMaybe<NetworkCreateNestedManyWithoutTaxonomyItemPoolsInput>;
};

export type TaxonomyItemPoolListRelationFilter = {
  every?: InputMaybe<TaxonomyItemPoolWhereInput>;
  none?: InputMaybe<TaxonomyItemPoolWhereInput>;
  some?: InputMaybe<TaxonomyItemPoolWhereInput>;
};

export type TaxonomyItemPoolOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TaxonomyItemPoolScalarWhereInput = {
  AND?: InputMaybe<Array<TaxonomyItemPoolScalarWhereInput>>;
  NOT?: InputMaybe<Array<TaxonomyItemPoolScalarWhereInput>>;
  OR?: InputMaybe<Array<TaxonomyItemPoolScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type TaxonomyItemPoolUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TaxonomyItemPoolUpdateManyWithWhereWithoutNetworksInput = {
  data: TaxonomyItemPoolUpdateManyMutationInput;
  where: TaxonomyItemPoolScalarWhereInput;
};

export type TaxonomyItemPoolUpdateManyWithWhereWithoutTaxonomyItemsInput = {
  data: TaxonomyItemPoolUpdateManyMutationInput;
  where: TaxonomyItemPoolScalarWhereInput;
};

export type TaxonomyItemPoolUpdateManyWithoutNetworksNestedInput = {
  connect?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemPoolCreateOrConnectWithoutNetworksInput>>;
  create?: InputMaybe<Array<TaxonomyItemPoolCreateWithoutNetworksInput>>;
  delete?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaxonomyItemPoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  set?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  update?: InputMaybe<Array<TaxonomyItemPoolUpdateWithWhereUniqueWithoutNetworksInput>>;
  updateMany?: InputMaybe<Array<TaxonomyItemPoolUpdateManyWithWhereWithoutNetworksInput>>;
  upsert?: InputMaybe<Array<TaxonomyItemPoolUpsertWithWhereUniqueWithoutNetworksInput>>;
};

export type TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput = {
  connect?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemPoolCreateOrConnectWithoutTaxonomyItemsInput>>;
  create?: InputMaybe<Array<TaxonomyItemPoolCreateWithoutTaxonomyItemsInput>>;
  delete?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaxonomyItemPoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  set?: InputMaybe<Array<TaxonomyItemPoolWhereUniqueInput>>;
  update?: InputMaybe<Array<TaxonomyItemPoolUpdateWithWhereUniqueWithoutTaxonomyItemsInput>>;
  updateMany?: InputMaybe<Array<TaxonomyItemPoolUpdateManyWithWhereWithoutTaxonomyItemsInput>>;
  upsert?: InputMaybe<Array<TaxonomyItemPoolUpsertWithWhereUniqueWithoutTaxonomyItemsInput>>;
};

export type TaxonomyItemPoolUpdateWithWhereUniqueWithoutNetworksInput = {
  data: TaxonomyItemPoolUpdateWithoutNetworksInput;
  where: TaxonomyItemPoolWhereUniqueInput;
};

export type TaxonomyItemPoolUpdateWithWhereUniqueWithoutTaxonomyItemsInput = {
  data: TaxonomyItemPoolUpdateWithoutTaxonomyItemsInput;
  where: TaxonomyItemPoolWhereUniqueInput;
};

export type TaxonomyItemPoolUpdateWithoutNetworksInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  taxonomyItems?: InputMaybe<TaxonomyItemUpdateManyWithoutPoolsNestedInput>;
};

export type TaxonomyItemPoolUpdateWithoutTaxonomyItemsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  networks?: InputMaybe<NetworkUpdateManyWithoutTaxonomyItemPoolsNestedInput>;
};

export type TaxonomyItemPoolUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  name: Scalars['String']['input'];
  networks: Array<NetworkWhereUniqueInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
  taxonomyItems: Array<TaxonomyItemWhereUniqueInput>;
};

export type TaxonomyItemPoolUpsertWithWhereUniqueWithoutNetworksInput = {
  create: TaxonomyItemPoolCreateWithoutNetworksInput;
  update: TaxonomyItemPoolUpdateWithoutNetworksInput;
  where: TaxonomyItemPoolWhereUniqueInput;
};

export type TaxonomyItemPoolUpsertWithWhereUniqueWithoutTaxonomyItemsInput = {
  create: TaxonomyItemPoolCreateWithoutTaxonomyItemsInput;
  update: TaxonomyItemPoolUpdateWithoutTaxonomyItemsInput;
  where: TaxonomyItemPoolWhereUniqueInput;
};

export type TaxonomyItemPoolWhereInput = {
  AND?: InputMaybe<Array<TaxonomyItemPoolWhereInput>>;
  NOT?: InputMaybe<Array<TaxonomyItemPoolWhereInput>>;
  OR?: InputMaybe<Array<TaxonomyItemPoolWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  taxonomyItems?: InputMaybe<TaxonomyItemListRelationFilter>;
};

export type TaxonomyItemPoolWhereUniqueInput = {
  AND?: InputMaybe<Array<TaxonomyItemPoolWhereInput>>;
  NOT?: InputMaybe<Array<TaxonomyItemPoolWhereInput>>;
  OR?: InputMaybe<Array<TaxonomyItemPoolWhereInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<StringFilter>;
  networks?: InputMaybe<NetworkListRelationFilter>;
  taxonomyItems?: InputMaybe<TaxonomyItemListRelationFilter>;
};

export type TaxonomyItemScalarWhereInput = {
  AND?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  OR?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TaxonomyItemUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateManyWithWhereWithoutNetworkInput = {
  data: TaxonomyItemUpdateManyMutationInput;
  where: TaxonomyItemScalarWhereInput;
};

export type TaxonomyItemUpdateManyWithWhereWithoutParentInput = {
  data: TaxonomyItemUpdateManyMutationInput;
  where: TaxonomyItemScalarWhereInput;
};

export type TaxonomyItemUpdateManyWithWhereWithoutPoolsInput = {
  data: TaxonomyItemUpdateManyMutationInput;
  where: TaxonomyItemScalarWhereInput;
};

export type TaxonomyItemUpdateManyWithWhereWithoutPostsInput = {
  data: TaxonomyItemUpdateManyMutationInput;
  where: TaxonomyItemScalarWhereInput;
};

export type TaxonomyItemUpdateManyWithWhereWithoutProductsInput = {
  data: TaxonomyItemUpdateManyMutationInput;
  where: TaxonomyItemScalarWhereInput;
};

export type TaxonomyItemUpdateManyWithWhereWithoutProvidersInput = {
  data: TaxonomyItemUpdateManyMutationInput;
  where: TaxonomyItemScalarWhereInput;
};

export type TaxonomyItemUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<TaxonomyItemCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<TaxonomyItemUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<TaxonomyItemUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<TaxonomyItemUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type TaxonomyItemUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutParentInput>>;
  createMany?: InputMaybe<TaxonomyItemCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<TaxonomyItemUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<TaxonomyItemUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<TaxonomyItemUpsertWithWhereUniqueWithoutParentInput>>;
};

export type TaxonomyItemUpdateManyWithoutPoolsNestedInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutPoolsInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutPoolsInput>>;
  delete?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<TaxonomyItemUpdateWithWhereUniqueWithoutPoolsInput>>;
  updateMany?: InputMaybe<Array<TaxonomyItemUpdateManyWithWhereWithoutPoolsInput>>;
  upsert?: InputMaybe<Array<TaxonomyItemUpsertWithWhereUniqueWithoutPoolsInput>>;
};

export type TaxonomyItemUpdateManyWithoutPostsNestedInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutPostsInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutPostsInput>>;
  delete?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<TaxonomyItemUpdateWithWhereUniqueWithoutPostsInput>>;
  updateMany?: InputMaybe<Array<TaxonomyItemUpdateManyWithWhereWithoutPostsInput>>;
  upsert?: InputMaybe<Array<TaxonomyItemUpsertWithWhereUniqueWithoutPostsInput>>;
};

export type TaxonomyItemUpdateManyWithoutProductsNestedInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutProductsInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutProductsInput>>;
  delete?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<TaxonomyItemUpdateWithWhereUniqueWithoutProductsInput>>;
  updateMany?: InputMaybe<Array<TaxonomyItemUpdateManyWithWhereWithoutProductsInput>>;
  upsert?: InputMaybe<Array<TaxonomyItemUpsertWithWhereUniqueWithoutProductsInput>>;
};

export type TaxonomyItemUpdateManyWithoutProvidersNestedInput = {
  connect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TaxonomyItemCreateOrConnectWithoutProvidersInput>>;
  create?: InputMaybe<Array<TaxonomyItemCreateWithoutProvidersInput>>;
  delete?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TaxonomyItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  set?: InputMaybe<Array<TaxonomyItemWhereUniqueInput>>;
  update?: InputMaybe<Array<TaxonomyItemUpdateWithWhereUniqueWithoutProvidersInput>>;
  updateMany?: InputMaybe<Array<TaxonomyItemUpdateManyWithWhereWithoutProvidersInput>>;
  upsert?: InputMaybe<Array<TaxonomyItemUpsertWithWhereUniqueWithoutProvidersInput>>;
};

export type TaxonomyItemUpdateOneRequiredWithoutProviderTaxonomyConnectionsNestedInput = {
  connect?: InputMaybe<TaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TaxonomyItemCreateOrConnectWithoutProviderTaxonomyConnectionsInput>;
  create?: InputMaybe<TaxonomyItemCreateWithoutProviderTaxonomyConnectionsInput>;
  update?: InputMaybe<TaxonomyItemUpdateToOneWithWhereWithoutProviderTaxonomyConnectionsInput>;
  upsert?: InputMaybe<TaxonomyItemUpsertWithoutProviderTaxonomyConnectionsInput>;
};

export type TaxonomyItemUpdateOneWithoutChildrenNestedInput = {
  connect?: InputMaybe<TaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TaxonomyItemCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<TaxonomyItemCreateWithoutChildrenInput>;
  delete?: InputMaybe<TaxonomyItemWhereInput>;
  disconnect?: InputMaybe<TaxonomyItemWhereInput>;
  update?: InputMaybe<TaxonomyItemUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: InputMaybe<TaxonomyItemUpsertWithoutChildrenInput>;
};

export type TaxonomyItemUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<TaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TaxonomyItemCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<TaxonomyItemCreateWithoutContentInput>;
  delete?: InputMaybe<TaxonomyItemWhereInput>;
  disconnect?: InputMaybe<TaxonomyItemWhereInput>;
  update?: InputMaybe<TaxonomyItemUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<TaxonomyItemUpsertWithoutContentInput>;
};

export type TaxonomyItemUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<TaxonomyItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TaxonomyItemCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<TaxonomyItemCreateWithoutPropertiesInput>;
  delete?: InputMaybe<TaxonomyItemWhereInput>;
  disconnect?: InputMaybe<TaxonomyItemWhereInput>;
  update?: InputMaybe<TaxonomyItemUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<TaxonomyItemUpsertWithoutPropertiesInput>;
};

export type TaxonomyItemUpdateToOneWithWhereWithoutChildrenInput = {
  data: TaxonomyItemUpdateWithoutChildrenInput;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemUpdateToOneWithWhereWithoutContentInput = {
  data: TaxonomyItemUpdateWithoutContentInput;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemUpdateToOneWithWhereWithoutPropertiesInput = {
  data: TaxonomyItemUpdateWithoutPropertiesInput;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemUpdateToOneWithWhereWithoutProviderTaxonomyConnectionsInput = {
  data: TaxonomyItemUpdateWithoutProviderTaxonomyConnectionsInput;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemUpdateWithWhereUniqueWithoutNetworkInput = {
  data: TaxonomyItemUpdateWithoutNetworkInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpdateWithWhereUniqueWithoutParentInput = {
  data: TaxonomyItemUpdateWithoutParentInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpdateWithWhereUniqueWithoutPoolsInput = {
  data: TaxonomyItemUpdateWithoutPoolsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpdateWithWhereUniqueWithoutPostsInput = {
  data: TaxonomyItemUpdateWithoutPostsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpdateWithWhereUniqueWithoutProductsInput = {
  data: TaxonomyItemUpdateWithoutProductsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpdateWithWhereUniqueWithoutProvidersInput = {
  data: TaxonomyItemUpdateWithoutProvidersInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpdateWithoutChildrenInput = {
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutContentInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutNetworkInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutParentInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutPoolsInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutPostsInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutProductsInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutPropertiesInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutProviderTaxonomyConnectionsInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providers?: InputMaybe<ProviderUpdateManyWithoutTaxonomiesNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpdateWithoutProvidersInput = {
  children?: InputMaybe<TaxonomyItemUpdateManyWithoutParentNestedInput>;
  content?: InputMaybe<ContentItemUpdateManyWithoutTaxonomyItemNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTaxonomyItemNestedInput>;
  parent?: InputMaybe<TaxonomyItemUpdateOneWithoutChildrenNestedInput>;
  pools?: InputMaybe<TaxonomyItemPoolUpdateManyWithoutTaxonomyItemsNestedInput>;
  posts?: InputMaybe<PostUpdateManyWithoutTaxonomiesNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutTaxonomiesNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTaxonomyItemNestedInput>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionUpdateManyWithoutTaxonomyItemNestedInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TaxonomyItemUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TaxonomyItemUpsertWithWhereUniqueWithoutNetworkInput = {
  create: TaxonomyItemCreateWithoutNetworkInput;
  update: TaxonomyItemUpdateWithoutNetworkInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpsertWithWhereUniqueWithoutParentInput = {
  create: TaxonomyItemCreateWithoutParentInput;
  update: TaxonomyItemUpdateWithoutParentInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpsertWithWhereUniqueWithoutPoolsInput = {
  create: TaxonomyItemCreateWithoutPoolsInput;
  update: TaxonomyItemUpdateWithoutPoolsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpsertWithWhereUniqueWithoutPostsInput = {
  create: TaxonomyItemCreateWithoutPostsInput;
  update: TaxonomyItemUpdateWithoutPostsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpsertWithWhereUniqueWithoutProductsInput = {
  create: TaxonomyItemCreateWithoutProductsInput;
  update: TaxonomyItemUpdateWithoutProductsInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpsertWithWhereUniqueWithoutProvidersInput = {
  create: TaxonomyItemCreateWithoutProvidersInput;
  update: TaxonomyItemUpdateWithoutProvidersInput;
  where: TaxonomyItemWhereUniqueInput;
};

export type TaxonomyItemUpsertWithoutChildrenInput = {
  create: TaxonomyItemCreateWithoutChildrenInput;
  update: TaxonomyItemUpdateWithoutChildrenInput;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemUpsertWithoutContentInput = {
  create: TaxonomyItemCreateWithoutContentInput;
  update: TaxonomyItemUpdateWithoutContentInput;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemUpsertWithoutPropertiesInput = {
  create: TaxonomyItemCreateWithoutPropertiesInput;
  update: TaxonomyItemUpdateWithoutPropertiesInput;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemUpsertWithoutProviderTaxonomyConnectionsInput = {
  create: TaxonomyItemCreateWithoutProviderTaxonomyConnectionsInput;
  update: TaxonomyItemUpdateWithoutProviderTaxonomyConnectionsInput;
  where?: InputMaybe<TaxonomyItemWhereInput>;
};

export type TaxonomyItemWhereInput = {
  AND?: InputMaybe<Array<TaxonomyItemWhereInput>>;
  NOT?: InputMaybe<Array<TaxonomyItemWhereInput>>;
  OR?: InputMaybe<Array<TaxonomyItemWhereInput>>;
  children?: InputMaybe<TaxonomyItemListRelationFilter>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  parent?: InputMaybe<TaxonomyItemWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  pools?: InputMaybe<TaxonomyItemPoolListRelationFilter>;
  posts?: InputMaybe<PostListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionListRelationFilter>;
  providers?: InputMaybe<ProviderListRelationFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TaxonomyItemWhereUniqueInput = {
  AND?: InputMaybe<Array<TaxonomyItemWhereInput>>;
  NOT?: InputMaybe<Array<TaxonomyItemWhereInput>>;
  OR?: InputMaybe<Array<TaxonomyItemWhereInput>>;
  children?: InputMaybe<TaxonomyItemListRelationFilter>;
  content?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  parent?: InputMaybe<TaxonomyItemWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  pools?: InputMaybe<TaxonomyItemPoolListRelationFilter>;
  posts?: InputMaybe<PostListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  providerTaxonomyConnections?: InputMaybe<ProviderTaxonomyConnectionListRelationFilter>;
  providers?: InputMaybe<ProviderListRelationFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Template = {
  __typename?: 'Template';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  fields: Array<TemplateField>;
  groups: Array<TemplateFieldGroup>;
  id: Scalars['String']['output'];
  network?: Maybe<Network>;
  priority: Scalars['Int']['output'];
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  selector: Scalars['Json']['output'];
  subtype?: Maybe<Scalars['String']['output']>;
  type: TemplateType;
  updatedAt: Scalars['DateTime']['output'];
};


export type TemplateContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type TemplateFieldsArgs = {
  cursor?: InputMaybe<TemplateFieldWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateFieldWhereInput>;
};


export type TemplateGroupsArgs = {
  cursor?: InputMaybe<TemplateFieldGroupWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TemplateFieldGroupWhereInput>;
};


export type TemplateNetworkArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type TemplatePropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};

export type TemplateCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<TemplateCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<TemplateCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<TemplateCreateManyNetworkInputEnvelope>;
};

export type TemplateCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<TemplateCreateWithoutContentInput>;
};

export type TemplateCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<TemplateCreateWithoutContentOldInput>;
};

export type TemplateCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<TemplateCreateWithoutFieldsInput>;
};

export type TemplateCreateNestedOneWithoutGroupsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutGroupsInput>;
  create?: InputMaybe<TemplateCreateWithoutGroupsInput>;
};

export type TemplateCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<TemplateCreateWithoutPropertiesInput>;
};

export type TemplateCreateOrConnectWithoutContentInput = {
  create: TemplateCreateWithoutContentInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutContentOldInput = {
  create: TemplateCreateWithoutContentOldInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutFieldsInput = {
  create: TemplateCreateWithoutFieldsInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutGroupsInput = {
  create: TemplateCreateWithoutGroupsInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutNetworkInput = {
  create: TemplateCreateWithoutNetworkInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateOrConnectWithoutPropertiesInput = {
  create: TemplateCreateWithoutPropertiesInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutTemplateInput>;
  groups?: InputMaybe<TemplateFieldGroupCreateNestedManyWithoutTemplateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTemplatesInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTemplateInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateCreateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutTemplateInput>;
  groups?: InputMaybe<TemplateFieldGroupCreateNestedManyWithoutTemplateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTemplatesInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTemplateInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateCreateWithoutFieldsInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  groups?: InputMaybe<TemplateFieldGroupCreateNestedManyWithoutTemplateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTemplatesInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTemplateInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateCreateWithoutGroupsInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutTemplateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTemplatesInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTemplateInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateCreateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutTemplateInput>;
  groups?: InputMaybe<TemplateFieldGroupCreateNestedManyWithoutTemplateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutTemplateInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateCreateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutTemplateInput>;
  groups?: InputMaybe<TemplateFieldGroupCreateNestedManyWithoutTemplateInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutTemplatesInput>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TemplateField = {
  __typename?: 'TemplateField';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  context: ContextType;
  data?: Maybe<Scalars['JSON']['output']>;
  defaultTranslationType: ContentItemTranslationType;
  disabled: Scalars['Boolean']['output'];
  displayType?: Maybe<DisplayType>;
  generatePages: Scalars['Boolean']['output'];
  geo: GeoMode;
  group?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  isDefaultField: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  list: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  pathDepth: Scalars['Int']['output'];
  permissions?: Maybe<Scalars['Json']['output']>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  relatedContent: Array<ContentItemV2>;
  required: Scalars['Boolean']['output'];
  resourceType: ResourceType;
  roles?: Maybe<Scalars['Json']['output']>;
  template: Template;
  templateId: Scalars['String']['output'];
  type: FieldType;
};


export type TemplateFieldContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type TemplateFieldPropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};


export type TemplateFieldRelatedContentArgs = {
  cursor?: InputMaybe<ContentItemV2WhereUniqueInput>;
  orderBy?: InputMaybe<Array<ContentItemV2OrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};

export type TemplateFieldCreateManyParentInput = {
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  templateId: Scalars['String']['input'];
  type: FieldType;
};

export type TemplateFieldCreateManyParentInputEnvelope = {
  data?: InputMaybe<Array<TemplateFieldCreateManyParentInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateFieldCreateManyTemplateInput = {
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  type: FieldType;
};

export type TemplateFieldCreateManyTemplateInputEnvelope = {
  data?: InputMaybe<Array<TemplateFieldCreateManyTemplateInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateFieldCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateFieldCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<TemplateFieldCreateWithoutParentInput>>;
  createMany?: InputMaybe<TemplateFieldCreateManyParentInputEnvelope>;
};

export type TemplateFieldCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateFieldCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<TemplateFieldCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<TemplateFieldCreateManyTemplateInputEnvelope>;
};

export type TemplateFieldCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutContentInput>;
};

export type TemplateFieldCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutContentOldInput>;
};

export type TemplateFieldCreateNestedOneWithoutFieldsInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutFieldsInput>;
};

export type TemplateFieldCreateNestedOneWithoutPropertyItemsInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutPropertyItemsInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutPropertyItemsInput>;
};

export type TemplateFieldCreateNestedOneWithoutRelatedContentInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutRelatedContentInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutRelatedContentInput>;
};

export type TemplateFieldCreateNestedOneWithoutRelatedContentOldInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutRelatedContentOldInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutRelatedContentOldInput>;
};

export type TemplateFieldCreateOrConnectWithoutContentInput = {
  create: TemplateFieldCreateWithoutContentInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldCreateOrConnectWithoutContentOldInput = {
  create: TemplateFieldCreateWithoutContentOldInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldCreateOrConnectWithoutFieldsInput = {
  create: TemplateFieldCreateWithoutFieldsInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldCreateOrConnectWithoutParentInput = {
  create: TemplateFieldCreateWithoutParentInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldCreateOrConnectWithoutPropertyItemsInput = {
  create: TemplateFieldCreateWithoutPropertyItemsInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldCreateOrConnectWithoutRelatedContentInput = {
  create: TemplateFieldCreateWithoutRelatedContentInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldCreateOrConnectWithoutRelatedContentOldInput = {
  create: TemplateFieldCreateWithoutRelatedContentOldInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldCreateOrConnectWithoutTemplateInput = {
  create: TemplateFieldCreateWithoutTemplateInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldCreateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateFieldInput>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutParentInput>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<TemplateFieldCreateNestedOneWithoutFieldsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemCreateNestedManyWithoutFieldInput>;
  relatedContent?: InputMaybe<ContentItemV2CreateNestedManyWithoutFieldInput>;
  relatedContentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFieldInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template: TemplateCreateNestedOneWithoutFieldsInput;
  type: FieldType;
};

export type TemplateFieldCreateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateFieldInput>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutParentInput>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<TemplateFieldCreateNestedOneWithoutFieldsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemCreateNestedManyWithoutFieldInput>;
  relatedContent?: InputMaybe<ContentItemV2CreateNestedManyWithoutFieldInput>;
  relatedContentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFieldInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template: TemplateCreateNestedOneWithoutFieldsInput;
  type: FieldType;
};

export type TemplateFieldCreateWithoutFieldsInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateFieldInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateFieldInput>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<TemplateFieldCreateNestedOneWithoutFieldsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemCreateNestedManyWithoutFieldInput>;
  relatedContent?: InputMaybe<ContentItemV2CreateNestedManyWithoutFieldInput>;
  relatedContentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFieldInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template: TemplateCreateNestedOneWithoutFieldsInput;
  type: FieldType;
};

export type TemplateFieldCreateWithoutParentInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateFieldInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateFieldInput>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutParentInput>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemCreateNestedManyWithoutFieldInput>;
  relatedContent?: InputMaybe<ContentItemV2CreateNestedManyWithoutFieldInput>;
  relatedContentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFieldInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template: TemplateCreateNestedOneWithoutFieldsInput;
  type: FieldType;
};

export type TemplateFieldCreateWithoutPropertyItemsInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateFieldInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateFieldInput>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutParentInput>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<TemplateFieldCreateNestedOneWithoutFieldsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  relatedContent?: InputMaybe<ContentItemV2CreateNestedManyWithoutFieldInput>;
  relatedContentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFieldInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template: TemplateCreateNestedOneWithoutFieldsInput;
  type: FieldType;
};

export type TemplateFieldCreateWithoutRelatedContentInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateFieldInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateFieldInput>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutParentInput>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<TemplateFieldCreateNestedOneWithoutFieldsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemCreateNestedManyWithoutFieldInput>;
  relatedContentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFieldInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template: TemplateCreateNestedOneWithoutFieldsInput;
  type: FieldType;
};

export type TemplateFieldCreateWithoutRelatedContentOldInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateFieldInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateFieldInput>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutParentInput>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<TemplateFieldCreateNestedOneWithoutFieldsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemCreateNestedManyWithoutFieldInput>;
  relatedContent?: InputMaybe<ContentItemV2CreateNestedManyWithoutFieldInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template: TemplateCreateNestedOneWithoutFieldsInput;
  type: FieldType;
};

export type TemplateFieldCreateWithoutTemplateInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutTemplateFieldInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutTemplateFieldInput>;
  context?: InputMaybe<ContextType>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<ContentItemTranslationType>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayType?: InputMaybe<DisplayType>;
  fields?: InputMaybe<TemplateFieldCreateNestedManyWithoutParentInput>;
  generatePages?: InputMaybe<Scalars['Boolean']['input']>;
  geo?: InputMaybe<GeoMode>;
  group?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isDefaultField?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  list?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<TemplateFieldCreateNestedOneWithoutFieldsInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathDepth?: InputMaybe<Scalars['Int']['input']>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemCreateNestedManyWithoutFieldInput>;
  relatedContent?: InputMaybe<ContentItemV2CreateNestedManyWithoutFieldInput>;
  relatedContentOld?: InputMaybe<ContentItemCreateNestedManyWithoutFieldInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  resourceType?: InputMaybe<ResourceType>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  type: FieldType;
};

export type TemplateFieldGroup = {
  __typename?: 'TemplateFieldGroup';
  data?: Maybe<Scalars['Json']['output']>;
  extended: Scalars['Boolean']['output'];
  generalGroup?: Maybe<GeneralTemplateFieldGroup>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  template?: Maybe<Template>;
};


export type TemplateFieldGroupGeneralGroupArgs = {
  where?: InputMaybe<GeneralTemplateFieldGroupWhereInput>;
};


export type TemplateFieldGroupTemplateArgs = {
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateFieldGroupCreateInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  generalGroup?: InputMaybe<GeneralTemplateFieldGroupCreateNestedOneWithoutGroupsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  template?: InputMaybe<TemplateCreateNestedOneWithoutGroupsInput>;
};

export type TemplateFieldGroupCreateManyGeneralGroupInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type TemplateFieldGroupCreateManyGeneralGroupInputEnvelope = {
  data?: InputMaybe<Array<TemplateFieldGroupCreateManyGeneralGroupInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateFieldGroupCreateManyTemplateInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  generalGloupId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type TemplateFieldGroupCreateManyTemplateInputEnvelope = {
  data?: InputMaybe<Array<TemplateFieldGroupCreateManyTemplateInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TemplateFieldGroupCreateNestedManyWithoutGeneralGroupInput = {
  connect?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateFieldGroupCreateOrConnectWithoutGeneralGroupInput>>;
  create?: InputMaybe<Array<TemplateFieldGroupCreateWithoutGeneralGroupInput>>;
  createMany?: InputMaybe<TemplateFieldGroupCreateManyGeneralGroupInputEnvelope>;
};

export type TemplateFieldGroupCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateFieldGroupCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<TemplateFieldGroupCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<TemplateFieldGroupCreateManyTemplateInputEnvelope>;
};

export type TemplateFieldGroupCreateOrConnectWithoutGeneralGroupInput = {
  create: TemplateFieldGroupCreateWithoutGeneralGroupInput;
  where: TemplateFieldGroupWhereUniqueInput;
};

export type TemplateFieldGroupCreateOrConnectWithoutTemplateInput = {
  create: TemplateFieldGroupCreateWithoutTemplateInput;
  where: TemplateFieldGroupWhereUniqueInput;
};

export type TemplateFieldGroupCreateWithoutGeneralGroupInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  template?: InputMaybe<TemplateCreateNestedOneWithoutGroupsInput>;
};

export type TemplateFieldGroupCreateWithoutTemplateInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<Scalars['Boolean']['input']>;
  generalGroup?: InputMaybe<GeneralTemplateFieldGroupCreateNestedOneWithoutGroupsInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type TemplateFieldGroupListRelationFilter = {
  every?: InputMaybe<TemplateFieldGroupWhereInput>;
  none?: InputMaybe<TemplateFieldGroupWhereInput>;
  some?: InputMaybe<TemplateFieldGroupWhereInput>;
};

export type TemplateFieldGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TemplateFieldGroupScalarWhereInput = {
  AND?: InputMaybe<Array<TemplateFieldGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<TemplateFieldGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<TemplateFieldGroupScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  extended?: InputMaybe<BoolFilter>;
  generalGloupId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  index?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  templateId?: InputMaybe<StringNullableFilter>;
};

export type TemplateFieldGroupUpdateInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<BoolFieldUpdateOperationsInput>;
  generalGroup?: InputMaybe<GeneralTemplateFieldGroupUpdateOneWithoutGroupsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutGroupsNestedInput>;
};

export type TemplateFieldGroupUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TemplateFieldGroupUpdateManyWithWhereWithoutGeneralGroupInput = {
  data: TemplateFieldGroupUpdateManyMutationInput;
  where: TemplateFieldGroupScalarWhereInput;
};

export type TemplateFieldGroupUpdateManyWithWhereWithoutTemplateInput = {
  data: TemplateFieldGroupUpdateManyMutationInput;
  where: TemplateFieldGroupScalarWhereInput;
};

export type TemplateFieldGroupUpdateManyWithoutGeneralGroupNestedInput = {
  connect?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateFieldGroupCreateOrConnectWithoutGeneralGroupInput>>;
  create?: InputMaybe<Array<TemplateFieldGroupCreateWithoutGeneralGroupInput>>;
  createMany?: InputMaybe<TemplateFieldGroupCreateManyGeneralGroupInputEnvelope>;
  delete?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TemplateFieldGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<TemplateFieldGroupUpdateWithWhereUniqueWithoutGeneralGroupInput>>;
  updateMany?: InputMaybe<Array<TemplateFieldGroupUpdateManyWithWhereWithoutGeneralGroupInput>>;
  upsert?: InputMaybe<Array<TemplateFieldGroupUpsertWithWhereUniqueWithoutGeneralGroupInput>>;
};

export type TemplateFieldGroupUpdateManyWithoutTemplateNestedInput = {
  connect?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateFieldGroupCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<TemplateFieldGroupCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<TemplateFieldGroupCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TemplateFieldGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<TemplateFieldGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<TemplateFieldGroupUpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: InputMaybe<Array<TemplateFieldGroupUpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: InputMaybe<Array<TemplateFieldGroupUpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type TemplateFieldGroupUpdateWithWhereUniqueWithoutGeneralGroupInput = {
  data: TemplateFieldGroupUpdateWithoutGeneralGroupInput;
  where: TemplateFieldGroupWhereUniqueInput;
};

export type TemplateFieldGroupUpdateWithWhereUniqueWithoutTemplateInput = {
  data: TemplateFieldGroupUpdateWithoutTemplateInput;
  where: TemplateFieldGroupWhereUniqueInput;
};

export type TemplateFieldGroupUpdateWithoutGeneralGroupInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneWithoutGroupsNestedInput>;
};

export type TemplateFieldGroupUpdateWithoutTemplateInput = {
  data?: InputMaybe<Scalars['Json']['input']>;
  extended?: InputMaybe<BoolFieldUpdateOperationsInput>;
  generalGroup?: InputMaybe<GeneralTemplateFieldGroupUpdateOneWithoutGroupsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TemplateFieldGroupUpsertWithWhereUniqueWithoutGeneralGroupInput = {
  create: TemplateFieldGroupCreateWithoutGeneralGroupInput;
  update: TemplateFieldGroupUpdateWithoutGeneralGroupInput;
  where: TemplateFieldGroupWhereUniqueInput;
};

export type TemplateFieldGroupUpsertWithWhereUniqueWithoutTemplateInput = {
  create: TemplateFieldGroupCreateWithoutTemplateInput;
  update: TemplateFieldGroupUpdateWithoutTemplateInput;
  where: TemplateFieldGroupWhereUniqueInput;
};

export type TemplateFieldGroupWhereInput = {
  AND?: InputMaybe<Array<TemplateFieldGroupWhereInput>>;
  NOT?: InputMaybe<Array<TemplateFieldGroupWhereInput>>;
  OR?: InputMaybe<Array<TemplateFieldGroupWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  extended?: InputMaybe<BoolFilter>;
  generalGloupId?: InputMaybe<StringNullableFilter>;
  generalGroup?: InputMaybe<GeneralTemplateFieldGroupWhereInput>;
  id?: InputMaybe<StringFilter>;
  index?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<StringNullableFilter>;
};

export type TemplateFieldGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<TemplateFieldGroupWhereInput>>;
  NOT?: InputMaybe<Array<TemplateFieldGroupWhereInput>>;
  OR?: InputMaybe<Array<TemplateFieldGroupWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  extended?: InputMaybe<BoolFilter>;
  generalGloupId?: InputMaybe<StringNullableFilter>;
  generalGroup?: InputMaybe<GeneralTemplateFieldGroupWhereInput>;
  id: Scalars['String']['input'];
  index?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<StringNullableFilter>;
};

export type TemplateFieldListRelationFilter = {
  every?: InputMaybe<TemplateFieldWhereInput>;
  none?: InputMaybe<TemplateFieldWhereInput>;
  some?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TemplateFieldOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  context?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrderInput>;
  defaultTranslationType?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  displayType?: InputMaybe<SortOrderInput>;
  fields?: InputMaybe<TemplateFieldOrderByRelationAggregateInput>;
  generatePages?: InputMaybe<SortOrder>;
  geo?: InputMaybe<SortOrder>;
  group?: InputMaybe<SortOrderInput>;
  hidden?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  index?: InputMaybe<SortOrderInput>;
  isDefaultField?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  list?: InputMaybe<SortOrder>;
  parent?: InputMaybe<TemplateFieldOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrderInput>;
  path?: InputMaybe<SortOrder>;
  pathDepth?: InputMaybe<SortOrder>;
  permissions?: InputMaybe<SortOrderInput>;
  propertyItems?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  relatedContent?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  relatedContentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  required?: InputMaybe<SortOrder>;
  resourceType?: InputMaybe<SortOrder>;
  roles?: InputMaybe<SortOrderInput>;
  template?: InputMaybe<TemplateOrderByWithRelationInput>;
  templateId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type TemplateFieldScalarWhereInput = {
  AND?: InputMaybe<Array<TemplateFieldScalarWhereInput>>;
  NOT?: InputMaybe<Array<TemplateFieldScalarWhereInput>>;
  OR?: InputMaybe<Array<TemplateFieldScalarWhereInput>>;
  context?: InputMaybe<EnumContextTypeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  disabled?: InputMaybe<BoolFilter>;
  displayType?: InputMaybe<EnumDisplayTypeNullableFilter>;
  generatePages?: InputMaybe<BoolFilter>;
  geo?: InputMaybe<EnumGeoModeFilter>;
  group?: InputMaybe<StringNullableFilter>;
  hidden?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  index?: InputMaybe<IntNullableFilter>;
  isDefaultField?: InputMaybe<BoolFilter>;
  key?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  path?: InputMaybe<StringFilter>;
  pathDepth?: InputMaybe<IntFilter>;
  permissions?: InputMaybe<JsonNullableFilter>;
  required?: InputMaybe<BoolFilter>;
  resourceType?: InputMaybe<EnumResourceTypeFilter>;
  roles?: InputMaybe<JsonNullableFilter>;
  templateId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumFieldTypeFilter>;
};

export type TemplateFieldUpdateManyMutationInput = {
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpdateManyWithWhereWithoutParentInput = {
  data: TemplateFieldUpdateManyMutationInput;
  where: TemplateFieldScalarWhereInput;
};

export type TemplateFieldUpdateManyWithWhereWithoutTemplateInput = {
  data: TemplateFieldUpdateManyMutationInput;
  where: TemplateFieldScalarWhereInput;
};

export type TemplateFieldUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateFieldCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<TemplateFieldCreateWithoutParentInput>>;
  createMany?: InputMaybe<TemplateFieldCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TemplateFieldScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  set?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  update?: InputMaybe<Array<TemplateFieldUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<TemplateFieldUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<TemplateFieldUpsertWithWhereUniqueWithoutParentInput>>;
};

export type TemplateFieldUpdateManyWithoutTemplateNestedInput = {
  connect?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateFieldCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<TemplateFieldCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<TemplateFieldCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TemplateFieldScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  set?: InputMaybe<Array<TemplateFieldWhereUniqueInput>>;
  update?: InputMaybe<Array<TemplateFieldUpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: InputMaybe<Array<TemplateFieldUpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: InputMaybe<Array<TemplateFieldUpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type TemplateFieldUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutContentInput>;
  delete?: InputMaybe<TemplateFieldWhereInput>;
  disconnect?: InputMaybe<TemplateFieldWhereInput>;
  update?: InputMaybe<TemplateFieldUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<TemplateFieldUpsertWithoutContentInput>;
};

export type TemplateFieldUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutContentOldInput>;
  delete?: InputMaybe<TemplateFieldWhereInput>;
  disconnect?: InputMaybe<TemplateFieldWhereInput>;
  update?: InputMaybe<TemplateFieldUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<TemplateFieldUpsertWithoutContentOldInput>;
};

export type TemplateFieldUpdateOneWithoutFieldsNestedInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutFieldsInput>;
  delete?: InputMaybe<TemplateFieldWhereInput>;
  disconnect?: InputMaybe<TemplateFieldWhereInput>;
  update?: InputMaybe<TemplateFieldUpdateToOneWithWhereWithoutFieldsInput>;
  upsert?: InputMaybe<TemplateFieldUpsertWithoutFieldsInput>;
};

export type TemplateFieldUpdateOneWithoutPropertyItemsNestedInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutPropertyItemsInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutPropertyItemsInput>;
  delete?: InputMaybe<TemplateFieldWhereInput>;
  disconnect?: InputMaybe<TemplateFieldWhereInput>;
  update?: InputMaybe<TemplateFieldUpdateToOneWithWhereWithoutPropertyItemsInput>;
  upsert?: InputMaybe<TemplateFieldUpsertWithoutPropertyItemsInput>;
};

export type TemplateFieldUpdateOneWithoutRelatedContentNestedInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutRelatedContentInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutRelatedContentInput>;
  delete?: InputMaybe<TemplateFieldWhereInput>;
  disconnect?: InputMaybe<TemplateFieldWhereInput>;
  update?: InputMaybe<TemplateFieldUpdateToOneWithWhereWithoutRelatedContentInput>;
  upsert?: InputMaybe<TemplateFieldUpsertWithoutRelatedContentInput>;
};

export type TemplateFieldUpdateOneWithoutRelatedContentOldNestedInput = {
  connect?: InputMaybe<TemplateFieldWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateFieldCreateOrConnectWithoutRelatedContentOldInput>;
  create?: InputMaybe<TemplateFieldCreateWithoutRelatedContentOldInput>;
  delete?: InputMaybe<TemplateFieldWhereInput>;
  disconnect?: InputMaybe<TemplateFieldWhereInput>;
  update?: InputMaybe<TemplateFieldUpdateToOneWithWhereWithoutRelatedContentOldInput>;
  upsert?: InputMaybe<TemplateFieldUpsertWithoutRelatedContentOldInput>;
};

export type TemplateFieldUpdateToOneWithWhereWithoutContentInput = {
  data: TemplateFieldUpdateWithoutContentInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpdateToOneWithWhereWithoutContentOldInput = {
  data: TemplateFieldUpdateWithoutContentOldInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpdateToOneWithWhereWithoutFieldsInput = {
  data: TemplateFieldUpdateWithoutFieldsInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpdateToOneWithWhereWithoutPropertyItemsInput = {
  data: TemplateFieldUpdateWithoutPropertyItemsInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpdateToOneWithWhereWithoutRelatedContentInput = {
  data: TemplateFieldUpdateWithoutRelatedContentInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpdateToOneWithWhereWithoutRelatedContentOldInput = {
  data: TemplateFieldUpdateWithoutRelatedContentOldInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpdateWithWhereUniqueWithoutParentInput = {
  data: TemplateFieldUpdateWithoutParentInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldUpdateWithWhereUniqueWithoutTemplateInput = {
  data: TemplateFieldUpdateWithoutTemplateInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldUpdateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateFieldNestedInput>;
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutParentNestedInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parent?: InputMaybe<TemplateFieldUpdateOneWithoutFieldsNestedInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemUpdateManyWithoutFieldNestedInput>;
  relatedContent?: InputMaybe<ContentItemV2UpdateManyWithoutFieldNestedInput>;
  relatedContentOld?: InputMaybe<ContentItemUpdateManyWithoutFieldNestedInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template?: InputMaybe<TemplateUpdateOneRequiredWithoutFieldsNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpdateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateFieldNestedInput>;
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutParentNestedInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parent?: InputMaybe<TemplateFieldUpdateOneWithoutFieldsNestedInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemUpdateManyWithoutFieldNestedInput>;
  relatedContent?: InputMaybe<ContentItemV2UpdateManyWithoutFieldNestedInput>;
  relatedContentOld?: InputMaybe<ContentItemUpdateManyWithoutFieldNestedInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template?: InputMaybe<TemplateUpdateOneRequiredWithoutFieldsNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpdateWithoutFieldsInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateFieldNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateFieldNestedInput>;
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parent?: InputMaybe<TemplateFieldUpdateOneWithoutFieldsNestedInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemUpdateManyWithoutFieldNestedInput>;
  relatedContent?: InputMaybe<ContentItemV2UpdateManyWithoutFieldNestedInput>;
  relatedContentOld?: InputMaybe<ContentItemUpdateManyWithoutFieldNestedInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template?: InputMaybe<TemplateUpdateOneRequiredWithoutFieldsNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpdateWithoutParentInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateFieldNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateFieldNestedInput>;
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutParentNestedInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemUpdateManyWithoutFieldNestedInput>;
  relatedContent?: InputMaybe<ContentItemV2UpdateManyWithoutFieldNestedInput>;
  relatedContentOld?: InputMaybe<ContentItemUpdateManyWithoutFieldNestedInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template?: InputMaybe<TemplateUpdateOneRequiredWithoutFieldsNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpdateWithoutPropertyItemsInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateFieldNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateFieldNestedInput>;
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutParentNestedInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parent?: InputMaybe<TemplateFieldUpdateOneWithoutFieldsNestedInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  relatedContent?: InputMaybe<ContentItemV2UpdateManyWithoutFieldNestedInput>;
  relatedContentOld?: InputMaybe<ContentItemUpdateManyWithoutFieldNestedInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template?: InputMaybe<TemplateUpdateOneRequiredWithoutFieldsNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpdateWithoutRelatedContentInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateFieldNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateFieldNestedInput>;
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutParentNestedInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parent?: InputMaybe<TemplateFieldUpdateOneWithoutFieldsNestedInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemUpdateManyWithoutFieldNestedInput>;
  relatedContentOld?: InputMaybe<ContentItemUpdateManyWithoutFieldNestedInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template?: InputMaybe<TemplateUpdateOneRequiredWithoutFieldsNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpdateWithoutRelatedContentOldInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateFieldNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateFieldNestedInput>;
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutParentNestedInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parent?: InputMaybe<TemplateFieldUpdateOneWithoutFieldsNestedInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemUpdateManyWithoutFieldNestedInput>;
  relatedContent?: InputMaybe<ContentItemV2UpdateManyWithoutFieldNestedInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  template?: InputMaybe<TemplateUpdateOneRequiredWithoutFieldsNestedInput>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpdateWithoutTemplateInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateFieldNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateFieldNestedInput>;
  context?: InputMaybe<EnumContextTypeFieldUpdateOperationsInput>;
  data?: InputMaybe<Scalars['Json']['input']>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  displayType?: InputMaybe<NullableEnumDisplayTypeFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutParentNestedInput>;
  generatePages?: InputMaybe<BoolFieldUpdateOperationsInput>;
  geo?: InputMaybe<EnumGeoModeFieldUpdateOperationsInput>;
  group?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hidden?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  index?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  isDefaultField?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  list?: InputMaybe<BoolFieldUpdateOperationsInput>;
  parent?: InputMaybe<TemplateFieldUpdateOneWithoutFieldsNestedInput>;
  path?: InputMaybe<StringFieldUpdateOperationsInput>;
  pathDepth?: InputMaybe<IntFieldUpdateOperationsInput>;
  permissions?: InputMaybe<Scalars['Json']['input']>;
  propertyItems?: InputMaybe<PropertyItemUpdateManyWithoutFieldNestedInput>;
  relatedContent?: InputMaybe<ContentItemV2UpdateManyWithoutFieldNestedInput>;
  relatedContentOld?: InputMaybe<ContentItemUpdateManyWithoutFieldNestedInput>;
  required?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceType?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  roles?: InputMaybe<Scalars['Json']['input']>;
  type?: InputMaybe<EnumFieldTypeFieldUpdateOperationsInput>;
};

export type TemplateFieldUpsertWithWhereUniqueWithoutParentInput = {
  create: TemplateFieldCreateWithoutParentInput;
  update: TemplateFieldUpdateWithoutParentInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldUpsertWithWhereUniqueWithoutTemplateInput = {
  create: TemplateFieldCreateWithoutTemplateInput;
  update: TemplateFieldUpdateWithoutTemplateInput;
  where: TemplateFieldWhereUniqueInput;
};

export type TemplateFieldUpsertWithoutContentInput = {
  create: TemplateFieldCreateWithoutContentInput;
  update: TemplateFieldUpdateWithoutContentInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpsertWithoutContentOldInput = {
  create: TemplateFieldCreateWithoutContentOldInput;
  update: TemplateFieldUpdateWithoutContentOldInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpsertWithoutFieldsInput = {
  create: TemplateFieldCreateWithoutFieldsInput;
  update: TemplateFieldUpdateWithoutFieldsInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpsertWithoutPropertyItemsInput = {
  create: TemplateFieldCreateWithoutPropertyItemsInput;
  update: TemplateFieldUpdateWithoutPropertyItemsInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpsertWithoutRelatedContentInput = {
  create: TemplateFieldCreateWithoutRelatedContentInput;
  update: TemplateFieldUpdateWithoutRelatedContentInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldUpsertWithoutRelatedContentOldInput = {
  create: TemplateFieldCreateWithoutRelatedContentOldInput;
  update: TemplateFieldUpdateWithoutRelatedContentOldInput;
  where?: InputMaybe<TemplateFieldWhereInput>;
};

export type TemplateFieldWhereInput = {
  AND?: InputMaybe<Array<TemplateFieldWhereInput>>;
  NOT?: InputMaybe<Array<TemplateFieldWhereInput>>;
  OR?: InputMaybe<Array<TemplateFieldWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  context?: InputMaybe<EnumContextTypeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  disabled?: InputMaybe<BoolFilter>;
  displayType?: InputMaybe<EnumDisplayTypeNullableFilter>;
  fields?: InputMaybe<TemplateFieldListRelationFilter>;
  generatePages?: InputMaybe<BoolFilter>;
  geo?: InputMaybe<EnumGeoModeFilter>;
  group?: InputMaybe<StringNullableFilter>;
  hidden?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  index?: InputMaybe<IntNullableFilter>;
  isDefaultField?: InputMaybe<BoolFilter>;
  key?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  parent?: InputMaybe<TemplateFieldWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  path?: InputMaybe<StringFilter>;
  pathDepth?: InputMaybe<IntFilter>;
  permissions?: InputMaybe<JsonNullableFilter>;
  propertyItems?: InputMaybe<PropertyItemListRelationFilter>;
  relatedContent?: InputMaybe<ContentItemV2ListRelationFilter>;
  relatedContentOld?: InputMaybe<ContentItemListRelationFilter>;
  required?: InputMaybe<BoolFilter>;
  resourceType?: InputMaybe<EnumResourceTypeFilter>;
  roles?: InputMaybe<JsonNullableFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumFieldTypeFilter>;
};

export type TemplateFieldWhereUniqueInput = {
  AND?: InputMaybe<Array<TemplateFieldWhereInput>>;
  NOT?: InputMaybe<Array<TemplateFieldWhereInput>>;
  OR?: InputMaybe<Array<TemplateFieldWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  context?: InputMaybe<EnumContextTypeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  defaultTranslationType?: InputMaybe<EnumContentItemTranslationTypeFilter>;
  disabled?: InputMaybe<BoolFilter>;
  displayType?: InputMaybe<EnumDisplayTypeNullableFilter>;
  fields?: InputMaybe<TemplateFieldListRelationFilter>;
  generatePages?: InputMaybe<BoolFilter>;
  geo?: InputMaybe<EnumGeoModeFilter>;
  group?: InputMaybe<StringNullableFilter>;
  hidden?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<IntNullableFilter>;
  isDefaultField?: InputMaybe<BoolFilter>;
  key?: InputMaybe<StringFilter>;
  list?: InputMaybe<BoolFilter>;
  parent?: InputMaybe<TemplateFieldWhereInput>;
  parentId?: InputMaybe<StringNullableFilter>;
  path?: InputMaybe<StringFilter>;
  pathDepth?: InputMaybe<IntFilter>;
  permissions?: InputMaybe<JsonNullableFilter>;
  propertyItems?: InputMaybe<PropertyItemListRelationFilter>;
  relatedContent?: InputMaybe<ContentItemV2ListRelationFilter>;
  relatedContentOld?: InputMaybe<ContentItemListRelationFilter>;
  required?: InputMaybe<BoolFilter>;
  resourceType?: InputMaybe<EnumResourceTypeFilter>;
  roles?: InputMaybe<JsonNullableFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumFieldTypeFilter>;
};

export type TemplateListRelationFilter = {
  every?: InputMaybe<TemplateWhereInput>;
  none?: InputMaybe<TemplateWhereInput>;
  some?: InputMaybe<TemplateWhereInput>;
};

export type TemplateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TemplateOrderByWithRelationInput = {
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  fields?: InputMaybe<TemplateFieldOrderByRelationAggregateInput>;
  groups?: InputMaybe<TemplateFieldGroupOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  priority?: InputMaybe<SortOrder>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  selector?: InputMaybe<SortOrder>;
  subtype?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type TemplateScalarWhereInput = {
  AND?: InputMaybe<Array<TemplateScalarWhereInput>>;
  NOT?: InputMaybe<Array<TemplateScalarWhereInput>>;
  OR?: InputMaybe<Array<TemplateScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  priority?: InputMaybe<IntFilter>;
  selector?: InputMaybe<JsonFilter>;
  subtype?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTemplateTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum TemplateType {
  Author = 'AUTHOR',
  Filtertaxonomyitem = 'FILTERTAXONOMYITEM',
  Filtertaxonomyrule = 'FILTERTAXONOMYRULE',
  Menuitem = 'MENUITEM',
  Network = 'NETWORK',
  Page = 'PAGE',
  Post = 'POST',
  Product = 'PRODUCT',
  Provider = 'PROVIDER',
  Providertaxonomyconnection = 'PROVIDERTAXONOMYCONNECTION',
  Site = 'SITE',
  Stringtemplate = 'STRINGTEMPLATE',
  Taxonomy = 'TAXONOMY',
  Templatefield = 'TEMPLATEFIELD',
  Vertical = 'VERTICAL'
}

export type TemplateUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TemplateUpdateManyWithWhereWithoutNetworkInput = {
  data: TemplateUpdateManyMutationInput;
  where: TemplateScalarWhereInput;
};

export type TemplateUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<TemplateCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<TemplateCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TemplateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  set?: InputMaybe<Array<TemplateWhereUniqueInput>>;
  update?: InputMaybe<Array<TemplateUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<TemplateUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<TemplateUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type TemplateUpdateOneRequiredWithoutFieldsNestedInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutFieldsInput>;
  create?: InputMaybe<TemplateCreateWithoutFieldsInput>;
  update?: InputMaybe<TemplateUpdateToOneWithWhereWithoutFieldsInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutFieldsInput>;
};

export type TemplateUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<TemplateCreateWithoutContentInput>;
  delete?: InputMaybe<TemplateWhereInput>;
  disconnect?: InputMaybe<TemplateWhereInput>;
  update?: InputMaybe<TemplateUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutContentInput>;
};

export type TemplateUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<TemplateCreateWithoutContentOldInput>;
  delete?: InputMaybe<TemplateWhereInput>;
  disconnect?: InputMaybe<TemplateWhereInput>;
  update?: InputMaybe<TemplateUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutContentOldInput>;
};

export type TemplateUpdateOneWithoutGroupsNestedInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutGroupsInput>;
  create?: InputMaybe<TemplateCreateWithoutGroupsInput>;
  delete?: InputMaybe<TemplateWhereInput>;
  disconnect?: InputMaybe<TemplateWhereInput>;
  update?: InputMaybe<TemplateUpdateToOneWithWhereWithoutGroupsInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutGroupsInput>;
};

export type TemplateUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<TemplateCreateWithoutPropertiesInput>;
  delete?: InputMaybe<TemplateWhereInput>;
  disconnect?: InputMaybe<TemplateWhereInput>;
  update?: InputMaybe<TemplateUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutPropertiesInput>;
};

export type TemplateUpdateToOneWithWhereWithoutContentInput = {
  data: TemplateUpdateWithoutContentInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpdateToOneWithWhereWithoutContentOldInput = {
  data: TemplateUpdateWithoutContentOldInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpdateToOneWithWhereWithoutFieldsInput = {
  data: TemplateUpdateWithoutFieldsInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpdateToOneWithWhereWithoutGroupsInput = {
  data: TemplateUpdateWithoutGroupsInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpdateToOneWithWhereWithoutPropertiesInput = {
  data: TemplateUpdateWithoutPropertiesInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpdateWithWhereUniqueWithoutNetworkInput = {
  data: TemplateUpdateWithoutNetworkInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateUpdateWithoutContentInput = {
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutTemplateNestedInput>;
  groups?: InputMaybe<TemplateFieldGroupUpdateManyWithoutTemplateNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTemplatesNestedInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTemplateNestedInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutContentOldInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutTemplateNestedInput>;
  groups?: InputMaybe<TemplateFieldGroupUpdateManyWithoutTemplateNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTemplatesNestedInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTemplateNestedInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutFieldsInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  groups?: InputMaybe<TemplateFieldGroupUpdateManyWithoutTemplateNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTemplatesNestedInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTemplateNestedInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutGroupsInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutTemplateNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTemplatesNestedInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTemplateNestedInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutNetworkInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutTemplateNestedInput>;
  groups?: InputMaybe<TemplateFieldGroupUpdateManyWithoutTemplateNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutTemplateNestedInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TemplateUpdateWithoutPropertiesInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutTemplateNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutTemplateNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  fields?: InputMaybe<TemplateFieldUpdateManyWithoutTemplateNestedInput>;
  groups?: InputMaybe<TemplateFieldGroupUpdateManyWithoutTemplateNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutTemplatesNestedInput>;
  priority?: InputMaybe<IntFieldUpdateOperationsInput>;
  selector?: InputMaybe<Scalars['Json']['input']>;
  subtype?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumTemplateTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type TemplateUpsertWithWhereUniqueWithoutNetworkInput = {
  create: TemplateCreateWithoutNetworkInput;
  update: TemplateUpdateWithoutNetworkInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateUpsertWithoutContentInput = {
  create: TemplateCreateWithoutContentInput;
  update: TemplateUpdateWithoutContentInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpsertWithoutContentOldInput = {
  create: TemplateCreateWithoutContentOldInput;
  update: TemplateUpdateWithoutContentOldInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpsertWithoutFieldsInput = {
  create: TemplateCreateWithoutFieldsInput;
  update: TemplateUpdateWithoutFieldsInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpsertWithoutGroupsInput = {
  create: TemplateCreateWithoutGroupsInput;
  update: TemplateUpdateWithoutGroupsInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateUpsertWithoutPropertiesInput = {
  create: TemplateCreateWithoutPropertiesInput;
  update: TemplateUpdateWithoutPropertiesInput;
  where?: InputMaybe<TemplateWhereInput>;
};

export type TemplateWhereInput = {
  AND?: InputMaybe<Array<TemplateWhereInput>>;
  NOT?: InputMaybe<Array<TemplateWhereInput>>;
  OR?: InputMaybe<Array<TemplateWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  fields?: InputMaybe<TemplateFieldListRelationFilter>;
  groups?: InputMaybe<TemplateFieldGroupListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  priority?: InputMaybe<IntFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  selector?: InputMaybe<JsonFilter>;
  subtype?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTemplateTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<TemplateWhereInput>>;
  NOT?: InputMaybe<Array<TemplateWhereInput>>;
  OR?: InputMaybe<Array<TemplateWhereInput>>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  fields?: InputMaybe<TemplateFieldListRelationFilter>;
  groups?: InputMaybe<TemplateFieldGroupListRelationFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  priority?: InputMaybe<IntFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  selector?: InputMaybe<JsonFilter>;
  subtype?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumTemplateTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type TranslationJob = {
  __typename?: 'TranslationJob';
  attemptsMade?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  finishedOn?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  opts?: Maybe<Scalars['JSON']['output']>;
  processedOn?: Maybe<Scalars['DateTime']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  returnvalue?: Maybe<Scalars['JSON']['output']>;
  stacktrace?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type TranslationJobData = {
  contextIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  forceHumanStrings?: InputMaybe<Scalars['Boolean']['input']>;
  jobType?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  languages: Array<Scalars['String']['input']>;
  localizeFor?: InputMaybe<Array<InputMaybe<LocalizeForType>>>;
  localizeFrom?: InputMaybe<Scalars['String']['input']>;
  networkId: Scalars['String']['input'];
  options?: InputMaybe<TranslationJobOptions>;
  resourceId: Scalars['String']['input'];
  resourceType: TranslationJobResourceTypes;
};

export type TranslationJobOptions = {
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export enum TranslationJobResourceTypes {
  Author = 'author',
  FilterTaxonomyItem = 'filterTaxonomyItem',
  MenuItem = 'menuItem',
  Network = 'network',
  Post = 'post',
  Product = 'product',
  Provider = 'provider',
  Site = 'site',
  StringTemplate = 'stringTemplate',
  TaxonomyItem = 'taxonomyItem',
  Vertical = 'vertical'
}

export enum TranslationJobsTypeEnum {
  Active = 'active',
  Completed = 'completed',
  Failed = 'failed',
  Waiting = 'waiting'
}

export type UpsertSectionInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['JSON']['input'];
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  language: LanguageWhereUniqueInput;
  sectionId: Scalars['String']['input'];
  shouldBeApproved?: InputMaybe<Scalars['Boolean']['input']>;
  translation: StringItemTranslationType;
  variant: Scalars['Int']['input'];
};

export type User = {
  __typename?: 'User';
  app_metadata?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  picture?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_metadata?: Maybe<Scalars['JSON']['output']>;
};

export type Vertical = {
  __typename?: 'Vertical';
  content?: Maybe<Array<Maybe<ContentItemV2>>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  history?: Maybe<Array<Maybe<ResourceHistory>>>;
  id: Scalars['String']['output'];
  network?: Maybe<Network>;
  properties?: Maybe<Array<Maybe<PropertyItem>>>;
  sites: Array<Site>;
  updatedAt: Scalars['DateTime']['output'];
};


export type VerticalContentArgs = {
  orderBy?: InputMaybe<ContentItemV2OrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContentItemV2WhereInput>;
};


export type VerticalHistoryArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type VerticalNetworkArgs = {
  where?: InputMaybe<NetworkWhereInput>;
};


export type VerticalPropertiesArgs = {
  orderBy?: InputMaybe<PropertyItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PropertyItemWhereInput>;
};


export type VerticalSitesArgs = {
  cursor?: InputMaybe<SiteWhereUniqueInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SiteWhereInput>;
};

export type VerticalCreateManyNetworkInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateManyNetworkInputEnvelope = {
  data?: InputMaybe<Array<VerticalCreateManyNetworkInput>>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerticalCreateNestedManyWithoutNetworkInput = {
  connect?: InputMaybe<Array<VerticalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VerticalCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<VerticalCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<VerticalCreateManyNetworkInputEnvelope>;
};

export type VerticalCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<VerticalCreateWithoutContentInput>;
};

export type VerticalCreateNestedOneWithoutContentOldInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<VerticalCreateWithoutContentOldInput>;
};

export type VerticalCreateNestedOneWithoutMenusInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutMenusInput>;
  create?: InputMaybe<VerticalCreateWithoutMenusInput>;
};

export type VerticalCreateNestedOneWithoutPostInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutPostInput>;
  create?: InputMaybe<VerticalCreateWithoutPostInput>;
};

export type VerticalCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<VerticalCreateWithoutPropertiesInput>;
};

export type VerticalCreateNestedOneWithoutRouteResourcesInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutRouteResourcesInput>;
  create?: InputMaybe<VerticalCreateWithoutRouteResourcesInput>;
};

export type VerticalCreateNestedOneWithoutSitesInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutSitesInput>;
  create?: InputMaybe<VerticalCreateWithoutSitesInput>;
};

export type VerticalCreateNestedOneWithoutSourceRedirectsInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutSourceRedirectsInput>;
  create?: InputMaybe<VerticalCreateWithoutSourceRedirectsInput>;
};

export type VerticalCreateNestedOneWithoutTargetRedirectsInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutTargetRedirectsInput>;
  create?: InputMaybe<VerticalCreateWithoutTargetRedirectsInput>;
};

export type VerticalCreateOrConnectWithoutContentInput = {
  create: VerticalCreateWithoutContentInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutContentOldInput = {
  create: VerticalCreateWithoutContentOldInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutMenusInput = {
  create: VerticalCreateWithoutMenusInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutNetworkInput = {
  create: VerticalCreateWithoutNetworkInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutPostInput = {
  create: VerticalCreateWithoutPostInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutPropertiesInput = {
  create: VerticalCreateWithoutPropertiesInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutRouteResourcesInput = {
  create: VerticalCreateWithoutRouteResourcesInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutSitesInput = {
  create: VerticalCreateWithoutSitesInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutSourceRedirectsInput = {
  create: VerticalCreateWithoutSourceRedirectsInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateOrConnectWithoutTargetRedirectsInput = {
  create: VerticalCreateWithoutTargetRedirectsInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalCreateWithoutContentInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutContentOldInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutMenusInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutNetworkInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutPostInput = {
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutPropertiesInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutRouteResourcesInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutSitesInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutSourceRedirectsInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  targetRedirects?: InputMaybe<RedirectCreateNestedManyWithoutTargetVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCreateWithoutTargetRedirectsInput = {
  Post?: InputMaybe<PostCreateNestedManyWithoutVerticalInput>;
  content?: InputMaybe<ContentItemV2CreateNestedManyWithoutVerticalInput>;
  contentOld?: InputMaybe<ContentItemCreateNestedManyWithoutVerticalInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuCreateNestedManyWithoutVerticalInput>;
  network?: InputMaybe<NetworkCreateNestedOneWithoutVerticalsInput>;
  properties?: InputMaybe<PropertyItemCreateNestedManyWithoutVerticalInput>;
  routeResources?: InputMaybe<RouteResourceCreateNestedManyWithoutVerticalInput>;
  sites?: InputMaybe<SiteCreateNestedManyWithoutVerticalInput>;
  sourceRedirects?: InputMaybe<RedirectCreateNestedManyWithoutSourceVerticalInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerticalCurrentInput = {
  network?: InputMaybe<Scalars['String']['input']>;
};

export type VerticalListRelationFilter = {
  every?: InputMaybe<VerticalWhereInput>;
  none?: InputMaybe<VerticalWhereInput>;
  some?: InputMaybe<VerticalWhereInput>;
};

export type VerticalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VerticalOrderByWithRelationInput = {
  Post?: InputMaybe<PostOrderByRelationAggregateInput>;
  content?: InputMaybe<ContentItemV2OrderByRelationAggregateInput>;
  contentOld?: InputMaybe<ContentItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  menus?: InputMaybe<MenuOrderByRelationAggregateInput>;
  network?: InputMaybe<NetworkOrderByWithRelationInput>;
  networkId?: InputMaybe<SortOrderInput>;
  properties?: InputMaybe<PropertyItemOrderByRelationAggregateInput>;
  routeResources?: InputMaybe<RouteResourceOrderByRelationAggregateInput>;
  sites?: InputMaybe<SiteOrderByRelationAggregateInput>;
  sourceRedirects?: InputMaybe<RedirectOrderByRelationAggregateInput>;
  targetRedirects?: InputMaybe<RedirectOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type VerticalScalarWhereInput = {
  AND?: InputMaybe<Array<VerticalScalarWhereInput>>;
  NOT?: InputMaybe<Array<VerticalScalarWhereInput>>;
  OR?: InputMaybe<Array<VerticalScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  networkId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type VerticalUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateManyWithWhereWithoutNetworkInput = {
  data: VerticalUpdateManyMutationInput;
  where: VerticalScalarWhereInput;
};

export type VerticalUpdateManyWithoutNetworkNestedInput = {
  connect?: InputMaybe<Array<VerticalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VerticalCreateOrConnectWithoutNetworkInput>>;
  create?: InputMaybe<Array<VerticalCreateWithoutNetworkInput>>;
  createMany?: InputMaybe<VerticalCreateManyNetworkInputEnvelope>;
  delete?: InputMaybe<Array<VerticalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VerticalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VerticalWhereUniqueInput>>;
  set?: InputMaybe<Array<VerticalWhereUniqueInput>>;
  update?: InputMaybe<Array<VerticalUpdateWithWhereUniqueWithoutNetworkInput>>;
  updateMany?: InputMaybe<Array<VerticalUpdateManyWithWhereWithoutNetworkInput>>;
  upsert?: InputMaybe<Array<VerticalUpsertWithWhereUniqueWithoutNetworkInput>>;
};

export type VerticalUpdateOneRequiredWithoutSitesNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutSitesInput>;
  create?: InputMaybe<VerticalCreateWithoutSitesInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutSitesInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutSitesInput>;
};

export type VerticalUpdateOneWithoutContentNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<VerticalCreateWithoutContentInput>;
  delete?: InputMaybe<VerticalWhereInput>;
  disconnect?: InputMaybe<VerticalWhereInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutContentInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutContentInput>;
};

export type VerticalUpdateOneWithoutContentOldNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutContentOldInput>;
  create?: InputMaybe<VerticalCreateWithoutContentOldInput>;
  delete?: InputMaybe<VerticalWhereInput>;
  disconnect?: InputMaybe<VerticalWhereInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutContentOldInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutContentOldInput>;
};

export type VerticalUpdateOneWithoutMenusNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutMenusInput>;
  create?: InputMaybe<VerticalCreateWithoutMenusInput>;
  delete?: InputMaybe<VerticalWhereInput>;
  disconnect?: InputMaybe<VerticalWhereInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutMenusInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutMenusInput>;
};

export type VerticalUpdateOneWithoutPostNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutPostInput>;
  create?: InputMaybe<VerticalCreateWithoutPostInput>;
  delete?: InputMaybe<VerticalWhereInput>;
  disconnect?: InputMaybe<VerticalWhereInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutPostInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutPostInput>;
};

export type VerticalUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutPropertiesInput>;
  create?: InputMaybe<VerticalCreateWithoutPropertiesInput>;
  delete?: InputMaybe<VerticalWhereInput>;
  disconnect?: InputMaybe<VerticalWhereInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutPropertiesInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutPropertiesInput>;
};

export type VerticalUpdateOneWithoutRouteResourcesNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutRouteResourcesInput>;
  create?: InputMaybe<VerticalCreateWithoutRouteResourcesInput>;
  delete?: InputMaybe<VerticalWhereInput>;
  disconnect?: InputMaybe<VerticalWhereInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutRouteResourcesInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutRouteResourcesInput>;
};

export type VerticalUpdateOneWithoutSourceRedirectsNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutSourceRedirectsInput>;
  create?: InputMaybe<VerticalCreateWithoutSourceRedirectsInput>;
  delete?: InputMaybe<VerticalWhereInput>;
  disconnect?: InputMaybe<VerticalWhereInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutSourceRedirectsInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutSourceRedirectsInput>;
};

export type VerticalUpdateOneWithoutTargetRedirectsNestedInput = {
  connect?: InputMaybe<VerticalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<VerticalCreateOrConnectWithoutTargetRedirectsInput>;
  create?: InputMaybe<VerticalCreateWithoutTargetRedirectsInput>;
  delete?: InputMaybe<VerticalWhereInput>;
  disconnect?: InputMaybe<VerticalWhereInput>;
  update?: InputMaybe<VerticalUpdateToOneWithWhereWithoutTargetRedirectsInput>;
  upsert?: InputMaybe<VerticalUpsertWithoutTargetRedirectsInput>;
};

export type VerticalUpdateToOneWithWhereWithoutContentInput = {
  data: VerticalUpdateWithoutContentInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateToOneWithWhereWithoutContentOldInput = {
  data: VerticalUpdateWithoutContentOldInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateToOneWithWhereWithoutMenusInput = {
  data: VerticalUpdateWithoutMenusInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateToOneWithWhereWithoutPostInput = {
  data: VerticalUpdateWithoutPostInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateToOneWithWhereWithoutPropertiesInput = {
  data: VerticalUpdateWithoutPropertiesInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateToOneWithWhereWithoutRouteResourcesInput = {
  data: VerticalUpdateWithoutRouteResourcesInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateToOneWithWhereWithoutSitesInput = {
  data: VerticalUpdateWithoutSitesInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateToOneWithWhereWithoutSourceRedirectsInput = {
  data: VerticalUpdateWithoutSourceRedirectsInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateToOneWithWhereWithoutTargetRedirectsInput = {
  data: VerticalUpdateWithoutTargetRedirectsInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpdateWithWhereUniqueWithoutNetworkInput = {
  data: VerticalUpdateWithoutNetworkInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalUpdateWithoutContentInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutContentOldInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutMenusInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutNetworkInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutPostInput = {
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutPropertiesInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutRouteResourcesInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutSitesInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutSourceRedirectsInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  targetRedirects?: InputMaybe<RedirectUpdateManyWithoutTargetVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpdateWithoutTargetRedirectsInput = {
  Post?: InputMaybe<PostUpdateManyWithoutVerticalNestedInput>;
  content?: InputMaybe<ContentItemV2UpdateManyWithoutVerticalNestedInput>;
  contentOld?: InputMaybe<ContentItemUpdateManyWithoutVerticalNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  menus?: InputMaybe<MenuUpdateManyWithoutVerticalNestedInput>;
  network?: InputMaybe<NetworkUpdateOneWithoutVerticalsNestedInput>;
  properties?: InputMaybe<PropertyItemUpdateManyWithoutVerticalNestedInput>;
  routeResources?: InputMaybe<RouteResourceUpdateManyWithoutVerticalNestedInput>;
  sites?: InputMaybe<SiteUpdateManyWithoutVerticalNestedInput>;
  sourceRedirects?: InputMaybe<RedirectUpdateManyWithoutSourceVerticalNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type VerticalUpsertDataInput = {
  content?: InputMaybe<ResourceContentInput>;
  properties?: InputMaybe<ResourcePropertyInput>;
};

export type VerticalUpsertWithWhereUniqueWithoutNetworkInput = {
  create: VerticalCreateWithoutNetworkInput;
  update: VerticalUpdateWithoutNetworkInput;
  where: VerticalWhereUniqueInput;
};

export type VerticalUpsertWithoutContentInput = {
  create: VerticalCreateWithoutContentInput;
  update: VerticalUpdateWithoutContentInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpsertWithoutContentOldInput = {
  create: VerticalCreateWithoutContentOldInput;
  update: VerticalUpdateWithoutContentOldInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpsertWithoutMenusInput = {
  create: VerticalCreateWithoutMenusInput;
  update: VerticalUpdateWithoutMenusInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpsertWithoutPostInput = {
  create: VerticalCreateWithoutPostInput;
  update: VerticalUpdateWithoutPostInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpsertWithoutPropertiesInput = {
  create: VerticalCreateWithoutPropertiesInput;
  update: VerticalUpdateWithoutPropertiesInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpsertWithoutRouteResourcesInput = {
  create: VerticalCreateWithoutRouteResourcesInput;
  update: VerticalUpdateWithoutRouteResourcesInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpsertWithoutSitesInput = {
  create: VerticalCreateWithoutSitesInput;
  update: VerticalUpdateWithoutSitesInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpsertWithoutSourceRedirectsInput = {
  create: VerticalCreateWithoutSourceRedirectsInput;
  update: VerticalUpdateWithoutSourceRedirectsInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalUpsertWithoutTargetRedirectsInput = {
  create: VerticalCreateWithoutTargetRedirectsInput;
  update: VerticalUpdateWithoutTargetRedirectsInput;
  where?: InputMaybe<VerticalWhereInput>;
};

export type VerticalWhereInput = {
  AND?: InputMaybe<Array<VerticalWhereInput>>;
  NOT?: InputMaybe<Array<VerticalWhereInput>>;
  OR?: InputMaybe<Array<VerticalWhereInput>>;
  Post?: InputMaybe<PostListRelationFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  menus?: InputMaybe<MenuListRelationFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  routeResources?: InputMaybe<RouteResourceListRelationFilter>;
  sites?: InputMaybe<SiteListRelationFilter>;
  sourceRedirects?: InputMaybe<RedirectListRelationFilter>;
  targetRedirects?: InputMaybe<RedirectListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type VerticalWhereUniqueInput = {
  AND?: InputMaybe<Array<VerticalWhereInput>>;
  NOT?: InputMaybe<Array<VerticalWhereInput>>;
  OR?: InputMaybe<Array<VerticalWhereInput>>;
  Post?: InputMaybe<PostListRelationFilter>;
  content?: InputMaybe<ContentItemV2ListRelationFilter>;
  contentOld?: InputMaybe<ContentItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  menus?: InputMaybe<MenuListRelationFilter>;
  network?: InputMaybe<NetworkWhereInput>;
  networkId?: InputMaybe<StringNullableFilter>;
  properties?: InputMaybe<PropertyItemListRelationFilter>;
  routeResources?: InputMaybe<RouteResourceListRelationFilter>;
  sites?: InputMaybe<SiteListRelationFilter>;
  sourceRedirects?: InputMaybe<RedirectListRelationFilter>;
  targetRedirects?: InputMaybe<RedirectListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ShortcodePagesQueryVariables = Exact<{
  verticalId?: InputMaybe<Scalars['String']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type ShortcodePagesQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', id?: string | null, vertical?: { __typename?: 'Vertical', id: string } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type ShortcodePostsQueryVariables = Exact<{
  verticalId?: InputMaybe<Scalars['String']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type ShortcodePostsQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id?: string | null, vertical?: { __typename?: 'Vertical', id: string } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type ShortcodeProvidersQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type ShortcodeProvidersQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null, contextId?: string | null } | null> | null }> };

export type DuplicatedPageQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
}>;


export type DuplicatedPageQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', id?: string | null, vertical?: { __typename?: 'Vertical', id: string } | null }> };

export type DuplicatedPostQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
}>;


export type DuplicatedPostQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id?: string | null, vertical?: { __typename?: 'Vertical', id: string } | null }> };

export type ProviderInputDataQueryVariables = Exact<{
  languageId: Scalars['String']['input'];
  where?: InputMaybe<RouteResourceWhereInput>;
}>;


export type ProviderInputDataQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type FilteredTaxonomyItemsInputQueryVariables = Exact<{
  where: RouteResourceWhereInput;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type FilteredTaxonomyItemsInputQuery = { __typename?: 'Query', taxonomyItems: Array<{ __typename?: 'TaxonomyItem', id?: string | null, parentId?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type TaxonomyParentItemsInputQueryVariables = Exact<{
  where: RouteResourceWhereInput;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type TaxonomyParentItemsInputQuery = { __typename?: 'Query', taxonomyItems: Array<{ __typename?: 'TaxonomyItem', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type DynamicFormInputPropertyResourceQueryVariables = Exact<{
  languageId: Scalars['String']['input'];
  taxonomyItemsWhere?: InputMaybe<RouteResourceWhereInput>;
  providersWhere?: InputMaybe<RouteResourceWhereInput>;
}>;


export type DynamicFormInputPropertyResourceQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }>, taxonomyItems: Array<{ __typename?: 'TaxonomyItem', id?: string | null, parentId?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type PropertyItemsQueryVariables = Exact<{
  where?: InputMaybe<PropertyItemWhereInput>;
}>;


export type PropertyItemsQuery = { __typename?: 'Query', propertyItems: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null }> };

export type GroupTaxonomyItemsQueryVariables = Exact<{
  languageId: Scalars['String']['input'];
  where?: InputMaybe<RouteResourceWhereInput>;
}>;


export type GroupTaxonomyItemsQuery = { __typename?: 'Query', taxonomyItems: Array<{ __typename?: 'TaxonomyItem', id?: string | null, parentId?: string | null, subtype?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null, resolvedData?: Array<{ __typename?: 'MediaItem', url: string } | { __typename?: 'Product' } | { __typename?: 'TaxonomyItem' } | null> | null } | null> | null }> };

export type PillarSectionsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type PillarSectionsQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type NetworksVerticalsSitesQueryVariables = Exact<{
  defaultLanguageId: Scalars['String']['input'];
}>;


export type NetworksVerticalsSitesQuery = { __typename?: 'Query', networks: Array<{ __typename?: 'Network', id: string, verticals: Array<{ __typename?: 'Vertical', id: string, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, sites: Array<{ __typename?: 'Site', id: string, url: string }> }>, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }>, countries: Array<{ __typename?: 'Country', id: string, name: string, countryCode: string }> };

export type CreateTranslationJobMutationVariables = Exact<{
  jobs: Array<TranslationJobData> | TranslationJobData;
}>;


export type CreateTranslationJobMutation = { __typename?: 'Mutation', createTranslationJobs?: Array<{ __typename?: 'TranslationJob', id?: string | null, data?: any | null, timestamp?: any | null } | null> | null };

export type SitesForLocalizationQueryVariables = Exact<{
  where?: InputMaybe<SiteWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesForLocalizationQuery = { __typename?: 'Query', count?: number | null, sites: Array<{ __typename?: 'Site', id: string, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type ContentItemFragmentFragment = { __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null };

export type CountryFragmentFragment = { __typename?: 'Country', id: string, name: string, countryCode: string };

export type CountryWithLanguagesFragmentFragment = { __typename?: 'Country', id: string, name: string, countryCode: string, languages: Array<{ __typename?: 'Language', id: string, name: string, languageCode: string, shortNameEng?: string | null }> };

export type FilterTaxonomyRuleFragmentFragment = { __typename?: 'FilterTaxonomyRule', id: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, network: { __typename?: 'Network', id: string }, taxonomyBase: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> }, taxonomyFilter: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } };

export type LanguageFragmentFragment = { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null };

export type LanguageWithCountriesFragmentFragment = { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null, countries: Array<{ __typename?: 'Country', id: string, name: string, countryCode: string }> };

export type MediaItemFragmentFragment = { __typename?: 'MediaItem', id: string, checksum: string, metadata?: string | null, mimetype?: string | null, url: string, name?: string | null, alt?: string | null, createdAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null, network?: { __typename?: 'Network', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> };

export type MenuFragmentFragment = { __typename?: 'Menu', id: string, key: string, vertical?: { __typename?: 'Vertical', id: string, createdAt: any, updatedAt: any, network?: { __typename?: 'Network', id: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, sites: Array<{ __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null }>, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null } | null, items: Array<{ __typename?: 'MenuItem', id: string, type: MenuType, index: number, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, children: Array<{ __typename?: 'MenuItem', id: string, type: MenuType, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }>, parent?: { __typename?: 'MenuItem', id: string } | null }> };

export type MenuItemFragmentFragment = { __typename?: 'MenuItem', id: string, type: MenuType, index: number, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, children: Array<{ __typename?: 'MenuItem', id: string, type: MenuType, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }>, parent?: { __typename?: 'MenuItem', id: string } | null };

export type NetworkFragmentFragment = { __typename?: 'Network', id: string, companyId?: string | null, createdAt: any, updatedAt: any, company?: { __typename?: 'Company', id: string, name: string, slug: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null, verticals: Array<{ __typename?: 'Vertical', id: string, createdAt: any, updatedAt: any, network?: { __typename?: 'Network', id: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, sites: Array<{ __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null }>, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null }>, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null };

export type PostStatusFragmentFragment = { __typename?: 'Post', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, vertical?: { __typename?: 'Vertical', id: string } | null };

export type ProductFragmentFragment = { __typename?: 'Product', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null };

export type PropertyItemFragmentFragment = { __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null };

export type ProviderFragmentFragment = { __typename?: 'Provider', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null };

export type SiteFragmentFragment = { __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null };

export type TaxonomyItemFragmentFragment = { __typename?: 'TaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, network?: { __typename?: 'Network', id: string } | null };

export type UserFragmentFragment = { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null };

export type VerticalFragmentFragment = { __typename?: 'Vertical', id: string, createdAt: any, updatedAt: any, network?: { __typename?: 'Network', id: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, sites: Array<{ __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null }>, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null };

export type DeleteContentItemMutationVariables = Exact<{
  where: ContentItemWhereUniqueInput;
}>;


export type DeleteContentItemMutation = { __typename?: 'Mutation', deleteContentItem?: { __typename?: 'ContentItem', id: string } | null };

export type DeleteFileMutationVariables = Exact<{
  where?: InputMaybe<MediaItemWhereUniqueInput>;
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile?: { __typename?: 'MediaItem', id: string } | null };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  networkId: Scalars['String']['input'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile?: { __typename?: 'MediaItem', id: string, checksum: string, metadata?: string | null, mimetype?: string | null, url: string, name?: string | null, alt?: string | null, createdAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null, network?: { __typename?: 'Network', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type UploadFileWithCloudinaryWidgetMutationVariables = Exact<{
  networkId?: InputMaybe<Scalars['String']['input']>;
  cloudinaryFileObject: CloudinaryFileInput;
}>;


export type UploadFileWithCloudinaryWidgetMutation = { __typename?: 'Mutation', uploadFileWithCloudinaryWidget?: { __typename?: 'MediaItem', id: string, checksum: string, metadata?: string | null, mimetype?: string | null, url: string, name?: string | null, alt?: string | null, createdAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null, network?: { __typename?: 'Network', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type UploadFileWithUrlMutationVariables = Exact<{
  url: Scalars['String']['input'];
  networkId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadFileWithUrlMutation = { __typename?: 'Mutation', uploadFileWithURL?: { __typename?: 'MediaItem', id: string, checksum: string, metadata?: string | null, mimetype?: string | null, url: string, name?: string | null, alt?: string | null, createdAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null, network?: { __typename?: 'Network', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type UploadImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  networkId: Scalars['String']['input'];
}>;


export type UploadImageMutation = { __typename?: 'Mutation', uploadFile?: { __typename?: 'MediaItem', url: string } | null };

export type CreateRedirectMutationVariables = Exact<{
  data: RedirectCreateInput;
}>;


export type CreateRedirectMutation = { __typename?: 'Mutation', createRedirect: { __typename?: 'Redirect', id: string, httpCode: number, scope: RedirectScope, sourceKind: RedirectKind, sourcePath?: string | null, sourceUrl?: string | null, sourceResourceType?: RouteResourceType | null, sourceResourceId?: string | null, sourceSiteId?: string | null, sourceVerticalId?: string | null, sourceNetworkId?: string | null, targetKind: RedirectKind, targetPath?: string | null, targetUrl?: string | null, targetResourceType?: RouteResourceType | null, targetResourceId?: string | null, targetSiteId?: string | null, targetVerticalId?: string | null, targetNetworkId?: string | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null } | null } };

export type DeleteRedirectMutationVariables = Exact<{
  where: RedirectWhereUniqueInput;
}>;


export type DeleteRedirectMutation = { __typename?: 'Mutation', deleteRedirect?: { __typename?: 'Redirect', id: string } | null };

export type UpsertRedirectMutationVariables = Exact<{
  where: RedirectWhereUniqueInput;
  create: RedirectCreateInput;
  update: RedirectUpdateInput;
}>;


export type UpsertRedirectMutation = { __typename?: 'Mutation', upsertRedirect: { __typename?: 'Redirect', id: string, httpCode: number, scope: RedirectScope, sourceKind: RedirectKind, sourcePath?: string | null, sourceUrl?: string | null, sourceResourceType?: RouteResourceType | null, sourceResourceId?: string | null, sourceSiteId?: string | null, sourceVerticalId?: string | null, sourceNetworkId?: string | null, targetKind: RedirectKind, targetPath?: string | null, targetUrl?: string | null, targetResourceType?: RouteResourceType | null, targetResourceId?: string | null, targetSiteId?: string | null, targetVerticalId?: string | null, targetNetworkId?: string | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null } | null } };

export type UpsertProductMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: ProductUpsertDataInput;
  current: ResourceCurrentInput;
}>;


export type UpsertProductMutation = { __typename?: 'Mutation', upsertProduct?: { __typename?: 'Product', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type UpsertProviderMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: ProviderUpsertDataInput;
  current: ResourceCurrentInput;
}>;


export type UpsertProviderMutation = { __typename?: 'Mutation', upsertProvider?: { __typename?: 'Provider', id?: string | null } | null };

export type UpsertTaxonomyItemMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: TaxonomyItemUpsertDataInput;
  current: ResourceCurrentInput;
}>;


export type UpsertTaxonomyItemMutation = { __typename?: 'Mutation', upsertTaxonomyItem?: { __typename?: 'TaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, network?: { __typename?: 'Network', id: string } | null } | null };

export type UpsertPostStatusMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: PostUpsertDataInput;
  current: ResourceCurrentInput;
}>;


export type UpsertPostStatusMutation = { __typename?: 'Mutation', upsertPost?: { __typename?: 'Post', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, vertical?: { __typename?: 'Vertical', id: string } | null } | null };

export type UpsertSiteMutationVariables = Exact<{
  where: SiteWhereUniqueInput;
  data: SiteUpsertDataInput;
  current: SiteCurrentInput;
}>;


export type UpsertSiteMutation = { __typename?: 'Mutation', upsertSite?: { __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null } | null };

export type UpdateMediaItemMutationVariables = Exact<{
  where: MediaItemWhereUniqueInput;
  data: MediaItemUpdateInput;
}>;


export type UpdateMediaItemMutation = { __typename?: 'Mutation', updateMediaItem?: { __typename?: 'MediaItem', id: string } | null };

export type AllTaxonomyItemsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  languageId: Scalars['String']['input'];
}>;


export type AllTaxonomyItemsQuery = { __typename?: 'Query', taxonomyItems: Array<{ __typename?: 'TaxonomyItem', id?: string | null, parentId?: string | null, subtype?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null, contextId?: string | null, resolvedData?: Array<{ __typename?: 'MediaItem', url: string } | { __typename?: 'Product' } | { __typename?: 'TaxonomyItem' } | null> | null } | null> | null, pools?: Array<{ __typename?: 'TaxonomyItemPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null }> };

export type AllTemplatesQueryVariables = Exact<{
  where: TemplateWhereInput;
}>;


export type AllTemplatesQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Template', id: string, type: TemplateType, subtype?: string | null, network?: { __typename?: 'Network', id: string } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type AuthorsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AuthorsQuery = { __typename?: 'Query', count?: number | null, authors: Array<{ __typename?: 'Author', id?: string | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type CountriesQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
}>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: string, name: string, countryCode: string }> };

export type CountriesWithLanguagesQueryVariables = Exact<{
  where?: InputMaybe<CountryWhereInput>;
}>;


export type CountriesWithLanguagesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id: string, name: string, countryCode: string, languages: Array<{ __typename?: 'Language', id: string, name: string, languageCode: string, shortNameEng?: string | null }> }> };

export type FilterTaxonomyRulesQueryVariables = Exact<{
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type FilterTaxonomyRulesQuery = { __typename?: 'Query', count?: number | null, filterTaxonomyRules: Array<{ __typename?: 'FilterTaxonomyRule', id: string, taxonomyBase: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> }, taxonomyFilter: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } }> };

export type LanguagesQueryVariables = Exact<{
  where?: InputMaybe<LanguageWhereInput>;
}>;


export type LanguagesQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }> };

export type LanguagesWithCountriesQueryVariables = Exact<{
  where?: InputMaybe<LanguageWhereInput>;
}>;


export type LanguagesWithCountriesQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null, countries: Array<{ __typename?: 'Country', id: string, name: string, countryCode: string }> }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null };

export type MediaItemQueryVariables = Exact<{
  where: MediaItemWhereUniqueInput;
}>;


export type MediaItemQuery = { __typename?: 'Query', mediaItem?: { __typename?: 'MediaItem', id: string, checksum: string, metadata?: string | null, mimetype?: string | null, url: string, name?: string | null, alt?: string | null, createdAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null, network?: { __typename?: 'Network', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> } | null };

export type MediaItemsQueryVariables = Exact<{
  where?: InputMaybe<MediaItemWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MediaItemOrderByWithRelationInput> | MediaItemOrderByWithRelationInput>;
}>;


export type MediaItemsQuery = { __typename?: 'Query', count?: number | null, mediaItems: Array<{ __typename?: 'MediaItem', id: string, checksum: string, metadata?: string | null, mimetype?: string | null, url: string, name?: string | null, alt?: string | null, createdAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null, network?: { __typename?: 'Network', id: string } | null, tags: Array<{ __typename?: 'Tag', id: string, name: string }> }> };

export type NetworksQueryVariables = Exact<{
  where?: InputMaybe<NetworkWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NetworksQuery = { __typename?: 'Query', count?: number | null, networks: Array<{ __typename?: 'Network', id: string, companyId?: string | null, createdAt: any, updatedAt: any, company?: { __typename?: 'Company', id: string, name: string, slug: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null, verticals: Array<{ __typename?: 'Vertical', id: string, createdAt: any, updatedAt: any, network?: { __typename?: 'Network', id: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, sites: Array<{ __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null }>, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null }>, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null }> };

export type NetworksSlimQueryVariables = Exact<{
  where?: InputMaybe<NetworkWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NetworkOrderByWithRelationInput> | NetworkOrderByWithRelationInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type NetworksSlimQuery = { __typename?: 'Query', networks: Array<{ __typename?: 'Network', id: string, companyId?: string | null, company?: { __typename?: 'Company', id: string, name: string, slug: string } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type PagesQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type PagesQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type PostsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type PostsQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type ProductPoolsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourcePoolWhereInput>;
}>;


export type ProductPoolsQuery = { __typename?: 'Query', productPools: Array<{ __typename?: 'ProductPool', id?: string | null, name?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null, products?: Array<{ __typename?: 'Product', id?: string | null } | null> | null }> };

export type ProductsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductsQuery = { __typename?: 'Query', count?: number | null, products: Array<{ __typename?: 'Product', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type ProductsForStoreQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type ProductsForStoreQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id?: string | null, subtype?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type ProviderQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
}>;


export type ProviderQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type ProviderPoolsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourcePoolWhereInput>;
}>;


export type ProviderPoolsQuery = { __typename?: 'Query', providerPools: Array<{ __typename?: 'ProviderPool', id?: string | null, name?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null, providers?: Array<{ __typename?: 'Provider', id?: string | null } | null> | null }> };

export type ProvidersQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProvidersQuery = { __typename?: 'Query', count?: number | null, providers: Array<{ __typename?: 'Provider', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type ProvidersAndTaxonomiesCountsQueryVariables = Exact<{
  networkId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProvidersAndTaxonomiesCountsQuery = { __typename?: 'Query', newResourceCounts?: { __typename?: 'NewResourceCounts', providersCount: number, taxonomyItemsCount: number } | null };

export type RankingProvidersQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type RankingProvidersQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id?: string | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null, type: FieldType } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type RedirectsQueryVariables = Exact<{
  where?: InputMaybe<RedirectWhereInput>;
  orderBy?: InputMaybe<Array<RedirectOrderByWithRelationInput> | RedirectOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type RedirectsQuery = { __typename?: 'Query', redirects: Array<{ __typename?: 'Redirect', id: string, httpCode: number, scope: RedirectScope, sourceKind: RedirectKind, sourcePath?: string | null, sourceUrl?: string | null, sourceResourceType?: RouteResourceType | null, sourceResourceId?: string | null, sourceSiteId?: string | null, sourceVerticalId?: string | null, sourceNetworkId?: string | null, targetKind: RedirectKind, targetPath?: string | null, targetUrl?: string | null, targetResourceType?: RouteResourceType | null, targetResourceId?: string | null, targetSiteId?: string | null, targetVerticalId?: string | null, targetNetworkId?: string | null, createdAt: any, updatedAt: any, sourceResource?: { __typename?: 'RouteResource', id: string, resourceType: RouteResourceType, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } | null, targetResource?: { __typename?: 'RouteResource', id: string, resourceType: RouteResourceType, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } | null, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null } | null }> };

export type RedirectCountQueryVariables = Exact<{
  where?: InputMaybe<RedirectWhereInput>;
}>;


export type RedirectCountQuery = { __typename?: 'Query', redirectCount?: number | null };

export type RedirectQueryVariables = Exact<{
  where: RedirectWhereUniqueInput;
}>;


export type RedirectQuery = { __typename?: 'Query', redirect?: { __typename?: 'Redirect', id: string, httpCode: number, scope: RedirectScope, sourceKind: RedirectKind, sourcePath?: string | null, sourceUrl?: string | null, sourceResourceType?: RouteResourceType | null, sourceResourceId?: string | null, sourceSiteId?: string | null, sourceVerticalId?: string | null, sourceNetworkId?: string | null, targetKind: RedirectKind, targetPath?: string | null, targetUrl?: string | null, targetResourceType?: RouteResourceType | null, targetResourceId?: string | null, targetSiteId?: string | null, targetVerticalId?: string | null, targetNetworkId?: string | null, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, email?: string | null } | null } | null };

export type RegionsSubregionsCountriesQueryVariables = Exact<{
  where?: InputMaybe<RegionWhereInput>;
}>;


export type RegionsSubregionsCountriesQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: string, name: string, subregions: Array<{ __typename?: 'Subregion', id: string, name: string, countries: Array<{ __typename?: 'Country', countryCode: string, id: string, name: string }> }> }> };

export type SchedulerPostsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  currentLanguageId: Scalars['String']['input'];
}>;


export type SchedulerPostsQuery = { __typename?: 'Query', count?: number | null, posts: Array<{ __typename?: 'Post', id?: string | null, createdAt?: any | null, publishedAt?: any | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type SitesQueryVariables = Exact<{
  where?: InputMaybe<SiteWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesQuery = { __typename?: 'Query', count?: number | null, sites: Array<{ __typename?: 'Site', id: string, url: string, vertical: { __typename?: 'Vertical', id: string } }> };

export type SitesSlimQueryVariables = Exact<{
  where?: InputMaybe<SiteWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesSlimQuery = { __typename?: 'Query', count?: number | null, sites: Array<{ __typename?: 'Site', id: string, url: string, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null } }> };

export type StringTemplateVariablesQueryVariables = Exact<{
  where?: InputMaybe<StringTemplateVariableWhereInput>;
}>;


export type StringTemplateVariablesQuery = { __typename?: 'Query', stringTemplateVariables: Array<{ __typename?: 'StringTemplateVariable', id: string, type: StringTemplateVariableType, key: string, name: string, group?: string | null, data?: any | null }> };

export type TagsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByWithRelationInput> | TagOrderByWithRelationInput>;
  where?: InputMaybe<TagWhereInput>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', name: string, id: string }> };

export type TaxonomyItemPoolsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourcePoolWhereInput>;
}>;


export type TaxonomyItemPoolsQuery = { __typename?: 'Query', taxonomyItemPools: Array<{ __typename?: 'TaxonomyItemPool', id?: string | null, name?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null, taxonomyItems?: Array<{ __typename?: 'TaxonomyItem', id?: string | null } | null> | null }> };

export type TemplatesQueryVariables = Exact<{
  where: TemplateWhereInput;
}>;


export type TemplatesQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Template', id: string, type: TemplateType, subtype?: string | null, network?: { __typename?: 'Network', id: string } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, fields: Array<{ __typename?: 'TemplateField', id: string, required: boolean, index?: number | null, group?: string | null, key: string, type: FieldType, hidden: boolean, list: boolean, geo: GeoMode, data?: any | null, context: ContextType, resourceType: ResourceType, defaultTranslationType: ContentItemTranslationType, displayType?: DisplayType | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }>, groups: Array<{ __typename?: 'TemplateFieldGroup', id: string, name: string, index: number, extended: boolean, data?: any | null, generalGroup?: { __typename?: 'GeneralTemplateFieldGroup', id: string, name: string, index: number } | null }> }> };

export type TranslationJobsEstimatedCostQueryVariables = Exact<{
  jobs: Array<TranslationJobData> | TranslationJobData;
}>;


export type TranslationJobsEstimatedCostQuery = { __typename?: 'Query', translationJobsEstimatedCost?: number | null };

export type UserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', app_metadata?: any | null, user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', app_metadata?: any | null, user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null> | null };

export type VerticalsQueryVariables = Exact<{
  where?: InputMaybe<VerticalWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerticalOrderByWithRelationInput> | VerticalOrderByWithRelationInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type VerticalsQuery = { __typename?: 'Query', count?: number | null, verticals: Array<{ __typename?: 'Vertical', id: string, createdAt: any, sites: Array<{ __typename?: 'Site', id: string, url: string, language: { __typename?: 'Language', id: string, languageTag: string, countryCode?: string | null } }>, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type VerticalsSlimQueryVariables = Exact<{
  where?: InputMaybe<VerticalWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerticalOrderByWithRelationInput> | VerticalOrderByWithRelationInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type VerticalsSlimQuery = { __typename?: 'Query', verticals: Array<{ __typename?: 'Vertical', id: string, network?: { __typename?: 'Network', id: string } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type DeleteAuthorMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
}>;


export type DeleteAuthorMutation = { __typename?: 'Mutation', deleteAuthor?: { __typename?: 'Author', id?: string | null } | null };

export type AuthorQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
}>;


export type AuthorQuery = { __typename?: 'Query', author?: { __typename?: 'Author', id?: string | null, resourceType?: string | null, createdAt?: any | null, updatedAt?: any | null, data?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null } | null };

export type AuthorCrudFragmentFragment = { __typename?: 'Author', id?: string | null, resourceType?: string | null, createdAt?: any | null, updatedAt?: any | null, data?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null };

export type DynamicListAuthorsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput> | RouteResourceOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
}>;


export type DynamicListAuthorsQuery = { __typename?: 'Query', count: number, authors: Array<{ __typename?: 'Author', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type UpsertAuthorMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: AuthorUpsertDataInput;
  current: ResourceCurrentInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type UpsertAuthorMutation = { __typename?: 'Mutation', upsertAuthor?: { __typename?: 'Author', id?: string | null, resourceType?: string | null, createdAt?: any | null, updatedAt?: any | null, data?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null } | null };

export type CompaniesQueryVariables = Exact<{
  where?: InputMaybe<CompanyWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompanyOrderByWithRelationInput> | CompanyOrderByWithRelationInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type CompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id: string, name: string, slug: string, createdAt: any, updatedAt: any, networks: Array<{ __typename?: 'Network', id: string, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> }> };

export type CompanyQueryVariables = Exact<{
  where: CompanyWhereUniqueInput;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name: string, slug: string, createdAt: any, updatedAt: any, networks: Array<{ __typename?: 'Network', id: string, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> } | null };

export type CompanyFragmentFragment = { __typename?: 'Company', id: string, name: string, slug: string, createdAt: any, updatedAt: any, networks: Array<{ __typename?: 'Network', id: string, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type UpsertCompanyMutationVariables = Exact<{
  where: CompanyWhereUniqueInput;
  create: CompanyCreateInput;
  update: CompanyUpdateInput;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type UpsertCompanyMutation = { __typename?: 'Mutation', upsertCompany: { __typename?: 'Company', id: string, name: string, slug: string, createdAt: any, updatedAt: any, networks: Array<{ __typename?: 'Network', id: string, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> } };

export type ComplianceRulesQueryVariables = Exact<{
  networkId: Scalars['String']['input'];
}>;


export type ComplianceRulesQuery = { __typename?: 'Query', complianceRules: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null }> };

export type UpdatePropertyItemMutationVariables = Exact<{
  where: PropertyItemWhereUniqueInput;
  data: PropertyItemUpdateInput;
}>;


export type UpdatePropertyItemMutation = { __typename?: 'Mutation', updatePropertyItem?: { __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null };

export type AuthorsForExportQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
}>;


export type AuthorsForExportQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Author', id?: string | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type FilterTaxonomyItemsForExportQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type FilterTaxonomyItemsForExportQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'FilterTaxonomyItem', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type PagesForExportQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type PagesForExportQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Page', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type PostsForExportQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type PostsForExportQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Post', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type ProductsForExportQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type ProductsForExportQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Product', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type ProviderTaxonomyConnectionsForExportQueryVariables = Exact<{
  where?: InputMaybe<ProviderTaxonomyConnectionWhereInput>;
}>;


export type ProviderTaxonomyConnectionsForExportQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'ProviderTaxonomyConnection', id: string, providerId: string, taxonomyItemId: string }> };

export type ProvidersForExportQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type ProvidersForExportQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Provider', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', key: string, data?: any | null } | null> | null }> };

export type SitesForExportQueryVariables = Exact<{
  where?: InputMaybe<SiteWhereInput>;
}>;


export type SitesForExportQuery = { __typename?: 'Query', resources: Array<{ __typename?: 'Site', id: string, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type DeleteFilterTaxonomyItemMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
}>;


export type DeleteFilterTaxonomyItemMutation = { __typename?: 'Mutation', deleteFilterTaxonomyItem?: { __typename?: 'FilterTaxonomyItem', id?: string | null } | null };

export type FilterTaxonomyItemQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type FilterTaxonomyItemQuery = { __typename?: 'Query', filterTaxonomyItem?: { __typename?: 'FilterTaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type FilterTaxonomyItemCrudFragmentFragment = { __typename?: 'FilterTaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null };

export type DynamicListFilterTaxonomyItemsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput> | RouteResourceOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
}>;


export type DynamicListFilterTaxonomyItemsQuery = { __typename?: 'Query', count: number, filterTaxonomyItems: Array<{ __typename?: 'FilterTaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type UpsertFilterTaxonomyItemMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: FilterTaxonomyItemUpsertDataInput;
  current: ResourceCurrentInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type UpsertFilterTaxonomyItemMutation = { __typename?: 'Mutation', upsertFilterTaxonomyItem?: { __typename?: 'FilterTaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type DeleteFilterTaxonomyRuleMutationVariables = Exact<{
  where: FilterTaxonomyRuleWhereUniqueInput;
}>;


export type DeleteFilterTaxonomyRuleMutation = { __typename?: 'Mutation', deleteFilterTaxonomyRule?: { __typename?: 'FilterTaxonomyRule', id: string } | null };

export type FilterTaxonomyRuleQueryVariables = Exact<{
  where: FilterTaxonomyRuleWhereUniqueInput;
}>;


export type FilterTaxonomyRuleQuery = { __typename?: 'Query', filterTaxonomyRule?: { __typename?: 'FilterTaxonomyRule', id: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, network: { __typename?: 'Network', id: string }, taxonomyBase: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> }, taxonomyFilter: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } } | null };

export type DynamicListFilterTaxonomyRulesQueryVariables = Exact<{
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  search?: InputMaybe<ResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<FilterTaxonomyRuleOrderByWithRelationInput> | FilterTaxonomyRuleOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
}>;


export type DynamicListFilterTaxonomyRulesQuery = { __typename?: 'Query', count: number, filterTaxonomyRules: Array<{ __typename?: 'FilterTaxonomyRule', id: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, taxonomyBase: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> }, taxonomyFilter: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } }> };

export type UpsertFilterTaxonomyRuleMutationVariables = Exact<{
  where: FilterTaxonomyRuleWhereUniqueInput;
  data: FilterTaxonomyRuleUpsertDataInput;
  current: ResourceCurrentInput;
}>;


export type UpsertFilterTaxonomyRuleMutation = { __typename?: 'Mutation', upsertFilterTaxonomyRule?: { __typename?: 'FilterTaxonomyRule', id: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, network: { __typename?: 'Network', id: string }, taxonomyBase: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> }, taxonomyFilter: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } } | null };

export type CreateOrUpdateMenuMutationVariables = Exact<{
  menu: MenuInput;
  menuItemsDelete?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateOrUpdateMenuMutation = { __typename?: 'Mutation', upsertMenuCustom?: { __typename?: 'Menu', id: string } | null };

export type DeleteMenuMutationVariables = Exact<{
  where: MenuWhereUniqueInput;
}>;


export type DeleteMenuMutation = { __typename?: 'Mutation', deleteMenu?: { __typename?: 'Menu', id: string } | null };

export type DeleteMenusMutationVariables = Exact<{
  where: MenuWhereInput;
}>;


export type DeleteMenusMutation = { __typename?: 'Mutation', deleteMenus: { __typename?: 'AffectedRowsOutput', count: number } };

export type LoadMenusQueryVariables = Exact<{
  where?: InputMaybe<MenuWhereInput>;
  currentLanguageId: Scalars['String']['input'];
}>;


export type LoadMenusQuery = { __typename?: 'Query', menus: Array<{ __typename?: 'Menu', id: string, key: string, items: Array<{ __typename?: 'MenuItem', id: string, type: MenuType, index: number, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, type: FieldType, data?: any | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, parent?: { __typename?: 'MenuItem', id: string } | null }> }> };

export type LoadMinifiedMenusWithSitesQueryVariables = Exact<{
  where?: InputMaybe<MenuWhereInput>;
}>;


export type LoadMinifiedMenusWithSitesQuery = { __typename?: 'Query', menus: Array<{ __typename?: 'Menu', id: string, key: string, site?: { __typename?: 'Site', id: string, url: string, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null, language: { __typename?: 'Language', id: string, countryCode?: string | null, languageTag: string } } | null }> };

export type MenuPagesQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type MenuPagesQuery = { __typename?: 'Query', count?: number | null, pages: Array<{ __typename?: 'Page', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null, resolvedData?: Array<{ __typename?: 'MediaItem', url: string } | { __typename?: 'Product' } | { __typename?: 'TaxonomyItem' } | null> | null } | null> | null }> };

export type MenuPostsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type MenuPostsQuery = { __typename?: 'Query', count?: number | null, posts: Array<{ __typename?: 'Post', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null, resolvedData?: Array<{ __typename?: 'MediaItem', url: string } | { __typename?: 'Product' } | { __typename?: 'TaxonomyItem' } | null> | null } | null> | null }> };

export type MenuProvidersQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type MenuProvidersQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null }> };

export type AllSitesInNetworkQueryVariables = Exact<{
  where?: InputMaybe<SiteWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AllSitesInNetworkQuery = { __typename?: 'Query', sites: Array<{ __typename?: 'Site', id: string, language: { __typename?: 'Language', id: string, languageTag: string } }> };

export type MetaProductQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
}>;


export type MetaProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id?: string | null, subtype?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type MetaProductsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
}>;


export type MetaProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type MetaProviderQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
}>;


export type MetaProviderQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type MetaProvidersQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
}>;


export type MetaProvidersQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type MetaFilterTaxonomyRulesQueryVariables = Exact<{
  where?: InputMaybe<FilterTaxonomyRuleWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
}>;


export type MetaFilterTaxonomyRulesQuery = { __typename?: 'Query', count?: number | null, filterTaxonomyRules: Array<{ __typename?: 'FilterTaxonomyRule', id: string, taxonomyBase: { __typename?: 'RouteResource', id: string }, taxonomyFilter: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } }> };

export type MetaFilterTaxonomyRuleNewFragmentFragment = { __typename?: 'FilterTaxonomyRule', id: string, taxonomyBase: { __typename?: 'RouteResource', id: string }, taxonomyFilter: { __typename?: 'RouteResource', id: string, content: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null }> } };

export type MetaTaxonomyItemQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
}>;


export type MetaTaxonomyItemQuery = { __typename?: 'Query', taxonomyItem?: { __typename?: 'TaxonomyItem', id?: string | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type MetaTaxonomyItemsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
}>;


export type MetaTaxonomyItemsQuery = { __typename?: 'Query', taxonomyItems: Array<{ __typename?: 'TaxonomyItem', id?: string | null, subtype?: string | null, parentId?: string | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type StringTemplatesQueryVariables = Exact<{
  where?: InputMaybe<StringTemplateWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
}>;


export type StringTemplatesQuery = { __typename?: 'Query', stringTemplates: Array<{ __typename?: 'StringTemplate', id: string, key: string, level: ContextType, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null }> };

export type UpsertStringTemplateMutationVariables = Exact<{
  where: StringTemplateWhereUniqueInput;
  data: StringTemplateUpsertDataInput;
  current: ResourceCurrentInput;
}>;


export type UpsertStringTemplateMutation = { __typename?: 'Mutation', upsertStringTemplate?: { __typename?: 'StringTemplate', id: string } | null };

export type DeleteNetworkMutationVariables = Exact<{
  where: NetworkWhereUniqueInput;
}>;


export type DeleteNetworkMutation = { __typename?: 'Mutation', deleteNetwork?: { __typename?: 'Network', id: string } | null };

export type NetworkQueryVariables = Exact<{
  where: NetworkWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
}>;


export type NetworkQuery = { __typename?: 'Query', network?: { __typename?: 'Network', id: string, companyId?: string | null, createdAt: any, updatedAt: any, company?: { __typename?: 'Company', id: string, name: string, slug: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type NetworkCrudFragmentFragment = { __typename?: 'Network', id: string, companyId?: string | null, createdAt: any, updatedAt: any, company?: { __typename?: 'Company', id: string, name: string, slug: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null };

export type UpsertNetworkMutationVariables = Exact<{
  where: NetworkWhereUniqueInput;
  data: NetworkUpsertDataInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
}>;


export type UpsertNetworkMutation = { __typename?: 'Mutation', upsertNetwork?: { __typename?: 'Network', id: string, companyId?: string | null, createdAt: any, updatedAt: any, company?: { __typename?: 'Company', id: string, name: string, slug: string } | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type DeletePageMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
}>;


export type DeletePageMutation = { __typename?: 'Mutation', deletePage?: { __typename?: 'Page', id?: string | null } | null };

export type PageQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical?: { __typename?: 'Vertical', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, field?: { __typename?: 'TemplateField', id: string, key: string, context: ContextType, type: FieldType } | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type PageCrudFragmentFragment = { __typename?: 'Page', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical?: { __typename?: 'Vertical', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, field?: { __typename?: 'TemplateField', id: string, key: string, context: ContextType, type: FieldType } | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null };

export type UpsertPageMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: PageUpsertDataInput;
  current: ResourceCurrentInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type UpsertPageMutation = { __typename?: 'Mutation', upsertPage?: { __typename?: 'Page', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical?: { __typename?: 'Vertical', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, field?: { __typename?: 'TemplateField', id: string, key: string, context: ContextType, type: FieldType } | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type DynamicListPagesQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput> | RouteResourceOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
  currentLanguageId: Scalars['String']['input'];
}>;


export type DynamicListPagesQuery = { __typename?: 'Query', count: number, pages: Array<{ __typename?: 'Page', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type DeletePostMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost?: { __typename?: 'Post', id?: string | null } | null };

export type PostQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type PostQuery = { __typename?: 'Query', post?: { __typename?: 'Post', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical?: { __typename?: 'Vertical', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, field?: { __typename?: 'TemplateField', id: string, key: string, context: ContextType, type: FieldType } | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type PostCrudFragmentFragment = { __typename?: 'Post', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical?: { __typename?: 'Vertical', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, field?: { __typename?: 'TemplateField', id: string, key: string, context: ContextType, type: FieldType } | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null };

export type UpsertPostMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: PostUpsertDataInput;
  current: ResourceCurrentInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type UpsertPostMutation = { __typename?: 'Mutation', upsertPost?: { __typename?: 'Post', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical?: { __typename?: 'Vertical', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, field?: { __typename?: 'TemplateField', id: string, key: string, context: ContextType, type: FieldType } | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type DynamicListPostsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput> | RouteResourceOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
  currentLanguageId: Scalars['String']['input'];
}>;


export type DynamicListPostsQuery = { __typename?: 'Query', count: number, posts: Array<{ __typename?: 'Post', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type DeleteProductMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct?: { __typename?: 'Product', id?: string | null } | null };

export type DeleteProductPoolMutationVariables = Exact<{
  where: ProductPoolWhereUniqueInput;
}>;


export type DeleteProductPoolMutation = { __typename?: 'Mutation', deleteProductPool?: { __typename?: 'ProductPool', id?: string | null } | null };

export type ProductQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'ProductPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null } | null };

export type ProductCrudFragmentFragment = { __typename?: 'Product', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'ProductPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null };

export type ProductPoolQueryVariables = Exact<{
  where: RouteResourcePoolWhereUniqueInput;
}>;


export type ProductPoolQuery = { __typename?: 'Query', productPool?: { __typename?: 'ProductPool', id?: string | null, name?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null, products?: Array<{ __typename?: 'Product', id?: string | null } | null> | null } | null };

export type DynamicListProductsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput> | RouteResourceOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
}>;


export type DynamicListProductsQuery = { __typename?: 'Query', count: number, products: Array<{ __typename?: 'Product', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'ProductPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null }> };

export type UpsertProductCrudMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: ProductUpsertDataInput;
  current: ResourceCurrentInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type UpsertProductCrudMutation = { __typename?: 'Mutation', upsertProduct?: { __typename?: 'Product', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'ProductPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null } | null };

export type UpsertProductPoolMutationVariables = Exact<{
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
  data: RouteResourcePoolUpsertDataInput;
}>;


export type UpsertProductPoolMutation = { __typename?: 'Mutation', upsertProductPool?: { __typename?: 'ProductPool', id?: string | null } | null };

export type ProviderOverviewQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type ProviderOverviewQuery = { __typename?: 'Query', count?: number | null, providers: Array<{ __typename?: 'Provider', id?: string | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type DeleteProviderMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
}>;


export type DeleteProviderMutation = { __typename?: 'Mutation', deleteProvider?: { __typename?: 'Provider', id?: string | null } | null };

export type DeleteProviderPoolMutationVariables = Exact<{
  where: ProviderPoolWhereUniqueInput;
}>;


export type DeleteProviderPoolMutation = { __typename?: 'Mutation', deleteProviderPool?: { __typename?: 'ProviderPool', id?: string | null } | null };

export type DeleteProviderTaxonomyConnectionMutationVariables = Exact<{
  where: ProviderTaxonomyConnectionWhereUniqueInput;
}>;


export type DeleteProviderTaxonomyConnectionMutation = { __typename?: 'Mutation', deleteProviderTaxonomyConnection?: { __typename?: 'ProviderTaxonomyConnection', id: string } | null };

export type ProviderCrudQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type ProviderCrudQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, pools?: Array<{ __typename?: 'ProviderPool', id?: string | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type ProviderCrudFragmentFragment = { __typename?: 'Provider', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, pools?: Array<{ __typename?: 'ProviderPool', id?: string | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null };

export type ProviderPoolQueryVariables = Exact<{
  where: RouteResourcePoolWhereUniqueInput;
}>;


export type ProviderPoolQuery = { __typename?: 'Query', providerPool?: { __typename?: 'ProviderPool', id?: string | null, name?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null, providers?: Array<{ __typename?: 'Provider', id?: string | null } | null> | null } | null };

export type ProviderTaxonomyConnectionsQueryVariables = Exact<{
  currentLanguageId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type ProviderTaxonomyConnectionsQuery = { __typename?: 'Query', providerTaxonomyConnections: Array<{ __typename?: 'ProviderTaxonomyConnection', id: string, taxonomyItemId: string, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type DynamicListProvidersQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput> | RouteResourceOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
}>;


export type DynamicListProvidersQuery = { __typename?: 'Query', count: number, providers: Array<{ __typename?: 'Provider', id?: string | null, createdAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'ProviderPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null }> };

export type UpsertProviderCrudMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: ProviderUpsertDataInput;
  current: ResourceCurrentInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type UpsertProviderCrudMutation = { __typename?: 'Mutation', upsertProvider?: { __typename?: 'Provider', id?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, pools?: Array<{ __typename?: 'ProviderPool', id?: string | null } | null> | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type UpsertProviderPoolMutationVariables = Exact<{
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
  data: RouteResourcePoolUpsertDataInput;
}>;


export type UpsertProviderPoolMutation = { __typename?: 'Mutation', upsertProviderPool?: { __typename?: 'ProviderPool', id?: string | null } | null };

export type UpsertProviderTaxonomyConnectionMutationVariables = Exact<{
  where: ProviderTaxonomyConnectionWhereUniqueInput;
  data: ProviderTaxonomyConnectionUpsertDataInput;
  current: ResourceCurrentInput;
}>;


export type UpsertProviderTaxonomyConnectionMutation = { __typename?: 'Mutation', upsertProviderTaxonomyConnection?: { __typename?: 'ProviderTaxonomyConnection', id: string, providerId: string, taxonomyItemId: string, network?: { __typename?: 'Network', id: string } | null } | null };

export type ProvidersStatusQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentQueryKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type ProvidersStatusQuery = { __typename?: 'Query', count?: number | null, providers: Array<{ __typename?: 'Provider', id?: string | null, createdAt?: any | null, updatedAt?: any | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null, contextId?: string | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type LogotypesQueryVariables = Exact<{
  where?: InputMaybe<MediaItemWhereInput>;
}>;


export type LogotypesQuery = { __typename?: 'Query', logo: Array<{ __typename?: 'MediaItem', id: string, url: string }> };

export type RankingPositionNetworkQueryVariables = Exact<{
  defaultLanguageId: Scalars['String']['input'];
}>;


export type RankingPositionNetworkQuery = { __typename?: 'Query', networks: Array<{ __typename?: 'Network', id: string, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type DeleteSiteMutationVariables = Exact<{
  where: SiteWhereUniqueInput;
}>;


export type DeleteSiteMutation = { __typename?: 'Mutation', deleteSite?: { __typename?: 'Site', id: string } | null };

export type SiteQueryVariables = Exact<{
  where: SiteWhereUniqueInput;
}>;


export type SiteQuery = { __typename?: 'Query', site?: { __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null } | null };

export type DynamicListSitesQueryVariables = Exact<{
  where?: InputMaybe<SiteWhereInput>;
  search?: InputMaybe<ResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<SiteOrderByWithRelationInput> | SiteOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
}>;


export type DynamicListSitesQuery = { __typename?: 'Query', count: number, sites: Array<{ __typename?: 'Site', id: string, createdAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null } }> };

export type SitesStatusQueryVariables = Exact<{
  where?: InputMaybe<SiteWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesStatusQuery = { __typename?: 'Query', count: number, sites: Array<{ __typename?: 'Site', id: string, url: string, createdAt: any, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null, language: { __typename?: 'Language', id: string, countryCode?: string | null, languageTag: string }, vertical: { __typename?: 'Vertical', id: string, network?: { __typename?: 'Network', id: string } | null } }> };

export type NewsTaxStatusQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
}>;


export type NewsTaxStatusQuery = { __typename?: 'Query', posts: Array<{ __typename?: 'Post', id?: string | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null, vertical?: { __typename?: 'Vertical', id: string } | null }> };

export type ProviderTaxStatusQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type ProviderTaxStatusQuery = { __typename?: 'Query', providers: Array<{ __typename?: 'Provider', id?: string | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type TaxonomyItemsStatusQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentQueryKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  defaultLanguageId: Scalars['String']['input'];
}>;


export type TaxonomyItemsStatusQuery = { __typename?: 'Query', taxonomyItems: Array<{ __typename?: 'TaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, parentId?: string | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }> };

export type UpsertPropertyItemMutationVariables = Exact<{
  fieldId?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
  contextId?: InputMaybe<Scalars['String']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertPropertyItemMutation = { __typename?: 'Mutation', upsertOnePropertyItemCustom?: { __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null };

export type DeleteTaxonomyItemMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
}>;


export type DeleteTaxonomyItemMutation = { __typename?: 'Mutation', deleteTaxonomyItem?: { __typename?: 'TaxonomyItem', id?: string | null } | null };

export type DeleteTaxonomyItemPoolMutationVariables = Exact<{
  where?: InputMaybe<TaxonomyItemPoolWhereUniqueInput>;
}>;


export type DeleteTaxonomyItemPoolMutation = { __typename?: 'Mutation', deleteTaxonomyItemPool?: { __typename?: 'TaxonomyItemPool', id?: string | null } | null };

export type TaxonomyItemCrudQueryVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type TaxonomyItemCrudQuery = { __typename?: 'Query', taxonomyItem?: { __typename?: 'TaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'TaxonomyItemPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null } | null };

export type TaxonomyItemCrudFragmentFragment = { __typename?: 'TaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'TaxonomyItemPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null };

export type TaxonomyItemPoolQueryVariables = Exact<{
  where: RouteResourcePoolWhereUniqueInput;
}>;


export type TaxonomyItemPoolQuery = { __typename?: 'Query', taxonomyItemPool?: { __typename?: 'TaxonomyItemPool', id?: string | null, name?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null, taxonomyItems?: Array<{ __typename?: 'TaxonomyItem', id?: string | null } | null> | null } | null };

export type DynamicListTaxonomyItemsQueryVariables = Exact<{
  where?: InputMaybe<RouteResourceWhereInput>;
  search?: InputMaybe<RouteResourceSearchWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  contentKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  propertyKeys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<RouteResourceOrderByWithRelationInput> | RouteResourceOrderByWithRelationInput>;
  filters?: InputMaybe<ResourceFiltersInput>;
  config?: InputMaybe<ResourceConfigInput>;
}>;


export type DynamicListTaxonomyItemsQuery = { __typename?: 'Query', count: number, taxonomyItems: Array<{ __typename?: 'TaxonomyItem', id?: string | null, parentId?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'TaxonomyItemPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null }> };

export type UpsertTaxonomyItemCrudMutationVariables = Exact<{
  where: RouteResourceWhereUniqueInput;
  data: TaxonomyItemUpsertDataInput;
  current: ResourceCurrentInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
  currentCompanyId: Scalars['String']['input'];
  currentVerticalId: Scalars['String']['input'];
}>;


export type UpsertTaxonomyItemCrudMutation = { __typename?: 'Mutation', upsertTaxonomyItem?: { __typename?: 'TaxonomyItem', id?: string | null, subtype?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, parent?: { __typename?: 'TaxonomyItem', id?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, pools?: Array<{ __typename?: 'TaxonomyItemPool', id?: string | null, networks?: Array<{ __typename?: 'Network', id: string } | null> | null } | null> | null } | null };

export type UpsertTaxonomyItemPoolMutationVariables = Exact<{
  where?: InputMaybe<RouteResourcePoolWhereUniqueInput>;
  data: RouteResourcePoolUpsertDataInput;
}>;


export type UpsertTaxonomyItemPoolMutation = { __typename?: 'Mutation', upsertTaxonomyItemPool?: { __typename?: 'TaxonomyItemPool', id?: string | null } | null };

export type TemplatesOverviewQueryVariables = Exact<{
  where: TemplateWhereInput;
}>;


export type TemplatesOverviewQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Template', id: string, createdAt: any, updatedAt: any, type: TemplateType, subtype?: string | null, network?: { __typename?: 'Network', id: string } | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, fields: Array<{ __typename?: 'TemplateField', id: string, required: boolean, index?: number | null, group?: string | null, key: string, type: FieldType, hidden: boolean, list: boolean, data?: any | null, generatePages: boolean, context: ContextType, resourceType: ResourceType, isDefaultField: boolean, defaultTranslationType: ContentItemTranslationType, displayType?: DisplayType | null, roles?: any | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null }>, groups: Array<{ __typename?: 'TemplateFieldGroup', id: string, name: string, index: number, extended: boolean, data?: any | null, generalGroup?: { __typename?: 'GeneralTemplateFieldGroup', id: string, name: string, index: number } | null }> }> };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  permissions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', user_id?: string | null, email?: string | null, name?: string | null, picture?: string | null, permissions?: Array<string | null> | null } | null };

export type DeleteVerticalMutationVariables = Exact<{
  where: VerticalWhereUniqueInput;
}>;


export type DeleteVerticalMutation = { __typename?: 'Mutation', deleteVertical?: { __typename?: 'Vertical', id: string } | null };

export type UpsertVerticalMutationVariables = Exact<{
  where: VerticalWhereUniqueInput;
  data: VerticalUpsertDataInput;
  current: VerticalCurrentInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
}>;


export type UpsertVerticalMutation = { __typename?: 'Mutation', upsertVertical?: { __typename?: 'Vertical', id: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, sites: Array<{ __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null }>, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type VerticalQueryVariables = Exact<{
  where: VerticalWhereUniqueInput;
  currentLanguageId: Scalars['String']['input'];
  defaultLanguageId: Scalars['String']['input'];
  currentNetworkId: Scalars['String']['input'];
}>;


export type VerticalQuery = { __typename?: 'Query', vertical?: { __typename?: 'Vertical', id: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, sites: Array<{ __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null }>, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null } | null };

export type VerticalCrudFragmentFragment = { __typename?: 'Vertical', id: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, network?: { __typename?: 'Network', id: string } | null, sites: Array<{ __typename?: 'Site', id: string, url: string, createdAt: any, updatedAt: any, createdBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, vertical: { __typename?: 'Vertical', id: string }, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, parent?: { __typename?: 'Site', id: string } | null }>, properties?: Array<{ __typename?: 'PropertyItem', id: string, type: FieldType, key: string, data?: any | null, list: boolean, contextId?: string | null, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null, resolvedData?: Array<{ __typename: 'MediaItem', id: string, name?: string | null, url: string } | { __typename: 'Product' } | { __typename: 'TaxonomyItem' } | null> | null } | null> | null, content?: Array<{ __typename?: 'ContentItemV2', id: string, key: string, translationType: ContentItemTranslationType, variant: number, contextId?: string | null, list: boolean, data?: any | null, status: StringItemStatus, createdAt: any, updatedAt: any, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null, name: string, shortName: string, shortNameEng?: string | null }, updatedBy?: { __typename?: 'User', user_id?: string | null, name?: string | null } | null } | null> | null };

export type SitesForRedirectsQueryVariables = Exact<{
  where?: InputMaybe<SiteWhereInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SitesForRedirectsQuery = { __typename?: 'Query', count?: number | null, sites: Array<{ __typename?: 'Site', id: string, url: string, properties?: Array<{ __typename?: 'PropertyItem', id: string, key: string, data?: any | null, createdAt: any, updatedAt: any } | null> | null, language: { __typename?: 'Language', id: string, languageCode: string, languageTag: string, countryCode?: string | null } }> };

export const CountryFragmentFragmentDoc = gql`
    fragment CountryFragment on Country {
  id
  name
  countryCode
}
    `;
export const CountryWithLanguagesFragmentFragmentDoc = gql`
    fragment CountryWithLanguagesFragment on Country {
  id
  name
  countryCode
  languages {
    id
    name
    languageCode
    shortNameEng
  }
}
    `;
export const PropertyItemFragmentFragmentDoc = gql`
    fragment PropertyItemFragment on PropertyItem {
  id
  type
  key
  data
  list
  contextId
  updatedAt
  createdAt
  updatedBy {
    user_id
    name
  }
  resolvedData {
    __typename
    ... on MediaItem {
      id
      name
      url
    }
  }
}
    `;
export const LanguageFragmentFragmentDoc = gql`
    fragment LanguageFragment on Language {
  id
  languageCode
  languageTag
  countryCode
  name
  shortName
  shortNameEng
}
    `;
export const ContentItemFragmentFragmentDoc = gql`
    fragment ContentItemFragment on ContentItemV2 {
  id
  key
  translationType
  variant
  contextId
  list
  language {
    ...LanguageFragment
  }
  data
  status
  createdAt
  updatedAt
  updatedBy {
    user_id
    name
  }
}
    ${LanguageFragmentFragmentDoc}`;
export const FilterTaxonomyRuleFragmentFragmentDoc = gql`
    fragment FilterTaxonomyRuleFragment on FilterTaxonomyRule {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
  network {
    id
  }
  taxonomyBase {
    id
    content {
      ...ContentItemFragment
    }
  }
  taxonomyFilter {
    id
    content {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const LanguageWithCountriesFragmentFragmentDoc = gql`
    fragment LanguageWithCountriesFragment on Language {
  id
  languageCode
  languageTag
  countryCode
  name
  shortName
  shortNameEng
  countries {
    id
    name
    countryCode
  }
}
    `;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  user_id
  email
  name
  picture
  permissions
}
    `;
export const MediaItemFragmentFragmentDoc = gql`
    fragment MediaItemFragment on MediaItem {
  id
  checksum
  metadata
  mimetype
  url
  name
  alt
  createdAt
  createdBy {
    ...UserFragment
  }
  network {
    id
  }
  tags {
    id
    name
  }
}
    ${UserFragmentFragmentDoc}`;
export const SiteFragmentFragmentDoc = gql`
    fragment SiteFragment on Site {
  id
  url
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  vertical {
    id
  }
  properties {
    ...PropertyItemFragment
  }
  content(where: {status: {in: [APPROVED, DRAFT]}}) {
    ...ContentItemFragment
  }
  language {
    ...LanguageFragment
  }
  parent {
    id
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}
${LanguageFragmentFragmentDoc}`;
export const VerticalFragmentFragmentDoc = gql`
    fragment VerticalFragment on Vertical {
  id
  network {
    id
  }
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  createdAt
  sites {
    ...SiteFragment
  }
  content {
    ...ContentItemFragment
  }
  properties {
    ...PropertyItemFragment
  }
}
    ${SiteFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}
${PropertyItemFragmentFragmentDoc}`;
export const MenuItemFragmentFragmentDoc = gql`
    fragment MenuItemFragment on MenuItem {
  id
  type
  index
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
  children {
    id
    type
    properties {
      ...PropertyItemFragment
    }
    content {
      ...ContentItemFragment
    }
  }
  parent {
    id
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const MenuFragmentFragmentDoc = gql`
    fragment MenuFragment on Menu {
  id
  key
  vertical {
    ...VerticalFragment
  }
  items {
    ...MenuItemFragment
  }
}
    ${VerticalFragmentFragmentDoc}
${MenuItemFragmentFragmentDoc}`;
export const NetworkFragmentFragmentDoc = gql`
    fragment NetworkFragment on Network {
  id
  companyId
  company {
    id
    name
    slug
  }
  createdAt
  updatedAt
  createdBy {
    ...UserFragment
  }
  verticals {
    ...VerticalFragment
  }
  content {
    ...ContentItemFragment
  }
  properties {
    ...PropertyItemFragment
  }
}
    ${UserFragmentFragmentDoc}
${VerticalFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}
${PropertyItemFragmentFragmentDoc}`;
export const PostStatusFragmentFragmentDoc = gql`
    fragment PostStatusFragment on Post {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
  vertical {
    id
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const ProviderFragmentFragmentDoc = gql`
    fragment ProviderFragment on Provider {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const TaxonomyItemFragmentFragmentDoc = gql`
    fragment TaxonomyItemFragment on TaxonomyItem {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  parent {
    id
  }
  properties {
    ...PropertyItemFragment
  }
  content {
    ...ContentItemFragment
  }
  network {
    id
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const AuthorCrudFragmentFragmentDoc = gql`
    fragment AuthorCrudFragment on Author {
  id
  resourceType
  createdAt
  createdBy {
    user_id
    name
  }
  updatedAt
  data
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
  ) {
    ...ContentItemFragment
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
}
    ${ContentItemFragmentFragmentDoc}
${PropertyItemFragmentFragmentDoc}`;
export const CompanyFragmentFragmentDoc = gql`
    fragment CompanyFragment on Company {
  id
  name
  slug
  createdAt
  updatedAt
  networks {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED]}}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;
export const FilterTaxonomyItemCrudFragmentFragmentDoc = gql`
    fragment FilterTaxonomyItemCrudFragment on FilterTaxonomyItem {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  network {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const MetaFilterTaxonomyRuleNewFragmentFragmentDoc = gql`
    fragment MetaFilterTaxonomyRuleNewFragment on FilterTaxonomyRule {
  id
  taxonomyBase {
    id
  }
  taxonomyFilter {
    id
    content(
      where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;
export const NetworkCrudFragmentFragmentDoc = gql`
    fragment NetworkCrudFragment on Network {
  id
  companyId
  company {
    id
    name
    slug
  }
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  properties {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const PageCrudFragmentFragmentDoc = gql`
    fragment PageCrudFragment on Page {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  vertical {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    id
    key
    translationType
    field {
      id
      key
      context
      type
    }
    ...ContentItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const PostCrudFragmentFragmentDoc = gql`
    fragment PostCrudFragment on Post {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  vertical {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    id
    key
    translationType
    field {
      id
      key
      context
      type
    }
    ...ContentItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const ProductCrudFragmentFragmentDoc = gql`
    fragment ProductCrudFragment on Product {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  network {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
  pools {
    id
    networks {
      id
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const ProviderCrudFragmentFragmentDoc = gql`
    fragment ProviderCrudFragment on Provider {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  pools {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const TaxonomyItemCrudFragmentFragmentDoc = gql`
    fragment TaxonomyItemCrudFragment on TaxonomyItem {
  id
  subtype
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  parent {
    id
  }
  network {
    id
  }
  properties(
    where: {contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
  ) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
  pools {
    id
    networks {
      id
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const VerticalCrudFragmentFragmentDoc = gql`
    fragment VerticalCrudFragment on Vertical {
  id
  createdAt
  updatedAt
  createdBy {
    user_id
    name
  }
  network {
    id
  }
  sites {
    ...SiteFragment
  }
  properties(where: {contextId: {equals: $currentNetworkId}}) {
    ...PropertyItemFragment
  }
  content(
    where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, contextId: {equals: $currentNetworkId}, status: {in: [APPROVED, DRAFT]}}
    orderBy: {status: asc}
  ) {
    ...ContentItemFragment
  }
}
    ${SiteFragmentFragmentDoc}
${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;
export const ShortcodePagesDocument = gql`
    query ShortcodePages($verticalId: String, $defaultLanguageId: String!) {
  pages(where: {verticalId: {equals: $verticalId}}) {
    id
    vertical {
      id
    }
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useShortcodePagesQuery__
 *
 * To run a query within a React component, call `useShortcodePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortcodePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortcodePagesQuery({
 *   variables: {
 *      verticalId: // value for 'verticalId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useShortcodePagesQuery(baseOptions: Apollo.QueryHookOptions<ShortcodePagesQuery, ShortcodePagesQueryVariables> & ({ variables: ShortcodePagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortcodePagesQuery, ShortcodePagesQueryVariables>(ShortcodePagesDocument, options);
      }
export function useShortcodePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortcodePagesQuery, ShortcodePagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortcodePagesQuery, ShortcodePagesQueryVariables>(ShortcodePagesDocument, options);
        }
export function useShortcodePagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShortcodePagesQuery, ShortcodePagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShortcodePagesQuery, ShortcodePagesQueryVariables>(ShortcodePagesDocument, options);
        }
export type ShortcodePagesQueryHookResult = ReturnType<typeof useShortcodePagesQuery>;
export type ShortcodePagesLazyQueryHookResult = ReturnType<typeof useShortcodePagesLazyQuery>;
export type ShortcodePagesSuspenseQueryHookResult = ReturnType<typeof useShortcodePagesSuspenseQuery>;
export type ShortcodePagesQueryResult = Apollo.QueryResult<ShortcodePagesQuery, ShortcodePagesQueryVariables>;
export const ShortcodePostsDocument = gql`
    query ShortcodePosts($verticalId: String, $defaultLanguageId: String!) {
  posts(where: {verticalId: {equals: $verticalId}}) {
    id
    vertical {
      id
    }
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useShortcodePostsQuery__
 *
 * To run a query within a React component, call `useShortcodePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortcodePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortcodePostsQuery({
 *   variables: {
 *      verticalId: // value for 'verticalId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useShortcodePostsQuery(baseOptions: Apollo.QueryHookOptions<ShortcodePostsQuery, ShortcodePostsQueryVariables> & ({ variables: ShortcodePostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortcodePostsQuery, ShortcodePostsQueryVariables>(ShortcodePostsDocument, options);
      }
export function useShortcodePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortcodePostsQuery, ShortcodePostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortcodePostsQuery, ShortcodePostsQueryVariables>(ShortcodePostsDocument, options);
        }
export function useShortcodePostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShortcodePostsQuery, ShortcodePostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShortcodePostsQuery, ShortcodePostsQueryVariables>(ShortcodePostsDocument, options);
        }
export type ShortcodePostsQueryHookResult = ReturnType<typeof useShortcodePostsQuery>;
export type ShortcodePostsLazyQueryHookResult = ReturnType<typeof useShortcodePostsLazyQuery>;
export type ShortcodePostsSuspenseQueryHookResult = ReturnType<typeof useShortcodePostsSuspenseQuery>;
export type ShortcodePostsQueryResult = Apollo.QueryResult<ShortcodePostsQuery, ShortcodePostsQueryVariables>;
export const ShortcodeProvidersDocument = gql`
    query ShortcodeProviders($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  providers(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "verticals"]}}) {
      id
      key
      data
      contextId
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useShortcodeProvidersQuery__
 *
 * To run a query within a React component, call `useShortcodeProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortcodeProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortcodeProvidersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useShortcodeProvidersQuery(baseOptions: Apollo.QueryHookOptions<ShortcodeProvidersQuery, ShortcodeProvidersQueryVariables> & ({ variables: ShortcodeProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortcodeProvidersQuery, ShortcodeProvidersQueryVariables>(ShortcodeProvidersDocument, options);
      }
export function useShortcodeProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShortcodeProvidersQuery, ShortcodeProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortcodeProvidersQuery, ShortcodeProvidersQueryVariables>(ShortcodeProvidersDocument, options);
        }
export function useShortcodeProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShortcodeProvidersQuery, ShortcodeProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShortcodeProvidersQuery, ShortcodeProvidersQueryVariables>(ShortcodeProvidersDocument, options);
        }
export type ShortcodeProvidersQueryHookResult = ReturnType<typeof useShortcodeProvidersQuery>;
export type ShortcodeProvidersLazyQueryHookResult = ReturnType<typeof useShortcodeProvidersLazyQuery>;
export type ShortcodeProvidersSuspenseQueryHookResult = ReturnType<typeof useShortcodeProvidersSuspenseQuery>;
export type ShortcodeProvidersQueryResult = Apollo.QueryResult<ShortcodeProvidersQuery, ShortcodeProvidersQueryVariables>;
export const DuplicatedPageDocument = gql`
    query DuplicatedPage($where: RouteResourceWhereInput) {
  pages(where: $where) {
    id
    vertical {
      id
    }
  }
}
    `;

/**
 * __useDuplicatedPageQuery__
 *
 * To run a query within a React component, call `useDuplicatedPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicatedPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicatedPageQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDuplicatedPageQuery(baseOptions?: Apollo.QueryHookOptions<DuplicatedPageQuery, DuplicatedPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicatedPageQuery, DuplicatedPageQueryVariables>(DuplicatedPageDocument, options);
      }
export function useDuplicatedPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicatedPageQuery, DuplicatedPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicatedPageQuery, DuplicatedPageQueryVariables>(DuplicatedPageDocument, options);
        }
export function useDuplicatedPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DuplicatedPageQuery, DuplicatedPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DuplicatedPageQuery, DuplicatedPageQueryVariables>(DuplicatedPageDocument, options);
        }
export type DuplicatedPageQueryHookResult = ReturnType<typeof useDuplicatedPageQuery>;
export type DuplicatedPageLazyQueryHookResult = ReturnType<typeof useDuplicatedPageLazyQuery>;
export type DuplicatedPageSuspenseQueryHookResult = ReturnType<typeof useDuplicatedPageSuspenseQuery>;
export type DuplicatedPageQueryResult = Apollo.QueryResult<DuplicatedPageQuery, DuplicatedPageQueryVariables>;
export const DuplicatedPostDocument = gql`
    query DuplicatedPost($where: RouteResourceWhereInput) {
  posts(where: $where) {
    id
    vertical {
      id
    }
  }
}
    `;

/**
 * __useDuplicatedPostQuery__
 *
 * To run a query within a React component, call `useDuplicatedPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicatedPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicatedPostQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDuplicatedPostQuery(baseOptions?: Apollo.QueryHookOptions<DuplicatedPostQuery, DuplicatedPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicatedPostQuery, DuplicatedPostQueryVariables>(DuplicatedPostDocument, options);
      }
export function useDuplicatedPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicatedPostQuery, DuplicatedPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicatedPostQuery, DuplicatedPostQueryVariables>(DuplicatedPostDocument, options);
        }
export function useDuplicatedPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DuplicatedPostQuery, DuplicatedPostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DuplicatedPostQuery, DuplicatedPostQueryVariables>(DuplicatedPostDocument, options);
        }
export type DuplicatedPostQueryHookResult = ReturnType<typeof useDuplicatedPostQuery>;
export type DuplicatedPostLazyQueryHookResult = ReturnType<typeof useDuplicatedPostLazyQuery>;
export type DuplicatedPostSuspenseQueryHookResult = ReturnType<typeof useDuplicatedPostSuspenseQuery>;
export type DuplicatedPostQueryResult = Apollo.QueryResult<DuplicatedPostQuery, DuplicatedPostQueryVariables>;
export const ProviderInputDataDocument = gql`
    query ProviderInputData($languageId: String!, $where: RouteResourceWhereInput) {
  providers(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useProviderInputDataQuery__
 *
 * To run a query within a React component, call `useProviderInputDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderInputDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderInputDataQuery({
 *   variables: {
 *      languageId: // value for 'languageId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProviderInputDataQuery(baseOptions: Apollo.QueryHookOptions<ProviderInputDataQuery, ProviderInputDataQueryVariables> & ({ variables: ProviderInputDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderInputDataQuery, ProviderInputDataQueryVariables>(ProviderInputDataDocument, options);
      }
export function useProviderInputDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderInputDataQuery, ProviderInputDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderInputDataQuery, ProviderInputDataQueryVariables>(ProviderInputDataDocument, options);
        }
export function useProviderInputDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderInputDataQuery, ProviderInputDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderInputDataQuery, ProviderInputDataQueryVariables>(ProviderInputDataDocument, options);
        }
export type ProviderInputDataQueryHookResult = ReturnType<typeof useProviderInputDataQuery>;
export type ProviderInputDataLazyQueryHookResult = ReturnType<typeof useProviderInputDataLazyQuery>;
export type ProviderInputDataSuspenseQueryHookResult = ReturnType<typeof useProviderInputDataSuspenseQuery>;
export type ProviderInputDataQueryResult = Apollo.QueryResult<ProviderInputDataQuery, ProviderInputDataQueryVariables>;
export const FilteredTaxonomyItemsInputDocument = gql`
    query FilteredTaxonomyItemsInput($where: RouteResourceWhereInput!, $defaultLanguageId: String!) {
  taxonomyItems(where: $where) {
    id
    parentId
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useFilteredTaxonomyItemsInputQuery__
 *
 * To run a query within a React component, call `useFilteredTaxonomyItemsInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTaxonomyItemsInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTaxonomyItemsInputQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useFilteredTaxonomyItemsInputQuery(baseOptions: Apollo.QueryHookOptions<FilteredTaxonomyItemsInputQuery, FilteredTaxonomyItemsInputQueryVariables> & ({ variables: FilteredTaxonomyItemsInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTaxonomyItemsInputQuery, FilteredTaxonomyItemsInputQueryVariables>(FilteredTaxonomyItemsInputDocument, options);
      }
export function useFilteredTaxonomyItemsInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTaxonomyItemsInputQuery, FilteredTaxonomyItemsInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTaxonomyItemsInputQuery, FilteredTaxonomyItemsInputQueryVariables>(FilteredTaxonomyItemsInputDocument, options);
        }
export function useFilteredTaxonomyItemsInputSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilteredTaxonomyItemsInputQuery, FilteredTaxonomyItemsInputQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilteredTaxonomyItemsInputQuery, FilteredTaxonomyItemsInputQueryVariables>(FilteredTaxonomyItemsInputDocument, options);
        }
export type FilteredTaxonomyItemsInputQueryHookResult = ReturnType<typeof useFilteredTaxonomyItemsInputQuery>;
export type FilteredTaxonomyItemsInputLazyQueryHookResult = ReturnType<typeof useFilteredTaxonomyItemsInputLazyQuery>;
export type FilteredTaxonomyItemsInputSuspenseQueryHookResult = ReturnType<typeof useFilteredTaxonomyItemsInputSuspenseQuery>;
export type FilteredTaxonomyItemsInputQueryResult = Apollo.QueryResult<FilteredTaxonomyItemsInputQuery, FilteredTaxonomyItemsInputQueryVariables>;
export const TaxonomyParentItemsInputDocument = gql`
    query TaxonomyParentItemsInput($where: RouteResourceWhereInput!, $defaultLanguageId: String!) {
  taxonomyItems(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useTaxonomyParentItemsInputQuery__
 *
 * To run a query within a React component, call `useTaxonomyParentItemsInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyParentItemsInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyParentItemsInputQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useTaxonomyParentItemsInputQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyParentItemsInputQuery, TaxonomyParentItemsInputQueryVariables> & ({ variables: TaxonomyParentItemsInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyParentItemsInputQuery, TaxonomyParentItemsInputQueryVariables>(TaxonomyParentItemsInputDocument, options);
      }
export function useTaxonomyParentItemsInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyParentItemsInputQuery, TaxonomyParentItemsInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyParentItemsInputQuery, TaxonomyParentItemsInputQueryVariables>(TaxonomyParentItemsInputDocument, options);
        }
export function useTaxonomyParentItemsInputSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxonomyParentItemsInputQuery, TaxonomyParentItemsInputQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxonomyParentItemsInputQuery, TaxonomyParentItemsInputQueryVariables>(TaxonomyParentItemsInputDocument, options);
        }
export type TaxonomyParentItemsInputQueryHookResult = ReturnType<typeof useTaxonomyParentItemsInputQuery>;
export type TaxonomyParentItemsInputLazyQueryHookResult = ReturnType<typeof useTaxonomyParentItemsInputLazyQuery>;
export type TaxonomyParentItemsInputSuspenseQueryHookResult = ReturnType<typeof useTaxonomyParentItemsInputSuspenseQuery>;
export type TaxonomyParentItemsInputQueryResult = Apollo.QueryResult<TaxonomyParentItemsInputQuery, TaxonomyParentItemsInputQueryVariables>;
export const DynamicFormInputPropertyResourceDocument = gql`
    query DynamicFormInputPropertyResource($languageId: String!, $taxonomyItemsWhere: RouteResourceWhereInput, $providersWhere: RouteResourceWhereInput) {
  providers(where: $providersWhere) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
  taxonomyItems(where: $taxonomyItemsWhere) {
    id
    parentId
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useDynamicFormInputPropertyResourceQuery__
 *
 * To run a query within a React component, call `useDynamicFormInputPropertyResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicFormInputPropertyResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicFormInputPropertyResourceQuery({
 *   variables: {
 *      languageId: // value for 'languageId'
 *      taxonomyItemsWhere: // value for 'taxonomyItemsWhere'
 *      providersWhere: // value for 'providersWhere'
 *   },
 * });
 */
export function useDynamicFormInputPropertyResourceQuery(baseOptions: Apollo.QueryHookOptions<DynamicFormInputPropertyResourceQuery, DynamicFormInputPropertyResourceQueryVariables> & ({ variables: DynamicFormInputPropertyResourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicFormInputPropertyResourceQuery, DynamicFormInputPropertyResourceQueryVariables>(DynamicFormInputPropertyResourceDocument, options);
      }
export function useDynamicFormInputPropertyResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicFormInputPropertyResourceQuery, DynamicFormInputPropertyResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicFormInputPropertyResourceQuery, DynamicFormInputPropertyResourceQueryVariables>(DynamicFormInputPropertyResourceDocument, options);
        }
export function useDynamicFormInputPropertyResourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicFormInputPropertyResourceQuery, DynamicFormInputPropertyResourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicFormInputPropertyResourceQuery, DynamicFormInputPropertyResourceQueryVariables>(DynamicFormInputPropertyResourceDocument, options);
        }
export type DynamicFormInputPropertyResourceQueryHookResult = ReturnType<typeof useDynamicFormInputPropertyResourceQuery>;
export type DynamicFormInputPropertyResourceLazyQueryHookResult = ReturnType<typeof useDynamicFormInputPropertyResourceLazyQuery>;
export type DynamicFormInputPropertyResourceSuspenseQueryHookResult = ReturnType<typeof useDynamicFormInputPropertyResourceSuspenseQuery>;
export type DynamicFormInputPropertyResourceQueryResult = Apollo.QueryResult<DynamicFormInputPropertyResourceQuery, DynamicFormInputPropertyResourceQueryVariables>;
export const PropertyItemsDocument = gql`
    query PropertyItems($where: PropertyItemWhereInput) {
  propertyItems(where: $where) {
    ...PropertyItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}`;

/**
 * __usePropertyItemsQuery__
 *
 * To run a query within a React component, call `usePropertyItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePropertyItemsQuery(baseOptions?: Apollo.QueryHookOptions<PropertyItemsQuery, PropertyItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyItemsQuery, PropertyItemsQueryVariables>(PropertyItemsDocument, options);
      }
export function usePropertyItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyItemsQuery, PropertyItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyItemsQuery, PropertyItemsQueryVariables>(PropertyItemsDocument, options);
        }
export function usePropertyItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PropertyItemsQuery, PropertyItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PropertyItemsQuery, PropertyItemsQueryVariables>(PropertyItemsDocument, options);
        }
export type PropertyItemsQueryHookResult = ReturnType<typeof usePropertyItemsQuery>;
export type PropertyItemsLazyQueryHookResult = ReturnType<typeof usePropertyItemsLazyQuery>;
export type PropertyItemsSuspenseQueryHookResult = ReturnType<typeof usePropertyItemsSuspenseQuery>;
export type PropertyItemsQueryResult = Apollo.QueryResult<PropertyItemsQuery, PropertyItemsQueryVariables>;
export const GroupTaxonomyItemsDocument = gql`
    query GroupTaxonomyItems($languageId: String!, $where: RouteResourceWhereInput) {
  taxonomyItems(where: $where) {
    id
    parentId
    subtype
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "icon"]}}) {
      id
      key
      data
      resolvedData {
        ... on MediaItem {
          url
        }
      }
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useGroupTaxonomyItemsQuery__
 *
 * To run a query within a React component, call `useGroupTaxonomyItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupTaxonomyItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupTaxonomyItemsQuery({
 *   variables: {
 *      languageId: // value for 'languageId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGroupTaxonomyItemsQuery(baseOptions: Apollo.QueryHookOptions<GroupTaxonomyItemsQuery, GroupTaxonomyItemsQueryVariables> & ({ variables: GroupTaxonomyItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupTaxonomyItemsQuery, GroupTaxonomyItemsQueryVariables>(GroupTaxonomyItemsDocument, options);
      }
export function useGroupTaxonomyItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupTaxonomyItemsQuery, GroupTaxonomyItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupTaxonomyItemsQuery, GroupTaxonomyItemsQueryVariables>(GroupTaxonomyItemsDocument, options);
        }
export function useGroupTaxonomyItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupTaxonomyItemsQuery, GroupTaxonomyItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupTaxonomyItemsQuery, GroupTaxonomyItemsQueryVariables>(GroupTaxonomyItemsDocument, options);
        }
export type GroupTaxonomyItemsQueryHookResult = ReturnType<typeof useGroupTaxonomyItemsQuery>;
export type GroupTaxonomyItemsLazyQueryHookResult = ReturnType<typeof useGroupTaxonomyItemsLazyQuery>;
export type GroupTaxonomyItemsSuspenseQueryHookResult = ReturnType<typeof useGroupTaxonomyItemsSuspenseQuery>;
export type GroupTaxonomyItemsQueryResult = Apollo.QueryResult<GroupTaxonomyItemsQuery, GroupTaxonomyItemsQueryVariables>;
export const PillarSectionsDocument = gql`
    query PillarSections($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  pages(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "parent"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __usePillarSectionsQuery__
 *
 * To run a query within a React component, call `usePillarSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePillarSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePillarSectionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function usePillarSectionsQuery(baseOptions: Apollo.QueryHookOptions<PillarSectionsQuery, PillarSectionsQueryVariables> & ({ variables: PillarSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PillarSectionsQuery, PillarSectionsQueryVariables>(PillarSectionsDocument, options);
      }
export function usePillarSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PillarSectionsQuery, PillarSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PillarSectionsQuery, PillarSectionsQueryVariables>(PillarSectionsDocument, options);
        }
export function usePillarSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PillarSectionsQuery, PillarSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PillarSectionsQuery, PillarSectionsQueryVariables>(PillarSectionsDocument, options);
        }
export type PillarSectionsQueryHookResult = ReturnType<typeof usePillarSectionsQuery>;
export type PillarSectionsLazyQueryHookResult = ReturnType<typeof usePillarSectionsLazyQuery>;
export type PillarSectionsSuspenseQueryHookResult = ReturnType<typeof usePillarSectionsSuspenseQuery>;
export type PillarSectionsQueryResult = Apollo.QueryResult<PillarSectionsQuery, PillarSectionsQueryVariables>;
export const NetworksVerticalsSitesDocument = gql`
    query NetworksVerticalsSites($defaultLanguageId: String!) {
  networks {
    id
    verticals {
      id
      content(
        where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
      sites {
        id
        url
      }
    }
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
  countries {
    id
    name
    countryCode
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useNetworksVerticalsSitesQuery__
 *
 * To run a query within a React component, call `useNetworksVerticalsSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworksVerticalsSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworksVerticalsSitesQuery({
 *   variables: {
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useNetworksVerticalsSitesQuery(baseOptions: Apollo.QueryHookOptions<NetworksVerticalsSitesQuery, NetworksVerticalsSitesQueryVariables> & ({ variables: NetworksVerticalsSitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworksVerticalsSitesQuery, NetworksVerticalsSitesQueryVariables>(NetworksVerticalsSitesDocument, options);
      }
export function useNetworksVerticalsSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworksVerticalsSitesQuery, NetworksVerticalsSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworksVerticalsSitesQuery, NetworksVerticalsSitesQueryVariables>(NetworksVerticalsSitesDocument, options);
        }
export function useNetworksVerticalsSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworksVerticalsSitesQuery, NetworksVerticalsSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworksVerticalsSitesQuery, NetworksVerticalsSitesQueryVariables>(NetworksVerticalsSitesDocument, options);
        }
export type NetworksVerticalsSitesQueryHookResult = ReturnType<typeof useNetworksVerticalsSitesQuery>;
export type NetworksVerticalsSitesLazyQueryHookResult = ReturnType<typeof useNetworksVerticalsSitesLazyQuery>;
export type NetworksVerticalsSitesSuspenseQueryHookResult = ReturnType<typeof useNetworksVerticalsSitesSuspenseQuery>;
export type NetworksVerticalsSitesQueryResult = Apollo.QueryResult<NetworksVerticalsSitesQuery, NetworksVerticalsSitesQueryVariables>;
export const CreateTranslationJobDocument = gql`
    mutation CreateTranslationJob($jobs: [TranslationJobData!]!) {
  createTranslationJobs(jobs: $jobs) {
    id
    data
    timestamp
  }
}
    `;
export type CreateTranslationJobMutationFn = Apollo.MutationFunction<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>;

/**
 * __useCreateTranslationJobMutation__
 *
 * To run a mutation, you first call `useCreateTranslationJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTranslationJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTranslationJobMutation, { data, loading, error }] = useCreateTranslationJobMutation({
 *   variables: {
 *      jobs: // value for 'jobs'
 *   },
 * });
 */
export function useCreateTranslationJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>(CreateTranslationJobDocument, options);
      }
export type CreateTranslationJobMutationHookResult = ReturnType<typeof useCreateTranslationJobMutation>;
export type CreateTranslationJobMutationResult = Apollo.MutationResult<CreateTranslationJobMutation>;
export type CreateTranslationJobMutationOptions = Apollo.BaseMutationOptions<CreateTranslationJobMutation, CreateTranslationJobMutationVariables>;
export const SitesForLocalizationDocument = gql`
    query SitesForLocalization($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    properties(where: {key: {in: ["country", "global", "language"]}}) {
      id
      key
      data
    }
  }
  count: siteCount(where: $where)
}
    `;

/**
 * __useSitesForLocalizationQuery__
 *
 * To run a query within a React component, call `useSitesForLocalizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesForLocalizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesForLocalizationQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSitesForLocalizationQuery(baseOptions?: Apollo.QueryHookOptions<SitesForLocalizationQuery, SitesForLocalizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesForLocalizationQuery, SitesForLocalizationQueryVariables>(SitesForLocalizationDocument, options);
      }
export function useSitesForLocalizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesForLocalizationQuery, SitesForLocalizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesForLocalizationQuery, SitesForLocalizationQueryVariables>(SitesForLocalizationDocument, options);
        }
export function useSitesForLocalizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitesForLocalizationQuery, SitesForLocalizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesForLocalizationQuery, SitesForLocalizationQueryVariables>(SitesForLocalizationDocument, options);
        }
export type SitesForLocalizationQueryHookResult = ReturnType<typeof useSitesForLocalizationQuery>;
export type SitesForLocalizationLazyQueryHookResult = ReturnType<typeof useSitesForLocalizationLazyQuery>;
export type SitesForLocalizationSuspenseQueryHookResult = ReturnType<typeof useSitesForLocalizationSuspenseQuery>;
export type SitesForLocalizationQueryResult = Apollo.QueryResult<SitesForLocalizationQuery, SitesForLocalizationQueryVariables>;
export const DeleteContentItemDocument = gql`
    mutation DeleteContentItem($where: ContentItemWhereUniqueInput!) {
  deleteContentItem(where: $where) {
    id
  }
}
    `;
export type DeleteContentItemMutationFn = Apollo.MutationFunction<DeleteContentItemMutation, DeleteContentItemMutationVariables>;

/**
 * __useDeleteContentItemMutation__
 *
 * To run a mutation, you first call `useDeleteContentItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentItemMutation, { data, loading, error }] = useDeleteContentItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteContentItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentItemMutation, DeleteContentItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentItemMutation, DeleteContentItemMutationVariables>(DeleteContentItemDocument, options);
      }
export type DeleteContentItemMutationHookResult = ReturnType<typeof useDeleteContentItemMutation>;
export type DeleteContentItemMutationResult = Apollo.MutationResult<DeleteContentItemMutation>;
export type DeleteContentItemMutationOptions = Apollo.BaseMutationOptions<DeleteContentItemMutation, DeleteContentItemMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($where: MediaItemWhereUniqueInput) {
  deleteFile(where: $where) {
    id
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const UploadFileDocument = gql`
    mutation UploadFile($file: Upload!, $networkId: String!) {
  uploadFile(file: $file, networkId: $networkId) {
    ...MediaItemFragment
  }
}
    ${MediaItemFragmentFragmentDoc}`;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const UploadFileWithCloudinaryWidgetDocument = gql`
    mutation UploadFileWithCloudinaryWidget($networkId: String, $cloudinaryFileObject: CloudinaryFileInput!) {
  uploadFileWithCloudinaryWidget(
    networkId: $networkId
    cloudinaryFileObject: $cloudinaryFileObject
  ) {
    ...MediaItemFragment
  }
}
    ${MediaItemFragmentFragmentDoc}`;
export type UploadFileWithCloudinaryWidgetMutationFn = Apollo.MutationFunction<UploadFileWithCloudinaryWidgetMutation, UploadFileWithCloudinaryWidgetMutationVariables>;

/**
 * __useUploadFileWithCloudinaryWidgetMutation__
 *
 * To run a mutation, you first call `useUploadFileWithCloudinaryWidgetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileWithCloudinaryWidgetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileWithCloudinaryWidgetMutation, { data, loading, error }] = useUploadFileWithCloudinaryWidgetMutation({
 *   variables: {
 *      networkId: // value for 'networkId'
 *      cloudinaryFileObject: // value for 'cloudinaryFileObject'
 *   },
 * });
 */
export function useUploadFileWithCloudinaryWidgetMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileWithCloudinaryWidgetMutation, UploadFileWithCloudinaryWidgetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileWithCloudinaryWidgetMutation, UploadFileWithCloudinaryWidgetMutationVariables>(UploadFileWithCloudinaryWidgetDocument, options);
      }
export type UploadFileWithCloudinaryWidgetMutationHookResult = ReturnType<typeof useUploadFileWithCloudinaryWidgetMutation>;
export type UploadFileWithCloudinaryWidgetMutationResult = Apollo.MutationResult<UploadFileWithCloudinaryWidgetMutation>;
export type UploadFileWithCloudinaryWidgetMutationOptions = Apollo.BaseMutationOptions<UploadFileWithCloudinaryWidgetMutation, UploadFileWithCloudinaryWidgetMutationVariables>;
export const UploadFileWithUrlDocument = gql`
    mutation UploadFileWithURL($url: String!, $networkId: String!, $tags: [String]) {
  uploadFileWithURL(url: $url, networkId: $networkId, tags: $tags) {
    ...MediaItemFragment
  }
}
    ${MediaItemFragmentFragmentDoc}`;
export type UploadFileWithUrlMutationFn = Apollo.MutationFunction<UploadFileWithUrlMutation, UploadFileWithUrlMutationVariables>;

/**
 * __useUploadFileWithUrlMutation__
 *
 * To run a mutation, you first call `useUploadFileWithUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileWithUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileWithUrlMutation, { data, loading, error }] = useUploadFileWithUrlMutation({
 *   variables: {
 *      url: // value for 'url'
 *      networkId: // value for 'networkId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadFileWithUrlMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileWithUrlMutation, UploadFileWithUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileWithUrlMutation, UploadFileWithUrlMutationVariables>(UploadFileWithUrlDocument, options);
      }
export type UploadFileWithUrlMutationHookResult = ReturnType<typeof useUploadFileWithUrlMutation>;
export type UploadFileWithUrlMutationResult = Apollo.MutationResult<UploadFileWithUrlMutation>;
export type UploadFileWithUrlMutationOptions = Apollo.BaseMutationOptions<UploadFileWithUrlMutation, UploadFileWithUrlMutationVariables>;
export const UploadImageDocument = gql`
    mutation UploadImage($file: Upload!, $networkId: String!) {
  uploadFile(file: $file, networkId: $networkId) {
    url
  }
}
    `;
export type UploadImageMutationFn = Apollo.MutationFunction<UploadImageMutation, UploadImageMutationVariables>;

/**
 * __useUploadImageMutation__
 *
 * To run a mutation, you first call `useUploadImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageMutation, { data, loading, error }] = useUploadImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useUploadImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageMutation, UploadImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageMutation, UploadImageMutationVariables>(UploadImageDocument, options);
      }
export type UploadImageMutationHookResult = ReturnType<typeof useUploadImageMutation>;
export type UploadImageMutationResult = Apollo.MutationResult<UploadImageMutation>;
export type UploadImageMutationOptions = Apollo.BaseMutationOptions<UploadImageMutation, UploadImageMutationVariables>;
export const CreateRedirectDocument = gql`
    mutation CreateRedirect($data: RedirectCreateInput!) {
  createRedirect(data: $data) {
    id
    httpCode
    scope
    sourceKind
    sourcePath
    sourceUrl
    sourceResourceType
    sourceResourceId
    sourceSiteId
    sourceVerticalId
    sourceNetworkId
    targetKind
    targetPath
    targetUrl
    targetResourceType
    targetResourceId
    targetSiteId
    targetVerticalId
    targetNetworkId
    createdAt
    updatedAt
    createdBy {
      user_id
      email
    }
  }
}
    `;
export type CreateRedirectMutationFn = Apollo.MutationFunction<CreateRedirectMutation, CreateRedirectMutationVariables>;

/**
 * __useCreateRedirectMutation__
 *
 * To run a mutation, you first call `useCreateRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRedirectMutation, { data, loading, error }] = useCreateRedirectMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRedirectMutation(baseOptions?: Apollo.MutationHookOptions<CreateRedirectMutation, CreateRedirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRedirectMutation, CreateRedirectMutationVariables>(CreateRedirectDocument, options);
      }
export type CreateRedirectMutationHookResult = ReturnType<typeof useCreateRedirectMutation>;
export type CreateRedirectMutationResult = Apollo.MutationResult<CreateRedirectMutation>;
export type CreateRedirectMutationOptions = Apollo.BaseMutationOptions<CreateRedirectMutation, CreateRedirectMutationVariables>;
export const DeleteRedirectDocument = gql`
    mutation DeleteRedirect($where: RedirectWhereUniqueInput!) {
  deleteRedirect(where: $where) {
    id
  }
}
    `;
export type DeleteRedirectMutationFn = Apollo.MutationFunction<DeleteRedirectMutation, DeleteRedirectMutationVariables>;

/**
 * __useDeleteRedirectMutation__
 *
 * To run a mutation, you first call `useDeleteRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRedirectMutation, { data, loading, error }] = useDeleteRedirectMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteRedirectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRedirectMutation, DeleteRedirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRedirectMutation, DeleteRedirectMutationVariables>(DeleteRedirectDocument, options);
      }
export type DeleteRedirectMutationHookResult = ReturnType<typeof useDeleteRedirectMutation>;
export type DeleteRedirectMutationResult = Apollo.MutationResult<DeleteRedirectMutation>;
export type DeleteRedirectMutationOptions = Apollo.BaseMutationOptions<DeleteRedirectMutation, DeleteRedirectMutationVariables>;
export const UpsertRedirectDocument = gql`
    mutation UpsertRedirect($where: RedirectWhereUniqueInput!, $create: RedirectCreateInput!, $update: RedirectUpdateInput!) {
  upsertRedirect(where: $where, create: $create, update: $update) {
    id
    httpCode
    scope
    sourceKind
    sourcePath
    sourceUrl
    sourceResourceType
    sourceResourceId
    sourceSiteId
    sourceVerticalId
    sourceNetworkId
    targetKind
    targetPath
    targetUrl
    targetResourceType
    targetResourceId
    targetSiteId
    targetVerticalId
    targetNetworkId
    createdAt
    updatedAt
    createdBy {
      user_id
      email
    }
  }
}
    `;
export type UpsertRedirectMutationFn = Apollo.MutationFunction<UpsertRedirectMutation, UpsertRedirectMutationVariables>;

/**
 * __useUpsertRedirectMutation__
 *
 * To run a mutation, you first call `useUpsertRedirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRedirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRedirectMutation, { data, loading, error }] = useUpsertRedirectMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpsertRedirectMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRedirectMutation, UpsertRedirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRedirectMutation, UpsertRedirectMutationVariables>(UpsertRedirectDocument, options);
      }
export type UpsertRedirectMutationHookResult = ReturnType<typeof useUpsertRedirectMutation>;
export type UpsertRedirectMutationResult = Apollo.MutationResult<UpsertRedirectMutation>;
export type UpsertRedirectMutationOptions = Apollo.BaseMutationOptions<UpsertRedirectMutation, UpsertRedirectMutationVariables>;
export const UpsertProductDocument = gql`
    mutation UpsertProduct($where: RouteResourceWhereUniqueInput!, $data: ProductUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertProduct(where: $where, data: $data, current: $current) {
    ...ProductFragment
  }
}
    ${ProductFragmentFragmentDoc}`;
export type UpsertProductMutationFn = Apollo.MutationFunction<UpsertProductMutation, UpsertProductMutationVariables>;

/**
 * __useUpsertProductMutation__
 *
 * To run a mutation, you first call `useUpsertProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProductMutation, { data, loading, error }] = useUpsertProductMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useUpsertProductMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProductMutation, UpsertProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProductMutation, UpsertProductMutationVariables>(UpsertProductDocument, options);
      }
export type UpsertProductMutationHookResult = ReturnType<typeof useUpsertProductMutation>;
export type UpsertProductMutationResult = Apollo.MutationResult<UpsertProductMutation>;
export type UpsertProductMutationOptions = Apollo.BaseMutationOptions<UpsertProductMutation, UpsertProductMutationVariables>;
export const UpsertProviderDocument = gql`
    mutation UpsertProvider($where: RouteResourceWhereUniqueInput!, $data: ProviderUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertProvider(where: $where, data: $data, current: $current) {
    id
  }
}
    `;
export type UpsertProviderMutationFn = Apollo.MutationFunction<UpsertProviderMutation, UpsertProviderMutationVariables>;

/**
 * __useUpsertProviderMutation__
 *
 * To run a mutation, you first call `useUpsertProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProviderMutation, { data, loading, error }] = useUpsertProviderMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useUpsertProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProviderMutation, UpsertProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProviderMutation, UpsertProviderMutationVariables>(UpsertProviderDocument, options);
      }
export type UpsertProviderMutationHookResult = ReturnType<typeof useUpsertProviderMutation>;
export type UpsertProviderMutationResult = Apollo.MutationResult<UpsertProviderMutation>;
export type UpsertProviderMutationOptions = Apollo.BaseMutationOptions<UpsertProviderMutation, UpsertProviderMutationVariables>;
export const UpsertTaxonomyItemDocument = gql`
    mutation UpsertTaxonomyItem($where: RouteResourceWhereUniqueInput!, $data: TaxonomyItemUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertTaxonomyItem(where: $where, data: $data, current: $current) {
    ...TaxonomyItemFragment
  }
}
    ${TaxonomyItemFragmentFragmentDoc}`;
export type UpsertTaxonomyItemMutationFn = Apollo.MutationFunction<UpsertTaxonomyItemMutation, UpsertTaxonomyItemMutationVariables>;

/**
 * __useUpsertTaxonomyItemMutation__
 *
 * To run a mutation, you first call `useUpsertTaxonomyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTaxonomyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTaxonomyItemMutation, { data, loading, error }] = useUpsertTaxonomyItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useUpsertTaxonomyItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTaxonomyItemMutation, UpsertTaxonomyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTaxonomyItemMutation, UpsertTaxonomyItemMutationVariables>(UpsertTaxonomyItemDocument, options);
      }
export type UpsertTaxonomyItemMutationHookResult = ReturnType<typeof useUpsertTaxonomyItemMutation>;
export type UpsertTaxonomyItemMutationResult = Apollo.MutationResult<UpsertTaxonomyItemMutation>;
export type UpsertTaxonomyItemMutationOptions = Apollo.BaseMutationOptions<UpsertTaxonomyItemMutation, UpsertTaxonomyItemMutationVariables>;
export const UpsertPostStatusDocument = gql`
    mutation UpsertPostStatus($where: RouteResourceWhereUniqueInput!, $data: PostUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertPost(where: $where, data: $data, current: $current) {
    ...PostStatusFragment
  }
}
    ${PostStatusFragmentFragmentDoc}`;
export type UpsertPostStatusMutationFn = Apollo.MutationFunction<UpsertPostStatusMutation, UpsertPostStatusMutationVariables>;

/**
 * __useUpsertPostStatusMutation__
 *
 * To run a mutation, you first call `useUpsertPostStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPostStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPostStatusMutation, { data, loading, error }] = useUpsertPostStatusMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useUpsertPostStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPostStatusMutation, UpsertPostStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPostStatusMutation, UpsertPostStatusMutationVariables>(UpsertPostStatusDocument, options);
      }
export type UpsertPostStatusMutationHookResult = ReturnType<typeof useUpsertPostStatusMutation>;
export type UpsertPostStatusMutationResult = Apollo.MutationResult<UpsertPostStatusMutation>;
export type UpsertPostStatusMutationOptions = Apollo.BaseMutationOptions<UpsertPostStatusMutation, UpsertPostStatusMutationVariables>;
export const UpsertSiteDocument = gql`
    mutation UpsertSite($where: SiteWhereUniqueInput!, $data: SiteUpsertDataInput!, $current: SiteCurrentInput!) {
  upsertSite(where: $where, data: $data, current: $current) {
    ...SiteFragment
  }
}
    ${SiteFragmentFragmentDoc}`;
export type UpsertSiteMutationFn = Apollo.MutationFunction<UpsertSiteMutation, UpsertSiteMutationVariables>;

/**
 * __useUpsertSiteMutation__
 *
 * To run a mutation, you first call `useUpsertSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSiteMutation, { data, loading, error }] = useUpsertSiteMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useUpsertSiteMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSiteMutation, UpsertSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSiteMutation, UpsertSiteMutationVariables>(UpsertSiteDocument, options);
      }
export type UpsertSiteMutationHookResult = ReturnType<typeof useUpsertSiteMutation>;
export type UpsertSiteMutationResult = Apollo.MutationResult<UpsertSiteMutation>;
export type UpsertSiteMutationOptions = Apollo.BaseMutationOptions<UpsertSiteMutation, UpsertSiteMutationVariables>;
export const UpdateMediaItemDocument = gql`
    mutation UpdateMediaItem($where: MediaItemWhereUniqueInput!, $data: MediaItemUpdateInput!) {
  updateMediaItem(where: $where, data: $data) {
    id
  }
}
    `;
export type UpdateMediaItemMutationFn = Apollo.MutationFunction<UpdateMediaItemMutation, UpdateMediaItemMutationVariables>;

/**
 * __useUpdateMediaItemMutation__
 *
 * To run a mutation, you first call `useUpdateMediaItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaItemMutation, { data, loading, error }] = useUpdateMediaItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateMediaItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaItemMutation, UpdateMediaItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaItemMutation, UpdateMediaItemMutationVariables>(UpdateMediaItemDocument, options);
      }
export type UpdateMediaItemMutationHookResult = ReturnType<typeof useUpdateMediaItemMutation>;
export type UpdateMediaItemMutationResult = Apollo.MutationResult<UpdateMediaItemMutation>;
export type UpdateMediaItemMutationOptions = Apollo.BaseMutationOptions<UpdateMediaItemMutation, UpdateMediaItemMutationVariables>;
export const AllTaxonomyItemsDocument = gql`
    query AllTaxonomyItems($where: RouteResourceWhereInput, $languageId: String!) {
  taxonomyItems(where: $where) {
    id
    parentId
    subtype
    content(
      where: {key: {equals: "name"}, languageId: {equals: $languageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "icon", "verticals"]}}) {
      id
      key
      data
      contextId
      resolvedData {
        ... on MediaItem {
          url
        }
      }
    }
    pools {
      id
      networks {
        id
      }
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useAllTaxonomyItemsQuery__
 *
 * To run a query within a React component, call `useAllTaxonomyItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTaxonomyItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTaxonomyItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      languageId: // value for 'languageId'
 *   },
 * });
 */
export function useAllTaxonomyItemsQuery(baseOptions: Apollo.QueryHookOptions<AllTaxonomyItemsQuery, AllTaxonomyItemsQueryVariables> & ({ variables: AllTaxonomyItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTaxonomyItemsQuery, AllTaxonomyItemsQueryVariables>(AllTaxonomyItemsDocument, options);
      }
export function useAllTaxonomyItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTaxonomyItemsQuery, AllTaxonomyItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTaxonomyItemsQuery, AllTaxonomyItemsQueryVariables>(AllTaxonomyItemsDocument, options);
        }
export function useAllTaxonomyItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTaxonomyItemsQuery, AllTaxonomyItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTaxonomyItemsQuery, AllTaxonomyItemsQueryVariables>(AllTaxonomyItemsDocument, options);
        }
export type AllTaxonomyItemsQueryHookResult = ReturnType<typeof useAllTaxonomyItemsQuery>;
export type AllTaxonomyItemsLazyQueryHookResult = ReturnType<typeof useAllTaxonomyItemsLazyQuery>;
export type AllTaxonomyItemsSuspenseQueryHookResult = ReturnType<typeof useAllTaxonomyItemsSuspenseQuery>;
export type AllTaxonomyItemsQueryResult = Apollo.QueryResult<AllTaxonomyItemsQuery, AllTaxonomyItemsQueryVariables>;
export const AllTemplatesDocument = gql`
    query AllTemplates($where: TemplateWhereInput!) {
  templates(where: $where) {
    id
    type
    subtype
    network {
      id
    }
    content {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useAllTemplatesQuery__
 *
 * To run a query within a React component, call `useAllTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAllTemplatesQuery(baseOptions: Apollo.QueryHookOptions<AllTemplatesQuery, AllTemplatesQueryVariables> & ({ variables: AllTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTemplatesQuery, AllTemplatesQueryVariables>(AllTemplatesDocument, options);
      }
export function useAllTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTemplatesQuery, AllTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTemplatesQuery, AllTemplatesQueryVariables>(AllTemplatesDocument, options);
        }
export function useAllTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTemplatesQuery, AllTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTemplatesQuery, AllTemplatesQueryVariables>(AllTemplatesDocument, options);
        }
export type AllTemplatesQueryHookResult = ReturnType<typeof useAllTemplatesQuery>;
export type AllTemplatesLazyQueryHookResult = ReturnType<typeof useAllTemplatesLazyQuery>;
export type AllTemplatesSuspenseQueryHookResult = ReturnType<typeof useAllTemplatesSuspenseQuery>;
export type AllTemplatesQueryResult = Apollo.QueryResult<AllTemplatesQuery, AllTemplatesQueryVariables>;
export const AuthorsDocument = gql`
    query Authors($where: RouteResourceWhereInput, $take: Int, $skip: Int) {
  authors(where: $where, take: $take, skip: $skip) {
    id
    properties {
      id
      key
      data
    }
  }
  count: authorCount(where: $where)
}
    `;

/**
 * __useAuthorsQuery__
 *
 * To run a query within a React component, call `useAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAuthorsQuery(baseOptions?: Apollo.QueryHookOptions<AuthorsQuery, AuthorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorsQuery, AuthorsQueryVariables>(AuthorsDocument, options);
      }
export function useAuthorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorsQuery, AuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorsQuery, AuthorsQueryVariables>(AuthorsDocument, options);
        }
export function useAuthorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorsQuery, AuthorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorsQuery, AuthorsQueryVariables>(AuthorsDocument, options);
        }
export type AuthorsQueryHookResult = ReturnType<typeof useAuthorsQuery>;
export type AuthorsLazyQueryHookResult = ReturnType<typeof useAuthorsLazyQuery>;
export type AuthorsSuspenseQueryHookResult = ReturnType<typeof useAuthorsSuspenseQuery>;
export type AuthorsQueryResult = Apollo.QueryResult<AuthorsQuery, AuthorsQueryVariables>;
export const CountriesDocument = gql`
    query Countries($where: CountryWhereInput) {
  countries(where: $where) {
    ...CountryFragment
  }
}
    ${CountryFragmentFragmentDoc}`;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const CountriesWithLanguagesDocument = gql`
    query CountriesWithLanguages($where: CountryWhereInput) {
  countries(where: $where) {
    ...CountryWithLanguagesFragment
  }
}
    ${CountryWithLanguagesFragmentFragmentDoc}`;

/**
 * __useCountriesWithLanguagesQuery__
 *
 * To run a query within a React component, call `useCountriesWithLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesWithLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesWithLanguagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountriesWithLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesWithLanguagesQuery, CountriesWithLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesWithLanguagesQuery, CountriesWithLanguagesQueryVariables>(CountriesWithLanguagesDocument, options);
      }
export function useCountriesWithLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesWithLanguagesQuery, CountriesWithLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesWithLanguagesQuery, CountriesWithLanguagesQueryVariables>(CountriesWithLanguagesDocument, options);
        }
export function useCountriesWithLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountriesWithLanguagesQuery, CountriesWithLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesWithLanguagesQuery, CountriesWithLanguagesQueryVariables>(CountriesWithLanguagesDocument, options);
        }
export type CountriesWithLanguagesQueryHookResult = ReturnType<typeof useCountriesWithLanguagesQuery>;
export type CountriesWithLanguagesLazyQueryHookResult = ReturnType<typeof useCountriesWithLanguagesLazyQuery>;
export type CountriesWithLanguagesSuspenseQueryHookResult = ReturnType<typeof useCountriesWithLanguagesSuspenseQuery>;
export type CountriesWithLanguagesQueryResult = Apollo.QueryResult<CountriesWithLanguagesQuery, CountriesWithLanguagesQueryVariables>;
export const FilterTaxonomyRulesDocument = gql`
    query FilterTaxonomyRules($where: FilterTaxonomyRuleWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  filterTaxonomyRules(where: $where, take: $take, skip: $skip) {
    id
    taxonomyBase {
      id
      content(
        where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
    }
    taxonomyFilter {
      id
      content(
        where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
    }
  }
  count: filterTaxonomyRuleCount(where: $where)
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useFilterTaxonomyRulesQuery__
 *
 * To run a query within a React component, call `useFilterTaxonomyRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterTaxonomyRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterTaxonomyRulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useFilterTaxonomyRulesQuery(baseOptions: Apollo.QueryHookOptions<FilterTaxonomyRulesQuery, FilterTaxonomyRulesQueryVariables> & ({ variables: FilterTaxonomyRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterTaxonomyRulesQuery, FilterTaxonomyRulesQueryVariables>(FilterTaxonomyRulesDocument, options);
      }
export function useFilterTaxonomyRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterTaxonomyRulesQuery, FilterTaxonomyRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterTaxonomyRulesQuery, FilterTaxonomyRulesQueryVariables>(FilterTaxonomyRulesDocument, options);
        }
export function useFilterTaxonomyRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilterTaxonomyRulesQuery, FilterTaxonomyRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilterTaxonomyRulesQuery, FilterTaxonomyRulesQueryVariables>(FilterTaxonomyRulesDocument, options);
        }
export type FilterTaxonomyRulesQueryHookResult = ReturnType<typeof useFilterTaxonomyRulesQuery>;
export type FilterTaxonomyRulesLazyQueryHookResult = ReturnType<typeof useFilterTaxonomyRulesLazyQuery>;
export type FilterTaxonomyRulesSuspenseQueryHookResult = ReturnType<typeof useFilterTaxonomyRulesSuspenseQuery>;
export type FilterTaxonomyRulesQueryResult = Apollo.QueryResult<FilterTaxonomyRulesQuery, FilterTaxonomyRulesQueryVariables>;
export const LanguagesDocument = gql`
    query Languages($where: LanguageWhereInput) {
  languages(where: $where) {
    ...LanguageFragment
  }
}
    ${LanguageFragmentFragmentDoc}`;

/**
 * __useLanguagesQuery__
 *
 * To run a query within a React component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
      }
export function useLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export function useLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export type LanguagesQueryHookResult = ReturnType<typeof useLanguagesQuery>;
export type LanguagesLazyQueryHookResult = ReturnType<typeof useLanguagesLazyQuery>;
export type LanguagesSuspenseQueryHookResult = ReturnType<typeof useLanguagesSuspenseQuery>;
export type LanguagesQueryResult = Apollo.QueryResult<LanguagesQuery, LanguagesQueryVariables>;
export const LanguagesWithCountriesDocument = gql`
    query LanguagesWithCountries($where: LanguageWhereInput) {
  languages(where: $where) {
    ...LanguageWithCountriesFragment
  }
}
    ${LanguageWithCountriesFragmentFragmentDoc}`;

/**
 * __useLanguagesWithCountriesQuery__
 *
 * To run a query within a React component, call `useLanguagesWithCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesWithCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesWithCountriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLanguagesWithCountriesQuery(baseOptions?: Apollo.QueryHookOptions<LanguagesWithCountriesQuery, LanguagesWithCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguagesWithCountriesQuery, LanguagesWithCountriesQueryVariables>(LanguagesWithCountriesDocument, options);
      }
export function useLanguagesWithCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguagesWithCountriesQuery, LanguagesWithCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguagesWithCountriesQuery, LanguagesWithCountriesQueryVariables>(LanguagesWithCountriesDocument, options);
        }
export function useLanguagesWithCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LanguagesWithCountriesQuery, LanguagesWithCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LanguagesWithCountriesQuery, LanguagesWithCountriesQueryVariables>(LanguagesWithCountriesDocument, options);
        }
export type LanguagesWithCountriesQueryHookResult = ReturnType<typeof useLanguagesWithCountriesQuery>;
export type LanguagesWithCountriesLazyQueryHookResult = ReturnType<typeof useLanguagesWithCountriesLazyQuery>;
export type LanguagesWithCountriesSuspenseQueryHookResult = ReturnType<typeof useLanguagesWithCountriesSuspenseQuery>;
export type LanguagesWithCountriesQueryResult = Apollo.QueryResult<LanguagesWithCountriesQuery, LanguagesWithCountriesQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MediaItemDocument = gql`
    query MediaItem($where: MediaItemWhereUniqueInput!) {
  mediaItem(where: $where) {
    ...MediaItemFragment
  }
}
    ${MediaItemFragmentFragmentDoc}`;

/**
 * __useMediaItemQuery__
 *
 * To run a query within a React component, call `useMediaItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMediaItemQuery(baseOptions: Apollo.QueryHookOptions<MediaItemQuery, MediaItemQueryVariables> & ({ variables: MediaItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaItemQuery, MediaItemQueryVariables>(MediaItemDocument, options);
      }
export function useMediaItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaItemQuery, MediaItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaItemQuery, MediaItemQueryVariables>(MediaItemDocument, options);
        }
export function useMediaItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaItemQuery, MediaItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaItemQuery, MediaItemQueryVariables>(MediaItemDocument, options);
        }
export type MediaItemQueryHookResult = ReturnType<typeof useMediaItemQuery>;
export type MediaItemLazyQueryHookResult = ReturnType<typeof useMediaItemLazyQuery>;
export type MediaItemSuspenseQueryHookResult = ReturnType<typeof useMediaItemSuspenseQuery>;
export type MediaItemQueryResult = Apollo.QueryResult<MediaItemQuery, MediaItemQueryVariables>;
export const MediaItemsDocument = gql`
    query MediaItems($where: MediaItemWhereInput, $take: Int, $skip: Int, $orderBy: [MediaItemOrderByWithRelationInput!]) {
  mediaItems(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...MediaItemFragment
  }
  count: mediaItemCount(where: $where)
}
    ${MediaItemFragmentFragmentDoc}`;

/**
 * __useMediaItemsQuery__
 *
 * To run a query within a React component, call `useMediaItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMediaItemsQuery(baseOptions?: Apollo.QueryHookOptions<MediaItemsQuery, MediaItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaItemsQuery, MediaItemsQueryVariables>(MediaItemsDocument, options);
      }
export function useMediaItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaItemsQuery, MediaItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaItemsQuery, MediaItemsQueryVariables>(MediaItemsDocument, options);
        }
export function useMediaItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaItemsQuery, MediaItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaItemsQuery, MediaItemsQueryVariables>(MediaItemsDocument, options);
        }
export type MediaItemsQueryHookResult = ReturnType<typeof useMediaItemsQuery>;
export type MediaItemsLazyQueryHookResult = ReturnType<typeof useMediaItemsLazyQuery>;
export type MediaItemsSuspenseQueryHookResult = ReturnType<typeof useMediaItemsSuspenseQuery>;
export type MediaItemsQueryResult = Apollo.QueryResult<MediaItemsQuery, MediaItemsQueryVariables>;
export const NetworksDocument = gql`
    query Networks($where: NetworkWhereInput, $take: Int, $skip: Int) {
  networks(where: $where, take: $take, skip: $skip) {
    ...NetworkFragment
  }
  count: networkCount(where: $where)
}
    ${NetworkFragmentFragmentDoc}`;

/**
 * __useNetworksQuery__
 *
 * To run a query within a React component, call `useNetworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworksQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useNetworksQuery(baseOptions?: Apollo.QueryHookOptions<NetworksQuery, NetworksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworksQuery, NetworksQueryVariables>(NetworksDocument, options);
      }
export function useNetworksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworksQuery, NetworksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworksQuery, NetworksQueryVariables>(NetworksDocument, options);
        }
export function useNetworksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworksQuery, NetworksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworksQuery, NetworksQueryVariables>(NetworksDocument, options);
        }
export type NetworksQueryHookResult = ReturnType<typeof useNetworksQuery>;
export type NetworksLazyQueryHookResult = ReturnType<typeof useNetworksLazyQuery>;
export type NetworksSuspenseQueryHookResult = ReturnType<typeof useNetworksSuspenseQuery>;
export type NetworksQueryResult = Apollo.QueryResult<NetworksQuery, NetworksQueryVariables>;
export const NetworksSlimDocument = gql`
    query NetworksSlim($where: NetworkWhereInput, $take: Int, $skip: Int, $orderBy: [NetworkOrderByWithRelationInput!], $defaultLanguageId: String!) {
  networks(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    companyId
    company {
      id
      name
      slug
    }
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED]}}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useNetworksSlimQuery__
 *
 * To run a query within a React component, call `useNetworksSlimQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworksSlimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworksSlimQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useNetworksSlimQuery(baseOptions: Apollo.QueryHookOptions<NetworksSlimQuery, NetworksSlimQueryVariables> & ({ variables: NetworksSlimQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworksSlimQuery, NetworksSlimQueryVariables>(NetworksSlimDocument, options);
      }
export function useNetworksSlimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworksSlimQuery, NetworksSlimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworksSlimQuery, NetworksSlimQueryVariables>(NetworksSlimDocument, options);
        }
export function useNetworksSlimSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworksSlimQuery, NetworksSlimQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworksSlimQuery, NetworksSlimQueryVariables>(NetworksSlimDocument, options);
        }
export type NetworksSlimQueryHookResult = ReturnType<typeof useNetworksSlimQuery>;
export type NetworksSlimLazyQueryHookResult = ReturnType<typeof useNetworksSlimLazyQuery>;
export type NetworksSlimSuspenseQueryHookResult = ReturnType<typeof useNetworksSlimSuspenseQuery>;
export type NetworksSlimQueryResult = Apollo.QueryResult<NetworksSlimQuery, NetworksSlimQueryVariables>;
export const PagesDocument = gql`
    query Pages($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  pages(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "parent"]}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function usePagesQuery(baseOptions: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables> & ({ variables: PagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
      }
export function usePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export function usePagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>;
export type PagesSuspenseQueryHookResult = ReturnType<typeof usePagesSuspenseQuery>;
export type PagesQueryResult = Apollo.QueryResult<PagesQuery, PagesQueryVariables>;
export const PostsDocument = gql`
    query Posts($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  posts(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "parent"]}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __usePostsQuery__
 *
 * To run a query within a React component, call `usePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function usePostsQuery(baseOptions: Apollo.QueryHookOptions<PostsQuery, PostsQueryVariables> & ({ variables: PostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
      }
export function usePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsQuery, PostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
        }
export function usePostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostsQuery, PostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
        }
export type PostsQueryHookResult = ReturnType<typeof usePostsQuery>;
export type PostsLazyQueryHookResult = ReturnType<typeof usePostsLazyQuery>;
export type PostsSuspenseQueryHookResult = ReturnType<typeof usePostsSuspenseQuery>;
export type PostsQueryResult = Apollo.QueryResult<PostsQuery, PostsQueryVariables>;
export const ProductPoolsDocument = gql`
    query ProductPools($where: RouteResourcePoolWhereInput) {
  productPools(where: $where) {
    id
    name
    networks {
      id
    }
    products {
      id
    }
  }
}
    `;

/**
 * __useProductPoolsQuery__
 *
 * To run a query within a React component, call `useProductPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPoolsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProductPoolsQuery(baseOptions?: Apollo.QueryHookOptions<ProductPoolsQuery, ProductPoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPoolsQuery, ProductPoolsQueryVariables>(ProductPoolsDocument, options);
      }
export function useProductPoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPoolsQuery, ProductPoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPoolsQuery, ProductPoolsQueryVariables>(ProductPoolsDocument, options);
        }
export function useProductPoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPoolsQuery, ProductPoolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPoolsQuery, ProductPoolsQueryVariables>(ProductPoolsDocument, options);
        }
export type ProductPoolsQueryHookResult = ReturnType<typeof useProductPoolsQuery>;
export type ProductPoolsLazyQueryHookResult = ReturnType<typeof useProductPoolsLazyQuery>;
export type ProductPoolsSuspenseQueryHookResult = ReturnType<typeof useProductPoolsSuspenseQuery>;
export type ProductPoolsQueryResult = Apollo.QueryResult<ProductPoolsQuery, ProductPoolsQueryVariables>;
export const ProductsDocument = gql`
    query Products($where: RouteResourceWhereInput, $take: Int, $skip: Int) {
  products(where: $where, take: $take, skip: $skip) {
    ...ProductFragment
  }
  count: productCount(where: $where)
}
    ${ProductFragmentFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export function useProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsSuspenseQueryHookResult = ReturnType<typeof useProductsSuspenseQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const ProductsForStoreDocument = gql`
    query ProductsForStore($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  products(where: $where) {
    id
    subtype
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(
      where: {key: {in: ["published", "software-taxonomies", "verticals"]}}
    ) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useProductsForStoreQuery__
 *
 * To run a query within a React component, call `useProductsForStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsForStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsForStoreQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useProductsForStoreQuery(baseOptions: Apollo.QueryHookOptions<ProductsForStoreQuery, ProductsForStoreQueryVariables> & ({ variables: ProductsForStoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsForStoreQuery, ProductsForStoreQueryVariables>(ProductsForStoreDocument, options);
      }
export function useProductsForStoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsForStoreQuery, ProductsForStoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsForStoreQuery, ProductsForStoreQueryVariables>(ProductsForStoreDocument, options);
        }
export function useProductsForStoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsForStoreQuery, ProductsForStoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsForStoreQuery, ProductsForStoreQueryVariables>(ProductsForStoreDocument, options);
        }
export type ProductsForStoreQueryHookResult = ReturnType<typeof useProductsForStoreQuery>;
export type ProductsForStoreLazyQueryHookResult = ReturnType<typeof useProductsForStoreLazyQuery>;
export type ProductsForStoreSuspenseQueryHookResult = ReturnType<typeof useProductsForStoreSuspenseQuery>;
export type ProductsForStoreQueryResult = Apollo.QueryResult<ProductsForStoreQuery, ProductsForStoreQueryVariables>;
export const ProviderDocument = gql`
    query Provider($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!) {
  provider(where: $where) {
    id
    content(
      where: {languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useProviderQuery__
 *
 * To run a query within a React component, call `useProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *   },
 * });
 */
export function useProviderQuery(baseOptions: Apollo.QueryHookOptions<ProviderQuery, ProviderQueryVariables> & ({ variables: ProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
      }
export function useProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderQuery, ProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
        }
export function useProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderQuery, ProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
        }
export type ProviderQueryHookResult = ReturnType<typeof useProviderQuery>;
export type ProviderLazyQueryHookResult = ReturnType<typeof useProviderLazyQuery>;
export type ProviderSuspenseQueryHookResult = ReturnType<typeof useProviderSuspenseQuery>;
export type ProviderQueryResult = Apollo.QueryResult<ProviderQuery, ProviderQueryVariables>;
export const ProviderPoolsDocument = gql`
    query ProviderPools($where: RouteResourcePoolWhereInput) {
  providerPools(where: $where) {
    id
    name
    networks {
      id
    }
    providers {
      id
    }
  }
}
    `;

/**
 * __useProviderPoolsQuery__
 *
 * To run a query within a React component, call `useProviderPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderPoolsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProviderPoolsQuery(baseOptions?: Apollo.QueryHookOptions<ProviderPoolsQuery, ProviderPoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderPoolsQuery, ProviderPoolsQueryVariables>(ProviderPoolsDocument, options);
      }
export function useProviderPoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderPoolsQuery, ProviderPoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderPoolsQuery, ProviderPoolsQueryVariables>(ProviderPoolsDocument, options);
        }
export function useProviderPoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderPoolsQuery, ProviderPoolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderPoolsQuery, ProviderPoolsQueryVariables>(ProviderPoolsDocument, options);
        }
export type ProviderPoolsQueryHookResult = ReturnType<typeof useProviderPoolsQuery>;
export type ProviderPoolsLazyQueryHookResult = ReturnType<typeof useProviderPoolsLazyQuery>;
export type ProviderPoolsSuspenseQueryHookResult = ReturnType<typeof useProviderPoolsSuspenseQuery>;
export type ProviderPoolsQueryResult = Apollo.QueryResult<ProviderPoolsQuery, ProviderPoolsQueryVariables>;
export const ProvidersDocument = gql`
    query Providers($where: RouteResourceWhereInput, $take: Int, $skip: Int) {
  providers(where: $where, take: $take, skip: $skip) {
    ...ProviderFragment
  }
  count: providerCount(where: $where)
}
    ${ProviderFragmentFragmentDoc}`;

/**
 * __useProvidersQuery__
 *
 * To run a query within a React component, call `useProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useProvidersQuery(baseOptions?: Apollo.QueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
      }
export function useProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
        }
export function useProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
        }
export type ProvidersQueryHookResult = ReturnType<typeof useProvidersQuery>;
export type ProvidersLazyQueryHookResult = ReturnType<typeof useProvidersLazyQuery>;
export type ProvidersSuspenseQueryHookResult = ReturnType<typeof useProvidersSuspenseQuery>;
export type ProvidersQueryResult = Apollo.QueryResult<ProvidersQuery, ProvidersQueryVariables>;
export const ProvidersAndTaxonomiesCountsDocument = gql`
    query ProvidersAndTaxonomiesCounts($networkId: String) {
  newResourceCounts(networkId: $networkId) {
    providersCount
    taxonomyItemsCount
  }
}
    `;

/**
 * __useProvidersAndTaxonomiesCountsQuery__
 *
 * To run a query within a React component, call `useProvidersAndTaxonomiesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersAndTaxonomiesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersAndTaxonomiesCountsQuery({
 *   variables: {
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useProvidersAndTaxonomiesCountsQuery(baseOptions?: Apollo.QueryHookOptions<ProvidersAndTaxonomiesCountsQuery, ProvidersAndTaxonomiesCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvidersAndTaxonomiesCountsQuery, ProvidersAndTaxonomiesCountsQueryVariables>(ProvidersAndTaxonomiesCountsDocument, options);
      }
export function useProvidersAndTaxonomiesCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvidersAndTaxonomiesCountsQuery, ProvidersAndTaxonomiesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvidersAndTaxonomiesCountsQuery, ProvidersAndTaxonomiesCountsQueryVariables>(ProvidersAndTaxonomiesCountsDocument, options);
        }
export function useProvidersAndTaxonomiesCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProvidersAndTaxonomiesCountsQuery, ProvidersAndTaxonomiesCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProvidersAndTaxonomiesCountsQuery, ProvidersAndTaxonomiesCountsQueryVariables>(ProvidersAndTaxonomiesCountsDocument, options);
        }
export type ProvidersAndTaxonomiesCountsQueryHookResult = ReturnType<typeof useProvidersAndTaxonomiesCountsQuery>;
export type ProvidersAndTaxonomiesCountsLazyQueryHookResult = ReturnType<typeof useProvidersAndTaxonomiesCountsLazyQuery>;
export type ProvidersAndTaxonomiesCountsSuspenseQueryHookResult = ReturnType<typeof useProvidersAndTaxonomiesCountsSuspenseQuery>;
export type ProvidersAndTaxonomiesCountsQueryResult = Apollo.QueryResult<ProvidersAndTaxonomiesCountsQuery, ProvidersAndTaxonomiesCountsQueryVariables>;
export const RankingProvidersDocument = gql`
    query RankingProviders($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  providers(where: $where, take: $take, skip: $skip) {
    id
    properties(
      where: {OR: [{key: {in: ["logotype", "published", "calculated-restricted-countries", "suspended", "verticals"]}}, {type: {equals: TAXONOMYITEM}}]}
    ) {
      id
      key
      data
      type
    }
    content(
      where: {key: {in: ["name", "bonus-text"]}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useRankingProvidersQuery__
 *
 * To run a query within a React component, call `useRankingProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankingProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankingProvidersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useRankingProvidersQuery(baseOptions: Apollo.QueryHookOptions<RankingProvidersQuery, RankingProvidersQueryVariables> & ({ variables: RankingProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RankingProvidersQuery, RankingProvidersQueryVariables>(RankingProvidersDocument, options);
      }
export function useRankingProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RankingProvidersQuery, RankingProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RankingProvidersQuery, RankingProvidersQueryVariables>(RankingProvidersDocument, options);
        }
export function useRankingProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RankingProvidersQuery, RankingProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RankingProvidersQuery, RankingProvidersQueryVariables>(RankingProvidersDocument, options);
        }
export type RankingProvidersQueryHookResult = ReturnType<typeof useRankingProvidersQuery>;
export type RankingProvidersLazyQueryHookResult = ReturnType<typeof useRankingProvidersLazyQuery>;
export type RankingProvidersSuspenseQueryHookResult = ReturnType<typeof useRankingProvidersSuspenseQuery>;
export type RankingProvidersQueryResult = Apollo.QueryResult<RankingProvidersQuery, RankingProvidersQueryVariables>;
export const RedirectsDocument = gql`
    query Redirects($where: RedirectWhereInput, $orderBy: [RedirectOrderByWithRelationInput!], $skip: Int, $take: Int, $defaultLanguageId: String!) {
  redirects(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
    id
    httpCode
    scope
    sourceKind
    sourcePath
    sourceUrl
    sourceResourceType
    sourceResourceId
    sourceResource {
      id
      resourceType
      content(
        where: {key: {in: ["title", "name"]}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
    }
    sourceSiteId
    sourceVerticalId
    sourceNetworkId
    targetKind
    targetPath
    targetUrl
    targetResourceType
    targetResourceId
    targetResource {
      id
      resourceType
      content(
        where: {key: {in: ["title", "name"]}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
        take: 1
      ) {
        ...ContentItemFragment
      }
    }
    targetSiteId
    targetVerticalId
    targetNetworkId
    createdAt
    updatedAt
    createdBy {
      user_id
      email
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useRedirectsQuery__
 *
 * To run a query within a React component, call `useRedirectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useRedirectsQuery(baseOptions: Apollo.QueryHookOptions<RedirectsQuery, RedirectsQueryVariables> & ({ variables: RedirectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedirectsQuery, RedirectsQueryVariables>(RedirectsDocument, options);
      }
export function useRedirectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedirectsQuery, RedirectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedirectsQuery, RedirectsQueryVariables>(RedirectsDocument, options);
        }
export function useRedirectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedirectsQuery, RedirectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedirectsQuery, RedirectsQueryVariables>(RedirectsDocument, options);
        }
export type RedirectsQueryHookResult = ReturnType<typeof useRedirectsQuery>;
export type RedirectsLazyQueryHookResult = ReturnType<typeof useRedirectsLazyQuery>;
export type RedirectsSuspenseQueryHookResult = ReturnType<typeof useRedirectsSuspenseQuery>;
export type RedirectsQueryResult = Apollo.QueryResult<RedirectsQuery, RedirectsQueryVariables>;
export const RedirectCountDocument = gql`
    query RedirectCount($where: RedirectWhereInput) {
  redirectCount(where: $where)
}
    `;

/**
 * __useRedirectCountQuery__
 *
 * To run a query within a React component, call `useRedirectCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRedirectCountQuery(baseOptions?: Apollo.QueryHookOptions<RedirectCountQuery, RedirectCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedirectCountQuery, RedirectCountQueryVariables>(RedirectCountDocument, options);
      }
export function useRedirectCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedirectCountQuery, RedirectCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedirectCountQuery, RedirectCountQueryVariables>(RedirectCountDocument, options);
        }
export function useRedirectCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedirectCountQuery, RedirectCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedirectCountQuery, RedirectCountQueryVariables>(RedirectCountDocument, options);
        }
export type RedirectCountQueryHookResult = ReturnType<typeof useRedirectCountQuery>;
export type RedirectCountLazyQueryHookResult = ReturnType<typeof useRedirectCountLazyQuery>;
export type RedirectCountSuspenseQueryHookResult = ReturnType<typeof useRedirectCountSuspenseQuery>;
export type RedirectCountQueryResult = Apollo.QueryResult<RedirectCountQuery, RedirectCountQueryVariables>;
export const RedirectDocument = gql`
    query Redirect($where: RedirectWhereUniqueInput!) {
  redirect(where: $where) {
    id
    httpCode
    scope
    sourceKind
    sourcePath
    sourceUrl
    sourceResourceType
    sourceResourceId
    sourceSiteId
    sourceVerticalId
    sourceNetworkId
    targetKind
    targetPath
    targetUrl
    targetResourceType
    targetResourceId
    targetSiteId
    targetVerticalId
    targetNetworkId
    createdAt
    updatedAt
    createdBy {
      user_id
      email
    }
  }
}
    `;

/**
 * __useRedirectQuery__
 *
 * To run a query within a React component, call `useRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRedirectQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRedirectQuery(baseOptions: Apollo.QueryHookOptions<RedirectQuery, RedirectQueryVariables> & ({ variables: RedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RedirectQuery, RedirectQueryVariables>(RedirectDocument, options);
      }
export function useRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RedirectQuery, RedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RedirectQuery, RedirectQueryVariables>(RedirectDocument, options);
        }
export function useRedirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RedirectQuery, RedirectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RedirectQuery, RedirectQueryVariables>(RedirectDocument, options);
        }
export type RedirectQueryHookResult = ReturnType<typeof useRedirectQuery>;
export type RedirectLazyQueryHookResult = ReturnType<typeof useRedirectLazyQuery>;
export type RedirectSuspenseQueryHookResult = ReturnType<typeof useRedirectSuspenseQuery>;
export type RedirectQueryResult = Apollo.QueryResult<RedirectQuery, RedirectQueryVariables>;
export const RegionsSubregionsCountriesDocument = gql`
    query RegionsSubregionsCountries($where: RegionWhereInput) {
  regions(where: $where) {
    id
    name
    subregions {
      id
      name
      countries {
        countryCode
        id
        name
      }
    }
  }
}
    `;

/**
 * __useRegionsSubregionsCountriesQuery__
 *
 * To run a query within a React component, call `useRegionsSubregionsCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsSubregionsCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsSubregionsCountriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRegionsSubregionsCountriesQuery(baseOptions?: Apollo.QueryHookOptions<RegionsSubregionsCountriesQuery, RegionsSubregionsCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsSubregionsCountriesQuery, RegionsSubregionsCountriesQueryVariables>(RegionsSubregionsCountriesDocument, options);
      }
export function useRegionsSubregionsCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsSubregionsCountriesQuery, RegionsSubregionsCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsSubregionsCountriesQuery, RegionsSubregionsCountriesQueryVariables>(RegionsSubregionsCountriesDocument, options);
        }
export function useRegionsSubregionsCountriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegionsSubregionsCountriesQuery, RegionsSubregionsCountriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegionsSubregionsCountriesQuery, RegionsSubregionsCountriesQueryVariables>(RegionsSubregionsCountriesDocument, options);
        }
export type RegionsSubregionsCountriesQueryHookResult = ReturnType<typeof useRegionsSubregionsCountriesQuery>;
export type RegionsSubregionsCountriesLazyQueryHookResult = ReturnType<typeof useRegionsSubregionsCountriesLazyQuery>;
export type RegionsSubregionsCountriesSuspenseQueryHookResult = ReturnType<typeof useRegionsSubregionsCountriesSuspenseQuery>;
export type RegionsSubregionsCountriesQueryResult = Apollo.QueryResult<RegionsSubregionsCountriesQuery, RegionsSubregionsCountriesQueryVariables>;
export const SchedulerPostsDocument = gql`
    query SchedulerPosts($where: RouteResourceWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!) {
  posts(where: $where, take: $take, skip: $skip) {
    id
    createdAt
    publishedAt
    properties(where: {key: {in: ["published-at", "published"]}}) {
      id
      key
      data
    }
    content(
      where: {key: {equals: "title"}, languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
  count: postCount(where: $where)
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useSchedulerPostsQuery__
 *
 * To run a query within a React component, call `useSchedulerPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerPostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      currentLanguageId: // value for 'currentLanguageId'
 *   },
 * });
 */
export function useSchedulerPostsQuery(baseOptions: Apollo.QueryHookOptions<SchedulerPostsQuery, SchedulerPostsQueryVariables> & ({ variables: SchedulerPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulerPostsQuery, SchedulerPostsQueryVariables>(SchedulerPostsDocument, options);
      }
export function useSchedulerPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulerPostsQuery, SchedulerPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulerPostsQuery, SchedulerPostsQueryVariables>(SchedulerPostsDocument, options);
        }
export function useSchedulerPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerPostsQuery, SchedulerPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulerPostsQuery, SchedulerPostsQueryVariables>(SchedulerPostsDocument, options);
        }
export type SchedulerPostsQueryHookResult = ReturnType<typeof useSchedulerPostsQuery>;
export type SchedulerPostsLazyQueryHookResult = ReturnType<typeof useSchedulerPostsLazyQuery>;
export type SchedulerPostsSuspenseQueryHookResult = ReturnType<typeof useSchedulerPostsSuspenseQuery>;
export type SchedulerPostsQueryResult = Apollo.QueryResult<SchedulerPostsQuery, SchedulerPostsQueryVariables>;
export const SitesDocument = gql`
    query Sites($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    url
    vertical {
      id
    }
  }
  count: siteCount(where: $where)
}
    `;

/**
 * __useSitesQuery__
 *
 * To run a query within a React component, call `useSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSitesQuery(baseOptions?: Apollo.QueryHookOptions<SitesQuery, SitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
      }
export function useSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesQuery, SitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
        }
export function useSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitesQuery, SitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesQuery, SitesQueryVariables>(SitesDocument, options);
        }
export type SitesQueryHookResult = ReturnType<typeof useSitesQuery>;
export type SitesLazyQueryHookResult = ReturnType<typeof useSitesLazyQuery>;
export type SitesSuspenseQueryHookResult = ReturnType<typeof useSitesSuspenseQuery>;
export type SitesQueryResult = Apollo.QueryResult<SitesQuery, SitesQueryVariables>;
export const SitesSlimDocument = gql`
    query SitesSlim($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    url
    properties(where: {key: {in: ["name", "global", "country"]}}) {
      id
      key
      data
    }
    language {
      id
      languageCode
      languageTag
      countryCode
    }
  }
  count: siteCount(where: $where)
}
    `;

/**
 * __useSitesSlimQuery__
 *
 * To run a query within a React component, call `useSitesSlimQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesSlimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesSlimQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSitesSlimQuery(baseOptions?: Apollo.QueryHookOptions<SitesSlimQuery, SitesSlimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesSlimQuery, SitesSlimQueryVariables>(SitesSlimDocument, options);
      }
export function useSitesSlimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesSlimQuery, SitesSlimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesSlimQuery, SitesSlimQueryVariables>(SitesSlimDocument, options);
        }
export function useSitesSlimSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitesSlimQuery, SitesSlimQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesSlimQuery, SitesSlimQueryVariables>(SitesSlimDocument, options);
        }
export type SitesSlimQueryHookResult = ReturnType<typeof useSitesSlimQuery>;
export type SitesSlimLazyQueryHookResult = ReturnType<typeof useSitesSlimLazyQuery>;
export type SitesSlimSuspenseQueryHookResult = ReturnType<typeof useSitesSlimSuspenseQuery>;
export type SitesSlimQueryResult = Apollo.QueryResult<SitesSlimQuery, SitesSlimQueryVariables>;
export const StringTemplateVariablesDocument = gql`
    query StringTemplateVariables($where: StringTemplateVariableWhereInput) {
  stringTemplateVariables(where: $where) {
    id
    type
    key
    name
    group
    data
  }
}
    `;

/**
 * __useStringTemplateVariablesQuery__
 *
 * To run a query within a React component, call `useStringTemplateVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStringTemplateVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStringTemplateVariablesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useStringTemplateVariablesQuery(baseOptions?: Apollo.QueryHookOptions<StringTemplateVariablesQuery, StringTemplateVariablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StringTemplateVariablesQuery, StringTemplateVariablesQueryVariables>(StringTemplateVariablesDocument, options);
      }
export function useStringTemplateVariablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StringTemplateVariablesQuery, StringTemplateVariablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StringTemplateVariablesQuery, StringTemplateVariablesQueryVariables>(StringTemplateVariablesDocument, options);
        }
export function useStringTemplateVariablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StringTemplateVariablesQuery, StringTemplateVariablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StringTemplateVariablesQuery, StringTemplateVariablesQueryVariables>(StringTemplateVariablesDocument, options);
        }
export type StringTemplateVariablesQueryHookResult = ReturnType<typeof useStringTemplateVariablesQuery>;
export type StringTemplateVariablesLazyQueryHookResult = ReturnType<typeof useStringTemplateVariablesLazyQuery>;
export type StringTemplateVariablesSuspenseQueryHookResult = ReturnType<typeof useStringTemplateVariablesSuspenseQuery>;
export type StringTemplateVariablesQueryResult = Apollo.QueryResult<StringTemplateVariablesQuery, StringTemplateVariablesQueryVariables>;
export const TagsDocument = gql`
    query Tags($take: Int, $orderBy: [TagOrderByWithRelationInput!], $where: TagWhereInput) {
  tags(take: $take, orderBy: $orderBy, where: $where) {
    name
    id
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export function useTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const TaxonomyItemPoolsDocument = gql`
    query TaxonomyItemPools($where: RouteResourcePoolWhereInput) {
  taxonomyItemPools(where: $where) {
    id
    name
    networks {
      id
    }
    taxonomyItems {
      id
    }
  }
}
    `;

/**
 * __useTaxonomyItemPoolsQuery__
 *
 * To run a query within a React component, call `useTaxonomyItemPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyItemPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyItemPoolsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTaxonomyItemPoolsQuery(baseOptions?: Apollo.QueryHookOptions<TaxonomyItemPoolsQuery, TaxonomyItemPoolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyItemPoolsQuery, TaxonomyItemPoolsQueryVariables>(TaxonomyItemPoolsDocument, options);
      }
export function useTaxonomyItemPoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyItemPoolsQuery, TaxonomyItemPoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyItemPoolsQuery, TaxonomyItemPoolsQueryVariables>(TaxonomyItemPoolsDocument, options);
        }
export function useTaxonomyItemPoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxonomyItemPoolsQuery, TaxonomyItemPoolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxonomyItemPoolsQuery, TaxonomyItemPoolsQueryVariables>(TaxonomyItemPoolsDocument, options);
        }
export type TaxonomyItemPoolsQueryHookResult = ReturnType<typeof useTaxonomyItemPoolsQuery>;
export type TaxonomyItemPoolsLazyQueryHookResult = ReturnType<typeof useTaxonomyItemPoolsLazyQuery>;
export type TaxonomyItemPoolsSuspenseQueryHookResult = ReturnType<typeof useTaxonomyItemPoolsSuspenseQuery>;
export type TaxonomyItemPoolsQueryResult = Apollo.QueryResult<TaxonomyItemPoolsQuery, TaxonomyItemPoolsQueryVariables>;
export const TemplatesDocument = gql`
    query Templates($where: TemplateWhereInput!) {
  templates(where: $where) {
    id
    type
    subtype
    network {
      id
    }
    content(
      where: {languageId: {equals: "cka2r9yww001164rm5rp69iko"}, status: {equals: APPROVED}}
    ) {
      ...ContentItemFragment
    }
    fields {
      id
      required
      index
      group
      key
      type
      hidden
      list
      geo
      data
      context
      resourceType
      defaultTranslationType
      displayType
      content(
        where: {languageId: {equals: "cka2r9yww001164rm5rp69iko"}, status: {equals: APPROVED}}
      ) {
        ...ContentItemFragment
      }
    }
    groups {
      id
      name
      index
      extended
      generalGroup {
        id
        name
        index
      }
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions: Apollo.QueryHookOptions<TemplatesQuery, TemplatesQueryVariables> & ({ variables: TemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export function useTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesSuspenseQueryHookResult = ReturnType<typeof useTemplatesSuspenseQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<TemplatesQuery, TemplatesQueryVariables>;
export const TranslationJobsEstimatedCostDocument = gql`
    query TranslationJobsEstimatedCost($jobs: [TranslationJobData!]!) {
  translationJobsEstimatedCost(jobs: $jobs)
}
    `;

/**
 * __useTranslationJobsEstimatedCostQuery__
 *
 * To run a query within a React component, call `useTranslationJobsEstimatedCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationJobsEstimatedCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationJobsEstimatedCostQuery({
 *   variables: {
 *      jobs: // value for 'jobs'
 *   },
 * });
 */
export function useTranslationJobsEstimatedCostQuery(baseOptions: Apollo.QueryHookOptions<TranslationJobsEstimatedCostQuery, TranslationJobsEstimatedCostQueryVariables> & ({ variables: TranslationJobsEstimatedCostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranslationJobsEstimatedCostQuery, TranslationJobsEstimatedCostQueryVariables>(TranslationJobsEstimatedCostDocument, options);
      }
export function useTranslationJobsEstimatedCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranslationJobsEstimatedCostQuery, TranslationJobsEstimatedCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranslationJobsEstimatedCostQuery, TranslationJobsEstimatedCostQueryVariables>(TranslationJobsEstimatedCostDocument, options);
        }
export function useTranslationJobsEstimatedCostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranslationJobsEstimatedCostQuery, TranslationJobsEstimatedCostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TranslationJobsEstimatedCostQuery, TranslationJobsEstimatedCostQueryVariables>(TranslationJobsEstimatedCostDocument, options);
        }
export type TranslationJobsEstimatedCostQueryHookResult = ReturnType<typeof useTranslationJobsEstimatedCostQuery>;
export type TranslationJobsEstimatedCostLazyQueryHookResult = ReturnType<typeof useTranslationJobsEstimatedCostLazyQuery>;
export type TranslationJobsEstimatedCostSuspenseQueryHookResult = ReturnType<typeof useTranslationJobsEstimatedCostSuspenseQuery>;
export type TranslationJobsEstimatedCostQueryResult = Apollo.QueryResult<TranslationJobsEstimatedCostQuery, TranslationJobsEstimatedCostQueryVariables>;
export const UserDocument = gql`
    query User($id: String!) {
  user(id: $id) {
    app_metadata
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersDocument = gql`
    query Users {
  users {
    app_metadata
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const VerticalsDocument = gql`
    query Verticals($where: VerticalWhereInput, $take: Int, $skip: Int, $orderBy: [VerticalOrderByWithRelationInput!], $defaultLanguageId: String!) {
  verticals(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    createdAt
    sites {
      id
      url
      language {
        id
        languageTag
        countryCode
      }
    }
    content(
      where: {status: {in: [APPROVED, DRAFT]}, languageId: {equals: $defaultLanguageId}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
  count: verticalCount(where: $where)
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useVerticalsQuery__
 *
 * To run a query within a React component, call `useVerticalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useVerticalsQuery(baseOptions: Apollo.QueryHookOptions<VerticalsQuery, VerticalsQueryVariables> & ({ variables: VerticalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalsQuery, VerticalsQueryVariables>(VerticalsDocument, options);
      }
export function useVerticalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalsQuery, VerticalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalsQuery, VerticalsQueryVariables>(VerticalsDocument, options);
        }
export function useVerticalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalsQuery, VerticalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalsQuery, VerticalsQueryVariables>(VerticalsDocument, options);
        }
export type VerticalsQueryHookResult = ReturnType<typeof useVerticalsQuery>;
export type VerticalsLazyQueryHookResult = ReturnType<typeof useVerticalsLazyQuery>;
export type VerticalsSuspenseQueryHookResult = ReturnType<typeof useVerticalsSuspenseQuery>;
export type VerticalsQueryResult = Apollo.QueryResult<VerticalsQuery, VerticalsQueryVariables>;
export const VerticalsSlimDocument = gql`
    query VerticalsSlim($where: VerticalWhereInput, $take: Int, $skip: Int, $orderBy: [VerticalOrderByWithRelationInput!], $defaultLanguageId: String!) {
  verticals(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    id
    network {
      id
    }
    content(
      where: {key: {in: ["name", "abbreviated-name"]}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED]}}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useVerticalsSlimQuery__
 *
 * To run a query within a React component, call `useVerticalsSlimQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalsSlimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalsSlimQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useVerticalsSlimQuery(baseOptions: Apollo.QueryHookOptions<VerticalsSlimQuery, VerticalsSlimQueryVariables> & ({ variables: VerticalsSlimQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalsSlimQuery, VerticalsSlimQueryVariables>(VerticalsSlimDocument, options);
      }
export function useVerticalsSlimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalsSlimQuery, VerticalsSlimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalsSlimQuery, VerticalsSlimQueryVariables>(VerticalsSlimDocument, options);
        }
export function useVerticalsSlimSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalsSlimQuery, VerticalsSlimQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalsSlimQuery, VerticalsSlimQueryVariables>(VerticalsSlimDocument, options);
        }
export type VerticalsSlimQueryHookResult = ReturnType<typeof useVerticalsSlimQuery>;
export type VerticalsSlimLazyQueryHookResult = ReturnType<typeof useVerticalsSlimLazyQuery>;
export type VerticalsSlimSuspenseQueryHookResult = ReturnType<typeof useVerticalsSlimSuspenseQuery>;
export type VerticalsSlimQueryResult = Apollo.QueryResult<VerticalsSlimQuery, VerticalsSlimQueryVariables>;
export const DeleteAuthorDocument = gql`
    mutation DeleteAuthor($where: RouteResourceWhereUniqueInput!) {
  deleteAuthor(where: $where) {
    id
  }
}
    `;
export type DeleteAuthorMutationFn = Apollo.MutationFunction<DeleteAuthorMutation, DeleteAuthorMutationVariables>;

/**
 * __useDeleteAuthorMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorMutation, { data, loading, error }] = useDeleteAuthorMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteAuthorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAuthorMutation, DeleteAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAuthorMutation, DeleteAuthorMutationVariables>(DeleteAuthorDocument, options);
      }
export type DeleteAuthorMutationHookResult = ReturnType<typeof useDeleteAuthorMutation>;
export type DeleteAuthorMutationResult = Apollo.MutationResult<DeleteAuthorMutation>;
export type DeleteAuthorMutationOptions = Apollo.BaseMutationOptions<DeleteAuthorMutation, DeleteAuthorMutationVariables>;
export const AuthorDocument = gql`
    query Author($where: RouteResourceWhereUniqueInput!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!, $currentLanguageId: String!, $defaultLanguageId: String!) {
  author(where: $where) {
    ...AuthorCrudFragment
  }
}
    ${AuthorCrudFragmentFragmentDoc}`;

/**
 * __useAuthorQuery__
 *
 * To run a query within a React component, call `useAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useAuthorQuery(baseOptions: Apollo.QueryHookOptions<AuthorQuery, AuthorQueryVariables> & ({ variables: AuthorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorQuery, AuthorQueryVariables>(AuthorDocument, options);
      }
export function useAuthorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorQuery, AuthorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorQuery, AuthorQueryVariables>(AuthorDocument, options);
        }
export function useAuthorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorQuery, AuthorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorQuery, AuthorQueryVariables>(AuthorDocument, options);
        }
export type AuthorQueryHookResult = ReturnType<typeof useAuthorQuery>;
export type AuthorLazyQueryHookResult = ReturnType<typeof useAuthorLazyQuery>;
export type AuthorSuspenseQueryHookResult = ReturnType<typeof useAuthorSuspenseQuery>;
export type AuthorQueryResult = Apollo.QueryResult<AuthorQuery, AuthorQueryVariables>;
export const DynamicListAuthorsDocument = gql`
    query DynamicListAuthors($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: authorsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  authors: authorsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(where: {key: {in: $contentKeys}}) {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;

/**
 * __useDynamicListAuthorsQuery__
 *
 * To run a query within a React component, call `useDynamicListAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListAuthorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useDynamicListAuthorsQuery(baseOptions?: Apollo.QueryHookOptions<DynamicListAuthorsQuery, DynamicListAuthorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListAuthorsQuery, DynamicListAuthorsQueryVariables>(DynamicListAuthorsDocument, options);
      }
export function useDynamicListAuthorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListAuthorsQuery, DynamicListAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListAuthorsQuery, DynamicListAuthorsQueryVariables>(DynamicListAuthorsDocument, options);
        }
export function useDynamicListAuthorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListAuthorsQuery, DynamicListAuthorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListAuthorsQuery, DynamicListAuthorsQueryVariables>(DynamicListAuthorsDocument, options);
        }
export type DynamicListAuthorsQueryHookResult = ReturnType<typeof useDynamicListAuthorsQuery>;
export type DynamicListAuthorsLazyQueryHookResult = ReturnType<typeof useDynamicListAuthorsLazyQuery>;
export type DynamicListAuthorsSuspenseQueryHookResult = ReturnType<typeof useDynamicListAuthorsSuspenseQuery>;
export type DynamicListAuthorsQueryResult = Apollo.QueryResult<DynamicListAuthorsQuery, DynamicListAuthorsQueryVariables>;
export const UpsertAuthorDocument = gql`
    mutation UpsertAuthor($where: RouteResourceWhereUniqueInput!, $data: AuthorUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertAuthor(where: $where, data: $data, current: $current) {
    ...AuthorCrudFragment
  }
}
    ${AuthorCrudFragmentFragmentDoc}`;
export type UpsertAuthorMutationFn = Apollo.MutationFunction<UpsertAuthorMutation, UpsertAuthorMutationVariables>;

/**
 * __useUpsertAuthorMutation__
 *
 * To run a mutation, you first call `useUpsertAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAuthorMutation, { data, loading, error }] = useUpsertAuthorMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useUpsertAuthorMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAuthorMutation, UpsertAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAuthorMutation, UpsertAuthorMutationVariables>(UpsertAuthorDocument, options);
      }
export type UpsertAuthorMutationHookResult = ReturnType<typeof useUpsertAuthorMutation>;
export type UpsertAuthorMutationResult = Apollo.MutationResult<UpsertAuthorMutation>;
export type UpsertAuthorMutationOptions = Apollo.BaseMutationOptions<UpsertAuthorMutation, UpsertAuthorMutationVariables>;
export const CompaniesDocument = gql`
    query Companies($where: CompanyWhereInput, $take: Int, $skip: Int, $orderBy: [CompanyOrderByWithRelationInput!], $defaultLanguageId: String!) {
  companies(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
    ...CompanyFragment
  }
}
    ${CompanyFragmentFragmentDoc}`;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      orderBy: // value for 'orderBy'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions: Apollo.QueryHookOptions<CompaniesQuery, CompaniesQueryVariables> & ({ variables: CompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
      }
export function useCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export function useCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesQuery, CompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesQuery, CompaniesQueryVariables>(CompaniesDocument, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQueryHookResult = ReturnType<typeof useCompaniesLazyQuery>;
export type CompaniesSuspenseQueryHookResult = ReturnType<typeof useCompaniesSuspenseQuery>;
export type CompaniesQueryResult = Apollo.QueryResult<CompaniesQuery, CompaniesQueryVariables>;
export const CompanyDocument = gql`
    query Company($where: CompanyWhereUniqueInput!, $defaultLanguageId: String!) {
  company(where: $where) {
    ...CompanyFragment
  }
}
    ${CompanyFragmentFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables> & ({ variables: CompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export function useCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanySuspenseQueryHookResult = ReturnType<typeof useCompanySuspenseQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const UpsertCompanyDocument = gql`
    mutation UpsertCompany($where: CompanyWhereUniqueInput!, $create: CompanyCreateInput!, $update: CompanyUpdateInput!, $defaultLanguageId: String!) {
  upsertCompany(where: $where, create: $create, update: $update) {
    ...CompanyFragment
  }
}
    ${CompanyFragmentFragmentDoc}`;
export type UpsertCompanyMutationFn = Apollo.MutationFunction<UpsertCompanyMutation, UpsertCompanyMutationVariables>;

/**
 * __useUpsertCompanyMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyMutation, { data, loading, error }] = useUpsertCompanyMutation({
 *   variables: {
 *      where: // value for 'where'
 *      create: // value for 'create'
 *      update: // value for 'update'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useUpsertCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyMutation, UpsertCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyMutation, UpsertCompanyMutationVariables>(UpsertCompanyDocument, options);
      }
export type UpsertCompanyMutationHookResult = ReturnType<typeof useUpsertCompanyMutation>;
export type UpsertCompanyMutationResult = Apollo.MutationResult<UpsertCompanyMutation>;
export type UpsertCompanyMutationOptions = Apollo.BaseMutationOptions<UpsertCompanyMutation, UpsertCompanyMutationVariables>;
export const ComplianceRulesDocument = gql`
    query ComplianceRules($networkId: String!) {
  complianceRules: propertyItems(
    where: {key: {equals: "compliance-rules"}, Network: {id: {equals: $networkId}}}
  ) {
    ...PropertyItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}`;

/**
 * __useComplianceRulesQuery__
 *
 * To run a query within a React component, call `useComplianceRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceRulesQuery({
 *   variables: {
 *      networkId: // value for 'networkId'
 *   },
 * });
 */
export function useComplianceRulesQuery(baseOptions: Apollo.QueryHookOptions<ComplianceRulesQuery, ComplianceRulesQueryVariables> & ({ variables: ComplianceRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceRulesQuery, ComplianceRulesQueryVariables>(ComplianceRulesDocument, options);
      }
export function useComplianceRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceRulesQuery, ComplianceRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceRulesQuery, ComplianceRulesQueryVariables>(ComplianceRulesDocument, options);
        }
export function useComplianceRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ComplianceRulesQuery, ComplianceRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ComplianceRulesQuery, ComplianceRulesQueryVariables>(ComplianceRulesDocument, options);
        }
export type ComplianceRulesQueryHookResult = ReturnType<typeof useComplianceRulesQuery>;
export type ComplianceRulesLazyQueryHookResult = ReturnType<typeof useComplianceRulesLazyQuery>;
export type ComplianceRulesSuspenseQueryHookResult = ReturnType<typeof useComplianceRulesSuspenseQuery>;
export type ComplianceRulesQueryResult = Apollo.QueryResult<ComplianceRulesQuery, ComplianceRulesQueryVariables>;
export const UpdatePropertyItemDocument = gql`
    mutation UpdatePropertyItem($where: PropertyItemWhereUniqueInput!, $data: PropertyItemUpdateInput!) {
  updatePropertyItem(where: $where, data: $data) {
    ...PropertyItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}`;
export type UpdatePropertyItemMutationFn = Apollo.MutationFunction<UpdatePropertyItemMutation, UpdatePropertyItemMutationVariables>;

/**
 * __useUpdatePropertyItemMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyItemMutation, { data, loading, error }] = useUpdatePropertyItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePropertyItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyItemMutation, UpdatePropertyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyItemMutation, UpdatePropertyItemMutationVariables>(UpdatePropertyItemDocument, options);
      }
export type UpdatePropertyItemMutationHookResult = ReturnType<typeof useUpdatePropertyItemMutation>;
export type UpdatePropertyItemMutationResult = Apollo.MutationResult<UpdatePropertyItemMutation>;
export type UpdatePropertyItemMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyItemMutation, UpdatePropertyItemMutationVariables>;
export const AuthorsForExportDocument = gql`
    query AuthorsForExport($where: RouteResourceWhereInput) {
  resources: authors(where: $where) {
    id
    properties(where: {key: {equals: "name"}}) {
      id
      key
      data
    }
  }
}
    `;

/**
 * __useAuthorsForExportQuery__
 *
 * To run a query within a React component, call `useAuthorsForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorsForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorsForExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAuthorsForExportQuery(baseOptions?: Apollo.QueryHookOptions<AuthorsForExportQuery, AuthorsForExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorsForExportQuery, AuthorsForExportQueryVariables>(AuthorsForExportDocument, options);
      }
export function useAuthorsForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorsForExportQuery, AuthorsForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorsForExportQuery, AuthorsForExportQueryVariables>(AuthorsForExportDocument, options);
        }
export function useAuthorsForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthorsForExportQuery, AuthorsForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthorsForExportQuery, AuthorsForExportQueryVariables>(AuthorsForExportDocument, options);
        }
export type AuthorsForExportQueryHookResult = ReturnType<typeof useAuthorsForExportQuery>;
export type AuthorsForExportLazyQueryHookResult = ReturnType<typeof useAuthorsForExportLazyQuery>;
export type AuthorsForExportSuspenseQueryHookResult = ReturnType<typeof useAuthorsForExportSuspenseQuery>;
export type AuthorsForExportQueryResult = Apollo.QueryResult<AuthorsForExportQuery, AuthorsForExportQueryVariables>;
export const FilterTaxonomyItemsForExportDocument = gql`
    query filterTaxonomyItemsForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: filterTaxonomyItems(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useFilterTaxonomyItemsForExportQuery__
 *
 * To run a query within a React component, call `useFilterTaxonomyItemsForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterTaxonomyItemsForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterTaxonomyItemsForExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useFilterTaxonomyItemsForExportQuery(baseOptions: Apollo.QueryHookOptions<FilterTaxonomyItemsForExportQuery, FilterTaxonomyItemsForExportQueryVariables> & ({ variables: FilterTaxonomyItemsForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterTaxonomyItemsForExportQuery, FilterTaxonomyItemsForExportQueryVariables>(FilterTaxonomyItemsForExportDocument, options);
      }
export function useFilterTaxonomyItemsForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterTaxonomyItemsForExportQuery, FilterTaxonomyItemsForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterTaxonomyItemsForExportQuery, FilterTaxonomyItemsForExportQueryVariables>(FilterTaxonomyItemsForExportDocument, options);
        }
export function useFilterTaxonomyItemsForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilterTaxonomyItemsForExportQuery, FilterTaxonomyItemsForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilterTaxonomyItemsForExportQuery, FilterTaxonomyItemsForExportQueryVariables>(FilterTaxonomyItemsForExportDocument, options);
        }
export type FilterTaxonomyItemsForExportQueryHookResult = ReturnType<typeof useFilterTaxonomyItemsForExportQuery>;
export type FilterTaxonomyItemsForExportLazyQueryHookResult = ReturnType<typeof useFilterTaxonomyItemsForExportLazyQuery>;
export type FilterTaxonomyItemsForExportSuspenseQueryHookResult = ReturnType<typeof useFilterTaxonomyItemsForExportSuspenseQuery>;
export type FilterTaxonomyItemsForExportQueryResult = Apollo.QueryResult<FilterTaxonomyItemsForExportQuery, FilterTaxonomyItemsForExportQueryVariables>;
export const PagesForExportDocument = gql`
    query pagesForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: pages(where: $where) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __usePagesForExportQuery__
 *
 * To run a query within a React component, call `usePagesForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesForExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function usePagesForExportQuery(baseOptions: Apollo.QueryHookOptions<PagesForExportQuery, PagesForExportQueryVariables> & ({ variables: PagesForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesForExportQuery, PagesForExportQueryVariables>(PagesForExportDocument, options);
      }
export function usePagesForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesForExportQuery, PagesForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesForExportQuery, PagesForExportQueryVariables>(PagesForExportDocument, options);
        }
export function usePagesForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PagesForExportQuery, PagesForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PagesForExportQuery, PagesForExportQueryVariables>(PagesForExportDocument, options);
        }
export type PagesForExportQueryHookResult = ReturnType<typeof usePagesForExportQuery>;
export type PagesForExportLazyQueryHookResult = ReturnType<typeof usePagesForExportLazyQuery>;
export type PagesForExportSuspenseQueryHookResult = ReturnType<typeof usePagesForExportSuspenseQuery>;
export type PagesForExportQueryResult = Apollo.QueryResult<PagesForExportQuery, PagesForExportQueryVariables>;
export const PostsForExportDocument = gql`
    query postsForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: posts(where: $where) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __usePostsForExportQuery__
 *
 * To run a query within a React component, call `usePostsForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsForExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function usePostsForExportQuery(baseOptions: Apollo.QueryHookOptions<PostsForExportQuery, PostsForExportQueryVariables> & ({ variables: PostsForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsForExportQuery, PostsForExportQueryVariables>(PostsForExportDocument, options);
      }
export function usePostsForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsForExportQuery, PostsForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsForExportQuery, PostsForExportQueryVariables>(PostsForExportDocument, options);
        }
export function usePostsForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostsForExportQuery, PostsForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostsForExportQuery, PostsForExportQueryVariables>(PostsForExportDocument, options);
        }
export type PostsForExportQueryHookResult = ReturnType<typeof usePostsForExportQuery>;
export type PostsForExportLazyQueryHookResult = ReturnType<typeof usePostsForExportLazyQuery>;
export type PostsForExportSuspenseQueryHookResult = ReturnType<typeof usePostsForExportSuspenseQuery>;
export type PostsForExportQueryResult = Apollo.QueryResult<PostsForExportQuery, PostsForExportQueryVariables>;
export const ProductsForExportDocument = gql`
    query productsForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: products(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "software-taxonomies"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useProductsForExportQuery__
 *
 * To run a query within a React component, call `useProductsForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsForExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useProductsForExportQuery(baseOptions: Apollo.QueryHookOptions<ProductsForExportQuery, ProductsForExportQueryVariables> & ({ variables: ProductsForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsForExportQuery, ProductsForExportQueryVariables>(ProductsForExportDocument, options);
      }
export function useProductsForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsForExportQuery, ProductsForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsForExportQuery, ProductsForExportQueryVariables>(ProductsForExportDocument, options);
        }
export function useProductsForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsForExportQuery, ProductsForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsForExportQuery, ProductsForExportQueryVariables>(ProductsForExportDocument, options);
        }
export type ProductsForExportQueryHookResult = ReturnType<typeof useProductsForExportQuery>;
export type ProductsForExportLazyQueryHookResult = ReturnType<typeof useProductsForExportLazyQuery>;
export type ProductsForExportSuspenseQueryHookResult = ReturnType<typeof useProductsForExportSuspenseQuery>;
export type ProductsForExportQueryResult = Apollo.QueryResult<ProductsForExportQuery, ProductsForExportQueryVariables>;
export const ProviderTaxonomyConnectionsForExportDocument = gql`
    query ProviderTaxonomyConnectionsForExport($where: ProviderTaxonomyConnectionWhereInput) {
  resources: providerTaxonomyConnections(where: $where) {
    id
    providerId
    taxonomyItemId
  }
}
    `;

/**
 * __useProviderTaxonomyConnectionsForExportQuery__
 *
 * To run a query within a React component, call `useProviderTaxonomyConnectionsForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderTaxonomyConnectionsForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderTaxonomyConnectionsForExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProviderTaxonomyConnectionsForExportQuery(baseOptions?: Apollo.QueryHookOptions<ProviderTaxonomyConnectionsForExportQuery, ProviderTaxonomyConnectionsForExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderTaxonomyConnectionsForExportQuery, ProviderTaxonomyConnectionsForExportQueryVariables>(ProviderTaxonomyConnectionsForExportDocument, options);
      }
export function useProviderTaxonomyConnectionsForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderTaxonomyConnectionsForExportQuery, ProviderTaxonomyConnectionsForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderTaxonomyConnectionsForExportQuery, ProviderTaxonomyConnectionsForExportQueryVariables>(ProviderTaxonomyConnectionsForExportDocument, options);
        }
export function useProviderTaxonomyConnectionsForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderTaxonomyConnectionsForExportQuery, ProviderTaxonomyConnectionsForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderTaxonomyConnectionsForExportQuery, ProviderTaxonomyConnectionsForExportQueryVariables>(ProviderTaxonomyConnectionsForExportDocument, options);
        }
export type ProviderTaxonomyConnectionsForExportQueryHookResult = ReturnType<typeof useProviderTaxonomyConnectionsForExportQuery>;
export type ProviderTaxonomyConnectionsForExportLazyQueryHookResult = ReturnType<typeof useProviderTaxonomyConnectionsForExportLazyQuery>;
export type ProviderTaxonomyConnectionsForExportSuspenseQueryHookResult = ReturnType<typeof useProviderTaxonomyConnectionsForExportSuspenseQuery>;
export type ProviderTaxonomyConnectionsForExportQueryResult = Apollo.QueryResult<ProviderTaxonomyConnectionsForExportQuery, ProviderTaxonomyConnectionsForExportQueryVariables>;
export const ProvidersForExportDocument = gql`
    query ProvidersForExport($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  resources: providers(where: $where) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published"]}}) {
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useProvidersForExportQuery__
 *
 * To run a query within a React component, call `useProvidersForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersForExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useProvidersForExportQuery(baseOptions: Apollo.QueryHookOptions<ProvidersForExportQuery, ProvidersForExportQueryVariables> & ({ variables: ProvidersForExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvidersForExportQuery, ProvidersForExportQueryVariables>(ProvidersForExportDocument, options);
      }
export function useProvidersForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvidersForExportQuery, ProvidersForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvidersForExportQuery, ProvidersForExportQueryVariables>(ProvidersForExportDocument, options);
        }
export function useProvidersForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProvidersForExportQuery, ProvidersForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProvidersForExportQuery, ProvidersForExportQueryVariables>(ProvidersForExportDocument, options);
        }
export type ProvidersForExportQueryHookResult = ReturnType<typeof useProvidersForExportQuery>;
export type ProvidersForExportLazyQueryHookResult = ReturnType<typeof useProvidersForExportLazyQuery>;
export type ProvidersForExportSuspenseQueryHookResult = ReturnType<typeof useProvidersForExportSuspenseQuery>;
export type ProvidersForExportQueryResult = Apollo.QueryResult<ProvidersForExportQuery, ProvidersForExportQueryVariables>;
export const SitesForExportDocument = gql`
    query sitesForExport($where: SiteWhereInput) {
  resources: sites(where: $where) {
    id
    properties(where: {key: {equals: "name"}}) {
      id
      key
      data
    }
  }
}
    `;

/**
 * __useSitesForExportQuery__
 *
 * To run a query within a React component, call `useSitesForExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesForExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesForExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSitesForExportQuery(baseOptions?: Apollo.QueryHookOptions<SitesForExportQuery, SitesForExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesForExportQuery, SitesForExportQueryVariables>(SitesForExportDocument, options);
      }
export function useSitesForExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesForExportQuery, SitesForExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesForExportQuery, SitesForExportQueryVariables>(SitesForExportDocument, options);
        }
export function useSitesForExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitesForExportQuery, SitesForExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesForExportQuery, SitesForExportQueryVariables>(SitesForExportDocument, options);
        }
export type SitesForExportQueryHookResult = ReturnType<typeof useSitesForExportQuery>;
export type SitesForExportLazyQueryHookResult = ReturnType<typeof useSitesForExportLazyQuery>;
export type SitesForExportSuspenseQueryHookResult = ReturnType<typeof useSitesForExportSuspenseQuery>;
export type SitesForExportQueryResult = Apollo.QueryResult<SitesForExportQuery, SitesForExportQueryVariables>;
export const DeleteFilterTaxonomyItemDocument = gql`
    mutation DeleteFilterTaxonomyItem($where: RouteResourceWhereUniqueInput!) {
  deleteFilterTaxonomyItem(where: $where) {
    id
  }
}
    `;
export type DeleteFilterTaxonomyItemMutationFn = Apollo.MutationFunction<DeleteFilterTaxonomyItemMutation, DeleteFilterTaxonomyItemMutationVariables>;

/**
 * __useDeleteFilterTaxonomyItemMutation__
 *
 * To run a mutation, you first call `useDeleteFilterTaxonomyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilterTaxonomyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilterTaxonomyItemMutation, { data, loading, error }] = useDeleteFilterTaxonomyItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteFilterTaxonomyItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFilterTaxonomyItemMutation, DeleteFilterTaxonomyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFilterTaxonomyItemMutation, DeleteFilterTaxonomyItemMutationVariables>(DeleteFilterTaxonomyItemDocument, options);
      }
export type DeleteFilterTaxonomyItemMutationHookResult = ReturnType<typeof useDeleteFilterTaxonomyItemMutation>;
export type DeleteFilterTaxonomyItemMutationResult = Apollo.MutationResult<DeleteFilterTaxonomyItemMutation>;
export type DeleteFilterTaxonomyItemMutationOptions = Apollo.BaseMutationOptions<DeleteFilterTaxonomyItemMutation, DeleteFilterTaxonomyItemMutationVariables>;
export const FilterTaxonomyItemDocument = gql`
    query FilterTaxonomyItem($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  filterTaxonomyItem(where: $where) {
    ...FilterTaxonomyItemCrudFragment
  }
}
    ${FilterTaxonomyItemCrudFragmentFragmentDoc}`;

/**
 * __useFilterTaxonomyItemQuery__
 *
 * To run a query within a React component, call `useFilterTaxonomyItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterTaxonomyItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterTaxonomyItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useFilterTaxonomyItemQuery(baseOptions: Apollo.QueryHookOptions<FilterTaxonomyItemQuery, FilterTaxonomyItemQueryVariables> & ({ variables: FilterTaxonomyItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterTaxonomyItemQuery, FilterTaxonomyItemQueryVariables>(FilterTaxonomyItemDocument, options);
      }
export function useFilterTaxonomyItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterTaxonomyItemQuery, FilterTaxonomyItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterTaxonomyItemQuery, FilterTaxonomyItemQueryVariables>(FilterTaxonomyItemDocument, options);
        }
export function useFilterTaxonomyItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilterTaxonomyItemQuery, FilterTaxonomyItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilterTaxonomyItemQuery, FilterTaxonomyItemQueryVariables>(FilterTaxonomyItemDocument, options);
        }
export type FilterTaxonomyItemQueryHookResult = ReturnType<typeof useFilterTaxonomyItemQuery>;
export type FilterTaxonomyItemLazyQueryHookResult = ReturnType<typeof useFilterTaxonomyItemLazyQuery>;
export type FilterTaxonomyItemSuspenseQueryHookResult = ReturnType<typeof useFilterTaxonomyItemSuspenseQuery>;
export type FilterTaxonomyItemQueryResult = Apollo.QueryResult<FilterTaxonomyItemQuery, FilterTaxonomyItemQueryVariables>;
export const DynamicListFilterTaxonomyItemsDocument = gql`
    query DynamicListFilterTaxonomyItems($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: filterTaxonomyItemsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  filterTaxonomyItems: filterTaxonomyItemsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    subtype
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(where: {key: {in: $contentKeys}}) {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;

/**
 * __useDynamicListFilterTaxonomyItemsQuery__
 *
 * To run a query within a React component, call `useDynamicListFilterTaxonomyItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListFilterTaxonomyItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListFilterTaxonomyItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useDynamicListFilterTaxonomyItemsQuery(baseOptions?: Apollo.QueryHookOptions<DynamicListFilterTaxonomyItemsQuery, DynamicListFilterTaxonomyItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListFilterTaxonomyItemsQuery, DynamicListFilterTaxonomyItemsQueryVariables>(DynamicListFilterTaxonomyItemsDocument, options);
      }
export function useDynamicListFilterTaxonomyItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListFilterTaxonomyItemsQuery, DynamicListFilterTaxonomyItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListFilterTaxonomyItemsQuery, DynamicListFilterTaxonomyItemsQueryVariables>(DynamicListFilterTaxonomyItemsDocument, options);
        }
export function useDynamicListFilterTaxonomyItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListFilterTaxonomyItemsQuery, DynamicListFilterTaxonomyItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListFilterTaxonomyItemsQuery, DynamicListFilterTaxonomyItemsQueryVariables>(DynamicListFilterTaxonomyItemsDocument, options);
        }
export type DynamicListFilterTaxonomyItemsQueryHookResult = ReturnType<typeof useDynamicListFilterTaxonomyItemsQuery>;
export type DynamicListFilterTaxonomyItemsLazyQueryHookResult = ReturnType<typeof useDynamicListFilterTaxonomyItemsLazyQuery>;
export type DynamicListFilterTaxonomyItemsSuspenseQueryHookResult = ReturnType<typeof useDynamicListFilterTaxonomyItemsSuspenseQuery>;
export type DynamicListFilterTaxonomyItemsQueryResult = Apollo.QueryResult<DynamicListFilterTaxonomyItemsQuery, DynamicListFilterTaxonomyItemsQueryVariables>;
export const UpsertFilterTaxonomyItemDocument = gql`
    mutation UpsertFilterTaxonomyItem($where: RouteResourceWhereUniqueInput!, $data: FilterTaxonomyItemUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertFilterTaxonomyItem(where: $where, data: $data, current: $current) {
    ...FilterTaxonomyItemCrudFragment
  }
}
    ${FilterTaxonomyItemCrudFragmentFragmentDoc}`;
export type UpsertFilterTaxonomyItemMutationFn = Apollo.MutationFunction<UpsertFilterTaxonomyItemMutation, UpsertFilterTaxonomyItemMutationVariables>;

/**
 * __useUpsertFilterTaxonomyItemMutation__
 *
 * To run a mutation, you first call `useUpsertFilterTaxonomyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFilterTaxonomyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFilterTaxonomyItemMutation, { data, loading, error }] = useUpsertFilterTaxonomyItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useUpsertFilterTaxonomyItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFilterTaxonomyItemMutation, UpsertFilterTaxonomyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFilterTaxonomyItemMutation, UpsertFilterTaxonomyItemMutationVariables>(UpsertFilterTaxonomyItemDocument, options);
      }
export type UpsertFilterTaxonomyItemMutationHookResult = ReturnType<typeof useUpsertFilterTaxonomyItemMutation>;
export type UpsertFilterTaxonomyItemMutationResult = Apollo.MutationResult<UpsertFilterTaxonomyItemMutation>;
export type UpsertFilterTaxonomyItemMutationOptions = Apollo.BaseMutationOptions<UpsertFilterTaxonomyItemMutation, UpsertFilterTaxonomyItemMutationVariables>;
export const DeleteFilterTaxonomyRuleDocument = gql`
    mutation DeleteFilterTaxonomyRule($where: FilterTaxonomyRuleWhereUniqueInput!) {
  deleteFilterTaxonomyRule(where: $where) {
    id
  }
}
    `;
export type DeleteFilterTaxonomyRuleMutationFn = Apollo.MutationFunction<DeleteFilterTaxonomyRuleMutation, DeleteFilterTaxonomyRuleMutationVariables>;

/**
 * __useDeleteFilterTaxonomyRuleMutation__
 *
 * To run a mutation, you first call `useDeleteFilterTaxonomyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFilterTaxonomyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFilterTaxonomyRuleMutation, { data, loading, error }] = useDeleteFilterTaxonomyRuleMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteFilterTaxonomyRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFilterTaxonomyRuleMutation, DeleteFilterTaxonomyRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFilterTaxonomyRuleMutation, DeleteFilterTaxonomyRuleMutationVariables>(DeleteFilterTaxonomyRuleDocument, options);
      }
export type DeleteFilterTaxonomyRuleMutationHookResult = ReturnType<typeof useDeleteFilterTaxonomyRuleMutation>;
export type DeleteFilterTaxonomyRuleMutationResult = Apollo.MutationResult<DeleteFilterTaxonomyRuleMutation>;
export type DeleteFilterTaxonomyRuleMutationOptions = Apollo.BaseMutationOptions<DeleteFilterTaxonomyRuleMutation, DeleteFilterTaxonomyRuleMutationVariables>;
export const FilterTaxonomyRuleDocument = gql`
    query FilterTaxonomyRule($where: FilterTaxonomyRuleWhereUniqueInput!) {
  filterTaxonomyRule(where: $where) {
    ...FilterTaxonomyRuleFragment
  }
}
    ${FilterTaxonomyRuleFragmentFragmentDoc}`;

/**
 * __useFilterTaxonomyRuleQuery__
 *
 * To run a query within a React component, call `useFilterTaxonomyRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterTaxonomyRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterTaxonomyRuleQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFilterTaxonomyRuleQuery(baseOptions: Apollo.QueryHookOptions<FilterTaxonomyRuleQuery, FilterTaxonomyRuleQueryVariables> & ({ variables: FilterTaxonomyRuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterTaxonomyRuleQuery, FilterTaxonomyRuleQueryVariables>(FilterTaxonomyRuleDocument, options);
      }
export function useFilterTaxonomyRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterTaxonomyRuleQuery, FilterTaxonomyRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterTaxonomyRuleQuery, FilterTaxonomyRuleQueryVariables>(FilterTaxonomyRuleDocument, options);
        }
export function useFilterTaxonomyRuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilterTaxonomyRuleQuery, FilterTaxonomyRuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilterTaxonomyRuleQuery, FilterTaxonomyRuleQueryVariables>(FilterTaxonomyRuleDocument, options);
        }
export type FilterTaxonomyRuleQueryHookResult = ReturnType<typeof useFilterTaxonomyRuleQuery>;
export type FilterTaxonomyRuleLazyQueryHookResult = ReturnType<typeof useFilterTaxonomyRuleLazyQuery>;
export type FilterTaxonomyRuleSuspenseQueryHookResult = ReturnType<typeof useFilterTaxonomyRuleSuspenseQuery>;
export type FilterTaxonomyRuleQueryResult = Apollo.QueryResult<FilterTaxonomyRuleQuery, FilterTaxonomyRuleQueryVariables>;
export const DynamicListFilterTaxonomyRulesDocument = gql`
    query DynamicListFilterTaxonomyRules($where: FilterTaxonomyRuleWhereInput, $search: ResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [FilterTaxonomyRuleOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: filterTaxonomyRulesSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  filterTaxonomyRules: filterTaxonomyRulesSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(where: {key: {in: $contentKeys}}) {
      ...ContentItemFragment
    }
    taxonomyBase {
      id
      content(where: {key: {in: $contentKeys}}) {
        ...ContentItemFragment
      }
    }
    taxonomyFilter {
      id
      content(where: {key: {in: $contentKeys}}) {
        ...ContentItemFragment
      }
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;

/**
 * __useDynamicListFilterTaxonomyRulesQuery__
 *
 * To run a query within a React component, call `useDynamicListFilterTaxonomyRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListFilterTaxonomyRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListFilterTaxonomyRulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useDynamicListFilterTaxonomyRulesQuery(baseOptions?: Apollo.QueryHookOptions<DynamicListFilterTaxonomyRulesQuery, DynamicListFilterTaxonomyRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListFilterTaxonomyRulesQuery, DynamicListFilterTaxonomyRulesQueryVariables>(DynamicListFilterTaxonomyRulesDocument, options);
      }
export function useDynamicListFilterTaxonomyRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListFilterTaxonomyRulesQuery, DynamicListFilterTaxonomyRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListFilterTaxonomyRulesQuery, DynamicListFilterTaxonomyRulesQueryVariables>(DynamicListFilterTaxonomyRulesDocument, options);
        }
export function useDynamicListFilterTaxonomyRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListFilterTaxonomyRulesQuery, DynamicListFilterTaxonomyRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListFilterTaxonomyRulesQuery, DynamicListFilterTaxonomyRulesQueryVariables>(DynamicListFilterTaxonomyRulesDocument, options);
        }
export type DynamicListFilterTaxonomyRulesQueryHookResult = ReturnType<typeof useDynamicListFilterTaxonomyRulesQuery>;
export type DynamicListFilterTaxonomyRulesLazyQueryHookResult = ReturnType<typeof useDynamicListFilterTaxonomyRulesLazyQuery>;
export type DynamicListFilterTaxonomyRulesSuspenseQueryHookResult = ReturnType<typeof useDynamicListFilterTaxonomyRulesSuspenseQuery>;
export type DynamicListFilterTaxonomyRulesQueryResult = Apollo.QueryResult<DynamicListFilterTaxonomyRulesQuery, DynamicListFilterTaxonomyRulesQueryVariables>;
export const UpsertFilterTaxonomyRuleDocument = gql`
    mutation UpsertFilterTaxonomyRule($where: FilterTaxonomyRuleWhereUniqueInput!, $data: FilterTaxonomyRuleUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertFilterTaxonomyRule(where: $where, data: $data, current: $current) {
    ...FilterTaxonomyRuleFragment
  }
}
    ${FilterTaxonomyRuleFragmentFragmentDoc}`;
export type UpsertFilterTaxonomyRuleMutationFn = Apollo.MutationFunction<UpsertFilterTaxonomyRuleMutation, UpsertFilterTaxonomyRuleMutationVariables>;

/**
 * __useUpsertFilterTaxonomyRuleMutation__
 *
 * To run a mutation, you first call `useUpsertFilterTaxonomyRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFilterTaxonomyRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFilterTaxonomyRuleMutation, { data, loading, error }] = useUpsertFilterTaxonomyRuleMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useUpsertFilterTaxonomyRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFilterTaxonomyRuleMutation, UpsertFilterTaxonomyRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertFilterTaxonomyRuleMutation, UpsertFilterTaxonomyRuleMutationVariables>(UpsertFilterTaxonomyRuleDocument, options);
      }
export type UpsertFilterTaxonomyRuleMutationHookResult = ReturnType<typeof useUpsertFilterTaxonomyRuleMutation>;
export type UpsertFilterTaxonomyRuleMutationResult = Apollo.MutationResult<UpsertFilterTaxonomyRuleMutation>;
export type UpsertFilterTaxonomyRuleMutationOptions = Apollo.BaseMutationOptions<UpsertFilterTaxonomyRuleMutation, UpsertFilterTaxonomyRuleMutationVariables>;
export const CreateOrUpdateMenuDocument = gql`
    mutation CreateOrUpdateMenu($menu: MenuInput!, $menuItemsDelete: [String]) {
  upsertMenuCustom(menu: $menu, menuItemsDelete: $menuItemsDelete) {
    id
  }
}
    `;
export type CreateOrUpdateMenuMutationFn = Apollo.MutationFunction<CreateOrUpdateMenuMutation, CreateOrUpdateMenuMutationVariables>;

/**
 * __useCreateOrUpdateMenuMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateMenuMutation, { data, loading, error }] = useCreateOrUpdateMenuMutation({
 *   variables: {
 *      menu: // value for 'menu'
 *      menuItemsDelete: // value for 'menuItemsDelete'
 *   },
 * });
 */
export function useCreateOrUpdateMenuMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateMenuMutation, CreateOrUpdateMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateMenuMutation, CreateOrUpdateMenuMutationVariables>(CreateOrUpdateMenuDocument, options);
      }
export type CreateOrUpdateMenuMutationHookResult = ReturnType<typeof useCreateOrUpdateMenuMutation>;
export type CreateOrUpdateMenuMutationResult = Apollo.MutationResult<CreateOrUpdateMenuMutation>;
export type CreateOrUpdateMenuMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateMenuMutation, CreateOrUpdateMenuMutationVariables>;
export const DeleteMenuDocument = gql`
    mutation DeleteMenu($where: MenuWhereUniqueInput!) {
  deleteMenu(where: $where) {
    id
  }
}
    `;
export type DeleteMenuMutationFn = Apollo.MutationFunction<DeleteMenuMutation, DeleteMenuMutationVariables>;

/**
 * __useDeleteMenuMutation__
 *
 * To run a mutation, you first call `useDeleteMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenuMutation, { data, loading, error }] = useDeleteMenuMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteMenuMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenuMutation, DeleteMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenuMutation, DeleteMenuMutationVariables>(DeleteMenuDocument, options);
      }
export type DeleteMenuMutationHookResult = ReturnType<typeof useDeleteMenuMutation>;
export type DeleteMenuMutationResult = Apollo.MutationResult<DeleteMenuMutation>;
export type DeleteMenuMutationOptions = Apollo.BaseMutationOptions<DeleteMenuMutation, DeleteMenuMutationVariables>;
export const DeleteMenusDocument = gql`
    mutation DeleteMenus($where: MenuWhereInput!) {
  deleteMenus(where: $where) {
    count
  }
}
    `;
export type DeleteMenusMutationFn = Apollo.MutationFunction<DeleteMenusMutation, DeleteMenusMutationVariables>;

/**
 * __useDeleteMenusMutation__
 *
 * To run a mutation, you first call `useDeleteMenusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMenusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMenusMutation, { data, loading, error }] = useDeleteMenusMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteMenusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMenusMutation, DeleteMenusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMenusMutation, DeleteMenusMutationVariables>(DeleteMenusDocument, options);
      }
export type DeleteMenusMutationHookResult = ReturnType<typeof useDeleteMenusMutation>;
export type DeleteMenusMutationResult = Apollo.MutationResult<DeleteMenusMutation>;
export type DeleteMenusMutationOptions = Apollo.BaseMutationOptions<DeleteMenusMutation, DeleteMenusMutationVariables>;
export const LoadMenusDocument = gql`
    query LoadMenus($where: MenuWhereInput, $currentLanguageId: String!) {
  menus(where: $where) {
    id
    key
    items {
      id
      type
      index
      properties {
        id
        key
        type
        data
      }
      content(
        where: {languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
        orderBy: {status: asc}
      ) {
        ...ContentItemFragment
      }
      parent {
        id
      }
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useLoadMenusQuery__
 *
 * To run a query within a React component, call `useLoadMenusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadMenusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadMenusQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *   },
 * });
 */
export function useLoadMenusQuery(baseOptions: Apollo.QueryHookOptions<LoadMenusQuery, LoadMenusQueryVariables> & ({ variables: LoadMenusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadMenusQuery, LoadMenusQueryVariables>(LoadMenusDocument, options);
      }
export function useLoadMenusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadMenusQuery, LoadMenusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadMenusQuery, LoadMenusQueryVariables>(LoadMenusDocument, options);
        }
export function useLoadMenusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoadMenusQuery, LoadMenusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadMenusQuery, LoadMenusQueryVariables>(LoadMenusDocument, options);
        }
export type LoadMenusQueryHookResult = ReturnType<typeof useLoadMenusQuery>;
export type LoadMenusLazyQueryHookResult = ReturnType<typeof useLoadMenusLazyQuery>;
export type LoadMenusSuspenseQueryHookResult = ReturnType<typeof useLoadMenusSuspenseQuery>;
export type LoadMenusQueryResult = Apollo.QueryResult<LoadMenusQuery, LoadMenusQueryVariables>;
export const LoadMinifiedMenusWithSitesDocument = gql`
    query LoadMinifiedMenusWithSites($where: MenuWhereInput) {
  menus(where: $where) {
    id
    key
    site {
      id
      url
      properties(where: {key: {equals: "name"}}) {
        id
        key
        data
      }
      language {
        id
        countryCode
        languageTag
      }
    }
  }
}
    `;

/**
 * __useLoadMinifiedMenusWithSitesQuery__
 *
 * To run a query within a React component, call `useLoadMinifiedMenusWithSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadMinifiedMenusWithSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadMinifiedMenusWithSitesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoadMinifiedMenusWithSitesQuery(baseOptions?: Apollo.QueryHookOptions<LoadMinifiedMenusWithSitesQuery, LoadMinifiedMenusWithSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadMinifiedMenusWithSitesQuery, LoadMinifiedMenusWithSitesQueryVariables>(LoadMinifiedMenusWithSitesDocument, options);
      }
export function useLoadMinifiedMenusWithSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadMinifiedMenusWithSitesQuery, LoadMinifiedMenusWithSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadMinifiedMenusWithSitesQuery, LoadMinifiedMenusWithSitesQueryVariables>(LoadMinifiedMenusWithSitesDocument, options);
        }
export function useLoadMinifiedMenusWithSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoadMinifiedMenusWithSitesQuery, LoadMinifiedMenusWithSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoadMinifiedMenusWithSitesQuery, LoadMinifiedMenusWithSitesQueryVariables>(LoadMinifiedMenusWithSitesDocument, options);
        }
export type LoadMinifiedMenusWithSitesQueryHookResult = ReturnType<typeof useLoadMinifiedMenusWithSitesQuery>;
export type LoadMinifiedMenusWithSitesLazyQueryHookResult = ReturnType<typeof useLoadMinifiedMenusWithSitesLazyQuery>;
export type LoadMinifiedMenusWithSitesSuspenseQueryHookResult = ReturnType<typeof useLoadMinifiedMenusWithSitesSuspenseQuery>;
export type LoadMinifiedMenusWithSitesQueryResult = Apollo.QueryResult<LoadMinifiedMenusWithSitesQuery, LoadMinifiedMenusWithSitesQueryVariables>;
export const MenuPagesDocument = gql`
    query MenuPages($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  pages(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "icon"]}}) {
      id
      key
      data
      resolvedData {
        ... on MediaItem {
          url
        }
      }
    }
  }
  count: pageCount(where: $where)
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMenuPagesQuery__
 *
 * To run a query within a React component, call `useMenuPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuPagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useMenuPagesQuery(baseOptions: Apollo.QueryHookOptions<MenuPagesQuery, MenuPagesQueryVariables> & ({ variables: MenuPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuPagesQuery, MenuPagesQueryVariables>(MenuPagesDocument, options);
      }
export function useMenuPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuPagesQuery, MenuPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuPagesQuery, MenuPagesQueryVariables>(MenuPagesDocument, options);
        }
export function useMenuPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuPagesQuery, MenuPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuPagesQuery, MenuPagesQueryVariables>(MenuPagesDocument, options);
        }
export type MenuPagesQueryHookResult = ReturnType<typeof useMenuPagesQuery>;
export type MenuPagesLazyQueryHookResult = ReturnType<typeof useMenuPagesLazyQuery>;
export type MenuPagesSuspenseQueryHookResult = ReturnType<typeof useMenuPagesSuspenseQuery>;
export type MenuPagesQueryResult = Apollo.QueryResult<MenuPagesQuery, MenuPagesQueryVariables>;
export const MenuPostsDocument = gql`
    query MenuPosts($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  posts(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "title"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {in: ["published", "icon"]}}) {
      id
      key
      data
      resolvedData {
        ... on MediaItem {
          url
        }
      }
    }
  }
  count: postCount(where: $where)
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMenuPostsQuery__
 *
 * To run a query within a React component, call `useMenuPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuPostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useMenuPostsQuery(baseOptions: Apollo.QueryHookOptions<MenuPostsQuery, MenuPostsQueryVariables> & ({ variables: MenuPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuPostsQuery, MenuPostsQueryVariables>(MenuPostsDocument, options);
      }
export function useMenuPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuPostsQuery, MenuPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuPostsQuery, MenuPostsQueryVariables>(MenuPostsDocument, options);
        }
export function useMenuPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuPostsQuery, MenuPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuPostsQuery, MenuPostsQueryVariables>(MenuPostsDocument, options);
        }
export type MenuPostsQueryHookResult = ReturnType<typeof useMenuPostsQuery>;
export type MenuPostsLazyQueryHookResult = ReturnType<typeof useMenuPostsLazyQuery>;
export type MenuPostsSuspenseQueryHookResult = ReturnType<typeof useMenuPostsSuspenseQuery>;
export type MenuPostsQueryResult = Apollo.QueryResult<MenuPostsQuery, MenuPostsQueryVariables>;
export const MenuProvidersDocument = gql`
    query MenuProviders($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  providers(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
    properties(where: {key: {equals: "published"}}) {
      id
      key
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMenuProvidersQuery__
 *
 * To run a query within a React component, call `useMenuProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuProvidersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useMenuProvidersQuery(baseOptions: Apollo.QueryHookOptions<MenuProvidersQuery, MenuProvidersQueryVariables> & ({ variables: MenuProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuProvidersQuery, MenuProvidersQueryVariables>(MenuProvidersDocument, options);
      }
export function useMenuProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuProvidersQuery, MenuProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuProvidersQuery, MenuProvidersQueryVariables>(MenuProvidersDocument, options);
        }
export function useMenuProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MenuProvidersQuery, MenuProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MenuProvidersQuery, MenuProvidersQueryVariables>(MenuProvidersDocument, options);
        }
export type MenuProvidersQueryHookResult = ReturnType<typeof useMenuProvidersQuery>;
export type MenuProvidersLazyQueryHookResult = ReturnType<typeof useMenuProvidersLazyQuery>;
export type MenuProvidersSuspenseQueryHookResult = ReturnType<typeof useMenuProvidersSuspenseQuery>;
export type MenuProvidersQueryResult = Apollo.QueryResult<MenuProvidersQuery, MenuProvidersQueryVariables>;
export const AllSitesInNetworkDocument = gql`
    query AllSitesInNetwork($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    language {
      id
      languageTag
    }
  }
}
    `;

/**
 * __useAllSitesInNetworkQuery__
 *
 * To run a query within a React component, call `useAllSitesInNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSitesInNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSitesInNetworkQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useAllSitesInNetworkQuery(baseOptions?: Apollo.QueryHookOptions<AllSitesInNetworkQuery, AllSitesInNetworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSitesInNetworkQuery, AllSitesInNetworkQueryVariables>(AllSitesInNetworkDocument, options);
      }
export function useAllSitesInNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSitesInNetworkQuery, AllSitesInNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSitesInNetworkQuery, AllSitesInNetworkQueryVariables>(AllSitesInNetworkDocument, options);
        }
export function useAllSitesInNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSitesInNetworkQuery, AllSitesInNetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSitesInNetworkQuery, AllSitesInNetworkQueryVariables>(AllSitesInNetworkDocument, options);
        }
export type AllSitesInNetworkQueryHookResult = ReturnType<typeof useAllSitesInNetworkQuery>;
export type AllSitesInNetworkLazyQueryHookResult = ReturnType<typeof useAllSitesInNetworkLazyQuery>;
export type AllSitesInNetworkSuspenseQueryHookResult = ReturnType<typeof useAllSitesInNetworkSuspenseQuery>;
export type AllSitesInNetworkQueryResult = Apollo.QueryResult<AllSitesInNetworkQuery, AllSitesInNetworkQueryVariables>;
export const MetaProductDocument = gql`
    query MetaProduct($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!) {
  product(where: $where) {
    id
    subtype
    content(
      where: {OR: [{field: {displayType: {in: [META, UI]}}}, {field: {key: {equals: "name"}}}], languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMetaProductQuery__
 *
 * To run a query within a React component, call `useMetaProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaProductQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *   },
 * });
 */
export function useMetaProductQuery(baseOptions: Apollo.QueryHookOptions<MetaProductQuery, MetaProductQueryVariables> & ({ variables: MetaProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaProductQuery, MetaProductQueryVariables>(MetaProductDocument, options);
      }
export function useMetaProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaProductQuery, MetaProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaProductQuery, MetaProductQueryVariables>(MetaProductDocument, options);
        }
export function useMetaProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaProductQuery, MetaProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaProductQuery, MetaProductQueryVariables>(MetaProductDocument, options);
        }
export type MetaProductQueryHookResult = ReturnType<typeof useMetaProductQuery>;
export type MetaProductLazyQueryHookResult = ReturnType<typeof useMetaProductLazyQuery>;
export type MetaProductSuspenseQueryHookResult = ReturnType<typeof useMetaProductSuspenseQuery>;
export type MetaProductQueryResult = Apollo.QueryResult<MetaProductQuery, MetaProductQueryVariables>;
export const MetaProductsDocument = gql`
    query MetaProducts($where: RouteResourceWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  products(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {key: {in: ["name", "title"]}, languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMetaProductsQuery__
 *
 * To run a query within a React component, call `useMetaProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useMetaProductsQuery(baseOptions: Apollo.QueryHookOptions<MetaProductsQuery, MetaProductsQueryVariables> & ({ variables: MetaProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaProductsQuery, MetaProductsQueryVariables>(MetaProductsDocument, options);
      }
export function useMetaProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaProductsQuery, MetaProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaProductsQuery, MetaProductsQueryVariables>(MetaProductsDocument, options);
        }
export function useMetaProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaProductsQuery, MetaProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaProductsQuery, MetaProductsQueryVariables>(MetaProductsDocument, options);
        }
export type MetaProductsQueryHookResult = ReturnType<typeof useMetaProductsQuery>;
export type MetaProductsLazyQueryHookResult = ReturnType<typeof useMetaProductsLazyQuery>;
export type MetaProductsSuspenseQueryHookResult = ReturnType<typeof useMetaProductsSuspenseQuery>;
export type MetaProductsQueryResult = Apollo.QueryResult<MetaProductsQuery, MetaProductsQueryVariables>;
export const MetaProviderDocument = gql`
    query MetaProvider($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!) {
  provider(where: $where) {
    id
    content(
      where: {OR: [{field: {displayType: {in: [META, UI]}}}, {field: {key: {equals: "name"}}}], languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMetaProviderQuery__
 *
 * To run a query within a React component, call `useMetaProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaProviderQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *   },
 * });
 */
export function useMetaProviderQuery(baseOptions: Apollo.QueryHookOptions<MetaProviderQuery, MetaProviderQueryVariables> & ({ variables: MetaProviderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaProviderQuery, MetaProviderQueryVariables>(MetaProviderDocument, options);
      }
export function useMetaProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaProviderQuery, MetaProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaProviderQuery, MetaProviderQueryVariables>(MetaProviderDocument, options);
        }
export function useMetaProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaProviderQuery, MetaProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaProviderQuery, MetaProviderQueryVariables>(MetaProviderDocument, options);
        }
export type MetaProviderQueryHookResult = ReturnType<typeof useMetaProviderQuery>;
export type MetaProviderLazyQueryHookResult = ReturnType<typeof useMetaProviderLazyQuery>;
export type MetaProviderSuspenseQueryHookResult = ReturnType<typeof useMetaProviderSuspenseQuery>;
export type MetaProviderQueryResult = Apollo.QueryResult<MetaProviderQuery, MetaProviderQueryVariables>;
export const MetaProvidersDocument = gql`
    query MetaProviders($where: RouteResourceWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  providers(where: $where, take: $take, skip: $skip) {
    id
    content(
      where: {OR: [{key: {equals: "name"}}, {key: {equals: "title"}}], languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMetaProvidersQuery__
 *
 * To run a query within a React component, call `useMetaProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaProvidersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useMetaProvidersQuery(baseOptions: Apollo.QueryHookOptions<MetaProvidersQuery, MetaProvidersQueryVariables> & ({ variables: MetaProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaProvidersQuery, MetaProvidersQueryVariables>(MetaProvidersDocument, options);
      }
export function useMetaProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaProvidersQuery, MetaProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaProvidersQuery, MetaProvidersQueryVariables>(MetaProvidersDocument, options);
        }
export function useMetaProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaProvidersQuery, MetaProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaProvidersQuery, MetaProvidersQueryVariables>(MetaProvidersDocument, options);
        }
export type MetaProvidersQueryHookResult = ReturnType<typeof useMetaProvidersQuery>;
export type MetaProvidersLazyQueryHookResult = ReturnType<typeof useMetaProvidersLazyQuery>;
export type MetaProvidersSuspenseQueryHookResult = ReturnType<typeof useMetaProvidersSuspenseQuery>;
export type MetaProvidersQueryResult = Apollo.QueryResult<MetaProvidersQuery, MetaProvidersQueryVariables>;
export const MetaFilterTaxonomyRulesDocument = gql`
    query MetaFilterTaxonomyRules($where: FilterTaxonomyRuleWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  filterTaxonomyRules(where: $where, take: $take, skip: $skip) {
    ...MetaFilterTaxonomyRuleNewFragment
  }
  count: filterTaxonomyRuleCount(where: $where)
}
    ${MetaFilterTaxonomyRuleNewFragmentFragmentDoc}`;

/**
 * __useMetaFilterTaxonomyRulesQuery__
 *
 * To run a query within a React component, call `useMetaFilterTaxonomyRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaFilterTaxonomyRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaFilterTaxonomyRulesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useMetaFilterTaxonomyRulesQuery(baseOptions: Apollo.QueryHookOptions<MetaFilterTaxonomyRulesQuery, MetaFilterTaxonomyRulesQueryVariables> & ({ variables: MetaFilterTaxonomyRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaFilterTaxonomyRulesQuery, MetaFilterTaxonomyRulesQueryVariables>(MetaFilterTaxonomyRulesDocument, options);
      }
export function useMetaFilterTaxonomyRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaFilterTaxonomyRulesQuery, MetaFilterTaxonomyRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaFilterTaxonomyRulesQuery, MetaFilterTaxonomyRulesQueryVariables>(MetaFilterTaxonomyRulesDocument, options);
        }
export function useMetaFilterTaxonomyRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaFilterTaxonomyRulesQuery, MetaFilterTaxonomyRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaFilterTaxonomyRulesQuery, MetaFilterTaxonomyRulesQueryVariables>(MetaFilterTaxonomyRulesDocument, options);
        }
export type MetaFilterTaxonomyRulesQueryHookResult = ReturnType<typeof useMetaFilterTaxonomyRulesQuery>;
export type MetaFilterTaxonomyRulesLazyQueryHookResult = ReturnType<typeof useMetaFilterTaxonomyRulesLazyQuery>;
export type MetaFilterTaxonomyRulesSuspenseQueryHookResult = ReturnType<typeof useMetaFilterTaxonomyRulesSuspenseQuery>;
export type MetaFilterTaxonomyRulesQueryResult = Apollo.QueryResult<MetaFilterTaxonomyRulesQuery, MetaFilterTaxonomyRulesQueryVariables>;
export const MetaTaxonomyItemDocument = gql`
    query MetaTaxonomyItem($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!) {
  taxonomyItem(where: $where) {
    id
    parent {
      id
      content(
        where: {languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}, OR: [{field: {displayType: {in: [META, UI]}}}, {field: {key: {equals: "name"}}}]}
        orderBy: {status: asc}
      ) {
        ...ContentItemFragment
      }
    }
    content(
      where: {languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}, OR: [{field: {displayType: {in: [META, UI]}}}, {field: {key: {equals: "name"}}}]}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMetaTaxonomyItemQuery__
 *
 * To run a query within a React component, call `useMetaTaxonomyItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaTaxonomyItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaTaxonomyItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *   },
 * });
 */
export function useMetaTaxonomyItemQuery(baseOptions: Apollo.QueryHookOptions<MetaTaxonomyItemQuery, MetaTaxonomyItemQueryVariables> & ({ variables: MetaTaxonomyItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaTaxonomyItemQuery, MetaTaxonomyItemQueryVariables>(MetaTaxonomyItemDocument, options);
      }
export function useMetaTaxonomyItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaTaxonomyItemQuery, MetaTaxonomyItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaTaxonomyItemQuery, MetaTaxonomyItemQueryVariables>(MetaTaxonomyItemDocument, options);
        }
export function useMetaTaxonomyItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaTaxonomyItemQuery, MetaTaxonomyItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaTaxonomyItemQuery, MetaTaxonomyItemQueryVariables>(MetaTaxonomyItemDocument, options);
        }
export type MetaTaxonomyItemQueryHookResult = ReturnType<typeof useMetaTaxonomyItemQuery>;
export type MetaTaxonomyItemLazyQueryHookResult = ReturnType<typeof useMetaTaxonomyItemLazyQuery>;
export type MetaTaxonomyItemSuspenseQueryHookResult = ReturnType<typeof useMetaTaxonomyItemSuspenseQuery>;
export type MetaTaxonomyItemQueryResult = Apollo.QueryResult<MetaTaxonomyItemQuery, MetaTaxonomyItemQueryVariables>;
export const MetaTaxonomyItemsDocument = gql`
    query MetaTaxonomyItems($where: RouteResourceWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  taxonomyItems(where: $where, take: $take, skip: $skip) {
    id
    parent {
      id
    }
    subtype
    parentId
    content(
      where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {in: [APPROVED]}, OR: [{key: {equals: "name"}}, {key: {equals: "title"}}]}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useMetaTaxonomyItemsQuery__
 *
 * To run a query within a React component, call `useMetaTaxonomyItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetaTaxonomyItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetaTaxonomyItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useMetaTaxonomyItemsQuery(baseOptions: Apollo.QueryHookOptions<MetaTaxonomyItemsQuery, MetaTaxonomyItemsQueryVariables> & ({ variables: MetaTaxonomyItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetaTaxonomyItemsQuery, MetaTaxonomyItemsQueryVariables>(MetaTaxonomyItemsDocument, options);
      }
export function useMetaTaxonomyItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetaTaxonomyItemsQuery, MetaTaxonomyItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetaTaxonomyItemsQuery, MetaTaxonomyItemsQueryVariables>(MetaTaxonomyItemsDocument, options);
        }
export function useMetaTaxonomyItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetaTaxonomyItemsQuery, MetaTaxonomyItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetaTaxonomyItemsQuery, MetaTaxonomyItemsQueryVariables>(MetaTaxonomyItemsDocument, options);
        }
export type MetaTaxonomyItemsQueryHookResult = ReturnType<typeof useMetaTaxonomyItemsQuery>;
export type MetaTaxonomyItemsLazyQueryHookResult = ReturnType<typeof useMetaTaxonomyItemsLazyQuery>;
export type MetaTaxonomyItemsSuspenseQueryHookResult = ReturnType<typeof useMetaTaxonomyItemsSuspenseQuery>;
export type MetaTaxonomyItemsQueryResult = Apollo.QueryResult<MetaTaxonomyItemsQuery, MetaTaxonomyItemsQueryVariables>;
export const StringTemplatesDocument = gql`
    query StringTemplates($where: StringTemplateWhereInput, $take: Int, $skip: Int, $currentLanguageId: String!, $defaultLanguageId: String!) {
  stringTemplates(where: $where, take: $take, skip: $skip) {
    id
    key
    level
    content(
      where: {languageId: {in: [$currentLanguageId, $defaultLanguageId]}, status: {equals: APPROVED}}
    ) {
      ...ContentItemFragment
    }
    properties {
      ...PropertyItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}
${PropertyItemFragmentFragmentDoc}`;

/**
 * __useStringTemplatesQuery__
 *
 * To run a query within a React component, call `useStringTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStringTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStringTemplatesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useStringTemplatesQuery(baseOptions: Apollo.QueryHookOptions<StringTemplatesQuery, StringTemplatesQueryVariables> & ({ variables: StringTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StringTemplatesQuery, StringTemplatesQueryVariables>(StringTemplatesDocument, options);
      }
export function useStringTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StringTemplatesQuery, StringTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StringTemplatesQuery, StringTemplatesQueryVariables>(StringTemplatesDocument, options);
        }
export function useStringTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StringTemplatesQuery, StringTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StringTemplatesQuery, StringTemplatesQueryVariables>(StringTemplatesDocument, options);
        }
export type StringTemplatesQueryHookResult = ReturnType<typeof useStringTemplatesQuery>;
export type StringTemplatesLazyQueryHookResult = ReturnType<typeof useStringTemplatesLazyQuery>;
export type StringTemplatesSuspenseQueryHookResult = ReturnType<typeof useStringTemplatesSuspenseQuery>;
export type StringTemplatesQueryResult = Apollo.QueryResult<StringTemplatesQuery, StringTemplatesQueryVariables>;
export const UpsertStringTemplateDocument = gql`
    mutation UpsertStringTemplate($where: StringTemplateWhereUniqueInput!, $data: StringTemplateUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertStringTemplate(where: $where, data: $data, current: $current) {
    id
  }
}
    `;
export type UpsertStringTemplateMutationFn = Apollo.MutationFunction<UpsertStringTemplateMutation, UpsertStringTemplateMutationVariables>;

/**
 * __useUpsertStringTemplateMutation__
 *
 * To run a mutation, you first call `useUpsertStringTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertStringTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertStringTemplateMutation, { data, loading, error }] = useUpsertStringTemplateMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useUpsertStringTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpsertStringTemplateMutation, UpsertStringTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertStringTemplateMutation, UpsertStringTemplateMutationVariables>(UpsertStringTemplateDocument, options);
      }
export type UpsertStringTemplateMutationHookResult = ReturnType<typeof useUpsertStringTemplateMutation>;
export type UpsertStringTemplateMutationResult = Apollo.MutationResult<UpsertStringTemplateMutation>;
export type UpsertStringTemplateMutationOptions = Apollo.BaseMutationOptions<UpsertStringTemplateMutation, UpsertStringTemplateMutationVariables>;
export const DeleteNetworkDocument = gql`
    mutation DeleteNetwork($where: NetworkWhereUniqueInput!) {
  deleteNetwork(where: $where) {
    id
  }
}
    `;
export type DeleteNetworkMutationFn = Apollo.MutationFunction<DeleteNetworkMutation, DeleteNetworkMutationVariables>;

/**
 * __useDeleteNetworkMutation__
 *
 * To run a mutation, you first call `useDeleteNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNetworkMutation, { data, loading, error }] = useDeleteNetworkMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteNetworkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNetworkMutation, DeleteNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNetworkMutation, DeleteNetworkMutationVariables>(DeleteNetworkDocument, options);
      }
export type DeleteNetworkMutationHookResult = ReturnType<typeof useDeleteNetworkMutation>;
export type DeleteNetworkMutationResult = Apollo.MutationResult<DeleteNetworkMutation>;
export type DeleteNetworkMutationOptions = Apollo.BaseMutationOptions<DeleteNetworkMutation, DeleteNetworkMutationVariables>;
export const NetworkDocument = gql`
    query Network($where: NetworkWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!) {
  network(where: $where) {
    ...NetworkCrudFragment
  }
}
    ${NetworkCrudFragmentFragmentDoc}`;

/**
 * __useNetworkQuery__
 *
 * To run a query within a React component, call `useNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useNetworkQuery(baseOptions: Apollo.QueryHookOptions<NetworkQuery, NetworkQueryVariables> & ({ variables: NetworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkQuery, NetworkQueryVariables>(NetworkDocument, options);
      }
export function useNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkQuery, NetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkQuery, NetworkQueryVariables>(NetworkDocument, options);
        }
export function useNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkQuery, NetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworkQuery, NetworkQueryVariables>(NetworkDocument, options);
        }
export type NetworkQueryHookResult = ReturnType<typeof useNetworkQuery>;
export type NetworkLazyQueryHookResult = ReturnType<typeof useNetworkLazyQuery>;
export type NetworkSuspenseQueryHookResult = ReturnType<typeof useNetworkSuspenseQuery>;
export type NetworkQueryResult = Apollo.QueryResult<NetworkQuery, NetworkQueryVariables>;
export const UpsertNetworkDocument = gql`
    mutation UpsertNetwork($where: NetworkWhereUniqueInput!, $data: NetworkUpsertDataInput!, $currentLanguageId: String!, $defaultLanguageId: String!) {
  upsertNetwork(where: $where, data: $data) {
    ...NetworkCrudFragment
  }
}
    ${NetworkCrudFragmentFragmentDoc}`;
export type UpsertNetworkMutationFn = Apollo.MutationFunction<UpsertNetworkMutation, UpsertNetworkMutationVariables>;

/**
 * __useUpsertNetworkMutation__
 *
 * To run a mutation, you first call `useUpsertNetworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNetworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNetworkMutation, { data, loading, error }] = useUpsertNetworkMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useUpsertNetworkMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNetworkMutation, UpsertNetworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNetworkMutation, UpsertNetworkMutationVariables>(UpsertNetworkDocument, options);
      }
export type UpsertNetworkMutationHookResult = ReturnType<typeof useUpsertNetworkMutation>;
export type UpsertNetworkMutationResult = Apollo.MutationResult<UpsertNetworkMutation>;
export type UpsertNetworkMutationOptions = Apollo.BaseMutationOptions<UpsertNetworkMutation, UpsertNetworkMutationVariables>;
export const DeletePageDocument = gql`
    mutation DeletePage($where: RouteResourceWhereUniqueInput!) {
  deletePage(where: $where) {
    id
  }
}
    `;
export type DeletePageMutationFn = Apollo.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, options);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationResult = Apollo.MutationResult<DeletePageMutation>;
export type DeletePageMutationOptions = Apollo.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const PageDocument = gql`
    query Page($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  page(where: $where) {
    ...PageCrudFragment
  }
}
    ${PageCrudFragmentFragmentDoc}`;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables> & ({ variables: PageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export function usePageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageSuspenseQueryHookResult = ReturnType<typeof usePageSuspenseQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const UpsertPageDocument = gql`
    mutation UpsertPage($where: RouteResourceWhereUniqueInput!, $data: PageUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertPage(where: $where, data: $data, current: $current) {
    ...PageCrudFragment
  }
}
    ${PageCrudFragmentFragmentDoc}`;
export type UpsertPageMutationFn = Apollo.MutationFunction<UpsertPageMutation, UpsertPageMutationVariables>;

/**
 * __useUpsertPageMutation__
 *
 * To run a mutation, you first call `useUpsertPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPageMutation, { data, loading, error }] = useUpsertPageMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useUpsertPageMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPageMutation, UpsertPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPageMutation, UpsertPageMutationVariables>(UpsertPageDocument, options);
      }
export type UpsertPageMutationHookResult = ReturnType<typeof useUpsertPageMutation>;
export type UpsertPageMutationResult = Apollo.MutationResult<UpsertPageMutation>;
export type UpsertPageMutationOptions = Apollo.BaseMutationOptions<UpsertPageMutation, UpsertPageMutationVariables>;
export const DynamicListPagesDocument = gql`
    query DynamicListPages($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput, $currentLanguageId: String!) {
  count: pagesSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  pages: pagesSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;

/**
 * __useDynamicListPagesQuery__
 *
 * To run a query within a React component, call `useDynamicListPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListPagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *      currentLanguageId: // value for 'currentLanguageId'
 *   },
 * });
 */
export function useDynamicListPagesQuery(baseOptions: Apollo.QueryHookOptions<DynamicListPagesQuery, DynamicListPagesQueryVariables> & ({ variables: DynamicListPagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListPagesQuery, DynamicListPagesQueryVariables>(DynamicListPagesDocument, options);
      }
export function useDynamicListPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListPagesQuery, DynamicListPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListPagesQuery, DynamicListPagesQueryVariables>(DynamicListPagesDocument, options);
        }
export function useDynamicListPagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListPagesQuery, DynamicListPagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListPagesQuery, DynamicListPagesQueryVariables>(DynamicListPagesDocument, options);
        }
export type DynamicListPagesQueryHookResult = ReturnType<typeof useDynamicListPagesQuery>;
export type DynamicListPagesLazyQueryHookResult = ReturnType<typeof useDynamicListPagesLazyQuery>;
export type DynamicListPagesSuspenseQueryHookResult = ReturnType<typeof useDynamicListPagesSuspenseQuery>;
export type DynamicListPagesQueryResult = Apollo.QueryResult<DynamicListPagesQuery, DynamicListPagesQueryVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($where: RouteResourceWhereUniqueInput!) {
  deletePost(where: $where) {
    id
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: Apollo.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const PostDocument = gql`
    query Post($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  post(where: $where) {
    ...PostCrudFragment
  }
}
    ${PostCrudFragmentFragmentDoc}`;

/**
 * __usePostQuery__
 *
 * To run a query within a React component, call `usePostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function usePostQuery(baseOptions: Apollo.QueryHookOptions<PostQuery, PostQueryVariables> & ({ variables: PostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostQuery, PostQueryVariables>(PostDocument, options);
      }
export function usePostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostQuery, PostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostQuery, PostQueryVariables>(PostDocument, options);
        }
export function usePostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostQuery, PostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostQuery, PostQueryVariables>(PostDocument, options);
        }
export type PostQueryHookResult = ReturnType<typeof usePostQuery>;
export type PostLazyQueryHookResult = ReturnType<typeof usePostLazyQuery>;
export type PostSuspenseQueryHookResult = ReturnType<typeof usePostSuspenseQuery>;
export type PostQueryResult = Apollo.QueryResult<PostQuery, PostQueryVariables>;
export const UpsertPostDocument = gql`
    mutation UpsertPost($where: RouteResourceWhereUniqueInput!, $data: PostUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertPost(where: $where, data: $data, current: $current) {
    ...PostCrudFragment
  }
}
    ${PostCrudFragmentFragmentDoc}`;
export type UpsertPostMutationFn = Apollo.MutationFunction<UpsertPostMutation, UpsertPostMutationVariables>;

/**
 * __useUpsertPostMutation__
 *
 * To run a mutation, you first call `useUpsertPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPostMutation, { data, loading, error }] = useUpsertPostMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useUpsertPostMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPostMutation, UpsertPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPostMutation, UpsertPostMutationVariables>(UpsertPostDocument, options);
      }
export type UpsertPostMutationHookResult = ReturnType<typeof useUpsertPostMutation>;
export type UpsertPostMutationResult = Apollo.MutationResult<UpsertPostMutation>;
export type UpsertPostMutationOptions = Apollo.BaseMutationOptions<UpsertPostMutation, UpsertPostMutationVariables>;
export const DynamicListPostsDocument = gql`
    query DynamicListPosts($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput, $currentLanguageId: String!) {
  count: postsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  posts: postsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, languageId: {equals: $currentLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;

/**
 * __useDynamicListPostsQuery__
 *
 * To run a query within a React component, call `useDynamicListPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListPostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *      currentLanguageId: // value for 'currentLanguageId'
 *   },
 * });
 */
export function useDynamicListPostsQuery(baseOptions: Apollo.QueryHookOptions<DynamicListPostsQuery, DynamicListPostsQueryVariables> & ({ variables: DynamicListPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListPostsQuery, DynamicListPostsQueryVariables>(DynamicListPostsDocument, options);
      }
export function useDynamicListPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListPostsQuery, DynamicListPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListPostsQuery, DynamicListPostsQueryVariables>(DynamicListPostsDocument, options);
        }
export function useDynamicListPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListPostsQuery, DynamicListPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListPostsQuery, DynamicListPostsQueryVariables>(DynamicListPostsDocument, options);
        }
export type DynamicListPostsQueryHookResult = ReturnType<typeof useDynamicListPostsQuery>;
export type DynamicListPostsLazyQueryHookResult = ReturnType<typeof useDynamicListPostsLazyQuery>;
export type DynamicListPostsSuspenseQueryHookResult = ReturnType<typeof useDynamicListPostsSuspenseQuery>;
export type DynamicListPostsQueryResult = Apollo.QueryResult<DynamicListPostsQuery, DynamicListPostsQueryVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($where: RouteResourceWhereUniqueInput!) {
  deleteProduct(where: $where) {
    id
  }
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const DeleteProductPoolDocument = gql`
    mutation DeleteProductPool($where: ProductPoolWhereUniqueInput!) {
  deleteProductPool(where: $where) {
    id
  }
}
    `;
export type DeleteProductPoolMutationFn = Apollo.MutationFunction<DeleteProductPoolMutation, DeleteProductPoolMutationVariables>;

/**
 * __useDeleteProductPoolMutation__
 *
 * To run a mutation, you first call `useDeleteProductPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductPoolMutation, { data, loading, error }] = useDeleteProductPoolMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteProductPoolMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductPoolMutation, DeleteProductPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductPoolMutation, DeleteProductPoolMutationVariables>(DeleteProductPoolDocument, options);
      }
export type DeleteProductPoolMutationHookResult = ReturnType<typeof useDeleteProductPoolMutation>;
export type DeleteProductPoolMutationResult = Apollo.MutationResult<DeleteProductPoolMutation>;
export type DeleteProductPoolMutationOptions = Apollo.BaseMutationOptions<DeleteProductPoolMutation, DeleteProductPoolMutationVariables>;
export const ProductDocument = gql`
    query Product($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  product(where: $where) {
    ...ProductCrudFragment
  }
}
    ${ProductCrudFragmentFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables> & ({ variables: ProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<typeof useProductSuspenseQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductPoolDocument = gql`
    query ProductPool($where: RouteResourcePoolWhereUniqueInput!) {
  productPool(where: $where) {
    id
    name
    networks {
      id
    }
    products {
      id
    }
  }
}
    `;

/**
 * __useProductPoolQuery__
 *
 * To run a query within a React component, call `useProductPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPoolQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProductPoolQuery(baseOptions: Apollo.QueryHookOptions<ProductPoolQuery, ProductPoolQueryVariables> & ({ variables: ProductPoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPoolQuery, ProductPoolQueryVariables>(ProductPoolDocument, options);
      }
export function useProductPoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPoolQuery, ProductPoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPoolQuery, ProductPoolQueryVariables>(ProductPoolDocument, options);
        }
export function useProductPoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPoolQuery, ProductPoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPoolQuery, ProductPoolQueryVariables>(ProductPoolDocument, options);
        }
export type ProductPoolQueryHookResult = ReturnType<typeof useProductPoolQuery>;
export type ProductPoolLazyQueryHookResult = ReturnType<typeof useProductPoolLazyQuery>;
export type ProductPoolSuspenseQueryHookResult = ReturnType<typeof useProductPoolSuspenseQuery>;
export type ProductPoolQueryResult = Apollo.QueryResult<ProductPoolQuery, ProductPoolQueryVariables>;
export const DynamicListProductsDocument = gql`
    query DynamicListProducts($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: productsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  products: productsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    subtype
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, status: {in: [APPROVED, DRAFT]}, languageId: {equals: "cka2r9yww001164rm5rp69iko"}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
    pools {
      id
      networks {
        id
      }
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;

/**
 * __useDynamicListProductsQuery__
 *
 * To run a query within a React component, call `useDynamicListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useDynamicListProductsQuery(baseOptions?: Apollo.QueryHookOptions<DynamicListProductsQuery, DynamicListProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListProductsQuery, DynamicListProductsQueryVariables>(DynamicListProductsDocument, options);
      }
export function useDynamicListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListProductsQuery, DynamicListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListProductsQuery, DynamicListProductsQueryVariables>(DynamicListProductsDocument, options);
        }
export function useDynamicListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListProductsQuery, DynamicListProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListProductsQuery, DynamicListProductsQueryVariables>(DynamicListProductsDocument, options);
        }
export type DynamicListProductsQueryHookResult = ReturnType<typeof useDynamicListProductsQuery>;
export type DynamicListProductsLazyQueryHookResult = ReturnType<typeof useDynamicListProductsLazyQuery>;
export type DynamicListProductsSuspenseQueryHookResult = ReturnType<typeof useDynamicListProductsSuspenseQuery>;
export type DynamicListProductsQueryResult = Apollo.QueryResult<DynamicListProductsQuery, DynamicListProductsQueryVariables>;
export const UpsertProductCrudDocument = gql`
    mutation UpsertProductCrud($where: RouteResourceWhereUniqueInput!, $data: ProductUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertProduct(where: $where, data: $data, current: $current) {
    ...ProductCrudFragment
  }
}
    ${ProductCrudFragmentFragmentDoc}`;
export type UpsertProductCrudMutationFn = Apollo.MutationFunction<UpsertProductCrudMutation, UpsertProductCrudMutationVariables>;

/**
 * __useUpsertProductCrudMutation__
 *
 * To run a mutation, you first call `useUpsertProductCrudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProductCrudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProductCrudMutation, { data, loading, error }] = useUpsertProductCrudMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useUpsertProductCrudMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProductCrudMutation, UpsertProductCrudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProductCrudMutation, UpsertProductCrudMutationVariables>(UpsertProductCrudDocument, options);
      }
export type UpsertProductCrudMutationHookResult = ReturnType<typeof useUpsertProductCrudMutation>;
export type UpsertProductCrudMutationResult = Apollo.MutationResult<UpsertProductCrudMutation>;
export type UpsertProductCrudMutationOptions = Apollo.BaseMutationOptions<UpsertProductCrudMutation, UpsertProductCrudMutationVariables>;
export const UpsertProductPoolDocument = gql`
    mutation UpsertProductPool($where: RouteResourcePoolWhereUniqueInput, $data: RouteResourcePoolUpsertDataInput!) {
  upsertProductPool(where: $where, data: $data) {
    id
  }
}
    `;
export type UpsertProductPoolMutationFn = Apollo.MutationFunction<UpsertProductPoolMutation, UpsertProductPoolMutationVariables>;

/**
 * __useUpsertProductPoolMutation__
 *
 * To run a mutation, you first call `useUpsertProductPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProductPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProductPoolMutation, { data, loading, error }] = useUpsertProductPoolMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertProductPoolMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProductPoolMutation, UpsertProductPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProductPoolMutation, UpsertProductPoolMutationVariables>(UpsertProductPoolDocument, options);
      }
export type UpsertProductPoolMutationHookResult = ReturnType<typeof useUpsertProductPoolMutation>;
export type UpsertProductPoolMutationResult = Apollo.MutationResult<UpsertProductPoolMutation>;
export type UpsertProductPoolMutationOptions = Apollo.BaseMutationOptions<UpsertProductPoolMutation, UpsertProductPoolMutationVariables>;
export const ProviderOverviewDocument = gql`
    query ProviderOverview($where: RouteResourceWhereInput, $take: Int, $skip: Int, $defaultLanguageId: String!) {
  providers(where: $where, take: $take, skip: $skip) {
    id
    properties(where: {key: {equals: "logotype"}}) {
      ...PropertyItemFragment
    }
    content(
      where: {languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
  count: providerCount(where: $where)
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;

/**
 * __useProviderOverviewQuery__
 *
 * To run a query within a React component, call `useProviderOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderOverviewQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useProviderOverviewQuery(baseOptions: Apollo.QueryHookOptions<ProviderOverviewQuery, ProviderOverviewQueryVariables> & ({ variables: ProviderOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderOverviewQuery, ProviderOverviewQueryVariables>(ProviderOverviewDocument, options);
      }
export function useProviderOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderOverviewQuery, ProviderOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderOverviewQuery, ProviderOverviewQueryVariables>(ProviderOverviewDocument, options);
        }
export function useProviderOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderOverviewQuery, ProviderOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderOverviewQuery, ProviderOverviewQueryVariables>(ProviderOverviewDocument, options);
        }
export type ProviderOverviewQueryHookResult = ReturnType<typeof useProviderOverviewQuery>;
export type ProviderOverviewLazyQueryHookResult = ReturnType<typeof useProviderOverviewLazyQuery>;
export type ProviderOverviewSuspenseQueryHookResult = ReturnType<typeof useProviderOverviewSuspenseQuery>;
export type ProviderOverviewQueryResult = Apollo.QueryResult<ProviderOverviewQuery, ProviderOverviewQueryVariables>;
export const DeleteProviderDocument = gql`
    mutation DeleteProvider($where: RouteResourceWhereUniqueInput!) {
  deleteProvider(where: $where) {
    id
  }
}
    `;
export type DeleteProviderMutationFn = Apollo.MutationFunction<DeleteProviderMutation, DeleteProviderMutationVariables>;

/**
 * __useDeleteProviderMutation__
 *
 * To run a mutation, you first call `useDeleteProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderMutation, { data, loading, error }] = useDeleteProviderMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteProviderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderMutation, DeleteProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderMutation, DeleteProviderMutationVariables>(DeleteProviderDocument, options);
      }
export type DeleteProviderMutationHookResult = ReturnType<typeof useDeleteProviderMutation>;
export type DeleteProviderMutationResult = Apollo.MutationResult<DeleteProviderMutation>;
export type DeleteProviderMutationOptions = Apollo.BaseMutationOptions<DeleteProviderMutation, DeleteProviderMutationVariables>;
export const DeleteProviderPoolDocument = gql`
    mutation DeleteProviderPool($where: ProviderPoolWhereUniqueInput!) {
  deleteProviderPool(where: $where) {
    id
  }
}
    `;
export type DeleteProviderPoolMutationFn = Apollo.MutationFunction<DeleteProviderPoolMutation, DeleteProviderPoolMutationVariables>;

/**
 * __useDeleteProviderPoolMutation__
 *
 * To run a mutation, you first call `useDeleteProviderPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderPoolMutation, { data, loading, error }] = useDeleteProviderPoolMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteProviderPoolMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderPoolMutation, DeleteProviderPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderPoolMutation, DeleteProviderPoolMutationVariables>(DeleteProviderPoolDocument, options);
      }
export type DeleteProviderPoolMutationHookResult = ReturnType<typeof useDeleteProviderPoolMutation>;
export type DeleteProviderPoolMutationResult = Apollo.MutationResult<DeleteProviderPoolMutation>;
export type DeleteProviderPoolMutationOptions = Apollo.BaseMutationOptions<DeleteProviderPoolMutation, DeleteProviderPoolMutationVariables>;
export const DeleteProviderTaxonomyConnectionDocument = gql`
    mutation DeleteProviderTaxonomyConnection($where: ProviderTaxonomyConnectionWhereUniqueInput!) {
  deleteProviderTaxonomyConnection(where: $where) {
    id
  }
}
    `;
export type DeleteProviderTaxonomyConnectionMutationFn = Apollo.MutationFunction<DeleteProviderTaxonomyConnectionMutation, DeleteProviderTaxonomyConnectionMutationVariables>;

/**
 * __useDeleteProviderTaxonomyConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteProviderTaxonomyConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderTaxonomyConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderTaxonomyConnectionMutation, { data, loading, error }] = useDeleteProviderTaxonomyConnectionMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteProviderTaxonomyConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderTaxonomyConnectionMutation, DeleteProviderTaxonomyConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderTaxonomyConnectionMutation, DeleteProviderTaxonomyConnectionMutationVariables>(DeleteProviderTaxonomyConnectionDocument, options);
      }
export type DeleteProviderTaxonomyConnectionMutationHookResult = ReturnType<typeof useDeleteProviderTaxonomyConnectionMutation>;
export type DeleteProviderTaxonomyConnectionMutationResult = Apollo.MutationResult<DeleteProviderTaxonomyConnectionMutation>;
export type DeleteProviderTaxonomyConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteProviderTaxonomyConnectionMutation, DeleteProviderTaxonomyConnectionMutationVariables>;
export const ProviderCrudDocument = gql`
    query ProviderCrud($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  provider(where: $where) {
    ...ProviderCrudFragment
  }
}
    ${ProviderCrudFragmentFragmentDoc}`;

/**
 * __useProviderCrudQuery__
 *
 * To run a query within a React component, call `useProviderCrudQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderCrudQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderCrudQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useProviderCrudQuery(baseOptions: Apollo.QueryHookOptions<ProviderCrudQuery, ProviderCrudQueryVariables> & ({ variables: ProviderCrudQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderCrudQuery, ProviderCrudQueryVariables>(ProviderCrudDocument, options);
      }
export function useProviderCrudLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderCrudQuery, ProviderCrudQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderCrudQuery, ProviderCrudQueryVariables>(ProviderCrudDocument, options);
        }
export function useProviderCrudSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderCrudQuery, ProviderCrudQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderCrudQuery, ProviderCrudQueryVariables>(ProviderCrudDocument, options);
        }
export type ProviderCrudQueryHookResult = ReturnType<typeof useProviderCrudQuery>;
export type ProviderCrudLazyQueryHookResult = ReturnType<typeof useProviderCrudLazyQuery>;
export type ProviderCrudSuspenseQueryHookResult = ReturnType<typeof useProviderCrudSuspenseQuery>;
export type ProviderCrudQueryResult = Apollo.QueryResult<ProviderCrudQuery, ProviderCrudQueryVariables>;
export const ProviderPoolDocument = gql`
    query ProviderPool($where: RouteResourcePoolWhereUniqueInput!) {
  providerPool(where: $where) {
    id
    name
    networks {
      id
    }
    providers {
      id
    }
  }
}
    `;

/**
 * __useProviderPoolQuery__
 *
 * To run a query within a React component, call `useProviderPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderPoolQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProviderPoolQuery(baseOptions: Apollo.QueryHookOptions<ProviderPoolQuery, ProviderPoolQueryVariables> & ({ variables: ProviderPoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderPoolQuery, ProviderPoolQueryVariables>(ProviderPoolDocument, options);
      }
export function useProviderPoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderPoolQuery, ProviderPoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderPoolQuery, ProviderPoolQueryVariables>(ProviderPoolDocument, options);
        }
export function useProviderPoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderPoolQuery, ProviderPoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderPoolQuery, ProviderPoolQueryVariables>(ProviderPoolDocument, options);
        }
export type ProviderPoolQueryHookResult = ReturnType<typeof useProviderPoolQuery>;
export type ProviderPoolLazyQueryHookResult = ReturnType<typeof useProviderPoolLazyQuery>;
export type ProviderPoolSuspenseQueryHookResult = ReturnType<typeof useProviderPoolSuspenseQuery>;
export type ProviderPoolQueryResult = Apollo.QueryResult<ProviderPoolQuery, ProviderPoolQueryVariables>;
export const ProviderTaxonomyConnectionsDocument = gql`
    query ProviderTaxonomyConnections($currentLanguageId: String!, $providerId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  providerTaxonomyConnections(where: {providerId: {equals: $providerId}}) {
    id
    taxonomyItemId
    content(
      where: {languageId: {in: [$currentLanguageId]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useProviderTaxonomyConnectionsQuery__
 *
 * To run a query within a React component, call `useProviderTaxonomyConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderTaxonomyConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderTaxonomyConnectionsQuery({
 *   variables: {
 *      currentLanguageId: // value for 'currentLanguageId'
 *      providerId: // value for 'providerId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useProviderTaxonomyConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ProviderTaxonomyConnectionsQuery, ProviderTaxonomyConnectionsQueryVariables> & ({ variables: ProviderTaxonomyConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderTaxonomyConnectionsQuery, ProviderTaxonomyConnectionsQueryVariables>(ProviderTaxonomyConnectionsDocument, options);
      }
export function useProviderTaxonomyConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderTaxonomyConnectionsQuery, ProviderTaxonomyConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderTaxonomyConnectionsQuery, ProviderTaxonomyConnectionsQueryVariables>(ProviderTaxonomyConnectionsDocument, options);
        }
export function useProviderTaxonomyConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderTaxonomyConnectionsQuery, ProviderTaxonomyConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderTaxonomyConnectionsQuery, ProviderTaxonomyConnectionsQueryVariables>(ProviderTaxonomyConnectionsDocument, options);
        }
export type ProviderTaxonomyConnectionsQueryHookResult = ReturnType<typeof useProviderTaxonomyConnectionsQuery>;
export type ProviderTaxonomyConnectionsLazyQueryHookResult = ReturnType<typeof useProviderTaxonomyConnectionsLazyQuery>;
export type ProviderTaxonomyConnectionsSuspenseQueryHookResult = ReturnType<typeof useProviderTaxonomyConnectionsSuspenseQuery>;
export type ProviderTaxonomyConnectionsQueryResult = Apollo.QueryResult<ProviderTaxonomyConnectionsQuery, ProviderTaxonomyConnectionsQueryVariables>;
export const DynamicListProvidersDocument = gql`
    query DynamicListProviders($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: providersSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  providers: providersSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, status: {in: [APPROVED, DRAFT]}, languageId: {equals: "cka2r9yww001164rm5rp69iko"}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
    pools {
      id
      networks {
        id
      }
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}`;

/**
 * __useDynamicListProvidersQuery__
 *
 * To run a query within a React component, call `useDynamicListProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListProvidersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useDynamicListProvidersQuery(baseOptions?: Apollo.QueryHookOptions<DynamicListProvidersQuery, DynamicListProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListProvidersQuery, DynamicListProvidersQueryVariables>(DynamicListProvidersDocument, options);
      }
export function useDynamicListProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListProvidersQuery, DynamicListProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListProvidersQuery, DynamicListProvidersQueryVariables>(DynamicListProvidersDocument, options);
        }
export function useDynamicListProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListProvidersQuery, DynamicListProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListProvidersQuery, DynamicListProvidersQueryVariables>(DynamicListProvidersDocument, options);
        }
export type DynamicListProvidersQueryHookResult = ReturnType<typeof useDynamicListProvidersQuery>;
export type DynamicListProvidersLazyQueryHookResult = ReturnType<typeof useDynamicListProvidersLazyQuery>;
export type DynamicListProvidersSuspenseQueryHookResult = ReturnType<typeof useDynamicListProvidersSuspenseQuery>;
export type DynamicListProvidersQueryResult = Apollo.QueryResult<DynamicListProvidersQuery, DynamicListProvidersQueryVariables>;
export const UpsertProviderCrudDocument = gql`
    mutation UpsertProviderCrud($where: RouteResourceWhereUniqueInput!, $data: ProviderUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertProvider(where: $where, data: $data, current: $current) {
    ...ProviderCrudFragment
  }
}
    ${ProviderCrudFragmentFragmentDoc}`;
export type UpsertProviderCrudMutationFn = Apollo.MutationFunction<UpsertProviderCrudMutation, UpsertProviderCrudMutationVariables>;

/**
 * __useUpsertProviderCrudMutation__
 *
 * To run a mutation, you first call `useUpsertProviderCrudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProviderCrudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProviderCrudMutation, { data, loading, error }] = useUpsertProviderCrudMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useUpsertProviderCrudMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProviderCrudMutation, UpsertProviderCrudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProviderCrudMutation, UpsertProviderCrudMutationVariables>(UpsertProviderCrudDocument, options);
      }
export type UpsertProviderCrudMutationHookResult = ReturnType<typeof useUpsertProviderCrudMutation>;
export type UpsertProviderCrudMutationResult = Apollo.MutationResult<UpsertProviderCrudMutation>;
export type UpsertProviderCrudMutationOptions = Apollo.BaseMutationOptions<UpsertProviderCrudMutation, UpsertProviderCrudMutationVariables>;
export const UpsertProviderPoolDocument = gql`
    mutation UpsertProviderPool($where: RouteResourcePoolWhereUniqueInput, $data: RouteResourcePoolUpsertDataInput!) {
  upsertProviderPool(where: $where, data: $data) {
    id
  }
}
    `;
export type UpsertProviderPoolMutationFn = Apollo.MutationFunction<UpsertProviderPoolMutation, UpsertProviderPoolMutationVariables>;

/**
 * __useUpsertProviderPoolMutation__
 *
 * To run a mutation, you first call `useUpsertProviderPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProviderPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProviderPoolMutation, { data, loading, error }] = useUpsertProviderPoolMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertProviderPoolMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProviderPoolMutation, UpsertProviderPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProviderPoolMutation, UpsertProviderPoolMutationVariables>(UpsertProviderPoolDocument, options);
      }
export type UpsertProviderPoolMutationHookResult = ReturnType<typeof useUpsertProviderPoolMutation>;
export type UpsertProviderPoolMutationResult = Apollo.MutationResult<UpsertProviderPoolMutation>;
export type UpsertProviderPoolMutationOptions = Apollo.BaseMutationOptions<UpsertProviderPoolMutation, UpsertProviderPoolMutationVariables>;
export const UpsertProviderTaxonomyConnectionDocument = gql`
    mutation UpsertProviderTaxonomyConnection($where: ProviderTaxonomyConnectionWhereUniqueInput!, $data: ProviderTaxonomyConnectionUpsertDataInput!, $current: ResourceCurrentInput!) {
  upsertProviderTaxonomyConnection(where: $where, data: $data, current: $current) {
    id
    providerId
    taxonomyItemId
    network {
      id
    }
  }
}
    `;
export type UpsertProviderTaxonomyConnectionMutationFn = Apollo.MutationFunction<UpsertProviderTaxonomyConnectionMutation, UpsertProviderTaxonomyConnectionMutationVariables>;

/**
 * __useUpsertProviderTaxonomyConnectionMutation__
 *
 * To run a mutation, you first call `useUpsertProviderTaxonomyConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProviderTaxonomyConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProviderTaxonomyConnectionMutation, { data, loading, error }] = useUpsertProviderTaxonomyConnectionMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *   },
 * });
 */
export function useUpsertProviderTaxonomyConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertProviderTaxonomyConnectionMutation, UpsertProviderTaxonomyConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertProviderTaxonomyConnectionMutation, UpsertProviderTaxonomyConnectionMutationVariables>(UpsertProviderTaxonomyConnectionDocument, options);
      }
export type UpsertProviderTaxonomyConnectionMutationHookResult = ReturnType<typeof useUpsertProviderTaxonomyConnectionMutation>;
export type UpsertProviderTaxonomyConnectionMutationResult = Apollo.MutationResult<UpsertProviderTaxonomyConnectionMutation>;
export type UpsertProviderTaxonomyConnectionMutationOptions = Apollo.BaseMutationOptions<UpsertProviderTaxonomyConnectionMutation, UpsertProviderTaxonomyConnectionMutationVariables>;
export const ProvidersStatusDocument = gql`
    query ProvidersStatus($where: RouteResourceWhereInput, $take: Int, $skip: Int, $contentQueryKeys: [String!], $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  count: providerCount(where: $where)
  providers(where: $where, take: $take, skip: $skip) {
    id
    createdAt
    updatedAt
    properties(
      where: {key: {in: ["published", "affiliate-link"]}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}}
    ) {
      id
      key
      data
      contextId
    }
    content(
      where: {key: {in: $contentQueryKeys}, languageId: {equals: $defaultLanguageId}, contextId: {in: ["GLOBAL", $currentNetworkId, $currentCompanyId, $currentVerticalId]}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useProvidersStatusQuery__
 *
 * To run a query within a React component, call `useProvidersStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentQueryKeys: // value for 'contentQueryKeys'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useProvidersStatusQuery(baseOptions: Apollo.QueryHookOptions<ProvidersStatusQuery, ProvidersStatusQueryVariables> & ({ variables: ProvidersStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvidersStatusQuery, ProvidersStatusQueryVariables>(ProvidersStatusDocument, options);
      }
export function useProvidersStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvidersStatusQuery, ProvidersStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvidersStatusQuery, ProvidersStatusQueryVariables>(ProvidersStatusDocument, options);
        }
export function useProvidersStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProvidersStatusQuery, ProvidersStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProvidersStatusQuery, ProvidersStatusQueryVariables>(ProvidersStatusDocument, options);
        }
export type ProvidersStatusQueryHookResult = ReturnType<typeof useProvidersStatusQuery>;
export type ProvidersStatusLazyQueryHookResult = ReturnType<typeof useProvidersStatusLazyQuery>;
export type ProvidersStatusSuspenseQueryHookResult = ReturnType<typeof useProvidersStatusSuspenseQuery>;
export type ProvidersStatusQueryResult = Apollo.QueryResult<ProvidersStatusQuery, ProvidersStatusQueryVariables>;
export const LogotypesDocument = gql`
    query Logotypes($where: MediaItemWhereInput) {
  logo: mediaItems(where: $where) {
    id
    url
  }
}
    `;

/**
 * __useLogotypesQuery__
 *
 * To run a query within a React component, call `useLogotypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogotypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogotypesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLogotypesQuery(baseOptions?: Apollo.QueryHookOptions<LogotypesQuery, LogotypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogotypesQuery, LogotypesQueryVariables>(LogotypesDocument, options);
      }
export function useLogotypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogotypesQuery, LogotypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogotypesQuery, LogotypesQueryVariables>(LogotypesDocument, options);
        }
export function useLogotypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogotypesQuery, LogotypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogotypesQuery, LogotypesQueryVariables>(LogotypesDocument, options);
        }
export type LogotypesQueryHookResult = ReturnType<typeof useLogotypesQuery>;
export type LogotypesLazyQueryHookResult = ReturnType<typeof useLogotypesLazyQuery>;
export type LogotypesSuspenseQueryHookResult = ReturnType<typeof useLogotypesSuspenseQuery>;
export type LogotypesQueryResult = Apollo.QueryResult<LogotypesQuery, LogotypesQueryVariables>;
export const RankingPositionNetworkDocument = gql`
    query RankingPositionNetwork($defaultLanguageId: String!) {
  networks {
    id
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useRankingPositionNetworkQuery__
 *
 * To run a query within a React component, call `useRankingPositionNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankingPositionNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankingPositionNetworkQuery({
 *   variables: {
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useRankingPositionNetworkQuery(baseOptions: Apollo.QueryHookOptions<RankingPositionNetworkQuery, RankingPositionNetworkQueryVariables> & ({ variables: RankingPositionNetworkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RankingPositionNetworkQuery, RankingPositionNetworkQueryVariables>(RankingPositionNetworkDocument, options);
      }
export function useRankingPositionNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RankingPositionNetworkQuery, RankingPositionNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RankingPositionNetworkQuery, RankingPositionNetworkQueryVariables>(RankingPositionNetworkDocument, options);
        }
export function useRankingPositionNetworkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RankingPositionNetworkQuery, RankingPositionNetworkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RankingPositionNetworkQuery, RankingPositionNetworkQueryVariables>(RankingPositionNetworkDocument, options);
        }
export type RankingPositionNetworkQueryHookResult = ReturnType<typeof useRankingPositionNetworkQuery>;
export type RankingPositionNetworkLazyQueryHookResult = ReturnType<typeof useRankingPositionNetworkLazyQuery>;
export type RankingPositionNetworkSuspenseQueryHookResult = ReturnType<typeof useRankingPositionNetworkSuspenseQuery>;
export type RankingPositionNetworkQueryResult = Apollo.QueryResult<RankingPositionNetworkQuery, RankingPositionNetworkQueryVariables>;
export const DeleteSiteDocument = gql`
    mutation DeleteSite($where: SiteWhereUniqueInput!) {
  deleteSite(where: $where) {
    id
  }
}
    `;
export type DeleteSiteMutationFn = Apollo.MutationFunction<DeleteSiteMutation, DeleteSiteMutationVariables>;

/**
 * __useDeleteSiteMutation__
 *
 * To run a mutation, you first call `useDeleteSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSiteMutation, { data, loading, error }] = useDeleteSiteMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteSiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSiteMutation, DeleteSiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSiteMutation, DeleteSiteMutationVariables>(DeleteSiteDocument, options);
      }
export type DeleteSiteMutationHookResult = ReturnType<typeof useDeleteSiteMutation>;
export type DeleteSiteMutationResult = Apollo.MutationResult<DeleteSiteMutation>;
export type DeleteSiteMutationOptions = Apollo.BaseMutationOptions<DeleteSiteMutation, DeleteSiteMutationVariables>;
export const SiteDocument = gql`
    query Site($where: SiteWhereUniqueInput!) {
  site(where: $where) {
    ...SiteFragment
  }
}
    ${SiteFragmentFragmentDoc}`;

/**
 * __useSiteQuery__
 *
 * To run a query within a React component, call `useSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSiteQuery(baseOptions: Apollo.QueryHookOptions<SiteQuery, SiteQueryVariables> & ({ variables: SiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
      }
export function useSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteQuery, SiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
        }
export function useSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteQuery, SiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteQuery, SiteQueryVariables>(SiteDocument, options);
        }
export type SiteQueryHookResult = ReturnType<typeof useSiteQuery>;
export type SiteLazyQueryHookResult = ReturnType<typeof useSiteLazyQuery>;
export type SiteSuspenseQueryHookResult = ReturnType<typeof useSiteSuspenseQuery>;
export type SiteQueryResult = Apollo.QueryResult<SiteQuery, SiteQueryVariables>;
export const DynamicListSitesDocument = gql`
    query DynamicListSites($where: SiteWhereInput, $search: ResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [SiteOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: sitesSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  sites: sitesSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    createdAt
    createdBy {
      user_id
      name
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(where: {key: {in: $contentKeys}}) {
      ...ContentItemFragment
    }
    language {
      ...LanguageFragment
    }
  }
}
    ${PropertyItemFragmentFragmentDoc}
${ContentItemFragmentFragmentDoc}
${LanguageFragmentFragmentDoc}`;

/**
 * __useDynamicListSitesQuery__
 *
 * To run a query within a React component, call `useDynamicListSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListSitesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useDynamicListSitesQuery(baseOptions?: Apollo.QueryHookOptions<DynamicListSitesQuery, DynamicListSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListSitesQuery, DynamicListSitesQueryVariables>(DynamicListSitesDocument, options);
      }
export function useDynamicListSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListSitesQuery, DynamicListSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListSitesQuery, DynamicListSitesQueryVariables>(DynamicListSitesDocument, options);
        }
export function useDynamicListSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListSitesQuery, DynamicListSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListSitesQuery, DynamicListSitesQueryVariables>(DynamicListSitesDocument, options);
        }
export type DynamicListSitesQueryHookResult = ReturnType<typeof useDynamicListSitesQuery>;
export type DynamicListSitesLazyQueryHookResult = ReturnType<typeof useDynamicListSitesLazyQuery>;
export type DynamicListSitesSuspenseQueryHookResult = ReturnType<typeof useDynamicListSitesSuspenseQuery>;
export type DynamicListSitesQueryResult = Apollo.QueryResult<DynamicListSitesQuery, DynamicListSitesQueryVariables>;
export const SitesStatusDocument = gql`
    query SitesStatus($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip, orderBy: {url: asc}) {
    id
    url
    createdAt
    properties {
      id
      key
      data
    }
    language {
      id
      countryCode
      languageTag
    }
    vertical {
      id
      network {
        id
      }
    }
  }
  count: siteCount(where: $where)
}
    `;

/**
 * __useSitesStatusQuery__
 *
 * To run a query within a React component, call `useSitesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesStatusQuery({
 *   variables: {
 *      vertical: // value for 'vertical'
 *   },
 * });
 */
export function useSitesStatusQuery(baseOptions: Apollo.QueryHookOptions<SitesStatusQuery, SitesStatusQueryVariables> & ({ variables: SitesStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesStatusQuery, SitesStatusQueryVariables>(SitesStatusDocument, options);
      }
export function useSitesStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesStatusQuery, SitesStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesStatusQuery, SitesStatusQueryVariables>(SitesStatusDocument, options);
        }
export function useSitesStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitesStatusQuery, SitesStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesStatusQuery, SitesStatusQueryVariables>(SitesStatusDocument, options);
        }
export type SitesStatusQueryHookResult = ReturnType<typeof useSitesStatusQuery>;
export type SitesStatusLazyQueryHookResult = ReturnType<typeof useSitesStatusLazyQuery>;
export type SitesStatusSuspenseQueryHookResult = ReturnType<typeof useSitesStatusSuspenseQuery>;
export type SitesStatusQueryResult = Apollo.QueryResult<SitesStatusQuery, SitesStatusQueryVariables>;
export const NewsTaxStatusDocument = gql`
    query NewsTaxStatus($where: RouteResourceWhereInput) {
  posts(where: $where) {
    id
    properties(where: {key: {in: ["tags", "section"]}}) {
      id
      key
      data
    }
    vertical {
      id
    }
  }
}
    `;

/**
 * __useNewsTaxStatusQuery__
 *
 * To run a query within a React component, call `useNewsTaxStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsTaxStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsTaxStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNewsTaxStatusQuery(baseOptions?: Apollo.QueryHookOptions<NewsTaxStatusQuery, NewsTaxStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsTaxStatusQuery, NewsTaxStatusQueryVariables>(NewsTaxStatusDocument, options);
      }
export function useNewsTaxStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsTaxStatusQuery, NewsTaxStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsTaxStatusQuery, NewsTaxStatusQueryVariables>(NewsTaxStatusDocument, options);
        }
export function useNewsTaxStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewsTaxStatusQuery, NewsTaxStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsTaxStatusQuery, NewsTaxStatusQueryVariables>(NewsTaxStatusDocument, options);
        }
export type NewsTaxStatusQueryHookResult = ReturnType<typeof useNewsTaxStatusQuery>;
export type NewsTaxStatusLazyQueryHookResult = ReturnType<typeof useNewsTaxStatusLazyQuery>;
export type NewsTaxStatusSuspenseQueryHookResult = ReturnType<typeof useNewsTaxStatusSuspenseQuery>;
export type NewsTaxStatusQueryResult = Apollo.QueryResult<NewsTaxStatusQuery, NewsTaxStatusQueryVariables>;
export const ProviderTaxStatusDocument = gql`
    query ProviderTaxStatus($where: RouteResourceWhereInput, $defaultLanguageId: String!) {
  providers(where: $where) {
    id
    properties(where: {key: {contains: "-taxonomies"}}) {
      id
      key
      data
    }
    content(
      where: {key: {equals: "name"}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
      take: 1
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useProviderTaxStatusQuery__
 *
 * To run a query within a React component, call `useProviderTaxStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderTaxStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderTaxStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useProviderTaxStatusQuery(baseOptions: Apollo.QueryHookOptions<ProviderTaxStatusQuery, ProviderTaxStatusQueryVariables> & ({ variables: ProviderTaxStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderTaxStatusQuery, ProviderTaxStatusQueryVariables>(ProviderTaxStatusDocument, options);
      }
export function useProviderTaxStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderTaxStatusQuery, ProviderTaxStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderTaxStatusQuery, ProviderTaxStatusQueryVariables>(ProviderTaxStatusDocument, options);
        }
export function useProviderTaxStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderTaxStatusQuery, ProviderTaxStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderTaxStatusQuery, ProviderTaxStatusQueryVariables>(ProviderTaxStatusDocument, options);
        }
export type ProviderTaxStatusQueryHookResult = ReturnType<typeof useProviderTaxStatusQuery>;
export type ProviderTaxStatusLazyQueryHookResult = ReturnType<typeof useProviderTaxStatusLazyQuery>;
export type ProviderTaxStatusSuspenseQueryHookResult = ReturnType<typeof useProviderTaxStatusSuspenseQuery>;
export type ProviderTaxStatusQueryResult = Apollo.QueryResult<ProviderTaxStatusQuery, ProviderTaxStatusQueryVariables>;
export const TaxonomyItemsStatusDocument = gql`
    query TaxonomyItemsStatus($where: RouteResourceWhereInput, $take: Int, $skip: Int, $contentQueryKeys: [String!], $defaultLanguageId: String!) {
  taxonomyItems(where: $where, take: $take, skip: $skip) {
    id
    subtype
    createdAt
    updatedAt
    parentId
    parent {
      id
    }
    properties(where: {key: {in: ["published-countries", "published"]}}) {
      id
      key
      data
    }
    content(
      where: {key: {in: $contentQueryKeys}, languageId: {equals: $defaultLanguageId}, status: {in: [APPROVED, DRAFT]}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useTaxonomyItemsStatusQuery__
 *
 * To run a query within a React component, call `useTaxonomyItemsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyItemsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyItemsStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentQueryKeys: // value for 'contentQueryKeys'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *   },
 * });
 */
export function useTaxonomyItemsStatusQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyItemsStatusQuery, TaxonomyItemsStatusQueryVariables> & ({ variables: TaxonomyItemsStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyItemsStatusQuery, TaxonomyItemsStatusQueryVariables>(TaxonomyItemsStatusDocument, options);
      }
export function useTaxonomyItemsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyItemsStatusQuery, TaxonomyItemsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyItemsStatusQuery, TaxonomyItemsStatusQueryVariables>(TaxonomyItemsStatusDocument, options);
        }
export function useTaxonomyItemsStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxonomyItemsStatusQuery, TaxonomyItemsStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxonomyItemsStatusQuery, TaxonomyItemsStatusQueryVariables>(TaxonomyItemsStatusDocument, options);
        }
export type TaxonomyItemsStatusQueryHookResult = ReturnType<typeof useTaxonomyItemsStatusQuery>;
export type TaxonomyItemsStatusLazyQueryHookResult = ReturnType<typeof useTaxonomyItemsStatusLazyQuery>;
export type TaxonomyItemsStatusSuspenseQueryHookResult = ReturnType<typeof useTaxonomyItemsStatusSuspenseQuery>;
export type TaxonomyItemsStatusQueryResult = Apollo.QueryResult<TaxonomyItemsStatusQuery, TaxonomyItemsStatusQueryVariables>;
export const UpsertPropertyItemDocument = gql`
    mutation UpsertPropertyItem($fieldId: String, $value: JSON!, $contextId: String, $resourceName: String, $resourceId: String, $propertyId: String) {
  upsertOnePropertyItemCustom(
    fieldId: $fieldId
    value: $value
    contextId: $contextId
    resourceName: $resourceName
    resourceId: $resourceId
    propertyId: $propertyId
  ) {
    ...PropertyItemFragment
  }
}
    ${PropertyItemFragmentFragmentDoc}`;
export type UpsertPropertyItemMutationFn = Apollo.MutationFunction<UpsertPropertyItemMutation, UpsertPropertyItemMutationVariables>;

/**
 * __useUpsertPropertyItemMutation__
 *
 * To run a mutation, you first call `useUpsertPropertyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPropertyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPropertyItemMutation, { data, loading, error }] = useUpsertPropertyItemMutation({
 *   variables: {
 *      fieldId: // value for 'fieldId'
 *      value: // value for 'value'
 *      contextId: // value for 'contextId'
 *      resourceName: // value for 'resourceName'
 *      resourceId: // value for 'resourceId'
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useUpsertPropertyItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPropertyItemMutation, UpsertPropertyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPropertyItemMutation, UpsertPropertyItemMutationVariables>(UpsertPropertyItemDocument, options);
      }
export type UpsertPropertyItemMutationHookResult = ReturnType<typeof useUpsertPropertyItemMutation>;
export type UpsertPropertyItemMutationResult = Apollo.MutationResult<UpsertPropertyItemMutation>;
export type UpsertPropertyItemMutationOptions = Apollo.BaseMutationOptions<UpsertPropertyItemMutation, UpsertPropertyItemMutationVariables>;
export const DeleteTaxonomyItemDocument = gql`
    mutation DeleteTaxonomyItem($where: RouteResourceWhereUniqueInput!) {
  deleteTaxonomyItem(where: $where) {
    id
  }
}
    `;
export type DeleteTaxonomyItemMutationFn = Apollo.MutationFunction<DeleteTaxonomyItemMutation, DeleteTaxonomyItemMutationVariables>;

/**
 * __useDeleteTaxonomyItemMutation__
 *
 * To run a mutation, you first call `useDeleteTaxonomyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaxonomyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaxonomyItemMutation, { data, loading, error }] = useDeleteTaxonomyItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteTaxonomyItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaxonomyItemMutation, DeleteTaxonomyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaxonomyItemMutation, DeleteTaxonomyItemMutationVariables>(DeleteTaxonomyItemDocument, options);
      }
export type DeleteTaxonomyItemMutationHookResult = ReturnType<typeof useDeleteTaxonomyItemMutation>;
export type DeleteTaxonomyItemMutationResult = Apollo.MutationResult<DeleteTaxonomyItemMutation>;
export type DeleteTaxonomyItemMutationOptions = Apollo.BaseMutationOptions<DeleteTaxonomyItemMutation, DeleteTaxonomyItemMutationVariables>;
export const DeleteTaxonomyItemPoolDocument = gql`
    mutation DeleteTaxonomyItemPool($where: TaxonomyItemPoolWhereUniqueInput) {
  deleteTaxonomyItemPool(where: $where) {
    id
  }
}
    `;
export type DeleteTaxonomyItemPoolMutationFn = Apollo.MutationFunction<DeleteTaxonomyItemPoolMutation, DeleteTaxonomyItemPoolMutationVariables>;

/**
 * __useDeleteTaxonomyItemPoolMutation__
 *
 * To run a mutation, you first call `useDeleteTaxonomyItemPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaxonomyItemPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaxonomyItemPoolMutation, { data, loading, error }] = useDeleteTaxonomyItemPoolMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteTaxonomyItemPoolMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaxonomyItemPoolMutation, DeleteTaxonomyItemPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaxonomyItemPoolMutation, DeleteTaxonomyItemPoolMutationVariables>(DeleteTaxonomyItemPoolDocument, options);
      }
export type DeleteTaxonomyItemPoolMutationHookResult = ReturnType<typeof useDeleteTaxonomyItemPoolMutation>;
export type DeleteTaxonomyItemPoolMutationResult = Apollo.MutationResult<DeleteTaxonomyItemPoolMutation>;
export type DeleteTaxonomyItemPoolMutationOptions = Apollo.BaseMutationOptions<DeleteTaxonomyItemPoolMutation, DeleteTaxonomyItemPoolMutationVariables>;
export const TaxonomyItemCrudDocument = gql`
    query TaxonomyItemCrud($where: RouteResourceWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  taxonomyItem(where: $where) {
    ...TaxonomyItemCrudFragment
  }
}
    ${TaxonomyItemCrudFragmentFragmentDoc}`;

/**
 * __useTaxonomyItemCrudQuery__
 *
 * To run a query within a React component, call `useTaxonomyItemCrudQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyItemCrudQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyItemCrudQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useTaxonomyItemCrudQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyItemCrudQuery, TaxonomyItemCrudQueryVariables> & ({ variables: TaxonomyItemCrudQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyItemCrudQuery, TaxonomyItemCrudQueryVariables>(TaxonomyItemCrudDocument, options);
      }
export function useTaxonomyItemCrudLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyItemCrudQuery, TaxonomyItemCrudQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyItemCrudQuery, TaxonomyItemCrudQueryVariables>(TaxonomyItemCrudDocument, options);
        }
export function useTaxonomyItemCrudSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxonomyItemCrudQuery, TaxonomyItemCrudQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxonomyItemCrudQuery, TaxonomyItemCrudQueryVariables>(TaxonomyItemCrudDocument, options);
        }
export type TaxonomyItemCrudQueryHookResult = ReturnType<typeof useTaxonomyItemCrudQuery>;
export type TaxonomyItemCrudLazyQueryHookResult = ReturnType<typeof useTaxonomyItemCrudLazyQuery>;
export type TaxonomyItemCrudSuspenseQueryHookResult = ReturnType<typeof useTaxonomyItemCrudSuspenseQuery>;
export type TaxonomyItemCrudQueryResult = Apollo.QueryResult<TaxonomyItemCrudQuery, TaxonomyItemCrudQueryVariables>;
export const TaxonomyItemPoolDocument = gql`
    query TaxonomyItemPool($where: RouteResourcePoolWhereUniqueInput!) {
  taxonomyItemPool(where: $where) {
    id
    name
    networks {
      id
    }
    taxonomyItems {
      id
    }
  }
}
    `;

/**
 * __useTaxonomyItemPoolQuery__
 *
 * To run a query within a React component, call `useTaxonomyItemPoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyItemPoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyItemPoolQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTaxonomyItemPoolQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyItemPoolQuery, TaxonomyItemPoolQueryVariables> & ({ variables: TaxonomyItemPoolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyItemPoolQuery, TaxonomyItemPoolQueryVariables>(TaxonomyItemPoolDocument, options);
      }
export function useTaxonomyItemPoolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyItemPoolQuery, TaxonomyItemPoolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyItemPoolQuery, TaxonomyItemPoolQueryVariables>(TaxonomyItemPoolDocument, options);
        }
export function useTaxonomyItemPoolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxonomyItemPoolQuery, TaxonomyItemPoolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxonomyItemPoolQuery, TaxonomyItemPoolQueryVariables>(TaxonomyItemPoolDocument, options);
        }
export type TaxonomyItemPoolQueryHookResult = ReturnType<typeof useTaxonomyItemPoolQuery>;
export type TaxonomyItemPoolLazyQueryHookResult = ReturnType<typeof useTaxonomyItemPoolLazyQuery>;
export type TaxonomyItemPoolSuspenseQueryHookResult = ReturnType<typeof useTaxonomyItemPoolSuspenseQuery>;
export type TaxonomyItemPoolQueryResult = Apollo.QueryResult<TaxonomyItemPoolQuery, TaxonomyItemPoolQueryVariables>;
export const DynamicListTaxonomyItemsDocument = gql`
    query DynamicListTaxonomyItems($where: RouteResourceWhereInput, $search: RouteResourceSearchWhereInput, $take: Int, $skip: Int, $contentKeys: [String!], $propertyKeys: [String!], $orderBy: [RouteResourceOrderByWithRelationInput!], $filters: ResourceFiltersInput, $config: ResourceConfigInput) {
  count: taxonomyItemsSearchCount(
    where: $where
    search: $search
    filters: $filters
    config: $config
  )
  taxonomyItems: taxonomyItemsSearch(
    where: $where
    search: $search
    take: $take
    skip: $skip
    orderBy: $orderBy
    filters: $filters
    config: $config
  ) {
    id
    parentId
    subtype
    createdAt
    updatedAt
    createdBy {
      user_id
      name
    }
    parent {
      id
      content(
        where: {key: {in: $contentKeys}, status: {in: [APPROVED, DRAFT]}, languageId: {equals: "cka2r9yww001164rm5rp69iko"}}
        orderBy: {status: asc}
      ) {
        ...ContentItemFragment
      }
    }
    properties(where: {key: {in: $propertyKeys}}) {
      ...PropertyItemFragment
    }
    content(
      where: {key: {in: $contentKeys}, status: {in: [APPROVED, DRAFT]}, languageId: {equals: "cka2r9yww001164rm5rp69iko"}}
      orderBy: {status: asc}
    ) {
      ...ContentItemFragment
    }
    pools {
      id
      networks {
        id
      }
    }
  }
}
    ${ContentItemFragmentFragmentDoc}
${PropertyItemFragmentFragmentDoc}`;

/**
 * __useDynamicListTaxonomyItemsQuery__
 *
 * To run a query within a React component, call `useDynamicListTaxonomyItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicListTaxonomyItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicListTaxonomyItemsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      contentKeys: // value for 'contentKeys'
 *      propertyKeys: // value for 'propertyKeys'
 *      orderBy: // value for 'orderBy'
 *      filters: // value for 'filters'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useDynamicListTaxonomyItemsQuery(baseOptions?: Apollo.QueryHookOptions<DynamicListTaxonomyItemsQuery, DynamicListTaxonomyItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicListTaxonomyItemsQuery, DynamicListTaxonomyItemsQueryVariables>(DynamicListTaxonomyItemsDocument, options);
      }
export function useDynamicListTaxonomyItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicListTaxonomyItemsQuery, DynamicListTaxonomyItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicListTaxonomyItemsQuery, DynamicListTaxonomyItemsQueryVariables>(DynamicListTaxonomyItemsDocument, options);
        }
export function useDynamicListTaxonomyItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicListTaxonomyItemsQuery, DynamicListTaxonomyItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicListTaxonomyItemsQuery, DynamicListTaxonomyItemsQueryVariables>(DynamicListTaxonomyItemsDocument, options);
        }
export type DynamicListTaxonomyItemsQueryHookResult = ReturnType<typeof useDynamicListTaxonomyItemsQuery>;
export type DynamicListTaxonomyItemsLazyQueryHookResult = ReturnType<typeof useDynamicListTaxonomyItemsLazyQuery>;
export type DynamicListTaxonomyItemsSuspenseQueryHookResult = ReturnType<typeof useDynamicListTaxonomyItemsSuspenseQuery>;
export type DynamicListTaxonomyItemsQueryResult = Apollo.QueryResult<DynamicListTaxonomyItemsQuery, DynamicListTaxonomyItemsQueryVariables>;
export const UpsertTaxonomyItemCrudDocument = gql`
    mutation UpsertTaxonomyItemCrud($where: RouteResourceWhereUniqueInput!, $data: TaxonomyItemUpsertDataInput!, $current: ResourceCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!, $currentCompanyId: String!, $currentVerticalId: String!) {
  upsertTaxonomyItem(where: $where, data: $data, current: $current) {
    ...TaxonomyItemCrudFragment
  }
}
    ${TaxonomyItemCrudFragmentFragmentDoc}`;
export type UpsertTaxonomyItemCrudMutationFn = Apollo.MutationFunction<UpsertTaxonomyItemCrudMutation, UpsertTaxonomyItemCrudMutationVariables>;

/**
 * __useUpsertTaxonomyItemCrudMutation__
 *
 * To run a mutation, you first call `useUpsertTaxonomyItemCrudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTaxonomyItemCrudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTaxonomyItemCrudMutation, { data, loading, error }] = useUpsertTaxonomyItemCrudMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *      currentCompanyId: // value for 'currentCompanyId'
 *      currentVerticalId: // value for 'currentVerticalId'
 *   },
 * });
 */
export function useUpsertTaxonomyItemCrudMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTaxonomyItemCrudMutation, UpsertTaxonomyItemCrudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTaxonomyItemCrudMutation, UpsertTaxonomyItemCrudMutationVariables>(UpsertTaxonomyItemCrudDocument, options);
      }
export type UpsertTaxonomyItemCrudMutationHookResult = ReturnType<typeof useUpsertTaxonomyItemCrudMutation>;
export type UpsertTaxonomyItemCrudMutationResult = Apollo.MutationResult<UpsertTaxonomyItemCrudMutation>;
export type UpsertTaxonomyItemCrudMutationOptions = Apollo.BaseMutationOptions<UpsertTaxonomyItemCrudMutation, UpsertTaxonomyItemCrudMutationVariables>;
export const UpsertTaxonomyItemPoolDocument = gql`
    mutation UpsertTaxonomyItemPool($where: RouteResourcePoolWhereUniqueInput, $data: RouteResourcePoolUpsertDataInput!) {
  upsertTaxonomyItemPool(where: $where, data: $data) {
    id
  }
}
    `;
export type UpsertTaxonomyItemPoolMutationFn = Apollo.MutationFunction<UpsertTaxonomyItemPoolMutation, UpsertTaxonomyItemPoolMutationVariables>;

/**
 * __useUpsertTaxonomyItemPoolMutation__
 *
 * To run a mutation, you first call `useUpsertTaxonomyItemPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTaxonomyItemPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTaxonomyItemPoolMutation, { data, loading, error }] = useUpsertTaxonomyItemPoolMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertTaxonomyItemPoolMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTaxonomyItemPoolMutation, UpsertTaxonomyItemPoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTaxonomyItemPoolMutation, UpsertTaxonomyItemPoolMutationVariables>(UpsertTaxonomyItemPoolDocument, options);
      }
export type UpsertTaxonomyItemPoolMutationHookResult = ReturnType<typeof useUpsertTaxonomyItemPoolMutation>;
export type UpsertTaxonomyItemPoolMutationResult = Apollo.MutationResult<UpsertTaxonomyItemPoolMutation>;
export type UpsertTaxonomyItemPoolMutationOptions = Apollo.BaseMutationOptions<UpsertTaxonomyItemPoolMutation, UpsertTaxonomyItemPoolMutationVariables>;
export const TemplatesOverviewDocument = gql`
    query TemplatesOverview($where: TemplateWhereInput!) {
  templates(where: $where) {
    id
    createdAt
    updatedAt
    type
    subtype
    network {
      id
    }
    content {
      ...ContentItemFragment
    }
    fields {
      id
      required
      index
      group
      key
      type
      hidden
      list
      data
      generatePages
      context
      resourceType
      isDefaultField
      defaultTranslationType
      displayType
      roles
      content {
        ...ContentItemFragment
      }
    }
    groups {
      id
      name
      index
      extended
      generalGroup {
        id
        name
        index
      }
      data
    }
  }
}
    ${ContentItemFragmentFragmentDoc}`;

/**
 * __useTemplatesOverviewQuery__
 *
 * To run a query within a React component, call `useTemplatesOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesOverviewQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTemplatesOverviewQuery(baseOptions: Apollo.QueryHookOptions<TemplatesOverviewQuery, TemplatesOverviewQueryVariables> & ({ variables: TemplatesOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesOverviewQuery, TemplatesOverviewQueryVariables>(TemplatesOverviewDocument, options);
      }
export function useTemplatesOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesOverviewQuery, TemplatesOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesOverviewQuery, TemplatesOverviewQueryVariables>(TemplatesOverviewDocument, options);
        }
export function useTemplatesOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplatesOverviewQuery, TemplatesOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplatesOverviewQuery, TemplatesOverviewQueryVariables>(TemplatesOverviewDocument, options);
        }
export type TemplatesOverviewQueryHookResult = ReturnType<typeof useTemplatesOverviewQuery>;
export type TemplatesOverviewLazyQueryHookResult = ReturnType<typeof useTemplatesOverviewLazyQuery>;
export type TemplatesOverviewSuspenseQueryHookResult = ReturnType<typeof useTemplatesOverviewSuspenseQuery>;
export type TemplatesOverviewQueryResult = Apollo.QueryResult<TemplatesOverviewQuery, TemplatesOverviewQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $name: String, $roles: [String!], $permissions: [String!]) {
  updateUser(id: $id, name: $name, roles: $roles, permissions: $permissions) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      roles: // value for 'roles'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteVerticalDocument = gql`
    mutation DeleteVertical($where: VerticalWhereUniqueInput!) {
  deleteVertical(where: $where) {
    id
  }
}
    `;
export type DeleteVerticalMutationFn = Apollo.MutationFunction<DeleteVerticalMutation, DeleteVerticalMutationVariables>;

/**
 * __useDeleteVerticalMutation__
 *
 * To run a mutation, you first call `useDeleteVerticalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVerticalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVerticalMutation, { data, loading, error }] = useDeleteVerticalMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteVerticalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVerticalMutation, DeleteVerticalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVerticalMutation, DeleteVerticalMutationVariables>(DeleteVerticalDocument, options);
      }
export type DeleteVerticalMutationHookResult = ReturnType<typeof useDeleteVerticalMutation>;
export type DeleteVerticalMutationResult = Apollo.MutationResult<DeleteVerticalMutation>;
export type DeleteVerticalMutationOptions = Apollo.BaseMutationOptions<DeleteVerticalMutation, DeleteVerticalMutationVariables>;
export const UpsertVerticalDocument = gql`
    mutation UpsertVertical($where: VerticalWhereUniqueInput!, $data: VerticalUpsertDataInput!, $current: VerticalCurrentInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!) {
  upsertVertical(where: $where, data: $data, current: $current) {
    ...VerticalCrudFragment
  }
}
    ${VerticalCrudFragmentFragmentDoc}`;
export type UpsertVerticalMutationFn = Apollo.MutationFunction<UpsertVerticalMutation, UpsertVerticalMutationVariables>;

/**
 * __useUpsertVerticalMutation__
 *
 * To run a mutation, you first call `useUpsertVerticalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertVerticalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertVerticalMutation, { data, loading, error }] = useUpsertVerticalMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *      current: // value for 'current'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *   },
 * });
 */
export function useUpsertVerticalMutation(baseOptions?: Apollo.MutationHookOptions<UpsertVerticalMutation, UpsertVerticalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertVerticalMutation, UpsertVerticalMutationVariables>(UpsertVerticalDocument, options);
      }
export type UpsertVerticalMutationHookResult = ReturnType<typeof useUpsertVerticalMutation>;
export type UpsertVerticalMutationResult = Apollo.MutationResult<UpsertVerticalMutation>;
export type UpsertVerticalMutationOptions = Apollo.BaseMutationOptions<UpsertVerticalMutation, UpsertVerticalMutationVariables>;
export const VerticalDocument = gql`
    query Vertical($where: VerticalWhereUniqueInput!, $currentLanguageId: String!, $defaultLanguageId: String!, $currentNetworkId: String!) {
  vertical(where: $where) {
    ...VerticalCrudFragment
  }
}
    ${VerticalCrudFragmentFragmentDoc}`;

/**
 * __useVerticalQuery__
 *
 * To run a query within a React component, call `useVerticalQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerticalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerticalQuery({
 *   variables: {
 *      where: // value for 'where'
 *      currentLanguageId: // value for 'currentLanguageId'
 *      defaultLanguageId: // value for 'defaultLanguageId'
 *      currentNetworkId: // value for 'currentNetworkId'
 *   },
 * });
 */
export function useVerticalQuery(baseOptions: Apollo.QueryHookOptions<VerticalQuery, VerticalQueryVariables> & ({ variables: VerticalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerticalQuery, VerticalQueryVariables>(VerticalDocument, options);
      }
export function useVerticalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerticalQuery, VerticalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerticalQuery, VerticalQueryVariables>(VerticalDocument, options);
        }
export function useVerticalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerticalQuery, VerticalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerticalQuery, VerticalQueryVariables>(VerticalDocument, options);
        }
export type VerticalQueryHookResult = ReturnType<typeof useVerticalQuery>;
export type VerticalLazyQueryHookResult = ReturnType<typeof useVerticalLazyQuery>;
export type VerticalSuspenseQueryHookResult = ReturnType<typeof useVerticalSuspenseQuery>;
export type VerticalQueryResult = Apollo.QueryResult<VerticalQuery, VerticalQueryVariables>;
export const SitesForRedirectsDocument = gql`
    query SitesForRedirects($where: SiteWhereInput, $take: Int, $skip: Int) {
  sites(where: $where, take: $take, skip: $skip) {
    id
    url
    properties(where: {key: {in: ["name", "redirect-rules"]}}) {
      id
      key
      data
      createdAt
      updatedAt
    }
    language {
      id
      languageCode
      languageTag
      countryCode
    }
  }
  count: siteCount(where: $where)
}
    `;

/**
 * __useSitesForRedirectsQuery__
 *
 * To run a query within a React component, call `useSitesForRedirectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesForRedirectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesForRedirectsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSitesForRedirectsQuery(baseOptions?: Apollo.QueryHookOptions<SitesForRedirectsQuery, SitesForRedirectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesForRedirectsQuery, SitesForRedirectsQueryVariables>(SitesForRedirectsDocument, options);
      }
export function useSitesForRedirectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesForRedirectsQuery, SitesForRedirectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesForRedirectsQuery, SitesForRedirectsQueryVariables>(SitesForRedirectsDocument, options);
        }
export function useSitesForRedirectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SitesForRedirectsQuery, SitesForRedirectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SitesForRedirectsQuery, SitesForRedirectsQueryVariables>(SitesForRedirectsDocument, options);
        }
export type SitesForRedirectsQueryHookResult = ReturnType<typeof useSitesForRedirectsQuery>;
export type SitesForRedirectsLazyQueryHookResult = ReturnType<typeof useSitesForRedirectsLazyQuery>;
export type SitesForRedirectsSuspenseQueryHookResult = ReturnType<typeof useSitesForRedirectsSuspenseQuery>;
export type SitesForRedirectsQueryResult = Apollo.QueryResult<SitesForRedirectsQuery, SitesForRedirectsQueryVariables>;